
import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { useUser, useAuth, SignInButton, SignIn, UserButton, UserProfile, useClerk } from '@clerk/clerk-react';
import { 
  ThemeProvider, createTheme, CssBaseline, Box, Typography, Button, IconButton, Switch, Divider,
  List, ListItem, ListItemIcon, ListItemText, ListItemButton, Menu, MenuItem, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Snackbar, Alert, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, Avatar, Tooltip, ToggleButton, ToggleButtonGroup,
  CircularProgress, Autocomplete, Paper, Slider, Card, CardActionArea, Tabs, Tab,
  Checkbox, FormControlLabel, Select,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PeopleIcon from '@mui/icons-material/People';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import LockIcon from '@mui/icons-material/Lock';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import CropFreeIcon from '@mui/icons-material/CropFree';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LanguageIcon from '@mui/icons-material/Language';
import ArticleIcon from '@mui/icons-material/Article';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import StorageIcon from '@mui/icons-material/Storage';
import MenuIcon from '@mui/icons-material/Menu';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import SchoolIcon from '@mui/icons-material/School';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import WorkIcon from '@mui/icons-material/Work';
import ScienceIcon from '@mui/icons-material/Science';
import BusinessIcon from '@mui/icons-material/Business';
import MovieIcon from '@mui/icons-material/Movie';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import ForumIcon from '@mui/icons-material/Forum';
import EmailIcon from '@mui/icons-material/Email';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import AlignVerticalTopIcon from '@mui/icons-material/AlignVerticalTop';
import StopIcon from '@mui/icons-material/Stop';
import ShareIcon from '@mui/icons-material/Share';
import PublicIcon from '@mui/icons-material/Public';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import EditIcon from '@mui/icons-material/Edit';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ImageIcon from '@mui/icons-material/Image';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CodeIcon from '@mui/icons-material/Code';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import DownloadIcon from '@mui/icons-material/Download';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import StarIcon from '@mui/icons-material/Star';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WarningIcon from '@mui/icons-material/Warning';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import LinkIcon from '@mui/icons-material/Link';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import StarRateIcon from '@mui/icons-material/StarRate';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaletteIcon from '@mui/icons-material/Palette';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import TranslateIcon from '@mui/icons-material/Translate';
import CalculateIcon from '@mui/icons-material/Calculate';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HubIcon from '@mui/icons-material/Hub';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import SaveIcon from '@mui/icons-material/Save';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RemoveIcon from '@mui/icons-material/Remove';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
// ── Extracted modules (Stage 1 split) ──
import {
  generateBoardId, generateChainId, generateSourceId, generateSeedId, normId, dispId, _cacheChain, _lookupChain,
  updateURL, getURLParams, Position, Size, SourceFields, ReferencePointer, UploadedFile, RefPoint,
  TrustRates, API_BASE, sanitize, safeHref, okJson, EMPTY_EDIT_LOG, sanitizeFields, SQUARE_WIDTH, SQUARE_HEIGHT,
  emptyTrustRates, REF_TYPES, validateRefPointInput, REF_POINTER_TYPES, DEFAULT_POINTER_TYPES, formatRefPointLabel, ColorTheme, COLOR_THEMES,
  SquareData, User, AppSettings, DEFAULT_SETTINGS, formatTimestamp, TIMEZONES, formatTzLabel, emptyFields,
  emptyReference,
} from './lib';
import {
  SUPPORTED_LANGUAGES, LangCode, LANGUAGE_LABELS, TranslationProvider, useTranslation, T,
} from './i18n';
import {
  FieldConfig, SOURCE_COLORS, withArchivedUrlField, ALL_SOURCE_TYPES, parseFieldsFromContent, parseRefFromContent, getOrderLabel, formatFileSize,
  getSourceColor, getRefDescription, formatTime, escapeHtml, timeSince, formatSourceCitationText, formatSourceCitationHTML, formatSourceCitationJSX,
  getDurationFromFields, getMaxPagesFromFields, AppMode,
} from './sourceTypes';

const createAppTheme = (mode: 'light' | 'dark', colorTheme: ColorTheme = 'default') => {
  const ct = COLOR_THEMES[colorTheme];
  const sidebarBg = mode === 'dark' ? (ct.sidebarDark || ct.paperDark) : ct.paper;
  const borderColor = mode === 'dark' ? (ct.borderDark || 'rgba(255,255,255,0.08)') : 'rgba(0,0,0,0.11)';
  return createTheme({
    palette: {
      mode,
      primary: { main: ct.primary },
      secondary: { main: ct.accent || ct.primary },
      background: { default: mode === 'dark' ? ct.bgDark : ct.bg, paper: mode === 'dark' ? ct.paperDark : ct.paper },
      text: { primary: mode === 'dark' ? '#E3E3DF' : '#1a1a2e', secondary: mode === 'dark' ? 'rgba(227,227,223,0.6)' : 'rgba(0,0,0,0.6)' },
      divider: borderColor,
    },
    typography: { fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif' },
    components: { MuiButton: { styleOverrides: { root: { textTransform: 'none' } } } },
  });
};

// ▓▓▓▓▓ UTILITIES & VIEWER COMPONENTS ▓▓▓▓▓
const ZOOM_LEVELS = [0.1, 0.25, 0.33, 0.5, 0.67, 0.75, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4];

// ── Shared ViewerZoomControls ─────────────────────────────────────────────────
const ViewerZoomControls: React.FC<{
  zoom: number;
  onZoomChange: React.Dispatch<React.SetStateAction<number>>;
  variant?: 'dark' | 'light';
  size?: 'small' | 'medium';
  sx?: any;
}> = ({ zoom, onZoomChange, variant = 'dark', size = 'small', sx }) => {
  const dk = variant === 'dark';
  const btn = size === 'small' ? 26 : 28;
  const ico = size === 'small' ? 14 : 15;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3,
      bgcolor: dk ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
      borderRadius: '6px', border: '1px solid',
      borderColor: dk ? 'rgba(255,255,255,0.15)' : 'divider', px: 0.3, ...sx }}>
      {zoom !== 1 && (
        <IconButton size="small" onClick={() => onZoomChange(1)}
          sx={{ color: dk ? 'rgba(255,255,255,0.5)' : 'text.disabled', width: btn, height: btn, mr: 0.5 }} title="Fit to view">
          <RestartAltIcon sx={{ fontSize: ico - 2 }} />
        </IconButton>
      )}
      <IconButton size="small"
        onClick={() => onZoomChange(z => { const idx = ZOOM_LEVELS.findIndex(l => l >= z); return ZOOM_LEVELS[Math.max(0, idx - 1)] ?? ZOOM_LEVELS[0]; })}
        sx={{ color: dk ? '#E3E3DF' : undefined, width: btn, height: btn }}>
        <ZoomOutIcon sx={{ fontSize: ico }} />
      </IconButton>
      <Typography sx={{ fontSize: 10, color: dk ? '#E3E3DF' : undefined, fontFamily: 'monospace', minWidth: size === 'small' ? 36 : 38, textAlign: 'center' }}>
        {zoom === 1 ? 'Fit' : `${Math.round(zoom * 100)}%`}
      </Typography>
      <IconButton size="small"
        onClick={() => onZoomChange(z => { const idx = ZOOM_LEVELS.findIndex(l => l > z); return idx >= 0 ? ZOOM_LEVELS[idx] : ZOOM_LEVELS[ZOOM_LEVELS.length - 1]; })}
        sx={{ color: dk ? '#E3E3DF' : undefined, width: btn, height: btn }}>
        <ZoomInIcon sx={{ fontSize: ico }} />
      </IconButton>
    </Box>
  );
};

// ▓▓▓▓▓ COVER IMAGE COMPONENT ▓▓▓▓▓
const CoverImage: React.FC<{
  coverUrl: string;
  showPlaceholder?: boolean;
  onEdit?: (file: File) => void;
  renderTrigger?: (openFullsize: () => void) => React.ReactNode;
}> = ({ coverUrl, showPlaceholder = false, onEdit, renderTrigger }) => {
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [enlarged, setEnlarged] = useState(false);
  
  useEffect(() => {
    if (!coverUrl) { setLoading(false); return; }
    setLoading(true);
    setError(false);
    setImgSrc(null);
    if (coverUrl.startsWith('http') && !coverUrl.includes('/api/')) {
      setImgSrc(coverUrl);
      setLoading(false);
      return;
    }
    fetch(coverUrl)
      .then(r => r.ok ? r.json() : Promise.reject('not found'))
      .then(data => { if (data.coverUrl) setImgSrc(data.coverUrl); else setError(true); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, [coverUrl]);
  
  if (error || (!imgSrc && !loading)) {
    if (showPlaceholder && !renderTrigger) {
      return (
        <Box sx={{ flexShrink: 0, width: 68, height: 101, borderRadius: '4px', bgcolor: 'rgba(128,128,128,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px dashed', borderColor: 'divider' }}>
          <Typography sx={{ fontSize: 8, color: 'text.disabled', textAlign: 'center' }}>No<br/>cover</Typography>
        </Box>
      );
    }
    return null;
  }
  
  if (loading) {
    if (renderTrigger) return null;
    return (
      <Box sx={{ flexShrink: 0, width: 68, height: 101, borderRadius: '4px', bgcolor: 'action.hover', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={14} thickness={4} />
      </Box>
    );
  }
  
  return (
    <>
      {renderTrigger ? renderTrigger(() => setEnlarged(true)) : (
        <Tooltip title="View full size" placement="top">
          <Box sx={{ flexShrink: 0, cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setEnlarged(true); }}>
            <Box component="img" src={imgSrc!} alt="Cover" onError={() => setError(true)}
              sx={{ width: 68, height: 101, objectFit: 'cover', borderRadius: '4px', boxShadow: 2, bgcolor: 'action.hover', '&:hover': { opacity: 0.85, boxShadow: 4 }, transition: 'all 0.15s' }} />
          </Box>
        </Tooltip>
      )}
      <Dialog disableScrollLock open={enlarged} onClose={() => setEnlarged(false)} maxWidth={false}
        PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible', m: 0 } }}
        slotProps={{ backdrop: { sx: { bgcolor: 'rgba(0,0,0,0.85)' } } }}>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton onClick={() => setEnlarged(false)}
            sx={{ position: 'absolute', top: -40, right: -8, color: '#E3E3DF', bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }, zIndex: 1 }}>
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
          <Box component="img" src={imgSrc!} alt="Cover enlarged"
            sx={{ maxWidth: '85vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: '8px', boxShadow: '0 8px 40px rgba(0,0,0,0.5)' }} />
          {onEdit && (
            <Box component="label" sx={{
              position: 'absolute', bottom: 16, right: 16,
              display: 'flex', alignItems: 'center', gap: 0.7,
              px: 1.5, py: 0.8, borderRadius: '8px',
              bgcolor: 'rgba(0,0,0,0.75)',
              cursor: 'pointer', zIndex: 2,
              transition: 'background-color 120ms',
              '&:hover': { bgcolor: 'rgba(0,0,0,0.9)' },
            }}>
              <EditIcon sx={{ fontSize: 14, color: '#E3E3DF' }} />
              <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#E3E3DF', userSelect: 'none' }}>
                Replace cover
              </Typography>
              <input type="file" accept="image/png,image/jpeg" hidden
                onChange={(e) => { if (e.target.files?.[0]) { onEdit(e.target.files[0]); setEnlarged(false); } }} />
            </Box>
          )}
        </Box>
      </Dialog>
    </>
  );
};

// ▓▓▓▓▓ AUTOCOMPLETE COMPONENTS ▓▓▓▓▓

interface IMDBResult { id: string; title: string; year: string; poster?: string; posterFull?: string; stars?: string; kind?: string; }
interface OpenLibResult { key: string; title: string; author: string; year: string; cover?: string; coverId?: number; }


const MicrolinkAutocomplete: React.FC<{ onSelect: (data: any) => void; isDark: boolean }> = ({ onSelect, isDark }) => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const fetchData = async () => {
    if (!inputValue.trim()) return;
    let url = inputValue.trim();
    if (!url.startsWith('http://') && !url.startsWith('https://')) url = 'https://' + url;
    setLoading(true); setError('');
    try {
      const res = await fetch(`https://api.microlink.io/?url=${encodeURIComponent(url)}`);
      const data = await res.json();
      if (data.status === 'success' && data.data) {
        onSelect({ title: data.data.title || '', siteName: data.data.publisher || new URL(url).hostname, url: data.data.url || url });
        setInputValue('');
      } else setError('Could not fetch');
    } catch { setError('Failed'); }
    setLoading(false);
  };
  
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <TextField fullWidth size="small" value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder="Enter URL..." onKeyDown={(e) => e.key === 'Enter' && fetchData()} error={!!error} helperText={error} />
      <Button variant="contained" onClick={fetchData} disabled={loading || !inputValue.trim()} sx={{ minWidth: 80 }}>{loading ? <CircularProgress size={16} /> : 'Fetch'}</Button>
    </Box>
  );
};

const OpenLibAutocomplete: React.FC<{ onSelect: (data: any) => void; isDark: boolean }> = ({ onSelect, isDark }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<OpenLibResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<'network' | 'empty' | null>(null);
  const [lastSearchedQuery, setLastSearchedQuery] = useState('');
  const [retryNonce, setRetryNonce] = useState(0);
  const debounceRef = useRef<NodeJS.Timeout>();

  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [anchorWidth, setAnchorWidth] = useState<number | undefined>(undefined);
  useEffect(() => {
    if (!anchorRef.current) return;
    const ro = new ResizeObserver(() => {
      if (anchorRef.current) setAnchorWidth(anchorRef.current.clientWidth);
    });
    ro.observe(anchorRef.current);
    setAnchorWidth(anchorRef.current.clientWidth);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (inputValue.length < 2) { setOptions([]); setError(null); setLastSearchedQuery(''); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`https://openlibrary.org/search.json?q=${encodeURIComponent(inputValue)}&limit=8&fields=key,title,author_name,first_publish_year,cover_i`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const docs = data.docs || [];
        const mapped: OpenLibResult[] = docs.map((d: any) => ({ key: d.key, title: d.title || 'Unknown', author: d.author_name?.[0] || 'Unknown', year: d.first_publish_year?.toString() || '', cover: d.cover_i ? `https://covers.openlibrary.org/b/id/${d.cover_i}-S.jpg` : undefined, coverId: d.cover_i }));
        setOptions(mapped);
        setLastSearchedQuery(inputValue);
        if (mapped.length === 0) setError('empty');
      } catch {
        setOptions([]);
        setError('network');
        setLastSearchedQuery(inputValue);
      }
      setLoading(false);
    }, 500);
  }, [inputValue, retryNonce]);

  const handleSelect = async (item: OpenLibResult | null) => {
    if (!item) return;
    setLoading(true);
    try {
      const res = await fetch(`https://openlibrary.org${item.key}.json`);
      const data = await res.json();
      let publisher = '', pages = '', language = '', isbn = '';
      try { const ed = await fetch(`https://openlibrary.org${item.key}/editions.json?limit=1`); const edData = await ed.json(); const e = edData.entries?.[0] || {}; publisher = e.publishers?.[0] || ''; pages = e.number_of_pages?.toString() || ''; language = e.languages?.[0]?.key?.replace('/languages/', '').toUpperCase() || ''; isbn = e.isbn_13?.[0] || e.isbn_10?.[0] || ''; } catch {}
      const coverUrl = item.coverId ? `https://covers.openlibrary.org/b/id/${item.coverId}-L.jpg` : undefined;
      onSelect({ title: data.title || item.title, author: item.author, publisher, year: item.year, isbn, pages, language, subject: Array.isArray(data.subjects) ? data.subjects.slice(0, 3).join(', ') : '', olid: item.key.replace('/works/', ''), coverUrl });
      setInputValue(''); setOptions([]); setError(null); setLastSearchedQuery('');
    } catch {}
    setLoading(false);
  };

  return (
    <Box ref={anchorRef} sx={{ width: '100%' }}>
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(o) => typeof o === 'string' ? o : `${o.title} (${o.year})`}
      inputValue={inputValue}
      onInputChange={(_, v) => setInputValue(v)}
      onChange={(_, v) => handleSelect(v as OpenLibResult)}
      loading={loading}
      filterOptions={(x) => x}
      open={inputValue.length >= 2 && (loading || options.length > 0 || error !== null)}
      noOptionsText=""
      disablePortal={false}
      slotProps={{
        popper: {
          style: { zIndex: 99999, width: anchorWidth },
          placement: 'bottom-start',
        },
        paper: { sx: { bgcolor: 'background.paper', zIndex: 99999, width: '100%' } },
      }}
      PaperComponent={({ children, ...paperProps }) => (
        <Paper {...paperProps} sx={{ bgcolor: 'background.paper', boxShadow: 4, ...((paperProps as any).sx || {}) }}>
          {options.length > 0 && children}
          {error !== null && !loading && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.2, borderTop: options.length > 0 ? '1px solid' : 'none', borderColor: 'divider' }}>
              <WarningIcon sx={{ fontSize: 16, color: error === 'network' ? '#ef4444' : '#f59e0b', flexShrink: 0 }} />
              <Typography sx={{ fontSize: 12, flex: 1, color: 'text.secondary' }}>
                {error === 'network'
                  ? 'Connection error — could not reach Open Library.'
                  : `No results for "${lastSearchedQuery}".`}
              </Typography>
              <Button size="small" variant="outlined" onMouseDown={(e) => { e.preventDefault(); }} onClick={() => setRetryNonce(n => n + 1)}
                sx={{ fontSize: 11, textTransform: 'none', py: 0.2, minWidth: 0, px: 1 }}>
                Retry
              </Button>
            </Box>
          )}
          {options.length > 0 && error === null && !loading && (
            <Box sx={{ p: 0.7, borderTop: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'flex-end' }}>
              <Typography sx={{ fontSize: 10, color: 'text.disabled', fontWeight: 500 }}>
                {options.length} result{options.length === 1 ? '' : 's'}
              </Typography>
            </Box>
          )}
        </Paper>
      )}
      renderInput={(p) => <TextField {...p} size="small" placeholder="Search books..." InputProps={{ ...p.InputProps, endAdornment: <>{loading && <CircularProgress size={16} />}{p.InputProps.endAdornment}</> }} />}
      renderOption={(props, o) => <Box component="li" {...props} sx={{ display: 'flex', gap: 1, py: 0.75 }}>{o.cover ? <Box component="img" src={o.cover} sx={{ width: 28, height: 42, objectFit: 'cover', borderRadius: 0.5 }} /> : <Box sx={{ width: 28, height: 42, bgcolor: 'action.hover', borderRadius: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><MenuBookIcon sx={{ fontSize: 14, color: 'text.disabled' }} /></Box>}<Box><Typography variant="body2" fontWeight={500}>{o.title}</Typography><Typography variant="caption" color="text.secondary">{o.author} • {o.year}</Typography></Box></Box>}
    />
    </Box>
  );
};

interface IMDBSearchOutcome { results: IMDBResult[]; via: 'proxy' | 'imdb'; }

const IMDB_SUGGEST_BASE = 'https://v3.sg.media-imdb.com/suggestion';

const imdbThumb = (url?: string): string | undefined =>
  url ? url.replace(/\._V1_[^./]*\.(jpe?g|png)$/i, '._V1_UX96_.$1') : undefined;

const mapProxySearch = (data: any): IMDBResult[] => {
  const list = Array.isArray(data?.Search) ? data.Search : Array.isArray(data?.results) ? data.results : [];
  return list.slice(0, 8).map((i: any) => ({
    id: i.imdbID || i.id || '',
    title: i.Title || i.title || '',
    year: String(i.Year || i.year || ''),
    poster: (i.Poster && i.Poster !== 'N/A') ? i.Poster : (i.poster || undefined),
  })).filter((r: IMDBResult) => r.id && r.title);
};

const searchImdbDirect = async (q: string): Promise<IMDBResult[]> => {
  const slug = q.trim().toLowerCase();
  const first = /^[a-z0-9]/.test(slug) ? slug[0] : 'x';
  const res = await fetch(`${IMDB_SUGGEST_BASE}/${first}/${encodeURIComponent(slug)}.json`);
  if (!res.ok) throw new Error(`IMDb HTTP ${res.status}`);
  const data = await res.json();
  return (Array.isArray(data?.d) ? data.d : [])
    .filter((i: any) => typeof i?.id === 'string' && i.id.startsWith('tt'))
    .slice(0, 8)
    .map((i: any): IMDBResult => ({
      id: i.id, title: i.l || '', year: i.y ? String(i.y) : '',
      poster: imdbThumb(i.i?.imageUrl), posterFull: i.i?.imageUrl || undefined,
      stars: i.s || '', kind: i.q || '',
    }));
};

const detailFromWikidata = async (imdbId: string): Promise<{ directors: string; genres: string; minutes: string; year: string; article: string } | null> => {
  const sparql = `SELECT ?film ?article (MIN(YEAR(?date)) AS ?year) (MIN(?rt) AS ?minutes)
  (GROUP_CONCAT(DISTINCT ?dirLabel; separator=", ") AS ?directors)
  (GROUP_CONCAT(DISTINCT ?genLabel; separator=", ") AS ?genres) WHERE {
  ?film wdt:P345 "${imdbId.replace(/[^a-z0-9]/gi, '')}" .
  OPTIONAL { ?film wdt:P57 ?dir . ?dir rdfs:label ?dirLabel . FILTER(LANG(?dirLabel) = "en") }
  OPTIONAL { ?film wdt:P136 ?gen . ?gen rdfs:label ?genLabel . FILTER(LANG(?genLabel) = "en") }
  OPTIONAL { ?film wdt:P2047 ?rt . }
  OPTIONAL { ?film wdt:P577 ?date . }
  OPTIONAL { ?article schema:about ?film ; schema:isPartOf <https://en.wikipedia.org/> . }
} GROUP BY ?film ?article LIMIT 1`;
  const res = await fetch(`https://query.wikidata.org/sparql?format=json&query=${encodeURIComponent(sparql)}`, { headers: { Accept: 'application/sparql-results+json' } });
  if (!res.ok) throw new Error(`Wikidata HTTP ${res.status}`);
  const data = await res.json();
  const b = data?.results?.bindings?.[0];
  if (!b) return null;
  const v = (k: string) => (b[k]?.value ?? '') as string;
  const genres = v('genres').split(', ').filter(Boolean)
    .map(g => g.replace(/\s+film$/i, '').replace(/^\w/, c => c.toUpperCase())).join(', ');
  const rawMin = parseFloat(v('minutes'));
  return { directors: v('directors'), genres, minutes: isNaN(rawMin) ? '' : String(Math.round(rawMin)), year: v('year'), article: v('article') };
};

const wikipediaSummary = async (articleUrl: string): Promise<string> => {
  const title = articleUrl.split('/wiki/')[1];
  if (!title) return '';
  const res = await fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${title}`);
  if (!res.ok) return '';
  const d = await res.json();
  return typeof d?.extract === 'string' ? d.extract : '';
};

const IMDBAutocomplete: React.FC<{ onSelect: (data: any) => void; isDark: boolean }> = ({ onSelect, isDark }) => {
  const { getToken } = useAuth();
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<IMDBResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<'network' | 'empty' | null>(null);
  const [errorDetail, setErrorDetail] = useState('');
  const [lastSearchedQuery, setLastSearchedQuery] = useState('');
  const [retryNonce, setRetryNonce] = useState(0);
  const debounceRef = useRef<NodeJS.Timeout>();
  const viaRef = useRef<'proxy' | 'imdb'>('proxy');

  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [anchorWidth, setAnchorWidth] = useState<number | undefined>(undefined);
  useEffect(() => {
    if (!anchorRef.current) return;
    const ro = new ResizeObserver(() => {
      if (anchorRef.current) setAnchorWidth(anchorRef.current.clientWidth);
    });
    ro.observe(anchorRef.current);
    setAnchorWidth(anchorRef.current.clientWidth);
    return () => ro.disconnect();
  }, []);

  const authHeaders = async (): Promise<Record<string, string>> => {
    try { const token = await getToken(); return token ? { Authorization: `Bearer ${token}` } : {}; } catch { return {}; }
  };

  const searchViaProxy = async (q: string): Promise<IMDBResult[]> => {
    const res = await fetch(`${API_BASE}/omdb/search?q=${encodeURIComponent(q)}`, { headers: await authHeaders() });
    if (!res.ok) throw new Error(`proxy HTTP ${res.status}`);
    const data = await res.json();
    if (data?.Response === 'False') {
      if (/not found|too many results|incorrect imdb/i.test(data.Error || '')) return [];
      throw new Error(`proxy: ${data.Error || 'unexpected response'}`);
    }
    if (data?.error && !data?.Search && !data?.results) throw new Error(`proxy: ${data.error}`);
    return mapProxySearch(data);
  };

  const runSearch = async (q: string): Promise<IMDBSearchOutcome> => {
    let proxyErr = '';
    try { return { results: await searchViaProxy(q), via: 'proxy' }; }
    catch (e: any) { proxyErr = e?.message || 'proxy failed'; }
    try { return { results: await searchImdbDirect(q), via: 'imdb' }; }
    catch (e: any) { throw new Error(`${proxyErr}; IMDb direct: ${e?.message || 'blocked'}`); }
  };

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (inputValue.length < 2) { setOptions([]); setError(null); setErrorDetail(''); setLastSearchedQuery(''); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      setError(null); setErrorDetail('');
      try {
        const { results, via } = await runSearch(inputValue);
        viaRef.current = via;
        setOptions(results);
        setLastSearchedQuery(inputValue);
        if (results.length === 0) setError('empty');
      } catch (e: any) {
        setOptions([]);
        setError('network');
        setErrorDetail(e?.message || '');
        setLastSearchedQuery(inputValue);
      }
      setLoading(false);
    }, 500);
  }, [inputValue, retryNonce]); // eslint-disable-line

  const detailViaProxy = async (id: string) => {
    const res = await fetch(`${API_BASE}/omdb/detail?id=${encodeURIComponent(id)}`, { headers: await authHeaders() });
    if (!res.ok) throw new Error(`proxy HTTP ${res.status}`);
    const d = await res.json();
    if (d?.Response === 'False' || (!d?.Title && !d?.title)) throw new Error(d?.Error || d?.error || 'no detail');
    return {
      title: d.Title || d.title || '', director: d.Director || d.director || '', year: String(d.Year || d.year || ''),
      runtime: d.Runtime || d.runtime || '', genre: d.Genre || d.genre || '', plot: d.Plot || d.plot || '',
      cast: d.Actors || d.cast || '', rating: d.imdbRating ? `${d.imdbRating}/10` : (d.rating || ''),
      imdbId: d.imdbID || d.imdbId || id, posterUrl: d.Poster && d.Poster !== 'N/A' ? d.Poster : (d.posterUrl || ''),
    };
  };

  const detailViaFallback = async (item: IMDBResult) => {
    const wd = await detailFromWikidata(item.id).catch(() => null);
    const plot = wd?.article ? await wikipediaSummary(wd.article).catch(() => '') : '';
    return {
      title: item.title, director: wd?.directors || '', year: item.year || wd?.year || '',
      runtime: wd?.minutes ? `${wd.minutes} min` : '', genre: wd?.genres || '', plot,
      cast: item.stars || '', rating: '', imdbId: item.id, posterUrl: item.posterFull || item.poster || '',
    };
  };

  const handleSelect = async (item: IMDBResult | null) => {
    if (!item || !item.id) return;
    setLoading(true);
    try {
      let detail: any = null;
      if (viaRef.current === 'proxy') { try { detail = await detailViaProxy(item.id); } catch { detail = null; } }
      if (!detail) detail = await detailViaFallback(item);
      if (!detail.title) detail.title = item.title;
      onSelect(detail);
      setInputValue(''); setOptions([]); setError(null); setErrorDetail(''); setLastSearchedQuery('');
    } catch (e: any) {
      setError('network'); setErrorDetail(`detail lookup: ${e?.message || 'failed'}`);
    }
    setLoading(false);
  };

  return (
    <Box ref={anchorRef} sx={{ width: '100%' }}>
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(o) => typeof o === 'string' ? o : `${o.title}${o.year ? ` (${o.year})` : ''}`}
      inputValue={inputValue}
      onInputChange={(_, v) => setInputValue(v)}
      onChange={(_, v) => {
        if (v && typeof v === 'object') handleSelect(v as IMDBResult);
        else if (typeof v === 'string' && /^tt\d{5,}$/i.test(v.trim())) handleSelect({ id: v.trim().toLowerCase(), title: '', year: '' });
      }}
      loading={loading}
      filterOptions={(x) => x}
      open={inputValue.length >= 2 && (loading || options.length > 0 || error !== null)}
      noOptionsText=""
      disablePortal={false}
      slotProps={{
        popper: { style: { zIndex: 99999, width: anchorWidth }, placement: 'bottom-start' },
        paper: { sx: { bgcolor: 'background.paper', zIndex: 99999, width: '100%' } },
      }}
      PaperComponent={({ children, ...paperProps }) => (
        <Paper {...paperProps} sx={{ bgcolor: 'background.paper', boxShadow: 4, ...((paperProps as any).sx || {}) }}>
          {options.length > 0 && children}
          {error !== null && !loading && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.2, borderTop: options.length > 0 ? '1px solid' : 'none', borderColor: 'divider' }}>
              <WarningIcon sx={{ fontSize: 16, color: error === 'network' ? '#ef4444' : '#f59e0b', flexShrink: 0 }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                  {error === 'network'
                    ? 'Film lookup failed — could not reach the server proxy or IMDb.'
                    : `No results for "${lastSearchedQuery}".`}
                </Typography>
                {error === 'network' && errorDetail && (
                  <Typography sx={{ fontSize: 10.5, color: 'text.disabled', mt: 0.2, wordBreak: 'break-word' }}>{errorDetail}</Typography>
                )}
              </Box>
              <Button size="small" variant="outlined" onMouseDown={(e) => { e.preventDefault(); }} onClick={() => setRetryNonce(n => n + 1)}
                sx={{ fontSize: 11, textTransform: 'none', py: 0.2, minWidth: 0, px: 1 }}>
                Retry
              </Button>
            </Box>
          )}
          {options.length > 0 && error === null && !loading && (
            <Box sx={{ p: 0.7, borderTop: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography sx={{ fontSize: 10, color: 'text.disabled' }}>
                {viaRef.current === 'imdb' ? 'via IMDb (server proxy unavailable)' : ''}
              </Typography>
              <Typography sx={{ fontSize: 10, color: 'text.disabled', fontWeight: 500 }}>
                {options.length} result{options.length === 1 ? '' : 's'}
              </Typography>
            </Box>
          )}
        </Paper>
      )}
      renderInput={(p) => <TextField {...p} size="small" placeholder="Search films and series, or paste an IMDb id (tt…)" InputProps={{ ...p.InputProps, endAdornment: <>{loading && <CircularProgress size={16} />}{p.InputProps.endAdornment}</> }} />}
      renderOption={(props, o) => <Box component="li" {...props} key={o.id} sx={{ display: 'flex', gap: 1, py: 0.75 }}>{o.poster ? <Box component="img" src={o.poster} alt="" sx={{ width: 30, height: 45, objectFit: 'cover', borderRadius: 0.5 }} /> : <Box sx={{ width: 30, height: 45, bgcolor: 'action.hover', borderRadius: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><MovieIcon sx={{ fontSize: 16, color: 'text.disabled' }} /></Box>}<Box sx={{ minWidth: 0 }}><Typography variant="body2" fontWeight={500} noWrap>{o.title}</Typography><Typography variant="caption" color="text.secondary">{[o.year, o.kind, o.stars].filter(Boolean).join(' — ')}</Typography></Box></Box>}
    />
    </Box>
  );
};

interface ArxivResult { id: string; title: string; authors: string; published: string; summary: string; doi?: string; journal?: string; categories: string; pdfUrl: string }
const ArxivAutocomplete: React.FC<{ onSelect: (data: any) => void; isDark: boolean }> = ({ onSelect, isDark }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<ArxivResult[]>([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef<NodeJS.Timeout>();
  
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (inputValue.length < 3) { setOptions([]); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/arxiv-search?q=${encodeURIComponent(inputValue)}`);
        const data = await res.json();
        if (data.results) setOptions(data.results.slice(0, 8));
      } catch { setOptions([]); }
      setLoading(false);
    }, 600);
  }, [inputValue]);
  
  const handleSelect = (item: ArxivResult | null) => {
    if (!item) return;
    const catMap: Record<string, string> = { 'cs.': 'Computer Science', 'math.': 'Mathematics', 'physics': 'Physics', 'astro': 'Physics', 'cond-mat': 'Physics', 'hep-': 'Physics', 'quant-ph': 'Physics', 'gr-qc': 'Physics', 'nucl-': 'Physics', 'q-bio': 'Biology', 'stat.': 'Mathematics', 'econ.': 'Economics', 'eess.': 'Engineering', 'nlin.': 'Mathematics' };
    let field = 'Other';
    for (const [prefix, f] of Object.entries(catMap)) { if (item.categories.includes(prefix)) { field = f; break; } }
    onSelect({ title: item.title, authors: item.authors, journal: item.journal || item.categories, doi: item.doi ? `https://doi.org/${item.doi}` : item.pdfUrl, date: item.published, field, summary: item.summary, arxivId: item.id });
    setInputValue(''); setOptions([]);
  };
  
  return (
    <Autocomplete 
      freeSolo 
      options={options} 
      getOptionLabel={(o) => typeof o === 'string' ? o : o.title} 
      inputValue={inputValue} 
      onInputChange={(_, v) => setInputValue(v)} 
      onChange={(_, v) => handleSelect(v as ArxivResult)} 
      loading={loading} 
      filterOptions={(x) => x}
      disablePortal={false}
      slotProps={{
        popper: { style: { zIndex: 99999 }, placement: 'bottom-start' },
        paper: { sx: { bgcolor: 'background.paper', zIndex: 99999 } }
      }}
      renderInput={(p) => <TextField {...p} size="small" placeholder="Search arXiv papers..." InputProps={{ ...p.InputProps, endAdornment: <>{loading && <CircularProgress size={16} />}{p.InputProps.endAdornment}</> }} />}
      renderOption={(props, o) => (
        <Box component="li" {...props} sx={{ display: 'flex', gap: 1, py: 0.75, alignItems: 'flex-start' }}>
          <Box sx={{ width: 28, height: 36, bgcolor: 'rgba(139,92,246,0.1)', borderRadius: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: 0.3 }}>
            <ScienceIcon sx={{ fontSize: 14, color: '#8b5cf6' }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" fontWeight={500} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', lineHeight: 1.3, fontSize: 12 }}>{o.title}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.authors} · {o.published.substring(0, 4)}</Typography>
            <Typography variant="caption" sx={{ color: '#8b5cf6', fontSize: 9 }}>{o.categories}</Typography>
          </Box>
        </Box>
      )}
    />
  );
};

// ▓▓▓▓▓ INLINE INPUT COMPONENTS ▓▓▓▓▓
const StyledInput: React.FC<{ type: string; value: string; onChange: (v: string) => void; isDark: boolean }> = ({ type, value, onChange, isDark }) => (
  <input type={type} value={value} onChange={(e) => onChange(e.target.value)} style={{ width: '100%', padding: '6px 8px', borderRadius: '4px', border: `1px solid ${isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'}`, backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)', color: isDark ? '#E3E3DF' : '#1a1a2e', fontSize: '12px', outline: 'none' }} />
);

const DurationInput: React.FC<{ value: string; onChange: (v: string) => void; isDark: boolean }> = ({ value, onChange, isDark }) => {
  const parts = value.split(':');
  const s = { padding: '5px', borderRadius: '3px', border: `1px solid ${isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'}`, backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)', color: isDark ? '#E3E3DF' : '#1a1a2e', fontSize: '11px', textAlign: 'center' as const, width: 28, outline: 'none' };
  const h = (i: number, v: string) => { const n = v.replace(/\D/g, '').slice(0,2); const a = [parts[0]||'',parts[1]||'',parts[2]||'']; a[i] = n; onChange(a.join(':')); };
  return <Box sx={{ display: 'flex', gap: 0.25, alignItems: 'center' }}><input style={s} value={parts[0]||''} onChange={e=>h(0,e.target.value)} placeholder="HH"/><span>:</span><input style={s} value={parts[1]||''} onChange={e=>h(1,e.target.value)} placeholder="MM"/><span>:</span><input style={s} value={parts[2]||''} onChange={e=>h(2,e.target.value)} placeholder="SS"/></Box>;
};

const TimeRangeSlider: React.FC<{ from: number; to: number; onChange: (from: number, to: number) => void; max: number }> = ({ from, to, onChange, max }) => {
  const handleChange = (_: Event, v: number | number[]) => {
    const [newFrom, newTo] = v as number[];
    onChange(newFrom, newTo);
  };
  return (
    <Box sx={{ width: '100%', px: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary">From: <b>{formatTime(from)}</b></Typography>
        <Typography variant="caption" color="text.secondary">To: <b>{formatTime(to)}</b></Typography>
      </Box>
      <Slider value={[from, to]} onChange={handleChange} min={0} max={max || 7200} step={1} size="small" disableSwap sx={{ py: 0.5, '& .MuiSlider-thumb': { width: 16, height: 16 } }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.disabled" fontSize={9}>0:00</Typography>
        <Typography variant="caption" color="text.disabled" fontSize={9}>{formatTime(max || 7200)}</Typography>
      </Box>
    </Box>
  );
};

// ▓▓▓▓▓ REFERENCE & SOURCE-INFO DIALOGS ▓▓▓▓▓

const RefPointDialog: React.FC<{
  open: boolean; onClose: () => void;
  onSave: (fromValue: string, toValue: string, sectionAnchors: {
    fromSectionStartsWith: string;
    toSectionEndsWith: string;
  }) => void;
  mainSourceType: string | null;
  pointerType?: string;
  initialFrom?: string; initialTo?: string;
  initialFromSectionStartsWith?: string;
  initialToSectionEndsWith?: string;
  isDark: boolean;
}> = ({ open, onClose, onSave, mainSourceType, pointerType, initialFrom = '', initialTo = '',
       initialFromSectionStartsWith = '', initialToSectionEndsWith = '' }) => {
  const [fromValue, setFromValue] = useState('');
  const [toValue, setToValue] = useState('');
  const [fromSecStart, setFromSecStart] = useState('');
  const [toSecEnd, setToSecEnd] = useState('');
  const [fromError, setFromError] = useState('');
  const [toError, setToError] = useState('');
  const [fromTime, setFromTime] = useState(0);
  const [toTime, setToTime] = useState(0);

  const sourceTypeData = mainSourceType ? ALL_SOURCE_TYPES.find(s => s.type === mainSourceType) : null;
  const defaults = DEFAULT_POINTER_TYPES[mainSourceType || ''] || DEFAULT_POINTER_TYPES.default;
  const activeKey = pointerType || defaults[0] || 'page';
  const activePointer = REF_POINTER_TYPES.find(p => p.key === activeKey) || REF_POINTER_TYPES[0];
  const isTimeBased = activeKey === 'time';
  const isPageBased = activeKey === 'page';
  const color = getSourceColor(mainSourceType);

  useEffect(() => {
    if (open) {
      const fr = validateRefPointInput(activePointer.key, initialFrom);
      const tr = validateRefPointInput(activePointer.key, initialTo);
      setFromValue(fr.value);
      setToValue(tr.value);
      setFromError(initialFrom && fr.value !== initialFrom ? fr.error || 'Invalid value for current type' : '');
      setToError(initialTo && tr.value !== initialTo ? tr.error || 'Invalid value for current type' : '');
      setFromTime(initialFrom ? parseInt(initialFrom, 10) || 0 : 0);
      setToTime(initialTo ? parseInt(initialTo, 10) || 0 : 0);
      setFromSecStart(initialFromSectionStartsWith || '');
      setToSecEnd(initialToSectionEndsWith || '');
    }
  }, [open, initialFrom, initialTo,
      initialFromSectionStartsWith, initialToSectionEndsWith,
      activePointer.key]);

  const getComparable = (raw: string, ptype: string): number | null => {
    const s = (raw || '').trim();
    if (!s) return null;
    if (ptype === 'time' || ptype === 'datetime') {
      const m = s.match(/^(\d+):(\d+)(?::(\d+))?$/);
      if (m) return parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + (m[3] ? parseInt(m[3], 10) / 60 : 0);
      const d = new Date(s).getTime();
      return isNaN(d) ? null : d;
    }
    if (ptype === 'page' || ptype === 'section') {
      const m = s.match(/(-?\d+(?:\.\d+)?)/);
      return m ? parseFloat(m[1]) : null;
    }
    return null;
  };
  const checkOrderError = (f: string, t: string, ptype: string): string => {
    if (!t.trim()) return '';
    const fn = getComparable(f, ptype);
    const tn = getComparable(t, ptype);
    if (fn == null || tn == null) return '';
    if (tn < fn) return 'To value must not be less than From';
    return '';
  };

  const orderError = !isTimeBased ? checkOrderError(fromValue, toValue, activePointer.key) : '';

  const handleSave = () => {
    const f = isTimeBased ? formatTime(fromTime) : fromValue.trim();
    const t = isTimeBased ? (toTime > fromTime ? formatTime(toTime) : '') : toValue.trim();
    if (!f) return;
    if (fromError || toError) return;
    if (orderError) return;
    const anchors = isPageBased
      ? {
          fromSectionStartsWith: fromSecStart.trim(),
          toSectionEndsWith: toSecEnd.trim(),
        }
      : {
          fromSectionStartsWith: '',
          toSectionEndsWith: '',
        };
    onSave(f, t, anchors);
    onClose();
  };

  const isEditing = !!(initialFrom || initialTo);

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '8px' } }}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <RadioButtonCheckedIcon sx={{ color: '#64748b' }} />
          <Typography fontWeight={600}>{isEditing ? 'Edit Reference Point' : 'Add Reference Point'}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Specify the range this bubble points to in the seed source.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: color }} />
          {sourceTypeData?.icon}
          <Typography fontSize={13}>{sourceTypeData?.label || 'Source'}</Typography>
          <Box sx={{ flex: 1 }} />
          <Chip size="small" label={`${activePointer.icon} ${activePointer.label}`}
            sx={{ fontSize: 10, height: 20, bgcolor: `${color}20`, color, fontWeight: 600 }} />
        </Box>
        {isTimeBased ? (
          <Box sx={{ mt: 1, px: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" color="text.secondary">From: {formatTime(fromTime)}</Typography>
            </Box>
            <Slider value={fromTime} onChange={(_, v) => setFromTime(v as number)} min={0} max={7200} step={1} size="small" sx={{ py: 0.5 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, mt: 1 }}>
              <Typography variant="caption" color="text.secondary">To: {toTime > fromTime ? formatTime(toTime) : '— (single point)'}</Typography>
            </Box>
            <Slider value={toTime} onChange={(_, v) => setToTime(v as number)} min={0} max={7200} step={1} size="small" sx={{ py: 0.5 }} />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
            <TextField fullWidth size="small" label={activePointer.fromLabel} value={fromValue}
              onChange={(e) => {
                const r = validateRefPointInput(activePointer.key, e.target.value);
                setFromValue(r.value);
                setFromError(r.error);
              }}
              error={!!fromError} helperText={fromError || ' '}
              placeholder={activePointer.placeholder} autoFocus />
            <TextField fullWidth size="small" label={`${activePointer.toLabel} (optional)`} value={toValue}
              onChange={(e) => {
                const r = validateRefPointInput(activePointer.key, e.target.value);
                setToValue(r.value);
                setToError(r.error);
              }}
              error={!!toError || !!orderError} helperText={toError || orderError || ' '}
              placeholder={activePointer.placeholder} />
          </Box>
        )}
        {!isTimeBased && isPageBased && fromValue.trim() && (
          <Box sx={{ mt: 0.5, mb: 1, p: 1.2, borderRadius: 1, bgcolor: 'action.hover' }}>
            <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 1 }}>
              Section on page {fromValue.trim()} starts with <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
            </Typography>
            <TextField fullWidth size="small" value={fromSecStart}
              onChange={(e) => setFromSecStart(e.target.value)}
              placeholder='e.g. "It became apparent"' />
          </Box>
        )}
        {!isTimeBased && isPageBased && toValue.trim() && (
          <Box sx={{ mb: 1, p: 1.2, borderRadius: 1, bgcolor: 'action.hover' }}>
            <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 1 }}>
              Section on page {toValue.trim()} ends with <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
            </Typography>
            <TextField fullWidth size="small" value={toSecEnd}
              onChange={(e) => setToSecEnd(e.target.value)}
              placeholder='e.g. "the final outcome."' />
          </Box>
        )}
        <Typography variant="caption" color="text.disabled" sx={{ mt: 1.5, display: 'block' }}>
          Tip: leave the "to" empty for a single-point reference (e.g. "page 33"). The "to" value, if set, must not be less than "from" (e.g. <em>page 10 to page 8</em> is invalid). Change the reference type from the seed node's settings.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}
          disabled={!!fromError || !!toError || !!orderError || (!isTimeBased && !fromValue.trim())}
          sx={{ bgcolor: '#475569', '&:hover': { bgcolor: '#334155' } }}>{isEditing ? 'Save' : 'Add Reference'}</Button>
      </DialogActions>
    </Dialog>
  );
};

const ReferenceDialog: React.FC<{ open: boolean; onClose: () => void; onSave: (ref: ReferencePointer) => void; reference: ReferencePointer; sourceType: string | null; sourceFields: SourceFields; isWebArchive?: boolean }> = ({ open, onClose, onSave, reference, sourceType, sourceFields, isWebArchive }) => {
  const [ref, setRef] = useState<ReferencePointer>(reference);
  const [fromError, setFromError] = useState('');
  const [toError, setToError] = useState('');
  useEffect(() => {
    setRef(reference); setFromError(''); setToError('');
    if (!reference.pointerType && open) {
      const defaults = isWebArchive ? ['pixel'] : (DEFAULT_POINTER_TYPES[sourceType || ''] || DEFAULT_POINTER_TYPES.default);
      setRef(prev => ({ ...prev, pointerType: prev.pointerType || defaults[0] }));
    }
    if (isWebArchive && open && reference.pointerType !== 'pixel') {
      setRef(prev => ({ ...prev, pointerType: 'pixel' }));
    }
  }, [reference, open, sourceType, isWebArchive]);
  const color = getSourceColor(sourceType);
  const defaults = isWebArchive ? ['pixel'] : (DEFAULT_POINTER_TYPES[sourceType || ''] || DEFAULT_POINTER_TYPES.default);
  const orderedPointers = [...defaults.map(k => REF_POINTER_TYPES.find(p => p.key === k)!).filter(Boolean), ...REF_POINTER_TYPES.filter(p => !defaults.includes(p.key))];
  const activePointer = REF_POINTER_TYPES.find(p => p.key === ref.pointerType) || orderedPointers[0];
  const isTime = activePointer?.key === 'time';
  const maxDuration = isTime ? getDurationFromFields(sourceType, sourceFields) : 7200;
  const maxPages = activePointer?.key === 'page' ? getMaxPagesFromFields(sourceType, sourceFields) : null;

  const handleFromChange = (v: string) => {
    setRef(prev => ({ ...prev, from: v }));
    const num = parseFloat(v);
    if (v && !isNaN(num) && maxPages && num > maxPages) setFromError(`Max ${maxPages} pages`);
    else setFromError('');
    const toNum = parseFloat(ref.to);
    if (v && !isNaN(num) && !isNaN(toNum) && toNum < num) setToError(`Must be ≥ ${v}`);
    else setToError('');
  };
  const handleToChange = (v: string) => {
    setRef(prev => ({ ...prev, to: v }));
    const fromNum = parseFloat(ref.from);
    const toNum = parseFloat(v);
    if (v && !isNaN(fromNum) && !isNaN(toNum) && toNum < fromNum) setToError(`Must be ≥ ${ref.from}`);
    else if (v && !isNaN(toNum) && maxPages && toNum > maxPages) setToError(`Max ${maxPages} pages`);
    else setToError('');
  };
  const handleTimeRange = (from: number, to: number) => {
    setRef(prev => ({ ...prev, fromTime: from, toTime: to, from: formatTime(from), to: formatTime(to) }));
  };
  const canSave = !toError && !fromError;

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><BookmarkIcon sx={{ color }} /><Typography fontWeight={600}>Reference Pointer</Typography></Box></DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, p: 1.2, borderRadius: '8px', border: '1px solid', borderColor: ref.notApplicable ? color : 'divider', bgcolor: ref.notApplicable ? `${color}08` : 'transparent', cursor: 'pointer' }}
          onClick={() => setRef(prev => ({ ...prev, notApplicable: !prev.notApplicable }))}>
          <input type="checkbox" checked={!!ref.notApplicable} readOnly style={{ width: 16, height: 16, accentColor: color }} />
          <Box>
            <Typography fontSize={12} fontWeight={600}>Reference not applicable</Typography>
            <Typography fontSize={10} color="text.secondary">The entire source is the reference — no specific location needed.</Typography>
          </Box>
        </Box>

        {!ref.notApplicable && (
          <>
            <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ mb: 0.5, display: 'block' }}>Pointer Type</Typography>
            {isWebArchive && <Typography fontSize={10} color="text.disabled" sx={{ mb: 0.5, fontStyle: 'italic' }}>Web archive sources use Pixel Area coordinates</Typography>}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
              {orderedPointers.map(p => (
                <Chip key={p.key} label={<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}><span style={{ fontSize: 12 }}>{p.icon}</span><span>{p.label}</span></Box>}
                  size="small" clickable={!isWebArchive || p.key === 'pixel'} disabled={isWebArchive && p.key !== 'pixel'}
                  onClick={() => { if (isWebArchive && p.key !== 'pixel') return; setRef(prev => ({ ...prev, pointerType: p.key, from: '', to: '', fromTime: undefined, toTime: undefined })); }}
                  sx={{ fontSize: 11, height: 28, bgcolor: ref.pointerType === p.key ? color : 'transparent', color: ref.pointerType === p.key ? '#1a1a2e' : 'text.secondary', border: '1px solid', borderColor: ref.pointerType === p.key ? color : defaults.includes(p.key) ? `${color}40` : 'divider', fontWeight: ref.pointerType === p.key ? 600 : 400, opacity: isWebArchive && p.key !== 'pixel' ? 0.3 : 1 }} />
              ))}
            </Box>

            {isTime ? (
              <Box sx={{ mb: 2 }}>
                <TimeRangeSlider from={ref.fromTime || 0} to={ref.toTime || 0} onChange={handleTimeRange} max={maxDuration} />
              </Box>
            ) : (
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontWeight={500}>{activePointer?.fromLabel || 'From'}</Typography>
                  <TextField fullWidth size="small" value={ref.from}
                    onChange={(e) => handleFromChange(e.target.value)}
                    placeholder={activePointer?.placeholder}
                    error={!!fromError} helperText={fromError} sx={{ mt: 0.5 }} />
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontWeight={500}>{activePointer?.toLabel || 'To'}</Typography>
                  <TextField fullWidth size="small" value={ref.to}
                    onChange={(e) => handleToChange(e.target.value)}
                    placeholder={activePointer?.placeholder}
                    error={!!toError} helperText={toError} sx={{ mt: 0.5 }} />
                </Box>
              </Box>
            )}
            {maxPages && <Typography fontSize={10} color="text.disabled" sx={{ mt: -1.5, mb: 1.5 }}>{maxPages} pages total</Typography>}

            {sourceType === 'book' && activePointer?.key === 'page' && ref.from.trim() && (
              <Box sx={{ mb: 1.5, p: 1.2, borderRadius: 1, bgcolor: 'action.hover' }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 1 }}>
                  Section on page {ref.from.trim()} starts with <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
                </Typography>
                <TextField fullWidth size="small" value={ref.fromSectionStartsWith || ''}
                  onChange={(e) => setRef(prev => ({ ...prev, fromSectionStartsWith: e.target.value }))}
                  placeholder='e.g. "It became apparent"' />
              </Box>
            )}
            {sourceType === 'book' && activePointer?.key === 'page' && ref.to.trim() && (
              <Box sx={{ mb: 1.5, p: 1.2, borderRadius: 1, bgcolor: 'action.hover' }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 1 }}>
                  Section on page {ref.to.trim()} ends with <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
                </Typography>
                <TextField fullWidth size="small" value={ref.toSectionEndsWith || ''}
                  onChange={(e) => setRef(prev => ({ ...prev, toSectionEndsWith: e.target.value }))}
                  placeholder='e.g. "the final outcome."' />
              </Box>
            )}

            <Box sx={{ mb: 2 }}>
              <Typography variant="caption" color="text.secondary" fontWeight={500}>Reference Type</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                {REF_TYPES.map(t => (
                  <Chip key={t} label={t} size="small" clickable onClick={() => setRef(prev => ({ ...prev, refType: prev.refType === t ? '' : t }))} 
                    sx={{ fontSize: 11, height: 26, bgcolor: ref.refType === t ? color : 'transparent', color: ref.refType === t ? '#1a1a2e' : 'text.secondary', border: '1px solid', borderColor: ref.refType === t ? color : 'divider', fontWeight: ref.refType === t ? 600 : 400 }} />
                ))}
              </Box>
            </Box>

            <Typography variant="caption" color="text.secondary" fontWeight={500}>Notes</Typography>
            <TextField fullWidth multiline rows={2} size="small" value={ref.notes} onChange={(e) => setRef({ ...ref, notes: e.target.value })} sx={{ mt: 0.5 }} />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}><Button onClick={onClose}>Cancel</Button><Button variant="contained" disabled={!canSave} onClick={() => { onSave(ref); onClose(); }} sx={{ bgcolor: color }}>Save</Button></DialogActions>
    </Dialog>
  );
};

const SourceInfoDialog: React.FC<{ open: boolean; onClose: () => void; onSave: (fields: SourceFields, file: UploadedFile | null, apiPrefillFields?: Record<string, string>) => void; sourceType: string | null; currentFields: SourceFields; currentFile: UploadedFile | null; isDark: boolean; onChangeType?: () => void }> = ({ open, onClose, onSave, sourceType, currentFields, currentFile, isDark, onChangeType }) => {
  const [fields, setFields] = useState<SourceFields>(currentFields);
  const [file, setFile] = useState<UploadedFile | null>(currentFile);
  const fileRef = useRef<HTMLInputElement>(null);
  const apiPrefillRef = useRef<Record<string, string>>({});
  useEffect(() => { setFields(currentFields); setFile(currentFile); apiPrefillRef.current = {}; }, [currentFields, currentFile, open]);
  const sourceData = sourceType ? ALL_SOURCE_TYPES.find(s => s.type === sourceType) : null;
  const configs = sourceData?.fields || [];
  const color = getSourceColor(sourceType);
  const handleChange = (i: number, v: string) => { const k = `field${i + 1}` as keyof SourceFields; setFields(p => ({ ...p, [k]: v })); };
  const storeApiPrefill = (f: SourceFields) => { const pf: Record<string, string> = {}; Object.entries(f).forEach(([k, v]) => { if (v) pf[k] = v; }); apiPrefillRef.current = pf; };
  const handleOpenLib = (d: any) => { const f = { ...emptyFields, field2: d.title, field3: d.author, field4: d.publisher, field5: d.year, field6: d.isbn, field7: d.pages, field8: d.language, field9: d.subject, field10: d.coverUrl || d.olid }; setFields(f); storeApiPrefill(f); };
  const handleIMDB = (d: any) => { const f = { ...emptyFields, field2: d.title, field3: d.director, field4: d.year, field5: d.runtime, field6: d.genre, field7: d.plot, field8: d.cast, field9: d.rating, field10: d.posterUrl || d.imdbId }; setFields(f); storeApiPrefill(f); };
  const handleArxiv = (d: any) => { const f = { ...emptyFields, field2: d.title, field3: d.authors, field4: d.journal || '', field6: d.doi || '', field7: d.date || '', field8: d.field || '', field10: d.summary || '' }; setFields(f); storeApiPrefill(f); };
  const handleMicrolink = (d: any) => setFields({ ...emptyFields, field2: d.title, field3: d.siteName, field4: d.url, field5: new Date().toISOString().split('T')[0] });
  const renderField = (c: FieldConfig, i: number) => {
    const v = fields[`field${i + 1}` as keyof SourceFields];
    if (c.type === 'openlib_search') return <OpenLibAutocomplete onSelect={handleOpenLib} isDark={isDark} />;
    if (c.type === 'imdb_search') return <IMDBAutocomplete onSelect={handleIMDB} isDark={isDark} />;
    if (c.type === 'arxiv_search') return <ArxivAutocomplete onSelect={handleArxiv} isDark={isDark} />;
    if (c.type === 'microlink_search') return <MicrolinkAutocomplete onSelect={handleMicrolink} isDark={isDark} />;
    if (c.type === 'textarea') return <TextField fullWidth multiline rows={2} size="small" value={v} onChange={(e) => handleChange(i, e.target.value)} placeholder={c.placeholder} />;
    if (c.type === 'duration') return <DurationInput value={v} onChange={(x) => handleChange(i, x)} isDark={isDark} />;
    if (c.type === 'year') return <TextField fullWidth size="small" type="number" value={v} onChange={(e) => handleChange(i, e.target.value.slice(0, 4))} placeholder="YYYY" inputProps={{ style: { fontSize: '12px' } }} />;
    if (c.type === 'date' || c.type === 'datetime') return (
      <Box>
        <StyledInput type={c.type === 'datetime' ? 'datetime-local' : 'date'} value={v} onChange={(x) => handleChange(i, x)} isDark={isDark} />
        <Typography sx={{ fontSize: 9, color: 'text.disabled', mt: 0.3, fontStyle: 'italic' }}>Your local time: {new Date().toLocaleString(undefined, { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })} ({Intl.DateTimeFormat().resolvedOptions().timeZone})</Typography>
      </Box>
    );
    if (c.type === 'slider') return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 0.5 }}>
        <Slider size="small" value={Number(v) || c.min || 1} min={c.min || 1} max={c.max || 10} step={c.step || 1} onChange={(_, val) => handleChange(i, String(val))} valueLabelDisplay="auto" sx={{ flex: 1, '& .MuiSlider-thumb': { width: 14, height: 14 } }} />
        <Typography sx={{ fontSize: 13, fontWeight: 700, fontFamily: 'monospace', minWidth: 22, textAlign: 'center', color: Number(v) >= 7 ? '#10b981' : Number(v) >= 4 ? '#f59e0b' : Number(v) > 0 ? '#ef4444' : 'text.disabled' }}>{v || '—'}</Typography>
      </Box>
    );
    if (c.type === 'select' && c.options) return (
      <TextField fullWidth size="small" select value={v || ''} onChange={(e) => handleChange(i, e.target.value)} SelectProps={{ native: true }} inputProps={{ style: { fontSize: '12px' } }}>
        <option value="">— select —</option>
        {c.options.map(o => <option key={o} value={o}>{o}</option>)}
      </TextField>
    );
    if (c.type === 'map_picker') return (
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
        {(() => {
          const coordIdx = configs.findIndex(cf => cf.codeTag === 'coordinates' || cf.label?.toLowerCase().includes('coordinates'));
          const coordKey = coordIdx >= 0 ? `field${coordIdx + 1}` as keyof SourceFields : 'field2' as keyof SourceFields;
          const coordStr = fields[coordKey] || '';
          const coordParts = coordStr.split(',').map(s => parseFloat(s.trim()));
          const hasCoords = coordParts.length === 2 && !isNaN(coordParts[0]) && !isNaN(coordParts[1]);
          const lat = hasCoords ? coordParts[0] : 51.505;
          const lon = hasCoords ? coordParts[1] : -0.09;
          const span = 0.08;
          const bbox = { west: lon - span, south: lat - span * 0.6, east: lon + span, north: lat + span * 0.6 };
          return (
            <>
              <TextField size="small" fullWidth placeholder="Search location (e.g. Tenerife Airport, Paris France...)"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const q = (e.target as HTMLInputElement).value.trim();
                    if (!q) return;
                    fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=1`)
                      .then(r => r.json()).then(results => {
                        if (results.length > 0) {
                          const rlat = results[0].lat, rlon = results[0].lon;
                          setFields(p => ({ ...p, [coordKey]: `${parseFloat(rlat).toFixed(6)}, ${parseFloat(rlon).toFixed(6)}` }));
                        }
                      }).catch(() => {});
                  }
                }}
                InputProps={{ startAdornment: <SearchIcon sx={{ fontSize: 16, mr: 0.5, color: 'text.disabled' }} /> }}
                sx={{ '& input': { fontSize: 12 } }}
              />
              <Box sx={{ width: '100%', height: 400, borderRadius: '8px', overflow: 'hidden', border: '1px solid', borderColor: 'divider', position: 'relative' }}>
                {hasCoords ? (
                  <>
                    <iframe title="Map Picker" width="100%" height="100%" style={{ border: 0 }}
                      src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox.west},${bbox.south},${bbox.east},${bbox.north}&layer=mapnik&marker=${lat},${lon}`} />
                    <Box onClick={(e) => {
                        const rect = (e.target as HTMLElement).getBoundingClientRect();
                        const xPct = (e.clientX - rect.left) / rect.width;
                        const yPct = (e.clientY - rect.top) / rect.height;
                        const clickLon = bbox.west + xPct * (bbox.east - bbox.west);
                        const clickLat = bbox.north - yPct * (bbox.north - bbox.south);
                        setFields(p => ({ ...p, [coordKey]: `${clickLat.toFixed(6)}, ${clickLon.toFixed(6)}` }));
                      }}
                      sx={{ position: 'absolute', inset: 0, cursor: 'crosshair', zIndex: 2 }} />
                    <Box sx={{ position: 'absolute', top: 6, right: 6, bgcolor: 'rgba(0,0,0,0.75)', borderRadius: '6px', px: 1, py: 0.4, zIndex: 3 }}>
                      <Typography sx={{ fontSize: 10, color: '#E3E3DF', fontFamily: 'monospace' }}>📍 {lat.toFixed(5)}, {lon.toFixed(5)}</Typography>
                    </Box>
                    <Box sx={{ position: 'absolute', bottom: 6, left: 6, right: 6, display: 'flex', gap: 0.5, zIndex: 3 }}>
                      <TextField size="small" placeholder="Lat, Lon" value={fields[coordKey] || ''} onChange={(e) => { setFields(p => ({ ...p, [coordKey]: e.target.value })); }}
                        sx={{ flex: 1, '& input': { fontSize: 11, py: 0.5, px: 1, bgcolor: 'rgba(255,255,255,0.95)', borderRadius: '4px' } }} />
                    </Box>
                  </>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)' }}>
                    <Typography sx={{ fontSize: 36, mb: 1 }}>🗺️</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.secondary', mb: 0.5 }}>No location set</Typography>
                    <Typography sx={{ fontSize: 12, color: 'text.disabled', textAlign: 'center', maxWidth: 280 }}>
                      Search for a location above or enter coordinates manually below to place a pin on the map.
                    </Typography>
                    <TextField size="small" placeholder="Lat, Lon (e.g. 48.8566, 2.3522)" value={fields[coordKey] || ''}
                      onChange={(e) => { setFields(p => ({ ...p, [coordKey]: e.target.value })); }}
                      sx={{ mt: 2, width: 280, '& input': { fontSize: 12, textAlign: 'center' } }} />
                  </Box>
                )}
              </Box>
            </>
          );
        })()}
      </Box>
    );
    return <TextField fullWidth size="small" value={v} onChange={(e) => handleChange(i, e.target.value)} placeholder={c.placeholder} />;
  };
  const search = configs.find(c => c.type === 'openlib_search' || c.type === 'imdb_search' || c.type === 'arxiv_search' || c.type === 'microlink_search');
  const searchIdx = configs.findIndex(c => c.type === 'openlib_search' || c.type === 'imdb_search' || c.type === 'arxiv_search' || c.type === 'microlink_search');
  const isFullscreenType = sourceType === 'event' || sourceType === 'map';
  return (
    <Dialog disableScrollLock open={open} onClose={onClose} {...(isFullscreenType ? { fullScreen: true, PaperProps: { sx: { bgcolor: 'background.default' } } } : { maxWidth: 'md' as const, fullWidth: true, PaperProps: { sx: { borderRadius: '8px' } } })}>
      <DialogTitle sx={isFullscreenType ? { borderBottom: '1px solid', borderColor: 'divider' } : {}}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: color }} />{sourceData?.icon}<Typography fontWeight={600}>{sourceData?.label} Details</Typography><Box sx={{ flex: 1 }} />{onChangeType && <Button size="small" variant="outlined" onClick={() => { onClose(); onChangeType(); }} sx={{ fontSize: 11 }}>Change Type</Button>}</Box></DialogTitle>
      <DialogContent sx={isFullscreenType ? { display: 'flex', justifyContent: 'center', pt: '20px !important' } : {}}>
        <Box sx={isFullscreenType ? { width: '100%', maxWidth: 800 } : {}}>
        {search && <Box sx={{ mb: 2 }}><Typography variant="caption" color="text.secondary" fontWeight={500}>{search.label}</Typography>{renderField(search, searchIdx)}</Box>}
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>{configs.map((c, i) => { if (c.type === 'openlib_search' || c.type === 'imdb_search' || c.type === 'arxiv_search' || c.type === 'microlink_search') return null; const isFullWidth = c.type === 'map_picker' || c.type === 'textarea'; return (<Box key={i} sx={isFullWidth ? { gridColumn: '1 / -1' } : {}}><Typography variant="caption" color="text.secondary" fontWeight={500}>{c.label}</Typography>{c.hint && <Typography sx={{ fontSize: 10, color: 'text.disabled', lineHeight: 1.3, mb: 0.3, fontStyle: 'italic' }}>{c.hint}</Typography>}{renderField(c, i)}</Box>); })}</Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}><Button onClick={() => { setFields(emptyFields); setFile(null); apiPrefillRef.current = {}; }} color="error" sx={{ mr: 'auto' }}>Reset</Button><Button onClick={onClose}>Cancel</Button><Button variant="contained" onClick={() => { onSave(fields, file, Object.keys(apiPrefillRef.current).length > 0 ? apiPrefillRef.current : undefined); onClose(); }} sx={{ bgcolor: color }}>Save</Button></DialogActions>
    </Dialog>
  );
};

// ▓▓▓▓▓ SEARCH PAGE ▓▓▓▓▓
const SearchPage: React.FC<{ isDark: boolean; onBack: () => void; onLoadBoard: (boardId: string) => void }> = ({ isDark, onBack, onLoadBoard }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const doSearch = async () => {
    if (!query.trim()) return;
    setLoading(true); setSearched(true);
    try {
      const resp = await fetch(`${API_BASE}/search?q=${encodeURIComponent(query.trim())}`);
      if (resp.ok) { const data = await resp.json(); setResults(data.results || []); }
      else setResults([]);
    } catch { setResults([]); }
    setLoading(false);
  };

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small"><ArrowBackIcon sx={{ fontSize: 18 }} /></IconButton>
        <Typography fontWeight={700} fontSize={16}>Search Public Sources</Typography>
      </Box>
      <Box sx={{ px: 3, py: 2, maxWidth: 700, mx: 'auto', width: '100%' }}>
        <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
          <TextField fullWidth size="small" placeholder="Search boards, sources, chains..." value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') doSearch(); }}
            InputProps={{ startAdornment: <SearchIcon sx={{ fontSize: 18, color: 'text.disabled', mr: 0.5 }} /> }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }} />
          <Button variant="contained" onClick={doSearch} disabled={loading || !query.trim()}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '10px', px: 3 }}>
            {loading ? 'Searching...' : 'Search'}
          </Button>
        </Box>

        {loading ? (
          <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress size={28} /></Box>
        ) : searched && results.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <SearchIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
            <Typography color="text.secondary" fontSize={13}>No results found for "{query}"</Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {results.map((r, i) => (
              <Box key={i} onClick={() => onLoadBoard(r.board_id)}
                sx={{ p: 1.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', cursor: 'pointer',
                  '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderColor: 'primary.main' },
                  transition: 'all 0.12s' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Chip label={r.type || 'board'} size="small" sx={{ fontSize: 9, height: 18, bgcolor: r.type === 'source' ? '#8b5cf620' : r.type === 'chain' ? '#10b98120' : '#3b82f620', color: r.type === 'source' ? '#8b5cf6' : r.type === 'chain' ? '#10b981' : '#3b82f6', fontWeight: 600 }} />
                  <Typography sx={{ fontSize: 10, fontFamily: 'monospace', color: 'text.disabled' }}>{dispId(r.board_id)}</Typography>
                  {r.app_mode && <Chip label={r.app_mode} size="small" sx={{ fontSize: 8, height: 16 }} />}
                </Box>
                <Typography fontWeight={600} fontSize={13} sx={{ mb: 0.3 }}>{r.name || r.source_name || 'Untitled'}</Typography>
                {r.source_type && <Typography fontSize={10} color="text.secondary">Type: {r.source_type}</Typography>}
                {r.created_by && <Typography fontSize={9} color="text.disabled">by {r.created_by} · {r.created_at ? formatTimestamp(r.created_at, DEFAULT_SETTINGS) : ''}</Typography>}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

// ▓▓▓▓▓ DASHBOARD PAGE ▓▓▓▓▓
const DashboardPage: React.FC<{
  onSelect: (mode: AppMode) => void; isDark: boolean;
  onLoadBoard: (bid: string) => void; apiHeaders: () => Record<string, string>;
  onDeleteBoard: (bid: string) => void; username: string;
  onOpenMySources: () => void; userSettings: Record<string, any>;
}> = ({ onSelect, isDark, onLoadBoard, apiHeaders, onDeleteBoard, username, onOpenMySources, userSettings }) => {
  const { t } = useTranslation();
  const settings: AppSettings = { ...DEFAULT_SETTINGS, ...(userSettings || {}) };
  const [boards, setBoards] = useState<any[]>([]);
  const [stats, setStats] = useState({ boards: 0, sources: 0, publicBoards: 0 });
  const [siteStats, setSiteStats] = useState<{ users: number; boards: number; sources: number; publicBoards: number } | null>(null);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [lastLogin, setLastLogin] = useState<string | null>(null);
  const [retrying, setRetrying] = useState(false);
  const retryIntervalRef = React.useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchData = useCallback(() => {
    setLoading(true);
    setFetchError(false);
    const hdrs = apiHeaders();
    if (!hdrs['Authorization']) {
      setTimeout(() => {
        const h2 = apiHeaders();
        if (h2['Authorization']) fetchData();
        else setLoading(false);
      }, 500);
      return;
    }
    const timeout = new Promise<never>((_, reject) => setTimeout(() => reject(new Error('timeout')), 5000));
    Promise.race([
      Promise.all([
        fetch(`${API_BASE}/boards`, { headers: hdrs }).then(okJson),
        fetch(`${API_BASE}/auth/me`, { headers: hdrs }).then(okJson).catch(() => ({})),
        fetch(`${API_BASE}/stats`).then(okJson).catch(() => null),
      ]),
      timeout,
    ]).then(([boardsData, meData, sStats]) => {
      const ub = (boardsData && boardsData.boards) || [];
      setBoards(ub);
      setStats({ boards: ub.length, sources: ub.reduce((s: number, b: any) => s + (b.source_count || 0), 0), publicBoards: ub.filter((b: any) => b.is_public).length });
      if (sStats) setSiteStats(sStats);
      if ((meData as any).user?.lastLoginAt) setLastLogin((meData as any).user.lastLoginAt);
      setLoading(false);
      setFetchError(false);
      setRetrying(false);
      if (retryIntervalRef.current) { clearInterval(retryIntervalRef.current); retryIntervalRef.current = null; }
    }).catch(() => {
      setLoading(false);
      setFetchError(true);
      if (!retryIntervalRef.current) {
        setRetrying(true);
        retryIntervalRef.current = setInterval(() => { fetchData(); }, 4000);
      }
    });
  }, [apiHeaders]);

  const startRetrying = useCallback(() => {
    if (retryIntervalRef.current) return;
    setRetrying(true);
    fetchData();
    retryIntervalRef.current = setInterval(() => { fetchData(); }, 4000);
  }, [fetchData]);

  useEffect(() => { fetchData(); }, [fetchData]);
  useEffect(() => () => { if (retryIntervalRef.current) clearInterval(retryIntervalRef.current); }, []);

  const recentBoards = [...boards].sort((a, b) => (b.updated_at || '').localeCompare(a.updated_at || '')).slice(0, 6);

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', bgcolor: 'background.default' }}>
      <Box sx={{ width: '100%', borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', position: 'sticky', top: 0, zIndex: 10 }}>
        <Box sx={{ maxWidth: 980, mx: 'auto', px: 4, py: 1.5, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.3px' }}>source<span style={{ color: '#3b82f6' }}>.</span></Typography>
          <Box sx={{ flex: 1 }} />
          {username && <Typography fontSize={11} color="text.secondary">Signed in as {username}</Typography>}
        </Box>
      </Box>

      <Box sx={{ width: '100%', maxWidth: 980, px: 4, pt: 4, pb: 6 }}>
        <Box sx={{ mb: 4 }}>
          <Typography sx={{ fontSize: '1.7rem', fontWeight: 700, letterSpacing: '-0.4px', color: 'text.primary' }}>
            {loading ? t('common.loading', 'Loading…') : `${t('dashboard.welcome', 'Welcome back')}${username ? `, ${username}` : ''}`}
          </Typography>
          <Typography color="text.secondary" fontSize={12} sx={{ mt: 0.3 }}>
            {lastLogin ? `${t('dashboard.lastSession', 'Last session')}: ${formatTimestamp(lastLogin, settings)}` : loading ? '' : t('dashboard.firstSession', 'First session — welcome!')}
          </Typography>
        </Box>

        {fetchError && (
          <Box sx={{ mb: 3, p: 1.5, borderRadius: '10px', border: '1px solid', borderColor: '#f59e0b40', bgcolor: '#f59e0b08', display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <WarningIcon sx={{ fontSize: 16, color: '#f59e0b', flexShrink: 0 }} />
            <Typography fontSize={12} color="text.secondary" sx={{ flex: 1 }}>{t('dashboard.fetchError', 'Could not load your data.')} {retrying ? t('dashboard.retrying', 'Retrying automatically…') : t('dashboard.checkConnection', 'Check your connection.')}</Typography>
            {retrying ? <CircularProgress size={14} sx={{ color: '#f59e0b' }} /> : <Button size="small" variant="outlined" onClick={startRetrying} sx={{ fontSize: 10, py: 0.3, borderColor: '#f59e0b', color: '#f59e0b', textTransform: 'none' }}>{t('dashboard.retry', 'Retry')}</Button>}
          </Box>
        )}

        <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
          {[
            { label: t('dashboard.kpi.totalBoards', 'Total Boards'), value: stats.boards, color: '#3b82f6', icon: <StorageIcon sx={{ fontSize: 18 }} />, sub: t('dashboard.kpi.totalBoards.sub', 'boards created') },
            { label: t('dashboard.kpi.totalSources', 'Total Sources'), value: stats.sources, color: '#10b981', icon: <ArticleIcon sx={{ fontSize: 18 }} />, sub: t('dashboard.kpi.totalSources.sub', 'across all boards') },
            { label: t('dashboard.kpi.published', 'Published'), value: stats.publicBoards, color: '#8b5cf6', icon: <PublicIcon sx={{ fontSize: 18 }} />, sub: t('dashboard.kpi.published.sub', 'boards public') },
          ].map(s => (
            <Box key={s.label} sx={{ flex: '1 1 180px', p: 2.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{ width: 34, height: 34, borderRadius: '9px', bgcolor: `${s.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: s.color }}>{s.icon}</Box>
                <Typography fontSize={10} fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}>{s.label}</Typography>
              </Box>
              <Typography fontSize={28} fontWeight={700} sx={{ color: 'text.primary', lineHeight: 1, mb: 0.4, display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                {loading
                  ? <CircularProgress size={18} sx={{ color: s.color }} />
                  : (
                    <>
                      <Box component="span">{s.value}</Box>
                      {fetchError && <WarningIcon sx={{ fontSize: 18, color: '#f59e0b', opacity: 0.85 }} />}
                    </>
                  )}
              </Typography>
              <Typography fontSize={10} color="text.disabled">{s.sub}</Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ mb: 4, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Box sx={{ flex: '1 1 300px', p: 2.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
            <Typography fontSize={13} fontWeight={700} sx={{ mb: 2 }}>{t('dashboard.boardTypes', 'Board Types')}</Typography>
            {(() => {
              const chains = boards.filter(b => b.app_mode !== 'tree').length;
              const trees = boards.filter(b => b.app_mode === 'tree').length;
              const total = Math.max(chains + trees, 1);
              return [
                { label: t('dashboard.types.chains', 'Chains'), count: chains, color: '#3b82f6', pct: Math.round((chains / total) * 100) },
                { label: t('dashboard.types.trees', 'Trees'), count: trees, color: '#10b981', pct: Math.round((trees / total) * 100) },
                { label: t('dashboard.types.public', 'Public'), count: stats.publicBoards, color: '#8b5cf6', pct: Math.round((stats.publicBoards / total) * 100) },
              ].map(row => (
                <Box key={row.label} sx={{ mb: 1.8 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.4 }}>
                    <Typography fontSize={11} fontWeight={600}>{row.label}</Typography>
                    <Typography fontSize={11} fontWeight={700} sx={{ color: row.color }}>{loading ? '—' : row.count}</Typography>
                  </Box>
                  <Box sx={{ height: 6, borderRadius: 3, bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                    <Box sx={{ height: '100%', width: `${loading ? 0 : row.pct}%`, bgcolor: row.color, borderRadius: 3, transition: 'width 0.6s ease' }} />
                  </Box>
                </Box>
              ));
            })()}
          </Box>
          {siteStats && (
            <Box sx={{ flex: '1 1 300px', p: 2.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
              <Typography fontSize={13} fontWeight={700} sx={{ mb: 2 }}>{t('dashboard.platform', 'Platform')}</Typography>
              {[
                { label: t('dashboard.platform.users', 'Registered users'), value: siteStats.users },
                { label: t('dashboard.platform.boards', 'Total boards'), value: siteStats.boards },
                { label: t('dashboard.platform.sources', 'Total sources'), value: siteStats.sources },
                { label: t('dashboard.platform.public', 'Public boards'), value: siteStats.publicBoards },
              ].map(row => (
                <Box key={row.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.65, borderBottom: '1px solid', borderColor: 'divider', '&:last-of-type': { borderBottom: 'none' } }}>
                  <Typography fontSize={11} color="text.secondary">{row.label}</Typography>
                  <Typography fontSize={12} fontWeight={700}>{row.value}</Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>

        {!loading && !fetchError && recentBoards.length > 0 && (
          <Box sx={{ mb: 4, p: 2.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography fontSize={13} fontWeight={700}>{t('dashboard.recentBoards', 'Recent Boards')}</Typography>
              <Button size="small" onClick={onOpenMySources} sx={{ fontSize: 10, textTransform: 'none', color: 'text.secondary' }}>{t('dashboard.viewAll', 'View all →')}</Button>
            </Box>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {['Board ID', 'Title', 'Type', 'Sources', 'Status', 'Last modified'].map(h => (
                    <TableCell key={h} sx={{ fontWeight: 700, fontSize: 10, py: 0.8, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5, whiteSpace: 'nowrap' }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {recentBoards.map(b => (
                  <TableRow key={b.board_id} hover onClick={() => onLoadBoard(b.board_id)} sx={{ cursor: 'pointer', '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.025)' : 'rgba(59,130,246,0.03)' } }}>
                    <TableCell sx={{ py: 1.2, minWidth: 130 }}><Typography fontSize={12} sx={{ fontFamily: 'monospace', letterSpacing: 0.4, color: '#3b82f6' }}>{dispId(b.board_id || '')}</Typography></TableCell>
                    <TableCell sx={{ py: 1.2 }}>
                      <Typography fontSize={12} sx={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: b.title || b.name || b.main_source_name ? 'text.primary' : 'text.disabled' }}>
                        {b.title || b.name || b.main_source_name || 'Untitled'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 1.2 }}>
                      <Chip label={b.app_mode === 'tree' ? 'Tree' : 'Chain'} size="small" sx={{ fontSize: 9, height: 20, bgcolor: b.app_mode === 'tree' ? '#10b98115' : '#3b82f615', color: b.app_mode === 'tree' ? '#10b981' : '#3b82f6', fontWeight: 700 }} />
                    </TableCell>
                    <TableCell sx={{ py: 1.2 }}><Typography fontSize={12} fontWeight={600}>{b.source_count || 0}</Typography></TableCell>
                    <TableCell sx={{ py: 1.2 }}>
                      {b.is_public ? <Chip label="Public" size="small" sx={{ fontSize: 9, height: 18, bgcolor: '#10b98112', color: '#10b981', fontWeight: 600 }} /> : <Typography fontSize={9} color="text.disabled">Private</Typography>}
                    </TableCell>
                    <TableCell sx={{ py: 1.2 }}><Typography fontSize={10} color="text.secondary">{b.updated_at ? formatTimestamp(b.updated_at, settings) : '—'}</Typography></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}

        {(loading || fetchError || recentBoards.length === 0) && (
          <Button variant="outlined" fullWidth startIcon={<StorageIcon sx={{ fontSize: 14 }} />} onClick={onOpenMySources} sx={{ py: 1.2, borderRadius: '10px', fontWeight: 600, textTransform: 'none', fontSize: 12, borderColor: 'divider', color: 'text.secondary' }}>View All My Sources</Button>
        )}
      </Box>
    </Box>
  );
};

// ▓▓▓▓▓ MY SOURCES PAGE ▓▓▓▓▓
const MySourcesPage: React.FC<{
  isDark: boolean;
  onLoadBoard: (bid: string) => void;
  apiHeaders: () => Record<string, string>;
  onDeleteBoard: (bid: string) => void;
  onBack: () => void;
  appSettings?: AppSettings;
}> = ({ isDark, onLoadBoard, apiHeaders, onDeleteBoard, onBack, appSettings: userSettings }) => {
  const settings: AppSettings = { ...DEFAULT_SETTINGS, ...(userSettings || {}) };
  const [boards, setBoards] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortCol, setSortCol] = useState<string>('created_at');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const [filterMode, setFilterMode] = useState<'all' | 'chain' | 'tree'>('all');
  const [filterVisibility, setFilterVisibility] = useState<'all' | 'public' | 'private'>('all');
  const [deleteConfirm, setDeleteConfirm] = useState<string | null>(null);
  const [wideView, setWideView] = useState(false);
  const [mainTab, setMainTab] = useState(0);
  const [allSources, setAllSources] = useState<any[]>([]);
  const [srcSearch, setSrcSearch] = useState('');
  const [srcSort, setSrcSort] = useState<{col: string; dir: 'asc'|'desc'}>({ col: 'updatedAt', dir: 'desc' });
  const [srcTypeFilter, setSrcTypeFilter] = useState<string>('all');
  const [retrying, setRetrying] = useState(false);
  const retryIntervalRef = React.useRef<ReturnType<typeof setInterval> | null>(null);

  const sourcesOnly = allSources;
  const availableTypes = useMemo(() => {
    const types = new Set<string>();
    sourcesOnly.forEach(s => { if (s.sourceType) types.add(s.sourceType); });
    return Array.from(types).sort();
  }, [sourcesOnly]);
  const searchSuggestions = useMemo(() => {
    const titles = new Set<string>();
    sourcesOnly.forEach(s => { if (s.title) titles.add(s.title); });
    return Array.from(titles).slice(0, 50);
  }, [sourcesOnly]);

  const fetchBoards = useCallback(() => {
    setLoading(true);
    setFetchError(false);
    const hdrs = apiHeaders();
    if (!hdrs['Authorization']) { setLoading(false); return; }
    const timeout = new Promise<never>((_, reject) => setTimeout(() => reject(new Error('timeout')), 5000));
    Promise.race([
      Promise.all([
        fetch(`${API_BASE}/boards`, { headers: hdrs }).then(okJson),
        fetch(`${API_BASE}/my-sources`, { headers: hdrs }).then(okJson),
      ]),
      timeout,
    ]).then(([boardsData, srcData]) => {
      setBoards((boardsData && boardsData.boards) || []);
      setAllSources((srcData && srcData.sources) || []);
      setLoading(false);
      setFetchError(false);
      setRetrying(false);
      if (retryIntervalRef.current) { clearInterval(retryIntervalRef.current); retryIntervalRef.current = null; }
    }).catch(() => {
      setLoading(false); setFetchError(true);
      if (!retryIntervalRef.current) {
        setRetrying(true);
        retryIntervalRef.current = setInterval(() => { fetchBoards(); }, 4000);
      }
    });
  }, [apiHeaders]);

  const startRetrying = useCallback(() => {
    if (retryIntervalRef.current) return;
    setRetrying(true);
    fetchBoards();
    retryIntervalRef.current = setInterval(() => { fetchBoards(); }, 4000);
  }, [fetchBoards]);

  useEffect(() => { fetchBoards(); }, [fetchBoards]);
  useEffect(() => () => { if (retryIntervalRef.current) clearInterval(retryIntervalRef.current); }, []);

  const handleSort = (col: string) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir(col === 'updated_at' || col === 'created_at' ? 'desc' : 'asc'); }
  };

  const filtered = boards
    .filter(b => {
      if (searchTerm) {
        const q = searchTerm.toLowerCase();
        if (!b.board_id?.toLowerCase().includes(q) && !b.name?.toLowerCase().includes(q) && !(b.title || '').toLowerCase().includes(q)) return false;
      }
      if (filterMode === 'chain' && b.app_mode === 'tree') return false;
      if (filterMode === 'tree' && b.app_mode !== 'tree') return false;
      if (filterVisibility === 'public' && !b.is_public) return false;
      if (filterVisibility === 'private' && b.is_public) return false;
      return true;
    })
    .sort((a, b) => {
      let va = a[sortCol], vb = b[sortCol];
      if (sortCol === 'source_count') { va = va || 0; vb = vb || 0; return sortDir === 'asc' ? va - vb : vb - va; }
      if (sortCol === 'is_public') { va = va ? 1 : 0; vb = vb ? 1 : 0; return sortDir === 'asc' ? va - vb : vb - va; }
      va = (va || '').toString().toLowerCase(); vb = (vb || '').toString().toLowerCase();
      return sortDir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const SortHeader: React.FC<{ col: string; label: string; width?: number | string; align?: string }> = ({ col, label, width, align }) => (
    <TableCell onClick={() => handleSort(col)} sx={{ cursor: 'pointer', fontWeight: 500, fontSize: 10, py: 1, userSelect: 'none', width, whiteSpace: 'nowrap', color: sortCol === col ? 'text.primary' : 'text.secondary', '&:hover': { color: 'primary.main' }, textAlign: (align || 'left') as any, letterSpacing: 0.3, textTransform: 'uppercase' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, justifyContent: align === 'center' ? 'center' : 'flex-start' }}>
        {label}
        {sortCol === col ? (sortDir === 'asc' ? <ArrowDropUpIcon sx={{ fontSize: 14 }} /> : <ArrowDropDownIcon sx={{ fontSize: 14 }} />) : <Box sx={{ width: 14 }} />}
      </Box>
    </TableCell>
  );

  const stats = { total: boards.length, chains: boards.filter(b => b.app_mode !== 'tree').length, trees: boards.filter(b => b.app_mode === 'tree').length, pub: boards.filter(b => b.is_public).length };

  const fmtDate = (d: string) => { if (!d) return '—'; return formatTimestamp(d, settings); };

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small" sx={{ mr: 0.5 }}><ArrowBackIcon sx={{ fontSize: 18 }} /></IconButton>
        <Typography fontWeight={600} fontSize={16}>My Sources</Typography>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Chip label={`${stats.total} boards`} size="small" sx={{ fontSize: 10, height: 24 }} />
          <Chip label={`${stats.chains} chains`} size="small" sx={{ fontSize: 10, height: 24, bgcolor: '#3b82f610', color: '#3b82f6' }} />
          <Chip label={`${stats.trees} trees`} size="small" sx={{ fontSize: 10, height: 24, bgcolor: '#10b98110', color: '#10b981' }} />
          <Chip label={`${stats.pub} public`} size="small" sx={{ fontSize: 10, height: 24, bgcolor: '#f59e0b10', color: '#f59e0b' }} />
          <Tooltip title={wideView ? 'Centered view' : 'Wide view'}><IconButton size="small" onClick={() => setWideView(v => !v)} sx={{ ml: 1 }}><AspectRatioIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
        </Box>
      </Box>

      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', px: 3, flexShrink: 0 }}>
        <Tabs value={mainTab} onChange={(_, v) => setMainTab(v)} sx={{ minHeight: 36, '& .MuiTab-root': { minHeight: 36, fontSize: 11, textTransform: 'none', fontWeight: 600, py: 0 } }}>
          <Tab label={`Boards (${boards.length})`} />
          <Tab label={`All Sources (${sourcesOnly.length})`} />
        </Tabs>
      </Box>

      {mainTab === 0 ? (<>
      <Box sx={{ px: 3, py: 1.5, display: 'flex', alignItems: 'center', gap: 2.5, flexShrink: 0, borderBottom: '1px solid', borderColor: 'divider' }}>
        <TextField size="small" placeholder="Search ID, name, title..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} InputProps={{ sx: { fontSize: 12, height: 32, borderRadius: '8px' } }} sx={{ width: 220 }} />
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography fontSize={10} color="text.disabled" fontWeight={600} sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>Type:</Typography>
          <Box sx={{ display: 'flex', gap: 0.5, p: 0.4, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
            {(['all', 'chain', 'tree'] as const).map(m => (
              <Button key={m} size="small" onClick={() => setFilterMode(m)} variant={filterMode === m ? 'contained' : 'text'}
                sx={{ fontSize: 10, minWidth: 52, height: 24, px: 1.2, borderRadius: '6px', textTransform: 'none', fontWeight: filterMode === m ? 700 : 500, 
                  bgcolor: filterMode === m ? (m === 'tree' ? '#10b981' : m === 'chain' ? '#3b82f6' : 'primary.main') : 'transparent',
                  color: filterMode === m ? '#E3E3DF' : 'text.secondary',
                  '&:hover': { bgcolor: filterMode === m ? (m === 'tree' ? '#059669' : m === 'chain' ? '#2563eb' : 'primary.dark') : 'action.hover' } }}>
                {m === 'all' ? 'All' : m === 'chain' ? 'Chains' : 'Trees'}
              </Button>
            ))}
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography fontSize={10} color="text.disabled" fontWeight={600} sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>Status:</Typography>
          <Box sx={{ display: 'flex', gap: 0.5, p: 0.4, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
            {(['all', 'public', 'private'] as const).map(v => (
              <Button key={v} size="small" onClick={() => setFilterVisibility(v)} variant={filterVisibility === v ? 'contained' : 'text'}
                sx={{ fontSize: 10, minWidth: 52, height: 24, px: 1.2, borderRadius: '6px', textTransform: 'none', fontWeight: filterVisibility === v ? 700 : 500,
                  bgcolor: filterVisibility === v ? (v === 'public' ? '#10b981' : v === 'private' ? '#64748b' : 'primary.main') : 'transparent',
                  color: filterVisibility === v ? '#E3E3DF' : 'text.secondary',
                  '&:hover': { bgcolor: filterVisibility === v ? (v === 'public' ? '#059669' : v === 'private' ? '#475569' : 'primary.dark') : 'action.hover' } }}>
                {v === 'all' ? 'All' : v === 'public' ? 'Public' : 'Private'}
              </Button>
            ))}
          </Box>
        </Box>

        <Box sx={{ flex: 1 }} />
        <Typography fontSize={11} color="text.secondary">{filtered.length} of {boards.length} boards</Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: wideView ? 'none' : 960, px: wideView ? 0 : 2 }}>
          {loading ? (
            <Box sx={{ p: 6, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <CircularProgress size={28} />
              <Typography color="text.secondary" fontSize={13}>Loading boards...</Typography>
            </Box>
          ) : fetchError ? (
            <Box sx={{ p: 6, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <WarningIcon sx={{ fontSize: 28, color: '#f59e0b' }} />
              </Box>
              <Typography fontWeight={600} fontSize={14}>Connection lost</Typography>
              <Typography color="text.secondary" fontSize={12} sx={{ maxWidth: 300 }}>Could not reach the server. {retrying ? 'Retrying automatically…' : 'Check your internet connection and try again.'}</Typography>
              {retrying ? <CircularProgress size={22} sx={{ color: '#f59e0b' }} /> : <Button variant="contained" size="small" onClick={startRetrying} startIcon={<RestartAltIcon sx={{ fontSize: 14 }} />} sx={{ textTransform: 'none', fontSize: 12, bgcolor: '#f59e0b', '&:hover': { bgcolor: '#d97706' } }}>Retry Connection</Button>}
            </Box>
          ) : filtered.length === 0 ? (
            <Box sx={{ p: 6, textAlign: 'center' }}><Typography color="text.secondary">{boards.length === 0 ? 'No boards yet. Create your first source!' : 'No boards match filters.'}</Typography></Box>
          ) : (
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <SortHeader col="board_id" label="Board ID" width={130} />
                  <SortHeader col="title" label="Title" />
                  <SortHeader col="main_source_type" label="Type" width={100} />
                  <SortHeader col="app_mode" label="Mode" width={65} />
                  <SortHeader col="source_count" label="Src" width={50} align="center" />
                  <SortHeader col="is_public" label="Status" width={75} />
                  <SortHeader col="created_at" label="Created" width={110} />
                  <SortHeader col="updated_at" label="Modified" width={110} />
                  <TableCell sx={{ width: 60, py: 1, fontSize: 10, fontWeight: 500, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }} />
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.map(b => {
                  const st = ALL_SOURCE_TYPES.find(t => t.type === b.main_source_type);
                  return (
                    <TableRow key={b.board_id} hover onClick={() => onLoadBoard(b.board_id)} sx={{ cursor: 'pointer', '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.025)' : 'rgba(59,130,246,0.03)' }, '& td': { borderColor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)' } }}>
                      <TableCell sx={{ py: 1 }}>
                        <Typography sx={{ fontSize: 11.5, fontFamily: 'monospace', fontWeight: 500, letterSpacing: 0.3, color: 'text.secondary', whiteSpace: 'nowrap' }}>{dispId(b.board_id || '')}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Typography sx={{ fontSize: 12, fontWeight: 500, maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.title || b.name || <span style={{ color: 'inherit', opacity: 0.35 }}>Untitled</span>}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        {st ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: getSourceColor(b.main_source_type), flexShrink: 0 }} />
                            <Typography fontSize={11} color="text.secondary">{st.label}</Typography>
                          </Box>
                        ) : <Typography fontSize={11} color="text.disabled">—</Typography>}
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Typography fontSize={10} color={b.app_mode === 'tree' ? '#10b981' : '#3b82f6'} sx={{ fontWeight: 500 }}>{b.app_mode === 'tree' ? 'Tree' : 'Chain'}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1, textAlign: 'center' }}>
                        <Typography fontSize={11} color="text.secondary">{b.source_count || 0}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: b.is_public ? '#10b981' : 'text.disabled', flexShrink: 0 }} />
                          <Typography fontSize={10} color={b.is_public ? '#10b981' : 'text.disabled'}>{b.is_public ? 'Public' : 'Private'}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Typography fontSize={10} color="text.disabled" sx={{ whiteSpace: 'nowrap' }}>{fmtDate(b.created_at)}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Typography fontSize={10} color="text.disabled" sx={{ whiteSpace: 'nowrap' }}>{fmtDate(b.updated_at)}</Typography>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <Box sx={{ display: 'flex', gap: 0.3, justifyContent: 'flex-end' }}>
                          <Tooltip title="Open"><IconButton size="small" onClick={(e) => { e.stopPropagation(); onLoadBoard(b.board_id); }} sx={{ opacity: 0.4, '&:hover': { opacity: 1, color: 'primary.main' } }}><OpenInNewIcon sx={{ fontSize: 13 }} /></IconButton></Tooltip>
                          <Tooltip title="Delete"><IconButton size="small" onClick={(e) => { e.stopPropagation(); setDeleteConfirm(b.board_id); }} sx={{ opacity: 0.2, '&:hover': { opacity: 1, color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 13 }} /></IconButton></Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </Box>
      </Box>
      </>) : (
      <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ px: 3, py: 1.5, display: 'flex', alignItems: 'center', gap: 2.5, borderBottom: '1px solid', borderColor: 'divider', flexShrink: 0 }}>
          <Autocomplete
            freeSolo
            size="small"
            options={searchSuggestions}
            inputValue={srcSearch}
            onInputChange={(_, val) => setSrcSearch(val)}
            sx={{ width: 280 }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Search source ID, title..." InputProps={{ ...params.InputProps, sx: { fontSize: 12, height: 32, borderRadius: '8px' } }} />
            )}
          />
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography fontSize={10} color="text.disabled" fontWeight={600} sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>Type:</Typography>
            <TextField
              select
              size="small"
              value={srcTypeFilter}
              onChange={e => setSrcTypeFilter(e.target.value)}
              SelectProps={{ native: true }}
              sx={{ minWidth: 140, '& .MuiInputBase-root': { fontSize: 11, height: 32, borderRadius: '8px' } }}
            >
              <option value="all">All Types</option>
              {availableTypes.map(t => {
                const st = ALL_SOURCE_TYPES.find(x => x.type === t);
                return <option key={t} value={t}>{st?.label || t}</option>;
              })}
            </TextField>
          </Box>

          <Box sx={{ flex: 1 }} />
          <Typography fontSize={11} color="text.secondary">
            {(() => {
              const q = srcSearch.toLowerCase();
              return sourcesOnly.filter(s => {
                if (srcTypeFilter !== 'all' && s.sourceType !== srcTypeFilter) return false;
                return !q || s.sourceId?.toLowerCase().includes(q) || (s.title || '').toLowerCase().includes(q) || (s.sourceType || '').toLowerCase().includes(q) || s.boardId?.toLowerCase().includes(q);
              }).length;
            })()} of {sourcesOnly.length} sources
          </Typography>
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: wideView ? 'none' : 960, px: wideView ? 0 : 2 }}>
          {loading ? (
            <Box sx={{ p: 6, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <CircularProgress size={28} />
              <Typography color="text.secondary" fontSize={13}>Loading sources...</Typography>
            </Box>
          ) : sourcesOnly.length === 0 ? (
            <Box sx={{ p: 6, textAlign: 'center' }}><Typography color="text.secondary">No sources yet.</Typography></Box>
          ) : (
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {[{c:'sourceId',l:'Source ID',w:155},{c:'title',l:'Title'},{c:'sourceType',l:'Type',w:100},{c:'boardId',l:'Board',w:160},{c:'appMode',l:'Mode',w:65},{c:'isMain',l:'Role',w:70},{c:'updatedAt',l:'Modified',w:120}].map(h => (
                    <TableCell key={h.c} onClick={() => setSrcSort(p => ({ col: h.c, dir: p.col === h.c && p.dir === 'asc' ? 'desc' : 'asc' }))} sx={{ cursor: 'pointer', fontWeight: 700, fontSize: 11, py: 1, width: h.w, whiteSpace: 'nowrap', userSelect: 'none', '&:hover': { color: 'primary.main' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                        {h.l}
                        {srcSort.col === h.c ? (srcSort.dir === 'asc' ? <ArrowDropUpIcon sx={{ fontSize: 16 }} /> : <ArrowDropDownIcon sx={{ fontSize: 16 }} />) : <Box sx={{ width: 16 }} />}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sourcesOnly
                  .filter(s => {
                    if (srcTypeFilter !== 'all' && s.sourceType !== srcTypeFilter) return false;
                    const q = srcSearch.toLowerCase();
                    return !q || s.sourceId?.toLowerCase().includes(q) || (s.title || '').toLowerCase().includes(q) || (s.sourceType || '').toLowerCase().includes(q) || s.boardId?.toLowerCase().includes(q);
                  })
                  .sort((a, b) => {
                    let va = a[srcSort.col], vb = b[srcSort.col];
                    if (typeof va === 'boolean') { va = va ? 1 : 0; vb = vb ? 1 : 0; return srcSort.dir === 'asc' ? (va as number) - (vb as number) : (vb as number) - (va as number); }
                    va = (va || '').toString().toLowerCase(); vb = (vb || '').toString().toLowerCase();
                    return srcSort.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
                  })
                  .map(s => {
                    const st = ALL_SOURCE_TYPES.find(t => t.type === s.sourceType);
                    return (
                      <TableRow key={`${s.boardId}-${s.sourceId}`} hover onClick={() => onLoadBoard(s.boardId)} sx={{ cursor: 'pointer', '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)' } }}>
                        <TableCell sx={{ py: 1.2 }}><Typography fontSize={12} sx={{ fontFamily: '"Inter",system-ui,sans-serif', letterSpacing: 0.5 }}>{dispId(s.sourceId || '')}</Typography></TableCell>
                        <TableCell sx={{ py: 1.2 }}><Typography fontSize={12} sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.title || '—'}</Typography></TableCell>
                        <TableCell sx={{ py: 1.2 }}>
                          {st ? <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, '& .MuiSvgIcon-root': { fontSize: '12px !important' } }}><Box sx={{ display: 'flex', color: getSourceColor(s.sourceType) }}>{st.icon}</Box><Typography fontSize={10} color="text.secondary">{st.label}</Typography></Box> : <Typography fontSize={10} color="text.disabled">—</Typography>}
                        </TableCell>
                        <TableCell sx={{ py: 1.2 }}><Typography fontSize={11} sx={{ fontFamily: '"Inter",system-ui,sans-serif' }}>{dispId(s.boardId || '')}</Typography></TableCell>
                        <TableCell sx={{ py: 1.2 }}>
                          <Chip label={s.appMode === 'tree' ? 'Tree' : 'Chain'} size="small" sx={{ fontSize: 9, height: 20, bgcolor: s.appMode === 'tree' ? '#10b98112' : '#3b82f612', color: s.appMode === 'tree' ? '#10b981' : '#3b82f6' }} />
                        </TableCell>
                        <TableCell sx={{ py: 1.2 }}>
                          <Chip label={s.isMain ? 'Main' : s.refPointId ? 'Branch' : `#${s.order}`} size="small" sx={{ fontSize: 9, height: 20, bgcolor: s.isMain ? '#f59e0b15' : 'transparent', color: s.isMain ? '#f59e0b' : 'text.secondary', fontWeight: s.isMain ? 700 : 400 }} variant={s.isMain ? 'filled' : 'outlined'} />
                        </TableCell>
                        <TableCell sx={{ py: 1.2 }}><Typography fontSize={10} color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>{fmtDate(s.updatedAt)}</Typography></TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          )}
        </Box>
        </Box>
      </Box>
      )}

      <Dialog open={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} disableScrollLock PaperProps={{ sx: { borderRadius: '12px', p: 1 } }}>
        <Box sx={{ p: 2.5, textAlign: 'center' }}>
          <Typography fontWeight={600} sx={{ mb: 1 }}>Delete {deleteConfirm ? dispId(deleteConfirm) : ''}?</Typography>
          <Typography fontSize={12} color="text.secondary" sx={{ mb: 2 }}>This permanently deletes the board and all its sources.</Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button variant="outlined" onClick={() => setDeleteConfirm(null)} size="small">Cancel</Button>
            <Button variant="contained" color="error" onClick={() => { if (deleteConfirm) { onDeleteBoard(deleteConfirm); setBoards(p => p.filter(b => b.board_id !== deleteConfirm)); } setDeleteConfirm(null); }} size="small">Delete</Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

// ▓▓▓▓▓ MODE & CREATE-SOURCE PAGES ▓▓▓▓▓
const FRONTPAGE_STRINGS: Partial<Record<LangCode, Record<string, string>>> = {
  sv: {
    'frontpage.signin': 'Logga in',
    'frontpage.cta.create': 'Skapa ett gratis konto',
    'frontpage.demo': 'Prova demoläget',
    'ai.button': 'Skapa med AI',
    'ai.buttonHint': 'Generera en källkedja från en AI-prompt – ingen inloggning krävs',
    'frontpage.hero.headline': 'Spåra varje påstående tillbaka till bevisen',
    'frontpage.hero.lede': 'Source.io kopplar varje citat till exakt den upplaga, revision eller arkiverade sida som citeras, kedjar dem tillbaka till originalkällan och visar läsaren hur mycket varje länk går att lita på.',
    'frontpage.hero.footnote': 'Varje källa är fäst vid den version som citeras – en arkiverad ögonblicksbild, en DOI, en sida i en specifik upplaga – och förblir kontrollerbar.',
    'frontpage.how.heading': 'Så fungerar det',
    'frontpage.how.step1.title': 'Lägg till källor och fäst bevisen',
    'frontpage.how.step1.desc': 'Böcker, uppsatser, artiklar, uttalanden, händelser – 32 typade källformulär. Bifoga filer, arkivera webbsidor innan de ändras och ange exakt vilken upplaga eller revision som citeras.',
    'frontpage.how.step2.title': 'Kedja citaten',
    'frontpage.how.step2.desc': 'Länka varje källa till den som den citerar, med sidintervall och anteckningar. Påståendet spåras bakåt i tiden till sina grunder – synligt, på en tavla.',
    'frontpage.how.step3.title': 'Bedöm tillförlitlighet och dela',
    'frontpage.how.step3.desc': 'Betygsätt trovärdighet, verifierbarhet och aktualitet per källa. Publicera tavlan – läsare ser poängen, röstar och bedömer bevisen själva.',
    'frontpage.footer.nonprofit': 'Drivs av en svensk ideell förening. Gratis för människor, inga annonser.',
    'frontpage.machine.line': 'Publika tavlor är maskinläsbara: JSON-export, ett samlat dataset och en MCP-server så att AI-assistenter kan citera fästa bevis direkt.',
    'frontpage.featureList.button': 'Se alla funktioner',
    'frontpage.featureList.title': 'Fullständig funktionslista',
    'frontpage.featureList.subtitle': 'Allt Source.io erbjuder, rangordnat efter betydelse',
    'frontpage.featureList.topBadge': 'Toppfunktion',
    'frontpage.modePicker.heading': 'Välj hur du vill organisera dina källor',
    'frontpage.backToDashboard': 'Tillbaka till översikten',
    'mode.chain.title': 'Källkedja',
    'mode.chain.sub': 'Linjär referensspårning',
    'mode.chain.desc': 'Börja med en enda källa och bygg en kedja. Varje källa länkar till nästa med en referenspekare – perfekt för att följa citeringsspår.',
    'mode.tree.title': 'Källträd',
    'mode.tree.sub': 'Hierarkisk organisation',
    'mode.tree.desc': 'Börja med ett utgångsämne och förgrena till referenspunkter. Varje gren rymmer flera relaterade källor – idealiskt för forskningsämnen.',
    'frontpage.chain.cites': 'citerar',
    'frontpage.chain.c1.title': 'Nyhetsartikel',
    'frontpage.chain.c1.kind': 'Webbplats',
    'frontpage.chain.c1.pin': 'Arkiverad 2026-07-04',
    'frontpage.chain.c2.title': 'Vetenskaplig artikel',
    'frontpage.chain.c2.kind': 'Vetenskaplig',
    'frontpage.chain.c2.pin': 'DOI verifierad, ej indragen',
    'frontpage.chain.c3.title': 'Ursprunglig monografi',
    'frontpage.chain.c3.kind': 'Bok',
    'frontpage.chain.c3.pin': '1:a upplagan, s. 214',
  },
  es: {
    'frontpage.signin': 'Iniciar sesión',
    'frontpage.cta.create': 'Crear una cuenta gratuita',
    'frontpage.demo': 'Probar el modo demo',
    'ai.button': 'Crear con IA',
    'ai.buttonHint': 'Genera una cadena de fuentes a partir de una instrucción de IA — sin iniciar sesión',
    'frontpage.hero.headline': 'Rastrea cualquier afirmación hasta su evidencia',
    'frontpage.hero.lede': 'Source.io vincula cada cita a la edición, revisión o página archivada exacta que se cita, las encadena hasta el registro original y muestra a los lectores cuánto pueden confiar en cada eslabón.',
    'frontpage.hero.footnote': 'Cada fuente queda fijada a la versión citada —una captura archivada, un DOI, una página de una edición concreta— y sigue siendo verificable.',
    'frontpage.how.heading': 'Cómo funciona',
    'frontpage.how.step1.title': 'Añade fuentes y fija la evidencia',
    'frontpage.how.step1.desc': 'Libros, artículos científicos, noticias, declaraciones, eventos — 32 formularios de fuente tipados. Adjunta archivos, archiva páginas web antes de que cambien y registra la edición o revisión exacta citada.',
    'frontpage.how.step2.title': 'Encadena las citas',
    'frontpage.how.step2.desc': 'Vincula cada fuente con la que cita, con rangos de páginas y notas. La afirmación se rastrea hacia atrás en el tiempo hasta sus fundamentos — de forma visible, en un tablero.',
    'frontpage.how.step3.title': 'Puntúa la confianza y comparte',
    'frontpage.how.step3.desc': 'Valora la credibilidad, verificabilidad y actualidad de cada fuente. Publica el tablero — los lectores ven las puntuaciones, votan y juzgan la evidencia por sí mismos.',
    'frontpage.footer.nonprofit': 'Gestionado por una asociación sueca sin ánimo de lucro. Gratis para humanos, sin anuncios.',
    'frontpage.machine.line': 'Los tableros públicos son legibles por máquinas: exportación JSON, un conjunto de datos completo y un servidor MCP para que los asistentes de IA citen evidencia fijada directamente.',
    'frontpage.featureList.button': 'Ver todas las funciones',
    'frontpage.featureList.title': 'Lista completa de funciones',
    'frontpage.featureList.subtitle': 'Todo lo que ofrece Source.io, ordenado por impacto',
    'frontpage.featureList.topBadge': 'Función destacada',
    'frontpage.modePicker.heading': 'Elige cómo organizar tus fuentes',
    'frontpage.backToDashboard': 'Volver al panel',
    'mode.chain.title': 'Cadena de fuentes',
    'mode.chain.sub': 'Seguimiento lineal de referencias',
    'mode.chain.desc': 'Empieza con una sola fuente y construye una cadena. Cada fuente enlaza con la siguiente mediante un puntero de referencia — ideal para seguir rastros de citas.',
    'mode.tree.title': 'Árbol de fuentes',
    'mode.tree.sub': 'Organización jerárquica',
    'mode.tree.desc': 'Empieza con un tema semilla y ramifica en puntos de referencia. Cada rama contiene varias fuentes relacionadas — ideal para temas de investigación.',
    'frontpage.chain.cites': 'cita',
    'frontpage.chain.c1.title': 'Artículo de prensa',
    'frontpage.chain.c1.kind': 'Sitio web',
    'frontpage.chain.c1.pin': 'Archivado el 2026-07-04',
    'frontpage.chain.c2.title': 'Artículo científico',
    'frontpage.chain.c2.kind': 'Científica',
    'frontpage.chain.c2.pin': 'DOI verificado, sin retractar',
    'frontpage.chain.c3.title': 'Monografía original',
    'frontpage.chain.c3.kind': 'Libro',
    'frontpage.chain.c3.pin': '1.ª edición, p. 214',
  },
  fr: {
    'frontpage.signin': 'Se connecter',
    'frontpage.cta.create': 'Créer un compte gratuit',
    'frontpage.demo': 'Essayer le mode démo',
    'ai.button': 'Créer avec l’IA',
    'ai.buttonHint': 'Générez une chaîne de sources à partir d’une requête IA — sans connexion',
    'frontpage.hero.headline': 'Remontez de toute affirmation jusqu’à ses preuves',
    'frontpage.hero.lede': 'Source.io relie chaque citation à l’édition, la révision ou la page archivée exacte qui est citée, remonte la chaîne jusqu’au document d’origine et indique aux lecteurs le degré de confiance de chaque maillon.',
    'frontpage.hero.footnote': 'Chaque source est épinglée à la version citée — une capture archivée, un DOI, une page d’une édition précise — et reste vérifiable.',
    'frontpage.how.heading': 'Comment ça marche',
    'frontpage.how.step1.title': 'Ajoutez des sources et épinglez les preuves',
    'frontpage.how.step1.desc': 'Livres, articles scientifiques, articles de presse, déclarations, événements — 32 formulaires de source typés. Joignez des fichiers, archivez les pages web avant qu’elles ne changent, notez l’édition ou la révision exacte citée.',
    'frontpage.how.step2.title': 'Enchaînez les citations',
    'frontpage.how.step2.desc': 'Reliez chaque source à celle qu’elle cite, avec plages de pages et notes. L’affirmation remonte dans le temps jusqu’à ses fondements — visiblement, sur un tableau.',
    'frontpage.how.step3.title': 'Évaluez la fiabilité et partagez',
    'frontpage.how.step3.desc': 'Notez la crédibilité, la vérifiabilité et l’actualité de chaque source. Publiez le tableau — les lecteurs voient les scores, votent et jugent les preuves par eux-mêmes.',
    'frontpage.footer.nonprofit': 'Géré par une association suédoise à but non lucratif. Gratuit pour les humains, sans publicité.',
    'frontpage.machine.line': 'Les tableaux publics sont lisibles par machine : export JSON, jeu de données complet et serveur MCP pour que les assistants IA citent directement les preuves épinglées.',
    'frontpage.featureList.button': 'Voir toutes les fonctionnalités',
    'frontpage.featureList.title': 'Liste complète des fonctionnalités',
    'frontpage.featureList.subtitle': 'Tout ce que propose Source.io, classé par impact',
    'frontpage.featureList.topBadge': 'Fonction phare',
    'frontpage.modePicker.heading': 'Choisissez comment organiser vos sources',
    'frontpage.backToDashboard': 'Retour au tableau de bord',
    'mode.chain.title': 'Chaîne de sources',
    'mode.chain.sub': 'Suivi linéaire des références',
    'mode.chain.desc': 'Partez d’une seule source et construisez une chaîne. Chaque source renvoie à la suivante par un pointeur de référence — idéal pour suivre les pistes de citation.',
    'mode.tree.title': 'Arbre de sources',
    'mode.tree.sub': 'Organisation hiérarchique',
    'mode.tree.desc': 'Partez d’un sujet de départ et ramifiez en points de référence. Chaque branche regroupe plusieurs sources liées — idéal pour les sujets de recherche.',
    'frontpage.chain.cites': 'cite',
    'frontpage.chain.c1.title': 'Article de presse',
    'frontpage.chain.c1.kind': 'Site web',
    'frontpage.chain.c1.pin': 'Archivé le 2026-07-04',
    'frontpage.chain.c2.title': 'Article scientifique',
    'frontpage.chain.c2.kind': 'Scientifique',
    'frontpage.chain.c2.pin': 'DOI vérifié, non rétracté',
    'frontpage.chain.c3.title': 'Monographie originale',
    'frontpage.chain.c3.kind': 'Livre',
    'frontpage.chain.c3.pin': '1re édition, p. 214',
  },
  de: {
    'frontpage.signin': 'Anmelden',
    'frontpage.cta.create': 'Kostenloses Konto erstellen',
    'frontpage.demo': 'Demomodus ausprobieren',
    'ai.button': 'Mit KI erstellen',
    'ai.buttonHint': 'Erzeugen Sie eine Quellenkette aus einem KI-Prompt – ohne Anmeldung',
    'frontpage.hero.headline': 'Jede Behauptung bis zu ihren Belegen zurückverfolgen',
    'frontpage.hero.lede': 'Source.io verknüpft jedes Zitat mit genau der Ausgabe, Revision oder archivierten Seite, die zitiert wird, verkettet sie bis zur Originalquelle und zeigt Lesern, wie weit jedes Glied vertrauenswürdig ist.',
    'frontpage.hero.footnote': 'Jede Quelle ist an die zitierte Version gebunden – eine archivierte Momentaufnahme, eine DOI, eine Seite einer bestimmten Ausgabe – und bleibt überprüfbar.',
    'frontpage.how.heading': 'So funktioniert es',
    'frontpage.how.step1.title': 'Quellen hinzufügen und Belege fixieren',
    'frontpage.how.step1.desc': 'Bücher, Fachartikel, Artikel, Aussagen, Ereignisse – 32 typisierte Quellenformulare. Dateien anhängen, Webseiten archivieren, bevor sie sich ändern, die genau zitierte Ausgabe oder Revision festhalten.',
    'frontpage.how.step2.title': 'Zitate verketten',
    'frontpage.how.step2.desc': 'Verknüpfen Sie jede Quelle mit der, die sie zitiert – mit Seitenbereichen und Notizen. Die Behauptung lässt sich durch die Zeit bis zu ihren Grundlagen zurückverfolgen, sichtbar auf einem Board.',
    'frontpage.how.step3.title': 'Vertrauen bewerten und teilen',
    'frontpage.how.step3.desc': 'Bewerten Sie Glaubwürdigkeit, Überprüfbarkeit und Aktualität jeder Quelle. Veröffentlichen Sie das Board – Leser sehen die Bewertungen, stimmen ab und beurteilen die Belege selbst.',
    'frontpage.footer.nonprofit': 'Betrieben von einem schwedischen gemeinnützigen Verein. Kostenlos für Menschen, ohne Werbung.',
    'frontpage.machine.line': 'Öffentliche Boards sind maschinenlesbar: JSON-Export, ein Gesamtdatensatz und ein MCP-Server, damit KI-Assistenten fixierte Belege direkt zitieren können.',
    'frontpage.featureList.button': 'Alle Funktionen anzeigen',
    'frontpage.featureList.title': 'Vollständige Funktionsliste',
    'frontpage.featureList.subtitle': 'Alles, was Source.io bietet, nach Wirkung geordnet',
    'frontpage.featureList.topBadge': 'Top-Funktion',
    'frontpage.modePicker.heading': 'Wählen Sie, wie Sie Ihre Quellen organisieren',
    'frontpage.backToDashboard': 'Zurück zum Dashboard',
    'mode.chain.title': 'Quellenkette',
    'mode.chain.sub': 'Lineare Referenzverfolgung',
    'mode.chain.desc': 'Beginnen Sie mit einer einzelnen Quelle und bauen Sie eine Kette. Jede Quelle verweist mit einem Referenzzeiger auf die nächste – ideal, um Zitierpfaden zu folgen.',
    'mode.tree.title': 'Quellenbaum',
    'mode.tree.sub': 'Hierarchische Organisation',
    'mode.tree.desc': 'Beginnen Sie mit einem Ausgangsthema und verzweigen Sie in Referenzpunkte. Jeder Zweig enthält mehrere zusammengehörige Quellen – ideal für Forschungsthemen.',
    'frontpage.chain.cites': 'zitiert',
    'frontpage.chain.c1.title': 'Nachrichtenartikel',
    'frontpage.chain.c1.kind': 'Website',
    'frontpage.chain.c1.pin': 'Archiviert 2026-07-04',
    'frontpage.chain.c2.title': 'Fachartikel',
    'frontpage.chain.c2.kind': 'Wissenschaftlich',
    'frontpage.chain.c2.pin': 'DOI geprüft, kein Widerruf',
    'frontpage.chain.c3.title': 'Originalmonografie',
    'frontpage.chain.c3.kind': 'Buch',
    'frontpage.chain.c3.pin': '1. Auflage, S. 214',
  },
  pt: {
    'frontpage.signin': 'Iniciar sessão',
    'frontpage.cta.create': 'Criar uma conta gratuita',
    'frontpage.demo': 'Experimentar o modo de demonstração',
    'ai.button': 'Criar com IA',
    'ai.buttonHint': 'Gere uma cadeia de fontes a partir de um prompt de IA — sem iniciar sessão',
    'frontpage.hero.headline': 'Rastreie qualquer afirmação até à evidência que a sustenta',
    'frontpage.hero.lede': 'O Source.io liga cada citação à edição, revisão ou página arquivada exata que é citada, encadeia-as até ao registo original e mostra aos leitores quanto podem confiar em cada elo.',
    'frontpage.hero.footnote': 'Cada fonte fica fixada à versão citada — uma captura arquivada, um DOI, uma página de uma edição específica — e continua verificável.',
    'frontpage.how.heading': 'Como funciona',
    'frontpage.how.step1.title': 'Adicione fontes e fixe as evidências',
    'frontpage.how.step1.desc': 'Livros, artigos científicos, artigos, declarações, eventos — 32 formulários de fonte tipificados. Anexe ficheiros, arquive páginas web antes que mudem e registe a edição ou revisão exata citada.',
    'frontpage.how.step2.title': 'Encadeie as citações',
    'frontpage.how.step2.desc': 'Ligue cada fonte àquela que ela cita, com intervalos de páginas e notas. A afirmação é rastreada no tempo até aos seus fundamentos — de forma visível, num quadro.',
    'frontpage.how.step3.title': 'Avalie a confiança e partilhe',
    'frontpage.how.step3.desc': 'Avalie a credibilidade, a verificabilidade e a atualidade de cada fonte. Publique o quadro — os leitores veem as pontuações, votam e julgam as evidências por si próprios.',
    'frontpage.footer.nonprofit': 'Gerido por uma associação sueca sem fins lucrativos. Gratuito para humanos, sem anúncios.',
    'frontpage.machine.line': 'Os quadros públicos são legíveis por máquina: exportação JSON, um conjunto de dados completo e um servidor MCP para que os assistentes de IA citem diretamente as evidências fixadas.',
    'frontpage.featureList.button': 'Ver todas as funcionalidades',
    'frontpage.featureList.title': 'Lista completa de funcionalidades',
    'frontpage.featureList.subtitle': 'Tudo o que o Source.io oferece, ordenado por impacto',
    'frontpage.featureList.topBadge': 'Funcionalidade principal',
    'frontpage.modePicker.heading': 'Escolha como organizar as suas fontes',
    'frontpage.backToDashboard': 'Voltar ao painel',
    'mode.chain.title': 'Cadeia de fontes',
    'mode.chain.sub': 'Rastreamento linear de referências',
    'mode.chain.desc': 'Comece com uma única fonte e construa uma cadeia. Cada fonte liga-se à seguinte através de um ponteiro de referência — ideal para seguir trilhos de citação.',
    'mode.tree.title': 'Árvore de fontes',
    'mode.tree.sub': 'Organização hierárquica',
    'mode.tree.desc': 'Comece com um tema inicial e ramifique em pontos de referência. Cada ramo contém várias fontes relacionadas — ideal para temas de investigação.',
    'frontpage.chain.cites': 'cita',
    'frontpage.chain.c1.title': 'Artigo de notícias',
    'frontpage.chain.c1.kind': 'Sítio web',
    'frontpage.chain.c1.pin': 'Arquivado em 2026-07-04',
    'frontpage.chain.c2.title': 'Artigo científico',
    'frontpage.chain.c2.kind': 'Científica',
    'frontpage.chain.c2.pin': 'DOI verificado, não retratado',
    'frontpage.chain.c3.title': 'Monografia original',
    'frontpage.chain.c3.kind': 'Livro',
    'frontpage.chain.c3.pin': '1.ª edição, p. 214',
  },
};

const ModeSelectionPage: React.FC<{ onSelect: (mode: AppMode) => void; isDark: boolean; isLoggedIn: boolean; onSignIn: () => void; onOpenAi?: () => void; onDemo?: () => void; onClose?: () => void }> = ({ onSelect, isDark, isLoggedIn, onSignIn, onOpenAi, onDemo, onClose }) => {
  const { t, lang, setLanguage, languages } = useTranslation();
  const tf = useCallback((key: string, en: string): string => {
    const local = lang !== 'en' ? FRONTPAGE_STRINGS[lang]?.[key] : undefined;
    const server = t(key, '');
    if (server && (lang === 'en' || server !== en || !local)) return server;
    return local || en;
  }, [t, lang]);
  const [langMenu, setLangMenu] = useState<HTMLElement | null>(null);
  const [featureListOpen, setFeatureListOpen] = useState(false);
  const fullFeatures = [
    { icon: <StarRateIcon sx={{ fontSize: 22, color: '#f59e0b' }} />, top: true,
      title: tf('frontpage.featureList.feat1.title', 'Trust scoring of sources'),
      desc:  tf('frontpage.featureList.feat1.desc', 'Per-source assessment with a clear two-group split: rate the work itself (credibility, recency, completeness) separately from the cited reference (accuracy, relevance). Mark categories N/A when they don\'t apply. Public boards show the score so readers can judge for themselves.') },
    { icon: <BookmarkIcon sx={{ fontSize: 22, color: '#3b82f6' }} />,
      title: tf('frontpage.featureList.feat2.title', 'Reference pointers'),
      desc:  tf('frontpage.featureList.feat2.desc', 'Pinpoint exactly what part of a source you\'re citing — page ranges in books, timestamps in videos, sections on websites, scenes in films, coordinates for events on a map.') },
    { icon: <AccountTreeIcon sx={{ fontSize: 22, color: '#10b981' }} />,
      title: tf('frontpage.featureList.feat3.title', 'Chains & trees'),
      desc:  tf('frontpage.featureList.feat3.desc', 'Two ways to organize: a Source Chain traces a citation backward through a sequence of sources, and a Source Tree branches a topic into reference points each holding multiple related sources.') },
    { icon: <LanguageIcon sx={{ fontSize: 22, color: '#8b5cf6' }} />,
      title: tf('frontpage.featureList.feat4.title', 'Web archive capture'),
      desc:  tf('frontpage.featureList.feat4.desc', 'Archive any URL with full-page screenshot and a replayable HTML version. Draw the exact reference area on the screenshot so readers can see the cited part highlighted.') },
    { icon: <StorageIcon sx={{ fontSize: 22, color: '#3b82f6' }} />,
      title: tf('frontpage.featureList.feat5.title', 'Verified file storage'),
      desc:  tf('frontpage.featureList.feat5.desc', 'Upload PDFs, images, audio and video as evidence — stored on Wasabi S3 with a verified-source seal. Multi-page PDFs render with cited-page highlighting.') },
    { icon: <FormatQuoteIcon sx={{ fontSize: 22, color: '#0891b2' }} />,
      title: tf('frontpage.featureList.feat6.title', 'Citation export'),
      desc:  tf('frontpage.featureList.feat6.desc', 'Generate citations in APA, Harvard, MLA and Chicago formats — one click, ready to paste into your paper or article.') },
    { icon: <TranslateIcon sx={{ fontSize: 22, color: '#0891b2' }} />,
      title: tf('frontpage.featureList.feat7.title', 'Multi-language interface'),
      desc:  tf('frontpage.featureList.feat7.desc', 'Use Source.io in English, Swedish, Spanish, French, German or Portuguese. Switch languages from the header — your choice persists across sessions.') },
    { icon: <PublicIcon sx={{ fontSize: 22, color: '#10b981' }} />,
      title: tf('frontpage.featureList.feat8.title', 'Public sharing'),
      desc:  tf('frontpage.featureList.feat8.desc', 'Publish any board with a public read-only link. Visitors see the full chain or tree, all references, all trust scores — no account required.') },
    { icon: <CodeIcon sx={{ fontSize: 22, color: '#64748b' }} />,
      title: tf('frontpage.featureList.feat9.title', 'XML import & export'),
      desc:  tf('frontpage.featureList.feat9.desc', 'Pipe boards in and out as structured XML. Drop output from ChatGPT or Claude into the importer to bootstrap a board, or export your work for backup or AI processing.') },
    { icon: <CheckCircleIcon sx={{ fontSize: 22, color: '#ef4444' }} />,
      title: tf('frontpage.featureList.feat10.title', 'Free for humans'),
      desc:  tf('frontpage.featureList.feat10.desc', 'Reading and creating public boards is free. Built in Gothenburg, Sweden, in collaboration with Chalmers University of Technology. No ads.') },
  ];

  const ink = isDark ? '#e2e8f0' : '#1a1a2e';
  const muted = isDark ? '#94a3b8' : '#64748b';
  const rule = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.09)';
  const blue = '#3b82f6';
  const green = '#10b981';

  const steps = [
    { n: 1,
      title: tf('frontpage.how.step1.title', 'Add sources & pin the evidence'),
      desc: tf('frontpage.how.step1.desc', 'Books, papers, articles, statements, events — 32 typed source forms. Attach files, archive web pages before they change, record the exact edition or revision cited.') },
    { n: 2,
      title: tf('frontpage.how.step2.title', 'Chain the citations'),
      desc: tf('frontpage.how.step2.desc', 'Link each source to the one it cites, with page ranges and notes. The claim traces back through time to its foundations — visibly, on a board.') },
    { n: 3,
      title: tf('frontpage.how.step3.title', 'Score trust & share'),
      desc: tf('frontpage.how.step3.desc', 'Rate credibility, verifiability and timeliness per source. Publish the board — readers see the scores, vote, and judge the evidence for themselves.') },
  ];

  const chainIllustration = (() => {
    const cardBg = isDark ? '#12121a' : '#ffffff';
    const cardStroke = isDark ? '#2a2a36' : '#e2e8f0';
    const arrow = isDark ? '#475569' : '#cbd5e1';
    const cards: { x: number; type: string; title: string; kind: string; pin: string }[] = [
      { x: 6,   type: 'website',    title: tf('frontpage.chain.c1.title', 'News article'),       kind: tf('frontpage.chain.c1.kind', 'Website'),    pin: tf('frontpage.chain.c1.pin', 'Archived 2026-07-04') },
      { x: 266, type: 'scientific', title: tf('frontpage.chain.c2.title', 'Journal paper'),      kind: tf('frontpage.chain.c2.kind', 'Scientific'), pin: tf('frontpage.chain.c2.pin', 'DOI resolved, no retraction') },
      { x: 526, type: 'book',       title: tf('frontpage.chain.c3.title', 'Original monograph'), kind: tf('frontpage.chain.c3.kind', 'Book'),       pin: tf('frontpage.chain.c3.pin', '1st edition, p. 214') },
    ];
    const W = 200, H = 92, Y = 8;
    return (
      <svg viewBox="0 0 732 108" style={{ width: '100%', maxWidth: 732, height: 'auto', display: 'block' }} aria-hidden="true">
        {[0, 1].map(i => {
          const x1 = cards[i].x + W + 6, x2 = cards[i + 1].x - 6, y = Y + H / 2;
          return (
            <g key={i}>
              <line x1={x1} y1={y} x2={x2 - 8} y2={y} stroke={arrow} strokeWidth={1.5} />
              <polygon points={`${x2},${y} ${x2 - 9},${y - 4.5} ${x2 - 9},${y + 4.5}`} fill={arrow} />
              <text x={(x1 + x2) / 2} y={y - 8} textAnchor="middle" fontSize={10} fill={muted}>{tf('frontpage.chain.cites', 'cites')}</text>
            </g>
          );
        })}
        {cards.map(c => {
          const accent = (SOURCE_COLORS as Record<string, string>)[c.type] || '#64748b';
          return (
            <g key={c.type}>
              <rect x={c.x} y={Y} width={W} height={H} rx={8} fill={cardBg} stroke={cardStroke} strokeWidth={1.25} />
              <rect x={c.x} y={Y} width={4} height={H} rx={2} fill={accent} />
              <text x={c.x + 18} y={Y + 28} fontSize={13} fontWeight={600} fill={ink}>{c.title}</text>
              <text x={c.x + 18} y={Y + 46} fontSize={10.5} fill={muted}>{c.kind}</text>
              <circle cx={c.x + 22} cy={Y + 70} r={4} fill={green} />
              <path d={`M${c.x + 19.5} ${Y + 70} l2 2 l3.5 -4`} stroke={cardBg} strokeWidth={1.3} fill="none" strokeLinecap="round" strokeLinejoin="round" />
              <text x={c.x + 31} y={Y + 73.5} fontSize={10} fontWeight={500} fill={green}>{c.pin}</text>
            </g>
          );
        })}
      </svg>
    );
  })();

  const modeCard = (mode: AppMode, accent: string, icon: React.ReactNode, title: string, sub: string, desc: string, beta?: boolean) => (
    <Card elevation={0} onClick={() => onSelect(mode)}
      sx={{ width: 320, maxWidth: '100%', position: 'relative', overflow: 'visible', cursor: 'pointer', border: `1px solid ${rule}`, borderRadius: '10px', bgcolor: isDark ? '#12121a' : '#fff',
        transition: 'border-color 0.15s, box-shadow 0.15s', '&:hover': { borderColor: accent, boxShadow: `0 0 0 1px ${accent}` } }}>
      {beta && (
        <Box sx={{ position: 'absolute', top: -9, right: 12, bgcolor: '#f59e0b', color: '#fff', fontSize: 9.5, fontWeight: 700, letterSpacing: 0.4, px: 0.9, py: 0.25, borderRadius: '4px', zIndex: 1 }}>Beta</Box>
      )}
      <CardActionArea sx={{ p: 3, height: '100%', borderRadius: '10px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '8px', bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', color: accent, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</Box>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 16, color: ink, lineHeight: 1.2 }}>{title}</Typography>
            <Typography sx={{ fontSize: 12, color: muted, mt: 0.3 }}>{sub}</Typography>
          </Box>
        </Box>
        <Typography sx={{ fontSize: 13, lineHeight: 1.6, color: muted }}>{desc}</Typography>
      </CardActionArea>
    </Card>
  );

  return (
  <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: isDark ? '#0a0a0f' : '#fafbfc', overflow: 'auto', color: ink }}>
    <Box sx={{ px: { xs: 2.5, sm: 4 }, py: 2, borderBottom: `1px solid ${rule}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
      <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, letterSpacing: '-0.01em' }}>source<span style={{ color: blue }}>.</span></Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button size="small" variant="text"
          startIcon={<TranslateIcon sx={{ fontSize: 14 }} />}
          onClick={(e) => setLangMenu(e.currentTarget)}
          aria-label="Change language"
          sx={{ fontSize: 12.5, height: 32, borderRadius: '8px', color: muted, '&:hover': { color: ink, bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)' } }}>
          {LANGUAGE_LABELS[lang] || lang.toUpperCase()}
        </Button>
        <Menu anchorEl={langMenu} open={!!langMenu} onClose={() => setLangMenu(null)}
          disableScrollLock anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{ paper: { sx: { zIndex: 10000 } } }}
          sx={{ zIndex: 10000 }}>
          {languages.map(L => (
            <MenuItem key={L.code} selected={L.code === lang}
              onClick={() => { setLanguage(L.code); setLangMenu(null); }}
              sx={{ fontSize: 13, minWidth: 160 }}>
              {L.label}
            </MenuItem>
          ))}
        </Menu>
        {!isLoggedIn ? (
          <Button variant="contained" disableElevation onClick={onSignIn} sx={{ fontSize: 13, fontWeight: 600, borderRadius: '8px', px: 2 }}>
            {tf('frontpage.signin', 'Sign In')}
          </Button>
        ) : onClose ? (
          <Button variant="text" size="small" startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />} onClick={onClose} sx={{ fontSize: 12.5, color: muted, '&:hover': { color: ink, bgcolor: 'transparent' } }}>
            {tf('frontpage.backToDashboard', 'Back to dashboard')}
          </Button>
        ) : null}
      </Box>
    </Box>

    <Box sx={{ flex: 1, px: { xs: 2.5, sm: 4 }, py: { xs: 5, md: 8 } }}>
      <Box sx={{ maxWidth: 880, width: '100%', mx: 'auto' }}>
        {isLoggedIn ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem' }, fontWeight: 700, letterSpacing: '-0.01em', mb: 4 }}>
              {tf('frontpage.modePicker.heading', 'Choose how to organize your sources')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', textAlign: 'left' }}>
              {modeCard('single', blue, <ViewStreamIcon sx={{ fontSize: 22 }} />,
                tf('mode.chain.title', 'Source Chain'), tf('mode.chain.sub', 'Linear reference tracking'),
                tf('mode.chain.desc', 'Start with a single source and build a chain. Each source links to the next with a reference pointer — perfect for tracking citation trails.'))}
              {modeCard('tree', green, <AccountTreeIcon sx={{ fontSize: 22 }} />,
                tf('mode.tree.title', 'Source Tree'), tf('mode.tree.sub', 'Hierarchical organization'),
                tf('mode.tree.desc', 'Start with a seed topic and branch into reference points. Each branch holds multiple related sources — ideal for research topics.'), true)}
            </Box>
          </Box>
        ) : (
          <>
            <Box sx={{ textAlign: 'center' }}>
              <Typography component="h1" sx={{ fontSize: { xs: '2rem', sm: '2.6rem', md: '3rem' }, fontWeight: 700, lineHeight: 1.1, letterSpacing: '-0.02em', maxWidth: 720, mx: 'auto', textWrap: 'balance' }}>
                {tf('frontpage.hero.headline', 'Trace any claim back to its evidence')}
                <Box component="sup" sx={{ fontSize: '0.45em', fontWeight: 600, color: blue, ml: 0.4, verticalAlign: 'top', lineHeight: 1.6 }}>1</Box>
              </Typography>
              <Typography sx={{ mt: 2.5, fontSize: { xs: 15, sm: 17 }, lineHeight: 1.6, color: muted, maxWidth: 640, mx: 'auto', textWrap: 'balance' }}>
                {tf('frontpage.hero.lede', 'Source.io links each citation to the exact edition, revision or archived page it cites, chains them back to the original record, and shows readers how far to trust every link.')}
              </Typography>
              <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                <Button variant="contained" size="large" disableElevation onClick={onSignIn}
                  sx={{ px: 3.5, fontSize: 14, fontWeight: 600, borderRadius: '8px' }}>
                  {tf('frontpage.cta.create', 'Create a free account')}
                </Button>
                {onDemo && (
                  <Button variant="outlined" size="large" onClick={onDemo}
                    sx={{ px: 3.5, fontSize: 14, fontWeight: 500, borderRadius: '8px', color: ink, borderColor: rule, '&:hover': { borderColor: ink, bgcolor: 'transparent' } }}>
                    {tf('frontpage.demo', 'Try Demo Mode')}
                  </Button>
                )}
              </Box>
              {onOpenAi && (
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
                  <Button size="small" onClick={onOpenAi}
                    sx={{ fontSize: 12.5, fontWeight: 600, color: blue, p: 0, minWidth: 0, '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' } }}>
                    {tf('ai.button', 'Create with AI')}
                  </Button>
                  <Typography sx={{ fontSize: 12.5, color: muted }}>
                    {tf('ai.buttonHint', 'Generate a source chain from an AI prompt — no sign-in required')}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box sx={{ mt: { xs: 5, md: 7 }, overflowX: 'auto' }}>
              <Box sx={{ minWidth: 560 }}>{chainIllustration}</Box>
            </Box>
            <Typography sx={{ mt: 2, fontSize: 12.5, color: muted, textAlign: 'center', maxWidth: 640, mx: 'auto', lineHeight: 1.6 }}>
              <Box component="sup" sx={{ color: blue, fontWeight: 600, mr: 0.4 }}>1</Box>
              {tf('frontpage.hero.footnote', 'Each source is pinned to the version cited — an archived snapshot, a DOI, a page in a specific edition — and stays checkable.')}
            </Typography>

            <Box sx={{ mt: { xs: 6, md: 8 }, pt: 5, borderTop: `1px solid ${rule}` }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: muted, mb: 3.5, textAlign: 'center' }}>
                {tf('frontpage.how.heading', 'How it works')}
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' }, gap: { xs: 3.5, sm: 4 } }}>
                {steps.map(s => (
                  <Box key={s.n}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: blue, fontVariantNumeric: 'tabular-nums' }}>{s.n}</Typography>
                      <Box sx={{ flex: 1, height: '1px', bgcolor: rule }} />
                    </Box>
                    <Typography sx={{ fontSize: 15, fontWeight: 600, lineHeight: 1.3, mb: 0.75 }}>{s.title}</Typography>
                    <Typography sx={{ fontSize: 13, lineHeight: 1.65, color: muted }}>{s.desc}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>

    <Box sx={{ px: { xs: 2.5, sm: 4 }, py: 2.5, borderTop: `1px solid ${rule}`, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
      <Box sx={{ maxWidth: 640 }}>
        <Typography sx={{ fontSize: 11.5, color: muted, lineHeight: 1.6 }}>
          {tf('frontpage.footer.nonprofit', 'Run by a Swedish non-profit association. Free for humans, no ads.')}
        </Typography>
        <Typography sx={{ fontSize: 11.5, color: muted, lineHeight: 1.6 }}>
          {tf('frontpage.machine.line', 'Public boards are machine-readable: JSON export, a bulk dataset, and an MCP server so AI assistants can cite pinned evidence directly.')}
        </Typography>
      </Box>
      <Button onClick={() => setFeatureListOpen(true)} size="small"
        sx={{ fontSize: 11.5, color: muted, p: 0, minWidth: 0, '&:hover': { color: blue, bgcolor: 'transparent', textDecoration: 'underline' } }}>
        {tf('frontpage.featureList.button', 'See all features')}
      </Button>
    </Box>

    <Dialog open={featureListOpen} onClose={() => setFeatureListOpen(false)}
      disableScrollLock maxWidth="md" fullWidth
      PaperProps={{ sx: { zIndex: 10000, borderRadius: '14px' } }}
      sx={{ zIndex: 10000 }}>
      <DialogTitle sx={{ pb: 1, pr: 5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <StarRateIcon sx={{ color: '#f59e0b' }} />
          <Box>
            <Typography fontSize={18} fontWeight={700}>
              {tf('frontpage.featureList.title', 'Complete feature list')}
            </Typography>
            <Typography fontSize={12} color="text.secondary">
              {tf('frontpage.featureList.subtitle', 'Everything Source.io offers, ranked by impact')}
            </Typography>
          </Box>
        </Box>
        <IconButton onClick={() => setFeatureListOpen(false)}
          sx={{ position: 'absolute', top: 12, right: 12 }}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {fullFeatures.map((f, i) => (
          <Box key={i} sx={{
            display: 'flex', gap: 2, p: 2.2,
            borderBottom: i < fullFeatures.length - 1 ? '1px solid' : 'none',
            borderColor: 'divider',
            bgcolor: f.top ? (isDark ? 'rgba(245,158,11,0.06)' : 'rgba(245,158,11,0.04)') : 'transparent',
          }}>
            <Typography sx={{
              fontFamily: 'monospace', fontSize: 22, fontWeight: 700,
              color: f.top ? '#f59e0b' : 'text.disabled',
              minWidth: 32, textAlign: 'right', lineHeight: 1.2,
              flexShrink: 0,
            }}>
              {i + 1}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, flex: 1, minWidth: 0 }}>
              <Box sx={{ flexShrink: 0, mt: 0.2 }}>{f.icon}</Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.4 }}>
                  <Typography fontSize={14} fontWeight={700}>{f.title}</Typography>
                  {f.top && (
                    <Box sx={{
                      px: 0.8, py: 0.2, borderRadius: '4px',
                      bgcolor: '#f59e0b', color: '#fff',
                      fontSize: 9, fontWeight: 800,
                      textTransform: 'uppercase', letterSpacing: 0.5,
                      lineHeight: 1.2,
                    }}>
                      ★ {tf('frontpage.featureList.topBadge', 'Top Feature')}
                    </Box>
                  )}
                </Box>
                <Typography fontSize={12} color="text.secondary" sx={{ lineHeight: 1.55 }}>
                  {f.desc}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  </Box>
  );
};


// ── AI board XML helpers ─────────────────────────────────────────────────────
const AI_XML_TYPES: Record<string, string[]> = {
  book: ['title', 'author', 'publisher', 'year', 'isbn', 'pages', 'language', 'subject', 'edition', 'translator', 'originalYear'],
  scientific: ['title', 'authors', 'journal', 'volume', 'doi', 'date', 'field', 'method', 'abstract', 'url', 'pages', 'retractionStatus'],
  film: ['title', 'director', 'year', 'runtime', 'genre', 'plot', 'cast', 'rating'],
  website: ['title', 'site', 'url', 'accessed', 'author', 'published', 'contentType', 'language', 'archivedUrl'],
  article: ['title', 'author', 'journal', 'date', 'doi', 'volume', 'pages', 'url', 'archivedUrl'],
  essay: ['title', 'author', 'subject', 'teacher', 'school', 'date', 'gradeLevel', 'language', 'url', 'abstract'],
  video: ['title', 'creator', 'platform', 'duration', 'date', 'url', 'description', 'language', 'archivedUrl'],
  statement: ['claim', 'claimant', 'role', 'date', 'medium', 'location', 'recordedBy', 'attribution', 'witnesses', 'transcriptUrl'],
  event: ['title', 'location', 'coordinates', 'dateFrom', 'dateTo', 'eventType', 'severity', 'impact', 'parties', 'description', 'weather', 'response', 'reportNumber', 'witnesses', 'confirmedBy'],
};
const AI_TYPE_ALIASES: Record<string, string> = { scientific_paper: 'scientific', paper: 'scientific', web_archive: 'archive', tweet: 'twitter', testimony: 'statement' };
const AI_ALL_VALID_TYPES = new Set(['archive', 'article', 'book', 'dataset', 'email', 'encyclopedia', 'essay', 'event', 'facebook', 'film', 'government', 'image', 'interview', 'legal', 'manual', 'map', 'medical', 'music', 'newspaper', 'patent', 'podcast', 'report', 'scientific', 'speech', 'statement', 'statistics', 'thesis', 'tiktok', 'twitter', 'video', 'website', 'youtube']);
const AI_MAX_SOURCES = 50;
const AI_MAX_XML_BYTES = 32 * 1024;

const XML_CTRL_RE = new RegExp('[' + String.fromCharCode(0) + '-' + String.fromCharCode(8) + String.fromCharCode(11) + String.fromCharCode(12) + String.fromCharCode(14) + '-' + String.fromCharCode(31) + ']', 'g');
const repairBoardXml = (xml: string): { xml: string; fixes: string[] } => {
  const fixes: string[] = [];
  let out = xml || '';
  const bareAmp = /&(?![a-zA-Z][a-zA-Z0-9]*;|#\d+;|#x[0-9a-fA-F]+;)/g;
  const amp = (out.match(bareAmp) || []).length;
  if (amp) { out = out.replace(bareAmp, '&amp;'); fixes.push(`escaped ${amp} bare ampersand${amp === 1 ? '' : 's'}`); }
  const curly = /=\s*[\u201C\u201D]([^\u201C\u201D\n"]*)[\u201C\u201D]/g;
  const cq = (out.match(curly) || []).length;
  if (cq) { out = out.replace(curly, '="$1"'); fixes.push(`straightened ${cq} curly-quoted attribute${cq === 1 ? '' : 's'}`); }
  const ctrl = (out.match(XML_CTRL_RE) || []).length;
  if (ctrl) { out = out.replace(XML_CTRL_RE, ''); fixes.push(`removed ${ctrl} control character${ctrl === 1 ? '' : 's'}`); }
  return { xml: out, fixes };
};

const extractBoardXml = (raw: string): string => {
  if (!raw) return '';
  const stripped = raw.replace(/```[a-zA-Z]*\r?\n?/g, '\n');
  const m = stripped.match(/<source-(chain|tree)[\s\S]*<\/source-\1\s*>/i);
  return (m ? m[0] : stripped).trim();
};

type AiXmlSourceSummary = { order: string; type: string; title: string; knownType: boolean };
type AiXmlCheck = {
  ok: boolean;
  errors: string[];
  warnings: string[];
  mode: 'chain' | 'tree' | null;
  name: string;
  sources: AiXmlSourceSummary[];
};

const validateBoardXml = (xmlText: string): AiXmlCheck => {
  const res: AiXmlCheck = { ok: false, errors: [], warnings: [], mode: null, name: '', sources: [] };
  const text = (xmlText || '').trim();
  if (!text) { res.errors.push('No XML to validate yet.'); return res; }
  const bytes = typeof TextEncoder !== 'undefined' ? new TextEncoder().encode(text).length : text.length;
  if (bytes > AI_MAX_XML_BYTES) res.errors.push(`XML is ${(bytes / 1024).toFixed(1)} KB — the server accepts at most ${AI_MAX_XML_BYTES / 1024} KB. Remove some sources or shorten long fields (abstracts, plots).`);
  let doc: Document;
  try {
    doc = new DOMParser().parseFromString(text, 'application/xml');
  } catch {
    res.errors.push('XML could not be parsed.');
    return res;
  }
  const perr = doc.querySelector('parsererror');
  if (perr) {
    const firstLine = (perr.textContent || 'Malformed XML').split('\n').map(l => l.trim()).filter(Boolean)[0] || 'Malformed XML';
    res.errors.push(`Malformed XML: ${firstLine.slice(0, 200)}`);
    return res;
  }
  const root = doc.documentElement;
  if (root.tagName === 'source-chain') res.mode = 'chain';
  else if (root.tagName === 'source-tree') res.mode = 'tree';
  else { res.errors.push(`Root element must be <source-chain> or <source-tree>, got <${root.tagName}>.`); return res; }
  res.name = root.getAttribute('name') || '';
  if (!res.name) res.warnings.push('Root is missing a name="…" attribute — the board will get a generic title.');

  const childrenOf = (el: Element, tag: string) => Array.from(el.children).filter(c => c.tagName === tag);
  const titleOf = (srcEl: Element): string => {
    const fields = childrenOf(srcEl, 'field');
    const t = fields.find(f => (f.getAttribute('name') || '').toLowerCase() === 'title');
    return (t?.textContent || fields[0]?.textContent || '').trim();
  };
  const checkSource = (srcEl: Element, label: string): AiXmlSourceSummary => {
    const rawType = srcEl.getAttribute('type') || '';
    const type = AI_TYPE_ALIASES[rawType] || rawType;
    const known = AI_ALL_VALID_TYPES.has(type);
    if (!rawType) res.errors.push(`${label}: missing type="…" attribute.`);
    else if (!known) res.errors.push(`${label}: unknown type "${rawType}". Main types: ${Object.keys(AI_XML_TYPES).join(', ')} (plus ${AI_ALL_VALID_TYPES.size - Object.keys(AI_XML_TYPES).length} more — see the prompt).`);
    const fields = childrenOf(srcEl, 'field');
    if (fields.length === 0) res.warnings.push(`${label}: has no <field> elements.`);
    const allowed = AI_XML_TYPES[type];
    if (known && allowed) {
      fields.forEach(f => {
        const n = f.getAttribute('name') || '';
        if (n && !allowed.includes(n)) res.warnings.push(`${label}: field "${n}" isn't a known ${type} tag — it may be ignored.`);
      });
    }
    return { order: srcEl.getAttribute('order') || '', type, title: titleOf(srcEl), knownType: known };
  };

  if (res.mode === 'chain') {
    const sources = childrenOf(root, 'source');
    if (sources.length === 0) res.errors.push('Chain has no <source> elements.');
    if (sources.length > AI_MAX_SOURCES) res.errors.push(`Too many sources: ${sources.length} (max ${AI_MAX_SOURCES}).`);
    const seen = new Set<string>();
    sources.forEach((s, i) => {
      const sum = checkSource(s, `Source ${i + 1}`);
      if (!sum.order || isNaN(parseInt(sum.order, 10))) res.warnings.push(`Source ${i + 1}: missing order="…" — the server will assign it from document order.`);
      else if (seen.has(sum.order)) res.warnings.push(`Duplicate order="${sum.order}" — orders should be unique.`);
      else seen.add(sum.order);
      res.sources.push(sum);
    });
    res.sources.sort((a, b) => (parseInt(a.order, 10) || 0) - (parseInt(b.order, 10) || 0));
  } else {
    const rootSrc = childrenOf(root, 'root-source')[0];
    if (!rootSrc) res.errors.push('Tree is missing a <root-source> element.');
    else res.sources.push({ ...checkSource(rootSrc, 'Root source'), order: 'root' });
    const nodes = childrenOf(root, 'node');
    if (nodes.length === 0) res.warnings.push('Tree has no <node> branches yet.');
    let count = 0;
    nodes.forEach((n, i) => {
      const label = n.getAttribute('label') || `node ${i + 1}`;
      const srcs = childrenOf(n, 'source');
      if (srcs.length === 0) res.warnings.push(`Node "${label}" has no sources.`);
      srcs.forEach((s, j) => {
        count++;
        res.sources.push({ ...checkSource(s, `Node "${label}" source ${j + 1}`), order: label });
      });
    });
    if (count > AI_MAX_SOURCES) res.errors.push(`Too many sources: ${count} (max ${AI_MAX_SOURCES}).`);
  }
  res.ok = res.errors.length === 0;
  return res;
};

const AiBoardPage: React.FC<{ isDark: boolean; onBack: () => void; onOpenBoard: (boardId: string) => void }> = ({ isDark, onBack, onOpenBoard }) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<'generate' | 'paste'>('generate');
  const [result, setResult] = useState<{ boardId: string; publicUrl: string } | null>(null);
  const [error, setError] = useState('');
  const [copiedUrl, setCopiedUrl] = useState(false);
  const [topic, setTopic] = useState('');
  const [generating, setGenerating] = useState(false);
  const [genPhase, setGenPhase] = useState('');
  const [genUnavailable, setGenUnavailable] = useState(false);
  const genAbort = useRef<AbortController | null>(null);
  const [attribution, setAttribution] = useState('');
  const [rawInput, setRawInput] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [copiedPrompt, setCopiedPrompt] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [showDevDocs, setShowDevDocs] = useState(false);

  useEffect(() => () => { genAbort.current?.abort(); }, []);

  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://source.io';
  const systemPrompt = `You are helping a user build a "source chain" — a sequence of sources tracing a citation back through time, from a recent source to its older foundations.

Output VALID XML in this exact format (no preamble, no markdown fences):

<source-chain name="Short title for the board">
  <source type="SOURCE_TYPE" order="1">
    <field name="FIELD_TAG">value</field>
    ... more fields ...
    <ref from="START" to="END" notes="What this source cites in the next-older one"/>
  </source>
  <source type="SOURCE_TYPE" order="2">
    ... and so on, increasing order numbers for older sources ...
  </source>
</source-chain>

RULES:
- order="1" is the NEWEST source (e.g. a Wikipedia article today).
- Increasing order numbers go BACK IN TIME (older sources cite even older ones).
- Maximum 50 sources per chain.
- Each source references the NEXT-OLDER one — that's what makes it a chain.

MAIN SOURCE TYPES and their field tags:
  book        title, author, publisher, year, isbn, pages, language, subject, edition, translator, originalYear
  scientific  title, authors, journal, volume, doi, date, field, method, abstract, url, pages
  film        title, director, year, runtime, genre, plot, cast, rating
  website     title, site, url, accessed, author, published, contentType, language
  article     title, author, journal, date, doi, volume, pages, url
  essay       title, author, subject, teacher, school, date, gradeLevel, language, url, abstract
  video       title, creator, platform, duration, date, url, description, language
  statement   claim, claimant, role, date, medium, location, recordedBy, attribution, witnesses, transcriptUrl
  event       title, location, dateFrom, dateTo, eventType, impact, parties, description, witnesses, confirmedBy

Other valid types (same <field name> pattern; use only if clearly a better fit):
  archive, dataset, email, encyclopedia, facebook, government, image, interview, legal, manual, map, medical, music, newspaper, patent, podcast, report, speech, statistics, thesis, tiktok, twitter, youtube

OPTIONAL on book sources with page-based refs:
  fromSectionStartsWith="opening words on the From page"
  toSectionEndsWith="closing words on the To page"

EXAMPLE:
<source-chain name="Origin of cellular automaton concept">
  <source type="website" order="1">
    <field name="title">Cellular automaton</field>
    <field name="site">Wikipedia</field>
    <field name="url">https://en.wikipedia.org/wiki/Cellular_automaton</field>
    <field name="accessed">2026-05-21</field>
    <ref from="" to="" notes="Says Wolfram coined the term in 1983."/>
  </source>
  <source type="scientific" order="2">
    <field name="title">Statistical Mechanics of Cellular Automata</field>
    <field name="authors">Stephen Wolfram</field>
    <field name="journal">Reviews of Modern Physics</field>
    <field name="date">1983</field>
    <ref from="601" to="644" notes="Builds on von Neumann's earlier self-replication work."/>
  </source>
  <source type="book" order="3">
    <field name="title">Theory of Self-Reproducing Automata</field>
    <field name="author">John von Neumann</field>
    <field name="publisher">University of Illinois Press</field>
    <field name="year">1966</field>
  </source>
</source-chain>

OR, for a SOURCE TREE (one central source that multiple other sources reference at different points):

<source-tree name="Short title">
  <root-source type="book">
    <field name="title">The central work everything references</field>
    <field name="author">...</field>
  </root-source>
  <node label="p. 42">
    <source type="article">
      <field name="title">A source citing page 42 of the root</field>
      <ref from="42" to="42" notes="What it says about this point"/>
    </source>
  </node>
  <node label="p. 88">
    <source type="website">
      <field name="title">Another source citing a different point</field>
      <ref from="88" to="90"/>
    </source>
  </node>
</source-tree>

Use a CHAIN when sources form a linear citation trail (A cites B cites C).
Use a TREE when one central source is referenced by many others at different points.

Now research the topic the user describes and produce the XML.`;

  const extracted = useMemo(() => extractBoardXml(rawInput), [rawInput]);
  const repaired = useMemo(() => repairBoardXml(extracted), [extracted]);
  const xml = repaired.xml;
  const wasExtracted = !!extracted && !!rawInput.trim() && extracted !== rawInput.trim();
  const check = useMemo(() => (rawInput.trim() ? validateBoardXml(xml) : null), [rawInput, xml]);

  const handleCopyPrompt = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(systemPrompt);
      setCopiedPrompt(true);
      setTimeout(() => setCopiedPrompt(false), 2000);
    } catch {}
  }, [systemPrompt]);

  const handleCopyUrl = useCallback(async () => {
    if (!result) return;
    try {
      await navigator.clipboard.writeText(result.publicUrl);
      setCopiedUrl(true);
      setTimeout(() => setCopiedUrl(false), 2000);
    } catch {}
  }, [result]);

  const createBoard = useCallback(async (xmlToSend: string, attributionToSend: string): Promise<{ boardId: string; publicUrl: string }> => {
    const resp = await fetch(`${API_BASE}/public/boards`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ xml: xmlToSend, aiAttribution: attributionToSend.slice(0, 80) }),
    });
    const data = await resp.json().catch(() => ({} as any));
    if (!resp.ok) {
      if (resp.status === 429) throw new Error(t('ai.rateLimited', 'Rate limit reached for this network (5 boards per hour, 50 per day). Try again later, or sign in to create boards without limits.'));
      if (resp.status === 413) throw new Error(t('ai.tooLarge', 'The XML is larger than the server accepts (32 KB). Remove some sources or shorten long fields.'));
      const details = Array.isArray(data.details) ? ` (${data.details.join('; ')})` : '';
      throw new Error(`${data.error || `HTTP ${resp.status}`}${details}`);
    }
    if (!data.boardId || !data.publicUrl) throw new Error(t('ai.badResponse', 'The server accepted the board but returned no link — reload the page and try again.'));
    return { boardId: data.boardId, publicUrl: data.publicUrl };
  }, [t]);

  const handleGenerate = useCallback(async () => {
    const topicTrim = topic.trim();
    if (topicTrim.length < 3) { setError(t('ai.topicTooShort', 'Describe your topic in a few words first.')); return; }
    setError(''); setResult(null); setGenerating(true);
    setGenPhase(t('ai.genPhaseResearch', 'Researching the topic and drafting sources — this can take a minute…'));
    const ctrl = new AbortController();
    genAbort.current = ctrl;
    const timeout = setTimeout(() => ctrl.abort(), 180000);
    try {
      const resp = await fetch(`${API_BASE}/public/boards/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic: topicTrim.slice(0, 500) }),
        signal: ctrl.signal,
      });
      const data = await resp.json().catch(() => ({} as any));
      const looksUnconfigured = /not (?:configured|enabled|available)|api key|disabled/i.test(String(data?.error || ''));
      if (resp.status === 404 || resp.status === 501 || resp.status === 503 || (!resp.ok && looksUnconfigured)) {
        setGenUnavailable(true);
        setMode('paste');
        setError(t('ai.genUnavailable', 'One-click generation isn\u2019t enabled on this server yet — use the manual flow below.'));
        return;
      }
      if (resp.status === 429) { setError(t('ai.rateLimited', 'Rate limit reached for this network (5 boards per hour, 50 per day). Try again later, or sign in to create boards without limits.')); return; }
      if (!resp.ok) { setError(String(data.error || `HTTP ${resp.status}`)); return; }
      if (data.boardId && data.publicUrl) { setResult({ boardId: data.boardId, publicUrl: data.publicUrl }); return; }
      const genXml = extractBoardXml(String(data.xml || ''));
      const genCheck = validateBoardXml(genXml);
      if (!genCheck.ok) {
        setRawInput(String(data.xml || ''));
        setAttribution(String(data.attribution || 'source.io generator'));
        setMode('paste');
        setError(t('ai.genInvalid', 'The generator returned XML with problems — review it below, fix, and create manually.'));
        return;
      }
      setGenPhase(t('ai.genPhaseCreate', 'Creating your board…'));
      setResult(await createBoard(genXml, String(data.attribution || 'source.io generator')));
    } catch (err: any) {
      setError(err?.name === 'AbortError'
        ? t('ai.genTimeout', 'Generation was cancelled or timed out — try again with a narrower topic.')
        : (err?.message || 'Network error'));
    } finally {
      clearTimeout(timeout);
      setGenerating(false);
      setGenPhase('');
      genAbort.current = null;
    }
  }, [topic, t, createBoard]);

  const handleSubmit = useCallback(async () => {
    setError(''); setResult(null);
    if (!attribution.trim()) { setError(t('ai.attributionMissing', 'Tell us which AI generated this (pick one of the chips above) before creating the board.')); return; }
    if (!check || !check.ok) { setError(t('ai.fixErrors', 'Fix the validation errors shown above first.')); return; }
    setSubmitting(true);
    try {
      setResult(await createBoard(xml, attribution.trim()));
    } catch (err: any) {
      setError(err?.message || 'Network error');
    } finally {
      setSubmitting(false);
    }
  }, [attribution, check, xml, t, createBoard]);

  const curlExample = `curl -X POST ${origin}/api/public/boards \\
  -H "Content-Type: application/xml" \\
  -H "X-AI-Attribution: Claude Opus 4.7" \\
  --data-binary @board.xml`;

  const exampleTopics = [
    t('ai.example1', 'Who first proposed the greenhouse effect?'),
    t('ai.example2', 'Origin of the term "artificial intelligence"'),
    t('ai.example3', 'Where does the Pomodoro Technique come from?'),
  ];

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', overflow: 'auto', bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Button startIcon={<ArrowBackIcon />} size="small" onClick={onBack} sx={{ textTransform: 'none' }}>
          {t('ai.back', 'Back to home')}
        </Button>
        <Box sx={{ flex: 1 }} />
        <SmartToyIcon sx={{ fontSize: 20, color: '#38bdf8' }} />
      </Box>

      <Box sx={{ maxWidth: 880, mx: 'auto', px: 3, py: 4 }}>
        <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
          {t('ai.pageTitle', 'Create a source chain with AI')}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
          {t('ai.pageIntro2', 'Describe a topic and let source.io research it and build a shareable board for you — or paste XML from your own LLM. No sign-in required.')}
        </Typography>

        <Box sx={{ p: 1.5, mb: 3, borderRadius: '8px', bgcolor: isDark ? 'rgba(245,158,11,0.1)' : 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)', display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <WarningIcon sx={{ fontSize: 18, color: '#f59e0b', flexShrink: 0, mt: 0.2 }} />
          <Typography fontSize={12} color="text.secondary" sx={{ lineHeight: 1.5 }}>
            {t('ai.disclaimer', 'AI-generated source chains may contain hallucinated citations. Verify before sharing as authoritative.')}
          </Typography>
        </Box>

        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={(_, v) => { if (v) { setMode(v); setError(''); } }}
          size="small"
          sx={{ mb: 3 }}
        >
          <ToggleButton value="generate" sx={{ textTransform: 'none', px: 2.5, gap: 0.8 }} disabled={generating}>
            <SmartToyIcon sx={{ fontSize: 16 }} />
            {t('ai.modeGenerate', 'Generate for me')}
          </ToggleButton>
          <ToggleButton value="paste" sx={{ textTransform: 'none', px: 2.5 }} disabled={generating}>
            {t('ai.modePaste', 'Paste from your own AI')}
          </ToggleButton>
        </ToggleButtonGroup>

        {mode === 'generate' && (
          <Box sx={{ mb: 3 }}>
            {genUnavailable && (
              <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '6px', bgcolor: isDark ? 'rgba(59,130,246,0.1)' : 'rgba(59,130,246,0.06)', border: '1px solid rgba(59,130,246,0.3)' }}>
                <Typography fontSize={12} color="text.secondary" sx={{ lineHeight: 1.5 }}>
                  {t('ai.genUnavailable', 'One-click generation isn\u2019t enabled on this server yet — use the manual flow below.')}
                </Typography>
              </Box>
            )}
            <TextField
              label={t('ai.topicLabel', 'What should the source chain trace?')}
              placeholder={t('ai.topicPlaceholder', 'e.g. Who coined the term "meme" and what did they build on?')}
              value={topic}
              onChange={(e) => setTopic(e.target.value.slice(0, 500))}
              onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey && !generating) { e.preventDefault(); handleGenerate(); } }}
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              disabled={generating}
              sx={{ mb: 1.2 }}
            />
            <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap', mb: 1.5 }}>
              {exampleTopics.map((ex) => (
                <Chip key={ex} label={ex} size="small" variant="outlined" onClick={() => setTopic(ex)} disabled={generating}
                  sx={{ fontSize: 11, cursor: 'pointer' }} />
              ))}
            </Box>
            {error && mode === 'generate' && (
              <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '6px', bgcolor: isDark ? 'rgba(239,68,68,0.1)' : 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                <Typography fontSize={12} color="error" sx={{ lineHeight: 1.5, flex: 1, minWidth: 200 }}>{error}</Typography>
                <Button size="small" variant="outlined" onClick={() => { setMode('paste'); setError(''); }} sx={{ textTransform: 'none', fontSize: 11.5, flexShrink: 0 }}>
                  {t('ai.switchToPaste', 'Use my own AI instead')}
                </Button>
              </Box>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Button
                variant="contained"
                disabled={generating || topic.trim().length < 3}
                onClick={handleGenerate}
                sx={{ textTransform: 'none', px: 3 }}
                startIcon={generating ? <CircularProgress size={14} color="inherit" /> : <SmartToyIcon sx={{ fontSize: 16 }} />}
              >
                {generating ? t('ai.generating', 'Generating…') : t('ai.generateBtn', 'Generate board')}
              </Button>
              {generating && (
                <Button size="small" onClick={() => genAbort.current?.abort()} sx={{ textTransform: 'none', color: 'text.secondary' }}>
                  {t('ai.cancel', 'Cancel')}
                </Button>
              )}
              {generating && genPhase && (
                <Typography fontSize={12} color="text.secondary">{genPhase}</Typography>
              )}
            </Box>
          </Box>
        )}

        {mode === 'paste' && (
          <>
            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  1. {t('ai.promptLabel', 'Copy this prompt to your LLM')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Button size="small" onClick={() => setShowPrompt(s => !s)} sx={{ textTransform: 'none', color: 'text.secondary' }}
                    endIcon={<ExpandMoreIcon sx={{ transition: 'transform 0.2s', transform: showPrompt ? 'rotate(180deg)' : 'none', fontSize: 16 }} />}>
                    {showPrompt ? t('ai.hidePrompt', 'Hide') : t('ai.showPrompt', 'Show')}
                  </Button>
                  <Button size="small" startIcon={copiedPrompt ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />} onClick={handleCopyPrompt} sx={{ textTransform: 'none', minWidth: 90 }}>
                    {copiedPrompt ? t('ai.copied', 'Copied') : t('ai.copy', 'Copy')}
                  </Button>
                </Box>
              </Box>
              {showPrompt && (
                <Box sx={{ position: 'relative', borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.02)', maxHeight: 240, overflow: 'auto' }}>
                  <Typography component="pre" sx={{ p: 1.5, fontFamily: 'monospace', fontSize: 11, lineHeight: 1.5, color: 'text.secondary', m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {systemPrompt}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
                2. {t('ai.xmlLabel', 'Paste the XML from your LLM')}
              </Typography>
              <TextField
                label={t('ai.attributionLabel', 'Which AI generated this? (required)')}
                placeholder={t('ai.attributionPlaceholder', 'e.g. Claude Opus 4.7, GPT-4o, Gemini 2.0 Flash')}
                value={attribution}
                onChange={(e) => setAttribution(e.target.value.slice(0, 80))}
                fullWidth
                size="small"
                inputProps={{ maxLength: 80 }}
                sx={{ mb: 0.8 }}
                disabled={submitting}
              />
              <Box sx={{ display: 'flex', gap: 0.6, flexWrap: 'wrap', mb: 1.5 }}>
                {['ChatGPT', 'Claude', 'Gemini', 'Copilot', 'Perplexity', 'Mistral'].map(name => (
                  <Chip key={name} label={name} size="small" variant={attribution === name ? 'filled' : 'outlined'}
                    onClick={() => setAttribution(name)} disabled={submitting} sx={{ fontSize: 11, cursor: 'pointer' }} />
                ))}
              </Box>
              <TextField
                label={t('ai.pasteLabel', 'LLM reply (XML is extracted automatically)')}
                value={rawInput}
                onChange={(e) => setRawInput(e.target.value)}
                fullWidth
                multiline
                rows={12}
                placeholder={'<source-chain name="...">\n  <source type="book" order="1">\n    ...\n  </source>\n</source-chain>'}
                inputProps={{ style: { fontFamily: 'monospace', fontSize: 12 } }}
                sx={{ mb: 1 }}
                disabled={submitting}
              />
              {wasExtracted && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 1 }}>
                  <CheckIcon sx={{ fontSize: 14, color: '#10b981' }} />
                  <Typography fontSize={11} color="text.secondary">
                    {t('ai.extracted', 'Found the XML inside your paste — surrounding text and code fences will be ignored.')}
                  </Typography>
                </Box>
              )}
              {repaired.fixes.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 1 }}>
                  <CheckIcon sx={{ fontSize: 14, color: '#10b981' }} />
                  <Typography fontSize={11} color="text.secondary">
                    {t('ai.repaired', 'Auto-fixed before validating:')} {repaired.fixes.join(', ')}.
                  </Typography>
                </Box>
              )}

              {check && (
                <Box sx={{ mb: 1.5, p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: check.ok ? 'rgba(16,185,129,0.4)' : 'rgba(239,68,68,0.4)', bgcolor: isDark ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.02)' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: check.errors.length + check.warnings.length + check.sources.length > 0 ? 1 : 0 }}>
                    {check.ok
                      ? <CheckIcon sx={{ fontSize: 16, color: '#10b981' }} />
                      : <WarningIcon sx={{ fontSize: 16, color: '#ef4444' }} />}
                    <Typography fontSize={12} fontWeight={600}>
                      {check.ok
                        ? t('ai.validOk', `Valid ${check.mode === 'tree' ? 'source tree' : 'source chain'}`) + (check.name ? ` — “${check.name}”` : '')
                        : t('ai.validFail', 'The XML has problems:')}
                    </Typography>
                  </Box>
                  {check.errors.map((er, i) => (
                    <Typography key={`e${i}`} fontSize={11.5} color="error" sx={{ lineHeight: 1.6, pl: 3 }}>• {er}</Typography>
                  ))}
                  {check.warnings.map((w, i) => (
                    <Typography key={`w${i}`} fontSize={11.5} sx={{ lineHeight: 1.6, pl: 3, color: '#f59e0b' }}>• {w}</Typography>
                  ))}
                  {check.sources.length > 0 && (
                    <Box sx={{ display: 'flex', gap: 0.6, flexWrap: 'wrap', mt: 1 }}>
                      {check.sources.map((s, i) => (
                        <Chip key={i} size="small" variant="outlined"
                          label={`${s.order}. ${s.type || '?'}${s.title ? ` — ${s.title.slice(0, 40)}${s.title.length > 40 ? '…' : ''}` : ''}`}
                          sx={{ fontSize: 10.5, borderColor: s.knownType ? 'divider' : 'rgba(239,68,68,0.5)' }} />
                      ))}
                    </Box>
                  )}
                </Box>
              )}

              {error && mode === 'paste' && (
                <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '6px', bgcolor: isDark ? 'rgba(239,68,68,0.1)' : 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)' }}>
                  <Typography fontSize={12} color="error" sx={{ lineHeight: 1.5 }}>{error}</Typography>
                </Box>
              )}
              <Button
                variant="contained"
                disabled={submitting || !attribution.trim() || !check || !check.ok}
                onClick={handleSubmit}
                sx={{ textTransform: 'none', px: 3 }}
                startIcon={submitting ? <CircularProgress size={14} color="inherit" /> : <SmartToyIcon sx={{ fontSize: 16 }} />}
              >
                {submitting ? t('ai.creating', 'Creating…') : t('ai.create', 'Create board')}
              </Button>
            </Box>
          </>
        )}

        {result && (
          <Box sx={{ mb: 3, p: 2, borderRadius: '8px', bgcolor: isDark ? 'rgba(16,185,129,0.1)' : 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.3)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <CheckIcon sx={{ fontSize: 18, color: '#10b981' }} />
              <Typography fontWeight={600}>{t('ai.successTitle', 'Board created')}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
              <Typography component="code" sx={{ flex: 1, p: 0.8, borderRadius: '4px', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.05)', fontFamily: 'monospace', fontSize: 12, overflow: 'auto', whiteSpace: 'nowrap' }}>
              {result.publicUrl}
              </Typography>
              <Button size="small" startIcon={copiedUrl ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />} onClick={handleCopyUrl} sx={{ textTransform: 'none', minWidth: 90 }}>
                {copiedUrl ? t('ai.copied', 'Copied') : t('ai.copy', 'Copy')}
              </Button>
              <Button size="small" variant="contained" onClick={() => onOpenBoard(result.boardId)} sx={{ textTransform: 'none' }}>
                {t('ai.openBoard', 'Open board')}
              </Button>
            </Box>
            <Typography fontSize={11} color="text.secondary" sx={{ mt: 1, lineHeight: 1.5 }}>
              {t('ai.successHint', 'Sign in and click "claim" on the board to keep it permanently. Unclaimed AI boards are deleted after 90 days.')}
            </Typography>
          </Box>
        )}
        <Box sx={{ mt: 4 }}>
          <Button
            fullWidth
            onClick={() => setShowDevDocs(s => !s)}
            sx={{ justifyContent: 'space-between', textTransform: 'none', py: 1.2, px: 1.5, borderRadius: '6px', border: '1px solid', borderColor: 'divider' }}
            endIcon={<ExpandMoreIcon sx={{ transition: 'transform 0.2s', transform: showDevDocs ? 'rotate(180deg)' : 'none' }} />}
          >
            <Typography fontSize={13} fontWeight={600}>{t('ai.devDocs', 'Developer docs — API reference')}</Typography>
          </Button>
          {showDevDocs && (
            <Box sx={{ mt: 1, p: 2, borderRadius: '6px', border: '1px solid', borderColor: 'divider' }}>
              <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ display: 'block', mb: 0.6 }}>POST {origin}/api/public/boards</Typography>
              <Typography fontSize={12} color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.6 }}>
                Accepts the same XML format the Code panel exports. No auth required. Rate-limited per IP (5/hour, 50/day by default). 32 KB body cap, max 50 sources per chain.
              </Typography>

              <Typography fontWeight={600} fontSize={12} sx={{ mb: 0.5 }}>Curl (raw XML)</Typography>
              <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '4px', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)', fontFamily: 'monospace', fontSize: 11, whiteSpace: 'pre-wrap', wordBreak: 'break-all', color: 'text.secondary' }}>
                {curlExample}
              </Box>

              <Typography fontWeight={600} fontSize={12} sx={{ mb: 0.5 }}>JSON envelope variant</Typography>
              <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '4px', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)', fontFamily: 'monospace', fontSize: 11, whiteSpace: 'pre-wrap', color: 'text.secondary' }}>
                {`POST ${origin}/api/public/boards
Content-Type: application/json

{ "xml": "<source-chain>...</source-chain>",
  "aiAttribution": "Claude Opus 4.7" }`}
              </Box>

              <Typography fontWeight={600} fontSize={12} sx={{ mb: 0.5 }}>Response (200 OK)</Typography>
              <Box sx={{ p: 1.2, mb: 1.5, borderRadius: '4px', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)', fontFamily: 'monospace', fontSize: 11, whiteSpace: 'pre-wrap', color: 'text.secondary' }}>
                {`{ "ok": true,
  "boardId": "ABCDEFGHJK",
  "publicUrl": "${origin}/?board=ABCDEFGHJK",
  "expiresAt": "2026-08-19T...",
  "sourceCount": 3,
  "appMode": "single" }`}
              </Box>

              <Typography fontWeight={600} fontSize={12} sx={{ mb: 0.5 }}>Source types & field tags</Typography>
              <Box sx={{ p: 1.2, borderRadius: '4px', bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)', fontFamily: 'monospace', fontSize: 11, lineHeight: 1.7, color: 'text.secondary' }}>
                <div><b>book</b>: title, author, publisher, year, isbn, pages, language, subject, edition, translator, originalYear</div>
                <div><b>scientific</b>: title, authors, journal, volume, doi, date, field, method, abstract, url, pages, retractionStatus</div>
                <div><b>film</b>: title, director, year, runtime, genre, plot, cast, rating</div>
                <div><b>website</b>: title, site, url, accessed, author, published, contentType, language, archivedUrl</div>
                <div><b>article</b>: title, author, journal, date, doi, volume, pages, url, archivedUrl</div>
                <div><b>essay</b>: title, author, subject, teacher, school, date, gradeLevel, language, url, abstract</div>
                <div><b>video</b>: title, creator, platform, duration, date, url, description, language, archivedUrl</div>
                <div><b>statement</b>: claim, claimant, role, date, medium, location, recordedBy, attribution, witnesses, transcriptUrl</div>
                <div><b>event</b>: title, location, dateFrom, dateTo, eventType, impact, parties, description, witnesses, confirmedBy</div>
                <div style={{ marginTop: 6 }}><b>Also accepted</b>: archive, dataset, email, encyclopedia, facebook, government, image, interview, legal, manual, map, medical, music, newspaper, patent, podcast, report, speech, statistics, thesis, tiktok, twitter, youtube — unknown field tags are packed into free slots. <b>Aliases</b>: scientific_paper→scientific, web_archive→archive, testimony→statement.</div>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const CreateSourcePage: React.FC<{ onSelect: (mode: AppMode) => void; onClose: () => void; isDark: boolean }> = ({ onSelect, onClose, isDark }) => {
  const { t } = useTranslation();
  return (
  <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
    <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
      <IconButton onClick={onClose} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
      <Typography fontWeight={700} fontSize={18}>{t('dash.newBoard', 'Create New Source')}</Typography>
    </Box>

    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', px: 4 }}>
      <Box sx={{ maxWidth: 800, width: '100%' }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography fontSize={24} fontWeight={700} sx={{ mb: 1 }}>Choose your source structure</Typography>
          <Typography color="text.secondary" fontSize={14}>Select how you want to organize your sources for this project</Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
          <Card 
            onClick={() => onSelect('single')}
            sx={{ 
              width: 340, cursor: 'pointer', transition: 'all 0.2s', 
              border: '2px solid', borderColor: 'divider',
              '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, borderColor: '#3b82f6' }
            }}>
            <CardActionArea sx={{ p: 3, height: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Box sx={{ 
                  width: 56, height: 56, borderRadius: '14px', 
                  bgcolor: isDark ? 'rgba(59,130,246,0.15)' : 'rgba(59,130,246,0.1)', 
                  display: 'flex', alignItems: 'center', justifyContent: 'center' 
                }}>
                  <ViewStreamIcon sx={{ fontSize: 28, color: '#3b82f6' }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={18}>{t('mode.chain.title', 'Source Chain')}</Typography>
                  <Typography fontSize={12} color="text.secondary">Linear reference tracking</Typography>
                </Box>
              </Box>
              <Typography color="text.secondary" sx={{ fontSize: 13, lineHeight: 1.7, mb: 2 }}>
                {t('mode.chain.desc', 'Build a sequential chain of sources where each one references the next. Perfect for tracking citation trails and provenance.')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                {['Sequential', 'Citation trail', 'Provenance'].map(tag => (
                  <Chip key={tag} label={tag} size="small" sx={{ fontSize: 10, height: 22, bgcolor: isDark ? 'rgba(59,130,246,0.12)' : 'rgba(59,130,246,0.08)', color: '#3b82f6', fontWeight: 600 }} />
                ))}
              </Box>
            </CardActionArea>
          </Card>

          <Card 
            onClick={() => onSelect('tree')}
            sx={{ 
              width: 340, position: 'relative', overflow: 'visible',
              cursor: 'pointer', transition: 'all 0.2s', 
              border: '2px solid', borderColor: 'divider',
              '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, borderColor: '#10b981' }
            }}>
            <Box sx={{ position: 'absolute', top: -8, right: 12, bgcolor: '#f59e0b', color: '#fff', fontSize: 10, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', px: 1, py: 0.3, borderRadius: '4px', boxShadow: 1, zIndex: 1 }}>Beta</Box>
            <CardActionArea sx={{ p: 3, height: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Box sx={{ 
                  width: 56, height: 56, borderRadius: '14px', 
                  bgcolor: isDark ? 'rgba(16,185,129,0.15)' : 'rgba(16,185,129,0.1)', 
                  display: 'flex', alignItems: 'center', justifyContent: 'center' 
                }}>
                  <AccountTreeIcon sx={{ fontSize: 28, color: '#10b981' }} />
                </Box>
                <Box>
                  <Typography fontWeight={700} fontSize={18}>{t('mode.tree.title', 'Source Tree')}</Typography>
                  <Typography fontSize={12} color="text.secondary">Hierarchical organization</Typography>
                </Box>
              </Box>
              <Typography color="text.secondary" sx={{ fontSize: 13, lineHeight: 1.7, mb: 2 }}>
                {t('mode.tree.desc', 'Start with a central topic and branch into categories. Each branch can hold multiple related sources — ideal for research projects.')}
              </Typography>
              <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                {['Branching', 'Categories', 'Multi-source'].map(tag => (
                  <Chip key={tag} label={tag} size="small" sx={{ fontSize: 10, height: 22, bgcolor: isDark ? 'rgba(16,185,129,0.12)' : 'rgba(16,185,129,0.08)', color: '#10b981', fontWeight: 600 }} />
                ))}
              </Box>
            </CardActionArea>
          </Card>
        </Box>
      </Box>
    </Box>
  </Box>
  );
};

// ▓▓▓▓▓ HELP & WARNING DIALOGS ▓▓▓▓▓
const HelpDialog: React.FC<{ open: boolean; onClose: () => void; isDark: boolean }> = ({ open, onClose, isDark }) => {
  const sections = [
    { icon: <DashboardIcon sx={{ fontSize: 20 }} />, title: 'Source Board', color: '#3b82f6',
      text: 'Each board has a prefixed ID (b-XXXXXXX). URL formats: /b-xxx/ overview · /b-xxx/c-xxx/ chain · /b-xxx/c-xxx/s-xxx/ zoom to source. IDs exclude ambiguous chars (0, O, 1, L).' },
    { icon: <ViewStreamIcon sx={{ fontSize: 20 }} />, title: 'Source Box', color: '#8b5cf6',
      text: 'Each box represents one source — book, article, video, etc. Tabs at the bottom let you view summary, info, references, trust rating, citation, and file attachments.' },
    { icon: <LinkIcon sx={{ fontSize: 20 }} />, title: 'Source Chain', color: '#10b981',
      text: 'Connect sources in sequence: Primary → 2nd → 3rd → Foundation. The last source is your most authoritative. Connection lines link source boxes together.' },
    { icon: <BookmarkIcon sx={{ fontSize: 20 }} />, title: 'Reference Pointer', color: '#64748b',
      text: 'Mark exactly where in a source you are referencing. For books: page numbers. For video or film: timestamps via the time slider.' },
    { icon: <AccountTreeIcon sx={{ fontSize: 20 }} />, title: 'Source Tree', color: '#06b6d4',
      text: 'Organize sources hierarchically with a seed node at the top and reference branches below. Each branch can hold multiple sources linked in a chain to a specific reference point.' },
    { icon: <CodeIcon sx={{ fontSize: 20 }} />, title: 'Code Import / Export', color: '#64748b',
      text: 'Export your board as XML or paste AI-generated code to create sources. Use the Code tab on the right side of the canvas.' },
  ];
  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0.5 }}>
        <Typography fontWeight={700} fontSize={17}>How it works</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: '4px !important' }}>
        {sections.map(({ icon, title, color, text }, i) => (
          <Box key={title} sx={{ display: 'flex', gap: 1.5, py: 1.5, borderBottom: i < sections.length - 1 ? '1px solid' : 'none', borderColor: 'divider' }}>
            <Box sx={{ width: 36, height: 36, borderRadius: '8px', bgcolor: isDark ? `${color}18` : `${color}10`, display: 'flex', alignItems: 'center', justifyContent: 'center', color, flexShrink: 0, mt: 0.2 }}>{icon}</Box>
            <Box>
              <Typography fontSize={13} fontWeight={600} sx={{ mb: 0.2 }}>{title}</Typography>
              <Typography fontSize={12} color="text.secondary" lineHeight={1.55}>{text}</Typography>
            </Box>
          </Box>
        ))}
        <Box sx={{ mt: 1.5, p: 1.5, borderRadius: '8px', bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', border: '1px solid', borderColor: 'divider' }}>
          <Typography fontSize={11} fontWeight={600} sx={{ mb: 0.5 }}>Code tags</Typography>
          <Typography fontSize={11} color="text.secondary" fontFamily="monospace" lineHeight={1.8} component="div">
            {'<source-tree name="..."> · <source type="book"> · <field name="title">...</field> · <ref from="..." to="..."> · <chain>'}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const WarningDialog: React.FC<{ open: boolean; onClose: () => void; message: string }> = ({ open, onClose, message }) => (
  <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><WarningIcon color="warning" /><Typography fontWeight={600}>Warning</Typography></Box></DialogTitle>
    <DialogContent><Typography>{message}</Typography></DialogContent>
    <DialogActions><Button variant="contained" onClick={onClose}>OK</Button></DialogActions>
  </Dialog>
);


// ▓▓▓▓▓ SETTINGS PAGE & DIALOGS ▓▓▓▓▓
const SettingsPage: React.FC<{
  isDark: boolean; onToggleDark: () => void; onBack: () => void; settings: AppSettings; onSave: (s: AppSettings) => void;
  user: User; onUsernameChange: (name: string) => void; setSnackbar: (s: any) => void;
}> = ({ isDark, onToggleDark, onBack, settings, onSave, user, onUsernameChange, setSnackbar }) => {
  const { t } = useTranslation();
  const [local, setLocal] = useState<AppSettings>(settings);
  const [editUsername, setEditUsername] = useState(user.username);
  useEffect(() => { setLocal(settings); setEditUsername(user.username); }, [settings, user.username]);

  const handleSave = () => {
    onSave(local);
    if (editUsername !== user.username) onUsernameChange(editUsername);
    setSnackbar({ open: true, message: t('settings.saved', 'Settings saved') });
  };

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
        <SettingsIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
        <Typography fontWeight={700} fontSize={18}>{t('settings.title', 'Settings')}</Typography>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: 600, p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('settings.section.profile', 'Profile')}</Typography>
            <TextField fullWidth label={t('settings.username', 'Username')} value={editUsername} size="small" helperText="Your unique sourceio username (cannot be changed)" InputProps={{ readOnly: true }} sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }} />
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('settings.section.language', 'Language')}</Typography>
            <TextField select fullWidth label={t('settings.language.label', 'Interface language')} value={local.language || 'en'}
              onChange={(e) => setLocal({ ...local, language: e.target.value })} size="small">
              {SUPPORTED_LANGUAGES.map(code => (
                <MenuItem key={code} value={code}>{LANGUAGE_LABELS[code]}</MenuItem>
              ))}
            </TextField>
            <Typography fontSize={11} color="text.disabled" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              Untranslated strings fall back to English. Languages other than English may be partially translated.
            </Typography>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Date & Time</Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField select fullWidth label="Timezone" value={local.timezone} onChange={(e) => setLocal({ ...local, timezone: e.target.value })} size="small" SelectProps={{ MenuProps: { disableScrollLock: true, PaperProps: { sx: { maxHeight: 300 } } } }}>
                {TIMEZONES.map(tz => <MenuItem key={tz} value={tz}>{formatTzLabel(tz)}</MenuItem>)}
              </TextField>
              <TextField select fullWidth label="Date Format" value={local.dateFormat} onChange={(e) => setLocal({ ...local, dateFormat: e.target.value as AppSettings['dateFormat'] })} size="small">
                <MenuItem value="YYYY-MM-DD">2026-02-19</MenuItem>
                <MenuItem value="DD/MM/YYYY">19/02/2026</MenuItem>
                <MenuItem value="MM/DD/YYYY">02/19/2026</MenuItem>
                <MenuItem value="DD.MM.YYYY">19.02.2026</MenuItem>
              </TextField>
              <TextField select label="Time Format" value={local.timeFormat} onChange={(e) => setLocal({ ...local, timeFormat: e.target.value as '24h' | '12h' })} size="small" sx={{ minWidth: 130 }}>
                <MenuItem value="24h">24h (14:30)</MenuItem>
                <MenuItem value="12h">12h (2:30 PM)</MenuItem>
              </TextField>
            </Box>
            <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.5 }}>
              Preview: {formatTimestamp(new Date().toISOString(), local as AppSettings)}
            </Typography>
            <Typography fontSize={10} color="text.disabled" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              All times are stored in UTC and displayed in your selected timezone. When adding dates to sources (e.g. events), enter your local time — it will be shown correctly to other users based on their timezone settings.
            </Typography>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Citations</Typography>
            <TextField select fullWidth label="Default Citation Format" value={local.defaultCiteFormat} onChange={(e) => setLocal({ ...local, defaultCiteFormat: e.target.value as AppSettings['defaultCiteFormat'] })} size="small">
              <MenuItem value="apa">APA (7th Edition)</MenuItem><MenuItem value="harvard">Harvard</MenuItem><MenuItem value="mla">MLA (9th Edition)</MenuItem><MenuItem value="chicago">Chicago (17th Edition)</MenuItem><MenuItem value="vancouver">Vancouver</MenuItem>
            </TextField>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Trust scoring</Typography>
            <Box sx={{ p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography fontSize={13} fontWeight={500}>Source ↔ Reference weight</Typography>
                <Typography fontSize={11} color="text.disabled" sx={{ fontFamily: 'monospace' }}>
                  Source {local.trustSourceWeight ?? 50}% · Reference {100 - (local.trustSourceWeight ?? 50)}%
                </Typography>
              </Box>
              <Typography fontSize={11} color="text.secondary" sx={{ mb: 1 }}>
                Adjusts how the combined Trust score is calculated. Default 50/50 weights both halves equally; shift toward Source if you care more about the work itself, toward Reference if the cited part matters more.
              </Typography>
              <Box sx={{ px: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography fontSize={10} color="text.secondary" sx={{ minWidth: 50, textAlign: 'right' }}>Reference</Typography>
                <Slider
                  value={local.trustSourceWeight ?? 50}
                  min={0} max={100} step={5}
                  marks={[{ value: 0, label: '0' }, { value: 25, label: '25' }, { value: 50, label: '50' }, { value: 75, label: '75' }, { value: 100, label: '100' }]}
                  valueLabelDisplay="auto"
                  onChange={(_, v) => setLocal({ ...local, trustSourceWeight: v as number })}
                  sx={{ flex: 1, '& .MuiSlider-markLabel': { fontSize: 10 } }}
                />
                <Typography fontSize={10} color="text.secondary" sx={{ minWidth: 50 }}>Source</Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Display</Typography>
            <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
              <TextField label="Default Zoom (%)" type="number" value={local.defaultZoom} onChange={(e) => setLocal({ ...local, defaultZoom: Math.max(25, Math.min(200, Number(e.target.value))) })} size="small" inputProps={{ min: 25, max: 200, step: 5 }} sx={{ width: 160 }} />
              <TextField select label="Language" value={local.language} onChange={(e) => setLocal({ ...local, language: e.target.value })} size="small" sx={{ width: 160 }}>
                <MenuItem value="en">English</MenuItem><MenuItem value="sv">Svenska</MenuItem><MenuItem value="de">Deutsch</MenuItem><MenuItem value="fr">Français</MenuItem><MenuItem value="es">Español</MenuItem><MenuItem value="ar">العربية</MenuItem>
              </TextField>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.8 }}>
              <Box><Typography fontSize={13} fontWeight={500}>Dark Mode</Typography><Typography fontSize={11} color="text.secondary">Toggle dark / light canvas theme</Typography></Box>
              <Box component="label" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input type="checkbox" checked={isDark} onChange={onToggleDark} style={{ width: 16, height: 16, accentColor: '#0891b2' }} />
              </Box>
            </Box>
            <Divider />
            {[
              { key: 'showGrid', label: 'Show Grid', desc: 'Display background grid on canvas' },
              { key: 'snapToGrid', label: 'Snap to Grid', desc: 'Snap source positions to grid when dragging' },
              { key: 'autoSave', label: 'Auto-save', desc: 'Automatically save board changes' },
            ].map(opt => (
              <React.Fragment key={opt.key}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.8 }}>
                  <Box><Typography fontSize={13} fontWeight={500}>{opt.label}</Typography><Typography fontSize={11} color="text.secondary">{opt.desc}</Typography></Box>
                  <Box component="label" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input type="checkbox" checked={(local as any)[opt.key]} onChange={(e) => setLocal({ ...local, [opt.key]: e.target.checked })} style={{ width: 16, height: 16, accentColor: '#0891b2' }} />
                  </Box>
                </Box>
                <Divider />
              </React.Fragment>
            ))}
          </Box>
          <Button variant="contained" onClick={handleSave} sx={{ alignSelf: 'flex-start', fontWeight: 600, px: 4 }}>{t('common.save', 'Save Settings')}</Button>
        </Box>
      </Box>
    </Box>
  );
};

const SettingsDialog: React.FC<{
  open: boolean; onClose: () => void; settings: AppSettings; onSave: (s: AppSettings) => void;
  user: User; onUsernameChange: (name: string) => void; setSnackbar: (s: any) => void;
}> = ({ open, onClose, settings, onSave, user, onUsernameChange, setSnackbar }) => {
  const [local, setLocal] = useState<AppSettings>(settings);
  const [editUsername, setEditUsername] = useState(user.username);
  React.useEffect(() => { if (open) { setLocal(settings); setEditUsername(user.username); } }, [open, settings, user.username]);
  const { t } = useTranslation();

  const handleSave = () => {
    onSave(local);
    if (editUsername !== user.username) onUsernameChange(editUsername);
    setSnackbar({ open: true, message: t('settings.saved', 'Settings saved') });
    onClose();
  };

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SettingsIcon sx={{ fontSize: 20 }} />
          <Typography fontWeight={700} fontSize={16}>{t('settings.title', 'Settings')}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small"><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('settings.section.profile', 'Profile')}</Typography>
          <TextField fullWidth label={t('settings.username', 'Username')} value={editUsername} size="small" helperText="Your unique sourceio username (cannot be changed)" InputProps={{ readOnly: true }} sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }} />
        </Box>

        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('settings.section.language', 'Language')}</Typography>
          <TextField select fullWidth label={t('settings.language.label', 'Interface language')} value={local.language || 'en'}
            onChange={(e) => setLocal({ ...local, language: e.target.value })} size="small">
            {SUPPORTED_LANGUAGES.map(code => (
              <MenuItem key={code} value={code}>{LANGUAGE_LABELS[code]}</MenuItem>
            ))}
          </TextField>
          <Typography fontSize={11} color="text.disabled" sx={{ mt: 0.5, fontStyle: 'italic' }}>
            Untranslated strings fall back to English. Languages other than English may be partially translated.
          </Typography>
        </Box>

        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('settings.section.dateTime', 'Date & Time')}</Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField select fullWidth label="Timezone" value={local.timezone} onChange={(e) => setLocal({ ...local, timezone: e.target.value })} size="small" SelectProps={{ MenuProps: { disableScrollLock: true, PaperProps: { sx: { maxHeight: 300 } } } }}>
              {TIMEZONES.map(tz => <MenuItem key={tz} value={tz}>{formatTzLabel(tz)}</MenuItem>)}
            </TextField>
            <TextField select fullWidth label="Date Format" value={local.dateFormat} onChange={(e) => setLocal({ ...local, dateFormat: e.target.value as AppSettings['dateFormat'] })} size="small">
              <MenuItem value="YYYY-MM-DD">2026-02-19</MenuItem>
              <MenuItem value="DD/MM/YYYY">19/02/2026</MenuItem>
              <MenuItem value="MM/DD/YYYY">02/19/2026</MenuItem>
              <MenuItem value="DD.MM.YYYY">19.02.2026</MenuItem>
            </TextField>
            <TextField select label="Time Format" value={local.timeFormat} onChange={(e) => setLocal({ ...local, timeFormat: e.target.value as '24h' | '12h' })} size="small" sx={{ minWidth: 130 }}>
              <MenuItem value="24h">24h (14:30)</MenuItem>
              <MenuItem value="12h">12h (2:30 PM)</MenuItem>
            </TextField>
          </Box>
          <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.5 }}>
            Preview: {formatTimestamp(new Date().toISOString(), local as AppSettings)}
          </Typography>
          <Typography fontSize={10} color="text.disabled" sx={{ mt: 0.5, fontStyle: 'italic' }}>
            All times are stored in UTC and displayed in your selected timezone. When adding dates to sources, enter your local time — it will be shown correctly to other users based on their settings.
          </Typography>
        </Box>
        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Citations</Typography>
          <TextField select fullWidth label="Default Citation Format" value={local.defaultCiteFormat} onChange={(e) => setLocal({ ...local, defaultCiteFormat: e.target.value as AppSettings['defaultCiteFormat'] })} size="small">
            <MenuItem value="apa">APA (7th Edition)</MenuItem>
            <MenuItem value="harvard">Harvard</MenuItem>
            <MenuItem value="mla">MLA (9th Edition)</MenuItem>
            <MenuItem value="chicago">Chicago (17th Edition)</MenuItem>
            <MenuItem value="vancouver">Vancouver</MenuItem>
          </TextField>
        </Box>

        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Trust scoring</Typography>
          <Box sx={{ p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography fontSize={13} fontWeight={500}>Source ↔ Reference weight</Typography>
              <Typography fontSize={11} color="text.disabled" sx={{ fontFamily: 'monospace' }}>
                Source {local.trustSourceWeight ?? 50}% · Reference {100 - (local.trustSourceWeight ?? 50)}%
              </Typography>
            </Box>
            <Typography fontSize={11} color="text.secondary" sx={{ mb: 1 }}>
              Adjusts how the combined Trust score is calculated. Default 50/50 weights both halves equally; shift toward Source if you care more about the work itself, toward Reference if the cited part matters more.
            </Typography>
            <Box sx={{ px: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography fontSize={10} color="text.secondary" sx={{ minWidth: 50, textAlign: 'right' }}>Reference</Typography>
              <Slider
                value={local.trustSourceWeight ?? 50}
                min={0} max={100} step={5}
                marks={[{ value: 0, label: '0' }, { value: 25, label: '25' }, { value: 50, label: '50' }, { value: 75, label: '75' }, { value: 100, label: '100' }]}
                valueLabelDisplay="auto"
                onChange={(_, v) => setLocal({ ...local, trustSourceWeight: v as number })}
                sx={{ flex: 1, '& .MuiSlider-markLabel': { fontSize: 10 } }}
              />
              <Typography fontSize={10} color="text.secondary" sx={{ minWidth: 50 }}>Source</Typography>
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography fontWeight={700} fontSize={13} sx={{ mb: 1.5, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Display</Typography>
          <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
            <TextField label="Default Zoom (%)" type="number" value={local.defaultZoom} onChange={(e) => setLocal({ ...local, defaultZoom: Math.max(25, Math.min(200, Number(e.target.value))) })} size="small" inputProps={{ min: 25, max: 200, step: 5 }} sx={{ width: 160 }} />
            <TextField select label="Language" value={local.language} onChange={(e) => setLocal({ ...local, language: e.target.value })} size="small" sx={{ width: 160 }}>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="sv">Svenska</MenuItem>
              <MenuItem value="de">Deutsch</MenuItem>
              <MenuItem value="fr">Français</MenuItem>
              <MenuItem value="es">Español</MenuItem>
              <MenuItem value="ar">العربية</MenuItem>
            </TextField>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
              <Box>
                <Typography fontSize={13} fontWeight={500}>Show Grid</Typography>
                <Typography fontSize={11} color="text.secondary">Display background grid on canvas</Typography>
              </Box>
              <Box component="label" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input type="checkbox" checked={local.showGrid} onChange={(e) => setLocal({ ...local, showGrid: e.target.checked })} style={{ width: 16, height: 16, accentColor: '#0891b2' }} />
              </Box>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
              <Box>
                <Typography fontSize={13} fontWeight={500}>Snap to Grid</Typography>
                <Typography fontSize={11} color="text.secondary">Snap source positions to grid when dragging</Typography>
              </Box>
              <Box component="label" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input type="checkbox" checked={local.snapToGrid} onChange={(e) => setLocal({ ...local, snapToGrid: e.target.checked })} style={{ width: 16, height: 16, accentColor: '#0891b2' }} />
              </Box>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5 }}>
              <Box>
                <Typography fontSize={13} fontWeight={500}>Auto-save</Typography>
                <Typography fontSize={11} color="text.secondary">Automatically save board changes</Typography>
              </Box>
              <Box component="label" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input type="checkbox" checked={local.autoSave} onChange={(e) => setLocal({ ...local, autoSave: e.target.checked })} style={{ width: 16, height: 16, accentColor: '#0891b2' }} />
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose} color="inherit" sx={{ fontWeight: 500 }}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} sx={{ fontWeight: 600, px: 3 }}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

const SettingsDialogFull: React.FC<{
  open: boolean; onClose: () => void; setSnackbar: (s: any) => void;
  appSettings: AppSettings; onSettingsSave: (s: AppSettings) => void;
}> = ({ open, onClose, setSnackbar, appSettings, onSettingsSave }) => {
  const [localSettings, setLocalSettings] = useState<AppSettings>(appSettings);
  const { t } = useTranslation();

  React.useEffect(() => { if (open) setLocalSettings(appSettings); }, [open, appSettings]);

  const handleSaveSettings = () => {
    onSettingsSave(localSettings);
    setSnackbar({ open: true, message: t('settings.saved', 'Settings saved') });
  };

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SettingsIcon sx={{ fontSize: 22 }} />
          <Typography fontWeight={700} fontSize={16}>{t('settings.title', 'Settings')}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small"><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField select fullWidth label={t('settings.language.label', 'Interface language')} value={localSettings.language || 'en'}
            onChange={(e) => setLocalSettings(s => ({ ...s, language: e.target.value }))} size="small">
            {SUPPORTED_LANGUAGES.map(code => (
              <MenuItem key={code} value={code}>{LANGUAGE_LABELS[code]}</MenuItem>
            ))}
          </TextField>
          <TextField select fullWidth label={t('settings.timezone', 'Timezone')} value={localSettings.timezone} onChange={(e) => setLocalSettings(s => ({ ...s, timezone: e.target.value }))} size="small">
            {TIMEZONES.map(tz => <MenuItem key={tz} value={tz}>{formatTzLabel(tz)}</MenuItem>)}
          </TextField>
          <TextField select fullWidth label="Date Format" value={localSettings.dateFormat} onChange={(e) => setLocalSettings(s => ({ ...s, dateFormat: e.target.value as any }))} size="small">
            <MenuItem value="YYYY-MM-DD">YYYY-MM-DD</MenuItem>
            <MenuItem value="DD/MM/YYYY">DD/MM/YYYY</MenuItem>
            <MenuItem value="MM/DD/YYYY">MM/DD/YYYY</MenuItem>
            <MenuItem value="DD.MM.YYYY">DD.MM.YYYY</MenuItem>
          </TextField>
          <TextField select fullWidth label="Time Format" value={localSettings.timeFormat} onChange={(e) => setLocalSettings(s => ({ ...s, timeFormat: e.target.value as any }))} size="small">
            <MenuItem value="24h">24-hour (14:30)</MenuItem>
            <MenuItem value="12h">12-hour (2:30 PM)</MenuItem>
          </TextField>
          <TextField select fullWidth label="Default Citation Format" value={localSettings.defaultCiteFormat} onChange={(e) => setLocalSettings(s => ({ ...s, defaultCiteFormat: e.target.value as any }))} size="small">
            <MenuItem value="apa">APA</MenuItem><MenuItem value="harvard">Harvard</MenuItem><MenuItem value="mla">MLA</MenuItem><MenuItem value="chicago">Chicago</MenuItem><MenuItem value="vancouver">Vancouver</MenuItem>
          </TextField>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography fontSize={13}>Default Zoom</Typography>
            <Slider value={localSettings.defaultZoom} onChange={(_, v) => setLocalSettings(s => ({ ...s, defaultZoom: v as number }))} min={50} max={200} step={1} sx={{ flex: 1 }} />
            <Typography fontSize={12} fontWeight={600}>{localSettings.defaultZoom}%</Typography>
          </Box>
          <Button variant="contained" onClick={handleSaveSettings} sx={{ alignSelf: 'flex-start', px: 3 }}>{t('settings.saveBtn', 'Save Settings')}</Button>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ▓▓▓▓▓ MY-SOURCES / SHARE / SOURCE-TYPE DIALOGS ▓▓▓▓▓
const MySourcesDialog: React.FC<{ open: boolean; onClose: () => void; sources: SquareData[]; chainEnded: boolean; chainEndReason: string; appMode: AppMode; boardId: string; setSnackbar: (s: any) => void; onDelete: (id: number) => void; isPublic: boolean; onEdit: (sourceId: string) => void; onGoTo: (sourceId: string) => void; readOnly?: boolean; apiHeaders: () => Record<string, string>; onLoadBoard: (boardId: string) => void; isSignedIn: boolean; onDeleteBoard: (boardId: string) => void }> = ({ open, onClose, sources, chainEnded, chainEndReason, appMode, boardId, setSnackbar, onDelete, isPublic, onEdit, onGoTo, readOnly, apiHeaders, onLoadBoard, isSignedIn, onDeleteBoard }) => {
  const [tab, setTab] = useState(0);
  const [search, setSearch] = useState('');
  const [sortCol, setSortCol] = useState<string>('order');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');
  const [deleteTarget, setDeleteTarget] = useState<SquareData | null>(null);
  const [boards, setBoards] = useState<any[]>([]);
  const [loadingBoards, setLoadingBoards] = useState(false);
  const [deleteBoardTarget, setDeleteBoardTarget] = useState<any>(null);

  useEffect(() => {
    if (open && isSignedIn) {
      setLoadingBoards(true);
      fetch(`${API_BASE}/boards`, { headers: apiHeaders() })
        .then(r => r.ok ? r.json() : { boards: [] })
        .then(data => setBoards(data.boards || []))
        .catch(() => setBoards([]))
        .finally(() => setLoadingBoards(false));
    }
  }, [open, isSignedIn, apiHeaders]);

  const handleSort = (col: string) => {
    if (sortCol === col) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const nonMainSources = sources.filter(s => !s.isMainSource);
  const mainSource = sources.find(s => s.isMainSource);
  const isChain = appMode === 'single' && nonMainSources.length > 1;
  const isTree = appMode === 'tree';

  const filterAndSort = (list: SquareData[]) => {
    let filtered = list;
    if (search) {
      const q = search.toLowerCase();
      filtered = list.filter(s => 
        s.sourceId.toLowerCase().includes(q) ||
        (s.sourceType || '').toLowerCase().includes(q) ||
        s.fields.field1.toLowerCase().includes(q) ||
        s.fields.field2.toLowerCase().includes(q)
      );
    }
    return [...filtered].sort((a, b) => {
      let cmp = 0;
      if (sortCol === 'id') cmp = a.sourceId.localeCompare(b.sourceId);
      else if (sortCol === 'type') cmp = (a.sourceType || '').localeCompare(b.sourceType || '');
      else if (sortCol === 'title') cmp = (a.fields.field2 || a.fields.field1 || '').localeCompare(b.fields.field2 || b.fields.field1 || '');
      else if (sortCol === 'order') cmp = a.order - b.order;
      else if (sortCol === 'date') cmp = a.createdAt.localeCompare(b.createdAt);
      return sortDir === 'asc' ? cmp : -cmp;
    });
  };

  const SortHeader: React.FC<{ col: string; label: string }> = ({ col, label }) => (
    <TableCell onClick={() => handleSort(col)} sx={{ cursor: 'pointer', userSelect: 'none', fontWeight: 700, fontSize: 11, '&:hover': { color: 'primary.main' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
        {label}
        {sortCol === col && <Typography fontSize={10}>{sortDir === 'asc' ? '▲' : '▼'}</Typography>}
      </Box>
    </TableCell>
  );

  const CopyIdButton: React.FC<{ id: string }> = ({ id }) => (
    <Chip label={dispId(id)} size="small" onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(dispId(id)); setSnackbar({ open: true, message: `Copied ${dispId(id)}` }); }} icon={<ContentCopyIcon sx={{ fontSize: '12px !important' }} />} sx={{ fontFamily: 'monospace', fontSize: 11, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }} />
  );

  const renderTable = (list: SquareData[], showOrder: boolean) => {
    const sorted = filterAndSort(list);
    return (
      <TableContainer sx={{ flex: 1 }}><Table size="small" stickyHeader><TableHead><TableRow>
        <SortHeader col="id" label="Source ID" />
        <SortHeader col="type" label="Type" />
        <SortHeader col="title" label="Title" />
        {showOrder && <SortHeader col="order" label="Order" />}
        <SortHeader col="date" label="Created" />
        <TableCell sx={{ fontWeight: 700, fontSize: 11, width: 70 }}>Visibility</TableCell>
        <TableCell sx={{ fontWeight: 700, fontSize: 11, width: 100 }}>Actions</TableCell>
      </TableRow></TableHead><TableBody>
        {sorted.length === 0 ? (
          <TableRow><TableCell colSpan={showOrder ? 7 : 6} align="center"><Typography color="text.secondary" fontSize={12} py={3}>No sources found</Typography></TableCell></TableRow>
        ) : sorted.map((s, i) => (
          <TableRow key={s.sourceId} hover>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography component="a" href={`/${dispId(s.sourceId)}`} onClick={(e: React.MouseEvent) => { e.preventDefault(); onGoTo(s.sourceId); onClose(); }} sx={{ fontFamily: 'monospace', fontSize: 11, color: 'primary.main', textDecoration: 'none', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>{dispId(s.sourceId)}</Typography>
                <IconButton size="small" onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(`${window.location.origin}/${dispId(s.sourceId)}`); setSnackbar({ open: true, message: `Link copied` }); }} sx={{ width: 18, height: 18, color: 'text.disabled', '&:hover': { color: 'primary.main' } }}><ContentCopyIcon sx={{ fontSize: 11 }} /></IconButton>
              </Box>
            </TableCell>
            <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: getSourceColor(s.sourceType) }} /><Typography fontSize={12}>{s.sourceType || '-'}</Typography></Box></TableCell>
            <TableCell><Typography fontSize={12} sx={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.fields.field2 || s.fields.field1 || '-'}</Typography></TableCell>
            {showOrder && <TableCell><Typography fontSize={12}>{getOrderLabel(s.order, i === list.length - 1, chainEnded, s.isMainSource, chainEndReason)}</Typography></TableCell>}
            <TableCell><Typography fontSize={11} color="text.secondary">{s.createdAt}</Typography></TableCell>
            <TableCell><Chip size="small" icon={isPublic ? <PublicIcon sx={{ fontSize: '12px !important' }} /> : <LockPersonIcon sx={{ fontSize: '12px !important' }} />} label={isPublic ? 'Public' : 'Private'} sx={{ fontSize: 10, height: 20, bgcolor: isPublic ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: isPublic ? '#10b981' : '#ef4444', '& .MuiChip-icon': { color: 'inherit' } }} /></TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', gap: 0.3 }}>
                <Tooltip title="Go to source"><IconButton size="small" onClick={(e) => { e.stopPropagation(); onGoTo(s.sourceId); onClose(); }} sx={{ width: 24, height: 24, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}><OpenInNewIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                {!readOnly && <Tooltip title="Edit source"><IconButton size="small" onClick={(e) => { e.stopPropagation(); onEdit(s.sourceId); onClose(); }} sx={{ width: 24, height: 24, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}><EditIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>}
                {!readOnly && <Tooltip title="Delete source"><IconButton size="small" onClick={(e) => { e.stopPropagation(); setDeleteTarget(s); }} sx={{ width: 24, height: 24, color: 'text.disabled', '&:hover': { color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 15 }} /></IconButton></Tooltip>}
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody></Table></TableContainer>
    );
  };

  const allSources = sources;
  const chainSources = isChain ? nonMainSources : [];
  const treeSources = isTree ? sources : [];

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="lg" fullWidth PaperProps={{ sx: { minHeight: '60vh' } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <StorageIcon color="primary" sx={{ mr: 1 }} />My Sources
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ px: 2, pt: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0, fontSize: 12 } }}>
            <Tab label={`My Boards${boards.length ? ` (${boards.length})` : ''}`} />
            <Tab label={`All Sources (${allSources.length})`} />
            <Tab label={`Source Chain${isChain ? ` (${chainSources.length})` : ''}`} />
            <Tab label={`Source Tree${isTree ? ` (${treeSources.length})` : ''}`} />
          </Tabs>
          <Box sx={{ flex: 1 }} />
          <TextField size="small" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} InputProps={{ startAdornment: <SearchIcon sx={{ fontSize: 16, mr: 0.5, color: 'text.secondary' }} /> }} sx={{ width: 220, '& .MuiInputBase-root': { height: 32, fontSize: 12 } }} />
        </Box>
        <Divider sx={{ mt: 1 }} />
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {tab === 0 && (
            <>
              {!isSignedIn ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>Login to see your boards.</Typography>
                </Box>
              ) : loadingBoards ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>Loading boards...</Typography>
                </Box>
              ) : boards.length === 0 ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>No boards yet. Create one by selecting a mode.</Typography>
                </Box>
              ) : (
                <TableContainer><Table size="small" stickyHeader><TableHead><TableRow>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Board ID</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Mode</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Sources</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Visibility</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Last Updated</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: 11, width: 80 }}>Actions</TableCell>
                </TableRow></TableHead><TableBody>
                  {boards.filter(b => !search || b.board_id.toLowerCase().includes(search.toLowerCase()) || (b.name || '').toLowerCase().includes(search.toLowerCase())).map(b => (
                    <TableRow key={b.board_id} hover sx={{ cursor: 'pointer', bgcolor: b.board_id === boardId ? 'action.selected' : undefined }} onClick={() => { onLoadBoard(b.board_id); onClose(); }}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography sx={{ fontFamily: 'monospace', fontSize: 11, color: 'primary.main', fontWeight: b.board_id === boardId ? 700 : 400 }}>{dispId(b.board_id)}</Typography>
                          {b.board_id === boardId && <Chip label="current" size="small" sx={{ fontSize: 9, height: 16, bgcolor: 'primary.main', color: '#E3E3DF' }} />}
                        </Box>
                      </TableCell>
                      <TableCell><Typography fontSize={12}>{b.name || 'Untitled'}</Typography></TableCell>
                      <TableCell><Chip size="small" label={b.app_mode === 'single' ? 'Source' : b.app_mode === 'tree' ? 'Tree' : b.app_mode} sx={{ fontSize: 10, height: 20, bgcolor: b.app_mode === 'tree' ? 'rgba(16,185,129,0.1)' : 'rgba(59,130,246,0.1)', color: b.app_mode === 'tree' ? '#10b981' : '#3b82f6' }} /></TableCell>
                      <TableCell><Typography fontSize={12}>{b.source_count || 0}</Typography></TableCell>
                      <TableCell><Chip size="small" icon={b.is_public ? <PublicIcon sx={{ fontSize: '12px !important' }} /> : <LockPersonIcon sx={{ fontSize: '12px !important' }} />} label={b.is_public ? 'Public' : 'Private'} sx={{ fontSize: 10, height: 20, bgcolor: b.is_public ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: b.is_public ? '#10b981' : '#ef4444', '& .MuiChip-icon': { color: 'inherit' } }} /></TableCell>
                      <TableCell><Typography fontSize={11} color="text.secondary">{b.updated_at || ''}</Typography></TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.3 }}>
                          <Tooltip title="Open board"><IconButton size="small" onClick={(e) => { e.stopPropagation(); onLoadBoard(b.board_id); onClose(); }} sx={{ width: 24, height: 24, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}><OpenInNewIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                          <Tooltip title="Delete board"><IconButton size="small" onClick={(e) => { e.stopPropagation(); setDeleteBoardTarget(b); }} sx={{ width: 24, height: 24, color: 'text.disabled', '&:hover': { color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 15 }} /></IconButton></Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody></Table></TableContainer>
              )}
            </>
          )}
          {tab === 1 && (
            <>
              {allSources.length > 0 ? renderTable(allSources, true) : (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>No sources yet. Start by adding a source.</Typography>
                </Box>
              )}
            </>
          )}
          {tab === 2 && (
            <>
              {isChain ? (
                <>
                  <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ViewStreamIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                    <Typography fontSize={12} fontWeight={600}>Chain ID:</Typography>
                    <CopyIdButton id={boardId} />
                    <Typography fontSize={11} color="text.secondary">• {chainSources.length} sources • {chainEnded ? (chainEndReason === 'unknown' ? 'Unknown Origin' : 'Ended') : 'Active'}</Typography>
                  </Box>
                  {renderTable(chainSources, true)}
                </>
              ) : (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>No source chain yet. Add more than one source to create a chain.</Typography>
                </Box>
              )}
            </>
          )}
          {tab === 3 && (
            <>
              {isTree ? (
                <>
                  <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AccountTreeIcon sx={{ fontSize: 16, color: '#10b981' }} />
                    <Typography fontSize={12} fontWeight={600}>Tree ID:</Typography>
                    <CopyIdButton id={boardId} />
                    {mainSource && <><Typography fontSize={11} color="text.secondary">• Main:</Typography><CopyIdButton id={mainSource.sourceId} /></>}
                  </Box>
                  {renderTable(treeSources, false)}
                </>
              ) : (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary" fontSize={13}>No source tree. Start a Source Tree from the mode selection.</Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      <Dialog disableScrollLock open={!!deleteTarget} onClose={() => setDeleteTarget(null)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
        <DialogTitle sx={{ pb: 0.5 }}>
          <Typography fontWeight={600} fontSize={16}>Delete Source</Typography>
        </DialogTitle>
        <DialogContent>
          {deleteTarget && (
            <Box sx={{ mt: 0.5 }}>
              <Typography fontSize={13} color="text.secondary" sx={{ mb: 1.5 }}>Are you sure you want to delete this source? This action cannot be undone.</Typography>
              <Box sx={{ p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: getSourceColor(deleteTarget.sourceType), flexShrink: 0 }} />
                <Box sx={{ minWidth: 0 }}>
                  <Typography fontSize={12} fontWeight={600} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{deleteTarget.fields.field2 || deleteTarget.fields.field1 || 'Untitled'}</Typography>
                  <Typography fontSize={11} color="text.secondary" fontFamily="monospace">{dispId(deleteTarget.sourceId)}</Typography>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={() => setDeleteTarget(null)} color="inherit" sx={{ fontWeight: 500 }}>Cancel</Button>
          <Button variant="contained" color="error" onClick={() => { if (deleteTarget) { onDelete(deleteTarget.id); setDeleteTarget(null); setSnackbar({ open: true, message: 'Source deleted' }); } }} sx={{ fontWeight: 600 }}>Delete</Button>
        </DialogActions>
      </Dialog>
      <Dialog disableScrollLock open={!!deleteBoardTarget} onClose={() => setDeleteBoardTarget(null)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
        <DialogTitle sx={{ pb: 0.5 }}>
          <Typography fontWeight={600} fontSize={16}>Delete Board</Typography>
        </DialogTitle>
        <DialogContent>
          {deleteBoardTarget && (
            <Box sx={{ mt: 0.5 }}>
              <Typography fontSize={13} color="text.secondary" sx={{ mb: 1.5 }}>Delete this board and all its sources? This cannot be undone.</Typography>
              <Box sx={{ p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
                <Typography fontSize={12} fontWeight={600}>{deleteBoardTarget.name || 'Untitled'}</Typography>
                <Typography fontSize={11} color="text.secondary" fontFamily="monospace">{dispId(deleteBoardTarget.board_id || '')}</Typography>
                <Typography fontSize={11} color="text.secondary">{deleteBoardTarget.source_count || 0} sources • {deleteBoardTarget.app_mode}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setDeleteBoardTarget(null)} color="inherit" sx={{ fontWeight: 500 }}>Cancel</Button>
          <Button variant="contained" color="error" onClick={() => { if (deleteBoardTarget) { onDeleteBoard(deleteBoardTarget.board_id); setBoards(prev => prev.filter(b => b.board_id !== deleteBoardTarget.board_id)); setDeleteBoardTarget(null); setSnackbar({ open: true, message: 'Board deleted' }); } }} sx={{ fontWeight: 600 }}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

const ShareDialog: React.FC<{ open: boolean; onClose: () => void; boardId: string; chainId?: string | null; isPublic: boolean; setSnackbar: (s: any) => void }> = ({ open, onClose, boardId, chainId, isPublic, setSnackbar }) => {
  const [copied, setCopied] = useState(false);
  const shareBase = chainId ? dispId(chainId) : dispId(boardId);
  const url = `${window.location.origin}/${shareBase}/`;
  return (<Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '8px' } }}><DialogTitle><ShareIcon color="primary" sx={{ mr: 1 }} />Share</DialogTitle><DialogContent>{!isPublic && <Alert severity="warning" sx={{ mb: 2 }}>Make public to share</Alert>}<Box sx={{ display: 'flex', gap: 1 }}><TextField fullWidth size="small" value={url} InputProps={{ readOnly: true, sx: { fontFamily: 'monospace', fontSize: 12 } }} /><Button variant="contained" onClick={() => { navigator.clipboard.writeText(url); setCopied(true); setSnackbar({ open: true, message: 'Copied!' }); }} startIcon={copied ? <CheckCircleIcon /> : <ContentCopyIcon />} color={copied ? 'success' : 'primary'}>{copied ? 'Copied!' : 'Copy'}</Button></Box></DialogContent><DialogActions sx={{ px: 3, pb: 2 }}><Button onClick={onClose}>Close</Button></DialogActions></Dialog>);
};

const SourceTypeDialog: React.FC<{ open: boolean; onClose: () => void; onSelect: (type: string, prefill?: Partial<SourceFields>) => void; isDark: boolean }> = ({ open, onClose, onSelect, isDark }) => {
  const primarySources = ALL_SOURCE_TYPES.filter(s => s.category === 'primary');
  const secondarySources = ALL_SOURCE_TYPES.filter(s => s.category === 'secondary');

  const [wikiQuery, setWikiQuery] = React.useState('');
  const [wikiResults, setWikiResults] = React.useState<{ title: string; snippet: string; pageid: number }[]>([]);
  const [wikiLoading, setWikiLoading] = React.useState(false);
  const [wikiFetching, setWikiFetching] = React.useState(false);
  const wikiDebounce = React.useRef<NodeJS.Timeout>();

  React.useEffect(() => {
    if (!open) { setWikiQuery(''); setWikiResults([]); setWikiFetching(false); }
  }, [open]);

  React.useEffect(() => {
    if (wikiDebounce.current) clearTimeout(wikiDebounce.current);
    if (!wikiQuery.trim()) { setWikiResults([]); return; }
    wikiDebounce.current = setTimeout(async () => {
      setWikiLoading(true);
      try {
        const url = `https://en.wikipedia.org/w/api.php?action=query&list=search&srsearch=${encodeURIComponent(wikiQuery)}&format=json&origin=*&srlimit=6`;
        const res = await fetch(url);
        const data = await res.json();
        setWikiResults(data?.query?.search || []);
      } catch { setWikiResults([]); }
      setWikiLoading(false);
    }, 400);
  }, [wikiQuery]);

  const wikiClassify = async (title: string): Promise<{ sourceType: string; prefill: Partial<SourceFields> }> => {
    const enc = encodeURIComponent(title);
    const apiUrl = `https://en.wikipedia.org/w/api.php?action=query&titles=${enc}&prop=categories|extracts|coordinates|revisions&exintro=1&exsentences=5&redirects=1&format=json&origin=*&cllimit=30`;
    const res = await fetch(apiUrl);
    const data = await res.json();
    const pages = data?.query?.pages || {};
    const page: any = Object.values(pages)[0] || {};
    const cats: string[] = (page.categories || []).map((c: any) => c.title.toLowerCase());
    const extract: string = (page.extract || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    const coords = page.coordinates?.[0];
    const catStr = cats.join(' ');
    const wikiUrl = `https://en.wikipedia.org/wiki/${enc}`;

    const yearFromCats = (): string => {
      const m = catStr.match(/\b(1[0-9]{3}|20[0-9]{2})\b/);
      return m ? m[1] : '';
    };

    // ── FILM ──────────────────────────────────────────────
    if (/\bfilm|\bmovie|\bdocumentary|\bcinema/.test(catStr)) {
      const yr = yearFromCats();
      const dirMatch = extract.match(/directed by ([A-Z][^,.;()]+?)(?:\s*[,.]|$)/i);
      const director = dirMatch ? dirMatch[1].trim() : '';
      return { sourceType: 'film', prefill: { field2: title, field3: director, field4: yr } };
    }

    // ── BOOK / NOVEL ──────────────────────────────────────
    if (/\bnovel|\bbook\b|\bnon-fiction|\bfiction|\bautobiography|\bbiography.*book/.test(catStr)) {
      const yr = yearFromCats();
      const authMatch = extract.match(/(?:novel|book|written) by ([A-Z][^,.;()]+?)(?:\s*[,.]|$)/i);
      const author = authMatch ? authMatch[1].trim() : '';
      return { sourceType: 'book', prefill: { field2: title, field3: author, field5: yr } };
    }

    // ── MUSIC ─────────────────────────────────────────────
    if (/\balbum|\bsong\b|\bsingle\b|\bep\b|\bmusical work|\bdiscography/.test(catStr)) {
      const yr = yearFromCats();
      const artistMatch = extract.match(/by ([A-Z][^,.;()]+?)(?:\s*[,.]|$)/i);
      const artist = artistMatch ? artistMatch[1].trim() : '';
      return { sourceType: 'music', prefill: { field1: title, field2: artist, field5: yr } };
    }

    // ── PLACE / GEOGRAPHY ─────────────────────────────────
    if (coords || /\bcity\b|\btown\b|\bmunicipality|\bcountry\b|\bregion\b|\bprovince\b|\bgeography|\bpopulated place|\briver\b|\blake\b|\bmountain\b|\bisland\b/.test(catStr)) {
      const lat = coords ? String(coords.lat) : '';
      const lon = coords ? String(coords.lon) : '';
      return { sourceType: 'map', prefill: { field1: title, field2: lat && lon ? `${lat}, ${lon}` : '', field4: wikiUrl, field5: 'Wikipedia' } };
    }

    // ── SCIENTIFIC ────────────────────────────────────────
    if (/\bphysics|\bchemistry|\bbiology|\bmathematics|\bscientific concept|\btheorem|\bscience/.test(catStr)) {
      return { sourceType: 'scientific', prefill: { field1: title, field2: 'Wikipedia contributors', field3: 'Wikipedia', field5: wikiUrl } };
    }

    // ── PERSON / BIOGRAPHY ────────────────────────────────
    if (/\bbirths\b|\bdeaths\b|\bpeople\b|\bpolitician|\bactor|\bmusician|\bsinger|\bwriter|\bscientist|\bsportsperson|\barchitect|\bphilosopher/.test(catStr)) {
      const yr = yearFromCats();
      return { sourceType: 'article', prefill: { field1: title, field2: 'Wikipedia contributors', field3: 'Wikipedia', field4: yr ? yr + '-01-01' : '', field5: wikiUrl } };
    }

    // ── ORGANIZATION / COMPANY ────────────────────────────
    if (/\bcompan|\bcorporat|\borganization|\binstitution|\bfoundation\b/.test(catStr)) {
      return { sourceType: 'report', prefill: { field1: title, field2: 'Wikipedia', field3: yearFromCats() } };
    }

    // ── EVENT / DISASTER / BATTLE ─────────────────────────
    if (/\bdisaster|\baccident|\bbattle|\bwar\b|\bcrash|\bexplosion|\bearthquake|\bflood|\btsunami|\bmassacre|\bsiege|\battack|\bbombing|\briot|\bprotest|\bstrike\b|\bincident|\boperation\b|\bcoup/.test(catStr)) {
      const yr = yearFromCats();
      const lat = coords ? String(coords.lat) : '';
      const lon = coords ? String(coords.lon) : '';
      return { sourceType: 'event', prefill: { field1: title, field2: '', field3: lat && lon ? `${lat}, ${lon}` : '', field5: yr ? yr + '-01-01' : '' } };
    }

    // ── DEFAULT: Encyclopedia ─────────────────────────────
    return { sourceType: 'encyclopedia', prefill: { field1: title, field2: 'Wikipedia', field4: yearFromCats() } };
  };

  const handleWikiSelect = async (r: { title: string; snippet: string; pageid: number }) => {
    setWikiFetching(true);
    try {
      const { sourceType, prefill } = await wikiClassify(r.title);
      onSelect(sourceType, prefill as Partial<SourceFields>);
      onClose();
    } catch {
      onSelect('encyclopedia', { field1: r.title, field2: 'Wikipedia' } as Partial<SourceFields>);
      onClose();
    }
    setWikiFetching(false);
  };

  const dbLabel: Record<string, string> = {
    book: 'Open ISBN database',
    film: 'Open IMDB database',
  };

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ pb: 0.5 }}>
        <Typography fontWeight={700} fontSize={18}>Choose Source Type</Typography>
        <Typography variant="body2" color="text.secondary" fontSize={12}>Select the type of source you want to add</Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', mb: 1, display: 'block' }}>Popular</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
          {primarySources.map(s => (
            <Box key={s.type} onClick={() => { onSelect(s.type); onClose(); }} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, border: '2px solid', borderColor: 'divider', borderRadius: '10px', cursor: 'pointer', transition: 'all 0.15s', '&:hover': { borderColor: s.color, bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.02)', transform: 'translateY(-1px)', boxShadow: 2 } }}>
              <Box sx={{ width: 40, height: 40, borderRadius: '8px', bgcolor: `${s.color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: s.color, flexShrink: 0 }}>{s.icon}</Box>
              <Box>
                <Typography fontSize={13} fontWeight={600}>{s.label}</Typography>
                <Typography fontSize={10} color="text.secondary">{s.refLabel}</Typography>
                {dbLabel[s.type] && (
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.3, mt: 0.3, bgcolor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)', borderRadius: '4px', px: 0.6, py: 0.1 }}>
                    <StorageIcon sx={{ fontSize: 9, color: 'text.disabled' }} />
                    <Typography sx={{ fontSize: '0.6rem', color: 'text.disabled', fontWeight: 600 }}>{dbLabel[s.type]}</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          ))}
        </Box>
        <Divider sx={{ mb: 1.5 }} />
        <Typography variant="caption" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', mb: 1, display: 'block' }}>More types</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0.75, mb: 2 }}>
          {secondarySources.map(s => (
            <Box key={s.type} onClick={() => { onSelect(s.type); onClose(); }} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, p: 1, borderRadius: '6px', cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: s.color, flexShrink: 0 }} />
              <Typography fontSize={11}>{s.label}</Typography>
            </Box>
          ))}
        </Box>

        <Divider sx={{ mb: 1.5 }} />
        <Box sx={{ bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(59,130,246,0.04)', borderRadius: '10px', p: 2, border: '1px dashed', borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(59,130,246,0.2)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <SearchIcon sx={{ fontSize: 16, color: 'primary.main' }} />
            <Typography fontSize={13} fontWeight={700} color="primary.main">Quick Add via Wikipedia</Typography>
          </Box>
          <Typography fontSize={11} color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.5 }}>
            Great for quickly pinpointing a source when you know the topic. Search Wikipedia and the system will automatically detect the source type (book, film, person, place, etc.) and pre-fill the fields for you.
          </Typography>
          <TextField
            fullWidth size="small" placeholder="Search Wikipedia for a source topic..."
            value={wikiQuery} onChange={e => setWikiQuery(e.target.value)}
            InputProps={{
              startAdornment: <Box sx={{ mr: 1, display: 'flex', alignItems: 'center', color: 'text.disabled' }}><LanguageIcon sx={{ fontSize: 15 }} /></Box>,
              endAdornment: wikiLoading ? <CircularProgress size={14} sx={{ mr: 1 }} /> : null,
              sx: { borderRadius: '8px', fontSize: 13 }
            }}
          />
          {wikiResults.length > 0 && (
            <Box sx={{ mt: 0.75, border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden', boxShadow: 2 }}>
              {wikiResults.map((r, i) => (
                <Box key={r.pageid}>
                  {i > 0 && <Divider />}
                  <Box sx={{ px: 1.5, py: 1, cursor: wikiFetching ? 'wait' : 'pointer', display: 'flex', alignItems: 'flex-start', gap: 1, '&:hover': { bgcolor: 'action.hover' }, opacity: wikiFetching ? 0.6 : 1 }}
                    onClick={() => { if (!wikiFetching) handleWikiSelect(r); }}>
                    <LanguageIcon sx={{ fontSize: 14, color: 'text.disabled', mt: 0.2, flexShrink: 0 }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography fontSize={12} fontWeight={600}>{r.title}</Typography>
                      <Typography fontSize={10} color="text.secondary" sx={{ mt: 0.1 }}>
                        {r.snippet.replace(/<[^>]+>/g, '') + '...'}
                      </Typography>
                    </Box>
                    {wikiFetching ? <CircularProgress size={12} sx={{ ml: 'auto', mt: 0.3, flexShrink: 0 }} /> : <AddCircleOutlineIcon sx={{ fontSize: 13, color: 'primary.main', ml: 'auto', mt: 0.3, flexShrink: 0 }} />}
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}><Button onClick={onClose}>Cancel</Button></DialogActions>
    </Dialog>
  );
};

// ── FileUploadWizard ─────────────────────────────────────────────────────────

// ▓▓▓▓▓ FILE UPLOAD WIZARD ▓▓▓▓▓
const UPLOAD_ACCEPT = [
  '.pdf', 'application/pdf',
  '.doc','.docx','.odt','.rtf','.txt','.html','.htm','.epub',
  '.xls','.xlsx','.ods','.csv',
  '.ppt','.pptx','.odp',
  '.jpg','.jpeg','.png','.gif','.webp','.tiff','.tif','.bmp','.svg',
  'image/jpeg','image/png','image/gif','image/webp','image/tiff','image/bmp','image/svg+xml',
  '.mp3','.wav',
  'audio/mpeg','audio/mp3','audio/wav','audio/wave','audio/x-wav',
  '.md','.pages','.key','.numbers',
].join(',');

const SUPPORTED_FORMATS_LABEL = 'PDF · JPEG · PNG · GIF · WEBP · TIFF · BMP · SVG · DOC · DOCX · ODT · RTF · TXT · HTML · EPUB · XLS · XLSX · ODS · CSV · PPT · PPTX · ODP · MD · MP3 · WAV';

const FileUploadWizard: React.FC<{
  open: boolean;
  onClose: () => void;
  onDone: (file: UploadedFile, selectedPages: number[]) => void;
  authToken: string | null;
  boardId: string;
  sourceId: string;
  isDark: boolean;
  apiBase: string;
  getToken?: () => Promise<string | null>;
}> = ({ open, onClose, onDone, authToken, boardId, sourceId, isDark, apiBase, getToken: getTokenProp }) => {
  // ── state ────────────────────────────────────────────────────────────────
  const [step, setStep] = useState<1|2|3|4>(1);
  const [dragOver, setDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadSpeed, setUploadSpeed]   = useState('');
  const [uploadStatus, setUploadStatus] = useState<'uploading'|'converting'|'done'|'error'>('uploading');
  const [uploadingKind, setUploadingKind] = useState<'document'|'image'|'audio'>('document');
  const [uploadError, setUploadError]   = useState('');
  const [uploadedFile, setUploadedFile] = useState<UploadedFile | null>(null);
  const [pageImages, setPageImages]     = useState<string[]>([]);
  const [activePage, setActivePage]     = useState(1);
  const [selectedPages, setSelectedPages] = useState<Set<number>>(new Set([1]));
  const [extracting, setExtracting]     = useState(false);
  const [fileOrigin, setFileOrigin]     = useState<string>('');
  const [urlInput, setUrlInput]         = useState('');
  const [urlFetching, setUrlFetching]   = useState(false);
  const [refAreas, setRefAreas]         = useState<Array<{x:number;y:number;w:number;h:number;page:number}>>([]);
  const [isDrawing, setIsDrawing]       = useState(false);
  const [drawMode, setDrawMode]         = useState(false);
  
  const [highlightMode, setHighlightMode] = useState(false);
  const [highlightTool, setHighlightTool] = useState<'line'|'rect'|'circle'|null>(null);
  const [highlightColor, setHighlightColor] = useState<string>('#f59e0b');
  const [highlightThickness, setHighlightThickness] = useState<number>(3);
  const [highlights, setHighlights]     = useState<Array<{type:'line'|'rect'|'circle';x1:number;y1:number;x2:number;y2:number;page:number;color:string;thickness?:number}>>([]);
  const [isHighlighting, setIsHighlighting] = useState(false);
  const [highlightStart, setHighlightStart] = useState<{x:number;y:number}|null>(null);
  const [highlightCurrent, setHighlightCurrent] = useState<{x:number;y:number}|null>(null);
  const [viewerZoom, setViewerZoom] = useState(1);

  const HIGHLIGHT_COLORS = [
    { color: '#f59e0b', label: 'Orange' },
    { color: '#ef4444', label: 'Red' },
    { color: '#10b981', label: 'Green' },
    { color: '#3b82f6', label: 'Blue' },
  ];

  const enterDrawMode = () => setDrawMode(true);
  const exitDrawMode = () => { setDrawMode(false); setDrawStart(null); setDrawCurrent(null); };
  const enterHighlightMode = () => setHighlightMode(true);
  const exitHighlightMode = () => { setHighlightMode(false); setHighlightStart(null); setHighlightCurrent(null); };

  const [drawStart, setDrawStart]       = useState<{x:number;y:number}|null>(null);
  const [drawCurrent, setDrawCurrent]   = useState<{x:number;y:number}|null>(null);
  const abortRef = useRef<AbortController | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const thumbsRef = useRef<HTMLDivElement>(null);

  const [maxUploadSizeMb, setMaxUploadSizeMb] = useState(50);
  useEffect(() => {
    if (!open) return;
    fetch(`${apiBase}/site-info`).then(r => r.json()).then(d => {
      if (typeof d.maxUploadSizeMb === 'number' && d.maxUploadSizeMb > 0) {
        setMaxUploadSizeMb(d.maxUploadSizeMb);
      }
    }).catch(() => {  });
  }, [open, apiBase]);
  const overlayRef = useRef<HTMLDivElement>(null);
  const highlightOverlayRef = useRef<HTMLDivElement>(null);

  const FILE_ORIGINS = [
    { label: 'Photo taken by me', icon: '📱' },
    { label: 'Photo found online', icon: '🖼️' },
    { label: 'Scan from physical book or paper', icon: '📖' },
    { label: 'Screenshot or screen capture', icon: '🖥️' },
    { label: 'Digital document (PDF, Word)', icon: '📄' },
    { label: 'Downloaded from official source', icon: '🏛️' },
    { label: 'Received via email or message', icon: '📧' },
    { label: 'Exported from database or app', icon: '💾' },
    { label: 'Recovered from old media (disc, tape, drive)', icon: '💿' },
    { label: 'AI-generated or processed', icon: '🤖' },
    { label: 'Other / Unknown', icon: '📎' },
  ];

  useEffect(() => {
    if (!open) {
      setStep(1); setDragOver(false); setUploading(false);
      setUploadProgress(0); setUploadSpeed(''); setUploadStatus('uploading');
      setUploadError(''); setUploadedFile(null); setPageImages([]); setActivePage(1);
      setSelectedPages(new Set([1])); setExtracting(false);
      setFileOrigin(''); setUrlInput(''); setUrlFetching(false);
      setRefAreas([]); setIsDrawing(false); setDrawMode(false); setDrawStart(null); setDrawCurrent(null);
      setHighlightMode(false); setHighlightTool(null); setHighlightColor('#f59e0b'); setHighlightThickness(3); setHighlights([]); setIsHighlighting(false); setHighlightStart(null); setHighlightCurrent(null); setViewerZoom(1);
    }
  }, [open]);

  // ── upload ───────────────────────────────────────────────────────────────
  const doUpload = async (file: File) => {
    setUploading(true); setUploadProgress(0); setUploadStatus('uploading');
    setUploadError(''); setUploadedFile(null); setPageImages([]);
    const maxBytes = maxUploadSizeMb * 1024 * 1024;
    if (file.size > maxBytes) {
      const fileMb = (file.size / (1024 * 1024)).toFixed(1);
      setUploadError(`File is ${fileMb} MB — exceeds the upload limit of ${maxUploadSizeMb} MB. Ask the admin to raise the limit, or upload a smaller file.`);
      setUploadStatus('error');
      setUploading(false);
      return;
    }
    const isImage = file.type.startsWith('image/');
    const lowerName = file.name.toLowerCase();
    const isAudio = file.type.startsWith('audio/')
      || lowerName.endsWith('.mp3') || lowerName.endsWith('.wav');
    setUploadingKind(isAudio ? 'audio' : isImage ? 'image' : 'document');
    const rand = Array.from({length:8}, () => 'abcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random()*36)]).join('');
    const refName = `ref-${rand}.${(isImage || isAudio) ? (file.name.split('.').pop() || 'png') : 'png'}`;

    let token = authToken;
    if (getTokenProp) {
      try { const fresh = await getTokenProp(); if (fresh) token = fresh; } catch {}
    }

    if (token) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('boardId', boardId);
        formData.append('sourceId', sourceId);
        formData.append('origin', fileOrigin);
        const abort = new AbortController();
        abortRef.current = abort;
        const xhr = new XMLHttpRequest();
        let lastLoaded = 0, lastTime = Date.now();
        
        const endpoint = (isImage || isAudio) ? `${apiBase}/upload` : `${apiBase}/upload-and-convert-png`;

        const result = await new Promise<{ok:boolean;url?:string;originalUrl?:string;previewUrl?:string;pages?:string[];pageCount?:number;type?:string;error?:string}>((resolve) => {
          xhr.upload.onprogress = (ev) => {
            if (ev.lengthComputable) {
              const pct = Math.round(ev.loaded / ev.total * 100);
              setUploadProgress(pct < 100 ? pct : 99);
              const now = Date.now(), dt = (now - lastTime) / 1000;
              if (dt > 0.3) {
                const bps = (ev.loaded - lastLoaded) / dt;
                lastLoaded = ev.loaded; lastTime = now;
                setUploadSpeed(bps > 1048576 ? `${(bps/1048576).toFixed(1)} MB/s` : `${Math.round(bps/1024)} KB/s`);
              }
            }
          };
          xhr.upload.onload = () => { if (!isImage && !isAudio) { setUploadStatus('converting'); setUploadProgress(99); setUploadSpeed(''); } };
          xhr.onload = () => { try { const d = JSON.parse(xhr.responseText); resolve({ok: xhr.status===200, ...d}); } catch { resolve({ok:false, error:`Server error (${xhr.status})`}); }};
          xhr.onerror  = () => resolve({ok:false, error:'Network error'});
          xhr.onabort  = () => resolve({ok:false, error:'Upload cancelled'});
          abort.signal.addEventListener('abort', () => xhr.abort());
          xhr.open('POST', endpoint);
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
          xhr.send(formData);
        });

        abortRef.current = null;
        if (result.ok && (result.url || result.originalUrl || result.pages?.length)) {
          setUploadStatus('done'); setUploadProgress(100);
          const imgUrl = result.url || result.originalUrl || '';
          const pages = (isImage || isAudio) ? [imgUrl] : (result.pages || [imgUrl]);

          const uf: UploadedFile = {
            name: refName, size: file.size, type: file.type,
            uploadedAt: new Date().toISOString(),
            url: imgUrl,
            previewUrl: pages[0] || imgUrl,
            pageCount: pages.length || 1,
            origin: fileOrigin,
          };
          setUploadedFile(uf);
          setPageImages(pages);
          setActivePage(1);
          setSelectedPages(new Set([1]));
          setUploading(false);
          setTimeout(() => setStep(2), 400);
          return;
        } else if ((result as any).status === 401 && getTokenProp) {
          try {
            const freshToken = await getTokenProp();
            if (freshToken) {
              setUploadProgress(0); setUploadStatus('uploading');
              const retryForm = new FormData();
              retryForm.append('file', file);
              retryForm.append('boardId', boardId);
              retryForm.append('sourceId', sourceId);
              retryForm.append('origin', fileOrigin);
              const retryResp = await fetch(endpoint, { method: 'POST', headers: { 'Authorization': `Bearer ${freshToken}` }, body: retryForm });
              const retryData = await retryResp.json();
              if (retryResp.ok && (retryData.url || retryData.originalUrl || retryData.pages?.length)) {
                setUploadStatus('done'); setUploadProgress(100);
                const imgUrl2 = retryData.url || retryData.originalUrl || '';
                const pages2 = (isImage || isAudio) ? [imgUrl2] : (retryData.pages || [imgUrl2]);
                const uf2: UploadedFile = {
                  name: refName, size: file.size, type: file.type, uploadedAt: new Date().toISOString(),
                  url: imgUrl2,
                  previewUrl: pages2[0] || imgUrl2,
                  pageCount: pages2.length || 1,
                  origin: fileOrigin,
                };
                setUploadedFile(uf2); setPageImages(pages2);
                setActivePage(1); setSelectedPages(new Set([1])); setUploading(false);
                setTimeout(() => setStep(2), 400);
                return;
              }
            }
          } catch {}
          setUploadError('Session expired. Please close and try again.');
          setUploadStatus('error'); setUploading(false);
          return;
        } else {
          setUploadError(result.error || 'Upload failed. Please try again.');
          setUploadStatus('error'); setUploading(false);
          return;
        }
      } catch (err: any) {
        setUploadError(err?.message || 'Upload failed');
        setUploadStatus('error'); setUploading(false);
        return;
      }
    }

    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onprogress = (ev) => { if (ev.lengthComputable) setUploadProgress(Math.round(ev.loaded/ev.total*100)); };
      reader.onload = () => {
        const dataUrl = reader.result as string;
        const uf: UploadedFile = {
          name: refName, size: file.size, type: file.type,
          uploadedAt: new Date().toISOString(),
          dataUrl,
          previewUrl: dataUrl,
          pageCount: 1,
          origin: fileOrigin,
        };
        setUploadedFile(uf);
        setPageImages([dataUrl]);
        setUploading(false); setUploadStatus('done'); setUploadProgress(100);
        setTimeout(() => setStep(2), 400);
      };
      reader.readAsDataURL(file);
    } else {
      setUploadError('Please sign in to upload documents.');
      setUploadStatus('error'); setUploading(false);
    }
  };

  const handleFilePick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]; if (f) doUpload(f);
    e.target.value = '';
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault(); setDragOver(false);
    const f = e.dataTransfer.files?.[0]; if (f) doUpload(f);
  };

  // ── page selection helpers ────────────────────────────────────────────────
  const pageCount = pageImages.length || 1;
  const isMultiPage = pageCount > 1;
  const currentPageUrl = pageImages[activePage - 1] || uploadedFile?.previewUrl || uploadedFile?.dataUrl || '';

  const navigatePage = (p: number) => {
    if (p >= 1 && p <= pageCount) setActivePage(p);
  };

  const goToRefPage = () => {
    if (refAreas.length > 0) navigatePage(refAreas[0].page);
  };

  // ── confirm & extract ─────────────────────────────────────────────────────
  const handleConfirm = async () => {
    if (!uploadedFile) return;
    const refPage = refAreas.length > 0 ? refAreas[0].page : 1;
    const finalPages = [refPage];
    const refArea = refAreas.length > 0 ? refAreas[0] : null;

    const fileWithRefs: UploadedFile = {
      ...uploadedFile,
      refAreas: refAreas.map(a => ({ x: a.x, y: a.y, w: a.w, h: a.h, label: `Page ${a.page}` })),
      citedPages: finalPages,
      origin: fileOrigin,
      previewUrl: pageImages[refPage - 1] || uploadedFile.previewUrl,
      pageUrls: pageImages[refPage - 1] ? [pageImages[refPage - 1]] : undefined,
      highlights: highlights.length > 0 ? highlights.map(h => ({ type: h.type, x1: h.x1, y1: h.y1, x2: h.x2, y2: h.y2, color: h.color, thickness: h.thickness })) : undefined,
    };

    if (authToken && refArea && pageImages[refPage - 1]) {
      setExtracting(true);
      let token = authToken;
      if (getTokenProp) { try { const t = await getTokenProp(); if (t) token = t; } catch {} }
      try {
        const cropResp = await fetch(`${apiBase}/crop-image`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({
            imageUrl: pageImages[refPage - 1],
            x: refArea.x, y: refArea.y, w: refArea.w, h: refArea.h,
            boardId, sourceId,
            highlights: highlights.length > 0 ? highlights : undefined
          }),
        });
        if (cropResp.ok) {
          const cropData = await cropResp.json();
          fileWithRefs.refCropUrl = cropData.cropUrl || undefined;
        }
      } catch {}
      setExtracting(false);
    }

    onDone(fileWithRefs, finalPages);
  };

  // ── step labels ───────────────────────────────────────────────────────────
  const stepLabels = ['Upload File', 'Draw Reference', 'Highlight', 'Confirm'];
  const stepSubtitles = ['Select origin type, then upload', 'Draw the cited reference area', 'Highlight key text (optional)', 'Review and save'];

  return (
    <Dialog disableScrollLock open={open} onClose={() => { if (!uploading && !extracting) onClose(); }} maxWidth={false}
      PaperProps={{ sx: { position: 'fixed', inset: 0, m: 0, maxWidth: '100%', maxHeight: '100%', borderRadius: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' } }}>
      <Box sx={{ px: 3, pt: 2.5, pb: 0, flexShrink: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box>
            <Typography fontWeight={700} fontSize={16}>Attach File</Typography>
            <Typography fontSize={11} color="text.secondary">{stepSubtitles[step-1]}</Typography>
          </Box>
          <IconButton onClick={onClose} size="small" disabled={uploading || extracting}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
        </Box>
        <Box sx={{ display:'flex', alignItems:'center', mb: 2 }}>
          {stepLabels.map((label, i) => {
            const num = i+1 as 1|2|3|4;
            const active = step === num, done = step > num;
            return (
              <React.Fragment key={num}>
                {i > 0 && <Box sx={{ flex: 1, height: 2, bgcolor: done ? '#3b82f6' : 'divider', mx: 1, transition: 'background-color 0.3s' }} />}
                <Box sx={{ display:'flex', alignItems:'center', gap: 0.5, cursor: done ? 'pointer' : 'default', opacity: !active && !done ? 0.4 : 1 }}
                  onClick={() => { if (done) setStep(num); }}>
                  <Box sx={{ width:22, height:22, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
                    fontSize: 10, fontWeight: 700, transition: 'all 0.2s',
                    bgcolor: active ? '#3b82f6' : done ? '#3b82f6' : (isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'),
                    color: active || done ? '#E3E3DF' : 'text.disabled' }}>
                    {done ? '✓' : num}
                  </Box>
                  <Typography fontSize={10} fontWeight={active ? 700 : 500} color={active ? 'text.primary' : 'text.secondary'}>{label}</Typography>
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      </Box>
      <Divider />

      <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

        {step === 1 && (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', p: 3, overflow: 'auto' }}>
            <input type="file" ref={fileInputRef} accept={UPLOAD_ACCEPT} onChange={handleFilePick} style={{ display:'none' }} />

            {!uploading && uploadStatus !== 'error' && !fileOrigin && (
              <>
                <Typography fontWeight={600} fontSize={14} sx={{ mb: 0.5 }}>What type of file is this?</Typography>
                <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>Select the origin to help categorize this reference material.</Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 3 }}>
                  {FILE_ORIGINS.map(o => (
                    <Box key={o.label} onClick={() => setFileOrigin(o.label)}
                      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, border: '2px solid', borderColor: 'divider', borderRadius: '10px', cursor: 'pointer', transition: 'all 0.15s',
                        '&:hover': { borderColor: '#3b82f6', bgcolor: isDark ? 'rgba(59,130,246,0.06)' : 'rgba(59,130,246,0.03)', transform: 'translateY(-1px)', boxShadow: 2 } }}>
                      <Typography fontSize={20} lineHeight={1}>{o.icon}</Typography>
                      <Typography fontSize={12} fontWeight={500}>{o.label}</Typography>
                    </Box>
                  ))}
                </Box>
              </>
            )}

            {!uploading && uploadStatus !== 'error' && fileOrigin && (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Chip label={fileOrigin} size="small" onDelete={() => setFileOrigin('')} sx={{ fontSize: 11, height: 26 }} />
                </Box>

                <Box onDragOver={(e) => { e.preventDefault(); setDragOver(true); }} onDragLeave={() => setDragOver(false)} onDrop={handleDrop}
                  onClick={() => fileInputRef.current?.click()}
                  sx={{ width: '100%', maxWidth: 520, border: '2px dashed', borderColor: dragOver ? '#3b82f6' : 'divider',
                    borderRadius: '16px', p: 4, textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', mx: 'auto',
                    bgcolor: dragOver ? (isDark ? 'rgba(59,130,246,0.08)' : 'rgba(59,130,246,0.04)') : 'transparent',
                    '&:hover': { borderColor: '#3b82f6', bgcolor: isDark ? 'rgba(59,130,246,0.05)' : 'rgba(59,130,246,0.02)' } }}>
                  <UploadFileIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
                  <Typography fontWeight={600} fontSize={14} sx={{ mb: 0.5 }}>Drop a file here, or click to browse</Typography>
                  <Typography fontSize={11} color="text.secondary" sx={{ mb: 1 }}>
                    Images upload directly · Documents and PDFs convert to PNG pages · Audio (MP3/WAV) gets a waveform reference picker
                  </Typography>
                  <Typography fontSize={9} color="text.disabled" sx={{ mb: 0.5, px: 2, lineHeight: 1.6 }}>
                    {SUPPORTED_FORMATS_LABEL}
                  </Typography>
                  <Typography fontSize={9} color="text.disabled" sx={{ mb: 1.5, fontWeight: 600 }}>
                    Max upload size: {maxUploadSizeMb} MB
                  </Typography>
                  <Button variant="contained" size="small" sx={{ textTransform:'none', px: 3 }}>Choose File</Button>
                </Box>

                <Divider sx={{ my: 2.5 }}><Typography fontSize={10} color="text.disabled">or paste a URL to a file</Typography></Divider>
                <Box sx={{ display: 'flex', gap: 1, maxWidth: 520, mx: 'auto', width: '100%' }}>
                  <TextField size="small" fullWidth placeholder="https://example.com/image.png" value={urlInput} onChange={e => setUrlInput(e.target.value)}
                    InputProps={{ sx: { fontSize: 12, borderRadius: '8px' } }} />
                  <Button variant="outlined" size="small" disabled={!urlInput.trim() || urlFetching} onClick={async () => {
                    if (!urlInput.trim()) return;
                    setUrlFetching(true);
                    try {
                      const resp = await fetch(urlInput.trim());
                      const blob = await resp.blob();
                      const ext = urlInput.split('.').pop()?.split('?')[0] || 'png';
                      const file = new File([blob], `fetched-file.${ext}`, { type: blob.type || 'image/png' });
                      doUpload(file);
                    } catch { setUploadError('Could not fetch file from URL. Check the link.'); setUploadStatus('error'); }
                    setUrlFetching(false);
                  }} sx={{ textTransform: 'none', fontSize: 11, minWidth: 80, whiteSpace: 'nowrap' }}>
                    {urlFetching ? <CircularProgress size={14} /> : 'Fetch File'}
                  </Button>
                </Box>
                <Typography fontSize={9} color="text.disabled" sx={{ mt: 1, textAlign: 'center' }}>
                  Supported formats: {SUPPORTED_FORMATS_LABEL}
                </Typography>
              </>
            )}

            {uploading && (
              <Box sx={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>
                  {uploadStatus === 'uploading' ? (
                    uploadingKind === 'audio'
                      ? <AudiotrackIcon sx={{ fontSize: 48, color: '#3b82f6' }} />
                      : <InsertDriveFileIcon sx={{ fontSize: 48, color: '#3b82f6' }} />
                  ) : (
                    <Box sx={{ fontSize: 40, lineHeight: 1 }}>⚙️</Box>
                  )}
                </Box>
                <Typography fontWeight={600} fontSize={14} sx={{ mb: 0.5 }}>
                  {uploadStatus === 'uploading'
                    ? `Uploading… ${uploadProgress}%${uploadSpeed ? ` · ${uploadSpeed}` : ''}`
                    : uploadingKind === 'audio'
                      ? 'Processing audio file…'
                      : uploadingKind === 'image'
                        ? 'Processing image…'
                        : 'Converting to PNG…'}
                </Typography>
                <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
                  {uploadStatus === 'uploading'
                    ? 'Your file is being sent to the server.'
                    : uploadingKind === 'audio'
                      ? 'Preparing waveform and metadata…'
                      : uploadingKind === 'image'
                        ? 'Preparing image…'
                        : 'Generating page images…'}
                </Typography>
                <Box sx={{ width:'100%', height:6, bgcolor:'divider', borderRadius:3, overflow:'hidden' }}>
                  <Box sx={{ width: uploadStatus==='converting' ? '100%' : `${uploadProgress}%`, height:'100%',
                    bgcolor: uploadStatus==='converting' ? '#f59e0b' : '#3b82f6', borderRadius:3, transition:'width 0.3s',
                    ...(uploadStatus==='converting' ? {animation:'pulse 1.5s ease-in-out infinite','@keyframes pulse':{'0%,100%':{opacity:1},'50%':{opacity:0.5}}} : {}) }} />
                </Box>
                <Button size="small" color="error" sx={{ mt: 2, fontSize:10 }}
                  onClick={() => { abortRef.current?.abort(); setUploading(false); }}>
                  Cancel
                </Button>
              </Box>
            )}

            {!uploading && uploadStatus === 'done' && (
              <Box sx={{ textAlign:'center' }}>
                <Typography fontSize={24} sx={{ mb:1 }}>✅</Typography>
                <Typography fontWeight={600} fontSize={14}>Upload complete — opening viewer…</Typography>
              </Box>
            )}

            {uploadStatus === 'error' && (
              <Box sx={{ textAlign:'center', maxWidth: 440, mx: 'auto' }}>
                <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 1.5 }}>
                  <WarningIcon sx={{ fontSize: 28, color: '#ef4444' }} />
                </Box>
                <Typography fontWeight={600} fontSize={14} sx={{ mb: 0.5 }}>Upload failed</Typography>
                <Typography fontSize={12} color="text.secondary" sx={{ mb: 2, bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)', borderRadius:'8px', p:1.5, border:'1px solid', borderColor:'divider' }}>
                  {uploadError}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
                  <Button variant="contained" size="small" onClick={() => { setUploadStatus('uploading'); setUploadError(''); fileInputRef.current?.click(); }} sx={{ textTransform: 'none' }}>
                    Try Again with New File
                  </Button>
                  <Button variant="outlined" size="small" onClick={() => { setUploadStatus('uploading'); setUploadError(''); setFileOrigin(''); }} sx={{ textTransform: 'none' }}>
                    Start Over
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        )}

        {step === 2 && uploadedFile && (() => {
          const lowerType = (uploadedFile.type || '').toLowerCase();
          const lowerName = uploadedFile.name.toLowerCase();
          const isAudioFile = lowerType.startsWith('audio/')
            || lowerName.endsWith('.mp3') || lowerName.endsWith('.wav');
          return isAudioFile;
        })() && (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', p: 3, gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box sx={{ width: 48, height: 48, borderRadius: '12px', bgcolor: 'rgba(59,130,246,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <AudiotrackIcon sx={{ fontSize: 28, color: '#3b82f6' }} />
              </Box>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {uploadedFile.name}
                </Typography>
                <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>
                  {formatFileSize(uploadedFile.size)} · Audio file
                </Typography>
              </Box>
            </Box>
            <Box sx={{ p: 2, borderRadius: '12px', bgcolor: isDark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.03)', border: '1px solid', borderColor: 'divider' }}>
              <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary', mb: 1.5, textTransform: 'uppercase', letterSpacing: 0.4 }}>
                Reference timestamp
              </Typography>
              <AudioPlayer
                src={uploadedFile.url || ''}
                mode="set-ref"
                refTimestamp={uploadedFile.refTimestamp}
                onSetReference={(secs) => {
                  setUploadedFile(prev => prev ? { ...prev, refTimestamp: secs > 0 ? secs : undefined } : prev);
                }}
                onDurationLoad={(d) => {
                  setUploadedFile(prev => prev ? { ...prev, audioDuration: d } : prev);
                }}
                isDark={isDark}
                accent="#3b82f6"
              />
              <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 1.5, lineHeight: 1.6 }}>
                Click anywhere on the waveform to mark the timestamp this source is cited at. Playback starts from that point when readers click "Jump to reference".
              </Typography>
            </Box>
            <Box sx={{ flex: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
              <Button onClick={onClose} sx={{ textTransform: 'none' }}>Cancel</Button>
              <Button variant="contained" onClick={() => { if (uploadedFile) onDone(uploadedFile, []); }} sx={{ textTransform: 'none', fontWeight: 600 }}>
                Done
              </Button>
            </Box>
          </Box>
        )}

        {step === 2 && uploadedFile && (() => {
          const lowerType = (uploadedFile.type || '').toLowerCase();
          const lowerName = uploadedFile.name.toLowerCase();
          const isAudioFile = lowerType.startsWith('audio/')
            || lowerName.endsWith('.mp3') || lowerName.endsWith('.wav');
          return !isAudioFile;
        })() && (
          <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1,
                bgcolor: isDark ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.06)', borderBottom: '1px solid', borderColor: 'divider' }}>

                {pageCount > 1 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <IconButton size="small" disabled={activePage <= 1} onClick={() => navigatePage(activePage - 1)}>
                      <ChevronLeftIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                    <Typography fontSize={11} fontWeight={600}>Page {activePage} / {pageCount}</Typography>
                    <IconButton size="small" disabled={activePage >= pageCount} onClick={() => navigatePage(activePage + 1)}>
                      <ChevronRightIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Box>
                )}

                {refAreas.length > 0 && (
                  <Button size="small" variant="outlined"
                    startIcon={<BookmarkIcon sx={{ fontSize: 13 }} />}
                    onClick={goToRefPage}
                    sx={{ fontSize: 10, textTransform: 'none', borderColor: '#f59e0b', color: '#f59e0b', borderRadius: '8px', px: 1.5,
                      '&:hover': { bgcolor: '#f59e0b10', borderColor: '#f59e0b' } }}>
                    Go to Ref (p.{refAreas[0]?.page})
                  </Button>
                )}

                <Box sx={{ flex: 1 }} />

                {!drawMode ? (
                  <Button variant="contained" size="small"
                    startIcon={<CropFreeIcon sx={{ fontSize: 13 }} />}
                    onClick={enterDrawMode}
                    sx={{ bgcolor: '#3b82f6', fontWeight: 600, fontSize: 11, textTransform: 'none', px: 2, py: 0.5, borderRadius: '8px',
                      '&:hover': { bgcolor: '#2563eb' }, boxShadow: 1 }}>
                    Draw Reference
                  </Button>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography fontSize={12} fontWeight={600} color="#E3E3DF">Draw your reference on page {activePage}</Typography>
                    <Button variant="contained" size="small" color="warning"
                      startIcon={<CloseIcon sx={{ fontSize: 14 }} />}
                      onClick={exitDrawMode}
                      sx={{ fontWeight: 700, fontSize: 11, textTransform: 'none', px: 2, borderRadius: '8px' }}>
                      Cancel
                    </Button>
                  </Box>
                )}

                <Box sx={{ flex: 1 }} />

                {refAreas.length > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                    <Box sx={{ bgcolor: '#10b98120', color: '#10b981', px: 1.2, py: 0.4, borderRadius: '6px', fontSize: 11, fontWeight: 700 }}>
                      ✓ Page {refAreas[0]?.page}
                    </Box>
                    <Button size="small" color="error" onClick={() => setRefAreas([])} sx={{ fontSize: 10, textTransform: 'none', minWidth: 0 }}>Clear</Button>
                  </Box>
                )}
                
                <ViewerZoomControls zoom={viewerZoom} onZoomChange={setViewerZoom} variant="dark" sx={{ ml: 1 }} />
              </Box>

              <Box 
                sx={{ flex: 1, bgcolor: '#525659', position: 'relative', overflow: 'auto' }}>
                {currentPageUrl && !drawMode && (
                  <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, overflow: 'auto' }}>
                    <img src={currentPageUrl} alt={`Page ${activePage}`}
                      style={{ maxWidth: viewerZoom === 1 ? '100%' : 'none', maxHeight: viewerZoom === 1 ? '100%' : 'none', objectFit: 'contain', background: '#fff', boxShadow: '0 4px 24px rgba(0,0,0,0.3)', transform: `scale(${viewerZoom})`, transformOrigin: 'center center' }} />
                  </Box>
                )}

                {drawMode && currentPageUrl && (
                  <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#525659', zIndex: 3, overflow: 'auto' }}>
                    <Box sx={{ position: 'relative', display: 'inline-block', transform: `scale(${viewerZoom})`, transformOrigin: 'center center' }}>
                      <img src={currentPageUrl} alt={`Page ${activePage}`}
                        style={{ display: 'block', maxWidth: '90vw', maxHeight: 'calc(100vh - 160px)', background: '#fff', boxShadow: '0 4px 24px rgba(0,0,0,0.4)', userSelect: 'none' }} draggable={false} />
                      <Box ref={overlayRef}
                        onMouseDown={(e) => {
                          const rect = e.currentTarget.getBoundingClientRect();
                          const x = (e.clientX - rect.left) / viewerZoom;
                          const y = (e.clientY - rect.top) / viewerZoom;
                          setIsDrawing(true);
                          setDrawStart({ x, y });
                          setDrawCurrent({ x, y });
                        }}
                        onMouseMove={(e) => {
                          if (!isDrawing) return;
                          const rect = e.currentTarget.getBoundingClientRect();
                          const unscaledWidth = rect.width / viewerZoom;
                          const unscaledHeight = rect.height / viewerZoom;
                          setDrawCurrent({
                            x: Math.max(0, Math.min((e.clientX - rect.left) / viewerZoom, unscaledWidth)),
                            y: Math.max(0, Math.min((e.clientY - rect.top) / viewerZoom, unscaledHeight))
                          });
                        }}
                        onMouseUp={() => {
                          if (isDrawing && drawStart && drawCurrent && overlayRef.current) {
                            const rect = overlayRef.current.getBoundingClientRect();
                            const unscaledWidth = rect.width / viewerZoom;
                            const unscaledHeight = rect.height / viewerZoom;
                            const rawW = Math.abs(drawCurrent.x - drawStart.x);
                            const rawH = Math.abs(drawCurrent.y - drawStart.y);
                            if (rawW > 10 && rawH > 10) {
                              const rawX = Math.min(drawStart.x, drawCurrent.x);
                              const rawY = Math.min(drawStart.y, drawCurrent.y);
                              setRefAreas([{
                                x: Math.round((rawX / unscaledWidth) * 10000) / 100,
                                y: Math.round((rawY / unscaledHeight) * 10000) / 100,
                                w: Math.round((rawW / unscaledWidth) * 10000) / 100,
                                h: Math.round((rawH / unscaledHeight) * 10000) / 100,
                                page: activePage
                              }]);
                              exitDrawMode();
                              setStep(3);
                            }
                          }
                          setIsDrawing(false); setDrawStart(null); setDrawCurrent(null);
                        }}
                        sx={{ position: 'absolute', inset: 0, cursor: 'crosshair', zIndex: 2 }}>
                        <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                          {(() => {
                            const liveArea = isDrawing && drawStart && drawCurrent && overlayRef.current ? (() => {
                              const r = overlayRef.current.getBoundingClientRect();
                              const unscaledW = r.width / viewerZoom;
                              const unscaledH = r.height / viewerZoom;
                              return { x: (Math.min(drawStart.x, drawCurrent.x) / unscaledW) * 100, y: (Math.min(drawStart.y, drawCurrent.y) / unscaledH) * 100, w: (Math.abs(drawCurrent.x - drawStart.x) / unscaledW) * 100, h: (Math.abs(drawCurrent.y - drawStart.y) / unscaledH) * 100 };
                            })() : null;
                            if (!liveArea) return null;
                            return (
                              <>
                                <defs><mask id="draw-mask"><rect x="0" y="0" width="100%" height="100%" fill="white" /><rect x={`${liveArea.x}%`} y={`${liveArea.y}%`} width={`${liveArea.w}%`} height={`${liveArea.h}%`} fill="black" rx="3" /></mask></defs>
                                <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.45)" mask="url(#draw-mask)" />
                              </>
                            );
                          })()}
                          {isDrawing && drawStart && drawCurrent && overlayRef.current && (() => {
                            const r = overlayRef.current.getBoundingClientRect();
                            const unscaledW = r.width / viewerZoom;
                            const unscaledH = r.height / viewerZoom;
                            const xPct = (Math.min(drawStart.x, drawCurrent.x) / unscaledW) * 100;
                            const yPct = (Math.min(drawStart.y, drawCurrent.y) / unscaledH) * 100;
                            const wPct = (Math.abs(drawCurrent.x - drawStart.x) / unscaledW) * 100;
                            const hPct = (Math.abs(drawCurrent.y - drawStart.y) / unscaledH) * 100;
                            return (
                              <>
                                <rect x={`${xPct}%`} y={`${yPct}%`} width={`${wPct}%`} height={`${hPct}%`}
                                  fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeDasharray="6,3" rx="3" />
                                {wPct > 15 && hPct > 8 && (
                                  <text x={`${xPct + 2}%`} y={`${yPct + 5}%`} fill="#3b82f6" fontSize="12" fontWeight="700">Cited reference</text>
                                )}
                              </>
                            );
                          })()}
                        </svg>
                      </Box>
                    </Box>
                    <Box sx={{ position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)', bgcolor: 'rgba(0,0,0,0.7)', color: '#E3E3DF', px: 2, py: 0.5, borderRadius: '8px', fontSize: 12, fontWeight: 700, zIndex: 5 }}>
                      Draw cited reference area — Page {activePage}
                    </Box>
                  </Box>
                )}

                {!currentPageUrl && (
                  <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.4)' }}>
                    <InsertDriveFileIcon sx={{ fontSize: 64 }} />
                  </Box>
                )}

                {!drawMode && refAreas.length > 0 && (
                  <Box sx={{ position: 'absolute', top: 8, left: 8, bgcolor: 'rgba(245,158,11,0.9)', color: '#E3E3DF', px: 1.2, py: 0.4, borderRadius: '6px', fontSize: 11, fontWeight: 700, zIndex: 3, pointerEvents: 'none' }}>
                    ✓ Reference on page {refAreas[0].page}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}

        {step === 4 && uploadedFile && (() => {
          const refPage = refAreas.length > 0 ? refAreas[0].page : 1;
          const autoPagesArr = [refPage];
          return (
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
              <Box sx={{ maxWidth: 480, width: '100%' }}>
                <Typography fontWeight={700} fontSize={18} sx={{ mb: 3, textAlign: 'center' }}>Reference Summary</Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3 }}>
                  {[
                    { label: 'Referenced Page', value: `Page ${refPage}`, icon: '📄', color: '#3b82f6' },
                    { label: 'File Origin', value: uploadedFile.origin || 'Not specified', icon: '📋', color: '#8b5cf6' },
                    { label: 'File Type', value: uploadedFile.type?.split('/')[1]?.toUpperCase() || 'Document', icon: '📎', color: '#10b981' },
                    { label: 'Pages to Save', value: autoPagesArr.length === 1 ? `Page ${autoPagesArr[0]}` : `Pages ${autoPagesArr.join(', ')}`, icon: '📑', color: '#f59e0b' },
                    { label: 'Highlights', value: highlights.length > 0 ? `${highlights.length} highlight${highlights.length > 1 ? 's' : ''} applied` : 'None', icon: '🖍️', color: highlights.length > 0 ? '#ef4444' : '#64748b' },
                    { label: 'File Name', value: uploadedFile.name, icon: '🏷️', color: '#64748b' },
                  ].map(row => (
                    <Box key={row.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)' }}>
                      <Typography fontSize={20} lineHeight={1}>{row.icon}</Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography fontSize={10} color="text.disabled" fontWeight={600} sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>{row.label}</Typography>
                        <Typography fontSize={13} fontWeight={600} sx={{ color: row.color }}>{row.value}</Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>

                <Box sx={{ p: 1.5, borderRadius: '8px', bgcolor: isDark ? 'rgba(59,130,246,0.06)' : 'rgba(59,130,246,0.04)', border: '1px solid', borderColor: 'rgba(59,130,246,0.15)', textAlign: 'center' }}>
                  <Typography fontSize={10} color="text.secondary">
                    Only the referenced page will be saved.{highlights.length > 0 ? ' Highlights will be rendered on the reference image.' : ''}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })()}

        {step === 3 && uploadedFile && refAreas.length > 0 && (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, py: 1.5, bgcolor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.04)', borderBottom: '1px solid', borderColor: 'divider', flexWrap: 'wrap' }}>
              <Typography fontSize={12} color="text.secondary" sx={{ mr: 1 }}>Highlight tools (optional):</Typography>
              <ToggleButtonGroup value={highlightTool} exclusive onChange={(_, v) => { setHighlightTool(v); setHighlightMode(!!v); }} size="small">
                <ToggleButton value="line" sx={{ px: 2 }}>
                  <Tooltip title="Draw line"><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><RemoveIcon sx={{ fontSize: 16 }} /><Typography fontSize={11}>Line</Typography></Box></Tooltip>
                </ToggleButton>
                <ToggleButton value="rect" sx={{ px: 2 }}>
                  <Tooltip title="Draw rectangle"><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><CropFreeIcon sx={{ fontSize: 16 }} /><Typography fontSize={11}>Rectangle</Typography></Box></Tooltip>
                </ToggleButton>
                <ToggleButton value="circle" sx={{ px: 2 }}>
                  <Tooltip title="Draw circle"><Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><RadioButtonUncheckedIcon sx={{ fontSize: 16 }} /><Typography fontSize={11}>Circle</Typography></Box></Tooltip>
                </ToggleButton>
              </ToggleButtonGroup>
              
              {highlightTool === 'line' && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1.5 }}>
                  <Typography fontSize={10} color="text.secondary">Thickness:</Typography>
                  <ToggleButtonGroup value={highlightThickness} exclusive onChange={(_, v) => { if (v) setHighlightThickness(v); }} size="small">
                    {[2, 3, 5, 8].map(t => (
                      <ToggleButton key={t} value={t} sx={{ px: 1, minWidth: 32 }}>
                        <Box sx={{ width: 16, height: t, bgcolor: highlightColor, borderRadius: 1 }} />
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Box>
              )}
              
              {highlightTool && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1.5 }}>
                  <Typography fontSize={10} color="text.secondary" sx={{ mr: 0.5 }}>Color:</Typography>
                  {HIGHLIGHT_COLORS.map(c => (
                    <Box 
                      key={c.color}
                      onClick={() => setHighlightColor(c.color)}
                      sx={{ 
                        width: 22, height: 22, borderRadius: '50%', bgcolor: c.color, cursor: 'pointer',
                        border: highlightColor === c.color ? '3px solid #fff' : '2px solid rgba(255,255,255,0.3)',
                        boxShadow: highlightColor === c.color ? `0 0 0 2px ${c.color}` : 'none',
                        transition: 'all 0.15s',
                        '&:hover': { transform: 'scale(1.15)' }
                      }}
                    />
                  ))}
                </Box>
              )}
              
              {highlights.length > 0 && (
                <Button size="small" onClick={() => setHighlights([])} sx={{ ml: 2, fontSize: 11, textTransform: 'none' }}>Clear all</Button>
              )}
              
              <ViewerZoomControls zoom={viewerZoom} onZoomChange={setViewerZoom} variant="light" sx={{ ml: 2 }} />
            </Box>

            <Box 
              onWheel={(e) => { e.preventDefault(); setViewerZoom(z => { const dir = e.deltaY < 0 ? 1 : -1; const idx = ZOOM_LEVELS.findIndex(l => l >= z); const newIdx = Math.max(0, Math.min(ZOOM_LEVELS.length - 1, (idx === -1 ? ZOOM_LEVELS.length - 1 : idx) + dir)); return ZOOM_LEVELS[newIdx]; }); }}
              sx={{ flex: 1, position: 'relative', overflow: 'auto', bgcolor: '#525659' }}>
              <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {(() => {
                  const refArea = refAreas[0];
                  const pageUrl = pageImages[refArea.page - 1] || uploadedFile.previewUrl || '';
                  
                  return (
                    <Box sx={{ position: 'relative', display: 'inline-block', transform: `scale(${viewerZoom})`, transformOrigin: 'center center', transition: 'transform 0.1s' }}>
                      <Box sx={{ position: 'relative', boxShadow: '0 4px 24px rgba(0,0,0,0.4)', background: '#fff' }}>
                        <img 
                          src={pageUrl} 
                          alt={`Page ${refArea.page}`}
                          style={{ 
                            display: 'block', 
                            maxWidth: '90vw', 
                            maxHeight: 'calc(100vh - 200px)',
                            userSelect: 'none'
                          }} 
                          draggable={false}
                        />
                        <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                          <defs>
                            <mask id="highlight-ref-mask">
                              <rect x="0" y="0" width="100%" height="100%" fill="white" />
                              <rect x={`${refArea.x}%`} y={`${refArea.y}%`} width={`${refArea.w}%`} height={`${refArea.h}%`} fill="black" />
                            </mask>
                          </defs>
                          <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.5)" mask="url(#highlight-ref-mask)" />
                          <rect x={`${refArea.x}%`} y={`${refArea.y}%`} width={`${refArea.w}%`} height={`${refArea.h}%`} fill="none" stroke="#3b82f6" strokeWidth="2" strokeDasharray="6,3" />
                        </svg>
                        <Box 
                          ref={highlightOverlayRef}
                          onMouseDown={(e) => {
                            if (!highlightMode || !highlightTool) return;
                            const rect = e.currentTarget.getBoundingClientRect();
                            const x = (e.clientX - rect.left) / viewerZoom;
                            const y = (e.clientY - rect.top) / viewerZoom;
                            setIsHighlighting(true);
                            setHighlightStart({ x, y });
                            setHighlightCurrent({ x, y });
                          }}
                          onMouseMove={(e) => {
                            if (!isHighlighting || !highlightMode || !highlightTool) return;
                            const rect = e.currentTarget.getBoundingClientRect();
                            const unscaledWidth = rect.width / viewerZoom;
                            const unscaledHeight = rect.height / viewerZoom;
                            setHighlightCurrent({
                              x: Math.max(0, Math.min((e.clientX - rect.left) / viewerZoom, unscaledWidth)),
                              y: Math.max(0, Math.min((e.clientY - rect.top) / viewerZoom, unscaledHeight))
                            });
                          }}
                          onMouseUp={() => {
                            if (isHighlighting && highlightStart && highlightCurrent && highlightOverlayRef.current && highlightTool) {
                              const rect = highlightOverlayRef.current.getBoundingClientRect();
                              const unscaledWidth = rect.width / viewerZoom;
                              const unscaledHeight = rect.height / viewerZoom;
                              const minDist = highlightTool === 'line' ? 20 : 10;
                              const dist = Math.sqrt(Math.pow(highlightCurrent.x - highlightStart.x, 2) + Math.pow(highlightCurrent.y - highlightStart.y, 2));
                              if (dist > minDist) {
                                setHighlights(prev => [...prev, {
                                  type: highlightTool,
                                  x1: (highlightStart.x / unscaledWidth) * 100,
                                  y1: (highlightStart.y / unscaledHeight) * 100,
                                  x2: (highlightCurrent.x / unscaledWidth) * 100,
                                  y2: (highlightCurrent.y / unscaledHeight) * 100,
                                  page: refArea.page,
                                  color: highlightColor,
                                  thickness: highlightTool === 'line' ? highlightThickness : undefined
                                }]);
                              }
                            }
                            setIsHighlighting(false); setHighlightStart(null); setHighlightCurrent(null);
                          }}
                          sx={{ 
                            position: 'absolute', 
                            left: `${refArea.x}%`, top: `${refArea.y}%`,
                            width: `${refArea.w}%`, height: `${refArea.h}%`,
                            cursor: (highlightMode && highlightTool) ? 'crosshair' : 'default',
                            zIndex: 2 
                          }}
                        >
                          <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                            {highlights.map((h, i) => {
                              const c = h.color || '#f59e0b';
                              const hexToRgba = (hex: string, alpha: number) => {
                                const r = parseInt(hex.slice(1, 3), 16);
                                const g = parseInt(hex.slice(3, 5), 16);
                                const b = parseInt(hex.slice(5, 7), 16);
                                return `rgba(${r},${g},${b},${alpha})`;
                              };
                              if (h.type === 'line') {
                                return <line key={i} x1={`${h.x1}%`} y1={`${h.y1}%`} x2={`${h.x2}%`} y2={`${h.y2}%`} stroke={hexToRgba(c, 0.7)} strokeWidth={h.thickness || 3} strokeLinecap="round" />;
                              } else if (h.type === 'rect') {
                                const x = Math.min(h.x1, h.x2);
                                const y = Math.min(h.y1, h.y2);
                                const w = Math.abs(h.x2 - h.x1);
                                const hh = Math.abs(h.y2 - h.y1);
                                return <rect key={i} x={`${x}%`} y={`${y}%`} width={`${w}%`} height={`${hh}%`} fill={hexToRgba(c, 0.15)} stroke={hexToRgba(c, 0.7)} strokeWidth="2" rx="3" />;
                              } else {
                                const cx = (h.x1 + h.x2) / 2;
                                const cy = (h.y1 + h.y2) / 2;
                                const rx = Math.abs(h.x2 - h.x1) / 2;
                                const ry = Math.abs(h.y2 - h.y1) / 2;
                                return <ellipse key={i} cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={hexToRgba(c, 0.15)} stroke={hexToRgba(c, 0.7)} strokeWidth="2" />;
                              }
                            })}
                            {isHighlighting && highlightStart && highlightCurrent && highlightOverlayRef.current && highlightTool && (() => {
                              const rect = highlightOverlayRef.current.getBoundingClientRect();
                              const unscaledWidth = rect.width / viewerZoom;
                              const unscaledHeight = rect.height / viewerZoom;
                              const x1 = (highlightStart.x / unscaledWidth) * 100;
                              const y1 = (highlightStart.y / unscaledHeight) * 100;
                              const x2 = (highlightCurrent.x / unscaledWidth) * 100;
                              const y2 = (highlightCurrent.y / unscaledHeight) * 100;
                              const c = highlightColor;
                              const hexToRgba2 = (hex: string, alpha: number) => {
                                const r = parseInt(hex.slice(1, 3), 16);
                                const g = parseInt(hex.slice(3, 5), 16);
                                const b = parseInt(hex.slice(5, 7), 16);
                                return `rgba(${r},${g},${b},${alpha})`;
                              };
                              if (highlightTool === 'line') {
                                return <line x1={`${x1}%`} y1={`${y1}%`} x2={`${x2}%`} y2={`${y2}%`} stroke={hexToRgba2(c, 0.7)} strokeWidth={highlightThickness} strokeLinecap="round" strokeDasharray="8,4" />;
                              } else if (highlightTool === 'rect') {
                                const x = Math.min(x1, x2);
                                const y = Math.min(y1, y2);
                                const w = Math.abs(x2 - x1);
                                const h = Math.abs(y2 - y1);
                                return <rect x={`${x}%`} y={`${y}%`} width={`${w}%`} height={`${h}%`} fill={hexToRgba2(c, 0.08)} stroke={hexToRgba2(c, 0.5)} strokeWidth="2" strokeDasharray="6,3" rx="3" />;
                              } else {
                                const cx = (x1 + x2) / 2;
                                const cy = (y1 + y2) / 2;
                                const rx = Math.abs(x2 - x1) / 2;
                                const ry = Math.abs(y2 - y1) / 2;
                                return <ellipse cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={hexToRgba2(c, 0.08)} stroke={hexToRgba2(c, 0.5)} strokeWidth="2" strokeDasharray="6,3" />;
                              }
                            })()}
                          </svg>
                        </Box>
                      </Box>
                      <Box sx={{ position: 'absolute', top: -28, left: `${refArea.x}%`, bgcolor: '#3b82f6', color: '#E3E3DF', px: 1.5, py: 0.4, borderRadius: '6px 6px 0 0', fontSize: 11, fontWeight: 700 }}>
                        Cited reference — Page {refAreas[0].page}
                      </Box>
                    </Box>
                  );
                })()}
              </Box>
              
              <Box sx={{ position: 'absolute', bottom: 12, left: '50%', transform: 'translateX(-50%)', bgcolor: 'rgba(0,0,0,0.7)', color: '#E3E3DF', px: 2.5, py: 1, borderRadius: '10px', textAlign: 'center' }}>
                <Typography fontSize={12} fontWeight={600}>
                  {highlightMode ? `Draw ${highlightTool}s inside the reference box` : 'Select a tool to add highlights, or skip'}
                </Typography>
                <Typography fontSize={10} sx={{ opacity: 0.7, mt: 0.3 }}>
                  {highlights.length > 0 ? `${highlights.length} highlight${highlights.length > 1 ? 's' : ''} added` : 'Highlights appear on the saved reference image'}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      <Divider />
      <Box sx={{ px: 3, py: 1.5, display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
        <Box>
          {step > 1 && !extracting && (
            <Button onClick={() => {
              if (step === 3) setStep(2);
              else if (step === 4) setStep(3);
              else setStep(s => (s-1) as 1|2|3|4);
            }} color="inherit" sx={{ fontWeight:500, textTransform:'none' }}>Back</Button>
          )}
        </Box>
        <Box sx={{ display:'flex', alignItems:'center', gap: 2 }}>
          {step === 1 && !uploading && uploadStatus !== 'error' && (
            <Button color="inherit" sx={{ fontWeight:500, textTransform:'none' }} onClick={onClose}>Cancel</Button>
          )}
          {step === 2 && !drawMode && refAreas.length > 0 && (
            <Button variant="contained" onClick={() => setStep(3)}
              sx={{ fontWeight:600, textTransform:'none', px: 3 }}>
              Continue to Highlighting →
            </Button>
          )}
          {step === 3 && (
            <>
              <Button color="inherit" onClick={() => setStep(4)} sx={{ fontWeight:500, textTransform:'none' }}>
                Skip Highlighting
              </Button>
              <Button variant="contained" onClick={() => setStep(4)}
                sx={{ fontWeight:600, textTransform:'none', px: 3 }}>
                {highlights.length > 0 ? 'Continue with Highlights →' : 'Continue →'}
              </Button>
            </>
          )}
          {step === 4 && (
            <Button variant="contained" onClick={handleConfirm} disabled={extracting}
              sx={{ fontWeight:600, textTransform:'none', px: 3 }}>
              {extracting ? 'Saving…' : 'Done — Save Reference'}
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};


// ▓▓▓▓▓ CANVAS HELPERS ▓▓▓▓▓
type GraphNode = { id: string; label: string; type: string; occurrences: number; boardCount: number; trust: number; hasEvidence: boolean; isSeed: boolean; exampleSourceId: string; exampleBoardId: string };
type GraphEdge = { source: string; target: string; weight: number };
const SourceGraphDialog: React.FC<{
  open: boolean; onClose: () => void; sourceId: string; sourceLabel: string;
  isDark: boolean; onOpenBoard: (boardId: string) => void;
}> = ({ open, onClose, sourceId, sourceLabel, isDark, onOpenBoard }) => {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [status, setStatus] = useState<'idle' | 'loading' | 'ready' | 'empty' | 'error'>('idle');
  const [data, setData] = useState<{ nodes: GraphNode[]; edges: GraphEdge[]; boards: number } | null>(null);
  const [selected, setSelected] = useState<GraphNode | null>(null);
  const simRef = useRef<any>(null);

  useEffect(() => {
    if (!open || !sourceId) return;
    let cancelled = false;
    setStatus('loading'); setData(null); setSelected(null);
    fetch(`${API_BASE}/public/graph/source/${encodeURIComponent(sourceId)}`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then(d => {
        if (cancelled) return;
        if (!d.nodes || d.nodes.length === 0) { setStatus('empty'); return; }
        setData({ nodes: d.nodes, edges: d.edges || [], boards: d.boards || 0 });
        setStatus('ready');
      })
      .catch(() => { if (!cancelled) setStatus('error'); });
    return () => { cancelled = true; };
  }, [open, sourceId]);

  useEffect(() => {
    if (status !== 'ready' || !data || !svgRef.current) return;
    let disposed = false;
    loadD3().then((d3) => {
      if (disposed || !svgRef.current) return;
      const width = svgRef.current.clientWidth || 640;
      const height = svgRef.current.clientHeight || 460;
      const svg = d3.select(svgRef.current);
      svg.selectAll('*').remove();
      const g = svg.append('g');
      svg.call(d3.zoom().scaleExtent([0.2, 4]).on('zoom', (ev: any) => g.attr('transform', ev.transform)));

      const nodes = data.nodes.map((n) => ({ ...n }));
      const links = data.edges.map((e) => ({ ...e }));
      const colorFor = (t: string) => (SOURCE_COLORS as Record<string, string>)[t] || '#64748b';
      const radius = (n: GraphNode) => 7 + Math.min(18, Math.sqrt(n.occurrences) * 4) + (n.isSeed ? 4 : 0);

      const sim = d3.forceSimulation(nodes)
        .force('link', d3.forceLink(links).id((d: any) => d.id).distance(90).strength(0.4))
        .force('charge', d3.forceManyBody().strength(-260))
        .force('center', d3.forceCenter(width / 2, height / 2))
        .force('collide', d3.forceCollide().radius((d: any) => radius(d) + 6));
      simRef.current = sim;

      const link = g.append('g').attr('stroke', isDark ? '#475569' : '#cbd5e1').attr('stroke-opacity', 0.7)
        .selectAll('line').data(links).join('line')
        .attr('stroke-width', (d: any) => 1 + Math.min(4, d.weight));

      const node = g.append('g').selectAll('g').data(nodes).join('g').style('cursor', 'pointer');
      node.append('circle')
        .attr('r', (d: any) => radius(d))
        .attr('fill', (d: any) => colorFor(d.type))
        .attr('stroke', (d: any) => d.isSeed ? (isDark ? '#fff' : '#111') : (d.hasEvidence ? '#10b981' : (isDark ? '#1e293b' : '#fff')))
        .attr('stroke-width', (d: any) => d.isSeed ? 3 : (d.hasEvidence ? 2.5 : 1.5));
      node.append('text')
        .text((d: any) => d.label.length > 24 ? d.label.slice(0, 24) + '…' : d.label)
        .attr('x', (d: any) => radius(d) + 4).attr('y', 4)
        .attr('font-size', 11).attr('fill', isDark ? '#e2e8f0' : '#1e293b')
        .style('pointer-events', 'none').style('paint-order', 'stroke')
        .attr('stroke', isDark ? '#0f172a' : '#fff').attr('stroke-width', 3);
      node.on('click', (_ev: any, d: any) => setSelected(d));
      node.append('title').text((d: any) => `${d.label}\n${d.type} · ${d.occurrences} occurrence(s) in ${d.boardCount} board(s)`);

      node.call(d3.drag()
        .on('start', (ev: any, d: any) => { if (!ev.active) sim.alphaTarget(0.3).restart(); d.fx = d.x; d.fy = d.y; })
        .on('drag', (ev: any, d: any) => { d.fx = ev.x; d.fy = ev.y; })
        .on('end', (ev: any, d: any) => { if (!ev.active) sim.alphaTarget(0); d.fx = null; d.fy = null; }));

      sim.on('tick', () => {
        link.attr('x1', (d: any) => d.source.x).attr('y1', (d: any) => d.source.y)
            .attr('x2', (d: any) => d.target.x).attr('y2', (d: any) => d.target.y);
        node.attr('transform', (d: any) => `translate(${d.x},${d.y})`);
      });
    }).catch(() => setStatus('error'));
    return () => { disposed = true; if (simRef.current) { simRef.current.stop(); simRef.current = null; } };
  }, [status, data, isDark]);

  const distinctTypes = data ? Array.from(new Set(data.nodes.map(n => n.type))) : [];

  return (
    <Dialog open={open} onClose={onClose} disableScrollLock maxWidth="md" fullWidth
      PaperProps={{ sx: { height: '80vh', bgcolor: 'background.default' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <HubIcon sx={{ color: '#38bdf8' }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography fontWeight={600} noWrap>Source graph</Typography>
          <Typography variant="caption" color="text.secondary" noWrap>{sourceLabel}</Typography>
        </Box>
        <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', position: 'relative' }}>
        {status === 'loading' && <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5 }}><CircularProgress size={20} /><Typography color="text.secondary">Building the graph…</Typography></Box>}
        {status === 'empty' && <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, p: 3, textAlign: 'center' }}><HubIcon sx={{ fontSize: 40, color: 'text.disabled' }} /><Typography color="text.secondary">This source doesn’t appear on any other public board yet.</Typography><Typography variant="caption" color="text.secondary">As more boards cite it, they’ll connect here.</Typography></Box>}
        {status === 'error' && <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}><Typography color="error">Couldn’t load the graph. Please try again.</Typography></Box>}
        {status === 'ready' && data && (
          <>
            <Box sx={{ px: 2, py: 1, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', borderBottom: '1px solid', borderColor: 'divider' }}>
              <Typography variant="caption" color="text.secondary">{data.nodes.length} sources · {data.edges.length} links · appears in {data.boards} board{data.boards === 1 ? '' : 's'}</Typography>
              <Box sx={{ flex: 1 }} />
              {distinctTypes.slice(0, 6).map(t => (
                <Box key={t} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: (SOURCE_COLORS as Record<string, string>)[t] || '#64748b' }} />
                  <Typography variant="caption" color="text.secondary">{t}</Typography>
                </Box>
              ))}
            </Box>
            <Box sx={{ flex: 1, position: 'relative', minHeight: 0 }}>
              <svg ref={svgRef} style={{ width: '100%', height: '100%', display: 'block' }} />
              {selected && (
                <Paper elevation={4} sx={{ position: 'absolute', right: 12, bottom: 12, width: 260, p: 1.5, borderRadius: 2 }}>
                  <Typography variant="subtitle2" sx={{ mb: 0.5, wordBreak: 'break-word' }}>{selected.label}</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">{selected.type} · trust {selected.trust || '—'}{selected.hasEvidence ? ' · has evidence' : ''}</Typography>
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>{selected.occurrences} occurrence(s) across {selected.boardCount} board(s)</Typography>
                  <Button size="small" variant="contained" fullWidth onClick={() => { onOpenBoard(selected.exampleBoardId); onClose(); }} sx={{ textTransform: 'none' }}>Open a board with this source</Button>
                </Paper>
              )}
            </Box>
            <Box sx={{ px: 2, py: 0.8, borderTop: '1px solid', borderColor: 'divider' }}>
              <Typography variant="caption" color="text.secondary">Bigger node = cited more often · green ring = has archived evidence · outlined = this source · drag to rearrange, scroll to zoom.</Typography>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

const ArchiveReplayScene: React.FC<{
  htmlUrl?: string;
  warcUrl?: string;
  refArea?: { x: number; y: number; w: number; h: number; label?: string };
}> = ({ htmlUrl, warcUrl, refArea }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const sceneRef = useRef<HTMLDivElement | null>(null);
  const [zoom, setZoom] = useState(1);
  const [pageH, setPageH] = useState(4000);
  const BASE_W = 1024;

  const centerOnRef = useCallback((behavior: ScrollBehavior = 'smooth') => {
    const sc = scrollRef.current;
    if (!sc || !refArea) return;
    const markerCyLogical = ((refArea.y + refArea.h / 2) / 100) * pageH;
    const markerCxLogical = ((refArea.x + refArea.w / 2) / 100) * BASE_W;
    sc.scrollTo({
      top: markerCyLogical * zoom - sc.clientHeight / 2,
      left: markerCxLogical * zoom - sc.clientWidth / 2,
      behavior,
    });
  }, [refArea, pageH, zoom]);

  useEffect(() => {
    if (!refArea) return;
    const t = setTimeout(() => centerOnRef('smooth'), 700);
    return () => clearTimeout(t);
  }, [refArea, centerOnRef]);

  useEffect(() => { if (refArea) centerOnRef('auto'); }, [zoom]); // eslint-disable-line

  useEffect(() => {
    const h = () => centerOnRef('smooth');
    window.addEventListener('archive-goto-ref', h);
    return () => window.removeEventListener('archive-goto-ref', h);
  }, [centerOnRef]);

  const onIframeLoad = useCallback(() => {
    if (refArea) setTimeout(() => centerOnRef('smooth'), 150);
  }, [refArea, centerOnRef]);

  const zoomStep = (dir: 1 | -1) => setZoom(z => Math.min(2, Math.max(0.25, Math.round((z + dir * 0.15) * 100) / 100)));

  if (!htmlUrl) {
    return (
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.5)' }}>
        <Box sx={{ textAlign: 'center' }}>
          <LanguageIcon sx={{ fontSize: 48, mb: 1, opacity: 0.3 }} />
          <Typography fontSize={14}>No HTML preview available</Typography>
          {warcUrl && <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => window.open(safeHref(warcUrl) || 'about:blank', '_blank', 'noopener,noreferrer')} sx={{ mt: 2, color: 'rgba(255,255,255,0.7)', borderColor: 'rgba(255,255,255,0.2)', textTransform: 'none' }}>Download WARC file</Button>}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, position: 'relative', minHeight: 0, bgcolor: '#0f172a' }}>
      <Box sx={{ position: 'absolute', bottom: 16, right: 16, zIndex: 5, display: 'flex', flexDirection: 'column', gap: 0.5, bgcolor: 'rgba(15,23,42,0.9)', borderRadius: '10px', p: 0.5, border: '1px solid rgba(255,255,255,0.1)' }}>
        <IconButton size="small" onClick={() => zoomStep(1)} sx={{ color: '#E3E3DF' }} aria-label="Zoom in"><AddIcon sx={{ fontSize: 18 }} /></IconButton>
        <Typography sx={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', textAlign: 'center', fontFamily: 'monospace' }}>{Math.round(zoom * 100)}%</Typography>
        <IconButton size="small" onClick={() => zoomStep(-1)} sx={{ color: '#E3E3DF' }} aria-label="Zoom out"><RemoveIcon sx={{ fontSize: 18 }} /></IconButton>
        {refArea && <IconButton size="small" onClick={() => centerOnRef('smooth')} sx={{ color: '#3b82f6' }} aria-label="Center on reference"><CropFreeIcon sx={{ fontSize: 16 }} /></IconButton>}
      </Box>

      <Box ref={scrollRef} sx={{ position: 'absolute', inset: 0, overflow: 'auto' }}>
        <Box ref={sceneRef} sx={{ position: 'relative', width: BASE_W * zoom, height: pageH * zoom }}>
          <iframe
            id="warc-iframe" title="Archived page" src={safeHref(htmlUrl) || 'about:blank'}
            onLoad={onIframeLoad}
            style={{ width: BASE_W, height: pageH, border: 'none', backgroundColor: '#fff', transform: `scale(${zoom})`, transformOrigin: 'top left' }}
            sandbox="allow-scripts" referrerPolicy="no-referrer" loading="lazy"
          />
          {refArea && (
            <Box sx={{
              position: 'absolute', pointerEvents: 'none',
              left: (refArea.x / 100) * BASE_W * zoom,
              top: (refArea.y / 100) * pageH * zoom,
              width: (refArea.w / 100) * BASE_W * zoom,
              height: (refArea.h / 100) * pageH * zoom,
              border: '3px solid #3b82f6', borderRadius: '4px',
              boxShadow: '0 0 0 9999px rgba(15,23,42,0.35), 0 0 18px rgba(59,130,246,0.6)',
              transition: 'all 120ms',
            }}>
              {refArea.label && (
                <Box sx={{ position: 'absolute', top: -22, left: 0, bgcolor: '#3b82f6', color: '#fff', fontSize: 10, fontWeight: 700, px: 0.8, py: 0.2, borderRadius: '4px', whiteSpace: 'nowrap' }}>{refArea.label}</Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const EmbedDialog: React.FC<{
  open: boolean; onClose: () => void; sourceId: string; sourceLabel: string;
  isDark: boolean; getToken?: () => Promise<string | null>;
}> = ({ open, onClose, sourceId, sourceLabel, isDark, getToken }) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://source.io';
  const [keys, setKeys] = useState<Array<{ id: number; prefix: string; label: string; requestCount: number }>>([]);
  const [newKey, setNewKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [copied, setCopied] = useState('');
  const [keyLabel, setKeyLabel] = useState('');
  const [origins, setOrigins] = useState('');

  const authFetch = useCallback(async (path: string, opts: RequestInit = {}) => {
    const token = getToken ? await getToken() : null;
    const headers: Record<string, string> = { ...(opts.headers as Record<string, string> || {}) };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return fetch(`${API_BASE}${path}`, { ...opts, headers });
  }, [getToken]);

  const loadKeys = useCallback(async () => {
    try {
      const r = await authFetch('/keys');
      if (r.ok) { const j = await r.json(); setKeys(j.keys || []); }
    } catch {}
  }, [authFetch]);

  useEffect(() => { if (open) { setNewKey(null); setErr(''); loadKeys(); } }, [open, loadKeys]);

  const createKey = async () => {
    setLoading(true); setErr('');
    try {
      const r = await authFetch('/keys', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ label: keyLabel, origins }) });
      const j = await r.json();
      if (!r.ok) { setErr(j.error || 'Could not create key'); return; }
      setNewKey(j.key); setKeyLabel(''); loadKeys();
    } catch { setErr('Network error'); } finally { setLoading(false); }
  };

  const deleteKey = async (id: number) => {
    try { await authFetch(`/keys/${id}`, { method: 'DELETE' }); loadKeys(); } catch {}
  };

  const copy = async (text: string, tag: string) => {
    try { await navigator.clipboard.writeText(text); setCopied(tag); setTimeout(() => setCopied(''), 1600); } catch {}
  };

  const keyForSnippet = newKey || (keys.length ? `sio_${keys[0].prefix}_YOUR_SECRET` : 'sio_YOUR_KEY');
  const scriptTag = `<script src="${origin}/embed.js" data-key="${keyForSnippet}"><\/script>`;
  const markerExample = `Text you want to cite [[cite:${sourceId}]]the exact quoted passage[[/cite]] continues here.`;

  const codeBox = (label: string, code: string, tag: string) => (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography fontSize={12} fontWeight={600} color="text.secondary">{label}</Typography>
        <Button size="small" startIcon={copied === tag ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />} onClick={() => copy(code, tag)} sx={{ textTransform: 'none', minWidth: 84 }}>{copied === tag ? 'Copied' : 'Copy'}</Button>
      </Box>
      <Box component="pre" sx={{ m: 0, p: 1.2, borderRadius: '8px', bgcolor: isDark ? 'rgba(0,0,0,0.35)' : 'rgba(0,0,0,0.04)', border: '1px solid', borderColor: 'divider', fontSize: 11.5, fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all', lineHeight: 1.5 }}>{code}</Box>
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} disableScrollLock maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <CodeIcon sx={{ color: '#3b82f6' }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography fontWeight={700}>Embed this source on your site</Typography>
          <Typography variant="caption" color="text.secondary" noWrap>{sourceLabel} · {sourceId}</Typography>
        </Box>
        <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography fontSize={13} color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
          Add the script once per page, then wrap any cited text in markers. A numbered “source” badge appears; clicking highlights the passage, clicking again shows this source’s details.
        </Typography>

        <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>1 · Your API key</Typography>
        {newKey ? (
          <Box sx={{ mb: 2, p: 1.2, borderRadius: '8px', border: '1px solid', borderColor: 'success.main', bgcolor: isDark ? 'rgba(16,185,129,0.08)' : 'rgba(16,185,129,0.06)' }}>
            <Typography fontSize={11} color="text.secondary" sx={{ mb: 0.5 }}>Copy this now — it won’t be shown again:</Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Box component="code" sx={{ flex: 1, fontSize: 11.5, fontFamily: 'monospace', wordBreak: 'break-all' }}>{newKey}</Box>
              <Button size="small" startIcon={copied === 'key' ? <CheckIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />} onClick={() => copy(newKey, 'key')} sx={{ textTransform: 'none' }}>{copied === 'key' ? 'Copied' : 'Copy'}</Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ mb: 2 }}>
            {keys.length > 0 && (
              <Box sx={{ mb: 1.5 }}>
                {keys.map(k => (
                  <Box key={k.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.4 }}>
                    <Box component="code" sx={{ fontSize: 11, fontFamily: 'monospace' }}>sio_{k.prefix}_…</Box>
                    <Typography fontSize={11} color="text.secondary">{k.label || 'key'} · {k.requestCount} calls</Typography>
                    <Box sx={{ flex: 1 }} />
                    <Button size="small" color="error" onClick={() => deleteKey(k.id)} sx={{ textTransform: 'none', minWidth: 0 }}>Delete</Button>
                  </Box>
                ))}
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
              <TextField size="small" label="Label (optional)" value={keyLabel} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyLabel(e.target.value)} sx={{ flex: '1 1 140px' }} />
              <TextField size="small" label="Allowed sites (optional)" placeholder="example.com" value={origins} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOrigins(e.target.value)} sx={{ flex: '1 1 160px' }} />
              <Button variant="contained" onClick={createKey} disabled={loading} sx={{ textTransform: 'none' }}>{loading ? 'Creating…' : 'Generate key'}</Button>
            </Box>
            {err && <Typography fontSize={11} color="error" sx={{ mt: 0.8 }}>{err}</Typography>}
          </Box>
        )}

        <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>2 · Add the script (once per page)</Typography>
        {codeBox('Paste before </body>', scriptTag, 'script')}

        <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>3 · Mark your cited text</Typography>
        {codeBox('Wrap the passage with cite-start / cite-stop', markerExample, 'marker')}
        <Typography fontSize={11} color="text.secondary" sx={{ lineHeight: 1.6 }}>
          The badge shows “source 1”, “source 2”, … in the order markers appear on the page. Readers click to highlight the cited text, and again to open a small card with the source title, trust score, cited part, and a link back to source.io.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

const SourceContextMenu: React.FC<{ anchorPosition: { x: number; y: number } | null; onClose: () => void; onDelete: () => void; onEdit: () => void; onViewGraph?: () => void; onEmbed?: () => void; isPublic: boolean; readOnly?: boolean }> = ({ anchorPosition, onClose, onDelete, onEdit, onViewGraph, onEmbed, isPublic, readOnly }) => (
  <Menu open={Boolean(anchorPosition)} onClose={onClose} disableScrollLock anchorReference="anchorPosition" anchorPosition={anchorPosition ? { top: anchorPosition.y, left: anchorPosition.x } : undefined}>
    {!readOnly && <MenuItem onClick={() => { onEdit(); onClose(); }} sx={{ gap: 1 }}><EditIcon fontSize="small" />Edit</MenuItem>}
    {onViewGraph && <MenuItem onClick={() => { onViewGraph(); onClose(); }} sx={{ gap: 1 }}><HubIcon fontSize="small" />View source graph</MenuItem>}
    {onEmbed && <MenuItem onClick={() => { onEmbed(); onClose(); }} sx={{ gap: 1 }}><CodeIcon fontSize="small" />Embed on your site</MenuItem>}
    {!readOnly && <Divider />}
    {!readOnly && <MenuItem onClick={() => { onDelete(); onClose(); }} sx={{ gap: 1, color: 'error.main' }}><DeleteIcon fontSize="small" />Delete</MenuItem>}
  </Menu>
);

let __d3Promise: Promise<any> | null = null;
const loadD3 = (): Promise<any> => {
  if ((window as any).d3) return Promise.resolve((window as any).d3);
  if (__d3Promise) return __d3Promise;
  __d3Promise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-d3]') as HTMLScriptElement | null;
    if (existing) {
      const t = setInterval(() => { if ((window as any).d3) { clearInterval(t); resolve((window as any).d3); } }, 50);
      setTimeout(() => clearInterval(t), 10000);
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/d3/7.9.0/d3.min.js';
    s.setAttribute('data-d3', 'true');
    s.onload = () => resolve((window as any).d3);
    s.onerror = () => { __d3Promise = null; reject(new Error('d3 load failed')); };
    document.head.appendChild(s);
  });
  return __d3Promise;
};

let __leafletPromise: Promise<any> | null = null;
const loadLeaflet = (): Promise<any> => {
  if ((window as any).L) return Promise.resolve((window as any).L);
  if (__leafletPromise) return __leafletPromise;
  __leafletPromise = new Promise((resolve, reject) => {
    if (!document.querySelector('link[data-leaflet]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      link.setAttribute('data-leaflet', 'true');
      document.head.appendChild(link);
    }
    const existing = document.querySelector('script[data-leaflet]') as HTMLScriptElement | null;
    if (existing) {
      const t = setInterval(() => { if ((window as any).L) { clearInterval(t); resolve((window as any).L); } }, 50);
      setTimeout(() => clearInterval(t), 10000);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.setAttribute('data-leaflet', 'true');
    script.onload = () => resolve((window as any).L);
    script.onerror = (err) => { __leafletPromise = null; reject(err); };
    document.head.appendChild(script);
  });
  return __leafletPromise;
};

const BookSectionIcon: React.FC<{ size?: number; accent?: string; style?: React.CSSProperties }> = ({ size = 24, accent = '#c4b5fd', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    aria-hidden="true"
    focusable="false">
    <path
      d="M3 5.5 C 6 5, 9 5.5, 12 6.5 C 15 5.5, 18 5, 21 5.5 L 21 18 C 18 17.5, 15 18, 12 19 C 9 18, 6 17.5, 3 18 Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round" />
    <line
      x1="12" y1="6.5"
      x2="12" y2="19"
      stroke="currentColor"
      strokeWidth="1.4" />
    <line x1="5"  y1="9.5"  x2="10.5" y2="9.5"  stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" opacity="0.7" />
    <line x1="5"  y1="11.5" x2="10.5" y2="11.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" opacity="0.7" />
    <line x1="5"  y1="13.5" x2="9"    y2="13.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" opacity="0.7" />
    <line x1="13.5" y1="9.5"  x2="19"   y2="9.5"  stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" opacity="0.7" />
    <line x1="13.5" y1="11.5" x2="19"   y2="11.5" stroke={accent}        strokeWidth="1.8" strokeLinecap="round" />
    <line x1="13.5" y1="13.5" x2="17.5" y2="13.5" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" opacity="0.7" />
    <path
      d="M 22.5 11.5 L 20.6 11.5"
      stroke={accent}
      strokeWidth="1.6"
      strokeLinecap="round"
      fill="none" />
    <polygon
      points="19.2,11.5 21.2,10.4 21.2,12.6"
      fill={accent} />
  </svg>
);

// ─── WaveSurfer.js loader ────────────────────────────────────────────────
let __waveSurferPromise: Promise<any> | null = null;
const loadWaveSurfer = (): Promise<any> => {
  if (typeof window !== 'undefined' && (window as any).WaveSurfer) return Promise.resolve((window as any).WaveSurfer);
  if (__waveSurferPromise) return __waveSurferPromise;
  __waveSurferPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/wavesurfer.js@7.8.6/dist/wavesurfer.min.js';
    script.async = true;
    script.onload = () => {
      const WS = (window as any).WaveSurfer;
      if (WS) resolve(WS);
      else reject(new Error('WaveSurfer failed to attach to window'));
    };
    script.onerror = () => reject(new Error('Failed to load WaveSurfer'));
    document.head.appendChild(script);
  });
  return __waveSurferPromise;
};

const formatAudioTime = (secs: number) => {
  if (!Number.isFinite(secs) || secs < 0) return '0:00';
  const total = Math.floor(secs);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;
};

const AudioPlayer: React.FC<{
  src: string;
  mode?: 'view' | 'set-ref';
  refTimestamp?: number;
  onSetReference?: (seconds: number) => void;
  onDurationLoad?: (durationSeconds: number) => void;
  isDark?: boolean;
  accent?: string;
  compact?: boolean;
}> = ({ src, mode = 'view', refTimestamp, onSetReference, onDurationLoad, isDark = true, accent = '#3b82f6', compact = false }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const wsRef = useRef<any>(null);
  const [ready, setReady] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const onSetRefRef = useRef(onSetReference);
  const onDurationRef = useRef(onDurationLoad);
  useEffect(() => { onSetRefRef.current = onSetReference; }, [onSetReference]);
  useEffect(() => { onDurationRef.current = onDurationLoad; }, [onDurationLoad]);

  useEffect(() => {
    let cancelled = false;
    setReady(false);
    setError(null);
    loadWaveSurfer().then((WS) => {
      if (cancelled || !containerRef.current) return;
      if (wsRef.current) {
        try { wsRef.current.destroy(); } catch {}
        wsRef.current = null;
      }
      const ws = WS.create({
        container: containerRef.current,
        waveColor: isDark ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.25)',
        progressColor: accent,
        cursorColor: accent,
        cursorWidth: 1,
        height: compact ? 32 : 56,
        barWidth: 2,
        barGap: 1,
        barRadius: 1,
        normalize: true,
        url: src,
      });
      wsRef.current = ws;
      ws.on('ready', () => {
        if (cancelled) return;
        setReady(true);
        const d = ws.getDuration();
        setDuration(d);
        if (onDurationRef.current) onDurationRef.current(d);
      });
      ws.on('audioprocess', () => { if (!cancelled) setCurrentTime(ws.getCurrentTime()); });
      ws.on('timeupdate', () => { if (!cancelled) setCurrentTime(ws.getCurrentTime()); });
      ws.on('play', () => { if (!cancelled) setPlaying(true); });
      ws.on('pause', () => { if (!cancelled) setPlaying(false); });
      ws.on('finish', () => { if (!cancelled) setPlaying(false); });
      if (mode === 'set-ref') {
        ws.on('interaction', (newTime: number) => {
          if (cancelled) return;
          if (onSetRefRef.current) onSetRefRef.current(newTime);
        });
      }
      ws.on('error', (e: any) => {
        if (cancelled) return;
        setError(e?.message || 'Audio failed to load');
      });
    }).catch((e: Error) => {
      if (!cancelled) setError(e.message || 'Audio player unavailable');
    });
    return () => {
      cancelled = true;
      if (wsRef.current) {
        try { wsRef.current.destroy(); } catch {}
        wsRef.current = null;
      }
    };
  }, [src]);


  const togglePlay = () => {
    const ws = wsRef.current;
    if (!ws || !ready) return;
    if (ws.isPlaying()) ws.pause();
    else ws.play();
  };

  const jumpToRef = () => {
    const ws = wsRef.current;
    if (!ws || !ready || refTimestamp === undefined || duration === 0) return;
    ws.seekTo(Math.min(0.999, refTimestamp / duration));
    ws.play();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8, width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          onClick={togglePlay}
          disabled={!ready}
          sx={{
            width: compact ? 32 : 40, height: compact ? 32 : 40,
            bgcolor: accent, color: '#fff',
            '&:hover': { bgcolor: accent, filter: 'brightness(0.9)' },
            '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'action.disabled' },
          }}>
          {playing ? <PauseIcon sx={{ fontSize: compact ? 16 : 20 }} /> : <PlayArrowIcon sx={{ fontSize: compact ? 16 : 20 }} />}
        </IconButton>
        <Box sx={{ flex: 1, position: 'relative', minWidth: 0 }}>
          <Box ref={containerRef} sx={{ width: '100%', cursor: ready ? 'pointer' : 'default', opacity: ready ? 1 : 0.4 }} />
          {ready && refTimestamp !== undefined && duration > 0 && (
            <Box sx={{
              position: 'absolute',
              top: 0, bottom: 0,
              left: `${Math.min(99, (refTimestamp / duration) * 100)}%`,
              width: 2,
              bgcolor: '#f59e0b',
              boxShadow: '0 0 6px rgba(245,158,11,0.6)',
              pointerEvents: 'none',
            }} />
          )}
          {!ready && !error && (
            <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress size={16} sx={{ color: accent }} />
            </Box>
          )}
          {error && (
            <Typography sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: 'error.main' }}>
              {error}
            </Typography>
          )}
        </Box>
        <Typography sx={{ fontSize: compact ? 10 : 12, fontFamily: 'monospace', color: 'text.secondary', flexShrink: 0, minWidth: compact ? 70 : 90, textAlign: 'right' }}>
          {formatAudioTime(currentTime)} / {formatAudioTime(duration)}
        </Typography>
      </Box>
      {mode === 'set-ref' && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 11, color: 'text.secondary' }}>
          {refTimestamp !== undefined ? (
            <>
              <Typography sx={{ fontSize: 11, color: '#f59e0b', fontWeight: 600 }}>
                Reference at {formatAudioTime(refTimestamp)}
              </Typography>
              <Box sx={{ flex: 1 }} />
              <Button size="small" variant="text" onClick={() => onSetReference?.(0)} sx={{ fontSize: 10, textTransform: 'none', minWidth: 0, color: 'text.disabled' }}>Clear</Button>
            </>
          ) : (
            <Typography sx={{ fontSize: 11 }}>
              Click the waveform to set the reference point.
            </Typography>
          )}
        </Box>
      )}
      {mode === 'view' && refTimestamp !== undefined && duration > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button size="small" variant="outlined" startIcon={<CenterFocusStrongIcon sx={{ fontSize: 13 }} />}
            onClick={jumpToRef}
            sx={{ fontSize: 11, textTransform: 'none', borderColor: '#f59e0b', color: '#f59e0b', '&:hover': { borderColor: '#f59e0b', bgcolor: 'rgba(245,158,11,0.08)' } }}>
            Jump to reference ({formatAudioTime(refTimestamp)})
          </Button>
        </Box>
      )}
    </Box>
  );
};

const LeafletMap: React.FC<{ lat: number; lon: number; recenterRef?: React.MutableRefObject<(() => void) | null> }> = ({ lat, lon, recenterRef }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<any>(null);
  const INITIAL_ZOOM = 13;

  useEffect(() => {
    let cancelled = false;
    loadLeaflet().then((L) => {
      if (cancelled || !containerRef.current) return;
      if (mapRef.current) { try { mapRef.current.remove(); } catch {} mapRef.current = null; }
      const map = L.map(containerRef.current, {
        center: [lat, lon],
        zoom: INITIAL_ZOOM,
        zoomControl: true,
        scrollWheelZoom: true,
        attributionControl: true,
      });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '© OpenStreetMap contributors',
      }).addTo(map);
      L.marker([lat, lon]).addTo(map);
      mapRef.current = map;
      if (recenterRef) {
        recenterRef.current = () => {
          if (mapRef.current) mapRef.current.setView([lat, lon], INITIAL_ZOOM, { animate: true });
        };
      }
      setTimeout(() => { if (!cancelled && mapRef.current) mapRef.current.invalidateSize(); }, 100);
    }).catch(() => {  });

    return () => {
      cancelled = true;
      if (recenterRef) recenterRef.current = null;
      if (mapRef.current) { try { mapRef.current.remove(); } catch {} mapRef.current = null; }
    };
  }, []);

  return <div ref={containerRef} style={{ position: 'absolute', inset: 0 }} />;
};

// ▓▓▓▓▓                S I N G L E   S Q U A R E                           ▓▓▓▓▓
//   ─── State + refs                  (top of component)
//   ─── handleX callbacks             (events; updates parent via onUpdate)
//   ─── Floating CTAs above box       (Set trust / Set reference / Upload file)
//   ─── Source-type label + headline
//   ─── Tab content rendering         (Summary / Info / Reference / Notes / Trust / Code / Detail)
//   ─── Trust assessment Dialog       (the full-screen rating dialog)
//   ─── Map dialog (event sources)    (Leaflet fullscreen with draggable info bubble)
//   ─── File preview Dialog           (image / PDF / web-archive viewer)
//   ─── Cover edit Dialog             (book/film)
const SingleSquare: React.FC<{
  square: SquareData; onUpdate: (id: number, size: Size, position: Position) => void;
  onSourceTypeChange: (id: number, sourceType: string | null, fields: SourceFields, file: UploadedFile | null, apiPrefillFields?: Record<string, string>) => void;
  onReferenceChange: (id: number, ref: ReferencePointer) => void;
  onDelete: (id: number) => void; onCopyId: (id: string) => void;
  onViewProfile?: (username: string) => void; zoom: number; isDark: boolean;
  isSelected: boolean; onSelect: (sourceId: string) => void; boardId: string; chainId?: string | null; isLast: boolean; chainEnded: boolean; chainEndReason?: string;
  isPublic: boolean; appMode: AppMode; onSelectMainSource?: () => void; initialTab?: 'ref' | 'file' | 'info'; canvasLocked?: boolean;
  onTrustRateChange?: (id: number, rates: TrustRates, assessed?: boolean) => void; username?: string; onCommentsChange?: (id: number, comments: string) => void; simpleView?: boolean; appSettings?: AppSettings;
  readOnly?: boolean;
  authToken?: string | null;
  getToken?: () => Promise<string | null>;
  overrideOrder?: number;
  nextSourceLabel?: string;
  creatorVerified?: boolean;
  fieldEdits?: Array<{ sourceId?: string; field: string; editedAt: string; oldValue: string; newValue: string; editedBy?: string }>;
  autoOpenFile?: boolean;
  onFileOpened?: () => void;
  simpleCardScale?: number;
  onOpenRefSettings?: () => void;
  onOpenEdit?: () => void;
  isExpandedSeed?: boolean;
  onCloseExpandedSeed?: () => void;
  onOpenTrustDialog?: (sourceId: string) => void;
  onTrustVote?: (sourceId: string, category: 'source' | 'reference', vote: 'agree' | 'disagree' | null) => void;
  allowTrustVoting?: boolean;
  onViewGraph?: (sourceId: string, label: string) => void;
  onEmbed?: (sourceId: string, label: string) => void;
}> = ({ square, onUpdate, onSourceTypeChange, onReferenceChange, onDelete, onCopyId, zoom, isDark, isSelected, onSelect, boardId, chainId, isLast, chainEnded, chainEndReason, isPublic, appMode, onSelectMainSource, initialTab, canvasLocked, onTrustRateChange, username, onCommentsChange, simpleView, appSettings, readOnly, authToken, getToken: getTokenProp, onViewProfile, overrideOrder, nextSourceLabel, creatorVerified, fieldEdits, autoOpenFile, onFileOpened, simpleCardScale, onOpenRefSettings, onOpenEdit, isExpandedSeed, onCloseExpandedSeed, onOpenTrustDialog, onTrustVote, allowTrustVoting, onViewGraph, onEmbed }) => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState<Position>({ x: 0, y: 0 });
  const [initialPosition, setInitialPosition] = useState<Position>(square.position);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [refDialogOpen, setRefDialogOpen] = useState(false);
  const [sourceTypeDialogOpen, setSourceTypeDialogOpen] = useState(false);
  const [pendingSourceType, setPendingSourceType] = useState<string | null>(null);
  const [tabValue, setTabValue] = useState<'summary' | 'info' | 'ref' | 'trust' | 'cite' | 'comments' | 'detail'>(initialTab === 'file' ? 'ref' : initialTab === 'ref' ? 'ref' : 'summary');
  const [tabMenuAnchor, setTabMenuAnchor] = useState<HTMLElement | null>(null);
  const [showCopied, setShowCopied] = useState(false);
  const [uploadWizardOpen, setUploadWizardOpen] = useState(false);
  const [imageFullscreen, setImageFullscreen] = useState(false);
  const [imageRefSelection, setImageRefSelection] = useState<{x:number;y:number;w:number;h:number}|null>(null);
  const [imageRefDragging, setImageRefDragging] = useState(false);
  const [imageRefStart, setImageRefStart] = useState<{x:number;y:number}|null>(null);
  const [contextMenu, setContextMenu] = useState<{ x: number; y: number } | null>(null);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  useEffect(() => {
    if (autoOpenFile && square.uploadedFile) {
      setImagePreviewOpen(true);
      onFileOpened?.();
    }
  }, [autoOpenFile]);
  const [mapDialogCoords, setMapDialogCoords] = useState<{lat:number;lon:number}|null>(null);
  const [mapBubbleOffset, setMapBubbleOffset] = useState<{x:number;y:number}>({ x: 16, y: 16 });
  const [mapBubbleDragging, setMapBubbleDragging] = useState(false);
  const [mapSpan, setMapSpan] = useState(0.15);
  const mapRecenterRef = useRef<(() => void) | null>(null);
  const [removeConfirmOpen, setRemoveConfirmOpen] = useState(false);
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);
  const [archiveStep, setArchiveStep] = useState<1|2|3>(1);
  const [archiveShowAdvanced, setArchiveShowAdvanced] = useState(false);
  const [archiveStatus, setArchiveStatus] = useState<'idle' | 'archiving' | 'done' | 'annotate' | 'error'>('idle');
  const [archiveResult, setArchiveResult] = useState<any>(null);
  const [archiveError, setArchiveError] = useState('');
  const [replayViewerOpen, setReplayViewerOpen] = useState(false);
  const [archiveHighlights, setArchiveHighlights] = useState<Array<{type:'line'|'rect'|'circle';x1:number;y1:number;x2:number;y2:number;color:string;thickness?:number}>>([]);
  const [archiveHlTool, setArchiveHlTool] = useState<'line'|'rect'|'circle'|null>(null);
  const [archiveHlColor, setArchiveHlColor] = useState('#f59e0b');
  const [archiveHlThickness, setArchiveHlThickness] = useState(3);
  const [archiveHlDrawing, setArchiveHlDrawing] = useState(false);
  const [archiveHlStart, setArchiveHlStart] = useState<{x:number;y:number}|null>(null);
  const [archiveHlCurrent, setArchiveHlCurrent] = useState<{x:number;y:number}|null>(null);
  const archiveHlRef = useRef<HTMLDivElement>(null);
  const [archiveImgHeight, setArchiveImgHeight] = useState(0);
  const ARCHIVE_HL_COLORS = [{ color: '#f59e0b', label: 'Orange' }, { color: '#ef4444', label: 'Red' }, { color: '#10b981', label: 'Green' }, { color: '#3b82f6', label: 'Blue' }];
  const [archiveScrollTime, setArchiveScrollTime] = useState(10);
  const [archiveBrowser, setArchiveBrowser] = useState<'auto'|'puppeteer'|'playwright'>('auto');
  const [archiveWidth, setArchiveWidth] = useState(1024);
  const [archiveProgress, setArchiveProgress] = useState('');
  const [archiveCountdown, setArchiveCountdown] = useState(0);
  const [archiveUrlInput, setArchiveUrlInput] = useState('');
  const [archiveIframeLoaded, setArchiveIframeLoaded] = useState(false);
  const [archiveIframeFailed, setArchiveIframeFailed] = useState(false);
  const [archiveRefArea, setArchiveRefArea] = useState<{x:number;y:number;w:number;h:number}|null>(null);
  const [archiveRefDrawing, setArchiveRefDrawing] = useState(false);
  const [archiveRefToolActive, setArchiveRefToolActive] = useState(true);
  const [archiveRefStart, setArchiveRefStart] = useState<{x:number;y:number}|null>(null);
  const [archiveRefCurrent, setArchiveRefCurrent] = useState<{x:number;y:number}|null>(null);
  const [archiveRefMode, setArchiveRefMode] = useState(true);
  const archiveRefOverlayRef = useRef<HTMLDivElement>(null);
  const archiveStepLabels = ['Configure', 'Reference', 'Confirm'];
  const archiveStepSubtitles = ['Set URL and capture options', 'Draw reference area on screenshot', 'Review and save'];
  const ARCHIVE_VP_W = 1024;
  const refLabelPct = (imgH: number) => {
    const h = imgH > 0 ? Math.max((22 / imgH) * 100, 0.17) : 1.7;
    const w = imgH > 0 ? Math.max((88 / imgH) * 100 * (imgH / (ARCHIVE_VP_W || 1024)), 7) : 7;
    const off = imgH > 0 ? Math.max((26 / imgH) * 100, 0.20) : 2.0;
    const textOff = imgH > 0 ? Math.max((18 / imgH) * 100, 0.14) : 1.4;
    return { h, w: Math.max(w, 7), off, textOff };
  };
  const PixelRuler: React.FC<{ height: number; zoom: number; side: 'left'|'right' }> = ({ height, zoom, side }) => {
    const marks: number[] = [];
    for (let px = 0; px * zoom < height; px += 100) marks.push(px);
    return (
      <Box sx={{ width: 36, flexShrink: 0, bgcolor: '#3a3a42', position: 'relative', overflow: 'hidden', borderLeft: side === 'right' ? '1px solid rgba(255,255,255,0.1)' : 'none', borderRight: side === 'left' ? '1px solid rgba(255,255,255,0.1)' : 'none' }}>
        {marks.map(px => {
          const y = px * zoom;
          const isMajor = px % 500 === 0;
          return (
            <Box key={px} sx={{ position: 'absolute', top: y, width: '100%', display: 'flex', alignItems: side === 'left' ? 'flex-end' : 'flex-start', flexDirection: side === 'left' ? 'row-reverse' : 'row' }}>
              <Box sx={{ width: isMajor ? 16 : 8, height: '1px', bgcolor: isMajor ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.18)', flexShrink: 0 }} />
              {isMajor && px > 0 && (
                <Typography sx={{ fontSize: 9, color: 'rgba(255,255,255,0.45)', lineHeight: 1, px: 0.3, transform: 'translateY(-5px)', fontFamily: 'monospace', userSelect: 'none', fontWeight: 600 }}>{px}</Typography>
              )}
            </Box>
          );
        })}
      </Box>
    );
  };
  const [viewerShowRef, setViewerShowRef] = useState(true);
  const [viewerZoom, setViewerZoom] = useState(1);
  const [resizing, setResizing] = useState(false);
  const [resizeStart, setResizeStart] = useState<{ x: number; y: number; w: number; h: number } | null>(null);

  const [imageZoom, setImageZoom] = useState(1);
  const [citeFormat, setCiteFormat] = useState<'apa' | 'harvard' | 'mla' | 'chicago' | 'vancouver'>('apa');
  const [trustInfoOpen, setTrustInfoOpen] = useState(false);
  const [localTrustRates, setLocalTrustRates] = useState<TrustRates>({ ...square.trustRates });
  const [typeChangeConfirmOpen, setTypeChangeConfirmOpen] = useState(false);
  const [typeChangePending, setTypeChangePending] = useState<{ type: string; prefill?: Partial<SourceFields> } | null>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const scrollToRefArea = useCallback((opts?: { smooth?: boolean }) => {
    const containers = [
      document.getElementById('normal-file-preview-scroll'),
      document.getElementById('file-preview-scroll'),
    ].filter(Boolean) as HTMLElement[];
    for (const sc of containers) {
      const rect = sc.querySelector('[data-ref-rect]') as SVGRectElement | HTMLElement | null;
      if (!rect) continue;
      const rectBox = rect.getBoundingClientRect();
      const scBox = sc.getBoundingClientRect();
      const rectTopInScroll = rectBox.top - scBox.top + sc.scrollTop;
      const target = Math.max(0, rectTopInScroll - sc.clientHeight * 0.3);
      sc.scrollTo({ top: target, behavior: opts?.smooth ? 'smooth' : 'auto' });
      return true;
    }
    return false;
  }, []);

  useEffect(() => {
    if (!imagePreviewOpen) return;
    if (!square.uploadedFile?.refAreas || square.uploadedFile.refAreas.length === 0) return;
    let cancelled = false;
    const attempt = (n: number) => {
      if (cancelled) return;
      if (scrollToRefArea({ smooth: false })) return;
      if (n > 0) setTimeout(() => attempt(n - 1), 80);
    };
    requestAnimationFrame(() => attempt(8));
    return () => { cancelled = true; };
  }, [imagePreviewOpen, square.uploadedFile, scrollToRefArea]);

  useEffect(() => {
    if (initialTab === 'file') setTabValue('ref');
    else if (initialTab === 'ref') setTabValue('ref');
    else if (initialTab === 'info') setTabValue('info');
  }, [initialTab]);

  const sourceColor = getSourceColor(square.sourceType);
  const isRefCapableFile = square.uploadedFile ? (square.uploadedFile.type?.startsWith('image/') || square.uploadedFile.type === 'application/pdf' || !!square.uploadedFile.previewUrl) : false;
  const previewSrc = square.uploadedFile ? (square.uploadedFile.type?.startsWith('image/') ? (square.uploadedFile.url || square.uploadedFile.dataUrl) : square.uploadedFile.previewUrl) : undefined;
  const currentSourceType = ALL_SOURCE_TYPES.find(s => s.type === square.sourceType);
  
  const getDisplayTitle = () => {
    if (!currentSourceType) return null;
    const title = square.fields[`field${currentSourceType.titleField}` as keyof SourceFields];
    const subtitle = square.fields[`field${currentSourceType.subtitleField}` as keyof SourceFields];
    return title ? { title, subtitle } : null;
  };

  const getDisplayFields = () => {
    const configs = currentSourceType?.fields || [];
    return ['field1','field2','field3','field4','field5','field6','field7','field8','field9','field10','field11','field12','field13','field14','field15'].map((key, i) => ({
      key, value: square.fields[key as keyof SourceFields] || '', label: configs[i]?.label || '', 
      isSearch: configs[i]?.type === 'openlib_search' || configs[i]?.type === 'imdb_search' || configs[i]?.type === 'microlink_search',
      isHidden: configs[i]?.type === 'map_picker',
    })).filter(f => f.value.trim() && !f.isSearch && !f.isHidden);
  };

  const displayInfo = getDisplayTitle();
  const displayFields = getDisplayFields();
  const eventHasCoords = square.sourceType === 'event' && square.fields.field3 && square.fields.field3.split(',').length === 2 && !isNaN(parseFloat(square.fields.field3.split(',')[0]));
  const hasReference = square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable || eventHasCoords;
  const refDescription = getRefDescription(square.sourceType, square.reference, displayInfo?.title, nextSourceLabel);
  const halfPoint = Math.ceil(displayFields.length / 2);
  const orderLabel = getOrderLabel(overrideOrder ?? square.order, isLast, chainEnded, square.isMainSource, chainEndReason);
  const isPrimary = square.order === 1 && !square.isMainSource;
  const bannerColor = square.isMainSource ? sourceColor : (isDark ? '#4a4a55' : '#9ca3af');

  const sourceRateValues = [square.trustRates.credibility, square.trustRates.verifiability, square.trustRates.recency, square.trustRates.completeness].filter(v => v > 0);
  const sourceAvg = sourceRateValues.length ? sourceRateValues.reduce((a, b) => a + b, 0) / sourceRateValues.length : 0;
  const refRateValues = [square.trustRates.accuracy, square.trustRates.relevance].filter(v => v > 0);
  const refAvg = refRateValues.length ? refRateValues.reduce((a, b) => a + b, 0) / refRateValues.length : 0;
  const sourceWeightPct = appSettings?.trustSourceWeight ?? 50;
  const refWeightPct = 100 - sourceWeightPct;
  const trustAvg = (sourceAvg > 0 && refAvg > 0)
    ? (sourceAvg * sourceWeightPct + refAvg * refWeightPct) / 100
    : (sourceAvg > 0 ? sourceAvg : refAvg);
  const trustValues = Object.values(square.trustRates).filter(v => (v as number) > 0);
  void trustValues;

  const formatCitation = (format: 'apa' | 'harvard' | 'mla' | 'chicago' | 'vancouver'): string => {
    if (!currentSourceType) return 'Select a source type first.';
    const f = square.fields;
    const titleIdx = currentSourceType.titleField;
    const subtitleIdx = currentSourceType.subtitleField;
    const title = f[`field${titleIdx + 1}` as keyof SourceFields] || 'Untitled';
    const author = f[`field${subtitleIdx + 1}` as keyof SourceFields] || '';
    let year = 'n.d.', publisher = '', url = '', journal = '';
    currentSourceType.fields.forEach((fc, i) => {
      const v = f[`field${i + 1}` as keyof SourceFields];
      if (!v) return;
      if (fc.codeTag === 'year' || (fc.codeTag === 'date' && !year.match(/\d{4}/))) { year = v.length >= 4 ? v.substring(0, 4) : v; }
      if (fc.codeTag === 'publisher' || fc.codeTag === 'org' || fc.codeTag === 'site') publisher = v;
      if (fc.codeTag === 'url' || fc.codeTag === 'doi') url = v;
      if (fc.codeTag === 'journal') journal = v;
    });
    const authorName = author || 'Unknown Author';

    switch (format) {
      case 'apa': {
        let c = `${authorName} (${year}). *${title}*.`;
        if (journal) c += ` *${journal}*.`;
        if (publisher) c += ` ${publisher}.`;
        if (url) c += ` ${url}`;
        return c;
      }
      case 'harvard': {
        let c = `${authorName} (${year}) *${title}*.`;
        if (journal) c += ` *${journal}*.`;
        if (publisher) c += ` ${publisher}.`;
        if (url) c += ` Available at: ${url}`;
        return c;
      }
      case 'mla': {
        let c = `${authorName}. "*${title}*."`;
        if (journal) c += ` *${journal}*,`;
        if (publisher) c += ` ${publisher},`;
        c += ` ${year}.`;
        if (url) c += ` ${url}.`;
        return c;
      }
      case 'chicago': {
        let c = `${authorName}. *${title}*.`;
        if (publisher) c += ` ${publisher},`;
        c += ` ${year}.`;
        if (url) c += ` ${url}.`;
        return c;
      }
      case 'vancouver': {
        let c = `${authorName}. ${title}.`;
        if (journal) c += ` ${journal}.`;
        c += ` ${year}`;
        if (url) c += `. Available from: ${url}`;
        return c + '.';
      }
      default: return '';
    }
  };

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button === 2) return;
    const target = e.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT' || target.closest('input') || target.closest('textarea') || target.closest('select') || target.closest('[role="combobox"]') || target.closest('.MuiAutocomplete-root') || target.closest('button') || target.closest('[role="button"]') || target.closest('[role="option"]') || target.closest('[role="listbox"]') || target.closest('.MuiMenu-root') || target.closest('.MuiDialog-root')) {
      e.stopPropagation();
      return;
    }
    e.stopPropagation();
    if (square.isMainSource && onSelectMainSource) onSelectMainSource();
    else { onSelect(square.sourceId); updateURL(boardId, chainId, square.sourceId); }
    if (isPublic || canvasLocked || readOnly) return;
    e.preventDefault();
    setDragStart({ x: e.clientX, y: e.clientY }); setInitialPosition({ ...square.position }); setIsDragging(true);
  }, [square, onSelect, boardId, isPublic, onSelectMainSource, canvasLocked, readOnly]);

  const handleContextMenu = useCallback((e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    setContextMenu({ x: e.clientX, y: e.clientY });
  }, []);

  // ─── Drag state via refs ─────────────────────────────────────────────
  const dragStateRef = useRef({ dragStart: { x: 0, y: 0 }, initialPosition: { x: 0, y: 0 }, zoom: 1, squareId: 0, squareSize: { width: 0, height: 0 } });
  const onUpdateRef = useRef(onUpdate);
  useEffect(() => { onUpdateRef.current = onUpdate; }, [onUpdate]);
  useEffect(() => {
    dragStateRef.current = {
      dragStart, initialPosition, zoom,
      squareId: square.id,
      squareSize: square.size,
    };
  }, [dragStart, initialPosition, zoom, square.id, square.size]);

  useEffect(() => {
    if (!isDragging) return;
    const onMove = (e: MouseEvent) => {
      const s = dragStateRef.current;
      const dX = (e.clientX - s.dragStart.x) / s.zoom;
      const dY = (e.clientY - s.dragStart.y) / s.zoom;
      onUpdateRef.current(s.squareId, s.squareSize, { x: s.initialPosition.x + dX, y: s.initialPosition.y + dY });
    };
    const onUp = () => { setIsDragging(false); };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    window.addEventListener('blur', onUp);
    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      window.removeEventListener('blur', onUp);
    };
  }, [isDragging]);

  const hasExistingData = square.sourceType !== null || 
    Object.values(square.fields).some(v => (v as string).trim() !== '') ||
    square.uploadedFile !== null ||
    (square.reference.from || square.reference.to || square.reference.notes) ||
    square.trustAssessed ||
    (square.comments && square.comments.trim() !== '');

  const handleSourceTypeSelect = (type: string, prefill?: Partial<SourceFields>) => {
    setSourceTypeDialogOpen(false);
    if (hasExistingData) {
      setTypeChangePending({ type, prefill });
      setTypeChangeConfirmOpen(true);
      return;
    }
    proceedWithTypeChange(type, prefill);
  };

  const proceedWithTypeChange = (type: string, prefill?: Partial<SourceFields>) => {
    onSourceTypeChange(square.id, type, prefill ? { ...emptyFields, ...prefill } : emptyFields, null);
    if (onReferenceChange) onReferenceChange(square.id, emptyReference);
    if (onTrustRateChange) onTrustRateChange(square.id, emptyTrustRates, false);
    if (onCommentsChange) onCommentsChange(square.id, '');
    if (!prefill) {
      setPendingSourceType(type);
      setInfoDialogOpen(true);
    }
  };
  const handleCopySourceId = (e: React.MouseEvent) => { e.stopPropagation(); navigator.clipboard.writeText(dispId(square.sourceId)); setShowCopied(true); onCopyId(square.sourceId); setTimeout(() => setShowCopied(false), 1500); };

  const simpleTitle = displayInfo?.title || 'Untitled';

  const simpleScale = simpleCardScale && simpleCardScale > 0 ? simpleCardScale : 1;
  const simpleCardW = Math.round(220 * simpleScale);
  const simpleCardH = Math.round(105 * simpleScale);

  const simpleRefText = (square.reference.from || square.reference.to) ? (() => {
    const refLabel = currentSourceType?.refLabel?.toLowerCase() || '';
    const isTime = refLabel.includes('timestamp');
    const isPage = refLabel.includes('page');
    if (isTime) return `${square.reference.from || ''}–${square.reference.to || ''}`;
    if (isPage || (!square.reference.from?.includes(':') && !square.reference.to?.includes(':'))) return `pp. ${square.reference.from || '?'}–${square.reference.to || '?'}`;
    return `${square.reference.from || ''}–${square.reference.to || ''}`;
  })() : '';
  const simpleYear = (() => {
    const yf = currentSourceType?.fields.find(f => f.type === 'year' || f.codeTag === 'year' || f.codeTag === 'date');
    const yi = yf ? currentSourceType!.fields.indexOf(yf) : -1;
    const yv = yi >= 0 ? (square.fields as any)[`field${yi + 1}`] : '';
    return yv ? (yv.length === 4 ? yv : yv.substring(0, 4)) : '';
  })();

  const trustDialogElement = (
      <Dialog disableScrollLock open={trustInfoOpen} onClose={() => setTrustInfoOpen(false)} fullScreen PaperProps={{ sx: { bgcolor: 'background.default' } }}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Box>
            <Typography fontWeight={700} fontSize={17}>Trust Assessment</Typography>
            <Typography fontSize={12} color="text.secondary">
              {readOnly
                ? `Scores submitted by the chain owner · ${currentSourceType?.label || 'Source'}: ${displayInfo?.title || 'Untitled'}`
                : `Rate each category from 1 to 10 · ${currentSourceType?.label || 'Source'}: ${displayInfo?.title || 'Untitled'}`}
            </Typography>
          </Box>
          <IconButton onClick={() => setTrustInfoOpen(false)} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '20px !important', display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: '100%', maxWidth: 640 }}>
          <Box sx={{ display: 'flex', gap: 1, p: 1.5, mb: 2, borderRadius: '8px', bgcolor: isDark ? 'rgba(245,158,11,0.08)' : '#fffbeb', border: '1px solid', borderColor: isDark ? 'rgba(245,158,11,0.2)' : '#fde68a' }}>
            <WarningIcon sx={{ fontSize: 16, color: '#d97706', mt: 0.1, flexShrink: 0 }} />
            <Typography fontSize={11} color="text.secondary" lineHeight={1.5}>
              This rating is a <strong>subjective user assessment</strong>. It may be inaccurate, biased, or incomplete and should not be treated as an objective evaluation.
            </Typography>
          </Box>
          <Box sx={{ mb: 3, p: 2, borderRadius: '10px', border: '1px solid', borderColor: square.uploadedFile ? '#16a34a30' : '#ef444430', bgcolor: square.uploadedFile ? '#16a34a06' : '#ef444406' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Typography fontSize={16} lineHeight={1}>{square.uploadedFile ? '✅' : '⚠️'}</Typography>
              <Typography fontSize={14} fontWeight={700}>Verification</Typography>
              <Box sx={{ ml: 'auto', minWidth: 32, textAlign: 'center', bgcolor: square.uploadedFile ? '#16a34a' : '#ef4444', color: '#E3E3DF', borderRadius: '4px', px: 1, py: 0.15 }}>
                <Typography fontSize={13} fontWeight={700}>{square.uploadedFile ? '10' : '0'}</Typography>
              </Box>
            </Box>
            <Typography fontSize={12} color="text.secondary" lineHeight={1.5} sx={{ ml: 3.5 }}>
              {square.uploadedFile
                ? `File attached: ${(square.uploadedFile as any).originalName || 'document'}. Source material is verifiable.`
                : 'No file uploaded. Attach the original source document to verify this source and increase its trust score.'}
            </Typography>
            <Box sx={{ ml: 3.5, mt: 1, height: 6, bgcolor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)', borderRadius: 3, overflow: 'hidden' }}>
              <Box sx={{ width: square.uploadedFile ? '100%' : '0%', height: '100%', bgcolor: square.uploadedFile ? '#16a34a' : '#ef4444', borderRadius: 3 }} />
            </Box>
          </Box>

          {(() => {
            const sourceTitle = displayInfo?.title || 'this source';
            const typeNoun = currentSourceType?.label?.toLowerCase() || 'source';
            const titledNoun = `the ${typeNoun} "${sourceTitle}"`;
            const refSet = !!(square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable);
            const refDisabled = !refSet;
            const HISTORICAL_TYPES = ['book', 'statement', 'event', 'legal', 'government', 'patent', 'speech', 'interview', 'image', 'archive', 'map', 'music'];
            const isHistorical = HISTORICAL_TYPES.includes(square.sourceType || '');
            const sourceRates = [
              { key: 'credibility' as const, label: 'Credibility', color: '#10b981',
                question: `How trustworthy is the author and/or publisher of ${titledNoun}?`,
                guide: 'Weigh expertise, track record, editorial standards, and any conflict of interest.' },
              { key: 'verifiability' as const, label: 'Verifiability', color: '#8b5cf6',
                question: `Could someone independently verify ${titledNoun}?`,
                guide: 'Is there a DOI, archived snapshot, checksum, named witness, or public record that lets a third party confirm it — rather than taking it on trust?' },
              { key: 'recency' as const, label: isHistorical ? 'Timeliness' : 'Recency', color: '#f59e0b',
                question: isHistorical
                  ? `Is ${titledNoun} appropriately dated for the claim it supports?`
                  : `Is the information in ${titledNoun} still current?`,
                guide: isHistorical
                  ? 'A contemporaneous primary source is a strength here; a later account of an old event may be weaker. Age is not automatically a problem.'
                  : 'For fast-moving topics, older sources may be outdated. Mark N/A if timing is irrelevant to the claim.' },
            ];
            const referenceRates = [
              { key: 'accuracy' as const, label: 'Accuracy', color: '#ef4444',
                question: `For the cited reference, how factually correct is the information?`,
                guide: 'Are claims in this specific quote/page/scene supported by evidence? Look for misquotes or misleading framing.' },
              { key: 'relevance' as const, label: 'Relevance', color: '#3b82f6',
                question: `How directly does the cited reference relate to the next source's claim?`,
                guide: 'Rate how closely the cited part aligns with the claim it is supporting.' },
            ];
            const renderRate = ({ key, label, color, question, guide }: typeof sourceRates[number] | typeof referenceRates[number], disabled = false) => {
              const val = localTrustRates[key];
              const isNA = val === -1;
              const marks = Array.from({ length: 11 }, (_, i) => ({ value: i, label: i === 0 || i === 5 || i === 10 ? String(i) : '' }));
              if (readOnly) {
                if (val === 0) return null;
                return (
                  <Box key={key} sx={{ mb: 1.5, opacity: disabled ? 0.45 : 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
                      <Typography fontSize={13} fontWeight={600}>{label}</Typography>
                      <Box sx={{ ml: 'auto', minWidth: 36, textAlign: 'center',
                        bgcolor: isNA ? (isDark ? 'rgba(148,163,184,0.18)' : 'rgba(148,163,184,0.22)') : 'primary.main',
                        color: isNA ? 'text.secondary' : '#E3E3DF',
                        borderRadius: '4px', px: 1, py: 0.15 }}>
                        <Typography fontSize={isNA ? 10 : 13} fontWeight={700}>{isNA ? 'N/A' : val}</Typography>
                      </Box>
                    </Box>
                    <Typography fontSize={11} color="text.secondary" lineHeight={1.5} sx={{ ml: 2.5 }}>{question}</Typography>
                  </Box>
                );
              }
              return (
                <Box key={key} sx={{ mb: 2.5, opacity: disabled ? 0.45 : 1, transition: 'opacity 120ms', pointerEvents: disabled ? 'none' : 'auto' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
                    <Typography fontSize={13} fontWeight={600}>{label}</Typography>
                    <FormControlLabel
                      sx={{ ml: 1, mr: 0, '& .MuiFormControlLabel-label': { fontSize: 11, color: 'text.secondary' } }}
                      control={<Checkbox size="small" checked={isNA} disabled={disabled}
                        onChange={(e) => setLocalTrustRates(prev => ({ ...prev, [key]: e.target.checked ? -1 : 0 }))}
                        sx={{ p: 0.4 }} />}
                      label="N/A"
                    />
                    <Box sx={{ ml: 'auto', minWidth: 36, textAlign: 'center',
                      bgcolor: isNA ? (isDark ? 'rgba(148,163,184,0.18)' : 'rgba(148,163,184,0.22)') : (val > 0 ? 'primary.main' : (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)')),
                      color: isNA ? 'text.secondary' : (val > 0 ? '#E3E3DF' : 'text.disabled'),
                      borderRadius: '4px', px: 1, py: 0.15 }}>
                      <Typography fontSize={isNA ? 10 : 13} fontWeight={700}>{isNA ? 'N/A' : (val || '–')}</Typography>
                    </Box>
                  </Box>
                  <Typography fontSize={12} fontWeight={500} sx={{ mb: 0.2, ml: 2.5 }}>{question}</Typography>
                  <Typography fontSize={11} color="text.secondary" lineHeight={1.5} sx={{ mb: 1, ml: 2.5 }}>{guide}</Typography>
                  <Box sx={{ px: 2, maxWidth: 360 }}>
                    <Slider
                      value={isNA ? 0 : val}
                      min={0} max={10} step={1}
                      marks={marks}
                      disabled={disabled || isNA}
                      valueLabelDisplay="auto"
                      onChange={(_, v) => setLocalTrustRates(prev => ({ ...prev, [key]: v as number }))}
                      sx={{ '& .MuiSlider-markLabel': { fontSize: 9 } }}
                    />
                  </Box>
                </Box>
              );
            };
            const renderVoteRow = (category: 'source' | 'reference', accent: string) => {
              if (!readOnly) return null;
              if (allowTrustVoting === false) {
                return (
                  <Box sx={{ pl: 2.4, pb: 1, mt: -0.5 }}>
                    <Typography fontSize={11} color="text.disabled" sx={{ fontStyle: 'italic' }}>
                      The owner has disabled voting on this board.
                    </Typography>
                  </Box>
                );
              }
              const myVote = category === 'source' ? square.currentUserTrustVoteSource : square.currentUserTrustVoteReference;
              const agree = (category === 'source' ? square.trustVoteSourceAgree : square.trustVoteReferenceAgree) || 0;
              const dis   = (category === 'source' ? square.trustVoteSourceDisagree : square.trustVoteReferenceDisagree) || 0;
              const onVote = (v: 'agree' | 'disagree' | null) => {
                if (onTrustVote) onTrustVote(square.sourceId, category, v);
              };
              return (
                <Box sx={{ pl: 2.4, pb: 1, mt: -0.5, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Typography fontSize={11} color="text.secondary" fontWeight={600}>
                    Do you agree with this {category === 'source' ? 'source' : 'reference'} scoring?
                  </Typography>
                  <Button size="small" variant={myVote === 'agree' ? 'contained' : 'outlined'}
                    onClick={() => onVote(myVote === 'agree' ? null : 'agree')}
                    startIcon={myVote === 'agree' ? <ThumbUpIcon sx={{ fontSize: 14 }} /> : <ThumbUpOffAltIcon sx={{ fontSize: 14 }} />}
                    sx={{ fontSize: 11, textTransform: 'none', minWidth: 0, px: 1, py: 0.2,
                      bgcolor: myVote === 'agree' ? '#16a34a' : 'transparent',
                      color: myVote === 'agree' ? '#fff' : '#16a34a',
                      borderColor: '#16a34a',
                      '&:hover': { bgcolor: myVote === 'agree' ? '#15803d' : 'rgba(22,163,74,0.08)', borderColor: '#15803d' } }}>
                    Agree <Box component="span" sx={{ ml: 0.4, opacity: 0.7 }}>({agree})</Box>
                  </Button>
                  <Button size="small" variant={myVote === 'disagree' ? 'contained' : 'outlined'}
                    onClick={() => onVote(myVote === 'disagree' ? null : 'disagree')}
                    startIcon={myVote === 'disagree' ? <ThumbDownIcon sx={{ fontSize: 14 }} /> : <ThumbDownOffAltIcon sx={{ fontSize: 14 }} />}
                    sx={{ fontSize: 11, textTransform: 'none', minWidth: 0, px: 1, py: 0.2,
                      bgcolor: myVote === 'disagree' ? '#ef4444' : 'transparent',
                      color: myVote === 'disagree' ? '#fff' : '#ef4444',
                      borderColor: '#ef4444',
                      '&:hover': { bgcolor: myVote === 'disagree' ? '#dc2626' : 'rgba(239,68,68,0.08)', borderColor: '#dc2626' } }}>
                    Disagree <Box component="span" sx={{ ml: 0.4, opacity: 0.7 }}>({dis})</Box>
                  </Button>
                  {!isPublic }
                </Box>
              );
            };
            void renderVoteRow;
            return (
              <>
                <Box sx={{ mb: 1, p: 1.4, borderRadius: '8px',
                  bgcolor: isDark ? 'rgba(16,185,129,0.06)' : 'rgba(16,185,129,0.04)',
                  border: '1px solid', borderColor: isDark ? 'rgba(16,185,129,0.2)' : 'rgba(16,185,129,0.18)',
                  display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: '#10b981', color: 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 800 }}>1</Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography fontSize={13} fontWeight={700}>Score the source</Typography>
                    <Typography fontSize={11} color="text.secondary">Rate the work as a whole — {titledNoun}.</Typography>
                  </Box>
                </Box>
                <Box sx={{ pl: 2.4, py: 2 }}>
                  {sourceRates.map(r => renderRate(r))}
                </Box>
                {renderVoteRow('source', '#10b981')}

                <Box sx={{ mb: 1, p: 1.4, borderRadius: '8px',
                  bgcolor: refDisabled ? (isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)') : (isDark ? 'rgba(59,130,246,0.06)' : 'rgba(59,130,246,0.04)'),
                  border: '1px solid', borderColor: refDisabled ? 'divider' : (isDark ? 'rgba(59,130,246,0.2)' : 'rgba(59,130,246,0.18)'),
                  display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ width: 22, height: 22, borderRadius: '50%',
                    bgcolor: refDisabled ? '#94a3b8' : '#3b82f6',
                    color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 800 }}>2</Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography fontSize={13} fontWeight={700} sx={{ color: refDisabled ? 'text.disabled' : 'text.primary' }}>Score the reference</Typography>
                    <Typography fontSize={11} color="text.secondary">
                      {refDisabled
                        ? 'Set a reference point on this source first to enable reference scoring.'
                        : 'Rate the specific cited part — how well it supports the next claim.'}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ pl: 2.4, py: 2, opacity: refDisabled ? 0.55 : 1, transition: 'opacity 120ms' }}>
                  {referenceRates.map(r => renderRate(r, refDisabled))}
                </Box>
                {!refDisabled && renderVoteRow('reference', '#3b82f6')}
              </>
            );
          })()}
          {!readOnly && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, px: 0.5, mt: 1.5, pt: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
              {['1–3 Poor', '4–5 Below avg', '6–7 Adequate', '8–9 Good', '10 Excellent'].map(s => (
                <Typography key={s} fontSize={13} fontWeight={500} color="text.secondary">{s}</Typography>
              ))}
            </Box>
          )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2, pt: 0.5, borderTop: '1px solid', borderColor: 'divider' }}>
          {readOnly ? (
            <Button onClick={() => setTrustInfoOpen(false)} variant="contained"
              sx={{ bgcolor: '#1a1a2e', '&:hover': { bgcolor: '#2d2d44' }, fontWeight: 600, px: 3 }}>
              Close
            </Button>
          ) : (() => {
            const refIsSet = !!(square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable);
            const isAnswered = (v: number) => v >= 1 || v === -1;
            const sourceKeys = ['credibility', 'recency', 'completeness'] as const;
            const refKeys = ['accuracy', 'relevance'] as const;
            const sourceMissing = sourceKeys.filter(k => !isAnswered(localTrustRates[k]));
            const refMissing = refIsSet ? refKeys.filter(k => !isAnswered(localTrustRates[k])) : [];
            const missing = [...sourceMissing, ...refMissing];
            const allKeys = [...sourceKeys, ...(refIsSet ? refKeys : [])] as const;
            const answeredCount = allKeys.filter(k => isAnswered(localTrustRates[k])).length;
            const isEditing = square.trustAssessed === true;
            const canSave = isEditing
              ? answeredCount > 0
              : missing.length === 0;
            return (
              <>
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: 0 }}>
                  {missing.length > 0 && (
                    <Typography fontSize={11} color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {isEditing
                        ? `${missing.length} rate${missing.length === 1 ? '' : 's'} still unanswered: ${missing.map(k => k.charAt(0).toUpperCase() + k.slice(1)).join(', ')}`
                        : `${missing.length} more to rate — set a value or check N/A: ${missing.map(k => k.charAt(0).toUpperCase() + k.slice(1)).join(', ')}`}
                    </Typography>
                  )}
                </Box>
                <Button onClick={() => setTrustInfoOpen(false)} color="inherit" sx={{ fontWeight: 500 }}>Cancel</Button>
                <Button variant="contained" disabled={!canSave}
                  onClick={() => { if (onTrustRateChange) onTrustRateChange(square.id, localTrustRates, true); setTrustInfoOpen(false); }}
                  sx={{ bgcolor: '#1a1a2e', '&:hover': { bgcolor: '#2d2d44' }, fontWeight: 600, px: 3 }}>
                  Save
                </Button>
              </>
            );
          })()}
        </DialogActions>
      </Dialog>
  );

  const imageViewerDialogElement = (
      <Dialog disableScrollLock open={imagePreviewOpen} onClose={() => { setImagePreviewOpen(false); setViewerShowRef(false); updateURL(boardId, chainId, square.sourceId); }} maxWidth={false}
        PaperProps={{ sx: { position: 'fixed', inset: 0, m: 0, maxWidth: '100%', maxHeight: '100%', borderRadius: 0, bgcolor: '#3a3a42' } }}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 0.8, bgcolor: 'rgba(0,0,0,0.6)', flexShrink: 0, zIndex: 2, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            {(() => {
              const _f = square.uploadedFile;
              const _t = (_f?.type || '').toLowerCase();
              const _n = (_f?.name || '').toLowerCase();
              const isAudioFile = !!_f && (_t.startsWith('audio/') || _n.endsWith('.mp3') || _n.endsWith('.wav'));
              return (<>
                {isAudioFile
                  ? <AudiotrackIcon sx={{ fontSize: 14, color: sourceColor }} />
                  : <InsertDriveFileIcon sx={{ fontSize: 14, color: sourceColor }} />}
                <Typography sx={{ fontSize: 11, color: '#E3E3DF', fontFamily: 'monospace', opacity: 0.7, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{square.uploadedFile?.name}</Typography>
                <Box sx={{ flex: 1 }} />
                {!isAudioFile && square.uploadedFile?.refAreas && square.uploadedFile.refAreas.length > 0 && (
                  <Button size="small" variant="outlined" startIcon={<CropFreeIcon sx={{ fontSize: 12 }} />}
                    onClick={() => scrollToRefArea({ smooth: true })}
                    sx={{ fontSize: 10, color: '#3b82f6', borderColor: 'rgba(59,130,246,0.3)', textTransform: 'none', '&:hover': { bgcolor: 'rgba(59,130,246,0.1)' } }}>
                    Go to Reference
                  </Button>
                )}
                {!isAudioFile && (
                  <ViewerZoomControls zoom={viewerZoom} onZoomChange={setViewerZoom} variant="dark" size="medium" />
                )}
                {square.uploadedFile?.refCropUrl && (
                  <Button
                    component="a"
                    href={safeHref(square.uploadedFile.refCropUrl)}
                    download={`reference-${square.sourceId}.png`}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="small"
                    startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
                    sx={{ color: '#E3E3DF', bgcolor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)', textTransform: 'none', fontSize: 10, px: 1.5, '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' } }}
                  >
                    Download Ref
                  </Button>
                )}
                <IconButton onClick={() => { setImagePreviewOpen(false); setViewerShowRef(true); setViewerZoom(1); updateURL(boardId, chainId, square.sourceId); }} sx={{ color: '#E3E3DF', ml: 0.5 }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
              </>);
            })()}
          </Box>
          <Box id="normal-file-preview-scroll"
            sx={{ flex: 1, overflow: 'auto', py: 4 }}>
            {(() => {
              const citedPage = square.uploadedFile?.citedPages?.[0] || 1;
              const pageUrls = square.uploadedFile?.pageUrls || [];
              const totalPages = square.uploadedFile?.pageCount || pageUrls.length || 1;
              const isMultiPage = totalPages > 1 && pageUrls.length > 1;

              const file = square.uploadedFile;
              const audioType = (file?.type || '').toLowerCase();
              const audioName = (file?.name || '').toLowerCase();
              const isAudio = !!file && (
                audioType.startsWith('audio/')
                || audioName.endsWith('.mp3') || audioName.endsWith('.wav')
              );
              if (isAudio && file) {
                return (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100%', p: 4 }}>
                    <Box sx={{ width: '100%', maxWidth: 900, display: 'flex', flexDirection: 'column', gap: 3 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ width: 64, height: 64, borderRadius: '14px', bgcolor: 'rgba(59,130,246,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <AudiotrackIcon sx={{ fontSize: 36, color: '#3b82f6' }} />
                        </Box>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#E3E3DF', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {file.name}
                          </Typography>
                          <Typography sx={{ fontSize: 12, color: 'rgba(227,227,223,0.65)' }}>
                            {formatFileSize(file.size)} · Audio
                            {typeof file.refTimestamp === 'number' && file.refTimestamp > 0 && (
                              <> · Cited at <Box component="span" sx={{ color: '#f59e0b', fontWeight: 700 }}>{formatAudioTime(file.refTimestamp)}</Box></>
                            )}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ p: 3, borderRadius: '12px', bgcolor: 'rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.08)' }}>
                        <AudioPlayer
                          src={file.url || file.previewUrl || ''}
                          mode="view"
                          refTimestamp={file.refTimestamp}
                          isDark={true}
                          accent="#3b82f6"
                        />
                      </Box>
                      {file.url && (
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                          <Button component="a" href={safeHref(file.url)} target="_blank" rel="noopener noreferrer" startIcon={<DownloadIcon sx={{ fontSize: 14 }} />}
                            sx={{ textTransform: 'none', color: '#E3E3DF', borderColor: 'rgba(255,255,255,0.2)' }} variant="outlined" size="small">
                            Download audio file
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Box>
                );
              }

              const pagesToShow: { pageNum: number; url: string; isCited: boolean }[] = [];
              if (isMultiPage) {
                if (citedPage > 1 && pageUrls[citedPage - 2]) {
                  pagesToShow.push({ pageNum: citedPage - 1, url: pageUrls[citedPage - 2], isCited: false });
                }
                if (pageUrls[citedPage - 1]) {
                  pagesToShow.push({ pageNum: citedPage, url: pageUrls[citedPage - 1], isCited: true });
                } else if (previewSrc) {
                  pagesToShow.push({ pageNum: citedPage, url: previewSrc, isCited: true });
                }
                if (citedPage < totalPages && pageUrls[citedPage]) {
                  pagesToShow.push({ pageNum: citedPage + 1, url: pageUrls[citedPage], isCited: false });
                }
              }
              
              if (isMultiPage && pagesToShow.length > 0) {
                return (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, px: 4, pb: 4 }}>
                    {pagesToShow.map((p, idx) => (
                      <Box key={idx} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, opacity: p.isCited ? 1 : 0.6, position: 'relative' }}>
                        <Typography sx={{ fontSize: 48, fontWeight: 300, color: p.isCited ? '#f59e0b' : 'rgba(255,255,255,0.2)', minWidth: 70, textAlign: 'right', fontFamily: 'monospace', mt: 2 }}>
                          {p.pageNum}
                        </Typography>
                        <Box sx={{ position: 'relative', boxShadow: p.isCited ? '0 8px 40px rgba(245,158,11,0.3)' : '0 4px 20px rgba(0,0,0,0.3)', transform: `scale(${viewerZoom})`, transformOrigin: 'top left', transition: 'transform 0.2s', border: p.isCited ? '3px solid #f59e0b' : '1px solid rgba(255,255,255,0.1)', borderRadius: '4px' }}>
                          <img src={p.url} alt={`Page ${p.pageNum}`} style={{ display: 'block', maxWidth: '65vw', background: '#fff' }} />
                          {p.isCited && square.uploadedFile?.refAreas && square.uploadedFile.refAreas.length > 0 && (() => {
                            const fileHL = square.uploadedFile?.highlights || [];
                            return (
                            <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                              <defs>
                                <mask id={`viewer-ref-mask-${idx}`}>
                                  <rect x="0" y="0" width="100%" height="100%" fill="white" />
                                  {square.uploadedFile!.refAreas!.map((a, i) => (
                                    <rect key={i} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="black" rx="3" />
                                  ))}
                                </mask>
                              </defs>
                              <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.35)" mask={`url(#viewer-ref-mask-${idx})`} />
                              {square.uploadedFile!.refAreas!.map((a, i) => (
                                <g key={i}>
                                  <rect data-ref-rect={i === 0 ? 'true' : undefined} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="none" stroke="#3B82F6" strokeWidth="3" rx="3" />
                                  <rect x={`${a.x}%`} y={`${Math.max(0, a.y - refLabelPct(archiveImgHeight).off)}%`} width={`${refLabelPct(archiveImgHeight).w}%`} height={`${refLabelPct(archiveImgHeight).h}%`} rx="3" fill="#3B82F6" />
                                  <text x={`${a.x + 0.5}%`} y={`${Math.max(0.5, a.y - refLabelPct(archiveImgHeight).textOff)}%`} fill="#E3E3DF" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif">Referenced</text>
                                </g>
                              ))}
                              {fileHL.length > 0 && square.uploadedFile!.refAreas!.map((a) => (
                                fileHL.map((hl, hi) => {
                                  const hlX1 = a.x + (hl.x1 / 100) * a.w, hlY1 = a.y + (hl.y1 / 100) * a.h;
                                  const hlX2 = a.x + (hl.x2 / 100) * a.w, hlY2 = a.y + (hl.y2 / 100) * a.h;
                                  const c = hl.color || '#f59e0b'; const t = hl.thickness || 3;
                                  if (hl.type === 'line') return <line key={`hl-${hi}`} x1={`${hlX1}%`} y1={`${hlY1}%`} x2={`${hlX2}%`} y2={`${hlY2}%`} stroke={c} strokeWidth={t} strokeLinecap="round" />;
                                  if (hl.type === 'rect') return <rect key={`hl-${hi}`} x={`${Math.min(hlX1,hlX2)}%`} y={`${Math.min(hlY1,hlY2)}%`} width={`${Math.abs(hlX2-hlX1)}%`} height={`${Math.abs(hlY2-hlY1)}%`} fill={`${c}33`} stroke={c} strokeWidth="3" rx="3" />;
                                  if (hl.type === 'circle') { const cx=(hlX1+hlX2)/2, cy=(hlY1+hlY2)/2, rx=Math.abs(hlX2-hlX1)/2, ry=Math.abs(hlY2-hlY1)/2; return <ellipse key={`hl-${hi}`} cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={`${c}33`} stroke={c} strokeWidth="3" />; }
                                  return null;
                                })
                              ))}
                            </svg>
                            );
                          })()}
                        </Box>
                        {p.isCited && (
                          <Box sx={{ position: 'absolute', top: 8, right: -100, bgcolor: '#f59e0b', color: '#E3E3DF', px: 1.5, py: 0.5, borderRadius: '4px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', boxShadow: 2 }}>
                            ← Cited Reference
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                );
              } else if (previewSrc) {
                const fileHL = square.uploadedFile?.highlights || [];
                return (
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Typography sx={{ fontSize: 48, fontWeight: 300, color: 'rgba(255,255,255,0.2)', minWidth: 70, textAlign: 'right', fontFamily: 'monospace' }}>
                        {citedPage}
                      </Typography>
                      <Box sx={{ position: 'relative', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }}>
                        <img src={previewSrc} alt={square.uploadedFile?.name || ''}
                          onLoad={(e) => {
                            if (square.uploadedFile?.origin === 'web-archive') {
                              setArchiveImgHeight((e.target as HTMLImageElement).clientHeight);
                            }
                          }}
                          style={{ display: 'block', maxWidth: `${70 * viewerZoom}vw`, background: '#fff' }} />
                        {square.uploadedFile?.refAreas && square.uploadedFile.refAreas.length > 0 && (
                          <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                            <defs>
                              <mask id="viewer-ref-mask">
                                <rect x="0" y="0" width="100%" height="100%" fill="white" />
                                {square.uploadedFile.refAreas.map((a, i) => (
                                  <rect key={i} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="black" rx="3" />
                                ))}
                              </mask>
                            </defs>
                            <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.35)" mask="url(#viewer-ref-mask)" />
                            {square.uploadedFile.refAreas.map((a, i) => (
                              <g key={i}>
                                <rect data-ref-rect={i === 0 ? 'true' : undefined} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="none" stroke="#3B82F6" strokeWidth="3" rx="3" />
                                <rect x={`${a.x}%`} y={`${Math.max(0, a.y - refLabelPct(archiveImgHeight).off)}%`} width={`${refLabelPct(archiveImgHeight).w}%`} height={`${refLabelPct(archiveImgHeight).h}%`} rx="3" fill="#3B82F6" />
                                <text x={`${a.x + 0.5}%`} y={`${Math.max(0.5, a.y - refLabelPct(archiveImgHeight).textOff)}%`} fill="#E3E3DF" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif">Referenced</text>
                              </g>
                            ))}
                            {fileHL.length > 0 && square.uploadedFile.refAreas.map((a) => (
                              fileHL.map((hl, hi) => {
                                const hlX1 = a.x + (hl.x1 / 100) * a.w;
                                const hlY1 = a.y + (hl.y1 / 100) * a.h;
                                const hlX2 = a.x + (hl.x2 / 100) * a.w;
                                const hlY2 = a.y + (hl.y2 / 100) * a.h;
                                const c = hl.color || '#f59e0b';
                                const t = hl.thickness || 3;
                                if (hl.type === 'line') return <line key={`hl-${hi}`} x1={`${hlX1}%`} y1={`${hlY1}%`} x2={`${hlX2}%`} y2={`${hlY2}%`} stroke={c} strokeWidth={t} strokeLinecap="round" />;
                                if (hl.type === 'rect') return <rect key={`hl-${hi}`} x={`${Math.min(hlX1,hlX2)}%`} y={`${Math.min(hlY1,hlY2)}%`} width={`${Math.abs(hlX2-hlX1)}%`} height={`${Math.abs(hlY2-hlY1)}%`} fill={`${c}33`} stroke={c} strokeWidth="3" rx="3" />;
                                if (hl.type === 'circle') { const cx=(hlX1+hlX2)/2, cy=(hlY1+hlY2)/2, rx=Math.abs(hlX2-hlX1)/2, ry=Math.abs(hlY2-hlY1)/2; return <ellipse key={`hl-${hi}`} cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={`${c}33`} stroke={c} strokeWidth="3" />; }
                                return null;
                              })
                            ))}
                          </svg>
                        )}
                        {(!square.uploadedFile?.refAreas || square.uploadedFile.refAreas.length === 0) && fileHL.length > 0 && (
                          <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                            {fileHL.map((hl, hi) => {
                              const c = hl.color || '#f59e0b'; const t = hl.thickness || 3;
                              if (hl.type === 'line') return <line key={`hl-${hi}`} x1={`${hl.x1}%`} y1={`${hl.y1}%`} x2={`${hl.x2}%`} y2={`${hl.y2}%`} stroke={c} strokeWidth={t} strokeLinecap="round" />;
                              if (hl.type === 'rect') return <rect key={`hl-${hi}`} x={`${Math.min(hl.x1,hl.x2)}%`} y={`${Math.min(hl.y1,hl.y2)}%`} width={`${Math.abs(hl.x2-hl.x1)}%`} height={`${Math.abs(hl.y2-hl.y1)}%`} fill={`${c}33`} stroke={c} strokeWidth="3" rx="3" />;
                              if (hl.type === 'circle') { const cx=(hl.x1+hl.x2)/2, cy=(hl.y1+hl.y2)/2, rx=Math.abs(hl.x2-hl.x1)/2, ry=Math.abs(hl.y2-hl.y1)/2; return <ellipse key={`hl-${hi}`} cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={`${c}33`} stroke={c} strokeWidth="3" />; }
                              return null;
                            })}
                          </svg>
                        )}
                      </Box>
                    </Box>
                  </Box>
                );
              } else if (previewSrc) {
                const isArchive = square.uploadedFile?.origin === 'web-archive';
                const fileHL = square.uploadedFile?.highlights || [];
                const fileRefAreas = square.uploadedFile?.refAreas || [];
                return (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: '100%' }}>
                    {isArchive && <PixelRuler height={archiveImgHeight} zoom={viewerZoom} side="left" />}
                    <Box sx={{ position: 'relative', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }}>
                      <img src={previewSrc} alt={square.uploadedFile?.name || ''} onLoad={(e) => {
                        if (isArchive) {
                          const imgH = (e.target as HTMLImageElement).clientHeight;
                          setArchiveImgHeight(imgH);
                        }
                      }} style={{ display: 'block', width: isArchive ? ARCHIVE_VP_W * viewerZoom : undefined, maxWidth: isArchive ? undefined : `${70 * viewerZoom}vw`, background: '#fff' }} />
                      {(fileRefAreas.length > 0 || fileHL.length > 0) && (
                        <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                          {fileRefAreas.length > 0 && (
                            <>
                              <defs><mask id="normal-archive-ref-mask"><rect x="0" y="0" width="100%" height="100%" fill="white" />{fileRefAreas.map((a, i) => <rect key={i} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="black" />)}</mask></defs>
                              <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.35)" mask="url(#normal-archive-ref-mask)" />
                              {fileRefAreas.map((a, i) => (
                                <g key={i}>
                                  <rect data-ref-rect={i === 0 ? 'true' : undefined} x={`${a.x}%`} y={`${a.y}%`} width={`${a.w}%`} height={`${a.h}%`} fill="none" stroke="#3b82f6" strokeWidth="3" rx="3" />
                                  <rect x={`${a.x}%`} y={`${Math.max(0, a.y - refLabelPct(archiveImgHeight).off)}%`} width={`${refLabelPct(archiveImgHeight).w}%`} height={`${refLabelPct(archiveImgHeight).h}%`} rx="3" fill="#3b82f6" />
                                  <text x={`${a.x + 0.4}%`} y={`${Math.max(0.5, a.y - refLabelPct(archiveImgHeight).textOff)}%`} fill="#E3E3DF" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif">Referenced</text>
                                </g>
                              ))}
                            </>
                          )}
                          {fileHL.map((hl, hi) => {
                            const c = hl.color || '#f59e0b'; const t = hl.thickness || 3;
                            if (hl.type === 'line') return <line key={`hl-${hi}`} x1={`${hl.x1}%`} y1={`${hl.y1}%`} x2={`${hl.x2}%`} y2={`${hl.y2}%`} stroke={c} strokeWidth={t} strokeLinecap="round" />;
                            if (hl.type === 'rect') return <rect key={`hl-${hi}`} x={`${Math.min(hl.x1,hl.x2)}%`} y={`${Math.min(hl.y1,hl.y2)}%`} width={`${Math.abs(hl.x2-hl.x1)}%`} height={`${Math.abs(hl.y2-hl.y1)}%`} fill={`${c}33`} stroke={c} strokeWidth="3" rx="3" />;
                            if (hl.type === 'circle') { const cx=(hl.x1+hl.x2)/2, cy=(hl.y1+hl.y2)/2, rx=Math.abs(hl.x2-hl.x1)/2, ry=Math.abs(hl.y2-hl.y1)/2; return <ellipse key={`hl-${hi}`} cx={`${cx}%`} cy={`${cy}%`} rx={`${rx}%`} ry={`${ry}%`} fill={`${c}33`} stroke={c} strokeWidth="3" />; }
                            return null;
                          })}
                        </svg>
                      )}
                    </Box>
                    {isArchive && <PixelRuler height={archiveImgHeight} zoom={viewerZoom} side="right" />}
                  </Box>
                );
              } else {
                return (
                  <Box sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', pt: 10 }}>
                    <InsertDriveFileIcon sx={{ fontSize: 64 }} />
                    <Typography sx={{ color: 'rgba(255,255,255,0.5)', mt: 1 }}>{square.uploadedFile?.name}</Typography>
                  </Box>
                );
              }
            })()}
          </Box>
        </Box>
      </Dialog>
  );


  if (simpleView) {
    return (
      <>
      {!readOnly && square.sourceType && !square.isMainSource && (() => {
        const refIsSet = !!(square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable || eventHasCoords);
        const trustIsSet = sourceAvg > 0;
        const fileIsSet = !!square.uploadedFile;
        type CTA = { label: string; icon: React.ReactNode; accent: string; tip: string; onClick: () => void; isSet: boolean };
        const items: CTA[] = [
          {
            label: trustIsSet ? 'Trust ✓' : 'Set trust',
            icon: <StarRateIcon sx={{ fontSize: 10 }} />,
            accent: '#f59e0b',
            tip: trustIsSet ? 'Edit trust assessment — credibility, recency, completeness' : 'Score this source — credibility, recency, completeness',
            isSet: trustIsSet,
            onClick: () => { setLocalTrustRates({ ...square.trustRates }); setTrustInfoOpen(true); },
          },
          {
            label: refIsSet ? 'Reference ✓' : 'Set reference',
            icon: <BookmarkIcon sx={{ fontSize: 10 }} />,
            accent: '#3b82f6',
            tip: refIsSet ? 'Edit reference point' : 'Set a reference point — page, time, location, or note',
            isSet: refIsSet,
            onClick: () => { setRefDialogOpen(true); },
          },
          {
            label: fileIsSet ? 'File ✓' : 'Upload file',
            icon: <UploadFileIcon sx={{ fontSize: 10 }} />,
            accent: '#10b981',
            tip: fileIsSet ? 'Replace uploaded file' : 'Attach the source file — verification raises trust and lets readers see the original',
            isSet: fileIsSet,
            onClick: () => { setUploadWizardOpen(true); },
          },
        ];
        return (
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: 'absolute',
              left: square.position.x,
              top: square.position.y - 24,
              width: simpleCardW,
              display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.4,
              zIndex: 12, pointerEvents: 'none',
            }}>
            {items.map((it, i) => {
              const borderColor = it.isSet ? (isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.15)') : it.accent;
              const textColor   = it.isSet ? 'text.secondary' : it.accent;
              return (
                <Tooltip key={i} title={it.tip} placement="top">
                  <Box
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => { e.stopPropagation(); it.onClick(); }}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: 0.3,
                      px: 0.55, py: 0.2, borderRadius: '5px',
                      bgcolor: 'background.paper',
                      border: '1px solid', borderColor,
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                      cursor: 'pointer', pointerEvents: 'auto',
                      transition: 'box-shadow 120ms, transform 120ms',
                      '&:hover': { boxShadow: '0 3px 10px rgba(0,0,0,0.18)', transform: 'translateY(-1px)' },
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', color: it.accent, lineHeight: 0 }}>{it.icon}</Box>
                    <Typography sx={{ fontSize: 9, fontWeight: 700, color: textColor, lineHeight: 1, whiteSpace: 'nowrap' }}>
                      {it.label}
                    </Typography>
                  </Box>
                </Tooltip>
              );
            })}
          </Box>
        );
      })()}
      <Box onMouseDown={handleMouseDown} onContextMenu={handleContextMenu} sx={{
        position: 'absolute',
        left: square.position.x,
        top: (appMode === 'tree' && !square.isMainSource)
          ? square.position.y + (SQUARE_HEIGHT - simpleCardH) / 2
          : square.position.y,
        width: simpleCardW, height: simpleCardH,
        bgcolor: isDark ? 'rgba(26,26,36,0.98)' : 'rgba(255,255,255,0.98)',
        border: '2px solid', borderColor: isSelected ? sourceColor : (isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'),
        borderRadius: '12px',
        cursor: (isPublic || canvasLocked || readOnly) ? 'default' : (isDragging ? 'grabbing' : 'grab'),
        boxShadow: isSelected ? `0 0 0 3px ${sourceColor}25, 0 4px 16px rgba(0,0,0,0.15)` : `0 2px 8px rgba(0,0,0,${isDark ? 0.3 : 0.08})`,
        userSelect: 'none', display: 'flex', flexDirection: 'column', overflow: 'hidden',
        transition: 'box-shadow 0.15s, border-color 0.15s',
      }}>
        <Box sx={{ bgcolor: isSelected ? bannerColor : (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'), px: 1 * simpleScale, py: 0.4 * simpleScale, display: 'flex', alignItems: 'center', gap: 0.5, borderRadius: '10px 10px 0 0', transition: 'background 0.15s' }}>
          <Typography sx={{ fontSize: `${0.58 * simpleScale}rem`, fontWeight: 700, color: isSelected ? '#E3E3DF' : bannerColor, textTransform: 'uppercase', letterSpacing: '0.04em', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{currentSourceType?.label || 'Source'}</Typography>
        </Box>
        <Box sx={{ px: 1 * simpleScale, py: 0.5 * simpleScale, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.15 }}>
          <Typography sx={{ fontSize: `${0.72 * simpleScale}rem`, fontWeight: 700, lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', color: isDark ? '#E3E3DF' : 'text.primary' }}>{simpleTitle}</Typography>
          {displayInfo?.subtitle && <Typography sx={{ fontSize: `${0.56 * simpleScale}rem`, color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{displayInfo.subtitle}</Typography>}
          {simpleRefText ? (
            <Typography sx={{ fontSize: `${0.54 * simpleScale}rem`, color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontStyle: 'italic' }}>
              {currentSourceType?.refLabel ? `${currentSourceType.refLabel}: ` : 'Ref: '}{simpleRefText}
            </Typography>
          ) : square.reference.notApplicable ? (
            <Typography sx={{ fontSize: `${0.54 * simpleScale}rem`, color: '#16a34a', fontWeight: 600, fontStyle: 'italic' }}>
              Reference: N/A ✓
            </Typography>
          ) : null}
        </Box>
        <Box sx={{ px: 1 * simpleScale, py: 0.3 * simpleScale, borderTop: '1px solid', borderColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography onMouseDown={(e) => e.stopPropagation()} onClick={handleCopySourceId} sx={{ fontSize: `${0.5 * simpleScale}rem`, color: 'text.disabled', fontFamily: 'monospace', cursor: 'pointer', flexShrink: 0, lineHeight: 1, '&:hover': { color: 'text.secondary' } }}>{dispId(square.sourceId)}</Typography>
          <Box sx={{ flex: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 * simpleScale, flexShrink: 0 }}>
            <Typography sx={{ fontSize: `${0.52 * simpleScale}rem`, color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', lineHeight: 1, userSelect: 'none' }}>
              {square.isMainSource ? 'Seed' : orderLabel}
            </Typography>
          </Box>
          <Box sx={{ flex: 1 }} />
          {(sourceAvg > 0 || refAvg > 0) && (() => {
            const shown = trustAvg > 0 ? trustAvg : (sourceAvg > 0 ? sourceAvg : refAvg);
            const c = shown >= 7 ? '#16a34a' : shown >= 4 ? '#f59e0b' : '#ef4444';
            return (
              <Tooltip title={`Trust ${shown.toFixed(1)} · click for breakdown`} placement="top">
                <Box
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onOpenTrustDialog) {
                      onOpenTrustDialog(square.sourceId);
                    } else {
                      setLocalTrustRates({ ...square.trustRates });
                      setTrustInfoOpen(true);
                    }
                  }}
                  sx={{
                    display: 'inline-flex', alignItems: 'baseline', gap: 0.3 * simpleScale,
                    cursor: 'pointer', userSelect: 'none', lineHeight: 1, flexShrink: 0,
                    '&:hover': { textDecoration: 'underline', textDecorationColor: c },
                  }}>
                  <Typography sx={{ fontSize: `${0.46 * simpleScale}rem`, fontWeight: 700, color: c, textTransform: 'uppercase', letterSpacing: 0.3, lineHeight: 1 }}>Trust</Typography>
                  <Typography sx={{ fontSize: `${0.54 * simpleScale}rem`, fontWeight: 800, color: c, fontFamily: 'monospace', lineHeight: 1 }}>{shown.toFixed(1)}</Typography>
                </Box>
              </Tooltip>
            );
          })()}
          {onOpenEdit && !readOnly && (
            <Tooltip title="Edit seed fields">
              <IconButton onMouseDown={(e) => e.stopPropagation()} onClick={(e) => { e.stopPropagation(); onOpenEdit(); }}
                sx={{ width: 18 * simpleScale, height: 18 * simpleScale, ml: 0.3, color: 'text.disabled', '&:hover': { color: bannerColor } }}>
                <EditIcon sx={{ fontSize: 12 * simpleScale }} />
              </IconButton>
            </Tooltip>
          )}
          {onOpenRefSettings && !readOnly && (
            <Tooltip title="Bubble reference type">
              <IconButton onMouseDown={(e) => e.stopPropagation()} onClick={(e) => { e.stopPropagation(); onOpenRefSettings(); }}
                sx={{ width: 18 * simpleScale, height: 18 * simpleScale, ml: 0.3, color: 'text.disabled', '&:hover': { color: bannerColor } }}>
                <SettingsIcon sx={{ fontSize: 12 * simpleScale }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
      {imageViewerDialogElement}
      {replayViewerOpen && square.uploadedFile?.origin === 'web-archive' && (
        <Dialog disableScrollLock open={true} onClose={() => setReplayViewerOpen(false)} maxWidth={false} fullScreen PaperProps={{ sx: { bgcolor: '#1a1a2e', display: 'flex', flexDirection: 'column' } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 0.8, bgcolor: '#1e1e2e', borderBottom: '1px solid rgba(255,255,255,0.08)', gap: 1.5, flexShrink: 0 }}>
            <LanguageIcon sx={{ fontSize: 16, color: '#3b82f6', flexShrink: 0 }} />
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'rgba(255,255,255,0.06)', borderRadius: '6px', px: 1.5, py: 0.5, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
              <LockPersonIcon sx={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', flexShrink: 0 }} />
              <Typography sx={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                {square.uploadedFile.originalUrl || 'Archived page'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
              {square.uploadedFile.refAreas && square.uploadedFile.refAreas.length > 0 && (
                <Button size="small" startIcon={<CropFreeIcon sx={{ fontSize: 12 }} />}
                  onClick={() => window.dispatchEvent(new CustomEvent('archive-goto-ref'))}
                  sx={{ fontSize: 10, color: '#3b82f6', borderColor: 'rgba(59,130,246,0.3)', textTransform: 'none', '&:hover': { bgcolor: 'rgba(59,130,246,0.1)' } }} variant="outlined">
                  Go to Reference
                </Button>
              )}
              <Chip label={`Archived ${square.uploadedFile.archivedAt ? formatTimestamp(square.uploadedFile.archivedAt, appSettings || DEFAULT_SETTINGS) : ''}`} size="small" sx={{ fontSize: 9, height: 20, bgcolor: 'rgba(59,130,246,0.15)', color: '#3b82f6', fontFamily: 'monospace' }} />
              {square.uploadedFile.originalUrl && (
                <Tooltip title="Open original URL"><IconButton size="small" onClick={() => window.open(safeHref(square.uploadedFile!.originalUrl) || 'about:blank', '_blank', 'noopener,noreferrer')} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#E3E3DF' } }}><OpenInNewIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
              )}
              {square.uploadedFile.url && (
                <Tooltip title="Download WARC"><IconButton size="small" onClick={() => window.open(safeHref(square.uploadedFile!.url) || 'about:blank', '_blank', 'noopener,noreferrer')} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#E3E3DF' } }}><DownloadIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
              )}
              <IconButton onClick={() => setReplayViewerOpen(false)} sx={{ color: '#E3E3DF' }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
            </Box>
          </Box>
          <ArchiveReplayScene
            htmlUrl={square.uploadedFile.htmlUrl}
            warcUrl={square.uploadedFile.url}
            refArea={square.uploadedFile.refAreas && square.uploadedFile.refAreas[0]}
          />
        </Dialog>
      )}
      <SourceContextMenu anchorPosition={contextMenu} onClose={() => setContextMenu(null)} onDelete={() => setDeleteConfirmOpen(true)} onEdit={() => { setPendingSourceType(square.sourceType); setInfoDialogOpen(true); }} onViewGraph={onViewGraph ? () => onViewGraph(square.sourceId, square.fields.field2 || square.fields.field1 || square.sourceType || 'source') : undefined} onEmbed={onEmbed && isPublic ? () => onEmbed(square.sourceId, square.fields.field2 || square.fields.field1 || square.sourceType || 'source') : undefined} isPublic={isPublic} readOnly={readOnly} />
      <Dialog disableScrollLock open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)} maxWidth="xs" PaperProps={{ sx: { borderRadius: '12px' } }}>
        <DialogTitle sx={{ pb: 0.5 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><DeleteIcon color="error" /><Typography fontWeight={700} fontSize={16}>Delete Source?</Typography></Box></DialogTitle>
        <DialogContent>
          <Typography fontSize={12} color="text.secondary" lineHeight={1.6}>
            Are you sure you want to delete this source{displayInfo?.title ? ` "${displayInfo.title}"` : ''}? This will remove all its data, files, and references. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={() => setDeleteConfirmOpen(false)} color="inherit">Cancel</Button>
          <Button variant="contained" color="error" onClick={() => { setDeleteConfirmOpen(false); onDelete(square.id); }} sx={{ fontWeight: 600 }}>Delete</Button>
        </DialogActions>
      </Dialog>
      {!readOnly && <SourceInfoDialog open={infoDialogOpen} onClose={() => { setInfoDialogOpen(false); setPendingSourceType(null); }} onSave={(f, file, api) => onSourceTypeChange(square.id, pendingSourceType || square.sourceType, f, file, api)} sourceType={pendingSourceType || square.sourceType} currentFields={square.fields} currentFile={square.uploadedFile} isDark={isDark} onChangeType={() => setSourceTypeDialogOpen(true)} />}
      {!readOnly && <ReferenceDialog open={refDialogOpen} onClose={() => setRefDialogOpen(false)} onSave={(r) => onReferenceChange(square.id, r)} reference={square.reference} sourceType={square.sourceType} sourceFields={square.fields} isWebArchive={square.uploadedFile?.origin === 'web-archive'} />}
      <FileUploadWizard
        open={uploadWizardOpen}
        onClose={() => setUploadWizardOpen(false)}
        onDone={(file, _pages) => { onSourceTypeChange(square.id, square.sourceType, square.fields, file); setUploadWizardOpen(false); }}
        authToken={authToken || null}
        getToken={getTokenProp}
        boardId={boardId}
        sourceId={square.sourceId}
        isDark={isDark}
        apiBase={API_BASE}
      />
      {trustDialogElement}
      </>
    );
  }

  return (
    <>
      {isExpandedSeed && onCloseExpandedSeed && (
        <Box sx={{ position: 'absolute',
          left: square.position.x + square.size.width / 2, top: square.position.y - 36,
          transform: 'translateX(-50%)', zIndex: 30 }}>
          <Button onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); onCloseExpandedSeed(); }}
            size="small" variant="contained" startIcon={<CheckCircleIcon sx={{ fontSize: 14 }} />}
            sx={{ bgcolor: '#16a34a', color: '#E3E3DF', textTransform: 'none', fontSize: 11, fontWeight: 700,
              boxShadow: 3, height: 28, px: 1.6, '&:hover': { bgcolor: '#15803d' } }}>
            Done editing seed
          </Button>
        </Box>
      )}
      <Box onMouseDown={handleMouseDown} onContextMenu={handleContextMenu} sx={{
        position: 'absolute', left: square.position.x, top: square.position.y, width: square.size.width, height: square.size.height,
        bgcolor: isDark ? 'rgba(26,26,36,0.98)' : 'rgba(255,255,255,0.98)',
        border: '2px solid', borderColor: isSelected ? sourceColor : (isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'),
        borderRadius: '12px',
        cursor: (isPublic || canvasLocked || readOnly) ? 'default' : (isDragging ? 'grabbing' : 'grab'),
        boxShadow: isSelected ? `0 0 0 3px ${sourceColor}25, 0 4px 16px rgba(0,0,0,0.15)` : `0 2px 8px rgba(0,0,0,${isDark ? 0.3 : 0.08})`,
        userSelect: 'none', display: 'flex', flexDirection: 'column', overflow: 'hidden',
        transition: 'box-shadow 0.15s, border-color 0.15s',
      }}>
        {resizing && (
          <Box onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); setResizeStart({ x: e.clientX, y: e.clientY, w: square.size.width, h: square.size.height }); const onMove = (ev: MouseEvent) => { if (!resizeStart && !document.body.dataset.resizeW) return; const sw = parseFloat(document.body.dataset.resizeW || '560'); const sh = parseFloat(document.body.dataset.resizeH || '400'); const sx = parseFloat(document.body.dataset.resizeX || '0'); const sy = parseFloat(document.body.dataset.resizeY || '0'); const nw = Math.max(300, sw + (ev.clientX - sx) / zoom); const nh = Math.max(200, sh + (ev.clientY - sy) / zoom); onUpdate(square.id, { width: nw, height: nh }, square.position); }; const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); delete document.body.dataset.resizeW; delete document.body.dataset.resizeH; delete document.body.dataset.resizeX; delete document.body.dataset.resizeY; }; document.body.dataset.resizeW = String(square.size.width); document.body.dataset.resizeH = String(square.size.height); document.body.dataset.resizeX = String(e.clientX); document.body.dataset.resizeY = String(e.clientY); document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp); }}
            sx={{ position: 'absolute', bottom: -4, right: -4, width: 14, height: 14, cursor: 'nwse-resize', zIndex: 20, bgcolor: sourceColor, borderRadius: '2px', border: '2px solid', borderColor: 'background.paper', '&:hover': { transform: 'scale(1.3)' } }} />
        )}
        <Box sx={{
          bgcolor: isSelected ? bannerColor : (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'),
          px: 1.5, py: 0.8, display: 'flex', alignItems: 'center', gap: 0.6,
          borderRadius: '10px 10px 0 0', flexShrink: 0,
          transition: 'background 0.15s',
        }}>
          {square.isMainSource && <StarIcon sx={{ fontSize: 14, color: isSelected ? 'rgba(255,255,255,0.9)' : bannerColor }} />}
          <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: isSelected ? 'rgba(255,255,255,0.95)' : bannerColor, letterSpacing: 0.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2, textTransform: 'uppercase', flex: 1 }}>
            {currentSourceType?.label || (square.isMainSource ? 'Seed' : 'Source')}
          </Typography>
          {(sourceAvg > 0 || refAvg > 0) && (() => {
            const shown = trustAvg > 0 ? trustAvg : (sourceAvg > 0 ? sourceAvg : refAvg);
            const c = shown >= 7 ? '#16a34a' : shown >= 4 ? '#f59e0b' : '#ef4444';
            return (
              <Tooltip
                title={`Trust ${shown.toFixed(1)} · click for full per-category breakdown. Combined trust uses your ${sourceWeightPct}/${refWeightPct} source/reference weight (change in settings).`}
                placement="top">
                <Box
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onOpenTrustDialog) {
                      onOpenTrustDialog(square.sourceId);
                    } else {
                      setLocalTrustRates({ ...square.trustRates });
                      setTrustInfoOpen(true);
                    }
                  }}
                  sx={{
                    display: 'inline-flex', alignItems: 'baseline', gap: 0.4,
                    cursor: 'pointer', userSelect: 'none', lineHeight: 1, flexShrink: 0,
                    '&:hover': { textDecoration: 'underline', textDecorationColor: c },
                  }}>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: c, textTransform: 'uppercase', letterSpacing: 0.4, lineHeight: 1 }}>
                    Trust
                  </Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 800, color: c, fontFamily: 'monospace', lineHeight: 1 }}>
                    {shown.toFixed(1)}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })()}
        </Box>

        {(() => {
          const tabs = square.isMainSource ? ['summary', 'info', 'comments'] as const : ['summary', 'info', 'ref', 'comments', 'trust'] as const;
          const extraTabs = ['detail'] as const;
          const tabLabels: Record<string, string> = { summary: t('source.tab.summary', 'Summary'), info: t('source.tab.info', 'Info'), ref: t('source.tab.reference', 'References'), comments: t('source.tab.notes', 'Notes'), trust: t('source.tab.trust', 'Trust'), detail: t('source.tab.details', 'Details') };
          const tabIcons: Record<string, React.ReactNode> = { summary: <ViewCompactIcon sx={{ fontSize: 13 }} />, info: <InfoOutlinedIcon sx={{ fontSize: 13 }} />, ref: <BookmarkIcon sx={{ fontSize: 13 }} />, comments: <ChatBubbleOutlineIcon sx={{ fontSize: 13 }} />, trust: <StarRateIcon sx={{ fontSize: 13 }} />, detail: <SettingsIcon sx={{ fontSize: 13 }} /> };
          return (
            <>
              <Box onClick={(e) => { e.stopPropagation(); setTabMenuAnchor(e.currentTarget); }}
                sx={{ position: 'absolute', bottom: 8, right: tabValue !== 'summary' ? 38 : 10, zIndex: 10,
                  height: 28, display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', px: 1,
                  bgcolor: isDark ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.9)', borderRadius: '6px',
                  border: '1px solid', borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
                  boxShadow: 1, '&:hover': { bgcolor: sourceColor, color: '#E3E3DF', borderColor: sourceColor, '& svg': { color: '#E3E3DF !important' }, '& .tab-label': { color: '#E3E3DF' } },
                  transition: 'all 0.12s' }}>
                <Box sx={{ display: 'flex', color: sourceColor }}>{tabIcons[tabValue]}</Box>
                <Typography className="tab-label" sx={{ fontSize: 10, fontWeight: 600, color: 'text.secondary' }}>{tabLabels[tabValue]}</Typography>
                <ArrowDropDownIcon sx={{ fontSize: 14, color: 'text.disabled', ml: -0.3 }} />
              </Box>
              {tabValue !== 'summary' && (
                <Tooltip title="Back to summary">
                  <Box onClick={(e) => { e.stopPropagation(); setTabValue('summary'); updateURL(boardId, chainId, square.sourceId); }}
                    sx={{ position: 'absolute', bottom: 8, right: 10, zIndex: 10,
                      width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                      bgcolor: isDark ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.9)', borderRadius: '6px',
                      border: '1px solid', borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
                      boxShadow: 1, '&:hover': { bgcolor: sourceColor, '& svg': { color: '#E3E3DF !important' } },
                      transition: 'all 0.12s' }}>
                    <HomeIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                  </Box>
                </Tooltip>
              )}
              <Menu disableScrollLock anchorEl={tabMenuAnchor} open={Boolean(tabMenuAnchor)} onClose={() => setTabMenuAnchor(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                slotProps={{ paper: { sx: { borderRadius: '10px', minWidth: 160, mt: -0.5, boxShadow: 4, border: '1px solid', borderColor: 'divider' } } }}>
                {[...tabs].sort((a, b) => tabLabels[a].localeCompare(tabLabels[b])).map(t => {
                  const isActive = tabValue === t;
                  const isTrust = t === 'trust';
                  return (
                    <MenuItem key={t} onClick={() => { if (t === 'trust') { setLocalTrustRates({ ...square.trustRates }); setTrustInfoOpen(true); setTabMenuAnchor(null); return; } setTabValue(t); setTabMenuAnchor(null); if (t === 'summary') updateURL(boardId, chainId, square.sourceId); else updateURL(boardId, chainId, square.sourceId, t); }}
                      sx={{ fontSize: 11, fontWeight: isActive ? 700 : 400, gap: 1, py: 0.6, minHeight: 0,
                        color: isActive ? sourceColor : 'text.primary',
                        bgcolor: isActive ? `${sourceColor}10` : 'transparent',
                        opacity: 1 }}>
                      <Box sx={{ color: isActive ? sourceColor : 'text.secondary', display: 'flex' }}>{tabIcons[t]}</Box>
                      {tabLabels[t]}
                    </MenuItem>
                  );
                })}
                {!readOnly && <Divider />}
                {!readOnly && (
                  <MenuItem onClick={(e) => { e.stopPropagation(); setResizing(r => !r); setTabMenuAnchor(null); }}
                    sx={{ fontSize: 11, gap: 1, py: 0.6, minHeight: 0, color: resizing ? sourceColor : 'text.primary', bgcolor: resizing ? `${sourceColor}10` : 'transparent' }}>
                    <Box sx={{ color: resizing ? sourceColor : 'text.secondary', display: 'flex' }}><AspectRatioIcon sx={{ fontSize: 13 }} /></Box>
                    {resizing ? 'Stop Resize' : 'Resize Box'}
                  </MenuItem>
                )}
                <Divider />
                {extraTabs.map(t => {
                  const isActive = tabValue === t;
                  return (
                    <MenuItem key={t} onClick={() => { setTabValue(t); setTabMenuAnchor(null); updateURL(boardId, chainId, square.sourceId, t); }}
                      sx={{ fontSize: 11, fontWeight: isActive ? 700 : 400, gap: 1, py: 0.6, minHeight: 0,
                        color: isActive ? sourceColor : 'text.secondary',
                        bgcolor: isActive ? `${sourceColor}10` : 'transparent' }}>
                      <Box sx={{ color: isActive ? sourceColor : 'text.disabled', display: 'flex' }}>{tabIcons[t]}</Box>
                      {tabLabels[t]}
                    </MenuItem>
                  );
                })}
              </Menu>
            </>
          );
        })()}

        <Box sx={{ flex: 1, mx: 1.5, mt: 1.5, mb: '36px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {tabValue === 'summary' && (
            <>
              {displayInfo ? (
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                  {(() => {
                    const yf = currentSourceType?.fields.find((f: any) => f.type === 'year' || f.codeTag === 'year' || f.codeTag === 'date');
                    const yi = yf ? currentSourceType!.fields.indexOf(yf) : -1;
                    const yv = yi >= 0 ? (square.fields as any)[`field${yi + 1}`] : '';
                    const yr = yv ? (yv.length === 4 ? yv : yv.substring(0, 4)) : '';
                    const coverUrl = (() => {
                      if (square.sourceType === 'book') {
                        const isbn = square.fields.field6?.replace(/[-\s]/g, '');
                        const field10Val = square.fields.field10;
                        if (field10Val && field10Val.startsWith('http')) return field10Val;
                        if (isbn && isbn.length >= 10) return `${API_BASE}/cover-image?type=book&id=${isbn}`;
                        if (field10Val) return `${API_BASE}/cover-image?type=book&id=${field10Val}`;
                      }
                      if (square.sourceType === 'film') {
                        const imdbId = square.fields.field10;
                        if (imdbId && imdbId.startsWith('http')) return imdbId;
                        if (imdbId && imdbId.startsWith('tt')) return `${API_BASE}/cover-image?type=film&id=${imdbId}`;
                      }
                      return null;
                    })();
                    const showCoverPlaceholder = (square.sourceType === 'book' || square.sourceType === 'film') && !coverUrl;
                    const handleCoverUpload = async (file: File) => {
                      if (!file || !['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) return;
                      if (file.size > 10 * 1024 * 1024) return;
                      try {
                        const token = getTokenProp ? await getTokenProp() : authToken;
                        const fd = new FormData();
                        fd.append('cover', file);
                        fd.append('boardId', boardId);
                        fd.append('sourceId', square.sourceId);
                        const resp = await fetch(`${API_BASE}/upload-cover`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: fd });
                        if (resp.ok) {
                          const data = await resp.json();
                          onSourceTypeChange(square.id, square.sourceType, { ...square.fields, field10: data.url }, square.uploadedFile);
                        }
                      } catch {}
                    };
                    return (
                      <Box sx={{ mb: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.6 }}>
                            <Typography sx={{ fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.25, color: isDark ? '#E3E3DF' : 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', flex: 1, minWidth: 0 }}>{displayInfo.title}</Typography>
                          </Box>
                          {displayInfo.subtitle && <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.25 }}>{displayInfo.subtitle}</Typography>}
                          {yr && <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', mt: 0.25 }}>{yr}</Typography>}
                          {(square.sourceType === 'book' || square.sourceType === 'film') && (
                            coverUrl ? (
                              <CoverImage
                                coverUrl={coverUrl}
                                onEdit={!readOnly ? handleCoverUpload : undefined}
                                renderTrigger={(openFullsize) => (
                                  <Typography
                                    onClick={(e) => { e.stopPropagation(); openFullsize(); }}
                                    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, mt: 0.5, fontSize: '0.7rem', color: 'primary.main', cursor: 'pointer', userSelect: 'none', '&:hover': { textDecoration: 'underline' } }}>
                                    <ImageIcon sx={{ fontSize: 12 }} /> View cover
                                  </Typography>
                                )}
                              />
                            ) : !readOnly ? (
                              <Box component="label"
                                onClick={(e: any) => e.stopPropagation()}
                                sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, mt: 0.5, fontSize: '0.7rem', color: 'text.secondary', cursor: 'pointer', userSelect: 'none', '&:hover': { color: 'primary.main', textDecoration: 'underline' } }}>
                                <AddPhotoAlternateIcon sx={{ fontSize: 12 }} /> Upload cover
                                <input type="file" accept="image/png,image/jpeg" hidden
                                  onChange={(e) => { if (e.target.files?.[0]) handleCoverUpload(e.target.files[0]); }} />
                              </Box>
                            ) : null
                          )}
                        </Box>
                      </Box>
                    );
                  })()}
                  <Box sx={{ flex: 1 }} />
                  {square.sourceType === 'event' && (() => {
                    const coordField = square.fields.field3;
                    if (!coordField) return null;
                    const cp = coordField.split(',').map(s => parseFloat(s.trim()));
                    if (cp.length !== 2 || isNaN(cp[0]) || isNaN(cp[1])) return null;
                    return (
                      <Box sx={{ borderRadius: '6px', p: 0.8, mb: 0.5, bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          {square.fields.field2 && <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{square.fields.field2}</Typography>}
                          <Typography sx={{ fontSize: '0.6rem', fontFamily: 'monospace', color: 'text.disabled' }}>{cp[0].toFixed(5)}, {cp[1].toFixed(5)}</Typography>
                        </Box>
                        <Button size="small" onClick={(e) => { e.stopPropagation(); setMapDialogCoords({ lat: cp[0], lon: cp[1] }); }}
                          sx={{ fontSize: 9, minWidth: 0, px: 1, textTransform: 'none', flexShrink: 0 }}>
                          View Map
                        </Button>
                      </Box>
                    );
                  })()}
                  {square.sourceType === 'map' && (() => {
                    const coordField = square.fields.field2;
                    if (!coordField) return null;
                    const coordParts = coordField.split(',').map(s => parseFloat(s.trim()));
                    if (coordParts.length === 2 && !isNaN(coordParts[0]) && !isNaN(coordParts[1])) {
                      const lat = coordParts[0]; const lon = coordParts[1];
                      return (
                        <Box onClick={(e) => { e.stopPropagation(); setMapDialogCoords({ lat: coordParts[0], lon: coordParts[1] }); }} 
                          sx={{ borderRadius: '6px', overflow: 'hidden', mb: 0.5, border: '1px solid', borderColor: 'divider', height: 90, position: 'relative', cursor: 'pointer', '&:hover': { borderColor: sourceColor } }}>
                          <iframe title="Map" width="100%" height="100%" style={{ border: 0, pointerEvents: 'none' }}
                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${lon-0.02},${lat-0.012},${lon+0.02},${lat+0.012}&layer=mapnik&marker=${lat},${lon}`} />
                          <Box sx={{ position: 'absolute', bottom: 2, right: 4, bgcolor: 'rgba(0,0,0,0.6)', borderRadius: '3px', px: 0.5, py: 0.1, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                            <Typography sx={{ fontSize: 8, color: '#E3E3DF', fontFamily: 'monospace' }}>{lat.toFixed(4)}, {lon.toFixed(4)}</Typography>
                            <OpenInNewIcon sx={{ fontSize: 8, color: '#E3E3DF' }} />
                          </Box>
                        </Box>
                      );
                    }
                    return null;
                  })()}
                  {hasReference && (
                    <Box sx={{ mt: 0.5 }}>
                      <Typography sx={{ fontSize: '0.55rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.4 }}>Reference</Typography>
                      {square.reference.notApplicable ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <CheckCircleIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                          <Typography sx={{ fontSize: '0.7rem', color: '#16a34a', fontWeight: 600 }}>Reference: not applicable</Typography>
                        </Box>
                      ) : eventHasCoords && !square.reference.from && !square.reference.to ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <CheckCircleIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                          <Typography sx={{ fontSize: '0.7rem', color: '#16a34a', fontWeight: 600 }}>Map location set</Typography>
                        </Box>
                      ) : (
                        <>
                          <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary', lineHeight: 1.45, mb: 0.4 }}>
                            {refDescription}
                            {chainEnded && chainEndReason === 'unknown' && square.order === 1 && (
                              <Box component="span" sx={{ color: '#d97706', fontWeight: 600 }}>
                                {' '}— but the origin of this source is unknown
                              </Box>
                            )}
                          </Typography>
                          {square.reference.refType && <Chip label={square.reference.refType} size="small" sx={{ fontSize: '0.6rem', height: 18, mb: 0.4, bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)', fontWeight: 600 }} />}
                          {(square.reference.from || square.reference.to) && (
                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
                              <Box component="span" sx={{ color: 'text.secondary', fontWeight: 500, mr: 0.5 }}>
                                {(currentSourceType?.refLabel || 'Ref')}:
                              </Box>
                              {square.reference.from}{square.reference.from && square.reference.to && <span style={{ color: sourceColor, margin: '0 4px' }}>→</span>}{square.reference.to}
                            </Typography>
                          )}
                          {square.reference.notes && <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', lineHeight: 1.35, mt: 0.4, fontStyle: 'italic' }}>{square.reference.notes}</Typography>}
                          {(square.reference.fromSectionStartsWith || square.reference.toSectionEndsWith) && (
                            <Typography sx={{ fontSize: '0.62rem', color: 'text.disabled', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.3, lineHeight: 1.3 }}>
                              {square.reference.fromSectionStartsWith && square.reference.from && (
                                <Box component="span" sx={{ fontStyle: 'normal', fontWeight: 600, color: 'text.secondary', mr: 0.5 }}>{`p.${square.reference.from}`}</Box>
                              )}
                              {square.reference.fromSectionStartsWith && `«${square.reference.fromSectionStartsWith}»`}
                              {square.reference.fromSectionStartsWith && square.reference.toSectionEndsWith && ' … '}
                              {!square.reference.fromSectionStartsWith && square.reference.toSectionEndsWith && '… '}
                              {square.reference.toSectionEndsWith && `«${square.reference.toSectionEndsWith}»`}
                              {square.reference.toSectionEndsWith && square.reference.to && (
                                <Box component="span" sx={{ fontStyle: 'normal', fontWeight: 600, color: 'text.secondary', ml: 0.5 }}>{`p.${square.reference.to}`}</Box>
                              )}
                            </Typography>
                          )}
                        </>
                      )}
                    </Box>
                  )}
                </Box>
              ) : (
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {!square.sourceType ? (
                    !readOnly ? (
                      <Box sx={{ textAlign: 'center' }}>
                        <ArticleIcon sx={{ fontSize: 36, color: 'text.disabled', mb: 1 }} />
                        <Typography color="text.secondary" fontSize={12} sx={{ mb: 1 }}>Choose a source type to get started</Typography>
                        <Button variant="contained" size="small" onClick={(e) => { e.stopPropagation(); setSourceTypeDialogOpen(true); }} sx={{ fontSize: 12 }}>Choose Source Type</Button>
                      </Box>
                    ) : <Typography color="text.secondary" fontSize={12}>No source type selected</Typography>
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography color="text.secondary" fontSize={12}>No info yet</Typography>
                      {!readOnly && <Button size="small" variant="outlined" startIcon={<EditIcon sx={{ fontSize: 14 }} />} onClick={(e) => { e.stopPropagation(); setPendingSourceType(square.sourceType); setInfoDialogOpen(true); }} sx={{ mt: 0.5, fontSize: 11 }}>Edit source details</Button>}
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}
          {tabValue === 'info' && (
            <>
              {displayFields.length > 0 && (
                <Box sx={{ flex: 1, bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)', borderRadius: '6px', p: 1, overflow: 'hidden', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>{displayFields.slice(0, halfPoint).map((f) => {
                    const fieldEdit = fieldEdits?.find(e => e.field === f.label);
                    const apiOriginal = square.apiPrefillFields?.[f.key];
                    const isApiModified = apiOriginal !== undefined && apiOriginal !== f.value;
                    return (
                      <Box key={f.key}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                          {isApiModified && (
                            <Tooltip title={`Modified from database value: "${apiOriginal}"`}>
                              <FiberManualRecordIcon sx={{ fontSize: 6, color: '#FFD465' }} />
                            </Tooltip>
                          )}
                          {fieldEdit && (
                            <Tooltip title={`Edited ${formatTimestamp(fieldEdit.editedAt, appSettings || DEFAULT_SETTINGS)}: "${fieldEdit.oldValue || '(empty)'}" → "${fieldEdit.newValue || '(empty)'}"`}>
                              <FiberManualRecordIcon sx={{ fontSize: 5, color: '#f59e0b' }} />
                            </Tooltip>
                          )}
                          <Typography sx={{ fontSize: '0.55rem', color: sourceColor, textTransform: 'uppercase', fontWeight: 600, letterSpacing: 0.3, lineHeight: 1 }}>{f.label}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordBreak: 'break-word' }}>{f.value}</Typography>
                      </Box>
                    );
                  })}</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>{displayFields.slice(halfPoint).map((f) => {
                    const fieldEdit = fieldEdits?.find(e => e.field === f.label);
                    const apiOriginal = square.apiPrefillFields?.[f.key];
                    const isApiModified = apiOriginal !== undefined && apiOriginal !== f.value;
                    return (
                      <Box key={f.key}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                          {isApiModified && (
                            <Tooltip title={`Modified from database value: "${apiOriginal}"`}>
                              <FiberManualRecordIcon sx={{ fontSize: 6, color: '#FFD465' }} />
                            </Tooltip>
                          )}
                          {fieldEdit && (
                            <Tooltip title={`Edited ${formatTimestamp(fieldEdit.editedAt, appSettings || DEFAULT_SETTINGS)}: "${fieldEdit.oldValue || '(empty)'}" → "${fieldEdit.newValue || '(empty)'}"`}>
                              <FiberManualRecordIcon sx={{ fontSize: 5, color: '#f59e0b' }} />
                            </Tooltip>
                          )}
                          <Typography sx={{ fontSize: '0.55rem', color: sourceColor, textTransform: 'uppercase', fontWeight: 600, letterSpacing: 0.3, lineHeight: 1 }}>{f.label}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordBreak: 'break-word' }}>{f.value}</Typography>
                      </Box>
                    );
                  })}</Box>
                </Box>
              )}
              {!readOnly && square.sourceType && (
                <Button size="small" startIcon={<EditIcon sx={{ fontSize: 14 }} />} onClick={(e) => { e.stopPropagation(); setPendingSourceType(square.sourceType); setInfoDialogOpen(true); }} sx={{ mt: 1, fontSize: 11, color: 'text.secondary', alignSelf: 'flex-start' }}>
                  Edit Details
                </Button>
              )}
              {displayFields.length === 0 && square.sourceType && (
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                  <Typography color="text.secondary" fontSize={12}>No info yet</Typography>
                  {!readOnly && <Button size="small" variant="outlined" startIcon={<EditIcon sx={{ fontSize: 14 }} />} onClick={(e) => { e.stopPropagation(); setPendingSourceType(square.sourceType); setInfoDialogOpen(true); }} sx={{ fontSize: 11 }}>Edit source details</Button>}
                </Box>
              )}
              {!square.sourceType && (
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {!readOnly ? (
                    <Box sx={{ textAlign: 'center' }}>
                      <ArticleIcon sx={{ fontSize: 36, color: 'text.disabled', mb: 1 }} />
                      <Typography color="text.secondary" fontSize={12} sx={{ mb: 1 }}>Choose a source type first</Typography>
                      <Button variant="contained" size="small" onClick={(e) => { e.stopPropagation(); setSourceTypeDialogOpen(true); }} sx={{ fontSize: 12 }}>Choose Source Type</Button>
                    </Box>
                  ) : <Typography color="text.secondary" fontSize={12}>No source type selected</Typography>}
                </Box>
              )}
            </>
          )}
          {tabValue === 'ref' && (
            <Box sx={{ flex: 1, overflow: 'auto', px: 0.8, py: 0.5 }}>
              <Box sx={{ mb: 1.5, bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)', borderRadius: '6px', p: 0.8 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, mb: 0.5 }}>
                  <BookmarkIcon sx={{ fontSize: 11, color: sourceColor }} />
                  <Typography sx={{ fontSize: '0.55rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Reference Pointer</Typography>
                </Box>
                {hasReference ? (
                  <Box>
                    {square.reference.notApplicable ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <CheckCircleIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                        <Typography sx={{ fontSize: '0.7rem', color: '#16a34a', fontWeight: 600 }}>Reference: not applicable</Typography>
                      </Box>
                    ) : eventHasCoords && !square.reference.from && !square.reference.to ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <CheckCircleIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                        <Typography sx={{ fontSize: '0.7rem', color: '#16a34a', fontWeight: 600 }}>Map location set — reference valid</Typography>
                      </Box>
                    ) : (
                      <>
                        <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary', lineHeight: 1.5, mb: 0.5 }}>{refDescription}</Typography>
                        {square.reference.refType && <Chip label={square.reference.refType} size="small" sx={{ fontSize: '0.6rem', height: 18, mb: 0.5, bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)', fontWeight: 600 }} />}
                        {(square.reference.from || square.reference.to) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)', borderRadius: '4px', px: 0.8, py: 0.4, mb: 0.5 }}>
                            {square.reference.from && <Box><Typography sx={{ fontSize: '0.5rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase' }}>From</Typography><Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{square.reference.from}</Typography></Box>}
                            {square.reference.from && square.reference.to && <Typography sx={{ color: sourceColor, fontSize: '0.9rem' }}>→</Typography>}
                            {square.reference.to && <Box><Typography sx={{ fontSize: '0.5rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase' }}>To</Typography><Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{square.reference.to}</Typography></Box>}
                          </Box>
                        )}
                        {square.reference.notes && (
                          <Box sx={{ mt: 0.3 }}>
                            <Typography sx={{ fontSize: '0.5rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase', mb: 0.1 }}>Notes</Typography>
                            <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', wordBreak: 'break-word', lineHeight: 1.5, fontStyle: 'italic' }}>{square.reference.notes}</Typography>
                          </Box>
                        )}
                      </>
                    )}
                    {!readOnly && (
                      <Button size="small" startIcon={<EditIcon sx={{ fontSize: 12 }} />} onClick={(e) => { e.stopPropagation(); setRefDialogOpen(true); }} sx={{ fontSize: 10, color: sourceColor, mt: 0.5 }}>Edit Reference</Button>
                    )}
                  </Box>
                ) : (
                  <Box>
                    <Typography sx={{ fontSize: '0.65rem', color: 'text.disabled', mb: 0.5 }}>No reference pointer set</Typography>
                    {!readOnly && square.sourceType && (
                      <Button size="small" variant="text" startIcon={<BookmarkIcon sx={{ fontSize: 12 }} />} onClick={(e) => { e.stopPropagation(); setRefDialogOpen(true); }} sx={{ fontSize: 10, p: 0 }}>Add reference to make public</Button>
                    )}
                    {!square.sourceType && <Typography sx={{ fontSize: '0.6rem', color: 'text.disabled' }}>Select a source type first</Typography>}
                  </Box>
                )}
              </Box>

              {!square.isMainSource && (
              <Box sx={{ bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)', borderRadius: '6px', p: 0.8 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, mb: 0.5 }}>
                  <InsertDriveFileIcon sx={{ fontSize: 11, color: sourceColor }} />
                  <Typography sx={{ fontSize: '0.55rem', color: sourceColor, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{t('source.referenceFile', 'Reference File')}</Typography>
                </Box>
                {square.uploadedFile ? (
                  <Box>
                    <Typography sx={{ fontSize: '0.65rem', fontWeight: 600, fontFamily: 'monospace', mb: 0.3 }}>{square.uploadedFile.name}</Typography>
                    <Typography sx={{ fontSize: '0.6rem', color: 'text.secondary', mb: 0.4 }}>
                      {square.uploadedFile.origin === 'web-archive' ? t('source.webArchive', 'Web Archive') : (square.uploadedFile.origin || 'File')} · {formatFileSize(square.uploadedFile.size)}{square.uploadedFile.citedPages?.length ? ` · Page ${square.uploadedFile.citedPages.join(', ')}` : ''}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                      <Button size="small" startIcon={<OpenInNewIcon sx={{ fontSize: 11 }} />} onClick={() => { setImagePreviewOpen(true); updateURL(boardId, chainId, square.sourceId, 'file'); }} sx={{ fontSize: 9, textTransform: 'none', p: 0, minWidth: 0 }}>{t('source.viewFile', 'View file')}</Button>
                      {square.uploadedFile.origin === 'web-archive' && square.uploadedFile.url && (
                        <Button size="small" startIcon={<LanguageIcon sx={{ fontSize: 10 }} />} onClick={() => setReplayViewerOpen(true)} sx={{ fontSize: 9, textTransform: 'none', p: 0, minWidth: 0, color: '#3b82f6' }}>{t('source.browseArchive', 'Browse Archive')}</Button>
                      )}
                      {!readOnly && (
                        <Button size="small" color="error" onClick={(e) => { e.stopPropagation(); setRemoveConfirmOpen(true); }} sx={{ fontSize: 9, textTransform: 'none', p: 0, minWidth: 0 }}>{t('source.remove', 'Remove')}</Button>
                      )}
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    <Typography sx={{ fontSize: '0.65rem', color: 'text.disabled', mb: 0.5 }}>{t('source.noFile', 'No reference file attached')}</Typography>
                    {!readOnly && (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button size="small" variant="outlined" startIcon={<UploadFileIcon sx={{ fontSize: 11 }} />} onClick={(e) => { e.stopPropagation(); setUploadWizardOpen(true); }} sx={{ fontSize: 9, textTransform: 'none', borderColor: sourceColor, color: sourceColor }}>{t('source.uploadFile', 'Upload File')}</Button>
                        <Button size="small" variant="outlined" startIcon={<LanguageIcon sx={{ fontSize: 11 }} />}
                          onClick={(e) => { e.stopPropagation(); const uf = currentSourceType?.fields.find(f => f.type === 'url'); const ui = uf ? currentSourceType!.fields.indexOf(uf) : -1; setArchiveUrlInput(ui >= 0 ? (square.fields as any)[`field${ui + 1}`] || '' : ''); setArchiveDialogOpen(true); setArchiveStep(1); setArchiveStatus('idle'); setArchiveResult(null); setArchiveError(''); setArchiveHighlights([]); setArchiveRefArea(null); setArchiveHlTool(null); fetch(`${API_BASE}/archive-defaults`).then(r => r.json()).then(d => { if (d.scrollTime !== undefined) setArchiveScrollTime(d.scrollTime); if (d.browser) setArchiveBrowser(d.browser); if (d.viewportWidth) setArchiveWidth(d.viewportWidth); }).catch(() => {}); }}
                          sx={{ fontSize: 9, textTransform: 'none', borderColor: '#3b82f6', color: '#3b82f6' }}>{t('source.archiveUrl', 'Archive URL')}</Button>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
              )}

            </Box>
          )}
          {tabValue === 'comments' && (
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                <ForumIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase' }}>User Comments</Typography>
              </Box>
              {!readOnly ? (
                <TextField
                  multiline minRows={6} maxRows={12} fullWidth size="small"
                  placeholder="Add your comments, observations, or analysis about this source..."
                  defaultValue={square.comments || ''}
                  onBlur={(e) => onCommentsChange?.(square.id, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  InputProps={{ sx: { fontSize: '0.8rem', lineHeight: 1.6 } }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
                />
              ) : (
                square.comments ? (
                  <Box sx={{ bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '6px', p: 1.5, border: '1px solid', borderColor: 'divider' }}>
                    <Typography sx={{ fontSize: '0.8rem', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{square.comments}</Typography>
                  </Box>
                ) : (
                  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography color="text.secondary" fontSize={12}>No comments added</Typography>
                  </Box>
                )
              )}
            </Box>
          )}
          {tabValue === 'trust' && (() => {
            const refSet = !!(square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable);
            const sourceTitle = displayInfo?.title || 'Untitled';
            const typeLabel = currentSourceType?.label || 'Source';
            const sourceColorBlock = (val: number) => val >= 7 ? '#16a34a' : val >= 4 ? '#f59e0b' : val > 0 ? '#ef4444' : '#cbd5e1';
            const SectionCard: React.FC<{ step: number; title: string; sub: string;
              accentBg: string; accentBorder: string; accentDot: string;
              avg: number; rates: Array<{ label: string; value: number }>;
              disabled?: boolean }>
            = ({ step, title, sub, accentBg, accentBorder, accentDot, avg, rates, disabled }) => (
              <Box sx={{ p: 1.4, borderRadius: '8px', mb: 1.2,
                bgcolor: disabled ? (isDark ? 'rgba(255,255,255,0.025)' : 'rgba(0,0,0,0.02)') : accentBg,
                border: '1px solid', borderColor: disabled ? 'divider' : accentBorder,
                opacity: disabled ? 0.55 : 1, transition: 'opacity 120ms' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.6 }}>
                  <Box sx={{ width: 18, height: 18, borderRadius: '50%',
                    bgcolor: disabled ? '#94a3b8' : accentDot, color: 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, fontWeight: 800, flexShrink: 0 }}>{step}</Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography fontSize={11} fontWeight={700} sx={{ color: disabled ? 'text.disabled' : 'text.primary' }}>{title}</Typography>
                    <Typography fontSize={9} color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sub}</Typography>
                  </Box>
                  <Box sx={{ minWidth: 38, textAlign: 'center',
                    bgcolor: avg > 0 ? sourceColorBlock(avg) : (isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'),
                    color: avg > 0 ? 'white' : 'text.disabled',
                    borderRadius: '4px', px: 0.6, py: 0.2 }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 800, fontFamily: 'monospace', lineHeight: 1 }}>
                      {avg > 0 ? avg.toFixed(1) : '—'}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.4 }}>
                  {rates.map(r => (
                    <Box key={r.label} sx={{ display: 'flex', alignItems: 'center', gap: 0.3,
                      bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
                      px: 0.6, py: 0.15, borderRadius: '4px' }}>
                      <Typography sx={{ fontSize: 9, color: 'text.secondary' }}>{r.label}</Typography>
                      <Typography sx={{ fontSize: 9, fontWeight: 700, fontFamily: 'monospace',
                        color: r.value > 0 ? sourceColorBlock(r.value) : 'text.disabled' }}>
                        {r.value > 0 ? r.value.toFixed(1) : '—'}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            );
            return (
              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, p: 1.5, overflow: 'auto' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, mb: 0.4 }}>
                  <StarRateIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography fontSize={11} fontWeight={700}>Trust Assessment</Typography>
                    <Typography fontSize={9} color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {typeLabel}: {sourceTitle}
                    </Typography>
                  </Box>
                  {!square.uploadedFile
                    ? <Tooltip title="Verification: 0/10 — no file attached"><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ef4444' }} /></Tooltip>
                    : <Tooltip title="Verification: 10/10 — file attached"><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#16a34a' }} /></Tooltip>}
                </Box>

                <SectionCard
                  step={1}
                  title="Score the source"
                  sub={`The ${typeLabel.toLowerCase()} as a whole`}
                  accentBg={isDark ? 'rgba(16,185,129,0.06)' : 'rgba(16,185,129,0.04)'}
                  accentBorder={isDark ? 'rgba(16,185,129,0.22)' : 'rgba(16,185,129,0.2)'}
                  accentDot="#10b981"
                  avg={sourceAvg}
                  rates={[
                    { label: 'Credibility',   value: square.trustRates.credibility || 0 },
                    { label: 'Verifiability', value: square.trustRates.verifiability || 0 },
                    { label: 'Timeliness',    value: square.trustRates.recency || 0 },
                    ...(square.trustRates.completeness ? [{ label: 'Completeness', value: square.trustRates.completeness }] : []),
                  ]}
                />

                <SectionCard
                  step={2}
                  title="Score the reference"
                  sub={refSet ? 'The cited part of this source' : 'Set a reference point first'}
                  accentBg={isDark ? 'rgba(59,130,246,0.06)' : 'rgba(59,130,246,0.04)'}
                  accentBorder={isDark ? 'rgba(59,130,246,0.22)' : 'rgba(59,130,246,0.2)'}
                  accentDot="#3b82f6"
                  avg={refAvg}
                  rates={[
                    { label: 'Accuracy',  value: square.trustRates.accuracy || 0 },
                    { label: 'Relevance', value: square.trustRates.relevance || 0 },
                  ]}
                  disabled={!refSet}
                />

                <Button variant="outlined" size="small" startIcon={<StarRateIcon sx={{ fontSize: 14 }} />}
                  onClick={(e) => { e.stopPropagation(); setLocalTrustRates({ ...square.trustRates }); setTrustInfoOpen(true); }}
                  sx={{ fontSize: 11, textTransform: 'none', mt: 0.4, alignSelf: 'flex-start' }}>
                  {square.trustAssessed ? 'Edit assessment' : 'Start assessment'}
                </Button>
              </Box>
            );
          })()}
          {tabValue === 'detail' && (
            <Box sx={{ height: '100%', overflow: 'auto', px: 0.5, py: 0.5 }}>
              <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>Metadata</Typography>
              <Box sx={{ fontFamily: 'monospace', fontSize: 10, lineHeight: 1.8, color: 'text.secondary' }}>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Source ID</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{dispId(square.sourceId || "")}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Board ID</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{dispId(boardId || "")}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Created</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.createdAt ? formatTimestamp(square.createdAt, appSettings || DEFAULT_SETTINGS) : '—'}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Modified</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.updatedAt ? formatTimestamp(square.updatedAt, appSettings || DEFAULT_SETTINGS) : '—'}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Created by</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.createdBy || '—'}</Typography>{creatorVerified && <Tooltip title="Email verified"><CheckCircleIcon sx={{ fontSize: 10, color: '#16a34a' }} /></Tooltip>}</Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Type</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{currentSourceType?.label || square.sourceType || '—'}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Order</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.order} ({orderLabel})</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Main</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.isMainSource ? 'Yes' : 'No'}</Typography></Box>
                {square.refPointId && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Ref Point</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.refPointId}</Typography></Box>}
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Position</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>x:{Math.round(square.position.x)} y:{Math.round(square.position.y)}</Typography></Box>
                <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Size</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{Math.round(square.size.width)}×{Math.round(square.size.height)}</Typography></Box>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>Fields</Typography>
              <Box sx={{ fontFamily: 'monospace', fontSize: 10, lineHeight: 1.8, color: 'text.secondary' }}>
                {currentSourceType?.fields.map((f, i) => {
                  const val = (square.fields as any)[`field${i + 1}`] || '';
                  return val ? (
                    <Box key={i} sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.label}</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{val}</Typography></Box>
                  ) : null;
                })}
              </Box>
              {(square.reference.from || square.reference.to) && (<>
                <Divider sx={{ my: 1 }} />
                <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>Reference</Typography>
                <Box sx={{ fontFamily: 'monospace', fontSize: 10, lineHeight: 1.8, color: 'text.secondary' }}>
                  {square.reference.from && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>From</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.reference.from}</Typography></Box>}
                  {square.reference.to && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>To</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.reference.to}</Typography></Box>}
                  {square.reference.notes && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Notes</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{square.reference.notes}</Typography></Box>}
                  {square.reference.refType && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Type</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.reference.refType}</Typography></Box>}
                </Box>
              </>)}
              {square.uploadedFile && (<>
                <Divider sx={{ my: 1 }} />
                <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>File</Typography>
                <Box sx={{ fontFamily: 'monospace', fontSize: 10, lineHeight: 1.8, color: 'text.secondary' }}>
                  <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Name</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{square.uploadedFile.name}</Typography></Box>
                  <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Type</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.uploadedFile.type}</Typography></Box>
                  <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Size</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{formatFileSize(square.uploadedFile.size)}</Typography></Box>
                  {square.uploadedFile.pageCount && <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Pages</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.uploadedFile.pageCount}</Typography></Box>}
                  <Box sx={{ display: 'flex', gap: 1 }}><Typography fontSize={10} fontWeight={600} sx={{ width: 80, flexShrink: 0, fontFamily: 'monospace' }}>Uploaded</Typography><Typography fontSize={10} sx={{ fontFamily: 'monospace' }}>{square.uploadedFile.uploadedAt ? formatTimestamp(square.uploadedFile.uploadedAt, appSettings || DEFAULT_SETTINGS) : '—'}</Typography></Box>
                </Box>
              </>)}
              {square.sourceType === 'event' && (() => {
                const coordField = square.fields.field3;
                if (!coordField) return null;
                const coordParts = coordField.split(',').map(s => parseFloat(s.trim()));
                if (coordParts.length !== 2 || isNaN(coordParts[0]) || isNaN(coordParts[1])) return null;
                const lat = coordParts[0]; const lon = coordParts[1];
                const location = square.fields.field2 || '';
                const eventType = square.fields.field7 || '';
                return (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5 }}>Event Location</Typography>
                    <Box onClick={(e) => { e.stopPropagation(); setMapDialogCoords({ lat, lon }); }}
                      sx={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid', borderColor: 'divider', height: 120, position: 'relative', cursor: 'pointer', '&:hover': { borderColor: sourceColor, boxShadow: 1 } }}>
                      <iframe title="Event Map" width="100%" height="100%" style={{ border: 0, pointerEvents: 'none' }}
                        src={`https://www.openstreetmap.org/export/embed.html?bbox=${lon-0.03},${lat-0.018},${lon+0.03},${lat+0.018}&layer=mapnik&marker=${lat},${lon}`} />
                      <Box sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'rgba(0,0,0,0.7)', borderRadius: '4px', px: 0.8, py: 0.3, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                        <Typography sx={{ fontSize: 8, color: '#E3E3DF', fontFamily: 'monospace' }}>📍 {lat.toFixed(5)}, {lon.toFixed(5)}</Typography>
                        <OpenInNewIcon sx={{ fontSize: 8, color: '#E3E3DF' }} />
                      </Box>
                    </Box>
                    <Typography sx={{ fontSize: 9, color: 'text.disabled', mt: 0.5 }}>
                      {location}{location && eventType ? ' · ' : ''}{eventType}{' — click to enlarge'}
                    </Typography>
                  </>
                );
              })()}
            </Box>
          )}
          {displayInfo?.title && (
            <Box sx={{ flexShrink: 0, pt: 0.5, px: 0.5 }}>
              <Divider sx={{ mb: 0.5, opacity: 0.5 }} />
              <Typography sx={{ fontSize: '0.7rem', color: 'text.disabled', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {currentSourceType?.label || 'Source'}: {displayInfo.title}
              </Typography>
            </Box>
          )}
        </Box>

        {!readOnly && (
          <>
          <SourceTypeDialog open={sourceTypeDialogOpen} onClose={() => setSourceTypeDialogOpen(false)} onSelect={handleSourceTypeSelect} isDark={isDark} />
          <Dialog disableScrollLock open={typeChangeConfirmOpen} onClose={() => { setTypeChangeConfirmOpen(false); setTypeChangePending(null); }} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
            <DialogTitle sx={{ pb: 0.5 }}>
              <Typography fontWeight={700} fontSize={16}>Change Source Type?</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography fontSize={12} color="text.secondary" lineHeight={1.6}>
                This source already has data. Changing the source type will <strong>permanently reset</strong> all information:
              </Typography>
              <Box sx={{ mt: 1.5, mb: 0.5, pl: 1, borderLeft: '3px solid', borderColor: '#ef4444', display: 'flex', flexDirection: 'column', gap: 0.4 }}>
                {Object.values(square.fields).some(v => (v as string).trim() !== '') && <Typography fontSize={11} color="text.secondary">• All field data (title, author, etc.)</Typography>}
                {square.uploadedFile && <Typography fontSize={11} color="text.secondary">• Uploaded file: {(square.uploadedFile as any).originalName || 'document'}</Typography>}
                {(square.reference.from || square.reference.to || square.reference.notes) && <Typography fontSize={11} color="text.secondary">• Reference point data</Typography>}
                {square.trustAssessed && <Typography fontSize={11} color="text.secondary">• Trust assessment ratings</Typography>}
                {square.comments?.trim() && <Typography fontSize={11} color="text.secondary">• Notes / comments</Typography>}
              </Box>
              <Typography fontSize={11} color="error.main" fontWeight={600} sx={{ mt: 1.5 }}>This action cannot be undone.</Typography>
            </DialogContent>
            <DialogActions sx={{ px: 2.5, pb: 2 }}>
              <Button onClick={() => { setTypeChangeConfirmOpen(false); setTypeChangePending(null); }} color="inherit">Cancel</Button>
              <Button variant="contained" color="error" onClick={() => { setTypeChangeConfirmOpen(false); if (typeChangePending) proceedWithTypeChange(typeChangePending.type, typeChangePending.prefill); setTypeChangePending(null); }}
                sx={{ fontWeight: 600 }}>
                Reset & Change Type
              </Button>
            </DialogActions>
          </Dialog>
          </>
        )}
        <FileUploadWizard
            open={uploadWizardOpen}
            onClose={() => setUploadWizardOpen(false)}
            onDone={(file, _pages) => { onSourceTypeChange(square.id, square.sourceType, square.fields, file); setUploadWizardOpen(false); }}
            authToken={authToken || null}
            getToken={getTokenProp}
            boardId={boardId}
            sourceId={square.sourceId}
            isDark={isDark}
            apiBase={API_BASE}
          />
        <Box sx={{ position: 'absolute', bottom: 8, left: 10, display: 'flex', alignItems: 'center', gap: 0.7, zIndex: 5 }}>
          <Typography onMouseDown={(e) => e.stopPropagation()} onClick={handleCopySourceId} sx={{ fontSize: '0.75rem', color: 'text.disabled', fontFamily: 'monospace', cursor: 'pointer', flexShrink: 0, lineHeight: 1.2, '&:hover': { color: 'text.secondary' } }}>{showCopied ? '✓ copied' : dispId(square.sourceId)}</Typography>
        </Box>
        <Box sx={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', zIndex: 5, pointerEvents: 'none' }}>
          <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', lineHeight: 1.2, userSelect: 'none' }}>
            {square.isMainSource ? 'Seed' : orderLabel}
          </Typography>
        </Box>
      </Box>

      {!simpleView && !readOnly && !square.isMainSource && (() => {
        const refIsSet = !!(square.reference.from || square.reference.to || square.reference.notes || square.reference.notApplicable || eventHasCoords);
        const items: Array<{ label: string; icon: React.ReactNode; accent: string; tip: string; onClick: () => void }> = [];
        if (sourceAvg === 0 && square.sourceType) {
          items.push({
            label: 'Set trust', icon: <StarRateIcon sx={{ fontSize: 11 }} />, accent: '#f59e0b',
            tip: 'Score this source — credibility, recency, completeness',
            onClick: () => { setLocalTrustRates({ ...square.trustRates }); setTrustInfoOpen(true); },
          });
        }
        if (!refIsSet && square.sourceType) {
          items.push({
            label: 'Set reference', icon: <BookmarkIcon sx={{ fontSize: 11 }} />, accent: '#3b82f6',
            tip: 'Set a reference point — page, time, location, or note',
            onClick: () => { setRefDialogOpen(true); },
          });
        }
        if (!square.uploadedFile && square.sourceType) {
          items.push({
            label: 'Upload file', icon: <UploadFileIcon sx={{ fontSize: 11 }} />, accent: '#10b981',
            tip: 'Attach the source file — verification raises the trust score and lets readers see the original',
            onClick: () => { setUploadWizardOpen(true); },
          });
        }
        if (items.length === 0) return null;
        return (
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: 'absolute',
              left: square.position.x,
              top: square.position.y - 28,
              width: square.size.width,
              display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.6,
              zIndex: 12, pointerEvents: 'none',
            }}>
            {items.map((it, i) => (
              <Tooltip key={i} title={it.tip} placement="top">
                <Box
                  onClick={(e) => { e.stopPropagation(); it.onClick(); }}
                  sx={{
                    display: 'flex', alignItems: 'center', gap: 0.4,
                    px: 0.7, py: 0.3, borderRadius: '6px',
                    bgcolor: 'background.paper',
                    border: '1px solid', borderColor: it.accent,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                    cursor: 'pointer', pointerEvents: 'auto',
                    transition: 'box-shadow 120ms, transform 120ms',
                    '&:hover': { boxShadow: '0 3px 10px rgba(0,0,0,0.18)', transform: 'translateY(-1px)' },
                  }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', color: it.accent, lineHeight: 0 }}>{it.icon}</Box>
                  <Typography sx={{ fontSize: 10, fontWeight: 700, color: it.accent, lineHeight: 1, whiteSpace: 'nowrap' }}>
                    {it.label}
                  </Typography>
                </Box>
              </Tooltip>
            ))}
          </Box>
        );
      })()}


      {!simpleView && square.uploadedFile && (
        <>
          <Box sx={{ position: 'absolute', left: square.position.x + square.size.width / 2 - 1, top: square.position.y + square.size.height, width: 2, height: 80, bgcolor: sourceColor, opacity: 0.35, pointerEvents: 'none' }} />
          <Box sx={{ position: 'absolute', left: square.position.x + square.size.width / 2 - 4, top: square.position.y + square.size.height + 72, width: 8, height: 8, borderRadius: '50%', bgcolor: sourceColor, opacity: 0.35, pointerEvents: 'none' }} />
          {(() => {
            const pw = 312;
            const ph = 140;
            const file = square.uploadedFile!;
            const isArchive = file.origin === 'web-archive';
            const lowerType = (file.type || '').toLowerCase();
            const lowerName = (file.name || '').toLowerCase();
            const isAudio = lowerType.startsWith('audio/')
              || lowerName.endsWith('.mp3') || lowerName.endsWith('.wav');
            const isPdf = lowerType.includes('pdf') || lowerName.endsWith('.pdf');
            const isImage = lowerType.startsWith('image/')
              || lowerName.endsWith('.png') || lowerName.endsWith('.jpg')
              || lowerName.endsWith('.jpeg') || lowerName.endsWith('.gif')
              || lowerName.endsWith('.webp');
            const stLabel = (currentSourceType?.label || '').toLowerCase();
            const describeFile = () => {
              if (isArchive) return 'Web archive snapshot';
              if (isAudio) {
                if (stLabel === 'interview' || stLabel === 'podcast') return 'Audio recording';
                if (stLabel === 'speech' || stLabel === 'lecture') return 'Audio of the speech';
                return 'Audio recording';
              }
              if (isPdf) {
                if (stLabel === 'book') return 'Page from a book (PDF)';
                if (stLabel === 'article' || stLabel === 'paper' || stLabel === 'journal') return 'Article (PDF)';
                if (stLabel === 'report' || stLabel === 'whitepaper') return 'Report (PDF)';
                if (stLabel === 'magazine' || stLabel === 'newspaper') return 'Page from a ' + stLabel + ' (PDF)';
                return 'PDF document';
              }
              if (isImage) {
                if (stLabel === 'book') return 'Scan from a book';
                if (stLabel === 'magazine' || stLabel === 'newspaper') return 'Scan from a ' + stLabel;
                if (stLabel === 'photograph' || stLabel === 'image') return 'Photograph';
                return 'Image';
              }
              return 'Document';
            };
            const fileDescription = describeFile();
            const refMain = isAudio
              ? (typeof file.refTimestamp === 'number' && file.refTimestamp > 0
                  ? `At ${formatAudioTime(file.refTimestamp)}`
                  : 'No timestamp set')
              : file.citedPages && file.citedPages.length > 0
                ? `Page ${file.citedPages.join(', ')}`
                : square.reference.from || square.reference.to
                  ? `${square.reference.from || ''}${square.reference.from && square.reference.to ? ' → ' : ''}${square.reference.to || ''}`
                  : square.reference.notes
                    ? (square.reference.notes.length > 28 ? square.reference.notes.substring(0, 28) + '…' : square.reference.notes)
                    : 'No reference set';
            const TypeIcon = isArchive ? LanguageIcon
              : isAudio   ? AudiotrackIcon
              : isPdf     ? PictureAsPdfIcon
              : isImage   ? ImageIcon
              : InsertDriveFileIcon;
            return (
            <Box
              onClick={() => { setImagePreviewOpen(true); updateURL(boardId, chainId, square.sourceId, 'file'); }}
              sx={{
                position: 'absolute',
                left: square.position.x + square.size.width / 2 - pw / 2,
                top: square.position.y + square.size.height + 80,
                width: pw, height: ph,
                bgcolor: isDark ? 'rgba(20,20,30,0.97)' : 'rgba(255,255,255,0.97)',
                border: '1.5px solid', borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
                borderRadius: '8px', overflow: 'hidden',
                boxShadow: `0 2px 10px rgba(0,0,0,${isDark ? 0.45 : 0.12})`,
                display: 'flex', flexDirection: 'column',
                px: 1.4, py: 1.2, gap: 0.7, cursor: 'pointer',
                '&:hover': { borderColor: sourceColor, boxShadow: `0 0 0 2px ${sourceColor}25, 0 4px 14px rgba(0,0,0,${isDark ? 0.55 : 0.18})` },
              }}>
              <Typography sx={{ fontSize: 9, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.6, lineHeight: 1 }}>
                Reference file
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, minWidth: 0 }}>
                <TypeIcon sx={{ fontSize: 15, color: sourceColor, flexShrink: 0 }} />
                <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: sourceColor, textTransform: 'uppercase', letterSpacing: 0.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {fileDescription}
                </Typography>
              </Box>
              <Typography sx={{ fontSize: 11.5, fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.3 }}>
                {refMain}
              </Typography>
              <Box sx={{ flex: 1 }} />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4, color: sourceColor }}>
                {isAudio ? <PlayArrowIcon sx={{ fontSize: 13 }} /> : <OpenInNewIcon sx={{ fontSize: 12 }} />}
                <Typography sx={{ fontSize: 10.5, fontWeight: 600, textDecoration: 'underline' }}>
                  {isAudio ? 'Play audio' : 'Open file'}
                </Typography>
              </Box>
            </Box>
            );
          })()}
        </>
      )}

      {imageViewerDialogElement}
      <SourceContextMenu anchorPosition={contextMenu} onClose={() => setContextMenu(null)} onDelete={() => setDeleteConfirmOpen(true)} onEdit={() => { setPendingSourceType(square.sourceType); setInfoDialogOpen(true); }} onViewGraph={onViewGraph ? () => onViewGraph(square.sourceId, square.fields.field2 || square.fields.field1 || square.sourceType || 'source') : undefined} onEmbed={onEmbed && isPublic ? () => onEmbed(square.sourceId, square.fields.field2 || square.fields.field1 || square.sourceType || 'source') : undefined} isPublic={isPublic} readOnly={readOnly} />
      <Dialog disableScrollLock open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)} maxWidth="xs" PaperProps={{ sx: { borderRadius: '12px' } }}>
        <DialogTitle sx={{ pb: 0.5 }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><DeleteIcon color="error" /><Typography fontWeight={700} fontSize={16}>Delete Source?</Typography></Box></DialogTitle>
        <DialogContent>
          <Typography fontSize={12} color="text.secondary" lineHeight={1.6}>
            Are you sure you want to delete this source{displayInfo?.title ? ` "${displayInfo.title}"` : ''}? This will remove all its data, files, and references. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2 }}>
          <Button onClick={() => setDeleteConfirmOpen(false)} color="inherit">Cancel</Button>
          <Button variant="contained" color="error" onClick={() => { setDeleteConfirmOpen(false); onDelete(square.id); }} sx={{ fontWeight: 600 }}>Delete</Button>
        </DialogActions>
      </Dialog>
      {!readOnly && <SourceInfoDialog open={infoDialogOpen} onClose={() => { setInfoDialogOpen(false); setPendingSourceType(null); }} onSave={(f, file, api) => onSourceTypeChange(square.id, pendingSourceType || square.sourceType, f, file, api)} sourceType={pendingSourceType || square.sourceType} currentFields={square.fields} currentFile={square.uploadedFile} isDark={isDark} onChangeType={() => setSourceTypeDialogOpen(true)} />}
      {!readOnly && <ReferenceDialog open={refDialogOpen} onClose={() => setRefDialogOpen(false)} onSave={(r) => onReferenceChange(square.id, r)} reference={square.reference} sourceType={square.sourceType} sourceFields={square.fields} isWebArchive={square.uploadedFile?.origin === 'web-archive'} />}
      <Dialog disableScrollLock open={removeConfirmOpen} onClose={() => setRemoveConfirmOpen(false)} maxWidth="xs" PaperProps={{ sx: { borderRadius: '12px' } }}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
            <DeleteIcon sx={{ fontSize: 28, color: '#ef4444' }} />
          </Box>
          <Typography fontWeight={700} fontSize={15} sx={{ mb: 0.5 }}>Remove attached file?</Typography>
          <Typography fontSize={12} color="text.secondary" sx={{ mb: 2.5 }}>This will permanently delete the file from storage. This action cannot be undone.</Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button variant="outlined" onClick={() => setRemoveConfirmOpen(false)} sx={{ textTransform: 'none', flex: 1 }}>Cancel</Button>
            <Button variant="contained" color="error" onClick={async () => {
              if (square.uploadedFile && authToken) {
                try {
                  let token = authToken;
                  if (getTokenProp) { try { const t = await getTokenProp(); if (t) token = t; } catch {} }
                  await fetch(`${API_BASE}/delete-file`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({ boardId, sourceId: square.sourceId, urls: [square.uploadedFile.url, square.uploadedFile.previewUrl].filter(Boolean) })
                  });
                } catch {}
              }
              onSourceTypeChange(square.id, square.sourceType, square.fields, null);
              setRemoveConfirmOpen(false);
            }} sx={{ textTransform: 'none', flex: 1 }}>Delete File</Button>
          </Box>
        </Box>
      </Dialog>
      <Dialog disableScrollLock open={!!mapDialogCoords} onClose={() => { setMapDialogCoords(null); setMapBubbleOffset({ x: 16, y: 16 }); }} fullScreen PaperProps={{ sx: { bgcolor: 'background.default' } }}>
        {mapDialogCoords && (() => {
          const { lat, lon } = mapDialogCoords;
          const location = square.fields.field2 || '';
          const eventName = square.fields.field1 || displayInfo?.title || '';
          const eventType = square.sourceType === 'event' ? (square.fields.field7 || '') : '';
          const dateFrom = square.sourceType === 'event' ? (square.fields.field5 || '') : '';
          const bx = mapBubbleOffset.x;
          const by = mapBubbleOffset.y;
          return (
            <>
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Box>
                  <Typography fontWeight={700} fontSize={17}>📍 {eventName || location || 'Location'}</Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {lat.toFixed(6)}, {lon.toFixed(6)}{location ? ` · ${location}` : ''}{eventType ? ` · ${eventType}` : ''}{dateFrom ? ` · ${dateFrom}` : ''}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Tooltip title="Recenter on coordinates">
                    <IconButton size="small" onClick={() => { if (mapRecenterRef.current) mapRecenterRef.current(); }}>
                      <RestartAltIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <IconButton onClick={() => { setMapDialogCoords(null); setMapBubbleOffset({ x: 16, y: 16 }); }} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
                </Box>
              </DialogTitle>
              <DialogContent
                sx={{ p: 0, position: 'relative', overflow: 'hidden', cursor: mapBubbleDragging ? 'grabbing' : 'default' }}
                onMouseMove={(e) => { if (mapBubbleDragging) { setMapBubbleOffset(prev => ({ x: prev.x + e.movementX, y: prev.y + e.movementY })); } }}
                onMouseUp={() => setMapBubbleDragging(false)}
                onMouseLeave={() => setMapBubbleDragging(false)}
              >
                <LeafletMap lat={lat} lon={lon} recenterRef={mapRecenterRef} />

                <Box
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setMapBubbleDragging(true); }}
                  sx={{
                    position: 'absolute', top: by, right: bx,
                    bgcolor: 'background.paper', borderRadius: '12px', p: 2,
                    boxShadow: '0 4px 24px rgba(0,0,0,0.25)', border: '2px solid', borderColor: '#ef4444',
                    maxWidth: 280, minWidth: 200, zIndex: 5, cursor: 'grab', userSelect: 'none',
                    '&:active': { cursor: 'grabbing' },
                  }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.8 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: '50%', bgcolor: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <Typography sx={{ fontSize: 14 }}>📍</Typography>
                    </Box>
                    <Typography fontWeight={700} fontSize={14} sx={{ lineHeight: 1.2 }}>{eventName || 'Untitled'}</Typography>
                  </Box>
                  {location && <Typography fontSize={12} color="text.secondary" sx={{ mb: 0.2 }}>{location}</Typography>}
                  {eventType && <Typography fontSize={11} color="text.secondary">Type: {eventType}</Typography>}
                  {dateFrom && <Typography fontSize={11} color="text.secondary">Date: {dateFrom}</Typography>}
                  {square.sourceType === 'event' && square.fields.field9 && <Typography fontSize={11} color="text.secondary">Impact: {square.fields.field9}</Typography>}
                  {square.sourceType === 'event' && square.fields.field8 && <Typography fontSize={11} color="text.secondary">Severity: {square.fields.field8}</Typography>}
                  <Divider sx={{ my: 0.8 }} />
                  <Typography fontSize={10} color="text.disabled" sx={{ fontFamily: 'monospace' }}>{lat.toFixed(6)}, {lon.toFixed(6)}</Typography>
                </Box>
              </DialogContent>
            </>
          );
        })()}
      </Dialog>
      {replayViewerOpen && square.uploadedFile?.origin === 'web-archive' && (
        <Dialog disableScrollLock open={true} onClose={() => setReplayViewerOpen(false)} maxWidth={false} fullScreen PaperProps={{ sx: { bgcolor: '#1a1a2e', display: 'flex', flexDirection: 'column' } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 0.8, bgcolor: '#1e1e2e', borderBottom: '1px solid rgba(255,255,255,0.08)', gap: 1.5, flexShrink: 0 }}>
            <LanguageIcon sx={{ fontSize: 16, color: '#3b82f6', flexShrink: 0 }} />
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'rgba(255,255,255,0.06)', borderRadius: '6px', px: 1.5, py: 0.5, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
              <LockPersonIcon sx={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', flexShrink: 0 }} />
              <Typography sx={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                {square.uploadedFile.originalUrl || 'Archived page'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
              {square.uploadedFile.refAreas && square.uploadedFile.refAreas.length > 0 && (
                <Button size="small" startIcon={<CropFreeIcon sx={{ fontSize: 12 }} />}
                  onClick={() => window.dispatchEvent(new CustomEvent('archive-goto-ref'))}
                  sx={{ fontSize: 10, color: '#3b82f6', borderColor: 'rgba(59,130,246,0.3)', textTransform: 'none', '&:hover': { bgcolor: 'rgba(59,130,246,0.1)' } }} variant="outlined">
                  Go to Reference
                </Button>
              )}
              <Chip label={`Archived ${square.uploadedFile.archivedAt ? formatTimestamp(square.uploadedFile.archivedAt, appSettings || DEFAULT_SETTINGS) : ''}`} size="small" sx={{ fontSize: 9, height: 20, bgcolor: 'rgba(59,130,246,0.15)', color: '#3b82f6', fontFamily: 'monospace' }} />
              {square.uploadedFile.originalUrl && (
                <Tooltip title="Open original URL"><IconButton size="small" onClick={() => window.open(safeHref(square.uploadedFile!.originalUrl) || 'about:blank', '_blank', 'noopener,noreferrer')} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#E3E3DF' } }}><OpenInNewIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
              )}
              {square.uploadedFile.url && (
                <Tooltip title="Download WARC"><IconButton size="small" onClick={() => window.open(safeHref(square.uploadedFile!.url) || 'about:blank', '_blank', 'noopener,noreferrer')} sx={{ color: 'rgba(255,255,255,0.4)', '&:hover': { color: '#E3E3DF' } }}><DownloadIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
              )}
              <IconButton onClick={() => setReplayViewerOpen(false)} sx={{ color: '#E3E3DF' }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
            </Box>
          </Box>
          <ArchiveReplayScene
            htmlUrl={square.uploadedFile.htmlUrl}
            warcUrl={square.uploadedFile.url}
            refArea={square.uploadedFile.refAreas && square.uploadedFile.refAreas[0]}
          />
        </Dialog>
      )}
      <Dialog disableScrollLock open={archiveDialogOpen} onClose={() => { if (archiveStatus !== 'archiving') setArchiveDialogOpen(false); }} maxWidth={false} fullScreen
        PaperProps={{ sx: { bgcolor: archiveStep >= 2 ? '#525659' : 'background.default', display: 'flex', flexDirection: 'column', overflow: 'hidden' } }}>
        <Box sx={{ px: 3, pt: 2, pb: 0, flexShrink: 0, bgcolor: archiveStep >= 2 ? 'rgba(0,0,0,0.3)' : 'background.paper', borderBottom: '1px solid', borderColor: archiveStep >= 2 ? 'rgba(255,255,255,0.08)' : 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
            <Box>
              <Typography fontWeight={700} fontSize={16} sx={{ color: archiveStep >= 2 ? '#E3E3DF' : 'text.primary' }}>Web Archive</Typography>
              <Typography fontSize={11} sx={{ color: archiveStep >= 2 ? 'rgba(255,255,255,0.5)' : 'text.secondary' }}>{archiveStepSubtitles[archiveStep - 1]}</Typography>
            </Box>
            {archiveStatus !== 'archiving' && <IconButton onClick={() => setArchiveDialogOpen(false)} size="small" sx={{ color: archiveStep >= 2 ? '#E3E3DF' : 'text.primary' }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>}
          </Box>
          <Box sx={{ display: 'flex', gap: 0, mb: -0.5 }}>
            {archiveStepLabels.map((label, i) => (
              <Box key={i} sx={{ flex: 1, textAlign: 'center', pb: 1, borderBottom: '3px solid', borderColor: i + 1 <= archiveStep ? sourceColor : 'transparent', opacity: i + 1 <= archiveStep ? 1 : 0.4 }}>
                <Typography fontSize={10} fontWeight={i + 1 === archiveStep ? 700 : 400} sx={{ color: archiveStep >= 2 ? '#E3E3DF' : 'text.primary' }}>{i + 1}. {label}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {archiveStep === 1 && (
          <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center', pt: 4, px: 3 }}>
            <Box sx={{ maxWidth: 500, width: '100%' }}>
              {archiveStatus === 'idle' && (() => {
                const urlField = currentSourceType?.fields.find(f => f.type === 'url');
                const urlIdx = urlField ? currentSourceType!.fields.indexOf(urlField) : -1;
                const prefillUrl = urlIdx >= 0 ? (square.fields as any)[`field${urlIdx + 1}`] : '';
                if (!archiveUrlInput && prefillUrl) setTimeout(() => setArchiveUrlInput(prefillUrl), 0);
                return (
                  <Box>
                    <TextField label="URL to archive" value={archiveUrlInput} onChange={(e) => setArchiveUrlInput(e.target.value)} size="small" fullWidth sx={{ mb: 2 }} placeholder="https://example.com/article" helperText={prefillUrl && archiveUrlInput !== prefillUrl ? 'Modified from source URL field' : 'Full URL of the page to archive'} />
                    <Button size="small" onClick={() => setArchiveShowAdvanced(!archiveShowAdvanced)} sx={{ textTransform: 'none', fontSize: 11, color: 'text.secondary', mb: archiveShowAdvanced ? 1 : 2 }}>
                      {archiveShowAdvanced ? '▾ Hide options' : '▸ Archive options'}
                    </Button>
                    {archiveShowAdvanced && (
                      <Box sx={{ mb: 2, pl: 1, borderLeft: '2px solid', borderColor: 'divider', ml: 0.5 }}>
                        <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Auto-scroll: {archiveScrollTime}s</Typography>
                        <Slider value={archiveScrollTime} onChange={(_, v) => setArchiveScrollTime(v as number)} min={0} max={90} step={5} marks={[{value:0,label:'0s'},{value:10,label:'10s'},{value:30,label:'30s'},{value:60,label:'60s'},{value:90,label:'90s'}]} valueLabelDisplay="auto" valueLabelFormat={(v) => `${v}s`} sx={{ mb: 2, color: sourceColor, '& .MuiSlider-markLabel': { fontSize: 9 } }} />
                        <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Browser engine</Typography>
                        <ToggleButtonGroup value={archiveBrowser} exclusive onChange={(_, v) => { if (v) setArchiveBrowser(v); }} size="small" sx={{ mb: 2, '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 11, px: 2 } }}>
                          <ToggleButton value="auto">Auto</ToggleButton>
                          <ToggleButton value="puppeteer">Puppeteer</ToggleButton>
                          <ToggleButton value="playwright">Playwright</ToggleButton>
                        </ToggleButtonGroup>
                        <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Viewport width</Typography>
                        <ToggleButtonGroup value={archiveWidth} exclusive onChange={(_, v) => { if (v) setArchiveWidth(v); }} size="small" sx={{ mb: 1, '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 11, px: 2 } }}>
                          <ToggleButton value={1024}>1024px</ToggleButton>
                          <ToggleButton value={1280}>1280px</ToggleButton>
                          <ToggleButton value={1920}>1920px</ToggleButton>
                        </ToggleButtonGroup>
                      </Box>
                    )}
                    <Button variant="contained" fullWidth startIcon={<LanguageIcon sx={{ fontSize: 16 }} />} disabled={!archiveUrlInput.startsWith('http')} onClick={async () => {
                      setArchiveStatus('archiving');
                      setArchiveProgress('Connecting to URL...');
                      setArchiveCountdown(archiveScrollTime);
                      setArchiveIframeLoaded(false);
                      setArchiveIframeFailed(false);
                      setTimeout(() => {
                        setArchiveIframeLoaded(prev => {
                          if (!prev) setArchiveIframeFailed(true);
                          return prev;
                        });
                      }, 3000);
                      let countdownInterval: ReturnType<typeof setInterval> | null = null;
                      if (archiveScrollTime > 0) {
                        countdownInterval = setInterval(() => {
                          setArchiveCountdown(prev => { if (prev <= 1) { if (countdownInterval) clearInterval(countdownInterval); setArchiveProgress('Capturing screenshot...'); return 0; } return prev - 1; });
                        }, 1000);
                      }
                      setTimeout(() => setArchiveProgress(archiveScrollTime > 0 ? 'Auto-scrolling page...' : 'Capturing page...'), 2000);
                      try {
                        const token = getTokenProp ? await getTokenProp() : authToken;
                        const resp = await fetch(`${API_BASE}/archive-url`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ url: archiveUrlInput, boardId, sourceId: square.sourceId, scrollTime: archiveScrollTime, browser: archiveBrowser, viewportWidth: archiveWidth }) });
                        if (countdownInterval) clearInterval(countdownInterval);
                        setArchiveProgress('Processing result...');
                        const text = await resp.text();
                        let data: any;
                        try { data = JSON.parse(text); } catch { throw new Error(resp.ok ? 'Invalid response from server' : `Server error ${resp.status}: ${text.substring(0, 100)}`); }
                        if (data.ok) {
                          setArchiveResult(data); setArchiveStatus('done');
                          onSourceTypeChange(square.id, square.sourceType, withArchivedUrlField(square.sourceType, square.fields, data.htmlUrl || data.warcUrl), { name: `${data.pageTitle || 'archive'}.warc`, size: data.warcSize, type: 'application/warc', uploadedAt: data.archivedAt, url: data.warcUrl, previewUrl: data.previewUrl || data.screenshotUrl || undefined, origin: 'web-archive', htmlUrl: data.htmlUrl, originalUrl: data.originalUrl, archivedAt: data.archivedAt });
                          if (data.previewUrl || data.screenshotUrl) setArchiveStep(2); else setArchiveStep(3);
                        } else { setArchiveError(data.details || data.error || 'Error'); setArchiveStatus('error'); }
                      } catch (err: any) { if (countdownInterval) clearInterval(countdownInterval); setArchiveError(err.message); setArchiveStatus('error'); }
                    }} sx={{ py: 1.5, fontSize: 14, fontWeight: 700, bgcolor: sourceColor, textTransform: 'none', mb: 2 }}>Start Archive</Button>
                  </Box>
                );
              })()}
              {archiveStatus === 'archiving' && (
                <Box sx={{ textAlign: 'center', pt: 2 }}>
                  <Box sx={{ width: 420, height: 260, mx: 'auto', mb: 2.5, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: '#fff', overflow: 'hidden', position: 'relative', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                    <Box sx={{ height: 28, bgcolor: '#f0f0f0', borderBottom: '1px solid #ddd', display: 'flex', alignItems: 'center', px: 1.2, gap: 0.5 }}>
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ff5f57' }} />
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#febc2e' }} />
                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#28c840' }} />
                      <Box sx={{ flex: 1, mx: 1, bgcolor: '#fff', borderRadius: '4px', border: '1px solid #ddd', px: 1, py: 0.2, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                        <LockPersonIcon sx={{ fontSize: 9, color: '#999', mr: 0.5 }} />
                        <Typography sx={{ fontSize: 9, color: '#666', fontFamily: 'monospace', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{archiveUrlInput.replace(/^https?:\/\//, '')}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ position: 'absolute', inset: '28px 0 0 0', overflow: 'hidden' }}>
                      {!archiveIframeFailed && (
                        <iframe
                          src={safeHref(archiveUrlInput) || 'about:blank'}
                          title="Live preview"
                          sandbox="allow-same-origin allow-scripts"
                          onLoad={() => setArchiveIframeLoaded(true)}
                          style={{
                            width: '100%', height: '100%', border: 'none',
                            opacity: archiveIframeLoaded ? 1 : 0,
                            transition: 'opacity 0.2s',
                            pointerEvents: 'none',
                          }}
                        />
                      )}
                      {(!archiveIframeLoaded || archiveIframeFailed) && (
                        <Box sx={{ position: 'absolute', inset: 0, p: 2, bgcolor: '#fff' }}>
                          <Box sx={{ width: '60%', height: 10, bgcolor: '#e0e0e0', borderRadius: 1, mb: 1.2, animation: 'pulse 1.5s ease-in-out infinite', '@keyframes pulse': { '0%,100%': { opacity: 0.4 }, '50%': { opacity: 1 } } }} />
                          <Box sx={{ width: '85%', height: 6, bgcolor: '#eee', borderRadius: 1, mb: 0.8, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.2s' }} />
                          <Box sx={{ width: '75%', height: 6, bgcolor: '#eee', borderRadius: 1, mb: 0.8, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.4s' }} />
                          <Box sx={{ width: '90%', height: 6, bgcolor: '#eee', borderRadius: 1, mb: 1.5, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.6s' }} />
                          <Box sx={{ display: 'flex', gap: 1.5 }}>
                            <Box sx={{ width: 90, height: 60, bgcolor: '#f0f0f0', borderRadius: 1, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.3s' }} />
                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ width: '70%', height: 6, bgcolor: '#eee', borderRadius: 1, mb: 0.6, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.5s' }} />
                              <Box sx={{ width: '50%', height: 6, bgcolor: '#eee', borderRadius: 1, animation: 'pulse 1.5s ease-in-out infinite', animationDelay: '0.7s' }} />
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ position: 'absolute', left: 0, right: 0, height: 3, bgcolor: sourceColor, opacity: 0.8, animation: 'scanbar 2.5s ease-in-out infinite', '@keyframes scanbar': { '0%': { top: 28 }, '50%': { top: 'calc(100% - 3px)' }, '100%': { top: 28 } } }} />
                    <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, bgcolor: 'rgba(0,0,0,0.1)' }}>
                      <Box sx={{ height: '100%', bgcolor: sourceColor, transition: 'width 1s linear', width: archiveScrollTime > 0 ? `${Math.max(5, ((archiveScrollTime - archiveCountdown) / archiveScrollTime) * 100)}%` : '100%' }} />
                    </Box>
                  </Box>
                  <Typography fontWeight={700} fontSize={15} sx={{ mb: 0.3 }}>{archiveProgress}</Typography>
                  {archiveCountdown > 0 && <Typography fontSize={28} fontWeight={300} color="text.secondary" sx={{ fontFamily: 'monospace', mb: 0.3 }}>{archiveCountdown}s</Typography>}
                  <Typography fontSize={11} color="text.disabled">{archiveUrlInput.replace(/^https?:\/\//, '').split('/')[0]} · {archiveBrowser === 'auto' ? 'Auto' : archiveBrowser} · {archiveScrollTime}s scroll</Typography>
                </Box>
              )}
              {archiveStatus === 'error' && (
                <Box sx={{ pt: 4 }}>
                  <Typography fontWeight={700} fontSize={16} color="error" sx={{ mb: 1 }}>Archive failed</Typography>
                  <Typography fontSize={13} color="text.secondary" sx={{ mb: 2 }}>{archiveError}</Typography>
                  <Button variant="outlined" onClick={() => { setArchiveStatus('idle'); setArchiveProgress(''); }}>Retry</Button>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {archiveStep === 2 && archiveResult && (archiveResult.screenshotUrl || archiveResult.previewUrl) && (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1, px: 2, bgcolor: 'rgba(0,0,0,0.2)', flexShrink: 0 }}>
              <Button size="small" variant={archiveRefToolActive ? 'contained' : 'outlined'}
                onClick={() => setArchiveRefToolActive(!archiveRefToolActive)}
                startIcon={<CropFreeIcon sx={{ fontSize: 14 }} />}
                sx={{ textTransform: 'none', fontSize: 11, bgcolor: archiveRefToolActive ? '#3b82f6' : 'transparent', color: archiveRefToolActive ? '#fff' : 'rgba(255,255,255,0.6)', borderColor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: archiveRefToolActive ? '#2563eb' : 'rgba(255,255,255,0.08)' } }}>
                {archiveRefToolActive ? 'Drawing' : 'Draw'}
              </Button>
              {archiveRefArea && <Button size="small" onClick={() => setArchiveRefArea(null)} sx={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', textTransform: 'none' }}>Clear</Button>}
              <ViewerZoomControls zoom={viewerZoom} onZoomChange={setViewerZoom} variant="dark" sx={{ ml: 1 }} />
              <Box sx={{ flex: 1 }} />
              <Button size="small" onClick={() => setArchiveStep(3)} sx={{ color: 'rgba(255,255,255,0.5)', textTransform: 'none' }}>Skip</Button>
              <Button size="small" variant="contained" disabled={!archiveRefArea} onClick={() => setArchiveStep(3)} sx={{ bgcolor: '#3b82f6', textTransform: 'none', fontWeight: 700 }}>Next →</Button>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', bgcolor: '#525659', display: 'flex', justifyContent: 'center', pt: 2, pb: 4,
              '&::-webkit-scrollbar': { width: 10, height: 10 },
              '&::-webkit-scrollbar-track': { bgcolor: 'rgba(0,0,0,0.2)' },
              '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 5, '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } } }}>
              <Box sx={{ display: 'flex', flexShrink: 0, alignItems: 'flex-start' }}>
                <PixelRuler height={archiveImgHeight} zoom={viewerZoom} side="left" />
                <Box id="archive-draw-container" sx={{ position: 'relative', flexShrink: 0, lineHeight: 0, fontSize: 0 }}>
                  <img src={archiveResult.screenshotUrl || archiveResult.previewUrl} alt="Screenshot" draggable={false}
                    onLoad={(e) => setArchiveImgHeight((e.target as HTMLImageElement).clientHeight)}
                    style={{ display: 'block', width: archiveWidth * viewerZoom, userSelect: 'none', boxShadow: '0 4px 24px rgba(0,0,0,0.4)' }} />
                  <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 2 }}>
                    {archiveRefArea && (
                      <>
                        <defs><mask id="archive-ref-mask"><rect x="0" y="0" width="100%" height="100%" fill="white" /><rect x={`${archiveRefArea.x}%`} y={`${archiveRefArea.y}%`} width={`${archiveRefArea.w}%`} height={`${archiveRefArea.h}%`} fill="black" /></mask></defs>
                        <rect x="0" y="0" width="100%" height="100%" fill="rgba(0,0,0,0.4)" mask="url(#archive-ref-mask)" />
                        <rect x={`${archiveRefArea.x}%`} y={`${archiveRefArea.y}%`} width={`${archiveRefArea.w}%`} height={`${archiveRefArea.h}%`} fill="none" stroke="#3b82f6" strokeWidth="3" rx="3" />
                        <rect x={`${archiveRefArea.x}%`} y={`${Math.max(0, archiveRefArea.y - refLabelPct(archiveImgHeight).off)}%`} width={`${refLabelPct(archiveImgHeight).w}%`} height={`${refLabelPct(archiveImgHeight).h}%`} rx="3" fill="#3b82f6" />
                        <text x={`${archiveRefArea.x + 0.4}%`} y={`${Math.max(0.5, archiveRefArea.y - refLabelPct(archiveImgHeight).textOff)}%`} fill="#E3E3DF" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif">Referenced</text>
                      </>
                    )}
                    {archiveRefDrawing && archiveRefStart && archiveRefCurrent && (() => {
                      const x = Math.min(archiveRefStart.x, archiveRefCurrent.x);
                      const y = Math.min(archiveRefStart.y, archiveRefCurrent.y);
                      const w = Math.abs(archiveRefCurrent.x - archiveRefStart.x);
                      const h = Math.abs(archiveRefCurrent.y - archiveRefStart.y);
                      return <rect x={`${x}%`} y={`${y}%`} width={`${w}%`} height={`${h}%`} fill="rgba(59,130,246,0.15)" stroke="#3b82f6" strokeWidth="2" strokeDasharray="6,3" rx="3" />;
                    })()}
                  </svg>
                  {archiveRefToolActive && <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 3, cursor: 'crosshair' }}
                    onMouseDown={(e) => {
                      e.preventDefault(); e.stopPropagation();
                      const container = document.getElementById('archive-draw-container');
                      if (!container) return;
                      const rect = container.getBoundingClientRect();
                      if (rect.width === 0 || rect.height === 0) return;
                      const sx = ((e.clientX - rect.left) / rect.width) * 100;
                      const sy = ((e.clientY - rect.top) / rect.height) * 100;
                      let lastX = sx, lastY = sy;
                      setArchiveRefStart({ x: sx, y: sy }); setArchiveRefCurrent({ x: sx, y: sy }); setArchiveRefDrawing(true);
                      const onMove = (ev: MouseEvent) => {
                        const r = container.getBoundingClientRect();
                        if (r.width === 0) return;
                        lastX = Math.max(0, Math.min(((ev.clientX - r.left) / r.width) * 100, 100));
                        lastY = Math.max(0, Math.min(((ev.clientY - r.top) / r.height) * 100, 100));
                        setArchiveRefCurrent({ x: lastX, y: lastY });
                      };
                      const onUp = () => {
                        document.removeEventListener('mousemove', onMove);
                        document.removeEventListener('mouseup', onUp);
                        const rw = Math.abs(lastX - sx); const rh = Math.abs(lastY - sy);
                        if (rw > 0.15 && rh > 0.15) {
                          setArchiveRefArea({ x: Math.min(sx, lastX), y: Math.min(sy, lastY), w: rw, h: rh });
                        }
                        setArchiveRefDrawing(false); setArchiveRefStart(null); setArchiveRefCurrent(null);
                      };
                      document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
                    }} />}
                </Box>
                <PixelRuler height={archiveImgHeight} zoom={viewerZoom} side="right" />
              </Box>
            </Box>
          </Box>
        )}

        {archiveStep === 3 && archiveResult && (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ maxWidth: 500, width: '100%', textAlign: 'center', px: 3 }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: '#10b981', mb: 2 }} />
              <Typography fontWeight={700} fontSize={18} color="#10b981" sx={{ mb: 0.5 }}>{archiveResult.pageTitle || 'Archive complete'}</Typography>
              <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap', justifyContent: 'center', mb: 3 }}>
                <Chip label={formatTimestamp(archiveResult.archivedAt, appSettings || DEFAULT_SETTINGS)} size="small" sx={{ fontSize: 10, height: 22 }} />
                <Chip label={`${archiveResult.method}`} size="small" sx={{ fontSize: 10, height: 22 }} />
                <Chip label={formatFileSize(archiveResult.warcSize)} size="small" sx={{ fontSize: 10, height: 22 }} />
                {archiveRefArea && <Chip label="Reference area set" size="small" sx={{ fontSize: 10, height: 22, bgcolor: 'rgba(59,130,246,0.1)', color: '#3b82f6' }} />}
              </Box>
              <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
                <Button size="small" variant="outlined" onClick={() => setArchiveStep(2)} sx={{ textTransform: 'none', fontSize: 11 }}>← Edit Reference</Button>
                <Button variant="contained" size="large" onClick={() => {
                  if (square.uploadedFile) {
                    const updates: any = { ...square.uploadedFile };
                    if (archiveRefArea) updates.refAreas = [archiveRefArea];
                    if (archiveHighlights.length > 0) updates.highlights = archiveHighlights.map(h => ({ type: h.type, x1: h.x1, y1: h.y1, x2: h.x2, y2: h.y2, color: h.color, thickness: h.thickness }));
                    if (archiveRefArea) {
                      const from = `${archiveRefArea.x.toFixed(1)}, ${archiveRefArea.y.toFixed(1)}`;
                      const to = `${(archiveRefArea.x + archiveRefArea.w).toFixed(1)}, ${(archiveRefArea.y + archiveRefArea.h).toFixed(1)}`;
                      onReferenceChange(square.id, { ...square.reference, from, to, pointerType: 'pixel' });
                    }
                    onSourceTypeChange(square.id, square.sourceType, square.fields, updates);
                  }
                  setArchiveDialogOpen(false);
                }} sx={{ bgcolor: '#10b981', textTransform: 'none', fontWeight: 700, px: 4, fontSize: 14 }}>Save & Close</Button>
              </Box>
            </Box>
          </Box>
        )}
      </Dialog>
      {trustDialogElement}
    </>
  );
};

// ▓▓▓▓▓ REF-POINT BOX & CANVAS CONNECTIONS ▓▓▓▓▓
const REF_BOX_WIDTH = 180;
const REF_BOX_HEIGHT = 50;

const RefPointBox: React.FC<{
  refPoint: RefPoint; x: number;
  onAddSource: () => void; onEdit?: () => void;
  isSelected: boolean; onSelect: () => void; sourceCount: number;
  isDark: boolean; isPublic: boolean; mainSourceType: string | null;
  pointerType?: string;
}> = ({ refPoint, x, isSelected, onSelect, onEdit, isDark, mainSourceType, pointerType, isPublic }) => {
  const sourceTypeData = mainSourceType ? ALL_SOURCE_TYPES.find(s => s.type === mainSourceType) : null;
  const activeKey = pointerType || (DEFAULT_POINTER_TYPES[mainSourceType || ''] || DEFAULT_POINTER_TYPES.default)[0];
  const activePointer = REF_POINTER_TYPES.find(p => p.key === activeKey);
  const headerLabel = activePointer?.label || sourceTypeData?.refLabel || 'Reference';
  const bodyLabel = formatRefPointLabel(activeKey, refPoint.fromValue, refPoint.toValue, refPoint.value) || '—';
  const hasAnyAnchor = !!(refPoint.fromSectionStartsWith || refPoint.toSectionEndsWith);
  const bubbleHeight = REF_BOX_HEIGHT + (hasAnyAnchor ? 18 : 0);
  return (
    <Box onClick={onSelect}
      onDoubleClick={() => { if (!isPublic && onEdit) onEdit(); }}
      sx={{ position: 'absolute', left: x, top: refPoint.y - bubbleHeight / 2, width: REF_BOX_WIDTH, height: bubbleHeight, bgcolor: isDark ? 'rgba(26,26,36,0.95)' : 'rgba(255,255,255,0.95)', border: isSelected ? '2px solid #475569' : '1px solid', borderColor: isSelected ? '#475569' : 'divider', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', p: 1.5, gap: 1, userSelect: 'none', '&:hover': { borderColor: '#475569', '& .rp-edit': { opacity: 1 } } }}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#64748b', flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>{headerLabel}</Typography>
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{bodyLabel}</Typography>
        {(refPoint.fromSectionStartsWith || refPoint.toSectionEndsWith) && (
          <Typography sx={{ fontSize: '0.62rem', color: 'text.disabled', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.2, lineHeight: 1.25 }}>
            {refPoint.fromSectionStartsWith && refPoint.fromValue && (
              <Box component="span" sx={{ fontStyle: 'normal', fontWeight: 600, color: '#94a3b8', mr: 0.5 }}>{`p.${refPoint.fromValue}`}</Box>
            )}
            {refPoint.fromSectionStartsWith && `«${refPoint.fromSectionStartsWith}»`}
            {refPoint.fromSectionStartsWith && refPoint.toSectionEndsWith && ' … '}
            {!refPoint.fromSectionStartsWith && refPoint.toSectionEndsWith && '… '}
            {refPoint.toSectionEndsWith && `«${refPoint.toSectionEndsWith}»`}
            {refPoint.toSectionEndsWith && refPoint.toValue && (
              <Box component="span" sx={{ fontStyle: 'normal', fontWeight: 600, color: '#94a3b8', ml: 0.5 }}>{`p.${refPoint.toValue}`}</Box>
            )}
          </Typography>
        )}
      </Box>
      {!isPublic && onEdit && (
        <IconButton size="small" className="rp-edit" onClick={(e) => { e.stopPropagation(); onEdit(); }}
          sx={{ width: 22, height: 22, opacity: 0, transition: 'opacity 120ms', '&:hover': { color: '#475569' } }}>
          <EditIcon sx={{ fontSize: 13 }} />
        </IconButton>
      )}
    </Box>
  );
};

const REF_POINTER_Y_OFFSET = 110;
const REF_BOX_INSET = 12;

const SingleConnections: React.FC<{ squares: SquareData[]; isDark: boolean; boardId: string; chainId?: string | null; setSnackbar: (s: any) => void; simpleView?: boolean; selectedSourceId?: string | null; onOpenFile?: (sourceId: string) => void }> = ({ squares, isDark, boardId, chainId, setSnackbar, simpleView, selectedSourceId, onOpenFile }) => {
  const [chainTrustOpen, setChainTrustOpen] = useState(false);

  if (squares.length < 1) return null;
  
  const sw = simpleView ? 220 : 0;
  const sh = simpleView ? 105 : 0;
  const getExitPoint = (sq: SquareData) => ({
    x: sq.position.x + (simpleView ? sw : sq.size.width),
    y: sq.position.y + (simpleView ? sh : sq.size.height) / 2,
  });
  const getEntryPoint = (sq: SquareData) => ({
    x: sq.position.x,
    y: sq.position.y + (simpleView ? sh : sq.size.height) / 2,
  });

  const isChain = squares.length > 1;
  const nonMainForBracket = squares.filter(s => !s.isMainSource);
  const bracketSq = nonMainForBracket.length > 0
    ? nonMainForBracket.reduce((a, b) => a.order > b.order ? a : b)
    : squares[0];
  const boxH = simpleView ? sh : bracketSq.size.height;
  const chainLineX = bracketSq.position.x - 40;
  const chainTop = bracketSq.position.y + (simpleView ? 8 : 20);
  const chainHeight = boxH - (simpleView ? 16 : 40);
  const chainBottom = chainTop + chainHeight;

  const assessedSources = squares.filter(sq => sq.trustAssessed);
  const chainTrustAvg = assessedSources.length > 0
    ? assessedSources.reduce((sum, sq) => {
        const vals = Object.values(sq.trustRates).filter(v => v > 0);
        return sum + (vals.length > 0 ? vals.reduce((a, b) => a + b, 0) / vals.length : 0);
      }, 0) / assessedSources.length
    : 0;

  const trustChartData = squares.map((sq, i) => {
    const vals = Object.values(sq.trustRates).filter(v => v > 0);
    const avg = vals.length > 0 ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
    const label = getOrderLabel(sq.order, i === squares.length - 1, false, sq.isMainSource);
    const title = sq.fields.field2 || sq.fields.field1 || `Source ${i + 1}`;
    return { index: i, label, title, avg: Math.round(avg * 10) / 10, assessed: sq.trustAssessed, rates: sq.trustRates };
  });
  
  const assessedData = trustChartData.filter(d => d.assessed);
  const trend = assessedData.length >= 2
    ? assessedData[assessedData.length - 1].avg - assessedData[0].avg
    : 0;
  
  return (
    <>
      <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', overflow: 'visible' }}>
        <defs>
          {[...squares].map(s => getSourceColor(s.sourceType)).filter((c, i, a) => a.indexOf(c) === i).map(color => (
            <marker key={color} id={`arrowhead-${color.replace('#','')}`} markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
              <path d="M0,0 L0,6 L8,3 z" fill={color} opacity={0.8} />
            </marker>
          ))}
          <marker id="arrowhead-file" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
            <path d="M0,0 L0,6 L8,3 z" fill="#FFD465" opacity={0.9} />
          </marker>
        </defs>
        {[...squares].filter(s => !s.isMainSource).sort((a, b) => b.order - a.order).map((sq, i, sorted) => {
          if (i === sorted.length - 1) return null;
          const next = sorted[i + 1];
          const color = getSourceColor(next.sourceType);
          const colorId = color.replace('#','');
          const sqHasFile = !!(sq.uploadedFile?.previewUrl || sq.uploadedFile?.refCropUrl || sq.uploadedFile?.url);
          const nextHasFile = !!(next.uploadedFile?.previewUrl || next.uploadedFile?.refCropUrl || next.uploadedFile?.url);
          const sqW = simpleView ? sw : sq.size.width;
          const sqH = simpleView ? sh : sq.size.height;
          const nextW = simpleView ? sw : next.size.width;
          const nextH = simpleView ? sh : next.size.height;
          const miniW = 120; const miniH = 24; const miniGap = 30;
          const fileBoxW = simpleView ? miniW : 312;
          const fileBoxH = simpleView ? miniH : 219;
          const fileBoxGap = simpleView ? miniGap : 80;

          const sqFileRight = sq.position.x + sqW / 2 + fileBoxW / 2;
          const sqFileMidY = sq.position.y + sqH + fileBoxGap + fileBoxH / 2;
          const nextFileLeft = next.position.x + nextW / 2 - fileBoxW / 2;
          const nextFileMidY = next.position.y + nextH + fileBoxGap + fileBoxH / 2;

          if (sqHasFile && !nextHasFile) {
            const p1 = { x: sqFileRight, y: sqFileMidY };
            const p2 = getEntryPoint(next);
            const midX = (p1.x + p2.x) / 2;
            return (
              <g key={`${sq.id}-${next.id}`}>
                <path d={`M ${p1.x} ${p1.y} C ${midX} ${p1.y}, ${midX} ${p2.y}, ${p2.x} ${p2.y}`}
                  stroke="#FFD465" strokeWidth="2" fill="none" strokeDasharray="6 4" opacity={0.7}
                  markerEnd={`url(#arrowhead-${colorId})`} />
                <circle cx={p1.x} cy={p1.y} r="3.5" fill="#FFD465" />
                <circle cx={p2.x} cy={p2.y} r="4" fill={color} />
              </g>
            );
          } else if (!sqHasFile && nextHasFile) {
            const p1 = getExitPoint(sq);
            const p2 = { x: nextFileLeft, y: nextFileMidY };
            const midX = (p1.x + p2.x) / 2;
            return (
              <g key={`${sq.id}-${next.id}`}>
                <path d={`M ${p1.x} ${p1.y} C ${midX} ${p1.y}, ${midX} ${p2.y}, ${p2.x} ${p2.y}`}
                  stroke="#FFD465" strokeWidth="2" fill="none" strokeDasharray="6 4" opacity={0.7}
                  markerEnd="url(#arrowhead-file)" />
                <circle cx={p1.x} cy={p1.y} r="4" fill={getSourceColor(sq.sourceType)} />
                <circle cx={p2.x} cy={p2.y} r="3.5" fill="#FFD465" />
              </g>
            );
          } else {
            const p1 = getExitPoint(sq);
            const p2 = getEntryPoint(next);
            const midX = (p1.x + p2.x) / 2;
            const t = 0.5;
            const cx1 = midX; const cy1 = p1.y;
            const cx2 = midX; const cy2 = p2.y;
            const bx = (1-t)**3*p1.x + 3*(1-t)**2*t*cx1 + 3*(1-t)*t**2*cx2 + t**3*p2.x;
            const by = (1-t)**3*p1.y + 3*(1-t)**2*t*cy1 + 3*(1-t)*t**2*cy2 + t**3*p2.y;
            const dx = 3*(1-t)**2*(cx1-p1.x) + 6*(1-t)*t*(cx2-cx1) + 3*t**2*(p2.x-cx2);
            const dy = 3*(1-t)**2*(cy1-p1.y) + 6*(1-t)*t*(cy2-cy1) + 3*t**2*(p2.y-cy2);
            const angle = Math.atan2(dy, dx) * 180 / Math.PI;
            return (
              <g key={`${sq.id}-${next.id}`}>
                <path d={`M ${p1.x} ${p1.y} C ${midX} ${p1.y}, ${midX} ${p2.y}, ${p2.x} ${p2.y}`}
                  stroke={color} strokeWidth="2.4" fill="none" opacity={0.6}
                  markerEnd={`url(#arrowhead-${colorId})`} />
                <circle cx={p1.x} cy={p1.y} r="4" fill={getSourceColor(sq.sourceType)} />
                <circle cx={p2.x} cy={p2.y} r="4" fill={color} />
                <polygon points="-7,-4 -7,4 2,0" transform={`translate(${bx},${by}) rotate(${angle})`} fill={color} opacity={0.85} />
              </g>
            );
          }
        })}
        {simpleView && squares.filter(s => !s.isMainSource).map(sq => {
          const hasFile = !!(sq.uploadedFile?.previewUrl || sq.uploadedFile?.refCropUrl || sq.uploadedFile?.url);
          if (!hasFile) return null;
          const sqW = sw;
          const sqH = sh;
          const miniW = 120; const miniH = 24; const miniGap = 30;
          const x = sq.position.x + sqW / 2 - miniW / 2;
          const y = sq.position.y + sqH + miniGap;
          const fileName = sq.uploadedFile?.name || 'File';
          const shortName = fileName.length > 14 ? fileName.substring(0, 14) + '…' : fileName;
          const sColor = getSourceColor(sq.sourceType);
          return (
            <g key={`mini-file-${sq.id}`}>
              <line x1={sq.position.x + sqW / 2} y1={sq.position.y + sqH} x2={sq.position.x + sqW / 2} y2={y} stroke={sColor} strokeWidth="1" opacity={0.3} />
              <foreignObject x={x} y={y} width={miniW} height={miniH} style={{ overflow: 'visible', pointerEvents: 'auto' }}>
                <div onClick={(e) => { e.stopPropagation(); onOpenFile?.(sq.sourceId); }} style={{ width: miniW, height: miniH, borderRadius: 6, backgroundColor: isDark ? 'rgba(42,42,52,0.95)' : 'rgba(232,232,236,0.95)', border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`, display: 'flex', alignItems: 'center', gap: 4, padding: '0 6px', cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.15)', transition: 'border-color 0.15s' }}
                  onMouseOver={(e) => (e.currentTarget.style.borderColor = sColor)}
                  onMouseOut={(e) => (e.currentTarget.style.borderColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)')}>
                  <span style={{ fontSize: 10 }}>📎</span>
                  <span style={{ fontSize: 8, fontWeight: 600, color: isDark ? '#E3E3DF' : '#1a1a2e', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'Inter, sans-serif' }}>{shortName}</span>
                </div>
              </foreignObject>
            </g>
          );
        })}
        {isChain && (
          <g>
            <line
              x1={chainLineX}
              y1={(chainTop + chainBottom) / 2}
              x2={bracketSq.position.x}
              y2={(chainTop + chainBottom) / 2}
              stroke={isDark ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.2)'}
              strokeWidth="2.4" />
            <foreignObject x={chainLineX - 130} y={(chainTop + chainBottom) / 2 - 12} width={120} height={24} style={{ overflow: 'visible', pointerEvents: 'auto' }}>
              <div onClick={(e) => { e.stopPropagation(); if (chainId) { updateURL(boardId, chainId); navigator.clipboard.writeText(`${window.location.origin}/${dispId(chainId)}/`); setSnackbar({ open: true, message: `Chain URL copied` }); } }}
                style={{ cursor: 'pointer', userSelect: 'none', fontFamily: 'monospace', fontSize: 10, fontWeight: 600, color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.4)', whiteSpace: 'nowrap', padding: '3px 8px', borderRadius: 4, backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', textAlign: 'right' }}>
                Chain: {chainId ? dispId(chainId) : ''}
              </div>
            </foreignObject>
          </g>
        )}
      </svg>
      <Dialog disableScrollLock open={chainTrustOpen} onClose={() => setChainTrustOpen(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: '10px', pointerEvents: 'auto', minHeight: '70vh' } }}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0 }}>
          <Box>
            <Typography fontWeight={700} fontSize={18}>Chain Trust Analysis</Typography>
            <Typography fontSize={12} color="text.secondary">{squares.length} sources · {assessedSources.length} assessed · {dispId(boardId)}</Typography>
          </Box>
          <IconButton onClick={() => setChainTrustOpen(false)} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '12px !important', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            {[
              { label: 'Chain Average', value: chainTrustAvg > 0 ? chainTrustAvg.toFixed(1) : '–', color: chainTrustAvg >= 7 ? '#10b981' : chainTrustAvg >= 4 ? '#f59e0b' : chainTrustAvg > 0 ? '#ef4444' : undefined, sub: chainTrustAvg >= 7 ? 'Strong' : chainTrustAvg >= 4 ? 'Moderate' : chainTrustAvg > 0 ? 'Weak' : '' },
              { label: 'Trend', value: assessedData.length >= 2 ? (trend > 0.5 ? '↑' : trend < -0.5 ? '↓' : '→') : '–', color: trend > 0.5 ? '#10b981' : trend < -0.5 ? '#ef4444' : undefined, sub: assessedData.length >= 2 ? (trend > 0.5 ? 'Strengthening' : trend < -0.5 ? 'Weakening' : 'Stable') : '' },
              { label: 'Highest', value: assessedData.length > 0 ? Math.max(...assessedData.map(d => d.avg)).toFixed(1) : '–', color: '#10b981', sub: assessedData.length > 0 ? assessedData.reduce((best, d) => d.avg > best.avg ? d : best, assessedData[0]).title : '' },
              { label: 'Lowest', value: assessedData.length > 0 ? Math.min(...assessedData.map(d => d.avg)).toFixed(1) : '–', color: '#ef4444', sub: assessedData.length > 0 ? assessedData.reduce((worst, d) => d.avg < worst.avg ? d : worst, assessedData[0]).title : '' },
            ].map(({ label, value, color, sub }) => (
              <Box key={label} sx={{ flex: 1, p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
                <Typography fontSize={10} color="text.secondary" sx={{ mb: 0.3 }}>{label}</Typography>
                <Typography fontSize={24} fontWeight={800} sx={{ color: color || 'text.disabled', lineHeight: 1.1 }}>{value}</Typography>
                {sub && <Typography fontSize={10} color="text.secondary" sx={{ mt: 0.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sub}</Typography>}
              </Box>
            ))}
          </Box>

          {(() => {
            const chartW = 700, chartH = 280;
            const padL = 40, padR = 30, padT = 20, padB = 50;
            const gW = chartW - padL - padR;
            const gH = chartH - padT - padB;
            const n = trustChartData.length;
            if (n < 1) return null;
            const xStep = n > 1 ? gW / (n - 1) : gW / 2;
            const toX = (i: number) => padL + (n > 1 ? i * xStep : gW / 2);
            const toY = (v: number) => padT + gH - (v / 10) * gH;

            const categories: { key: keyof TrustRates; label: string; color: string }[] = [
              { key: 'accuracy', label: 'Accuracy', color: '#ef4444' },
              { key: 'relevance', label: 'Relevance', color: '#3b82f6' },
              { key: 'credibility', label: 'Credibility', color: '#10b981' },
              { key: 'verifiability', label: 'Verifiability', color: '#8b5cf6' },
              { key: 'recency', label: 'Timeliness', color: '#f59e0b' },
              { key: 'completeness', label: 'Completeness', color: '#a78bfa' },
            ];

            const buildPath = (pts: { x: number; y: number }[]) => {
              if (pts.length < 2) return '';
              return pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');
            };

            const avgPts = trustChartData.filter(d => d.assessed).map(d => ({ x: toX(d.index), y: toY(d.avg) }));
            const catLines = categories.map(cat => ({
              ...cat,
              pts: trustChartData.filter(d => d.assessed && d.rates[cat.key] > 0).map(d => ({ x: toX(d.index), y: toY(d.rates[cat.key]) })),
            }));

            const gridColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
            const textColor = isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.35)';

            return (
              <Box>
                <Typography fontSize={13} fontWeight={600} sx={{ mb: 1 }}>Trust progression across chain</Typography>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                  <svg viewBox={`0 0 ${chartW} ${chartH}`} style={{ width: '100%', maxWidth: chartW, height: 'auto', minHeight: 220 }}>
                    {[0, 2, 4, 6, 8, 10].map(v => (
                      <g key={v}>
                        <line x1={padL} y1={toY(v)} x2={padL + gW} y2={toY(v)} stroke={gridColor} strokeWidth={1} />
                        <text x={padL - 8} y={toY(v) + 4} textAnchor="end" fontSize={10} fill={textColor}>{v}</text>
                      </g>
                    ))}
                    <rect x={padL} y={toY(10)} width={gW} height={toY(7) - toY(10)} fill="#10b98108" />
                    <rect x={padL} y={toY(7)} width={gW} height={toY(4) - toY(7)} fill="#f59e0b06" />
                    <rect x={padL} y={toY(4)} width={gW} height={toY(0) - toY(4)} fill="#ef444406" />
                    <text x={padL + gW + 4} y={toY(8.5) + 3} fontSize={8} fill="#10b981" opacity={0.6}>Good</text>
                    <text x={padL + gW + 4} y={toY(5.5) + 3} fontSize={8} fill="#f59e0b" opacity={0.6}>Avg</text>
                    <text x={padL + gW + 4} y={toY(2) + 3} fontSize={8} fill="#ef4444" opacity={0.6}>Poor</text>
                    {trustChartData.map((d) => (
                      <g key={d.index}>
                        <line x1={toX(d.index)} y1={padT} x2={toX(d.index)} y2={padT + gH} stroke={gridColor} strokeWidth={1} strokeDasharray="3,3" />
                        <text x={toX(d.index)} y={padT + gH + 14} textAnchor="middle" fontSize={9} fontWeight={700} fill={textColor}>{d.label}</text>
                        <text x={toX(d.index)} y={padT + gH + 26} textAnchor="middle" fontSize={8} fill={textColor}>{d.title.length > 14 ? d.title.slice(0, 13) + '…' : d.title}</text>
                        {!d.assessed && <text x={toX(d.index)} y={toY(5) + 4} textAnchor="middle" fontSize={8} fill={textColor} fontStyle="italic">N/A</text>}
                      </g>
                    ))}
                    {catLines.map(({ key, color, pts }) => pts.length >= 2 && (
                      <g key={key}>
                        <path d={buildPath(pts)} stroke={color} strokeWidth={1.5} fill="none" opacity={0.35} strokeLinejoin="round" />
                        {pts.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r={2.5} fill={color} opacity={0.4} />)}
                      </g>
                    ))}
                    {avgPts.length >= 2 && (
                      <g>
                        <path d={`${buildPath(avgPts)} L ${avgPts[avgPts.length - 1].x} ${toY(0)} L ${avgPts[0].x} ${toY(0)} Z`} fill="url(#avgGrad)" opacity={0.15} />
                        <defs><linearGradient id="avgGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#3b82f6" /><stop offset="100%" stopColor="#3b82f6" stopOpacity={0} /></linearGradient></defs>
                        <path d={buildPath(avgPts)} stroke="#3b82f6" strokeWidth={2.5} fill="none" strokeLinejoin="round" strokeLinecap="round" />
                      </g>
                    )}
                    {avgPts.map((p, i) => {
                      const d = assessedData[i];
                      return (
                        <g key={i}>
                          <circle cx={p.x} cy={p.y} r={5} fill="#fff" stroke="#3b82f6" strokeWidth={2.5} />
                          <rect x={p.x - 12} y={p.y - 18} width={24} height={14} rx={3} fill="#3b82f6" />
                          <text x={p.x} y={p.y - 8.5} textAnchor="middle" fontSize={9} fontWeight={700} fill="#E3E3DF">{d?.avg.toFixed(1)}</text>
                        </g>
                      );
                    })}
                  </svg>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <Box sx={{ width: 16, height: 3, bgcolor: '#3b82f6', borderRadius: 1 }} />
                    <Typography fontSize={10} fontWeight={600}>Average</Typography>
                  </Box>
                  {categories.map(({ label, color }) => (
                    <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                      <Box sx={{ width: 16, height: 2, bgcolor: color, borderRadius: 1, opacity: 0.5 }} />
                      <Typography fontSize={10} color="text.secondary">{label}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            );
          })()}

          <Box>
            <Typography fontSize={13} fontWeight={600} sx={{ mb: 1 }}>Source breakdown</Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Source</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#ef4444' }}>ACC</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#3b82f6' }}>REL</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#10b981' }}>CRD</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#8b5cf6' }}>CMP</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11, color: '#f59e0b' }}>REC</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700, fontSize: 11 }}>AVG</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {trustChartData.map((d) => {
                    const avgColor = d.avg >= 7 ? '#10b981' : d.avg >= 4 ? '#f59e0b' : d.avg > 0 ? '#ef4444' : undefined;
                    const cellVal = (v: number, color: string) => (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <Box sx={{ width: 20, height: 4, bgcolor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)', borderRadius: 2, overflow: 'hidden' }}>
                          <Box sx={{ width: `${v * 10}%`, height: '100%', bgcolor: color, borderRadius: 2 }} />
                        </Box>
                        <Typography fontSize={11} fontWeight={600} sx={{ color: v > 0 ? color : 'text.disabled', minWidth: 14, textAlign: 'right' }}>{v || '–'}</Typography>
                      </Box>
                    );
                    return (
                      <TableRow key={d.index} sx={{ opacity: d.assessed ? 1 : 0.4 }}>
                        <TableCell><Typography fontSize={11} fontWeight={700} color="text.secondary">{d.label}</Typography></TableCell>
                        <TableCell><Typography fontSize={11} sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.title}</Typography></TableCell>
                        <TableCell align="center">{d.assessed ? cellVal(d.rates.accuracy, '#ef4444') : <Typography fontSize={10} color="text.disabled">–</Typography>}</TableCell>
                        <TableCell align="center">{d.assessed ? cellVal(d.rates.relevance, '#3b82f6') : <Typography fontSize={10} color="text.disabled">–</Typography>}</TableCell>
                        <TableCell align="center">{d.assessed ? cellVal(d.rates.credibility, '#10b981') : <Typography fontSize={10} color="text.disabled">–</Typography>}</TableCell>
                        <TableCell align="center">{d.assessed ? cellVal(d.rates.completeness, '#8b5cf6') : <Typography fontSize={10} color="text.disabled">–</Typography>}</TableCell>
                        <TableCell align="center">{d.assessed ? cellVal(d.rates.recency, '#f59e0b') : <Typography fontSize={10} color="text.disabled">–</Typography>}</TableCell>
                        <TableCell align="center">
                          {d.assessed ? (
                            <Chip label={d.avg.toFixed(1)} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, bgcolor: avgColor, color: '#E3E3DF', minWidth: 38 }} />
                          ) : <Typography fontSize={10} color="text.disabled">N/A</Typography>}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {assessedData.length >= 2 && (
            <Box sx={{ p: 1.5, borderRadius: '8px', bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)', border: '1px solid', borderColor: 'divider' }}>
              <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Insights</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                {(() => {
                  const insights: string[] = [];
                  if (trend > 1) insights.push('Trust scores are increasing significantly through the chain — your sources are getting more reliable toward the foundation.');
                  else if (trend > 0.5) insights.push('Slight upward trend — the chain is strengthening toward the foundation.');
                  else if (trend < -1) insights.push('Trust scores are dropping significantly through the chain — later sources are weaker.');
                  else if (trend < -0.5) insights.push('Slight downward trend — consider reviewing the weaker sources.');
                  else insights.push('Trust scores are relatively stable across the chain.');

                  const catAvgs = (['accuracy', 'relevance', 'credibility', 'completeness', 'recency'] as const).map(key => {
                    const vals = assessedData.map(d => d.rates[key]).filter(v => v > 0);
                    return { key, avg: vals.length > 0 ? vals.reduce((a, b) => a + b, 0) / vals.length : 0 };
                  });
                  const weakest = catAvgs.filter(c => c.avg > 0).sort((a, b) => a.avg - b.avg)[0];
                  const strongest = catAvgs.filter(c => c.avg > 0).sort((a, b) => b.avg - a.avg)[0];
                  if (weakest && weakest.avg < 5) insights.push(`Weakest category across the chain: ${weakest.key} (avg ${weakest.avg.toFixed(1)}). Consider finding sources that score higher in this area.`);
                  if (strongest) insights.push(`Strongest category: ${strongest.key} (avg ${strongest.avg.toFixed(1)}).`);

                  const unassessed = trustChartData.filter(d => !d.assessed).length;
                  if (unassessed > 0) insights.push(`${unassessed} source${unassessed > 1 ? 's have' : ' has'} not been assessed yet.`);

                  return insights.map((t, i) => (
                    <Typography key={i} fontSize={11} color="text.secondary" lineHeight={1.5}>• {t}</Typography>
                  ));
                })()}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2, pt: 0.5, borderTop: '1px solid', borderColor: 'divider' }}>
          <Button onClick={() => { navigator.clipboard.writeText(dispId(boardId)); setSnackbar({ open: true, message: `Chain ID copied: ${dispId(boardId)}` }); }} startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />} color="inherit" sx={{ fontSize: 12 }}>Copy Chain ID</Button>
          <Box sx={{ flex: 1 }} />
          <Button onClick={() => setChainTrustOpen(false)} variant="contained" sx={{ bgcolor: '#1a1a2e', '&:hover': { bgcolor: '#2d2d44' }, fontWeight: 600 }}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// ▓▓▓▓▓ ABOUT / PROFILE / LEGAL PAGES ▓▓▓▓▓
const AboutDialog: React.FC<{ open: boolean; onClose: () => void; isDark: boolean }> = ({ open, onClose, isDark }) => (
  <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0.5 }}>
      <Typography fontWeight={700} fontSize={17}>About source.</Typography>
      <IconButton onClick={onClose} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
    </DialogTitle>
    <DialogContent sx={{ pt: '4px !important' }}>
      <Typography fontSize={13} color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>A tool for organizing, verifying, and sharing references.</Typography>
    </DialogContent>
  </Dialog>
);


// ── Public User Profile Page ─────────────────────────────────────────────────
const PublicProfilePage: React.FC<{ username: string; onClose: () => void; isDark: boolean; apiHeaders: () => Record<string, string> }> = ({ username, onClose, isDark, apiHeaders }) => {
  const { t } = useTranslation();
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState<any>(null);
  const [fetchError, setFetchError] = useState(false);
  const retryRef = React.useRef<ReturnType<typeof setInterval> | null>(null);
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    if (!username) { setLoading(false); return; }
    setLoading(true);
    setFetchError(false);
    let alive = true;
    Promise.all([
      fetch(`${API_BASE}/users/profile/${encodeURIComponent(username)}`).then(r => r.ok ? r.json() : Promise.reject(new Error(`http ${r.status}`))),
      fetch(`${API_BASE}/users/stats/${encodeURIComponent(username)}`).then(r => r.ok ? r.json() : null).catch(() => null),
    ]).then(([p, s]) => {
      if (!alive) return;
      setProfile(p);
      if (s) setStats(s);
      setLoading(false);
      setFetchError(false);
      if (retryRef.current) { clearInterval(retryRef.current); retryRef.current = null; }
    }).catch(() => {
      if (!alive) return;
      setLoading(false);
      setFetchError(true);
      if (!retryRef.current) {
        retryRef.current = setInterval(() => setReloadKey(k => k + 1), 4000);
      }
    });
    return () => { alive = false; };
  }, [username, reloadKey]);
  useEffect(() => () => { if (retryRef.current) clearInterval(retryRef.current); }, []);

  const fullName = profile?.firstName && profile?.lastName ? `${profile.firstName} ${profile.lastName}` : null;
  const displayName = profile ? (fullName || (/^user_/.test(profile.displayName || '') ? (profile.username && !/^user_/.test(profile.username) ? profile.username : 'Anonymous User') : (profile.displayName || profile.username || 'User'))) : '';
  const initial = displayName ? displayName[0].toUpperCase() : '?';

  return (
    <Dialog open onClose={onClose} maxWidth={false} PaperProps={{ sx: { position: 'fixed', inset: 0, m: 0, maxWidth: '100%', maxHeight: '100%', borderRadius: 0, bgcolor: isDark ? '#0f0f17' : '#f8f9fa' } }}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', flexShrink: 0 }}>
          <Typography fontWeight={700} fontSize={15}>{t('profile.title', 'User Profile')}</Typography>
          <Box sx={{ flex: 1 }} />
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>

        {loading ? (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={36} /></Box>
        ) : fetchError && !profile ? (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 1.5 }}>
            <CircularProgress size={28} />
            <Typography fontSize={13} color="text.secondary">Reconnecting to server…</Typography>
            <Button onClick={() => setReloadKey(k => k + 1)} size="small" variant="outlined">Retry now</Button>
          </Box>
        ) : !profile ? (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography fontSize={14} color="text.secondary">{t('profile.notFound', 'Profile not found.')}</Typography>
          </Box>
        ) : profile.profileHidden ? (
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
            <AccountCircleIcon sx={{ fontSize: 56, color: 'text.disabled' }} />
            <Typography fontWeight={600} fontSize={16}>{displayName}</Typography>
            <Typography fontSize={13} color="text.secondary">{t('profile.hidden', 'This user has chosen not to display their public profile.')}</Typography>
          </Box>
        ) : (
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            <Box sx={{ height: 120, bgcolor: isDark ? 'rgba(59,130,246,0.08)' : 'rgba(59,130,246,0.05)', position: 'relative' }}>
              <Box sx={{ position: 'absolute', bottom: -40, left: 40 }}>
                {profile.photoUrl ? (
                  <Box component="img" src={profile.photoUrl} alt={displayName} sx={{ width: 80, height: 80, borderRadius: '50%', border: '4px solid', borderColor: 'background.paper', objectFit: 'cover' }} />
                ) : (
                  <Box sx={{ width: 80, height: 80, borderRadius: '50%', bgcolor: '#3b82f6', border: '4px solid', borderColor: 'background.paper', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography fontSize={32} fontWeight={700} color="white">{initial}</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            <Box sx={{ maxWidth: 700, mx: 'auto', px: 4, pt: 7, pb: 6 }}>
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Typography fontWeight={800} fontSize={24} lineHeight={1.2}>{displayName}</Typography>
                  {profile.emailVerified && (
                    <Tooltip title="This user has verified their email address">
                      <CheckCircleIcon sx={{ fontSize: 22, color: '#16a34a' }} />
                    </Tooltip>
                  )}
                </Box>
                <Typography fontSize={13} color="text.secondary" sx={{ mt: 0.3 }}>
                  {profile.username && !/^user_/.test(profile.username) ? `@${profile.username}` : ''}
                </Typography>
              </Box>

              {profile.emailVerified && (
                <Box sx={{ mb: 3, p: 1.5, borderRadius: '10px', bgcolor: isDark ? 'rgba(22,163,74,0.08)' : 'rgba(22,163,74,0.06)', border: '1px solid', borderColor: isDark ? 'rgba(22,163,74,0.2)' : 'rgba(22,163,74,0.15)', display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: isDark ? 'rgba(22,163,74,0.15)' : 'rgba(22,163,74,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <CheckCircleIcon sx={{ fontSize: 18, color: '#16a34a' }} />
                  </Box>
                  <Box>
                    <Typography fontSize={12} fontWeight={600} sx={{ color: '#16a34a' }}>{t('profile.verified', 'Verified Account')}</Typography>
                    <Typography fontSize={11} color="text.secondary">{t('profile.verifiedDesc', 'This user has verified their email address')}</Typography>
                  </Box>
                </Box>
              )}

              <Box sx={{ mb: 3 }}>
                <Typography fontSize={10} fontWeight={600} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 0.5 }}>{t('profile.about', 'About')}</Typography>
                <Typography fontSize={13} color={profile.bio ? 'text.primary' : 'text.disabled'} lineHeight={1.7}>
                  {profile.bio || '—'}
                </Typography>
              </Box>

              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 3 }}>
                {[
                  { label: t('profile.location', 'Location'), value: profile.location, iconEl: <LocationOnIcon sx={{ fontSize: 14, color: 'text.secondary' }} /> },
                  { label: t('profile.organization', 'Organization'), value: profile.organization, iconEl: <BusinessIcon sx={{ fontSize: 14, color: 'text.secondary' }} /> },
                  { label: t('profile.website', 'Website'), value: profile.website, iconEl: <LinkIcon sx={{ fontSize: 14, color: 'text.secondary' }} />, isLink: true },
                  { label: t('profile.memberSince', 'Member since'), value: profile.memberSince ? formatTimestamp(profile.memberSince, DEFAULT_SETTINGS, false) : null, iconEl: <CalendarTodayIcon sx={{ fontSize: 14, color: 'text.secondary' }} /> },
                ].map(item => (
                  <Box key={item.label} sx={{ p: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDark ? 'rgba(255,255,255,0.02)' : '#fff' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      {item.iconEl}
                      <Typography fontSize={9} fontWeight={600} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>{item.label}</Typography>
                    </Box>
                    {item.isLink && item.value && safeHref(item.value) ? (
                      <Typography component="a" href={safeHref(item.value)} target="_blank" rel="noopener noreferrer" fontSize={12} sx={{ color: 'primary.main', display: 'block', mt: 0.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.value}</Typography>
                    ) : (
                      <Typography fontSize={12} color={item.value ? 'text.primary' : 'text.disabled'} sx={{ mt: 0.3 }}>{item.value || '—'}</Typography>
                    )}
                  </Box>
                ))}
              </Box>

              {stats && (
                <Box sx={{ mb: 3 }}>
                  <Typography fontSize={10} fontWeight={600} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 1 }}>{t('profile.activity', 'Activity')}</Typography>
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    {[
                      { label: 'Boards', value: stats.boards ?? '—' },
                      { label: 'Sources', value: stats.sources ?? '—' },
                      { label: 'Public', value: stats.publicBoards ?? '—' },
                    ].map(s => (
                      <Box key={s.label} sx={{ px: 2, py: 1.5, borderRadius: '10px', bgcolor: isDark ? 'rgba(59,130,246,0.06)' : 'rgba(59,130,246,0.04)', border: '1px solid', borderColor: 'rgba(59,130,246,0.1)', textAlign: 'center', minWidth: 70 }}>
                        <Typography fontSize={22} fontWeight={800} color="primary.main">{s.value}</Typography>
                        <Typography fontSize={9} color="text.secondary">{s.label}</Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              <Box sx={{ mb: 3 }}>
                <Typography fontSize={10} fontWeight={600} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 1 }}>Education</Typography>
                {profile.education?.length > 0 ? profile.education.map((e: any, i: number) => (
                  <Box key={i} sx={{ display: 'flex', gap: 1, py: 0.8, borderBottom: '1px solid', borderColor: i < profile.education.length - 1 ? 'divider' : 'transparent' }}>
                    <SchoolIcon sx={{ fontSize: 18, color: 'text.secondary', mt: 0.2 }} />
                    <Box>
                      <Typography fontSize={12} fontWeight={600}>{e.type}{e.field ? ` — ${e.field}` : ''}</Typography>
                      <Typography fontSize={11} color="text.secondary">{e.institution || '—'}{e.startYear ? ` · ${e.startYear}${e.current ? '–present' : e.endYear ? `–${e.endYear}` : ''}` : ''}</Typography>
                    </Box>
                  </Box>
                )) : (
                  <Typography fontSize={12} color="text.disabled">—</Typography>
                )}
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography fontSize={10} fontWeight={600} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 1 }}>Employment</Typography>
                {profile.employment?.length > 0 ? profile.employment.map((e: any, i: number) => (
                  <Box key={i} sx={{ display: 'flex', gap: 1, py: 0.8, borderBottom: '1px solid', borderColor: i < profile.employment.length - 1 ? 'divider' : 'transparent' }}>
                    <WorkIcon sx={{ fontSize: 18, color: 'text.secondary', mt: 0.2 }} />
                    <Box>
                      <Typography fontSize={12} fontWeight={600}>{e.title || 'Position'}{e.employer ? ` at ${e.employer}` : ''}</Typography>
                      <Typography fontSize={11} color="text.secondary">{e.type || ''}{e.startYear ? ` · ${e.startYear}${e.current ? '–present' : e.endYear ? `–${e.endYear}` : ''}` : ''}</Typography>
                    </Box>
                  </Box>
                )) : (
                  <Typography fontSize={12} color="text.disabled">—</Typography>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

// ── Edit Public Profile Page ──────────────────────────────────────────────────
interface EducationEntry { id: string; type: string; institution: string; field: string; startYear: string; endYear: string; current: boolean; }
interface EmploymentEntry { id: string; type: string; employer: string; title: string; startYear: string; endYear: string; current: boolean; }
const EDU_TYPES = ["High School", "Vocational / Trade School", "Associate Degree", "Bachelor's Degree", "Master's Degree", "MBA", "Doctorate (PhD)", "Post-doctoral", "Professional Degree (MD/JD/etc)", "Certificate / Diploma", "Online Course", "Other"];
const EMP_TYPES = ['Full-time', 'Part-time', 'Self-employed / Freelance', 'Contract', 'Internship', 'Volunteer', 'Research Position', 'Academic / Faculty', 'Emeritus / Retired', 'Other'];
const YEARS = Array.from({ length: 60 }, (_, i) => String(new Date().getFullYear() - i));
const mkId = () => Math.random().toString(36).slice(2, 9);

const EntryRow: React.FC<{ label: string; onRemove: () => void; children: React.ReactNode }> = ({ label, onRemove, children }) => (
  <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', p: 2, mb: 1.5 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
      <Typography fontSize={12} fontWeight={700} color="text.secondary">{label}</Typography>
      <IconButton size="small" onClick={onRemove} sx={{ color: 'text.disabled', '&:hover': { color: 'error.main' } }}><CloseIcon sx={{ fontSize: 14 }} /></IconButton>
    </Box>
    {children}
  </Box>
);

const EditProfilePage: React.FC<{ isDark: boolean; onBack: () => void; apiHeaders: () => Record<string, string>; clerkUser: any }> = ({ isDark, onBack, apiHeaders, clerkUser }) => {
  const emailVerified = clerkUser?.emailAddresses?.[0]?.verification?.status === 'verified';
  const email = clerkUser?.emailAddresses?.[0]?.emailAddress || '';
  const [form, setForm] = useState({ firstName: '', lastName: '', displayName: '', bio: '', location: '', organization: '', website: '' });
  const [education, setEducation] = useState<EducationEntry[]>([]);
  const [employment, setEmployment] = useState<EmploymentEntry[]>([]);
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [profileHidden, setProfileHidden] = useState(false);
  const [photoUrl, setPhotoUrl] = useState('');
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const photoInputRef = React.useRef<HTMLInputElement>(null);

  const handlePhotoUpload = async (file: File) => {
    if (!file.type.startsWith('image/') || file.size > 5 * 1024 * 1024) return;
    setUploadingPhoto(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('boardId', 'profile');
      formData.append('sourceId', 'avatar');
      const resp = await fetch(`${API_BASE}/upload`, { method: 'POST', headers: { 'Authorization': apiHeaders()['Authorization'] }, body: formData });
      if (resp.ok) {
        const data = await resp.json();
        if (data.url) setPhotoUrl(data.url);
        else if (data.originalUrl) setPhotoUrl(data.originalUrl);
      }
    } catch {}
    setUploadingPhoto(false);
  };

  useEffect(() => {
    fetch(`${API_BASE}/auth/me`, { headers: apiHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d?.user) {
          const p = d.user.publicProfile || {};
          setForm({ firstName: p.firstName || '', lastName: p.lastName || '', displayName: d.user.displayName || d.user.display_name || '', bio: p.bio || '', location: p.location || '', organization: p.organization || '', website: p.website || '' });
          setEducation(p.education || []);
          setEmployment(p.employment || []);
          setProfileHidden(!!p.profileHidden);
          setPhotoUrl(p.photoUrl || '');
        }
        setLoaded(true);
      }).catch(() => setLoaded(true));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const r = await fetch(`${API_BASE}/auth/profile`, {
        method: 'PUT',
        headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, education, employment, profileHidden, photoUrl })
      });
      if (!r.ok) throw new Error(await r.text());
    } catch (e) { console.error('[profile save]', e); }
    setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500);
  };

  const addEdu = () => setEducation(p => [...p, { id: mkId(), type: "Bachelor's Degree", institution: '', field: '', startYear: '', endYear: '', current: false }]);
  const updEdu = (id: string, k: string, v: any) => setEducation(p => p.map(e => e.id === id ? { ...e, [k]: v } : e));
  const delEdu = (id: string) => setEducation(p => p.filter(e => e.id !== id));

  const addEmp = () => setEmployment(p => [...p, { id: mkId(), type: 'Full-time', employer: '', title: '', startYear: '', endYear: '', current: false }]);
  const updEmp = (id: string, k: string, v: any) => setEmployment(p => p.map(e => e.id === id ? { ...e, [k]: v } : e));
  const delEmp = (id: string) => setEmployment(p => p.filter(e => e.id !== id));

  const SectionHeader: React.FC<{ title: string; onAdd: () => void; addLabel: string }> = ({ title, onAdd, addLabel }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
      <Typography fontWeight={700} fontSize={13}>{title}</Typography>
      <Button size="small" startIcon={<AddIcon sx={{ fontSize: 13 }} />} onClick={onAdd} sx={{ fontSize: 11, textTransform: 'none' }}>{addLabel}</Button>
    </Box>
  );

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
        <Typography fontWeight={700} fontSize={18}>Public Profile</Typography>
        <Box sx={{ flex: 1 }} />
        <Button variant="contained" size="small" onClick={handleSave} disabled={saving}
          startIcon={saved ? <CheckCircleIcon sx={{ fontSize: 14 }} /> : <SaveIcon sx={{ fontSize: 14 }} />}
          color={saved ? 'success' : 'primary'} sx={{ fontSize: 11, textTransform: 'none' }}>
          {saving ? 'Saving…' : saved ? 'Saved!' : 'Save Profile'}
        </Button>
      </Box>

      {!loaded ? (
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress /></Box>
      ) : (
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <Box sx={{ maxWidth: 620, mx: 'auto', px: 3, py: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>

            <Box sx={{ p: 2, borderRadius: '10px', border: '1px solid', borderColor: 'divider', bgcolor: emailVerified ? (isDark ? '#052e16' : '#f0fdf4') : (isDark ? '#422006' : '#fef9c3') }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ fontSize: 15, color: emailVerified ? '#16a34a' : '#ca8a04' }} />
                <Typography fontSize={13} fontWeight={600}>{email || 'No email'}</Typography>
                <Chip label={emailVerified ? '✓ Verified' : '⚠ Not verified'} size="small" color={emailVerified ? 'success' : 'warning'} sx={{ fontSize: 10, height: 18 }} />
              </Box>
              {!emailVerified && <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.5 }}>Check your inbox to verify your email address.</Typography>}
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={13} sx={{ mb: 1 }}>Profile Photo</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ position: 'relative' }}>
                  {photoUrl ? (
                    <Box component="img" src={photoUrl} alt="Profile" sx={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', border: '2px solid', borderColor: 'divider' }} />
                  ) : (
                    <Box sx={{ width: 72, height: 72, borderRadius: '50%', bgcolor: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid', borderColor: 'divider' }}>
                      <Typography fontSize={28} fontWeight={700} color="white">{(form.displayName || '?')[0].toUpperCase()}</Typography>
                    </Box>
                  )}
                  <IconButton size="small" onClick={() => photoInputRef.current?.click()}
                    sx={{ position: 'absolute', bottom: -4, right: -4, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', width: 28, height: 28, '&:hover': { bgcolor: 'action.hover' } }}>
                    {uploadingPhoto ? <CircularProgress size={14} /> : <PhotoCameraIcon sx={{ fontSize: 14 }} />}
                  </IconButton>
                </Box>
                <Box>
                  <Button size="small" variant="outlined" onClick={() => photoInputRef.current?.click()} disabled={uploadingPhoto}
                    sx={{ fontSize: 11, textTransform: 'none', borderRadius: '8px' }}>
                    {uploadingPhoto ? 'Uploading...' : 'Upload Photo'}
                  </Button>
                  {photoUrl && (
                    <Button size="small" color="error" onClick={() => setPhotoUrl('')} sx={{ fontSize: 10, textTransform: 'none', ml: 1 }}>Remove</Button>
                  )}
                  <Typography fontSize={10} color="text.disabled" sx={{ mt: 0.5 }}>Max 5 MB · JPG, PNG</Typography>
                </Box>
                <input ref={photoInputRef} type="file" accept="image/jpeg,image/png,image/webp" hidden
                  onChange={(e) => { const f = e.target.files?.[0]; if (f) handlePhotoUpload(f); e.target.value = ''; }} />
              </Box>
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={13} sx={{ mb: 0.5 }}>Basic Information</Typography>
              <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>Publicly visible on your profile.</Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                <TextField fullWidth label="First Name" placeholder="Your first name" size="small"
                  value={form.firstName} onChange={e => setForm(p => ({ ...p, firstName: e.target.value }))} />
                <TextField fullWidth label="Last Name" placeholder="Your last name" size="small"
                  value={form.lastName} onChange={e => setForm(p => ({ ...p, lastName: e.target.value }))} />
              </Box>
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2 }}>
                <TextField fullWidth label="Display Name" placeholder="Your public name" size="small"
                  value={form.displayName} onChange={e => setForm(p => ({ ...p, displayName: e.target.value }))} />
                <TextField fullWidth label="Location" placeholder="City, Country" size="small"
                  value={form.location} onChange={e => setForm(p => ({ ...p, location: e.target.value }))} />
              </Box>
              <TextField fullWidth label="Bio" placeholder="A short description about yourself and your research interests…" size="small" multiline rows={3}
                value={form.bio} onChange={e => setForm(p => ({ ...p, bio: e.target.value }))} sx={{ mt: 2 }} />
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2 }}>
                <TextField fullWidth label="Organisation / Affiliation" placeholder="University, company…" size="small"
                  value={form.organization} onChange={e => setForm(p => ({ ...p, organization: e.target.value }))} />
                <TextField fullWidth label="Website" placeholder="https://yoursite.com" size="small"
                  value={form.website} onChange={e => setForm(p => ({ ...p, website: e.target.value }))} />
              </Box>
            </Box>

            <Box>
              <SectionHeader title="Education" onAdd={addEdu} addLabel="Add Education" />
              {education.length === 0 && <Typography fontSize={11} color="text.disabled" sx={{ mb: 1 }}>No education entries yet.</Typography>}
              {education.map((e, i) => (
                <EntryRow key={e.id} label={`Education ${i + 1}`} onRemove={() => delEdu(e.id)}>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                    <TextField select fullWidth label="Degree / Type" size="small" value={e.type}
                      onChange={ev => updEdu(e.id, 'type', ev.target.value)} SelectProps={{ native: true }}>
                      {EDU_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </TextField>
                    <TextField fullWidth label="Institution / School" placeholder="e.g. MIT, Khan Academy" size="small"
                      value={e.institution} onChange={ev => updEdu(e.id, 'institution', ev.target.value)} />
                    <TextField fullWidth label="Field of Study" placeholder="e.g. Computer Science" size="small"
                      value={e.field} onChange={ev => updEdu(e.id, 'field', ev.target.value)} />
                    <Box />
                    <TextField select fullWidth label="Start Year" size="small" value={e.startYear}
                      onChange={ev => updEdu(e.id, 'startYear', ev.target.value)} SelectProps={{ native: true }}>
                      <option value="">— Year —</option>
                      {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                    </TextField>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {!e.current && (
                        <TextField select fullWidth label="End Year" size="small" value={e.endYear}
                          onChange={ev => updEdu(e.id, 'endYear', ev.target.value)} SelectProps={{ native: true }}>
                          <option value="">— Year —</option>
                          {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                        </TextField>
                      )}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                        <input type="checkbox" id={`edu-cur-${e.id}`} checked={e.current} onChange={ev => updEdu(e.id, 'current', ev.target.checked)} />
                        <label htmlFor={`edu-cur-${e.id}`} style={{ fontSize: 11, cursor: 'pointer', whiteSpace: 'nowrap' }}>Currently enrolled</label>
                      </Box>
                    </Box>
                  </Box>
                </EntryRow>
              ))}
            </Box>

            <Box>
              <SectionHeader title="Employment" onAdd={addEmp} addLabel="Add Employment" />
              {employment.length === 0 && <Typography fontSize={11} color="text.disabled" sx={{ mb: 1 }}>No employment entries yet.</Typography>}
              {employment.map((e, i) => (
                <EntryRow key={e.id} label={`Employment ${i + 1}`} onRemove={() => delEmp(e.id)}>
                  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                    <TextField select fullWidth label="Employment Type" size="small" value={e.type}
                      onChange={ev => updEmp(e.id, 'type', ev.target.value)} SelectProps={{ native: true }}>
                      {EMP_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </TextField>
                    <TextField fullWidth label="Employer / Organisation" placeholder="e.g. Google, UN, Self" size="small"
                      value={e.employer} onChange={ev => updEmp(e.id, 'employer', ev.target.value)} />
                    <TextField fullWidth label="Job Title / Role" placeholder="e.g. Senior Researcher" size="small"
                      value={e.title} onChange={ev => updEmp(e.id, 'title', ev.target.value)} />
                    <Box />
                    <TextField select fullWidth label="Start Year" size="small" value={e.startYear}
                      onChange={ev => updEmp(e.id, 'startYear', ev.target.value)} SelectProps={{ native: true }}>
                      <option value="">— Year —</option>
                      {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                    </TextField>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {!e.current && (
                        <TextField select fullWidth label="End Year" size="small" value={e.endYear}
                          onChange={ev => updEmp(e.id, 'endYear', ev.target.value)} SelectProps={{ native: true }}>
                          <option value="">— Year —</option>
                          {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                        </TextField>
                      )}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                        <input type="checkbox" id={`emp-cur-${e.id}`} checked={e.current} onChange={ev => updEmp(e.id, 'current', ev.target.checked)} />
                        <label htmlFor={`emp-cur-${e.id}`} style={{ fontSize: 11, cursor: 'pointer', whiteSpace: 'nowrap' }}>Currently working here</label>
                      </Box>
                    </Box>
                  </Box>
                </EntryRow>
              ))}
            </Box>

            <Box sx={{ p: 2, borderRadius: '8px', border: '1px solid', borderColor: profileHidden ? 'warning.main' : 'divider', bgcolor: profileHidden ? (isDark ? '#2d1f00' : '#fffbeb') : 'transparent' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <input type="checkbox" id="profile-hidden" checked={profileHidden} onChange={e => setProfileHidden(e.target.checked)} style={{ width: 16, height: 16, cursor: 'pointer' }} />
                <Box>
                  <label htmlFor="profile-hidden" style={{ fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Hide my public profile</label>
                  <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.2 }}>Your profile will not be shown when others click "By: {form.displayName || 'you'}" on your sources. A notice will appear instead.</Typography>
                </Box>
              </Box>
            </Box>

            <Box sx={{ p: 2, borderRadius: '8px', bgcolor: isDark ? '#1e293b' : '#f8fafc', border: '1px solid', borderColor: 'divider' }}>
              <Typography fontSize={11} fontWeight={700} sx={{ mb: 0.5 }}>🔒 Data & Privacy (GDPR)</Typography>
              <Typography fontSize={10} color="text.secondary" lineHeight={1.7}>
                This information is publicly visible on source. You can update or remove it at any time. We process it based on your consent.
                See our <Typography component="a" href="/gdpr/" target="_blank" fontSize={10} sx={{ color: 'primary.main' }}>Privacy Policy</Typography>,{' '}
                <Typography component="a" href="/tos/" target="_blank" fontSize={10} sx={{ color: 'primary.main' }}>Terms</Typography>{' '}and{' '}
                <Typography component="a" href="/optout/" target="_blank" fontSize={10} sx={{ color: 'primary.main' }}>opt-out page</Typography>.
              </Typography>
            </Box>

          </Box>
        </Box>
      )}
    </Box>
  );
};

const AboutPage: React.FC<{ isDark: boolean; onBack: () => void }> = ({ isDark, onBack }) => {
  const [expanded, setExpanded] = useState<number | null>(null);
  const faqs = [
    { q: 'What is a Source Board?', a: 'A board is your workspace. Each board has a unique 8-character ID and contains all your sources, chains, or trees. You can have multiple boards and switch between them from My Sources.' },
    { q: 'What is a Source Chain?', a: 'A chain links sources in order: Primary → 2nd → 3rd → Foundation. Each source points to the next via a reference. The last source in the chain is your most authoritative.' },
    { q: 'What is a Source Tree?', a: 'A tree starts with a seed node at the top and branches into reference points below. Each reference point can hold multiple sources.' },
    { q: 'What is a Reference Pointer?', a: 'A reference pointer marks exactly where in a source you\'re citing. For books, this is a page or page range. For videos or film, use timestamps.' },
    { q: 'How do Trust Ratings work?', a: 'Each source can be rated across multiple trust dimensions (credibility, accuracy, bias, etc.) from 1–10. Once assessed, the overall trust score helps you evaluate which sources are most reliable.' },
    { q: 'Can I share my board?', a: 'Yes. Toggle your board to Public using the visibility switch at the bottom of the canvas. Then share the URL. Others can view your board but only you can edit it.' },
    { q: 'How do I import sources from code?', a: 'Use the Code panel on the right side of the canvas. Paste XML-formatted source data and click Import. You can also Export your board to XML.' },
    { q: 'What source types are supported?', a: 'Books, articles, journals, websites, videos, podcasts, films, interviews, datasets, government documents, legal cases, social media posts, and more.' },
    { q: 'Is my data saved automatically?', a: 'Auto-save is off by default. You can enable it in Settings. Use the save button to save manually.' },
    { q: 'Can I delete a board?', a: 'Yes. Open My Sources and click the delete icon next to any board. This permanently removes the board and all its sources.' },
  ];

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
        <Typography fontWeight={700} fontSize={18}>About</Typography>
        <Box sx={{ flex: 1 }} />
        <Button size="small" startIcon={<MonitorHeartIcon sx={{ fontSize: 14 }} />} onClick={() => window.open('https://status.source.io', '_blank', 'noopener,noreferrer')} sx={{ fontSize: 11, textTransform: 'none' }}>System Status</Button>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', maxWidth: 680, mx: 'auto', width: '100%', px: 3, py: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography sx={{ fontSize: '2.5rem', fontWeight: 700, mb: 1 }}>source<span style={{ color: '#3b82f6' }}>.</span></Typography>
          <Typography fontSize={14} color="text.secondary" sx={{ maxWidth: 440, mx: 'auto', lineHeight: 1.7 }}>
            Organize, verify and share your references. Build source chains to trace information back to its origin, or create source trees to map complex research hierarchies.
          </Typography>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 4 }}>
          {[
            { icon: <ViewStreamIcon sx={{ fontSize: 22, color: '#3b82f6' }} />, title: 'Source Chains', desc: 'Link sources in sequence with reference pointers connecting each step.' },
            { icon: <AccountTreeIcon sx={{ fontSize: 22, color: '#10b981' }} />, title: 'Source Trees', desc: 'Branch from a seed node into reference points with multiple linked sources.' },
            { icon: <StarRateIcon sx={{ fontSize: 22, color: '#f59e0b' }} />, title: 'Trust Ratings', desc: 'Rate reliability across multiple trust dimensions for each source.' },
            { icon: <PublicIcon sx={{ fontSize: 22, color: '#8b5cf6' }} />, title: 'Share & Collaborate', desc: 'Make boards public to share your research with others.' },
          ].map(item => (
            <Box key={item.title} sx={{ p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
              <Box sx={{ mb: 1 }}>{item.icon}</Box>
              <Typography fontSize={13} fontWeight={700} sx={{ mb: 0.5 }}>{item.title}</Typography>
              <Typography fontSize={11} color="text.secondary" lineHeight={1.6}>{item.desc}</Typography>
            </Box>
          ))}
        </Box>

        <Typography fontWeight={700} fontSize={16} sx={{ mb: 2 }}>Frequently Asked Questions</Typography>
        <Box sx={{ mb: 4 }}>
          {faqs.map((faq, i) => (
            <Box key={i} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
              <Box onClick={() => setExpanded(expanded === i ? null : i)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, cursor: 'pointer', '&:hover': { color: 'primary.main' } }}>
                <Typography fontSize={13} fontWeight={600}>{faq.q}</Typography>
                <Typography fontSize={16} color="text.secondary" sx={{ ml: 1, flexShrink: 0, transition: 'transform 0.2s', transform: expanded === i ? 'rotate(180deg)' : 'none' }}>▾</Typography>
              </Box>
              {expanded === i && <Box sx={{ pb: 1.5 }}><Typography fontSize={12} color="text.secondary" lineHeight={1.7}>{faq.a}</Typography></Box>}
            </Box>
          ))}
        </Box>

        <Typography fontSize={10} color="text.disabled" textAlign="center" sx={{ pb: 2 }}>source. — Organize, verify and share your references.</Typography>
      </Box>
    </Box>
  );
};


// ── Corporate Static Pages (About / TOS / GDPR / Opt-out) ───────────────────
const APP_NAME = 'source.';
const APP_URL  = 'https://source.io';
const CONTACT_EMAIL = 'privacy@source.io';
const COMPANY_NAME  = 'Source Technologies';

const CorporateLayout: React.FC<{ title: string; subtitle?: string; children: React.ReactNode }> = ({ title, subtitle, children }) => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column' }}>
    <Box component="nav" sx={{ bgcolor: '#E3E3DF', borderBottom: '1px solid #e2e8f0', px: { xs: 2, md: 6 }, py: 1.5, display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography component="a" href="/" sx={{ fontWeight: 800, fontSize: 20, textDecoration: 'none', color: '#0f172a' }}>
        source<span style={{ color: '#3b82f6' }}>.</span>
      </Typography>
      <Box sx={{ flex: 1 }} />
      {['About', 'TOS', 'GDPR', 'Opt-out'].map(p => (
        <Typography key={p} component="a" href={`/${p.toLowerCase()}/`}
          sx={{ fontSize: 13, color: '#64748b', textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#3b82f6' } }}>{p}</Typography>
      ))}
      <Button component="a" href="/" variant="contained" size="small" sx={{ fontSize: 12, textTransform: 'none', borderRadius: '6px' }}>Open App</Button>
    </Box>
    <Box sx={{ bgcolor: '#0f172a', color: '#E3E3DF', px: { xs: 3, md: 8 }, py: { xs: 4, md: 6 } }}>
      <Typography fontSize={{ xs: 28, md: 36 }} fontWeight={800} sx={{ mb: 1 }}>{title}</Typography>
      {subtitle && <Typography fontSize={15} sx={{ color: '#94a3b8', maxWidth: 560 }}>{subtitle}</Typography>}
    </Box>
    <Box sx={{ flex: 1, maxWidth: 820, mx: 'auto', width: '100%', px: { xs: 3, md: 4 }, py: { xs: 4, md: 6 } }}>
      {children}
    </Box>
    <Box sx={{ bgcolor: '#0f172a', color: '#94a3b8', px: { xs: 3, md: 8 }, py: 3, mt: 4 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'center', maxWidth: 1100, mx: 'auto' }}>
        <Typography fontSize={13} fontWeight={700} color="#E3E3DF">source<span style={{ color: '#3b82f6' }}>.</span></Typography>
        <Box sx={{ flex: 1 }} />
        {[['About', '/about/'], ['Terms', '/tos/'], ['Privacy', '/gdpr/'], ['Opt-out', '/optout/']].map(([l, h]) => (
          <Typography key={l} component="a" href={h} fontSize={12} sx={{ color: '#94a3b8', textDecoration: 'none', '&:hover': { color: '#E3E3DF' } }}>{l}</Typography>
        ))}
        <Typography fontSize={12}>{CONTACT_EMAIL}</Typography>
      </Box>
      <Typography fontSize={11} sx={{ mt: 1.5, maxWidth: 1100, mx: 'auto' }}>© {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.</Typography>
    </Box>
  </Box>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ mb: 5 }}>
    <Typography fontSize={20} fontWeight={700} sx={{ mb: 1.5, color: '#0f172a', borderBottom: '2px solid #3b82f6', pb: 0.5, display: 'inline-block' }}>{title}</Typography>
    <Box sx={{ fontSize: 14, color: '#334155', lineHeight: 1.85 }}>{children}</Box>
  </Box>
);

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography fontSize={14} color="#334155" lineHeight={1.85} sx={{ mb: 1.5 }}>{children}</Typography>
);
const Li: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box component="li" sx={{ fontSize: 14, color: '#334155', lineHeight: 1.85, mb: 0.5, ml: 2 }}>{children}</Box>
);

// ── About Page ────────────────────────────────────────────────────────────────
const AboutSitePage: React.FC = () => (
  <CorporateLayout title="About source." subtitle="Organize, verify and share your references — from primary sources to foundational documents.">
    <Section title="What is source.?">
      <P>source. is a research and reference management platform designed for journalists, academics, analysts, and anyone who cares about where information comes from. Build source chains to trace information back to its origin, or create source trees to map complex research hierarchies.</P>
    </Section>
    <Section title="Core Features">
      <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
        {[
          ['Source Chains', 'Link sources in sequence — Primary → Secondary → Foundation. Each step connects via a verifiable reference pointer.'],
          ['Source Trees', 'Start with a seed node and branch into reference points, each holding multiple linked sources.'],
          ['Trust Ratings', 'Rate each source across dimensions like credibility, accuracy, and bias. Calculate composite trust scores.'],
          ['Public Sharing', 'Make boards public and share a clean URL. Others can view your research; only you can edit.'],
          ['File Uploads', 'Attach PDFs, documents, and images directly to sources. Select and highlight cited pages.'],
        ].map(([t, d]) => (
          <Box key={t} component="li" sx={{ display: 'flex', gap: 2, mb: 2, p: 2, borderRadius: '10px', border: '1px solid #e2e8f0', bgcolor: '#E3E3DF' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#3b82f6', mt: 0.8, flexShrink: 0 }} />
            <Box><Typography fontSize={14} fontWeight={700} sx={{ mb: 0.3 }}>{t}</Typography><Typography fontSize={13} color="#64748b">{d}</Typography></Box>
          </Box>
        ))}
      </Box>
    </Section>
    <Section title="Contact">
      <P>Questions, feedback or partnership inquiries: <Typography component="a" href={`mailto:${CONTACT_EMAIL}`} sx={{ color: '#3b82f6' }}>{CONTACT_EMAIL}</Typography></P>
    </Section>
  </CorporateLayout>
);

// ── Terms of Service ──────────────────────────────────────────────────────────
const TOSPage: React.FC = () => (
  <CorporateLayout title="Terms of Service" subtitle={`Last updated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`}>
    <Section title="1. Acceptance of Terms">
      <P>By accessing or using {APP_NAME} ("the Service") you agree to be bound by these Terms of Service. If you do not agree, please discontinue use immediately.</P>
    </Section>
    <Section title="2. Use of Service">
      <P>You may use the Service for lawful purposes only. You agree not to:</P>
      <Box component="ul"><Li>Upload or share illegal, defamatory, or infringing content</Li><Li>Attempt to gain unauthorised access to any system or data</Li><Li>Scrape or harvest data without written permission</Li><Li>Use the Service to distribute spam or malicious code</Li></Box>
    </Section>
    <Section title="3. User Content">
      <P>You retain ownership of content you create. By uploading content you grant {COMPANY_NAME} a non-exclusive, worldwide, royalty-free licence to host and display it for the purpose of providing the Service.</P>
    </Section>
    <Section title="4. Account Responsibility">
      <P>You are responsible for maintaining the security of your account credentials. Notify us immediately at {CONTACT_EMAIL} if you suspect unauthorised access.</P>
    </Section>
    <Section title="5. Public Boards">
      <P>If you make a board public, its content becomes accessible to anyone with the URL. Review your content before making it public. {COMPANY_NAME} is not responsible for the content of public boards.</P>
    </Section>
    <Section title="6. Termination">
      <P>We reserve the right to suspend or terminate accounts that violate these terms, at our sole discretion, without prior notice.</P>
    </Section>
    <Section title="7. Limitation of Liability">
      <P>The Service is provided "as is". {COMPANY_NAME} shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.</P>
    </Section>
    <Section title="8. Changes to Terms">
      <P>We may update these terms from time to time. Continued use of the Service after changes constitutes acceptance of the new terms.</P>
    </Section>
    <Section title="9. Contact">
      <P>For questions about these terms: <Typography component="a" href={`mailto:${CONTACT_EMAIL}`} sx={{ color: '#3b82f6' }}>{CONTACT_EMAIL}</Typography></P>
    </Section>
  </CorporateLayout>
);

// ── GDPR / Privacy Policy ─────────────────────────────────────────────────────
const GDPRPage: React.FC = () => (
  <CorporateLayout title="Privacy Policy (GDPR)" subtitle="We are committed to protecting your personal data and your rights under the General Data Protection Regulation.">
    <Section title="1. Data Controller">
      <P>{COMPANY_NAME} is the data controller for personal data processed through {APP_URL}. Contact: <Typography component="a" href={`mailto:${CONTACT_EMAIL}`} sx={{ color: '#3b82f6' }}>{CONTACT_EMAIL}</Typography></P>
    </Section>
    <Section title="2. Data We Collect">
      <Box component="ul">
        <Li><strong>Account data:</strong> email address, username, display name — collected during registration via Clerk.</Li>
        <Li><strong>Profile data:</strong> bio, location, organisation, website — provided voluntarily.</Li>
        <Li><strong>Content data:</strong> boards, sources, notes, uploaded files you create.</Li>
        <Li><strong>Usage data:</strong> page views, feature usage, error logs — collected anonymously.</Li>
        <Li><strong>Technical data:</strong> IP address, browser type, session tokens — for security.</Li>
      </Box>
    </Section>
    <Section title="3. Legal Basis for Processing">
      <Box component="ul">
        <Li><strong>Contract performance:</strong> to provide the Service you signed up for.</Li>
        <Li><strong>Consent:</strong> for public profile information and optional features.</Li>
        <Li><strong>Legitimate interest:</strong> for security monitoring and service improvement.</Li>
        <Li><strong>Legal obligation:</strong> where required by applicable law.</Li>
      </Box>
    </Section>
    <Section title="4. Data Retention">
      <P>Account and content data is retained for as long as your account is active. Upon account deletion, personal data is removed within 30 days except where legal obligations require longer retention.</P>
    </Section>
    <Section title="5. Your Rights (GDPR)">
      <P>Under GDPR you have the right to:</P>
      <Box component="ul">
        <Li>Access the personal data we hold about you</Li><Li>Correct inaccurate data</Li><Li>Request erasure ("right to be forgotten")</Li>
        <Li>Restrict or object to processing</Li><Li>Data portability</Li><Li>Withdraw consent at any time</Li>
      </Box>
      <P>Exercise any right by visiting our <Typography component="a" href="/optout/" sx={{ color: '#3b82f6' }}>opt-out page</Typography> or emailing {CONTACT_EMAIL}.</P>
    </Section>
    <Section title="6. Cookies">
      <P>We use strictly necessary cookies for authentication and session management. We do not use tracking or advertising cookies.</P>
    </Section>
    <Section title="7. Third-Party Services">
      <P>We use Clerk for authentication. Clerk processes your email address and authentication tokens under their own privacy policy. We do not sell your data to third parties.</P>
    </Section>
    <Section title="8. International Transfers">
      <P>Data may be processed on servers located in the EU and US. Where data is transferred outside the EEA we ensure adequate safeguards are in place.</P>
    </Section>
    <Section title="9. Updates">
      <P>We will notify registered users of material changes to this policy by email. The "last updated" date at the top of this page reflects the current version.</P>
    </Section>
  </CorporateLayout>
);

// ── Opt-out / Data Deletion Page ──────────────────────────────────────────────
const OptOutPage: React.FC = () => {
  const [form, setForm] = useState({ email: '', request: 'delete', notes: '' });
  const [sent, setSent] = useState(false);
  const handleSubmit = async () => {
    await fetch(`${API_BASE}/privacy/request`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) }).catch(() => {});
    setSent(true);
  };
  return (
    <CorporateLayout title="Privacy Opt-out & Data Requests" subtitle="Exercise your GDPR rights. Submit a request below and we will respond within 30 days.">
      <Section title="Your Options">
        <Box component="ul">
          <Li><strong>Delete my account and all data</strong> — permanently removes your account, boards, sources and files.</Li>
          <Li><strong>Export my data</strong> — receive a copy of all data we hold about you.</Li>
          <Li><strong>Correct my data</strong> — request corrections to inaccurate personal data.</Li>
          <Li><strong>Restrict processing</strong> — limit how we use your data while retaining your account.</Li>
        </Box>
      </Section>
      {sent ? (
        <Box sx={{ p: 3, borderRadius: '10px', bgcolor: '#f0fdf4', border: '1px solid #86efac', textAlign: 'center' }}>
          <Typography fontSize={16} fontWeight={700} color="#16a34a">✓ Request received</Typography>
          <Typography fontSize={13} color="#166534" sx={{ mt: 0.5 }}>We will respond to <strong>{form.email}</strong> within 30 days.</Typography>
        </Box>
      ) : (
        <Box sx={{ bgcolor: '#E3E3DF', p: 3, borderRadius: '12px', border: '1px solid #e2e8f0' }}>
          <TextField fullWidth label="Your email address" size="small" sx={{ mb: 2 }}
            value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
          <TextField select fullWidth label="Request type" size="small" sx={{ mb: 2 }}
            value={form.request} onChange={e => setForm(p => ({ ...p, request: e.target.value }))} SelectProps={{ native: true }}>
            <option value="delete">Delete my account and all data</option>
            <option value="export">Export my data</option>
            <option value="correct">Correct my data</option>
            <option value="restrict">Restrict processing</option>
          </TextField>
          <TextField fullWidth label="Additional notes (optional)" size="small" multiline rows={3} sx={{ mb: 2 }}
            value={form.notes} onChange={e => setForm(p => ({ ...p, notes: e.target.value }))} />
          <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
            By submitting you confirm this is your own account. We will verify your identity before acting on the request.
          </Typography>
          <Button variant="contained" onClick={handleSubmit} disabled={!form.email}>Submit Request</Button>
        </Box>
      )}
    </CorporateLayout>
  );
};

type DismissSite = {
  id: number; domain: string; selector: string;
  click_x: number | null; click_y: number | null;
  viewport_width: number; double_click: number;
  wait_before_ms: number; wait_after_ms: number;
  notes: string; enabled: number;
  created_at: string; updated_at: string;
};
// ▓▓▓▓▓ ADMIN UI ▓▓▓▓▓
const DismissSitesTab: React.FC<{ apiHeaders: () => Record<string, string>; isDark: boolean }> = ({ apiHeaders, isDark }) => {
  const [sites, setSites] = useState<DismissSite[]>([]);
  const [loading, setLoading] = useState(true);
  const [snack, setSnack] = useState('');
  const [editorOpen, setEditorOpen] = useState(false);
  const [editorMode, setEditorMode] = useState<'add'|'edit'>('add');
  const [editorId, setEditorId] = useState<number | null>(null);
  const [editorDomain, setEditorDomain] = useState('');
  const [editorSelector, setEditorSelector] = useState('');
  const [editorClickX, setEditorClickX] = useState<number | null>(null);
  const [editorClickY, setEditorClickY] = useState<number | null>(null);
  const [editorVpWidth, setEditorVpWidth] = useState(1024);
  const [editorDoubleClick, setEditorDoubleClick] = useState(false);
  const [editorWaitBefore, setEditorWaitBefore] = useState(2500);
  const [editorWaitAfter, setEditorWaitAfter] = useState(800);
  const [editorNotes, setEditorNotes] = useState('');
  const [editorEnabled, setEditorEnabled] = useState(true);
  const [testUrl, setTestUrl] = useState('');
  const [testStatus, setTestStatus] = useState<'idle'|'capturing'|'done'|'error'>('idle');
  const [testResult, setTestResult] = useState<any>(null);
  const [testError, setTestError] = useState('');
  const [testWithConfig, setTestWithConfig] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState<number | null>(null);

  const hdrs = apiHeaders();
  const loadSites = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/admin/dismiss-sites`, { headers: hdrs });
      if (r.ok) { const d = await r.json(); setSites(d.sites || []); }
    } catch {}
    setLoading(false);
  };
  useEffect(() => { loadSites(); }, []);

  const resetEditor = () => {
    setEditorId(null); setEditorDomain(''); setEditorSelector('');
    setEditorClickX(null); setEditorClickY(null);
    setEditorVpWidth(1024); setEditorDoubleClick(false);
    setEditorWaitBefore(2500); setEditorWaitAfter(800);
    setEditorNotes(''); setEditorEnabled(true);
    setTestUrl(''); setTestStatus('idle'); setTestResult(null); setTestError(''); setTestWithConfig(false);
  };
  const openAdd = () => { resetEditor(); setEditorMode('add'); setEditorOpen(true); };
  const openEdit = (s: DismissSite) => {
    resetEditor();
    setEditorMode('edit'); setEditorId(s.id);
    setEditorDomain(s.domain); setEditorSelector(s.selector || '');
    setEditorClickX(s.click_x); setEditorClickY(s.click_y);
    setEditorVpWidth(s.viewport_width || 1024);
    setEditorDoubleClick(!!s.double_click);
    setEditorWaitBefore(s.wait_before_ms ?? 2500);
    setEditorWaitAfter(s.wait_after_ms ?? 800);
    setEditorNotes(s.notes || '');
    setEditorEnabled(!!s.enabled);
    setTestUrl(s.domain ? `https://${s.domain}` : '');
    setEditorOpen(true);
  };

  const extractDomain = (raw: string) => {
    try {
      const u = new URL(raw.startsWith('http') ? raw : `https://${raw}`);
      return u.hostname.toLowerCase().replace(/^www\./, '');
    } catch { return raw.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/.*$/, '').toLowerCase(); }
  };

  const runCapture = async (withConfig: boolean) => {
    if (!testUrl || !testUrl.startsWith('http')) { setTestError('Enter a URL starting with http(s)://'); return; }
    setTestStatus('capturing'); setTestError(''); setTestResult(null); setTestWithConfig(withConfig);
    try {
      const body: any = { url: testUrl, scrollTime: 0, browser: 'auto', viewportWidth: editorVpWidth };
      if (withConfig) {
        if (editorSelector) body.testSelector = editorSelector;
        if (editorClickX != null && editorClickY != null) {
          body.testClickPosition = { x: editorClickX, y: editorClickY };
        }
        body.testDoubleClick = editorDoubleClick;
        body.testViewportWidth = editorVpWidth;
      }
      const r = await fetch(`${API_BASE}/archive-url`, { method: 'POST', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const data = await r.json().catch(() => null);
      if (!data || !data.ok) { setTestError(data?.details || data?.error || `Server error ${r.status}`); setTestStatus('error'); return; }
      setTestResult(data); setTestStatus('done');
      if (!editorDomain) setEditorDomain(extractDomain(testUrl));
    } catch (e: any) { setTestError(e.message || 'Capture failed'); setTestStatus('error'); }
  };

  const saveSite = async () => {
    const dom = extractDomain(editorDomain);
    if (!dom) { setSnack('Domain is required'); return; }
    if (!editorSelector && (editorClickX == null || editorClickY == null)) {
      setSnack('Provide a CSS selector or click coordinates'); return;
    }
    const payload = {
      domain: dom, selector: editorSelector,
      click_x: editorClickX, click_y: editorClickY,
      viewport_width: editorVpWidth,
      double_click: editorDoubleClick,
      wait_before_ms: editorWaitBefore,
      wait_after_ms: editorWaitAfter,
      notes: editorNotes, enabled: editorEnabled,
    };
    try {
      const url = editorMode === 'add' ? `${API_BASE}/admin/dismiss-sites` : `${API_BASE}/admin/dismiss-sites/${editorId}`;
      const method = editorMode === 'add' ? 'POST' : 'PUT';
      const r = await fetch(url, { method, headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const data = await r.json().catch(() => null);
      if (!r.ok) { setSnack(data?.error || 'Save failed'); return; }
      setSnack(`Saved rule for ${dom}`);
      setEditorOpen(false);
      loadSites();
    } catch (e: any) { setSnack(e.message || 'Save failed'); }
  };

  const deleteSite = async (id: number) => {
    try {
      const r = await fetch(`${API_BASE}/admin/dismiss-sites/${id}`, { method: 'DELETE', headers: hdrs });
      if (r.ok) { setSnack('Rule deleted'); loadSites(); }
      else setSnack('Delete failed');
    } catch { setSnack('Delete failed'); }
    setDeleteConfirmId(null);
  };

  const handleScreenshotClick = (e: React.MouseEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    const rect = img.getBoundingClientRect();
    const x = Math.round((e.clientX - rect.left) * (editorVpWidth / rect.width));
    const y = Math.round((e.clientY - rect.top) * (editorVpWidth / rect.width));
    setEditorClickX(x); setEditorClickY(y);
  };

  const previewUrl = testResult?.screenshotUrl || testResult?.previewUrl;
  const TIME_PRESETS = [{label:'1s',v:1000},{label:'2.5s',v:2500},{label:'5s',v:5000}];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography fontWeight={700} fontSize={14} sx={{ mb: 0.5 }}>Per-Site Cookie/Popup Dismiss Rules</Typography>
          <Typography fontSize={11} color="text.secondary" sx={{ maxWidth: 720 }}>
            When a user archives a URL, the server matches the URL's domain against this list and applies the saved rule
            to dismiss cookie banners or popups. Rules are tried selector-first, then by coordinate click.
            Sub-domains inherit from parent domains (e.g. <code>news.bbc.co.uk</code> uses the rule for <code>bbc.co.uk</code>).
          </Typography>
        </Box>
        <Button size="small" variant="contained" startIcon={<AddIcon sx={{ fontSize: 16 }} />} onClick={openAdd}
          sx={{ bgcolor: '#3b82f6', textTransform: 'none', fontWeight: 600, fontSize: 12, '&:hover': { bgcolor: '#2563eb' } }}>
          Add Site
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress size={24} /></Box>
      ) : sites.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 6, color: 'text.disabled', border: '1px dashed', borderColor: 'divider', borderRadius: '8px' }}>
          <LanguageIcon sx={{ fontSize: 40, opacity: 0.3, mb: 1 }} />
          <Typography fontSize={13} fontWeight={600} color="text.secondary">No dismiss rules yet</Typography>
          <Typography fontSize={11} color="text.disabled" sx={{ mt: 0.5 }}>Click "Add Site" above to create your first rule.</Typography>
        </Box>
      ) : (
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)' }}>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1 }}>Domain</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1 }}>Method</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 90 }}>Viewport</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 70, textAlign: 'center' }}>×2</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 70, textAlign: 'center' }}>Enabled</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 130 }}>Updated</TableCell>
                <TableCell sx={{ width: 90 }} />
              </TableRow>
            </TableHead>
            <TableBody>
              {sites.map(s => (
                <TableRow key={s.id} hover sx={{ '&:last-child td': { borderBottom: 0 }, opacity: s.enabled ? 1 : 0.5 }}>
                  <TableCell sx={{ fontSize: 12, fontFamily: 'monospace', fontWeight: 600 }}>{s.domain}</TableCell>
                  <TableCell sx={{ fontSize: 11 }}>
                    {s.selector ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Chip size="small" label="selector" sx={{ fontSize: 9, height: 18, bgcolor: 'rgba(16,185,129,0.15)', color: '#10b981' }} />
                        <Typography fontSize={11} sx={{ fontFamily: 'monospace', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 240 }}>{s.selector}</Typography>
                      </Box>
                    ) : (s.click_x != null && s.click_y != null) ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Chip size="small" label="coords" sx={{ fontSize: 9, height: 18, bgcolor: 'rgba(249,115,22,0.15)', color: '#f97316' }} />
                        <Typography fontSize={11} sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>({s.click_x}, {s.click_y})</Typography>
                      </Box>
                    ) : <Typography fontSize={11} color="text.disabled">—</Typography>}
                  </TableCell>
                  <TableCell sx={{ fontSize: 11, fontFamily: 'monospace', color: 'text.secondary' }}>{s.viewport_width}px</TableCell>
                  <TableCell sx={{ textAlign: 'center', fontSize: 11 }}>{s.double_click ? '✓' : ''}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    {s.enabled ? <CheckCircleIcon sx={{ fontSize: 16, color: '#10b981' }} /> : <Box sx={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', bgcolor: 'text.disabled' }} />}
                  </TableCell>
                  <TableCell sx={{ fontSize: 10, color: 'text.disabled' }}>{s.updated_at ? formatTimestamp(s.updated_at, DEFAULT_SETTINGS) : '—'}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.3 }}>
                      <Tooltip title="Edit"><IconButton size="small" onClick={() => openEdit(s)} sx={{ width: 24, height: 24 }}><EditIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                      <Tooltip title="Delete"><IconButton size="small" onClick={() => setDeleteConfirmId(s.id)} sx={{ width: 24, height: 24, '&:hover': { color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}

      <Dialog open={editorOpen} onClose={() => setEditorOpen(false)} maxWidth="lg" fullWidth disableScrollLock
        PaperProps={{ sx: { borderRadius: '12px', height: '88vh', display: 'flex', flexDirection: 'column' } }}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Box>
            <Typography fontWeight={700} fontSize={15}>{editorMode === 'add' ? 'New Dismiss Rule' : `Edit Rule: ${editorDomain}`}</Typography>
            <Typography fontSize={11} color="text.secondary">Capture a screenshot, click on the cookie button, save the coordinates and/or a CSS selector.</Typography>
          </Box>
          <IconButton onClick={() => setEditorOpen(false)} size="small"><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}>
          <Box sx={{ width: 360, flexShrink: 0, p: 2.5, overflow: 'auto', borderRight: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <TextField label="Domain" size="small" fullWidth value={editorDomain} onChange={e => setEditorDomain(e.target.value)}
              helperText='e.g. "bbc.com" — sub-domains will inherit'
              InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace' } }} InputLabelProps={{ sx: { fontSize: 12 } }} />
            <TextField label="CSS selector (preferred)" size="small" fullWidth value={editorSelector} onChange={e => setEditorSelector(e.target.value)}
              helperText="Most reliable. Tried first; coords used as fallback."
              placeholder='e.g. button[data-test="accept-cookies"]'
              InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace' } }} InputLabelProps={{ sx: { fontSize: 12 } }} />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField label="Click X" size="small" type="number" value={editorClickX ?? ''} onChange={e => setEditorClickX(e.target.value === '' ? null : parseInt(e.target.value, 10))}
                InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace' } }} InputLabelProps={{ sx: { fontSize: 12 } }} sx={{ flex: 1 }} />
              <TextField label="Click Y" size="small" type="number" value={editorClickY ?? ''} onChange={e => setEditorClickY(e.target.value === '' ? null : parseInt(e.target.value, 10))}
                InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace' } }} InputLabelProps={{ sx: { fontSize: 12 } }} sx={{ flex: 1 }} />
            </Box>
            <Box>
              <Typography fontSize={11} fontWeight={600} sx={{ mb: 0.5 }}>Viewport width (coordinates are scaled at runtime)</Typography>
              <ToggleButtonGroup value={editorVpWidth} exclusive onChange={(_, v) => { if (v) setEditorVpWidth(v); }} size="small" sx={{ '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 11, px: 2 } }}>
                <ToggleButton value={1024}>1024</ToggleButton>
                <ToggleButton value={1280}>1280</ToggleButton>
                <ToggleButton value={1920}>1920</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <FormControlLabel control={<Checkbox size="small" checked={editorDoubleClick} onChange={e => setEditorDoubleClick(e.target.checked)} />}
              label={<Typography fontSize={12}>Click twice (some banners need a second confirm)</Typography>} />
            <Box>
              <Typography fontSize={11} fontWeight={600} sx={{ mb: 0.5 }}>Wait before click: {(editorWaitBefore/1000).toFixed(1)}s</Typography>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {TIME_PRESETS.map(p => <Chip key={p.v} size="small" label={p.label} clickable onClick={() => setEditorWaitBefore(p.v)} variant={editorWaitBefore === p.v ? 'filled' : 'outlined'} sx={{ fontSize: 10, height: 22 }} />)}
                <TextField size="small" type="number" value={editorWaitBefore} onChange={e => setEditorWaitBefore(parseInt(e.target.value, 10) || 0)} sx={{ width: 80 }} InputProps={{ sx: { fontSize: 11, height: 24 } }} />
              </Box>
            </Box>
            <Box>
              <Typography fontSize={11} fontWeight={600} sx={{ mb: 0.5 }}>Wait after click: {(editorWaitAfter/1000).toFixed(1)}s</Typography>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {[{label:'0.5s',v:500},{label:'0.8s',v:800},{label:'1.5s',v:1500}].map(p => <Chip key={p.v} size="small" label={p.label} clickable onClick={() => setEditorWaitAfter(p.v)} variant={editorWaitAfter === p.v ? 'filled' : 'outlined'} sx={{ fontSize: 10, height: 22 }} />)}
                <TextField size="small" type="number" value={editorWaitAfter} onChange={e => setEditorWaitAfter(parseInt(e.target.value, 10) || 0)} sx={{ width: 80 }} InputProps={{ sx: { fontSize: 11, height: 24 } }} />
              </Box>
            </Box>
            <TextField label="Notes" size="small" fullWidth multiline minRows={2} value={editorNotes} onChange={e => setEditorNotes(e.target.value)}
              InputProps={{ sx: { fontSize: 12 } }} InputLabelProps={{ sx: { fontSize: 12 } }} />
            <FormControlLabel control={<Switch size="small" checked={editorEnabled} onChange={e => setEditorEnabled(e.target.checked)} />}
              label={<Typography fontSize={12}>Enabled</Typography>} />
            <Box sx={{ display: 'flex', gap: 1, mt: 'auto', pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
              <Button size="small" onClick={() => setEditorOpen(false)} sx={{ textTransform: 'none' }}>Cancel</Button>
              <Box sx={{ flex: 1 }} />
              <Button size="small" variant="contained" onClick={saveSite} sx={{ bgcolor: '#3b82f6', textTransform: 'none', fontWeight: 600 }}>
                {editorMode === 'add' ? 'Create Rule' : 'Save Changes'}
              </Button>
            </Box>
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, bgcolor: '#1e293b' }}>
            <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid rgba(255,255,255,0.08)', flexWrap: 'wrap' }}>
              <TextField size="small" placeholder="https://www.bbc.com/news" fullWidth value={testUrl} onChange={e => setTestUrl(e.target.value)}
                sx={{ minWidth: 240, flex: 1, '& .MuiOutlinedInput-root': { bgcolor: 'rgba(255,255,255,0.06)', color: '#e2e8f0', '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' } } }}
                InputProps={{ sx: { fontSize: 12, fontFamily: 'monospace' } }} />
              <Button size="small" variant="contained" disabled={testStatus === 'capturing' || !testUrl.startsWith('http')} onClick={() => runCapture(false)}
                sx={{ bgcolor: '#f97316', textTransform: 'none', fontWeight: 600, fontSize: 11, '&:hover': { bgcolor: '#ea580c' } }}>
                {testStatus === 'capturing' && !testWithConfig ? 'Capturing…' : 'Capture'}
              </Button>
              <Button size="small" variant="outlined" disabled={testStatus === 'capturing' || !testUrl.startsWith('http') || (!editorSelector && (editorClickX == null || editorClickY == null))} onClick={() => runCapture(true)}
                sx={{ textTransform: 'none', fontSize: 11, color: '#10b981', borderColor: 'rgba(16,185,129,0.4)' }}>
                {testStatus === 'capturing' && testWithConfig ? 'Testing…' : 'Test config'}
              </Button>
              {(editorClickX != null && editorClickY != null) && <Chip size="small" label={`x: ${editorClickX}  y: ${editorClickY}`} onDelete={() => { setEditorClickX(null); setEditorClickY(null); }}
                sx={{ fontSize: 10, height: 22, bgcolor: 'rgba(249,115,22,0.15)', color: '#f97316', fontFamily: 'monospace', fontWeight: 700 }} />}
            </Box>
            <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', p: 2,
              '&::-webkit-scrollbar': { width: 10, height: 10 },
              '&::-webkit-scrollbar-track': { bgcolor: 'rgba(0,0,0,0.2)' },
              '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 5, '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } } }}>
              {testStatus === 'idle' && (
                <Box sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', mt: 6 }}>
                  <PhotoCameraIcon sx={{ fontSize: 56, opacity: 0.3, mb: 1.5 }} />
                  <Typography fontSize={13} fontWeight={600}>Capture a screenshot to start</Typography>
                  <Typography fontSize={11} sx={{ maxWidth: 360, mx: 'auto', mt: 0.5, color: 'rgba(255,255,255,0.4)' }}>Enter the URL above and click <strong>Capture</strong>. Then click on the cookie banner button in the screenshot to record its coordinates.</Typography>
                </Box>
              )}
              {testStatus === 'capturing' && (
                <Box sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.6)', mt: 6 }}>
                  <CircularProgress size={32} sx={{ color: '#f97316', mb: 2 }} />
                  <Typography fontSize={13} fontWeight={600}>{testWithConfig ? 'Testing dismiss config…' : 'Capturing screenshot…'}</Typography>
                </Box>
              )}
              {testStatus === 'error' && (
                <Box sx={{ textAlign: 'center', color: '#fca5a5', mt: 6, px: 3 }}>
                  <WarningIcon sx={{ fontSize: 40, mb: 1 }} />
                  <Typography fontSize={13} fontWeight={700}>Capture failed</Typography>
                  <Typography fontSize={11} sx={{ mt: 0.5, color: 'rgba(255,255,255,0.5)' }}>{testError}</Typography>
                </Box>
              )}
              {testStatus === 'done' && previewUrl && (
                <Box sx={{ position: 'relative', flexShrink: 0, lineHeight: 0, fontSize: 0 }}>
                  <img src={previewUrl} alt="Screenshot" draggable={false}
                    style={{ display: 'block', width: editorVpWidth, maxWidth: '100%', userSelect: 'none', cursor: 'crosshair', boxShadow: '0 4px 24px rgba(0,0,0,0.4)' }}
                    onClick={handleScreenshotClick} />
                  {editorClickX != null && editorClickY != null && (() => {
                    const markerX = editorClickX;
                    const markerY = editorClickY;
                    return (
                      <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', overflow: 'visible' }}>
                        <line x1="0" y1={markerY} x2="100%" y2={markerY} stroke="#f97316" strokeWidth="1" opacity="0.4" strokeDasharray="6,4" />
                        <line x1={markerX} y1="0" x2={markerX} y2="100%" stroke="#f97316" strokeWidth="1" opacity="0.4" strokeDasharray="6,4" />
                        <line x1={markerX - 20} y1={markerY} x2={markerX - 6} y2={markerY} stroke="#f97316" strokeWidth="2.5" />
                        <line x1={markerX + 6} y1={markerY} x2={markerX + 20} y2={markerY} stroke="#f97316" strokeWidth="2.5" />
                        <line x1={markerX} y1={markerY - 20} x2={markerX} y2={markerY - 6} stroke="#f97316" strokeWidth="2.5" />
                        <line x1={markerX} y1={markerY + 6} x2={markerX} y2={markerY + 20} stroke="#f97316" strokeWidth="2.5" />
                        <circle cx={markerX} cy={markerY} r="14" fill="none" stroke="#f97316" strokeWidth="2" />
                        <circle cx={markerX} cy={markerY} r="2.5" fill="#f97316" />
                        <rect x={markerX + 18} y={markerY - 24} width="92" height="18" rx="4" fill="rgba(0,0,0,0.85)" />
                        <text x={markerX + 22} y={markerY - 11} fill="#f97316" fontSize="11" fontFamily="monospace" fontWeight="bold">{editorClickX}, {editorClickY}</text>
                      </svg>
                    );
                  })()}
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={deleteConfirmId != null} onClose={() => setDeleteConfirmId(null)} disableScrollLock PaperProps={{ sx: { borderRadius: '12px' } }}>
        <Box sx={{ p: 3, textAlign: 'center', minWidth: 320 }}>
          <Typography fontWeight={700} sx={{ mb: 1, color: '#ef4444' }}>Delete this rule?</Typography>
          <Typography fontSize={12} color="text.secondary" sx={{ mb: 2 }}>
            {(() => { const s = sites.find(x => x.id === deleteConfirmId); return s ? `Domain: ${s.domain}` : ''; })()}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button variant="outlined" onClick={() => setDeleteConfirmId(null)} size="small">Cancel</Button>
            <Button variant="contained" color="error" onClick={() => deleteConfirmId != null && deleteSite(deleteConfirmId)} size="small">Delete</Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar open={!!snack} autoHideDuration={3500} onClose={() => setSnack('')} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="info" onClose={() => setSnack('')} sx={{ fontSize: 12 }}>{snack}</Alert>
      </Snackbar>
    </Box>
  );
};

const TranslationsAdmin: React.FC<{ apiHeaders: () => Record<string, string>; setSnack: (msg: string) => void }> = ({ apiHeaders, setSnack }) => {
  const [keys, setKeys] = useState<{ key: string; values: Record<string, string> }[]>([]);
  const [languages, setLanguages] = useState<string[]>(['en', 'sv', 'es', 'fr', 'de', 'pt']);
  const [labels, setLabels] = useState<Record<string, string>>({ en: 'English', sv: 'Svenska', es: 'Español', fr: 'Français', de: 'Deutsch', pt: 'Português' });
  const [filter, setFilter] = useState('');
  const [editing, setEditing] = useState<Record<string, Record<string, string>>>({});
  const [savingLang, setSavingLang] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newKey, setNewKey] = useState('');
  const [newEn, setNewEn] = useState('');
  const [deleteConfirmKey, setDeleteConfirmKey] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/admin/translations`, { headers: apiHeaders() });
      if (r.ok) {
        const d = await r.json();
        if (Array.isArray(d.languages)) setLanguages(d.languages);
        if (d.labels) setLabels(d.labels);
        if (Array.isArray(d.keys)) setKeys(d.keys);
        setEditing({});
      } else {
        setSnack('Failed to load translations');
      }
    } catch { setSnack('Failed to load translations'); }
    setLoading(false);
  }, [apiHeaders, setSnack]);

  React.useEffect(() => { load(); }, [load]);

  const cellValue = (k: string, lang: string): string => {
    if (editing[k] && editing[k][lang] != null) return editing[k][lang];
    const row = keys.find(r => r.key === k);
    return row?.values[lang] || '';
  };

  const setCellValue = (k: string, lang: string, v: string) => {
    setEditing(prev => ({ ...prev, [k]: { ...(prev[k] || {}), [lang]: v } }));
  };

  const hasEditsForLang = (lang: string): boolean => {
    for (const k of Object.keys(editing)) {
      if (editing[k][lang] != null) {
        const row = keys.find(r => r.key === k);
        if ((row?.values[lang] || '') !== editing[k][lang]) return true;
      }
    }
    return false;
  };

  const saveLanguage = async (lang: string) => {
    const updates: Record<string, string> = {};
    for (const k of Object.keys(editing)) {
      if (editing[k][lang] != null) {
        const row = keys.find(r => r.key === k);
        if ((row?.values[lang] || '') !== editing[k][lang]) {
          updates[k] = editing[k][lang];
        }
      }
    }
    const count = Object.keys(updates).length;
    if (count === 0) { setSnack('No changes to save'); return; }
    setSavingLang(lang);
    try {
      const r = await fetch(`${API_BASE}/admin/translations`, {
        method: 'PUT',
        headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ language: lang, updates }),
      });
      if (r.ok) {
        setSnack(`Saved ${count} translation${count === 1 ? '' : 's'} for ${labels[lang] || lang}`);
        setEditing(prev => {
          const next: typeof prev = {};
          for (const k of Object.keys(prev)) {
            const remaining: Record<string, string> = { ...prev[k] };
            delete remaining[lang];
            if (Object.keys(remaining).length > 0) next[k] = remaining;
          }
          return next;
        });
        load();
      } else {
        setSnack('Failed to save translations');
      }
    } catch { setSnack('Failed to save translations'); }
    setSavingLang(null);
  };

  const addKey = async () => {
    if (!newKey.trim() || !newEn.trim()) { setSnack('Key and English value are required'); return; }
    try {
      const r = await fetch(`${API_BASE}/admin/translations/key`, {
        method: 'POST',
        headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: newKey.trim(), en: newEn.trim() }),
      });
      if (r.ok) {
        setSnack(`Added key "${newKey.trim()}"`);
        setNewKey('');
        setNewEn('');
        setAddDialogOpen(false);
        load();
      } else {
        const d = await r.json().catch(() => ({}));
        setSnack(d.error || 'Failed to add key');
      }
    } catch { setSnack('Failed to add key'); }
  };

  const deleteKey = async (k: string) => {
    try {
      const r = await fetch(`${API_BASE}/admin/translations/key/${encodeURIComponent(k)}`, {
        method: 'DELETE',
        headers: apiHeaders(),
      });
      if (r.ok) {
        setSnack(`Deleted key "${k}"`);
        setDeleteConfirmKey(null);
        load();
      } else {
        setSnack('Failed to delete key');
      }
    } catch { setSnack('Failed to delete key'); }
  };

  const filtered = filter.trim()
    ? keys.filter(k => {
        const f = filter.toLowerCase();
        if (k.key.toLowerCase().includes(f)) return true;
        for (const lang of languages) {
          const v = cellValue(k.key, lang).toLowerCase();
          if (v.includes(f)) return true;
        }
        return false;
      })
    : keys;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        <Typography fontWeight={700} fontSize={15}>Translations</Typography>
        <Chip size="small" label={`${keys.length} keys`} sx={{ fontSize: 10, height: 20 }} />
        <Box sx={{ flex: 1 }} />
        <TextField size="small" placeholder="Search keys or values…" value={filter}
          onChange={(e) => setFilter(e.target.value)}
          InputProps={{ startAdornment: <SearchIcon sx={{ fontSize: 14, mr: 0.5, color: 'text.disabled' }} />, sx: { fontSize: 12, height: 32 } }}
          sx={{ width: 240 }} />
        <Button size="small" variant="outlined" startIcon={<AddIcon sx={{ fontSize: 14 }} />}
          onClick={() => setAddDialogOpen(true)}
          sx={{ textTransform: 'none', fontSize: 11, height: 32 }}>
          Add key
        </Button>
      </Box>
      <Typography fontSize={11} color="text.secondary" sx={{ mb: 1.5 }}>
        Edit cells inline; click "Save (lang)" to commit changes for that language. Empty non-English values fall back to English on the public side.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.7, mb: 1.5 }}>
        {languages.map(lang => {
          const dirty = hasEditsForLang(lang);
          return (
            <Button key={lang} size="small" variant={dirty ? 'contained' : 'outlined'}
              disabled={!dirty || savingLang === lang}
              onClick={() => saveLanguage(lang)}
              sx={{ textTransform: 'none', fontSize: 11, height: 28 }}>
              {savingLang === lang ? <CircularProgress size={12} sx={{ color: 'inherit' }} /> : `Save ${labels[lang] || lang}${dirty ? ' *' : ''}`}
            </Button>
          );
        })}
      </Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={24} /></Box>
      ) : (
        <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 280px)', border: '1px solid', borderColor: 'divider', borderRadius: '8px' }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: `220px repeat(${languages.length}, minmax(180px, 1fr)) 36px`, fontSize: 11 }}>
            <Box sx={{ position: 'sticky', top: 0, bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider', px: 1, py: 0.7, fontWeight: 700, zIndex: 1 }}>Key</Box>
            {languages.map(lang => (
              <Box key={lang} sx={{ position: 'sticky', top: 0, bgcolor: 'background.paper', borderBottom: '1px solid', borderLeft: '1px solid', borderColor: 'divider', px: 1, py: 0.7, fontWeight: 700, zIndex: 1 }}>
                {labels[lang] || lang}
              </Box>
            ))}
            <Box sx={{ position: 'sticky', top: 0, bgcolor: 'background.paper', borderBottom: '1px solid', borderLeft: '1px solid', borderColor: 'divider', zIndex: 1 }} />

            {filtered.map((row, idx) => (
              <React.Fragment key={row.key}>
                <Box sx={{ px: 1, py: 0.6, borderBottom: idx === filtered.length - 1 ? 0 : '1px solid', borderColor: 'divider', fontFamily: 'monospace', fontSize: 10.5, color: 'text.secondary', display: 'flex', alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <Tooltip title={row.key} placement="top-start">
                    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.key}</Box>
                  </Tooltip>
                </Box>
                {languages.map(lang => {
                  const original = row.values[lang] || '';
                  const current = cellValue(row.key, lang);
                  const dirty = current !== original;
                  return (
                    <Box key={lang} sx={{ px: 0.5, py: 0.4, borderLeft: '1px solid', borderColor: 'divider', borderBottom: idx === filtered.length - 1 ? 0 : '1px solid' }}>
                      <TextField size="small" fullWidth multiline maxRows={4} value={current}
                        onChange={(e) => setCellValue(row.key, lang, e.target.value)}
                        InputProps={{ sx: { fontSize: 11, py: 0, bgcolor: dirty ? 'rgba(245,158,11,0.08)' : 'transparent', '& textarea': { py: 0.4 } } }}
                        placeholder={lang !== 'en' ? row.values.en || '(English missing)' : '(empty)'} />
                    </Box>
                  );
                })}
                <Box sx={{ borderLeft: '1px solid', borderColor: 'divider', borderBottom: idx === filtered.length - 1 ? 0 : '1px solid', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Tooltip title="Delete this key for all languages">
                    <IconButton size="small" onClick={() => setDeleteConfirmKey(row.key)} sx={{ width: 24, height: 24 }}>
                      <DeleteIcon sx={{ fontSize: 13, color: 'text.disabled' }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </React.Fragment>
            ))}
            {filtered.length === 0 && (
              <Box sx={{ gridColumn: `1 / span ${languages.length + 2}`, py: 4, textAlign: 'center', color: 'text.disabled', fontSize: 12 }}>
                {filter.trim() ? 'No matches' : 'No translations yet'}
              </Box>
            )}
          </Box>
        </Box>
      )}

      <Dialog disableScrollLock open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add translation key</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: '16px !important' }}>
          <TextField size="small" label="Key" value={newKey} onChange={(e) => setNewKey(e.target.value)}
            placeholder="e.g. dash.recent" autoFocus
            helperText='Use dot-namespaced ids like "common.save" or "settings.section.profile".' />
          <TextField size="small" label="English value" value={newEn} onChange={(e) => setNewEn(e.target.value)}
            placeholder="e.g. Recent boards"
            helperText="English is required; other languages can be filled in via the table after the key is created." />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setAddDialogOpen(false)} sx={{ textTransform: 'none' }}>Cancel</Button>
          <Button variant="contained" onClick={addKey} sx={{ textTransform: 'none' }}>Add key</Button>
        </DialogActions>
      </Dialog>

      <Dialog disableScrollLock open={!!deleteConfirmKey} onClose={() => setDeleteConfirmKey(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Delete key?</DialogTitle>
        <DialogContent>
          <Typography fontSize={13}>This deletes the key <Box component="span" sx={{ fontFamily: 'monospace', fontWeight: 700 }}>{deleteConfirmKey}</Box> for all languages. UI elements that reference it will fall back to their hardcoded fallback strings until the key is added again.</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setDeleteConfirmKey(null)} sx={{ textTransform: 'none' }}>Cancel</Button>
          <Button variant="contained" color="error" onClick={() => deleteConfirmKey && deleteKey(deleteConfirmKey)} sx={{ textTransform: 'none' }}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const AdminPage: React.FC<{ isDark: boolean; onBack: () => void; apiHeaders: () => Record<string, string> }> = ({ isDark, onBack, apiHeaders }) => {
  const [tab, setTab] = useState(0);
  const [stats, setStats] = useState<any>(null);
  const [users, setUsers] = useState<any[]>([]);
  const [boards, setBoards] = useState<any[]>([]);
  const [activity, setActivity] = useState<any>(null);
  const [system, setSystem] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [userSearch, setUserSearch] = useState('');
  const [boardSearch, setBoardSearch] = useState('');
  const [userSort, setUserSort] = useState<{col: string; dir: 'asc'|'desc'}>({ col: 'created_at', dir: 'desc' });
  const [boardSort, setBoardSort] = useState<{col: string; dir: 'asc'|'desc'}>({ col: 'updated_at', dir: 'desc' });
  const [userPage, setUserPage] = useState(1);
  const [boardPage, setBoardPage] = useState(1);
  const [userTotal, setUserTotal] = useState(0);
  const [boardTotal, setBoardTotal] = useState(0);
  const [deleteConfirm, setDeleteConfirm] = useState<{type: 'user'|'board'; id: string; label: string} | null>(null);
  const [snack, setSnack] = useState('');
  const [maxUploadMB, setMaxUploadMB] = useState(50);
  const [maxUploadInput, setMaxUploadInput] = useState('50');
  const [savingUpload, setSavingUpload] = useState(false);
  const [defaultScrollTime, setDefaultScrollTime] = useState(10);
  const [scrollTimeInput, setScrollTimeInput] = useState('10');
  const [defaultBrowser, setDefaultBrowser] = useState('auto');
  const [defaultVpWidth, setDefaultVpWidth] = useState(1024);
  const [savingArchive, setSavingArchive] = useState(false);
  const [maxRefPointsInput, setMaxRefPointsInput] = useState('20');
  const [maxBranchSourcesInput, setMaxBranchSourcesInput] = useState('10');
  const [savingTreeLimits, setSavingTreeLimits] = useState(false);
  const [maxChainSourcesInput, setMaxChainSourcesInput] = useState('10');
  const [savingChainLimits, setSavingChainLimits] = useState(false);
  const [expandedUserId, setExpandedUserId] = useState<number | null>(null);
  const [userSourcesMap, setUserSourcesMap] = useState<Record<number, any[]>>({});
  const [loadingUserSources, setLoadingUserSources] = useState<number | null>(null);

  const hdrs = apiHeaders();
  const fetchJson = async (url: string) => { const r = await fetch(url, { headers: hdrs }); if (!r.ok) throw new Error(`${r.status}`); return r.json(); };

  const loadStats = async () => { try { const d = await fetchJson(`${API_BASE}/admin/stats`); setStats(d); } catch {} };
  const loadSystem = async () => { try { const d = await fetchJson(`${API_BASE}/admin/system`); setSystem(d); } catch {} try { const s = await fetchJson(`${API_BASE}/admin/settings`); if (s.maxUploadMB) { const v = parseInt(s.maxUploadMB); setMaxUploadMB(v); setMaxUploadInput(String(v)); } if (s.archive_default_scroll_time) { const v = parseInt(s.archive_default_scroll_time); setDefaultScrollTime(v); setScrollTimeInput(String(v)); } if (s.archive_default_browser) setDefaultBrowser(s.archive_default_browser); if (s.archive_default_viewport_width) setDefaultVpWidth(parseInt(s.archive_default_viewport_width) || 1024); if (s.tree_max_ref_points) setMaxRefPointsInput(String(parseInt(s.tree_max_ref_points) || 20)); if (s.tree_max_sources_per_branch) setMaxBranchSourcesInput(String(parseInt(s.tree_max_sources_per_branch) || 10)); if (s.chain_max_sources) setMaxChainSourcesInput(String(parseInt(s.chain_max_sources) || 10)); } catch {} };
  const loadActivity = async () => { try { const d = await fetchJson(`${API_BASE}/admin/activity?days=30`); setActivity(d); } catch {} };

  const loadUserSources = async (userId: number) => {
    if (userSourcesMap[userId]) { setExpandedUserId(expandedUserId === userId ? null : userId); return; }
    setLoadingUserSources(userId);
    setExpandedUserId(userId);
    try {
      const d = await fetchJson(`${API_BASE}/admin/users/${userId}/sources`);
      setUserSourcesMap(p => ({ ...p, [userId]: d.sources || [] }));
    } catch { setUserSourcesMap(p => ({ ...p, [userId]: [] })); }
    setLoadingUserSources(null);
  };

  const handleSaveUploadSize = async () => {
    const mb = parseInt(maxUploadInput, 10);
    if (isNaN(mb) || mb < 1 || mb > 2048) { setSnack('Enter a value between 1 and 2048 MB'); return; }
    setSavingUpload(true);
    try {
      const r = await fetch(`${API_BASE}/admin/settings`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ maxUploadMB: mb }) });
      if (r.ok) { setMaxUploadMB(mb); setSnack(`Max upload size set to ${mb} MB`); }
      else setSnack('Failed to save setting');
    } catch { setSnack('Failed to save setting'); }
    setSavingUpload(false);
  };

  const handleSaveArchiveSettings = async () => {
    const sec = parseInt(scrollTimeInput, 10);
    if (isNaN(sec) || sec < 0 || sec > 120) { setSnack('Enter 0–120 seconds'); return; }
    setSavingArchive(true);
    try {
      const r = await fetch(`${API_BASE}/admin/settings`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ archive_default_scroll_time: String(sec), archive_default_browser: defaultBrowser, archive_default_viewport_width: String(defaultVpWidth) }) });
      if (r.ok) { setDefaultScrollTime(sec); setSnack(`Web archive defaults saved (scroll ${sec}s, ${defaultBrowser}, ${defaultVpWidth}px)`); }
      else setSnack('Failed to save');
    } catch { setSnack('Failed to save'); }
    setSavingArchive(false);
  };

  const handleSaveTreeLimits = async () => {
    const rp = parseInt(maxRefPointsInput, 10);
    const sb = parseInt(maxBranchSourcesInput, 10);
    if (isNaN(rp) || rp < 1 || rp > 200) { setSnack('Max ref points must be 1–200'); return; }
    if (isNaN(sb) || sb < 1 || sb > 100) { setSnack('Max sources per branch must be 1–100'); return; }
    setSavingTreeLimits(true);
    try {
      const r = await fetch(`${API_BASE}/admin/settings`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ tree_max_ref_points: String(rp), tree_max_sources_per_branch: String(sb) }) });
      if (r.ok) setSnack(`Source-tree limits saved: ${rp} ref points, ${sb} sources per branch`);
      else setSnack('Failed to save');
    } catch { setSnack('Failed to save'); }
    setSavingTreeLimits(false);
  };

  const handleSaveChainLimits = async () => {
    const cs = parseInt(maxChainSourcesInput, 10);
    if (isNaN(cs) || cs < 1 || cs > 100) { setSnack('Max sources per chain must be 1–100'); return; }
    setSavingChainLimits(true);
    try {
      const r = await fetch(`${API_BASE}/admin/settings`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ chain_max_sources: String(cs) }) });
      if (r.ok) setSnack(`Source-chain limit saved: ${cs} sources per chain`);
      else setSnack('Failed to save');
    } catch { setSnack('Failed to save'); }
    setSavingChainLimits(false);
  };
  
  const loadUsers = async (page = 1, search = '', sort = userSort) => {
    try {
      const d = await fetchJson(`${API_BASE}/admin/users?page=${page}&limit=50&search=${encodeURIComponent(search)}&sort=${sort.col}&dir=${sort.dir}`);
      setUsers(d.users || []); setUserTotal(d.total || 0); setUserPage(page);
    } catch {}
  };
  const loadBoards = async (page = 1, search = '', sort = boardSort) => {
    try {
      const d = await fetchJson(`${API_BASE}/admin/boards?page=${page}&limit=50&search=${encodeURIComponent(search)}&sort=${sort.col}&dir=${sort.dir}`);
      setBoards(d.boards || []); setBoardTotal(d.total || 0); setBoardPage(page);
    } catch {}
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([loadStats(), loadUsers(), loadBoards(), loadActivity(), loadSystem()]).then(() => setLoading(false));
  }, []);

  const handleDeleteConfirm = async () => {
    if (!deleteConfirm) return;
    try {
      const url = deleteConfirm.type === 'user' ? `${API_BASE}/admin/users/${deleteConfirm.id}` : `${API_BASE}/admin/boards/${deleteConfirm.id}`;
      await fetch(url, { method: 'DELETE', headers: hdrs });
      setSnack(`Deleted ${deleteConfirm.label}`);
      if (deleteConfirm.type === 'user') loadUsers(userPage, userSearch);
      else loadBoards(boardPage, boardSearch);
      loadStats();
    } catch { setSnack('Delete failed'); }
    setDeleteConfirm(null);
  };

  const handleSetRole = async (userId: number, role: string) => {
    try {
      await fetch(`${API_BASE}/admin/users/${userId}/role`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ role }) });
      setSnack(`Role updated`);
      loadUsers(userPage, userSearch);
    } catch { setSnack('Failed'); }
  };

  const handleToggleVisibility = async (boardId: string, isPublic: boolean) => {
    try {
      await fetch(`${API_BASE}/admin/boards/${boardId}/visibility`, { method: 'PUT', headers: { ...hdrs, 'Content-Type': 'application/json' }, body: JSON.stringify({ isPublic: !isPublic }) });
      loadBoards(boardPage, boardSearch);
    } catch {}
  };

  const fmtBytes = (b: number) => b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : b > 1024 ? `${(b / 1024).toFixed(0)} KB` : `${b} B`;
  const fmtDate = (d: string) => d ? formatTimestamp(d, DEFAULT_SETTINGS) : '—';

  const StatCard: React.FC<{ label: string; value: string | number; sub?: string; color: string; icon: React.ReactNode }> = ({ label, value, sub, color, icon }) => (
    <Box sx={{ flex: 1, minWidth: 140, p: 2, borderRadius: '12px', border: '1px solid', borderColor: `${color}25`, bgcolor: `${color}06` }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Box sx={{ width: 32, height: 32, borderRadius: '8px', bgcolor: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', color }}>{icon}</Box>
        <Typography fontSize={10} color="text.secondary" fontWeight={600}>{label}</Typography>
      </Box>
      <Typography fontSize={28} fontWeight={800} sx={{ color, lineHeight: 1 }}>{value}</Typography>
      {sub && <Typography fontSize={10} color="text.disabled" sx={{ mt: 0.5 }}>{sub}</Typography>}
    </Box>
  );

  const UserSortHeader: React.FC<{ col: string; label: string; w?: number }> = ({ col, label, w }) => (
    <TableCell onClick={() => { const ns = { col, dir: (userSort.col === col && userSort.dir === 'asc' ? 'desc' : 'asc') as 'asc'|'desc' }; setUserSort(ns); loadUsers(1, userSearch, ns); }}
      sx={{ cursor: 'pointer', fontWeight: 700, fontSize: 11, py: 1, width: w, whiteSpace: 'nowrap', userSelect: 'none', '&:hover': { color: 'primary.main' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>{label}
        {userSort.col === col ? (userSort.dir === 'asc' ? <ArrowDropUpIcon sx={{ fontSize: 16 }} /> : <ArrowDropDownIcon sx={{ fontSize: 16 }} />) : <Box sx={{ width: 16 }} />}
      </Box>
    </TableCell>
  );

  const BoardSortHeader: React.FC<{ col: string; label: string; w?: number }> = ({ col, label, w }) => (
    <TableCell onClick={() => { const ns = { col, dir: (boardSort.col === col && boardSort.dir === 'asc' ? 'desc' : 'asc') as 'asc'|'desc' }; setBoardSort(ns); loadBoards(1, boardSearch, ns); }}
      sx={{ cursor: 'pointer', fontWeight: 700, fontSize: 11, py: 1, width: w, whiteSpace: 'nowrap', userSelect: 'none', '&:hover': { color: 'primary.main' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>{label}
        {boardSort.col === col ? (boardSort.dir === 'asc' ? <ArrowDropUpIcon sx={{ fontSize: 16 }} /> : <ArrowDropDownIcon sx={{ fontSize: 16 }} />) : <Box sx={{ width: 16 }} />}
      </Box>
    </TableCell>
  );

  const chartData = useMemo(() => {
    if (!activity) return [];
    const days: Record<string, any> = {};
    const addData = (arr: any[], key: string) => { (arr || []).forEach((d: any) => { if (!days[d.day]) days[d.day] = { day: d.day }; days[d.day][key] = d.count; }); };
    addData(activity.usersByDay, 'users');
    addData(activity.boardsByDay, 'boards');
    addData(activity.sourcesByDay, 'sources');
    addData(activity.loginsByDay, 'logins');
    return Object.values(days).sort((a: any, b: any) => a.day.localeCompare(b.day));
  }, [activity]);

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton onClick={onBack} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
        <AdminPanelSettingsIcon sx={{ color: '#ef4444', fontSize: 22 }} />
        <Typography fontWeight={700} fontSize={18}>Admin Panel</Typography>
        <Box sx={{ flex: 1 }} />
        <Chip label="Admin" size="small" sx={{ bgcolor: '#ef444415', color: '#ef4444', fontWeight: 700, fontSize: 10 }} />
      </Box>

      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', px: 3, flexShrink: 0 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ minHeight: 38, '& .MuiTab-root': { minHeight: 38, fontSize: 12, textTransform: 'none', fontWeight: 600, py: 0.5 } }}>
          <Tab label="Overview" icon={<SpeedIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Users" icon={<PeopleIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Boards" icon={<StorageIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Activity" icon={<TrendingUpIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Sites" icon={<LanguageIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="System" icon={<SettingsIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
          <Tab label="Translations" icon={<TranslateIcon sx={{ fontSize: 16 }} />} iconPosition="start" />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress size={32} /></Box>
        ) : (
          <>
            {tab === 0 && stats && (
              <Box sx={{ maxWidth: 1000 }}>
                <Typography fontWeight={700} fontSize={14} sx={{ mb: 2 }}>Overview</Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
                  <StatCard label="Total Users" value={stats.users.total} sub={`+${stats.users.thisWeek} this week`} color="#3b82f6" icon={<PeopleIcon sx={{ fontSize: 16 }} />} />
                  <StatCard label="Active Today" value={stats.users.activeToday} sub={`${stats.users.activeWeek} this week`} color="#10b981" icon={<TrendingUpIcon sx={{ fontSize: 16 }} />} />
                  <StatCard label="Total Boards" value={stats.boards.total} sub={`${stats.boards.public} public · ${stats.boards.private} private`} color="#8b5cf6" icon={<StorageIcon sx={{ fontSize: 16 }} />} />
                  <StatCard label="Total Sources" value={stats.sources.total} sub={`${stats.sources.withFiles} with files · ${stats.sources.assessed} assessed`} color="#f59e0b" icon={<ArticleIcon sx={{ fontSize: 16 }} />} />
                </Box>

                <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
                  <Box sx={{ flex: 2, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                    <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>New Users (7 days)</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, height: 80 }}>
                      {(activity?.usersByDay || []).slice(-7).map((d: any, i: number) => {
                        const max = Math.max(...(activity?.usersByDay || []).slice(-7).map((x: any) => x.count), 1);
                        return (
                          <Tooltip key={i} title={`${d.day}: ${d.count} users`}>
                            <Box sx={{ flex: 1, bgcolor: '#3b82f6', borderRadius: '4px 4px 0 0', minHeight: 4, height: `${(d.count / max) * 100}%`, transition: 'height 0.3s' }} />
                          </Tooltip>
                        );
                      })}
                    </Box>
                  </Box>

                  <Box sx={{ flex: 1, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                    <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>Source Types</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      {(stats.sourceTypes || []).slice(0, 8).map((st: any) => (
                        <Box key={st.source_type} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography fontSize={10} sx={{ width: 70, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st.source_type}</Typography>
                          <Box sx={{ flex: 1, height: 6, bgcolor: 'divider', borderRadius: 3, overflow: 'hidden' }}>
                            <Box sx={{ width: `${(st.count / (stats.sourceTypes[0]?.count || 1)) * 100}%`, height: '100%', bgcolor: '#8b5cf6', borderRadius: 3 }} />
                          </Box>
                          <Typography fontSize={9} color="text.secondary" sx={{ width: 24, textAlign: 'right' }}>{st.count}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Box sx={{ flex: 1, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                    <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>Board Modes</Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Box sx={{ textAlign: 'center', flex: 1 }}>
                        <Typography fontSize={24} fontWeight={800} color="#3b82f6">{stats.boards.chains}</Typography>
                        <Typography fontSize={10} color="text.secondary">Chains</Typography>
                      </Box>
                      <Box sx={{ textAlign: 'center', flex: 1 }}>
                        <Typography fontSize={24} fontWeight={800} color="#10b981">{stats.boards.trees}</Typography>
                        <Typography fontSize={10} color="text.secondary">Trees</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ flex: 1, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                    <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>This Month</Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Box sx={{ textAlign: 'center', flex: 1 }}>
                        <Typography fontSize={24} fontWeight={800} color="#3b82f6">{stats.users.thisMonth}</Typography>
                        <Typography fontSize={10} color="text.secondary">New Users</Typography>
                      </Box>
                      <Box sx={{ textAlign: 'center', flex: 1 }}>
                        <Typography fontSize={24} fontWeight={800} color="#8b5cf6">{stats.boards.thisMonth}</Typography>
                        <Typography fontSize={10} color="text.secondary">New Boards</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ flex: 1, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                    <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>Storage</Typography>
                    <Typography fontSize={20} fontWeight={800} color="#f59e0b">{fmtBytes(stats.dbSize)}</Typography>
                    <Typography fontSize={10} color="text.secondary">Database size · {stats.refPoints} ref points</Typography>
                  </Box>
                </Box>
              </Box>
            )}

            {tab === 1 && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <TextField size="small" placeholder="Search users..." value={userSearch} onChange={e => { setUserSearch(e.target.value); loadUsers(1, e.target.value); }}
                    InputProps={{ sx: { fontSize: 12, height: 32, borderRadius: '8px' } }} sx={{ width: 260 }} />
                  <Typography fontSize={11} color="text.secondary">{userTotal} users total</Typography>
                </Box>
                <Table size="small" stickyHeader>
                  <TableHead><TableRow>
                    <UserSortHeader col="id" label="ID" w={50} />
                    <UserSortHeader col="username" label="Username" />
                    <UserSortHeader col="email" label="Email" />
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 60 }}>Boards</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 65 }}>Sources</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 60 }}>Role</TableCell>
                    <UserSortHeader col="created_at" label="Joined" w={130} />
                    <UserSortHeader col="last_login_at" label="Last Login" w={130} />
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 100 }}>Actions</TableCell>
                  </TableRow></TableHead>
                  <TableBody>
                    {users.map(u => (
                      <React.Fragment key={u.id}>
                      <TableRow hover sx={{ '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)' }, cursor: 'pointer' }} onClick={() => loadUserSources(u.id)}>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={11} color="text.secondary">{u.id}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={12} fontWeight={600}>{u.display_name || u.username || '—'}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={11} color="text.secondary">{u.email || '—'}</Typography></TableCell>
                        <TableCell sx={{ py: 1, textAlign: 'center' }}><Typography fontSize={12} fontWeight={600}>{u.board_count}</Typography></TableCell>
                        <TableCell sx={{ py: 1, textAlign: 'center' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                            <Typography fontSize={12}>{u.source_count}</Typography>
                            <Box sx={{ fontSize: 9, color: 'text.disabled' }}>{expandedUserId === u.id ? '▲' : '▼'}</Box>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip label={u.admin_role || 'user'} size="small" onClick={e => { e.stopPropagation(); handleSetRole(u.id, u.admin_role === 'admin' ? '' : 'admin'); }}
                            sx={{ fontSize: 9, height: 20, cursor: 'pointer', bgcolor: u.admin_role === 'admin' || u.admin_role === 'superadmin' ? '#ef444420' : 'transparent', color: u.admin_role ? '#ef4444' : 'text.disabled', fontWeight: u.admin_role ? 700 : 400, borderColor: 'divider' }}
                            variant={u.admin_role ? 'filled' : 'outlined'} />
                        </TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={10} color="text.secondary">{fmtDate(u.created_at)}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={10} color="text.secondary">{fmtDate(u.last_login_at)}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Tooltip title="Delete user"><IconButton size="small" onClick={e => { e.stopPropagation(); setDeleteConfirm({ type: 'user', id: String(u.id), label: u.username || u.email }); }}
                            sx={{ opacity: 0.3, '&:hover': { opacity: 1, color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                        </TableCell>
                      </TableRow>
                      {expandedUserId === u.id && (
                        <TableRow>
                          <TableCell colSpan={9} sx={{ p: 0, bgcolor: isDark ? 'rgba(255,255,255,0.015)' : 'rgba(0,0,0,0.018)', borderBottom: '2px solid', borderColor: 'divider' }}>
                            {loadingUserSources === u.id ? (
                              <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}><CircularProgress size={14} /><Typography fontSize={11} color="text.secondary">Loading sources…</Typography></Box>
                            ) : (
                              <Box sx={{ p: 1.5 }}>
                                <Typography fontSize={10} fontWeight={700} color="text.disabled" sx={{ mb: 1, textTransform: 'uppercase', letterSpacing: 0.6 }}>Sources by {u.display_name || u.username} ({(userSourcesMap[u.id] || []).length})</Typography>
                                {(userSourcesMap[u.id] || []).length === 0 ? (
                                  <Typography fontSize={11} color="text.disabled" sx={{ pl: 1 }}>No sources found.</Typography>
                                ) : (
                                  <Table size="small">
                                    <TableHead><TableRow sx={{ bgcolor: 'transparent' }}>
                                      <TableCell sx={{ fontWeight: 700, fontSize: 10, py: 0.5, width: 100 }}>Source ID</TableCell>
                                      <TableCell sx={{ fontWeight: 700, fontSize: 10, py: 0.5 }}>Title</TableCell>
                                      <TableCell sx={{ fontWeight: 700, fontSize: 10, py: 0.5, width: 90 }}>Type</TableCell>
                                      <TableCell sx={{ fontWeight: 700, fontSize: 10, py: 0.5, width: 90 }}>Board</TableCell>
                                      <TableCell sx={{ fontWeight: 700, fontSize: 10, py: 0.5, width: 120 }}>Created</TableCell>
                                    </TableRow></TableHead>
                                    <TableBody>
                                      {(userSourcesMap[u.id] || []).map((s: any) => (
                                        <TableRow key={s.source_id} hover>
                                          <TableCell sx={{ py: 0.6 }}><Typography fontSize={10} fontWeight={700} sx={{ fontFamily: 'monospace' }}>{dispId(s.source_id || '')}</Typography></TableCell>
                                          <TableCell sx={{ py: 0.6 }}><Typography fontSize={11} sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name || s.title || '—'}</Typography></TableCell>
                                          <TableCell sx={{ py: 0.6 }}><Typography fontSize={10} color="text.secondary">{s.source_type || '—'}</Typography></TableCell>
                                          <TableCell sx={{ py: 0.6 }}><Typography fontSize={10} fontWeight={600} sx={{ fontFamily: 'monospace' }}>{dispId(s.board_id || '')}</Typography></TableCell>
                                          <TableCell sx={{ py: 0.6 }}><Typography fontSize={10} color="text.disabled">{fmtDate(s.created_at)}</Typography></TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                )}
                              </Box>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
                {userTotal > 50 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
                    <Button size="small" disabled={userPage <= 1} onClick={() => loadUsers(userPage - 1, userSearch)}>Previous</Button>
                    <Typography fontSize={11} color="text.secondary" sx={{ py: 0.5 }}>Page {userPage} of {Math.ceil(userTotal / 50)}</Typography>
                    <Button size="small" disabled={userPage >= Math.ceil(userTotal / 50)} onClick={() => loadUsers(userPage + 1, userSearch)}>Next</Button>
                  </Box>
                )}
              </Box>
            )}

            {tab === 2 && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <TextField size="small" placeholder="Search boards..." value={boardSearch} onChange={e => { setBoardSearch(e.target.value); loadBoards(1, e.target.value); }}
                    InputProps={{ sx: { fontSize: 12, height: 32, borderRadius: '8px' } }} sx={{ width: 260 }} />
                  <Typography fontSize={11} color="text.secondary">{boardTotal} boards total</Typography>
                </Box>
                <Table size="small" stickyHeader>
                  <TableHead><TableRow>
                    <BoardSortHeader col="board_id" label="Board ID" w={110} />
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1 }}>Owner</TableCell>
                    <BoardSortHeader col="app_mode" label="Mode" w={70} />
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 65 }}>Sources</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 75 }}>Visibility</TableCell>
                    <BoardSortHeader col="created_at" label="Created" w={130} />
                    <BoardSortHeader col="updated_at" label="Modified" w={130} />
                    <TableCell sx={{ fontWeight: 700, fontSize: 11, py: 1, width: 70 }}>Actions</TableCell>
                  </TableRow></TableHead>
                  <TableBody>
                    {boards.map(b => (
                      <TableRow key={b.board_id} hover sx={{ '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)' } }}>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={12} fontWeight={700} sx={{ fontFamily: '"Inter",system-ui,sans-serif', letterSpacing: 0.5 }}>{dispId(b.board_id || '')}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Typography fontSize={11}>{b.owner_name || b.owner_email || '—'}</Typography>
                          <Typography fontSize={9} color="text.disabled">{b.owner_email}</Typography>
                        </TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip label={b.app_mode === 'tree' ? 'Tree' : 'Chain'} size="small" sx={{ fontSize: 9, height: 20, bgcolor: b.app_mode === 'tree' ? '#10b98112' : '#3b82f612', color: b.app_mode === 'tree' ? '#10b981' : '#3b82f6' }} />
                        </TableCell>
                        <TableCell sx={{ py: 1, textAlign: 'center' }}><Typography fontSize={12} fontWeight={600}>{b.source_count || 0}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Chip label={b.is_public ? 'Public' : 'Private'} size="small" onClick={() => handleToggleVisibility(b.board_id, !!b.is_public)}
                            sx={{ fontSize: 9, height: 20, cursor: 'pointer', bgcolor: b.is_public ? '#10b98115' : 'transparent', color: b.is_public ? '#10b981' : 'text.disabled' }}
                            variant={b.is_public ? 'filled' : 'outlined'} />
                        </TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={10} color="text.secondary">{fmtDate(b.created_at)}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}><Typography fontSize={10} color="text.secondary">{fmtDate(b.updated_at)}</Typography></TableCell>
                        <TableCell sx={{ py: 1 }}>
                          <Tooltip title="Delete board"><IconButton size="small" onClick={() => setDeleteConfirm({ type: 'board', id: b.board_id, label: b.board_id?.toUpperCase() })}
                            sx={{ opacity: 0.3, '&:hover': { opacity: 1, color: '#ef4444' } }}><DeleteIcon sx={{ fontSize: 14 }} /></IconButton></Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {boardTotal > 50 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
                    <Button size="small" disabled={boardPage <= 1} onClick={() => loadBoards(boardPage - 1, boardSearch)}>Previous</Button>
                    <Typography fontSize={11} color="text.secondary" sx={{ py: 0.5 }}>Page {boardPage} of {Math.ceil(boardTotal / 50)}</Typography>
                    <Button size="small" disabled={boardPage >= Math.ceil(boardTotal / 50)} onClick={() => loadBoards(boardPage + 1, boardSearch)}>Next</Button>
                  </Box>
                )}
              </Box>
            )}

            {tab === 3 && activity && (
              <Box sx={{ maxWidth: 1000 }}>
                <Typography fontWeight={700} fontSize={14} sx={{ mb: 2 }}>Activity (Last 30 Days)</Typography>
                <Box sx={{ display: 'flex', gap: 3, mb: 3, flexWrap: 'wrap' }}>
                  {[
                    { label: 'New Users', data: activity.usersByDay, color: '#3b82f6' },
                    { label: 'New Boards', data: activity.boardsByDay, color: '#8b5cf6' },
                    { label: 'New Sources', data: activity.sourcesByDay, color: '#10b981' },
                    { label: 'Logins', data: activity.loginsByDay, color: '#f59e0b' },
                  ].map(chart => (
                    <Box key={chart.label} sx={{ flex: 1, minWidth: 200, p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography fontSize={12} fontWeight={700}>{chart.label}</Typography>
                        <Typography fontSize={11} fontWeight={700} sx={{ color: chart.color }}>
                          {(chart.data || []).reduce((s: number, d: any) => s + d.count, 0)}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '2px', height: 60 }}>
                        {(chart.data || []).slice(-14).map((d: any, i: number) => {
                          const max = Math.max(...(chart.data || []).slice(-14).map((x: any) => x.count), 1);
                          return (
                            <Tooltip key={i} title={`${d.day}: ${d.count}`}>
                              <Box sx={{ flex: 1, bgcolor: chart.color, borderRadius: '2px 2px 0 0', minHeight: 2, height: `${(d.count / max) * 100}%`, opacity: 0.8, '&:hover': { opacity: 1 } }} />
                            </Tooltip>
                          );
                        })}
                      </Box>
                    </Box>
                  ))}
                </Box>

                <Typography fontSize={12} fontWeight={700} sx={{ mb: 1 }}>Daily Breakdown</Typography>
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                  <Table size="small" stickyHeader>
                    <TableHead><TableRow>
                      <TableCell sx={{ fontWeight: 700, fontSize: 11 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 11, textAlign: 'center' }}>Users</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 11, textAlign: 'center' }}>Boards</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 11, textAlign: 'center' }}>Sources</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: 11, textAlign: 'center' }}>Logins</TableCell>
                    </TableRow></TableHead>
                    <TableBody>
                      {chartData.slice().reverse().map((d: any) => (
                        <TableRow key={d.day} hover>
                          <TableCell sx={{ py: 0.8 }}><Typography fontSize={11}>{d.day}</Typography></TableCell>
                          <TableCell sx={{ py: 0.8, textAlign: 'center' }}><Typography fontSize={11} fontWeight={d.users ? 600 : 400} color={d.users ? '#3b82f6' : 'text.disabled'}>{d.users || 0}</Typography></TableCell>
                          <TableCell sx={{ py: 0.8, textAlign: 'center' }}><Typography fontSize={11} fontWeight={d.boards ? 600 : 400} color={d.boards ? '#8b5cf6' : 'text.disabled'}>{d.boards || 0}</Typography></TableCell>
                          <TableCell sx={{ py: 0.8, textAlign: 'center' }}><Typography fontSize={11} fontWeight={d.sources ? 600 : 400} color={d.sources ? '#10b981' : 'text.disabled'}>{d.sources || 0}</Typography></TableCell>
                          <TableCell sx={{ py: 0.8, textAlign: 'center' }}><Typography fontSize={11} fontWeight={d.logins ? 600 : 400} color={d.logins ? '#f59e0b' : 'text.disabled'}>{d.logins || 0}</Typography></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            )}

            {tab === 4 && (
              <DismissSitesTab apiHeaders={apiHeaders} isDark={isDark} />
            )}

            {tab === 5 && system && (
              <Box sx={{ maxWidth: 700 }}>
                <Typography fontWeight={700} fontSize={14} sx={{ mb: 2 }}>System Information</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {[
                    { label: 'Node.js', value: system.nodeVersion },
                    { label: 'Platform', value: system.platform },
                    { label: 'Uptime', value: system.uptimeHuman },
                    { label: 'Memory (RSS)', value: fmtBytes(system.memory?.rss || 0) },
                    { label: 'Heap Used', value: `${fmtBytes(system.memory?.heapUsed || 0)} / ${fmtBytes(system.memory?.heapTotal || 0)}` },
                    { label: 'Database', value: `${fmtBytes(system.dbSize)} — ${system.dbPath}` },
                    { label: 'LibreOffice', value: system.libreoffice ? 'Installed ✓' : 'Not installed ✗' },
                    { label: 'Poppler', value: system.poppler ? 'Installed ✓' : 'Not installed ✗' },
                    { label: 'S3 Bucket', value: system.s3Bucket },
                    { label: 'Admin Users', value: `${system.adminClerkIds} configured in env` },
                  ].map(row => (
                    <Box key={row.label} sx={{ display: 'flex', py: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
                      <Typography fontSize={12} fontWeight={600} sx={{ width: 160, flexShrink: 0 }}>{row.label}</Typography>
                      <Typography fontSize={12} color="text.secondary" sx={{ fontFamily: 'monospace' }}>{row.value}</Typography>
                    </Box>
                  ))}
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Typography fontWeight={700} fontSize={12} sx={{ mb: 1 }}>Environment Setup</Typography>
                  <Box sx={{ p: 2, borderRadius: '8px', bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', fontFamily: 'monospace', fontSize: 11, lineHeight: 1.8, color: 'text.secondary' }}>
                    # Add admin users via env var<br/>
                    ADMIN_CLERK_IDS=user_xxx,user_yyy<br/><br/>
                    # Or set role via API<br/>
                    PUT /api/admin/users/:id/role {'{'} "role": "admin" {'}'}
                  </Box>
                </Box>

                <Box sx={{ mt: 3, p: 2.5, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                  <Typography fontWeight={700} fontSize={13} sx={{ mb: 0.5 }}>Max Upload Size</Typography>
                  <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
                    Maximum file size users can upload per source. Currently set to <strong>{maxUploadMB} MB</strong>.
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <TextField
                      size="small"
                      label="Max size (MB)"
                      value={maxUploadInput}
                      onChange={e => setMaxUploadInput(e.target.value)}
                      type="number"
                      inputProps={{ min: 1, max: 2048, step: 1 }}
                      sx={{ width: 150 }}
                      InputProps={{ sx: { fontSize: 12, height: 36 } }}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      disabled={savingUpload}
                      onClick={handleSaveUploadSize}
                      sx={{ height: 36, textTransform: 'none', fontWeight: 600, fontSize: 12, bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}
                    >
                      {savingUpload ? <CircularProgress size={14} sx={{ color: '#E3E3DF' }} /> : 'Save'}
                    </Button>
                    <Typography fontSize={11} color="text.disabled">1 – 2048 MB</Typography>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {[10, 25, 50, 100, 250, 500].map(v => (
                      <Chip key={v} label={`${v} MB`} size="small" onClick={() => { setMaxUploadInput(String(v)); }}
                        variant={parseInt(maxUploadInput, 10) === v ? 'filled' : 'outlined'}
                        sx={{ fontSize: 10, height: 22, cursor: 'pointer', fontWeight: parseInt(maxUploadInput, 10) === v ? 700 : 400 }} />
                    ))}
                  </Box>
                </Box>

                <Box sx={{ mt: 3, p: 2.5, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                  <Typography fontWeight={700} fontSize={13} sx={{ mb: 0.5 }}>Web Archive Defaults</Typography>
                  <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
                    Default settings for all users when opening the archive wizard.
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box>
                      <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Scroll time: {scrollTimeInput}s</Typography>
                      <Slider value={parseInt(scrollTimeInput, 10) || 10} onChange={(_, v) => setScrollTimeInput(String(v))} min={0} max={90} step={5}
                        marks={[{value:0,label:'0s'},{value:10,label:'10s'},{value:30,label:'30s'},{value:60,label:'60s'},{value:90,label:'90s'}]}
                        valueLabelDisplay="auto" valueLabelFormat={(v: number) => `${v}s`}
                        sx={{ maxWidth: 400, '& .MuiSlider-markLabel': { fontSize: 9 } }} />
                    </Box>
                    <Box>
                      <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Browser engine</Typography>
                      <ToggleButtonGroup value={defaultBrowser} exclusive onChange={(_, v) => { if (v) setDefaultBrowser(v); }} size="small" sx={{ '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 11, px: 2 } }}>
                        <ToggleButton value="auto">Auto</ToggleButton>
                        <ToggleButton value="puppeteer">Puppeteer</ToggleButton>
                        <ToggleButton value="playwright">Playwright</ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                    <Box>
                      <Typography fontSize={12} fontWeight={600} sx={{ mb: 0.5 }}>Viewport width</Typography>
                      <ToggleButtonGroup value={defaultVpWidth} exclusive onChange={(_, v) => { if (v) setDefaultVpWidth(v); }} size="small" sx={{ '& .MuiToggleButton-root': { textTransform: 'none', fontSize: 11, px: 2 } }}>
                        <ToggleButton value={1024}>1024px</ToggleButton>
                        <ToggleButton value={1280}>1280px</ToggleButton>
                        <ToggleButton value={1920}>1920px</ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                    <Button variant="contained" size="small" disabled={savingArchive} onClick={handleSaveArchiveSettings}
                      sx={{ alignSelf: 'flex-start', height: 36, textTransform: 'none', fontWeight: 600, fontSize: 12, bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}>
                      {savingArchive ? <CircularProgress size={14} sx={{ color: '#E3E3DF' }} /> : 'Save Archive Defaults'}
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ mt: 3, p: 2.5, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                  <Typography fontWeight={700} fontSize={13} sx={{ mb: 0.5 }}>Source Tree Limits</Typography>
                  <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
                    Maximum reference points per source-tree board, and maximum source boxes per branch chain. Applied client-side; existing trees that exceed a new lower limit keep their current sizes but cannot grow further.
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <TextField label="Max reference points" type="number" size="small"
                        value={maxRefPointsInput} onChange={(e) => setMaxRefPointsInput(e.target.value)}
                        inputProps={{ min: 1, max: 200 }} sx={{ width: 200 }}
                        InputProps={{ sx: { fontSize: 12, height: 36 } }} />
                      <Typography fontSize={11} color="text.disabled">per board · default 20</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', maxWidth: 400 }}>
                      {[10, 20, 30, 50, 100].map(v => (
                        <Chip key={v} label={String(v)} size="small" onClick={() => setMaxRefPointsInput(String(v))}
                          variant={parseInt(maxRefPointsInput, 10) === v ? 'filled' : 'outlined'}
                          sx={{ fontSize: 10, height: 22, cursor: 'pointer', fontWeight: parseInt(maxRefPointsInput, 10) === v ? 700 : 400 }} />
                      ))}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <TextField label="Max sources per branch" type="number" size="small"
                        value={maxBranchSourcesInput} onChange={(e) => setMaxBranchSourcesInput(e.target.value)}
                        inputProps={{ min: 1, max: 100 }} sx={{ width: 200 }}
                        InputProps={{ sx: { fontSize: 12, height: 36 } }} />
                      <Typography fontSize={11} color="text.disabled">per branch chain · default 10</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', maxWidth: 400 }}>
                      {[5, 10, 15, 20, 30].map(v => (
                        <Chip key={v} label={String(v)} size="small" onClick={() => setMaxBranchSourcesInput(String(v))}
                          variant={parseInt(maxBranchSourcesInput, 10) === v ? 'filled' : 'outlined'}
                          sx={{ fontSize: 10, height: 22, cursor: 'pointer', fontWeight: parseInt(maxBranchSourcesInput, 10) === v ? 700 : 400 }} />
                      ))}
                    </Box>
                    <Button variant="contained" size="small" disabled={savingTreeLimits} onClick={handleSaveTreeLimits}
                      sx={{ alignSelf: 'flex-start', height: 36, textTransform: 'none', fontWeight: 600, fontSize: 12, bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}>
                      {savingTreeLimits ? <CircularProgress size={14} sx={{ color: '#E3E3DF' }} /> : 'Save Tree Limits'}
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ mt: 3, p: 2.5, borderRadius: '12px', border: '1px solid', borderColor: 'divider' }}>
                  <Typography fontWeight={700} fontSize={13} sx={{ mb: 0.5 }}>Source Chain Limits</Typography>
                  <Typography fontSize={11} color="text.secondary" sx={{ mb: 2 }}>
                    Maximum source boxes per source-chain board. Existing chains that exceed a new lower limit keep their current sizes but cannot grow further.
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <TextField label="Max sources per chain" type="number" size="small"
                        value={maxChainSourcesInput} onChange={(e) => setMaxChainSourcesInput(e.target.value)}
                        inputProps={{ min: 1, max: 100 }} sx={{ width: 200 }}
                        InputProps={{ sx: { fontSize: 12, height: 36 } }} />
                      <Typography fontSize={11} color="text.disabled">per chain board · default 10</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', maxWidth: 400 }}>
                      {[5, 10, 15, 20, 30].map(v => (
                        <Chip key={v} label={String(v)} size="small" onClick={() => setMaxChainSourcesInput(String(v))}
                          variant={parseInt(maxChainSourcesInput, 10) === v ? 'filled' : 'outlined'}
                          sx={{ fontSize: 10, height: 22, cursor: 'pointer', fontWeight: parseInt(maxChainSourcesInput, 10) === v ? 700 : 400 }} />
                      ))}
                    </Box>
                    <Button variant="contained" size="small" disabled={savingChainLimits} onClick={handleSaveChainLimits}
                      sx={{ alignSelf: 'flex-start', height: 36, textTransform: 'none', fontWeight: 600, fontSize: 12, bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}>
                      {savingChainLimits ? <CircularProgress size={14} sx={{ color: '#E3E3DF' }} /> : 'Save Chain Limits'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
            {tab === 6 && (
              <TranslationsAdmin apiHeaders={apiHeaders} setSnack={setSnack} />
            )}
          </>
        )}
      </Box>

      <Dialog open={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} disableScrollLock PaperProps={{ sx: { borderRadius: '12px' } }}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography fontWeight={700} sx={{ mb: 1, color: '#ef4444' }}>Delete {deleteConfirm?.type}: {deleteConfirm?.label}?</Typography>
          <Typography fontSize={12} color="text.secondary" sx={{ mb: 2 }}>
            {deleteConfirm?.type === 'user' ? 'This deletes the user and ALL their boards and sources permanently.' : 'This deletes the board and all its sources permanently.'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
            <Button variant="outlined" onClick={() => setDeleteConfirm(null)} size="small">Cancel</Button>
            <Button variant="contained" color="error" onClick={handleDeleteConfirm} size="small">Delete Permanently</Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar open={!!snack} autoHideDuration={3500} onClose={() => setSnack('')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={snack.toLowerCase().includes('fail') || snack.toLowerCase().includes('must') || snack.toLowerCase().includes('enter') ? 'error' : 'success'}
          onClose={() => setSnack('')} sx={{ fontSize: 13, fontWeight: 600 }}>
          {snack}
        </Alert>
      </Snackbar>
    </Box>
  );
};

// ▓▓▓▓▓ SAVED BOARDS / SIDEBAR / EDIT LOG ▓▓▓▓▓
const SavedBoardsList: React.FC<{ apiHeaders: () => Record<string, string>; isDark: boolean; onLoadBoard: (bid: string) => void; appSettings: any }> = ({ apiHeaders, isDark, onLoadBoard, appSettings }) => {
  const [boards, setBoards] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${API_BASE}/saved-boards`, { headers: apiHeaders() })
      .then(r => r.json())
      .then(d => { setBoards(d.boards || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);
  const handleUnsave = async (boardId: string) => {
    await fetch(`${API_BASE}/saved-boards/${boardId}`, { method: 'DELETE', headers: apiHeaders() });
    setBoards(prev => prev.filter(b => b.board_id !== boardId));
  };
  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={24} /></Box>;
  if (boards.length === 0) return (
    <Box sx={{ textAlign: 'center', py: 6, color: 'text.disabled' }}>
      <BookmarkIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
      <Typography fontSize={14} fontWeight={600} color="text.secondary">No saved boards yet</Typography>
      <Typography fontSize={11} color="text.disabled" sx={{ mt: 0.5 }}>Browse public boards and click the bookmark icon to save them here.</Typography>
    </Box>
  );
  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 1, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography fontSize={9} fontWeight={700} color="text.disabled" sx={{ width: 130, textTransform: 'uppercase', letterSpacing: 0.5 }}>Board ID</Typography>
        <Typography fontSize={9} fontWeight={700} color="text.disabled" sx={{ flex: 1, textTransform: 'uppercase', letterSpacing: 0.5 }}>Title</Typography>
        <Typography fontSize={9} fontWeight={700} color="text.disabled" sx={{ width: 90, textTransform: 'uppercase', letterSpacing: 0.5 }}>Owner</Typography>
        <Typography fontSize={9} fontWeight={700} color="text.disabled" sx={{ width: 50, textTransform: 'uppercase', letterSpacing: 0.5, textAlign: 'center' }}>Sources</Typography>
        <Typography fontSize={9} fontWeight={700} color="text.disabled" sx={{ width: 80, textTransform: 'uppercase', letterSpacing: 0.5 }}>Saved</Typography>
        <Box sx={{ width: 32 }} />
      </Box>
      {boards.map(b => (
        <Box key={b.board_id} sx={{ display: 'flex', alignItems: 'center', px: 2, py: 0.8, borderBottom: '1px solid', borderColor: 'divider', cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' }, '&:last-child': { borderBottom: 'none' } }}
          onClick={() => onLoadBoard(b.board_id)}>
          <Box sx={{ width: 130, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {b.is_public ? <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#10b981', flexShrink: 0 }} /> : <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'text.disabled', opacity: 0.3, flexShrink: 0 }} />}
            <Typography sx={{ fontSize: 10, fontFamily: 'monospace', color: 'primary.main', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{dispId(b.board_id)}</Typography>
          </Box>
          <Typography sx={{ flex: 1, fontSize: 11, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 1 }}>{b.title || '—'}</Typography>
          <Typography sx={{ width: 90, fontSize: 10, color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.owner_username || '—'}</Typography>
          <Typography sx={{ width: 50, fontSize: 10, color: 'text.secondary', textAlign: 'center' }}>{b.source_count || 0}</Typography>
          <Typography sx={{ width: 80, fontSize: 9, color: 'text.disabled' }}>{b.saved_at ? formatTimestamp(b.saved_at, appSettings) : '—'}</Typography>
          <Tooltip title="Remove from saved">
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleUnsave(b.board_id); }} sx={{ width: 24, height: 24, '&:hover': { color: '#ef4444' } }}>
              <CloseIcon sx={{ fontSize: 12 }} />
            </IconButton>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

const Sidebar: React.FC<{ onOpenMySourcesDialog: () => void; onOpenMySources: () => void; onOpenSaved: () => void; isSignedIn: boolean; isCollapsed: boolean; setIsCollapsed: (v: boolean) => void; onNewBoard: () => void; isPublic: boolean; appMode: AppMode; onOpenSettings: () => void; isAdmin?: boolean; onOpenAdmin?: () => void; onSignIn: () => void; onSignUp: () => void; onAccount: () => void; onLogout: () => void; onProfile: () => void; onPrevBoard?: () => void; hasPrevBoard?: boolean; activeView?: string; boardId?: string; boardHistory?: Array<{ boardId: string; title?: string; isPublic?: boolean }>; onLoadHistory?: (bid: string) => void; onRemoveHistory?: (bid: string) => void }> = ({ onOpenMySourcesDialog, onOpenMySources, onOpenSaved, isSignedIn, isCollapsed, setIsCollapsed, onNewBoard, isPublic, appMode, onOpenSettings, isAdmin, onOpenAdmin, onSignIn, onSignUp, onAccount, onLogout, onProfile, onPrevBoard, hasPrevBoard, activeView, boardId, boardHistory = [], onLoadHistory, onRemoveHistory }) => {
  const { t } = useTranslation();
  const isOnBoard = appMode !== 'none';
  const activeSx = (view: string) => activeView === view ? { bgcolor: 'rgba(59,130,246,0.12)', '& .MuiListItemIcon-root svg': { color: '#3b82f6' }, '& .MuiListItemText-primary': { color: '#3b82f6', fontWeight: 700 } } : {};
  const activeIconSx = (view: string) => activeView === view ? { bgcolor: 'rgba(59,130,246,0.15)', color: '#3b82f6' } : {};
  if (isCollapsed) return (
    <Box sx={{ width: 46, height: '100vh', bgcolor: 'background.paper', borderRight: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1.5, userSelect: 'none' }}>
      <Tooltip title="Expand" placement="right"><IconButton onClick={() => setIsCollapsed(false)} size="small" sx={{ mb: 1.5 }}><ViewSidebarIcon fontSize="small" /></IconButton></Tooltip>
      <Divider sx={{ width: '70%', mb: 1 }} />
      <Tooltip title={t('sidebar.dashboard', 'Dashboard')} placement="right"><IconButton onClick={onOpenMySourcesDialog} size="small" sx={{ mb: 0.5, borderRadius: '6px', ...activeIconSx('home') }}><DashboardIcon fontSize="small" /></IconButton></Tooltip>
      <Tooltip title={t('dash.mySources', 'My sources')} placement="right"><IconButton onClick={onOpenMySources} size="small" sx={{ mb: 0.5, borderRadius: '6px', ...activeIconSx('sources') }}><StorageIcon fontSize="small" /></IconButton></Tooltip>
      {isSignedIn && <Tooltip title={t('dash.saved', 'Saved boards')} placement="right"><IconButton onClick={onOpenSaved} size="small" sx={{ mb: 0.5, borderRadius: '6px', ...activeIconSx('saved') }}><BookmarkIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>}
      {hasPrevBoard && <Tooltip title={t('sidebar.lastBoard', 'Last Board')} placement="right"><IconButton onClick={onPrevBoard} size="small" sx={{ mb: 0.5, color: 'primary.main' }}><HistoryIcon fontSize="small" /></IconButton></Tooltip>}
      <Tooltip title={t('dash.newBoard', 'New board')} placement="right"><IconButton onClick={onNewBoard} size="small" sx={{ mb: 0.5, borderRadius: '6px', ...activeIconSx('create') }}><AddIcon fontSize="small" /></IconButton></Tooltip>
      {isOnBoard && boardId && (
        <>
          <Divider sx={{ width: '70%', my: 0.5 }} />
          <Tooltip title={`Board: ${boardId}`} placement="right">
            <Box sx={{ width: 34, py: 0.5, borderRadius: '6px', bgcolor: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'default', mb: 0.3 }}>
              <Typography sx={{ fontSize: 7, fontFamily: 'monospace', color: '#3b82f6', fontWeight: 700, textAlign: 'center', lineHeight: 1.2 }}>{boardId.substring(0, 4)}<br/>{boardId.substring(4, 8)}</Typography>
            </Box>
          </Tooltip>
        </>
      )}
      {boardHistory.filter(h => h.boardId !== boardId).slice(0, 3).map(h => (
        <Tooltip key={h.boardId} title={`${dispId(h.boardId)}${h.title ? ': ' + h.title : ''}${h.isPublic ? ' (public)' : ''}`} placement="right">
          <IconButton size="small" onClick={() => onLoadHistory?.(h.boardId)} sx={{ mb: 0.3, width: 34, height: 22, borderRadius: '5px', bgcolor: 'rgba(255,255,255,0.03)', '&:hover': { bgcolor: 'action.hover' }, position: 'relative' }}>
            <Typography sx={{ fontSize: 7, fontFamily: 'monospace', color: 'text.disabled', lineHeight: 1 }}>{dispId(h.boardId).substring(0, 5)}</Typography>
            {h.isPublic && <Box sx={{ position: 'absolute', top: 2, right: 2, width: 5, height: 5, borderRadius: '50%', bgcolor: '#10b981' }} />}
          </IconButton>
        </Tooltip>
      ))}
      <Box sx={{ flex: 1 }} />
      <Divider sx={{ width: '70%', mb: 0.5 }} />
      {isSignedIn && <Tooltip title={t('dash.settings', 'Settings')} placement="right"><IconButton onClick={onOpenSettings} size="small" sx={{ mb: 0.5 }}><SettingsIcon fontSize="small" /></IconButton></Tooltip>}
      {isSignedIn && <Tooltip title={t('dash.profile', 'Public profile')} placement="right"><IconButton onClick={onProfile} size="small" sx={{ mb: 0.5 }}><AccountCircleIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>}
      {isAdmin && <Tooltip title="Admin Panel" placement="right"><IconButton onClick={onOpenAdmin} size="small" sx={{ mb: 0.5, color: '#ef4444' }}><AdminPanelSettingsIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>}
      <Tooltip title="Docs" placement="right"><IconButton onClick={() => window.open(`${window.location.protocol}//${window.location.host}/docs/`, '_blank', 'noopener,noreferrer')} size="small" sx={{ mb: 0.5 }}><MenuBookIcon sx={{ fontSize: 16 }} /></IconButton></Tooltip>
      <Divider sx={{ width: '70%', my: 0.5 }} />
      {isSignedIn
        ? <>
            <Tooltip title={t('sidebar.logout', 'Logout')} placement="right"><IconButton size="small" onClick={onLogout} sx={{ mb: 0.5 }}><LogoutIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title={t('sidebar.account', 'Account')} placement="right"><IconButton size="small" onClick={onAccount} sx={{ mb: 0.25 }}><AccountCircleIcon sx={{ fontSize: 18 }} /></IconButton></Tooltip>
          </>
        : <><Tooltip title={t('sidebar.signin', 'Sign In')} placement="right"><IconButton size="small" onClick={onSignIn} sx={{ mb: 0.5 }}><LoginIcon fontSize="small" /></IconButton></Tooltip>
           <Tooltip title={t('sidebar.signup', 'Sign Up')} placement="right"><IconButton size="small" onClick={onSignUp} sx={{ color: 'primary.main' }}><PersonAddIcon fontSize="small" /></IconButton></Tooltip></>}
    </Box>
  );

  return (
    <Box sx={{ width: 190, height: '100vh', bgcolor: 'background.paper', borderRight: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', userSelect: 'none' }}>
      <Box sx={{ p: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><Typography sx={{ fontSize: '1.35rem', fontWeight: 700 }}>source<span style={{ color: '#5b8fc7' }}>.</span></Typography><IconButton onClick={() => setIsCollapsed(true)} size="small"><ViewSidebarIcon fontSize="small" /></IconButton></Box>
      <Divider />
      <List sx={{ px: 0.5 }} dense>
        <ListItem disablePadding><ListItemButton onClick={onOpenMySourcesDialog} sx={{ borderRadius: '4px', py: 0.35, ...activeSx('home') }}><ListItemIcon sx={{ minWidth: 24 }}><DashboardIcon sx={{ fontSize: 14 }} /></ListItemIcon><ListItemText primary={t('sidebar.dashboard', 'Dashboard')} primaryTypographyProps={{ fontSize: 10 }} /></ListItemButton></ListItem>
        <ListItem disablePadding><ListItemButton onClick={onOpenMySources} sx={{ borderRadius: '4px', py: 0.35, ...activeSx('sources') }}><ListItemIcon sx={{ minWidth: 24 }}><StorageIcon sx={{ fontSize: 14 }} /></ListItemIcon><ListItemText primary={t('dash.mySources', 'My sources')} primaryTypographyProps={{ fontSize: 10 }} /></ListItemButton></ListItem>
        {isSignedIn && <ListItem disablePadding><ListItemButton onClick={onOpenSaved} sx={{ borderRadius: '4px', py: 0.35, ...activeSx('saved') }}><ListItemIcon sx={{ minWidth: 24 }}><BookmarkIcon sx={{ fontSize: 14 }} /></ListItemIcon><ListItemText primary={t('dash.saved', 'Saved boards')} primaryTypographyProps={{ fontSize: 10 }} /></ListItemButton></ListItem>}
        {hasPrevBoard && <ListItem disablePadding><ListItemButton onClick={onPrevBoard} sx={{ borderRadius: '4px', py: 0.35 }}><ListItemIcon sx={{ minWidth: 24 }}><HistoryIcon sx={{ fontSize: 14, color: 'primary.main' }} /></ListItemIcon><ListItemText primary={t('sidebar.lastBoard', 'Last Board')} primaryTypographyProps={{ fontSize: 10, color: 'primary.main', fontWeight: 600 }} /></ListItemButton></ListItem>}
        <ListItem disablePadding><ListItemButton onClick={onNewBoard} sx={{ borderRadius: '4px', py: 0.35, ...activeSx('create') }}><ListItemIcon sx={{ minWidth: 24 }}><AddIcon sx={{ fontSize: 14 }} /></ListItemIcon><ListItemText primary={t('sidebar.createSource', 'Create Source')} primaryTypographyProps={{ fontSize: 10 }} /></ListItemButton></ListItem>
      </List>
      {(isOnBoard || boardHistory.length > 0) && (
        <Box sx={{ mx: 0.5, my: 0.5 }}>
          <Typography sx={{ fontSize: 8.5, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8, px: 1, mb: 0.3 }}>{t('sidebar.recentBoards', 'Recent Boards')}</Typography>
          <List dense sx={{ p: 0 }}>
            {isOnBoard && boardId && (() => {
              const histEntry = boardHistory.find(h => h.boardId === boardId);
              const titleText = histEntry?.title || 'Current board';
              return (
                <ListItem disablePadding>
                  <ListItemButton sx={{ borderRadius: '4px', py: 0.4, bgcolor: 'rgba(59,130,246,0.18)', '& .MuiListItemText-primary': { color: '#3b82f6', fontWeight: 700 }, '&:hover': { bgcolor: 'rgba(59,130,246,0.24)' } }}>
                    <ListItemIcon sx={{ minWidth: 20 }}>
                      <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: isPublic ? '#10b981' : '#3b82f6' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={titleText}
                      primaryTypographyProps={{ fontSize: 10, fontWeight: 700, noWrap: true }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })()}
            {boardHistory.filter(h => h.boardId !== boardId).slice(0, 3).map(h => (
              <ListItem key={h.boardId} disablePadding secondaryAction={
                <IconButton edge="end" size="small" onClick={(e) => { e.stopPropagation(); onRemoveHistory?.(h.boardId); }} sx={{ width: 18, height: 18, opacity: 0, transition: 'opacity 0.15s', '&:hover': { opacity: 1, bgcolor: 'rgba(239,68,68,0.1)' } }} className="history-remove">
                  <CloseIcon sx={{ fontSize: 10, color: '#ef4444' }} />
                </IconButton>
              }>
                <ListItemButton onClick={() => onLoadHistory?.(h.boardId)} sx={{ borderRadius: '4px', py: 0.4, pr: 4, '&:hover .history-remove': { opacity: 0.6 } }}>
                  <ListItemIcon sx={{ minWidth: 20 }}>
                    <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: h.isPublic ? '#10b981' : 'text.disabled', opacity: h.isPublic ? 1 : 0.35 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={h.title || 'Untitled board'}
                    primaryTypographyProps={{ fontSize: 10, noWrap: true, fontWeight: 500 }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
      <Box sx={{ flex: 1 }} />
      <Divider />
      <Box sx={{ px: 1.5, pt: 0.8, pb: 0.3 }}><Typography fontSize={8.5} fontWeight={700} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 0.8 }}>Settings</Typography></Box>
      <List sx={{ px: 0.5, pb: 0 }} dense>
        {isSignedIn && <ListItem disablePadding><ListItemButton onClick={onOpenSettings} sx={{ borderRadius: '4px', py: 0.25, ...activeSx('settings') }}><ListItemIcon sx={{ minWidth: 24 }}><SettingsIcon sx={{ fontSize: 13, color: 'text.disabled' }} /></ListItemIcon><ListItemText primary={t('dash.settings', 'Settings')} primaryTypographyProps={{ fontSize: 9.5, color: 'text.secondary' }} /></ListItemButton></ListItem>}
        {isSignedIn && <ListItem disablePadding><ListItemButton onClick={onProfile} sx={{ borderRadius: '4px', py: 0.25, ...activeSx('profile') }}><ListItemIcon sx={{ minWidth: 24 }}><AccountCircleIcon sx={{ fontSize: 13, color: 'text.disabled' }} /></ListItemIcon><ListItemText primary={t('dash.profile', 'Public profile')} primaryTypographyProps={{ fontSize: 9.5, color: 'text.secondary' }} /></ListItemButton></ListItem>}
        {isAdmin && <ListItem disablePadding><ListItemButton onClick={onOpenAdmin} sx={{ borderRadius: '4px', py: 0.25 }}><ListItemIcon sx={{ minWidth: 24 }}><AdminPanelSettingsIcon sx={{ fontSize: 13, color: '#ef4444' }} /></ListItemIcon><ListItemText primary="Admin" primaryTypographyProps={{ fontSize: 9.5, color: '#ef4444', fontWeight: 600 }} /></ListItemButton></ListItem>}
      </List>
      <Divider />
      <List sx={{ px: 0.5, py: 0.5 }} dense>
        <ListItem disablePadding><ListItemButton onClick={() => window.open(`${window.location.protocol}//${window.location.host}/docs/`, '_blank', 'noopener,noreferrer')} sx={{ borderRadius: '4px', py: 0.25 }}><ListItemIcon sx={{ minWidth: 24 }}><MenuBookIcon sx={{ fontSize: 13, color: 'text.disabled' }} /></ListItemIcon><ListItemText primary="Docs" primaryTypographyProps={{ fontSize: 9.5, color: 'text.secondary' }} /></ListItemButton></ListItem>
      </List>
      <Divider />
      <Box sx={{ p: 1 }}>
        {isSignedIn ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4 }}>
            <Box onClick={onLogout} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 0.6, py: 0.5, borderRadius: '6px', cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
              <LogoutIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography fontSize={10}>{t('sidebar.logout', 'Logout')}</Typography>
            </Box>
            <Box onClick={onAccount} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 0.6, py: 0.5, borderRadius: '6px', cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
              <AccountCircleIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
              <Typography fontSize={10}>{t('sidebar.account', 'Account')}</Typography>
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Button fullWidth variant="contained" size="small" startIcon={<LoginIcon sx={{ fontSize: 13 }} />} onClick={onSignIn} sx={{ fontSize: 10, textTransform: 'none', py: 0.6 }}>Sign In</Button>
            <Button fullWidth variant="outlined" size="small" startIcon={<PersonAddIcon sx={{ fontSize: 13 }} />} onClick={onSignUp} sx={{ fontSize: 10, textTransform: 'none', py: 0.6 }}>Create Account</Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const EditLogTable: React.FC<{ entries: Array<{ sourceId: string; field: string; oldValue: string; newValue: string; editedAt: string; editedBy: string }>; isDark: boolean; appSettings?: AppSettings }> = ({ entries, isDark, appSettings: settings }) => {
  const [sortCol, setSortCol] = useState<string>('editedAt');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const handleSort = (col: string) => {
    if (sortCol === col) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir(col === 'editedAt' ? 'desc' : 'asc'); }
  };
  const sorted = [...entries].sort((a, b) => {
    const va = (a as any)[sortCol] || '';
    const vb = (b as any)[sortCol] || '';
    if (sortCol === 'editedAt') return sortDir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    return sortDir === 'asc' ? String(va).localeCompare(String(vb)) : String(vb).localeCompare(String(va));
  });
  const cols: { key: string; label: string; width?: string | number }[] = [
    { key: 'editedAt', label: 'Date', width: 145 },
    { key: 'field', label: 'Field', width: 120 },
    { key: 'sourceId', label: 'Source', width: 90 },
    { key: 'oldValue', label: 'Previous Value' },
    { key: 'newValue', label: 'New Value' },
    { key: 'editedBy', label: 'By', width: 100 },
  ];
  const SortHeader = ({ col }: { col: typeof cols[0] }) => (
    <TableCell onClick={() => handleSort(col.key)} sx={{ cursor: 'pointer', fontWeight: 700, fontSize: 10, py: 1.2, userSelect: 'none', width: col.width, whiteSpace: 'nowrap', color: sortCol === col.key ? 'text.primary' : 'text.secondary', '&:hover': { color: 'primary.main' }, textTransform: 'uppercase', letterSpacing: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
        {col.label}
        {sortCol === col.key ? (sortDir === 'asc' ? <ArrowDropUpIcon sx={{ fontSize: 14 }} /> : <ArrowDropDownIcon sx={{ fontSize: 14 }} />) : <Box sx={{ width: 14 }} />}
      </Box>
    </TableCell>
  );
  return (
    <Table size="small" sx={{ '& .MuiTableCell-root': { borderColor: 'divider' } }}>
      <TableHead>
        <TableRow sx={{ bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)' }}>
          {cols.map(c => <SortHeader key={c.key} col={c} />)}
        </TableRow>
      </TableHead>
      <TableBody>
        {sorted.map((e, i) => (
          <TableRow key={i} sx={{ '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)' } }}>
            <TableCell sx={{ fontSize: 11, fontFamily: 'monospace', whiteSpace: 'nowrap', py: 1.2 }}>{formatTimestamp(e.editedAt, settings || DEFAULT_SETTINGS)}</TableCell>
            <TableCell sx={{ py: 1.2 }}>
              <Chip label={e.field} size="small" sx={{ fontSize: 10, height: 20, fontWeight: 600, bgcolor: e.field === 'Deleted' ? 'rgba(239,68,68,0.1)' : e.field === 'Visibility' ? 'rgba(16,185,129,0.1)' : e.field === 'Chain Status' ? 'rgba(245,158,11,0.1)' : isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)', color: e.field === 'Deleted' ? '#ef4444' : e.field === 'Visibility' ? '#10b981' : e.field === 'Chain Status' ? '#f59e0b' : 'text.primary' }} />
            </TableCell>
            <TableCell sx={{ fontSize: 10, fontFamily: 'monospace', color: 'text.disabled', py: 1.2 }}>{e.sourceId === 'board' ? '—' : dispId(e.sourceId)}</TableCell>
            <TableCell sx={{ fontSize: 11, py: 1.2, maxWidth: 200 }}>
              <Typography sx={{ fontSize: 11, color: '#ef4444', opacity: 0.7, textDecoration: 'line-through', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.oldValue || '(empty)'}</Typography>
            </TableCell>
            <TableCell sx={{ fontSize: 11, py: 1.2, maxWidth: 200 }}>
              <Typography sx={{ fontSize: 11, color: '#10b981', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.newValue || '(empty)'}</Typography>
            </TableCell>
            <TableCell sx={{ fontSize: 10, color: 'text.secondary', py: 1.2 }}>{e.editedBy}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const CanvasContextMenu: React.FC<{ anchorPosition: { x: number; y: number } | null; onClose: () => void; onAddSource: () => void; onResetView: () => void; onEndChain: () => void; chainEnded: boolean; isPublic: boolean; appMode: AppMode; onStartSingle: () => void; onStartTree: () => void; readOnly?: boolean }> = ({ anchorPosition, onClose, onAddSource, onResetView, onEndChain, chainEnded, isPublic, appMode, onStartSingle, onStartTree, readOnly }) => (
  <Menu open={Boolean(anchorPosition)} onClose={onClose} disableScrollLock anchorReference="anchorPosition" anchorPosition={anchorPosition ? { top: anchorPosition.y, left: anchorPosition.x } : undefined}>
    {appMode === 'none' && !readOnly && (
      <>
        <MenuItem onClick={() => { onStartSingle(); onClose(); }} sx={{ gap: 1 }}><ViewStreamIcon fontSize="small" color="primary" />Start Source</MenuItem>
        <MenuItem onClick={() => { onStartTree(); onClose(); }} sx={{ gap: 1 }}><AccountTreeIcon fontSize="small" sx={{ color: '#10b981' }} />Start Source Tree</MenuItem>
      </>
    )}
    {appMode === 'single' && !readOnly && (
      <>
        <MenuItem onClick={() => { onAddSource(); onClose(); }} sx={{ gap: 1 }}><AddIcon fontSize="small" color="primary" />Add Source</MenuItem>
        <Divider />
        <MenuItem onClick={() => { onEndChain(); onClose(); }} sx={{ gap: 1, py: 1.2 }}>
          <StopIcon fontSize="small" color={chainEnded ? 'success' : 'error'} />
          <Box>
            <Typography fontSize={12} fontWeight={600} color={chainEnded ? '#10b981' : '#ef4444'}>{chainEnded ? 'Resume chain' : 'Mark as final source'}</Typography>
            <Typography fontSize={9} color="text.disabled">{chainEnded ? 'Re-open to add more sources' : 'No further sources to trace — this is the origin'}</Typography>
          </Box>
        </MenuItem>
      </>
    )}
    <MenuItem onClick={() => { onResetView(); onClose(); }} sx={{ gap: 1 }}><CenterFocusStrongIcon fontSize="small" />Reset View</MenuItem>
  </Menu>
);

interface PerSourceTrust {
  index: number;
  sourceId: string;
  title: string;
  isMain: boolean;
  credibility: number;
  accuracy: number;
  relevance: number;
  verifiability: number;
  completeness: number;
  recency: number;
  avg: number;
}
interface ChainTrust {
  hasData: boolean;
  chainLength: number;
  avgCredibility: number;
  compoundedReliability: number;
  compoundedPercent: number;
  weakestLink: PerSourceTrust | null;
  perSource: PerSourceTrust[];
}
const computeChainTrust = (squares: SquareData[]): ChainTrust => {
  const ordered = [...squares].sort((a, b) => a.order - b.order);
  const perSource: PerSourceTrust[] = ordered.map((sq, i) => {
    const r = sq.trustRates || ({ accuracy: 0, relevance: 0, credibility: 0, verifiability: 0, completeness: 0, recency: 0 } as TrustRates);
    const positives = [r.accuracy, r.relevance, r.credibility, r.verifiability, r.completeness, r.recency].filter(v => v > 0);
    const avg = positives.length ? positives.reduce((a, b) => a + b, 0) / positives.length : 0;
    return {
      index: i,
      sourceId: sq.sourceId,
      title: sq.fields.field2 || sq.fields.field1 || `Source ${i + 1}`,
      isMain: !!sq.isMainSource,
      credibility: r.credibility || 0,
      accuracy: r.accuracy || 0,
      relevance: r.relevance || 0,
      verifiability: r.verifiability || 0,
      completeness: r.completeness || 0,
      recency: r.recency || 0,
      avg: Math.round(avg * 10) / 10,
    };
  });
  const hasData = perSource.some(p => p.credibility > 0 || p.avg > 0);
  const credibilityScores = perSource.map(p => p.credibility).filter(v => v > 0);
  const chainLength = credibilityScores.length;
  const avgCredibility = chainLength > 0 ? credibilityScores.reduce((a, b) => a + b, 0) / chainLength : 0;
  const compoundedReliability = chainLength > 0 ? Math.pow(avgCredibility / 10, chainLength) * 10 : 0;
  const compoundedPercent = Math.round(compoundedReliability * 10);
  const credibilityAssessed = perSource.filter(p => p.credibility > 0);
  const weakestLink = credibilityAssessed.length > 0
    ? credibilityAssessed.reduce((min, p) => p.credibility < min.credibility ? p : min, credibilityAssessed[0])
    : null;
  return {
    hasData,
    chainLength,
    avgCredibility: Math.round(avgCredibility * 10) / 10,
    compoundedReliability: Math.round(compoundedReliability * 10) / 10,
    compoundedPercent,
    weakestLink,
    perSource,
  };
};

const trustColorFor = (score: number): string => {
  if (score <= 0) return '#94a3b8';
  if (score < 4) return '#ef4444';
  if (score < 7) return '#f59e0b';
  return '#10b981';
};
const trustLabelFor = (score: number): string => {
  if (score <= 0) return 'Not assessed';
  if (score < 4) return 'Weak';
  if (score < 7) return 'Moderate';
  return 'Strong';
};

// ▓▓▓▓▓ TRUST DIALOGS & STRIP ▓▓▓▓▓
const TrustStrip: React.FC<{
  trust: ChainTrust;
  onJumpToSource?: (sourceId: string) => void;
  onShowMath?: () => void;
  isDark: boolean;
  showDecayCurve?: boolean;
}> = ({ trust, onJumpToSource, onShowMath, isDark, showDecayCurve }) => {
  const { t } = useTranslation();
  const [graphHidden, setGraphHidden] = useState<boolean>(() => {
    try { return localStorage.getItem('sourceio.trustGraphHidden') === '1'; }
    catch { return false; }
  });
  const toggleGraph = useCallback(() => {
    setGraphHidden(prev => {
      const next = !prev;
      try { localStorage.setItem('sourceio.trustGraphHidden', next ? '1' : '0'); } catch {}
      return next;
    });
  }, []);
  if (!trust.hasData) return null;
  if (trust.chainLength < 1) return null;
  const showCompound = trust.chainLength >= 3;

  const decayPoints = trust.chainLength >= 3 ? Array.from({ length: trust.chainLength }, (_, i) => {
    const p = Math.pow(trust.avgCredibility / 10, i + 1) * 10;
    return Math.round(p * 10) / 10;
  }) : [];

  const sentence = (() => {
    const parts: string[] = [];
    parts.push(`Average credibility ${trust.avgCredibility.toFixed(1)}`);
    if (showCompound) {
      parts.push(`compounded ${trust.compoundedPercent}% across ${trust.chainLength} sources`);
    }
    if (trust.weakestLink) {
      parts.push(`weakest link: ${trust.weakestLink.title} (${trust.weakestLink.credibility.toFixed(1)})`);
    }
    return parts.join(' · ');
  })();

  return (
    <Box sx={{ position: 'absolute', top: 96, left: '50%', transform: 'translateX(-50%)',
      pointerEvents: 'auto', zIndex: 5,
      bgcolor: isDark ? 'rgba(15,15,20,0.85)' : 'rgba(255,255,255,0.92)',
      backdropFilter: 'blur(6px)',
      border: '1px solid', borderColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
      borderRadius: '10px', boxShadow: 2,
      px: 1.6, py: 0.9,
      minWidth: 460, maxWidth: '74vw',
      display: 'flex', flexDirection: 'column', gap: 0.6,
    }}
    role="region"
    aria-label={`Chain trust assessment: ${sentence}`}>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.8, flex: 1, flexWrap: 'wrap' }}>
          <Tooltip title="Mean credibility across all assessed sources in this chain (1–10).">
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.4 }}>
              <Typography sx={{ fontSize: 9, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8 }}>{t('trust.label', 'Trust')}</Typography>
              <Typography sx={{ fontSize: 17, fontWeight: 700, lineHeight: 1, color: trustColorFor(trust.avgCredibility) }}>
                {trust.avgCredibility.toFixed(1)}
              </Typography>
              <Typography sx={{ fontSize: 10, color: 'text.disabled' }}>/10</Typography>
            </Box>
          </Tooltip>
          {showCompound && (
            <Tooltip title={`Joint reliability across ${trust.chainLength} sources: (${(trust.avgCredibility/10).toFixed(2)})^${trust.chainLength} = ${(trust.compoundedReliability/10).toFixed(3)}. The chain-length penalty.`}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.4 }}>
                <Typography sx={{ fontSize: 9, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8 }}>{t('trust.compounded', 'Compounded')}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1, color: trustColorFor(trust.compoundedReliability) }}>
                  {trust.compoundedPercent}%
                </Typography>
                <Typography sx={{ fontSize: 10, color: 'text.disabled' }}>· {trust.chainLength} {t('trust.links', 'links')}</Typography>
              </Box>
            </Tooltip>
          )}
          {trust.weakestLink && (
            <Tooltip title={`Lowest-credibility source in the chain: ${trust.weakestLink.title} — ${trust.weakestLink.credibility.toFixed(1)}/10. Click to jump.`}>
              <Box onClick={() => onJumpToSource && trust.weakestLink && onJumpToSource(trust.weakestLink.sourceId)}
                sx={{ display: 'flex', alignItems: 'baseline', gap: 0.4, cursor: onJumpToSource ? 'pointer' : 'default',
                  '&:hover': onJumpToSource ? { '& .weak-num': { textDecoration: 'underline' } } : undefined }}>
                <Typography sx={{ fontSize: 9, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8 }}>{t('trust.weakest', 'Weakest')}</Typography>
                <Typography className="weak-num" sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1, color: trustColorFor(trust.weakestLink.credibility) }}>
                  {trust.weakestLink.credibility.toFixed(1)}
                </Typography>
                <Typography sx={{ fontSize: 10, color: 'text.disabled', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  · {trust.weakestLink.title}
                </Typography>
              </Box>
            </Tooltip>
          )}
        </Box>
        <Tooltip title={graphHidden ? t('trust.showGraph', 'Show graph') : t('trust.hideGraph', 'Hide graph')}>
          <IconButton size="small" onClick={toggleGraph} sx={{ width: 22, height: 22, flexShrink: 0 }}>
            {graphHidden
              ? <KeyboardArrowDownIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
              : <KeyboardArrowUpIcon sx={{ fontSize: 15, color: 'text.disabled' }} />}
          </IconButton>
        </Tooltip>
        {onShowMath && (
          <Tooltip title={t('trust.viewMath', 'See how this is computed')}>
            <IconButton size="small" onClick={onShowMath} sx={{ width: 22, height: 22, flexShrink: 0 }}>
              <InfoOutlinedIcon sx={{ fontSize: 13, color: 'text.disabled' }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {!graphHidden && (
      <>
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 0,
          minHeight: 60, py: 1, overflowX: 'auto', overflowY: 'visible',
          '&::-webkit-scrollbar': { height: 4 },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(0,0,0,0.15)', borderRadius: 2 } }}
        role="group" aria-label="Per-source credibility chain">

        {trust.perSource.length >= 2 && (
          <Box aria-hidden sx={{
            position: 'absolute',
            left: 16, right: 16, top: '50%',
            height: 1.5,
            bgcolor: isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.15)',
            transform: 'translateY(calc(-50% - 7px))',
            zIndex: 0,
            pointerEvents: 'none',
          }} />
        )}

        {trust.perSource.map((p, i) => {
          const score = p.credibility > 0 ? p.credibility : p.avg;
          const isWeakest = !!trust.weakestLink && p.sourceId === trust.weakestLink.sourceId;
          const titleText = score > 0
            ? `#${p.index + 1} ${p.title} — credibility ${p.credibility.toFixed(1)}, accuracy ${p.accuracy.toFixed(1)}, relevance ${p.relevance.toFixed(1)} (avg ${p.avg.toFixed(1)})`
            : `#${p.index + 1} ${p.title} — not assessed yet`;

          let connector: React.ReactNode = null;
          if (i > 0) {
            const prev = trust.perSource[i - 1];
            const prevScore = prev.credibility > 0 ? prev.credibility : prev.avg;
            const haveBoth = score > 0 && prevScore > 0;
            const delta = haveBoth ? score - prevScore : null;
            const direction: 'up' | 'down' | 'flat' | 'unknown' =
              !haveBoth ? 'unknown' :
              Math.abs(delta!) < 0.05 ? 'flat' :
              delta! > 0 ? 'up' : 'down';
            const deltaColor =
              direction === 'up' ? '#10b981' :
              direction === 'down' ? '#ef4444' :
              direction === 'flat' ? '#94a3b8' : '#cbd5e1';
            const ArrowIcon =
              direction === 'up' ? TrendingUpIcon :
              direction === 'down' ? TrendingDownIcon :
              TrendingFlatIcon;
            const deltaText = haveBoth ? (delta! > 0 ? `+${delta!.toFixed(1)}` : delta!.toFixed(1)) : '—';
            connector = (
              <Box sx={{ flex: 1, minWidth: 36, display: 'flex', justifyContent: 'center',
                  alignItems: 'flex-end', pb: 2.4,
                  position: 'relative', zIndex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.2,
                    bgcolor: isDark ? 'rgba(15,15,20,0.95)' : 'rgba(255,255,255,0.95)',
                    px: 0.5, py: 0.1, borderRadius: '4px',
                    fontSize: 0  }}>
                  <ArrowIcon sx={{ fontSize: 11, color: deltaColor }} />
                  <Typography sx={{ fontSize: 9.5, fontWeight: 600, color: deltaColor, lineHeight: 1 }}>
                    {deltaText}
                  </Typography>
                </Box>
              </Box>
            );
          }

          const boxBg = isWeakest
            ? '#ef4444'
            : (score > 0 ? trustColorFor(score) : (isDark ? 'rgba(148,163,184,0.25)' : 'rgba(148,163,184,0.35)'));

          return (
            <React.Fragment key={p.sourceId}>
              {connector}
              <Tooltip title={titleText} placement="top">
                <Box onClick={() => onJumpToSource && onJumpToSource(p.sourceId)}
                  role="button" aria-label={titleText} tabIndex={0}
                  sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.4,
                    cursor: onJumpToSource ? 'pointer' : 'default',
                    '&:hover .square': { filter: 'brightness(1.1)' },
                    flexShrink: 0, position: 'relative', zIndex: 1 }}>
                  <Box className="square" sx={{
                    width: 32, height: 32, borderRadius: '6px',
                    bgcolor: boxBg,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'filter 0.15s',
                  }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 700, color: score > 0 || isWeakest ? 'white' : 'text.disabled',
                      userSelect: 'none', lineHeight: 1 }}>
                      {score > 0 ? score.toFixed(1) : '—'}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize: 9, fontWeight: 600,
                    color: isWeakest ? '#ef4444' : 'text.disabled',
                    letterSpacing: 0.3, lineHeight: 1, userSelect: 'none' }}>
                    #{p.index + 1}
                  </Typography>
                </Box>
              </Tooltip>
            </React.Fragment>
          );
        })}
      </Box>

      {showDecayCurve && decayPoints.length >= 3 && (
        <Box sx={{ pt: 0.4, borderTop: '1px dashed', borderColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.2 }}>
            <Typography sx={{ fontSize: 8, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8 }}>
              {t('trust.decay', 'Decay')}
            </Typography>
            <Typography sx={{ fontSize: 9, color: 'text.disabled', fontStyle: 'italic' }}>
              {t('trust.decay.subtitle', 'joint reliability after each link')}
            </Typography>
          </Box>
          <svg width="100%" height={20} viewBox={`0 0 ${decayPoints.length * 20} 20`} preserveAspectRatio="none" aria-hidden>
            {(() => {
              const w = decayPoints.length * 20;
              const xStep = w / (decayPoints.length - 1 || 1);
              const yFor = (v: number) => 18 - (v / 10) * 16;
              const path = decayPoints.map((v, i) => `${i === 0 ? 'M' : 'L'} ${i * xStep} ${yFor(v)}`).join(' ');
              const fillPath = `${path} L ${w} 20 L 0 20 Z`;
              return (
                <>
                  <path d={fillPath} fill={trustColorFor(decayPoints[decayPoints.length - 1])} fillOpacity={0.18} />
                  <path d={path} fill="none" stroke={trustColorFor(decayPoints[decayPoints.length - 1])} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
                  {decayPoints.map((v, i) => (
                    <circle key={i} cx={i * xStep} cy={yFor(v)} r={1.5} fill={trustColorFor(v)} />
                  ))}
                </>
              );
            })()}
          </svg>
        </Box>
      )}
      </>
      )}

      <Typography sx={{ fontSize: 9, color: 'text.disabled', fontStyle: 'italic', mt: -0.2 }}>
        {t('trust.disclaimer', 'Owner-assigned scores. Not an independent assessment.')}
      </Typography>
    </Box>
  );
};

const TrustMathDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  trust: ChainTrust;
  isDark: boolean;
  onJumpToSource?: (sourceId: string) => void;
}> = ({ open, onClose, trust, isDark, onJumpToSource }) => {
  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalculateIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography fontWeight={700} fontSize={15}>How the trust score is computed</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Box sx={{ flex: 1, p: 1.2, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
            <Typography sx={{ fontSize: 10, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8, mb: 0.3 }}>Average credibility</Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 700, lineHeight: 1, color: trustColorFor(trust.avgCredibility) }}>
              {trust.avgCredibility.toFixed(1)}<Typography component="span" sx={{ fontSize: 11, color: 'text.disabled', ml: 0.5 }}>/10</Typography>
            </Typography>
            <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5 }}>{trustLabelFor(trust.avgCredibility)}</Typography>
          </Box>
          {trust.chainLength >= 3 && (
            <Box sx={{ flex: 1, p: 1.2, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px solid', borderColor: 'divider' }}>
              <Typography sx={{ fontSize: 10, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.8, mb: 0.3 }}>Compounded reliability</Typography>
              <Typography sx={{ fontSize: 22, fontWeight: 700, lineHeight: 1, color: trustColorFor(trust.compoundedReliability) }}>
                {trust.compoundedPercent}%
              </Typography>
              <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.5 }}>across {trust.chainLength} sources</Typography>
            </Box>
          )}
        </Box>

        <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.8 }}>Formula</Typography>
        <Box sx={{ p: 1.2, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '8px', border: '1px solid', borderColor: 'divider', mb: 2, fontFamily: 'monospace', fontSize: 12 }}>
          <Box>average_credibility = mean(per-source credibility scores) = <strong>{trust.avgCredibility.toFixed(2)}</strong></Box>
          {trust.chainLength >= 3 && (
            <>
              <Box sx={{ mt: 0.6 }}>compounded = (avg/10)<sup>n</sup> × 10, where n = {trust.chainLength}</Box>
              <Box sx={{ mt: 0.3 }}>           = ({(trust.avgCredibility/10).toFixed(3)})<sup>{trust.chainLength}</sup> × 10 = <strong>{trust.compoundedReliability.toFixed(2)}</strong> = <strong>{trust.compoundedPercent}%</strong></Box>
            </>
          )}
        </Box>

        <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.8 }}>Per-source breakdown</Typography>
        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden', mb: 2 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: '24px 1fr 56px 56px 56px 56px 56px', fontSize: 10, fontWeight: 700, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.04)', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            <Box sx={{ px: 0.6, py: 0.6 }}>#</Box>
            <Box sx={{ px: 0.6, py: 0.6 }}>Source</Box>
            <Box sx={{ px: 0.6, py: 0.6, textAlign: 'right' }}>Cred</Box>
            <Box sx={{ px: 0.6, py: 0.6, textAlign: 'right' }}>Acc</Box>
            <Box sx={{ px: 0.6, py: 0.6, textAlign: 'right' }}>Rel</Box>
            <Box sx={{ px: 0.6, py: 0.6, textAlign: 'right' }}>Comp</Box>
            <Box sx={{ px: 0.6, py: 0.6, textAlign: 'right' }}>Rec</Box>
          </Box>
          {trust.perSource.map(p => {
            const isWeakest = !!trust.weakestLink && p.sourceId === trust.weakestLink.sourceId;
            return (
              <Box key={p.sourceId} onClick={() => onJumpToSource && onJumpToSource(p.sourceId)}
                sx={{ display: 'grid', gridTemplateColumns: '24px 1fr 56px 56px 56px 56px 56px', fontSize: 11,
                  borderTop: '1px solid', borderColor: 'divider',
                  bgcolor: isWeakest ? (isDark ? 'rgba(239,68,68,0.10)' : 'rgba(239,68,68,0.06)') : 'transparent',
                  cursor: onJumpToSource ? 'pointer' : 'default',
                  '&:hover': onJumpToSource ? { bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)' } : undefined,
                }}>
                <Box sx={{ px: 0.6, py: 0.6, color: 'text.disabled' }}>{p.index + 1}</Box>
                <Box sx={{ px: 0.6, py: 0.6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  {p.isMain && <Chip size="small" label="seed" sx={{ height: 14, fontSize: 8, fontWeight: 700, '& .MuiChip-label': { px: 0.6 } }} />}
                  {isWeakest && <Chip size="small" label="weakest" color="error" sx={{ height: 14, fontSize: 8, fontWeight: 700, '& .MuiChip-label': { px: 0.6 } }} />}
                  <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.title}</Box>
                </Box>
                {([['credibility', p.credibility], ['accuracy', p.accuracy], ['relevance', p.relevance], ['completeness', p.completeness], ['recency', p.recency]] as const).map(([_k, v]) => (
                  <Box key={_k} sx={{ px: 0.6, py: 0.6, textAlign: 'right', color: v > 0 ? trustColorFor(v) : 'text.disabled', fontFamily: 'monospace', fontWeight: v > 0 ? 700 : 400 }}>
                    {v > 0 ? v.toFixed(1) : '—'}
                  </Box>
                ))}
              </Box>
            );
          })}
        </Box>

        <Box sx={{ p: 1.2, bgcolor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '8px' }}>
          <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#d97706', mb: 0.4 }}>What this number is, and isn't</Typography>
          <Typography sx={{ fontSize: 11, color: 'text.secondary', lineHeight: 1.55 }}>
            These scores are <strong>assigned by the board's owner</strong>, not by an independent reviewer. The compounded number assumes each link is conditional on the previous link being correct — true for citation chains where source N quotes source N-1, less true for parallel sources of the same fact. Treat the strip as a starting point for verification, not a verdict.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

const PerSourceTrustDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  squares: SquareData[];
  sourceId: string | null;
  isDark: boolean;
}> = ({ open, onClose, squares, sourceId, isDark }) => {
  if (!sourceId) return null;
  const isAvg = sourceId === '__avg__';
  const ordered = [...squares].sort((a, b) => a.order - b.order);

  const perSource = ordered.map((sq, i) => {
    const r = sq.trustRates || ({ accuracy: 0, relevance: 0, credibility: 0, verifiability: 0, completeness: 0, recency: 0 } as TrustRates);
    const positives = [r.accuracy, r.relevance, r.credibility, r.verifiability, r.completeness, r.recency].filter(v => v > 0);
    const avg = positives.length ? positives.reduce((a, b) => a + b, 0) / positives.length : 0;
    return {
      square: sq, index: i,
      title: sq.fields.field2 || sq.fields.field1 || `Source ${i + 1}`,
      r, avg: Math.round(avg * 10) / 10,
    };
  });

  const single = isAvg ? null : perSource.find(p => p.square.sourceId === sourceId);
  const assessed = perSource.filter(p => p.avg > 0);
  const chainAvg = assessed.length ? Math.round((assessed.reduce((s, p) => s + p.avg, 0) / assessed.length) * 10) / 10 : 0;

  const rateRows: { label: string; value: number }[] = single ? [
    { label: 'Accuracy',     value: single.r.accuracy || 0 },
    { label: 'Credibility',   value: single.r.credibility || 0 },
    { label: 'Relevance',     value: single.r.relevance || 0 },
    { label: 'Verifiability', value: single.r.verifiability || 0 },
    { label: 'Timeliness',    value: single.r.recency || 0 },
    ...(single.r.completeness ? [{ label: 'Completeness', value: single.r.completeness }] : []),
  ] : [];

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <StarRateIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Typography fontWeight={700} fontSize={14}>
            {isAvg ? 'Chain trust — average' : `Source #${(single?.index || 0) + 1} · trust`}
          </Typography>
        </Box>
        {!isAvg && single && (
          <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {single.title}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {isAvg ? (
          <>
            <Box sx={{ textAlign: 'center', mb: 2, p: 2, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '10px', border: '1px solid', borderColor: 'divider' }}>
              <Typography sx={{ fontSize: 36, fontWeight: 800, lineHeight: 1, color: trustColorFor(chainAvg) }}>
                {chainAvg.toFixed(1)}<Typography component="span" sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, fontWeight: 500 }}>/10</Typography>
              </Typography>
              <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.6 }}>
                across {assessed.length} assessed source{assessed.length === 1 ? '' : 's'} · {trustLabelFor(chainAvg)}
              </Typography>
            </Box>
            <Typography fontSize={11} fontWeight={700} sx={{ mb: 0.6, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Per-source</Typography>
            <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden' }}>
              {perSource.map((p, i) => (
                <Box key={p.square.sourceId} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.7,
                  borderTop: i === 0 ? 0 : '1px solid', borderColor: 'divider' }}>
                  <Typography sx={{ fontSize: 10, color: 'text.disabled', width: 20, textAlign: 'right' }}>#{p.index + 1}</Typography>
                  <Typography sx={{ fontSize: 11, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.title}</Typography>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, fontFamily: 'monospace',
                    color: p.avg > 0 ? trustColorFor(p.avg) : 'text.disabled' }}>
                    {p.avg > 0 ? p.avg.toFixed(1) : '—'}
                  </Typography>
                </Box>
              ))}
            </Box>
          </>
        ) : single ? (
          <>
            <Box sx={{ textAlign: 'center', mb: 2, p: 2, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)', borderRadius: '10px', border: '1px solid', borderColor: 'divider' }}>
              <Typography sx={{ fontSize: 36, fontWeight: 800, lineHeight: 1, color: single.avg > 0 ? trustColorFor(single.avg) : 'text.disabled' }}>
                {single.avg > 0 ? single.avg.toFixed(1) : '—'}<Typography component="span" sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, fontWeight: 500 }}>/10</Typography>
              </Typography>
              <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.6 }}>
                {single.avg > 0 ? trustLabelFor(single.avg) : 'Not assessed yet'}
              </Typography>
            </Box>

            {(() => {
              const sq = single.square;
              const refSet = !!(sq.reference.from || sq.reference.to || sq.reference.notes || sq.reference.notApplicable);
              const sVals = [sq.trustRates.credibility, sq.trustRates.recency, sq.trustRates.completeness].filter(v => v > 0);
              const sAvg = sVals.length ? sVals.reduce((a, b) => a + b, 0) / sVals.length : 0;
              const rVals = [sq.trustRates.accuracy, sq.trustRates.relevance].filter(v => v > 0);
              const rAvg = rVals.length ? rVals.reduce((a, b) => a + b, 0) / rVals.length : 0;
              const Section: React.FC<{ step: number; title: string; sub: string; accent: string; avg: number; rates: Array<{label: string; value: number}>; disabled?: boolean }> =
                ({ step, title, sub, accent, avg, rates, disabled }) => (
                <Box sx={{ p: 1.4, borderRadius: '8px', mb: 1.2,
                  bgcolor: disabled ? (isDark ? 'rgba(255,255,255,0.025)' : 'rgba(0,0,0,0.02)') : (isDark ? `${accent}14` : `${accent}10`),
                  border: '1px solid', borderColor: disabled ? 'divider' : `${accent}45`,
                  opacity: disabled ? 0.55 : 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.6 }}>
                    <Box sx={{ width: 18, height: 18, borderRadius: '50%',
                      bgcolor: disabled ? '#94a3b8' : accent, color: 'white',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 10, fontWeight: 800, flexShrink: 0 }}>{step}</Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography fontSize={11} fontWeight={700} sx={{ color: disabled ? 'text.disabled' : 'text.primary' }}>{title}</Typography>
                      <Typography fontSize={9} color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sub}</Typography>
                    </Box>
                    <Box sx={{ minWidth: 38, textAlign: 'center',
                      bgcolor: avg > 0 ? trustColorFor(avg) : (isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'),
                      color: avg > 0 ? 'white' : 'text.disabled',
                      borderRadius: '4px', px: 0.6, py: 0.2 }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 800, fontFamily: 'monospace', lineHeight: 1 }}>
                        {avg > 0 ? avg.toFixed(1) : '—'}
                      </Typography>
                    </Box>
                  </Box>
                  {rates.map(r => (
                    <Box key={r.label} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.4 }}>
                      <Typography sx={{ fontSize: 11, flex: 1 }}>{r.label}</Typography>
                      <Box sx={{ width: 80, height: 5, bgcolor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)', borderRadius: '3px', overflow: 'hidden' }}>
                        <Box sx={{ width: r.value > 0 ? `${(r.value / 10) * 100}%` : 0, height: '100%',
                          bgcolor: r.value > 0 ? trustColorFor(r.value) : 'transparent' }} />
                      </Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, fontFamily: 'monospace', minWidth: 24, textAlign: 'right',
                        color: r.value > 0 ? trustColorFor(r.value) : 'text.disabled' }}>
                        {r.value > 0 ? r.value.toFixed(1) : '—'}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              );
              return (
                <>
                  <Section step={1} title="Source" sub="The work as a whole"
                    accent="#10b981" avg={sAvg}
                    rates={[
                      { label: 'Credibility',   value: sq.trustRates.credibility || 0 },
                      { label: 'Verifiability', value: sq.trustRates.verifiability || 0 },
                      { label: 'Timeliness',    value: sq.trustRates.recency || 0 },
                      ...(sq.trustRates.completeness ? [{ label: 'Completeness', value: sq.trustRates.completeness }] : []),
                    ]} />
                  <Section step={2} title="Reference"
                    sub={refSet ? 'The cited part of this source' : 'No reference set yet'}
                    accent="#3b82f6" avg={rAvg}
                    rates={[
                      { label: 'Accuracy',  value: sq.trustRates.accuracy || 0 },
                      { label: 'Relevance', value: sq.trustRates.relevance || 0 },
                    ]}
                    disabled={!refSet} />
                </>
              );
            })()}
          </>
        ) : (
          <Typography fontSize={12} color="text.secondary">Source not found.</Typography>
        )}

        <Typography sx={{ fontSize: 10, color: 'text.disabled', fontStyle: 'italic', mt: 1.5, textAlign: 'center' }}>
          Owner-assigned scores. Not an independent assessment.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ▓▓▓▓▓                    S O U R C E   A P P                             ▓▓▓▓▓

interface MobileViewProps {
  squares: SquareData[];
  refPoints: RefPoint[];
  appMode: AppMode;
  boardId: string;
  boardTitle?: string;
  boardUpdatedAt: string | null;
  boardOwnerUsername?: string;
  isPublic: boolean;
  isOwner: boolean;
  isDark: boolean;
  appSettings: AppSettings;
  recentBoards: Array<{ board_id: string; title?: string; updated_at?: string }>;
  onSwitchBoard: (boardId: string) => void;
  onSignIn: () => void;
  isSignedIn: boolean;
  apiBase: string;
  getToken: () => Promise<string | null>;
}

const MobileView: React.FC<MobileViewProps> = (props) => {
  const {
    squares, refPoints, appMode, boardId, boardTitle, boardUpdatedAt,
    boardOwnerUsername, isPublic, isOwner, isDark, appSettings,
    recentBoards, onSwitchBoard, onSignIn, isSignedIn,
  } = props;

  // ─── Local UI state ─────────────────────────────────────────────────
  const [tab, setTab] = useState<'sources' | 'refs' | 'boards' | 'profile'>('sources');
  const [expandedSourceId, setExpandedSourceId] = useState<string | null>(null);
  const [editBannerOpen, setEditBannerOpen] = useState(false);
  const [citeFormat, setCiteFormat] = useState<'apa' | 'harvard' | 'mla' | 'chicago' | 'vancouver'>('apa');
  const [copiedSnackbar, setCopiedSnackbar] = useState<string | null>(null);
  const [viewerOpen, setViewerOpen] = useState<{ url: string; type: string; name: string } | null>(null);

  // ─── Chain-order sorting ────────────────────────────────────────────
  const orderedSources = useMemo(() => {
    if (appMode === 'tree') {
      const seed = squares.find(s => s.isMainSource);
      const refPointMap = new Map<string, SquareData[]>();
      for (const sq of squares) {
        if (sq.isMainSource) continue;
        const rpId = sq.refPointId || '_none';
        if (!refPointMap.has(rpId)) refPointMap.set(rpId, []);
        refPointMap.get(rpId)!.push(sq);
      }
      for (const list of Array.from(refPointMap.values())) {
        list.sort((a, b) => a.order - b.order);
      }
      const flat: SquareData[] = [];
      if (seed) flat.push(seed);
      const orderedRefPoints = [...refPoints].sort((a, b) => a.y - b.y);
      for (const rp of orderedRefPoints) {
        const branch = refPointMap.get(rp.id) || [];
        flat.push(...branch);
      }
      const orphans = refPointMap.get('_none') || [];
      flat.push(...orphans);
      return flat;
    }
    return [...squares].sort((a, b) => b.order - a.order);
  }, [squares, refPoints, appMode]);

  // ─── Helpers ────────────────────────────────────────────────────────
  const copyToClipboard = useCallback((text: string, label: string) => {
    try {
      navigator.clipboard.writeText(text);
      setCopiedSnackbar(label);
      setTimeout(() => setCopiedSnackbar(null), 2000);
    } catch {
      setCopiedSnackbar('Copy failed');
      setTimeout(() => setCopiedSnackbar(null), 2000);
    }
  }, []);

  const sourceTypeFor = useCallback((sq: SquareData) => {
    return ALL_SOURCE_TYPES.find(t => t.type === sq.sourceType);
  }, []);

  const refPointFor = useCallback((sq: SquareData) => {
    if (!sq.refPointId) return null;
    return refPoints.find(rp => rp.id === sq.refPointId) || null;
  }, [refPoints]);

  const fileKind = useCallback((file: UploadedFile | null | undefined): 'audio' | 'pdf' | 'image' | 'archive' | 'other' => {
    if (!file) return 'other';
    if (file.origin === 'web-archive') return 'archive';
    const t = (file.type || '').toLowerCase();
    const n = (file.name || '').toLowerCase();
    if (t.startsWith('audio/') || n.endsWith('.mp3') || n.endsWith('.wav')) return 'audio';
    if (t.includes('pdf') || n.endsWith('.pdf')) return 'pdf';
    if (t.startsWith('image/')) return 'image';
    return 'other';
  }, []);

  // ─── Common screen sections ─────────────────────────────────────────
  const headerBar = (
    <Box sx={{
      position: 'sticky', top: 0, zIndex: 10,
      px: 2, py: 1.2,
      bgcolor: 'background.paper',
      borderBottom: '1px solid', borderColor: 'divider',
      display: 'flex', alignItems: 'center', gap: 1,
    }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {boardTitle || (appMode === 'tree' ? 'Source Tree' : 'Source Chain')}
          </Typography>
          {isPublic && (
            <Chip label="Public" size="small" sx={{ height: 16, fontSize: 9, bgcolor: 'success.main', color: '#fff' }} />
          )}
          {!isPublic && isSignedIn && (
            <Chip label="Private" size="small" sx={{ height: 16, fontSize: 9, bgcolor: 'action.disabledBackground', color: 'text.secondary' }} />
          )}
        </Box>
        <Typography sx={{ fontSize: 10.5, color: 'text.disabled', fontFamily: 'monospace', mt: 0.1 }}>
          {dispId(boardId)}{boardOwnerUsername && ` · by ${boardOwnerUsername}`}{boardUpdatedAt && ` · ${timeSince(boardUpdatedAt)}`}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={() => {
          if (navigator.share) {
            navigator.share({ title: boardTitle || 'source.io board', url: window.location.href }).catch(() => {});
          } else {
            copyToClipboard(window.location.href, 'Link copied');
          }
        }}
        sx={{ color: 'text.secondary' }}>
        <ShareIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );

  const ownerBanner = isOwner && isSignedIn ? (
    <Box sx={{
      mx: 1.5, my: 1, p: 1.2,
      bgcolor: isDark ? 'rgba(245,158,11,0.12)' : 'rgba(245,158,11,0.16)',
      border: '1px solid', borderColor: 'warning.main',
      borderRadius: '8px',
      display: 'flex', alignItems: 'flex-start', gap: 1,
    }}>
      <InfoIcon sx={{ fontSize: 16, color: 'warning.main', mt: 0.2, flexShrink: 0 }} />
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'text.primary' }}>
          Read-only on mobile
        </Typography>
        <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.3, lineHeight: 1.4 }}>
          To add sources, set references, or edit fields, open this board on a desktop browser.
        </Typography>
      </Box>
    </Box>
  ) : null;

  // ─── Sources screen ─────────────────────────────────────────────────
  const sourcesScreen = (
    <Box sx={{ pb: 8 }}>
      {ownerBanner}
      {squares.length === 0 ? (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
            No sources yet
          </Typography>
          {isOwner && (
            <Typography sx={{ fontSize: 12, color: 'text.disabled', mt: 1 }}>
              Open this board on desktop to add your first source.
            </Typography>
          )}
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 1.5, pt: 1 }}>
          {orderedSources.map((sq, idx) => {
            const st = sourceTypeFor(sq);
            const sourceColor = st?.color || '#888';
            const isExpanded = expandedSourceId === sq.sourceId;
            const isFoundation = appMode === 'single' && idx === 0 && !sq.isMainSource;
            const isPrimary = appMode === 'single' && idx === orderedSources.length - 1 && !sq.isMainSource;
            const orderLabel = sq.isMainSource ? 'Seed'
              : isFoundation ? 'Foundation'
              : isPrimary ? 'Primary'
              : `Source ${sq.order}`;
            const f = sq.fields;
            const title = st ? String(f[`field${st.titleField + 1}` as keyof SourceFields] || '') : '';
            const subtitle = st ? String(f[`field${st.subtitleField + 1}` as keyof SourceFields] || '') : '';
            let year = '';
            if (st) {
              for (let i = 0; i < st.fields.length; i++) {
                const fc = st.fields[i];
                const v = String(f[`field${i + 1}` as keyof SourceFields] || '');
                if (!v) continue;
                if (fc.codeTag === 'year' || (fc.codeTag === 'date' && !year)) {
                  year = v.length >= 4 ? v.substring(0, 4) : v;
                }
              }
            }
            const tr = sq.trustRates;
            const trustVals = tr ? [tr.accuracy, tr.relevance, tr.credibility, tr.completeness, tr.recency].filter(v => v > 0) : [];
            const trustAvg = trustVals.length ? trustVals.reduce((a, b) => a + b, 0) / trustVals.length : 0;
            const trustColor = trustAvg >= 7 ? '#10b981' : trustAvg >= 4 ? '#f59e0b' : trustAvg > 0 ? '#ef4444' : 'text.disabled';
            const refSummary = sq.reference.notApplicable ? 'N/A'
              : sq.reference.from || sq.reference.to
                ? `${sq.reference.from || ''}${sq.reference.from && sq.reference.to ? ' → ' : ''}${sq.reference.to || ''}`
                : '';
            return (
              <Box
                key={sq.id}
                onClick={() => setExpandedSourceId(isExpanded ? null : sq.sourceId)}
                sx={{
                  bgcolor: 'background.paper',
                  border: '1px solid', borderColor: 'divider',
                  borderLeft: `3px solid ${sourceColor}`,
                  borderRadius: '8px',
                  p: 1.4,
                  cursor: 'pointer',
                  transition: 'background-color 0.15s',
                  '&:active': { bgcolor: 'action.hover' },
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, mb: 0.5 }}>
                  <Box sx={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    width: 18, height: 18, borderRadius: '4px',
                    bgcolor: `${sourceColor}20`, color: sourceColor, flexShrink: 0,
                  }}>
                    {React.cloneElement(st?.icon as React.ReactElement || <InsertDriveFileIcon />, { sx: { fontSize: 13 } } as any)}
                  </Box>
                  <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: sourceColor, textTransform: 'uppercase', letterSpacing: 0.4 }}>
                    {st?.label || 'Source'}
                  </Typography>
                  <Box sx={{ flex: 1 }} />
                  <Typography sx={{ fontSize: 9, fontWeight: 600, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    {orderLabel}
                  </Typography>
                  {year && (
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: 'text.secondary', fontFamily: 'monospace', ml: 0.5 }}>
                      {year}
                    </Typography>
                  )}
                </Box>
                <Typography sx={{
                  fontSize: 14, fontWeight: 600, color: 'text.primary',
                  lineHeight: 1.3, mb: 0.2,
                  overflow: 'hidden', display: '-webkit-box',
                  WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                }}>
                  {title || 'Untitled'}
                </Typography>
                {subtitle && (
                  <Typography sx={{ fontSize: 12, color: 'text.secondary', lineHeight: 1.3 }}>
                    {subtitle}
                  </Typography>
                )}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.6, flexWrap: 'wrap' }}>
                  {refSummary && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                      <BookmarkIcon sx={{ fontSize: 11, color: 'text.disabled' }} />
                      <Typography sx={{ fontSize: 10.5, color: 'text.secondary' }}>{refSummary}</Typography>
                    </Box>
                  )}
                  {trustAvg > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                      <StarRateIcon sx={{ fontSize: 11, color: trustColor }} />
                      <Typography sx={{ fontSize: 10.5, color: trustColor, fontWeight: 700 }}>{trustAvg.toFixed(1)}</Typography>
                    </Box>
                  )}
                  {sq.uploadedFile && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                      {fileKind(sq.uploadedFile) === 'audio' ? <AudiotrackIcon sx={{ fontSize: 11, color: 'text.disabled' }} />
                        : fileKind(sq.uploadedFile) === 'pdf' ? <PictureAsPdfIcon sx={{ fontSize: 11, color: 'text.disabled' }} />
                        : fileKind(sq.uploadedFile) === 'image' ? <ImageIcon sx={{ fontSize: 11, color: 'text.disabled' }} />
                        : fileKind(sq.uploadedFile) === 'archive' ? <LanguageIcon sx={{ fontSize: 11, color: 'text.disabled' }} />
                        : <InsertDriveFileIcon sx={{ fontSize: 11, color: 'text.disabled' }} />}
                      <Typography sx={{ fontSize: 10.5, color: 'text.disabled' }}>File</Typography>
                    </Box>
                  )}
                  <Box sx={{ flex: 1 }} />
                  <ExpandMoreIcon sx={{
                    fontSize: 16, color: 'text.disabled',
                    transition: 'transform 0.2s',
                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  }} />
                </Box>
                {isExpanded && (
                  <Box sx={{ mt: 1.2, pt: 1.2, borderTop: '1px solid', borderColor: 'divider' }}
                    onClick={(e) => e.stopPropagation()}>
                    {st && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6, mb: 1.2 }}>
                        {st.fields.map((fc, i) => {
                          const v = String(f[`field${i + 1}` as keyof SourceFields] || '');
                          if (!v) return null;
                          if (i === st.titleField || i === st.subtitleField) return null;
                          return (
                            <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.8 }}>
                              <Typography sx={{ fontSize: 10, fontWeight: 600, color: 'text.disabled', minWidth: 70, flexShrink: 0, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                                {fc.label}
                              </Typography>
                              <Typography sx={{ fontSize: 12, color: 'text.primary', flex: 1, wordBreak: 'break-word' }}>
                                {fc.type === 'url' && v.startsWith('http') ? (
                                  <a href={safeHref(v)} target="_blank" rel="noopener noreferrer" style={{ color: sourceColor, textDecoration: 'underline' }}>{v}</a>
                                ) : v}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                    {(sq.reference.from || sq.reference.to || sq.reference.notes) && (
                      <Box sx={{ mb: 1.2, p: 1, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.025)', borderRadius: '6px' }}>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.3 }}>
                          Reference {sq.reference.refType ? `· ${sq.reference.refType}` : ''}
                        </Typography>
                        {(sq.reference.from || sq.reference.to) && (
                          <Typography sx={{ fontSize: 12, color: 'text.primary' }}>
                            {sq.reference.from}{sq.reference.from && sq.reference.to ? ' → ' : ''}{sq.reference.to}
                          </Typography>
                        )}
                        {sq.reference.notes && (
                          <Typography sx={{ fontSize: 11.5, color: 'text.secondary', mt: 0.3, lineHeight: 1.4 }}>
                            {sq.reference.notes}
                          </Typography>
                        )}
                      </Box>
                    )}
                    {trustAvg > 0 && (
                      <Box sx={{ mb: 1.2 }}>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.4 }}>
                          Trust · {trustAvg.toFixed(1)} / 10
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {[
                            { label: 'Accuracy', val: tr.accuracy },
                            { label: 'Relevance', val: tr.relevance },
                            { label: 'Credibility', val: tr.credibility },
                            { label: 'Completeness', val: tr.completeness },
                            { label: 'Recency', val: tr.recency },
                          ].filter(x => x.val > 0).map(x => (
                            <Box key={x.label} sx={{ px: 0.7, py: 0.2, bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: 0.4 }}>
                              <Typography sx={{ fontSize: 10, color: 'text.secondary' }}>{x.label}</Typography>
                              <Typography sx={{ fontSize: 10, fontWeight: 700, color: x.val >= 7 ? '#10b981' : x.val >= 4 ? '#f59e0b' : '#ef4444' }}>{x.val}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                    {sq.uploadedFile && (
                      <Box sx={{ mb: 1.2, p: 1, bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.025)', borderRadius: '6px' }}>
                        <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.4 }}>
                          Reference File
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: 'text.primary', mb: 0.6, wordBreak: 'break-word' }}>
                          {sq.uploadedFile.name}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {sq.uploadedFile.url && (
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={fileKind(sq.uploadedFile) === 'audio' ? <PlayArrowIcon sx={{ fontSize: 13 }} /> : <OpenInNewIcon sx={{ fontSize: 12 }} />}
                              onClick={(e) => { e.stopPropagation(); window.open(safeHref(sq.uploadedFile!.url) || 'about:blank', '_blank', 'noopener,noreferrer'); }}
                              sx={{ fontSize: 10.5, textTransform: 'none', py: 0.3 }}>
                              {fileKind(sq.uploadedFile) === 'audio' ? 'Play audio' : 'Open file'}
                            </Button>
                          )}
                          {fileKind(sq.uploadedFile) === 'archive' && sq.uploadedFile.originalUrl && (
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<LanguageIcon sx={{ fontSize: 12 }} />}
                              onClick={(e) => { e.stopPropagation(); window.open(safeHref(sq.uploadedFile!.originalUrl) || 'about:blank', '_blank', 'noopener,noreferrer'); }}
                              sx={{ fontSize: 10.5, textTransform: 'none', py: 0.3 }}>
                              Visit original
                            </Button>
                          )}
                        </Box>
                      </Box>
                    )}
                    {st && (
                      <Box sx={{ mb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.4 }}>
                          <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Citation
                          </Typography>
                          <Box sx={{ flex: 1 }} />
                          <Select
                            value={citeFormat}
                            onChange={(e) => setCiteFormat(e.target.value as any)}
                            size="small"
                            sx={{ fontSize: 10, height: 22, '& .MuiSelect-select': { py: 0.2, pl: 0.8 } }}
                            onClick={(e) => e.stopPropagation()}>
                            <MenuItem value="apa" sx={{ fontSize: 11 }}>APA</MenuItem>
                            <MenuItem value="harvard" sx={{ fontSize: 11 }}>Harvard</MenuItem>
                            <MenuItem value="mla" sx={{ fontSize: 11 }}>MLA</MenuItem>
                            <MenuItem value="chicago" sx={{ fontSize: 11 }}>Chicago</MenuItem>
                            <MenuItem value="vancouver" sx={{ fontSize: 11 }}>Vancouver</MenuItem>
                          </Select>
                        </Box>
                        <Typography sx={{ fontSize: 11.5, color: 'text.primary', lineHeight: 1.5, fontFamily: 'Georgia, serif' }}>
                          {formatSourceCitationJSX(sq, citeFormat)}
                        </Typography>
                        <Button
                          size="small"
                          startIcon={<ContentCopyIcon sx={{ fontSize: 12 }} />}
                          onClick={(e) => { e.stopPropagation(); copyToClipboard(formatSourceCitationText(sq, citeFormat), 'Citation copied'); }}
                          sx={{ fontSize: 10, textTransform: 'none', mt: 0.5, p: 0, minWidth: 0 }}>
                          Copy citation
                        </Button>
                      </Box>
                    )}
                    <Box sx={{ pt: 0.6, borderTop: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
                      <Typography
                        onClick={(e) => { e.stopPropagation(); copyToClipboard(sq.sourceId, 'ID copied'); }}
                        sx={{ fontSize: 10, fontFamily: 'monospace', color: 'text.disabled', cursor: 'pointer' }}>
                        {dispId(sq.sourceId)}
                      </Typography>
                      {isOwner && (
                        <Typography
                          onClick={(e) => { e.stopPropagation(); setEditBannerOpen(true); }}
                          sx={{ fontSize: 10, color: 'warning.main', cursor: 'pointer' }}>
                          Edit on desktop →
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );

  // ─── References screen ─────────────────────────────────────────────
  const refsScreen = (
    <Box sx={{ pb: 8 }}>
      <Box sx={{ px: 1.5, py: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, flex: 1 }}>References</Typography>
        <Select
          value={citeFormat}
          onChange={(e) => setCiteFormat(e.target.value as any)}
          size="small"
          sx={{ fontSize: 11, height: 28 }}>
          <MenuItem value="apa">APA</MenuItem>
          <MenuItem value="harvard">Harvard</MenuItem>
          <MenuItem value="mla">MLA</MenuItem>
          <MenuItem value="chicago">Chicago</MenuItem>
          <MenuItem value="vancouver">Vancouver</MenuItem>
        </Select>
      </Box>
      <Box sx={{ px: 1.5 }}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
          onClick={() => {
            const all = orderedSources.map((sq, i) => {
              const text = formatSourceCitationText(sq, citeFormat);
              return `[${i + 1}] ${text}`;
            }).filter(Boolean).join('\n\n');
            copyToClipboard(all, 'All references copied');
          }}
          sx={{ mb: 1.5, fontSize: 12, textTransform: 'none' }}>
          Copy all references
        </Button>
      </Box>
      <Box sx={{ px: 1.5, display: 'flex', flexDirection: 'column', gap: 1.2 }}>
        {orderedSources.filter(sq => sourceTypeFor(sq)).map((sq, i) => (
          <Box key={sq.id} sx={{
            p: 1, borderLeft: `3px solid ${sourceTypeFor(sq)?.color || '#888'}`,
            bgcolor: 'background.paper', borderRadius: '4px',
          }}>
            <Typography sx={{ fontSize: 9.5, color: 'text.disabled', mb: 0.3 }}>
              [{i + 1}] {sourceTypeFor(sq)?.label}
            </Typography>
            <Typography sx={{ fontSize: 12, color: 'text.primary', lineHeight: 1.5, fontFamily: 'Georgia, serif' }}>
              {formatSourceCitationJSX(sq, citeFormat)}
            </Typography>
          </Box>
        ))}
        {orderedSources.filter(sq => sourceTypeFor(sq)).length === 0 && (
          <Typography sx={{ fontSize: 12, color: 'text.disabled', textAlign: 'center', mt: 4 }}>
            No citable sources yet
          </Typography>
        )}
      </Box>
    </Box>
  );

  // ─── Boards screen ─────────────────────────────────────────────────
  const boardsScreen = (
    <Box sx={{ pb: 8 }}>
      <Box sx={{ px: 1.5, py: 1.5 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, mb: 1.5 }}>Your Boards</Typography>
        {!isSignedIn ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1.5 }}>
              Sign in to see your boards
            </Typography>
            <Button variant="contained" onClick={onSignIn} sx={{ fontSize: 12, textTransform: 'none' }}>
              Sign in
            </Button>
          </Box>
        ) : recentBoards.length === 0 ? (
          <Typography sx={{ fontSize: 12, color: 'text.disabled', textAlign: 'center', mt: 4 }}>
            No recent boards. Create one on desktop.
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
            {recentBoards.map(b => {
              const isCurrent = b.board_id === boardId;
              return (
                <Box
                  key={b.board_id}
                  onClick={() => { if (!isCurrent) onSwitchBoard(b.board_id); }}
                  sx={{
                    p: 1.2,
                    bgcolor: isCurrent ? 'action.selected' : 'background.paper',
                    border: '1px solid', borderColor: isCurrent ? 'primary.main' : 'divider',
                    borderRadius: '6px',
                    cursor: isCurrent ? 'default' : 'pointer',
                    '&:active': { bgcolor: isCurrent ? 'action.selected' : 'action.hover' },
                  }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {b.title || `Board ${dispId(b.board_id)}`}
                  </Typography>
                  <Typography sx={{ fontSize: 10, color: 'text.disabled', fontFamily: 'monospace', mt: 0.2 }}>
                    {dispId(b.board_id)}{b.updated_at && ` · ${timeSince(b.updated_at)}`}
                  </Typography>
                  {isCurrent && (
                    <Typography sx={{ fontSize: 10, color: 'primary.main', fontWeight: 700, mt: 0.3 }}>
                      Current
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );

  // ─── Profile screen ────────────────────────────────────────────────
  const profileScreen = (
    <Box sx={{ pb: 8, px: 1.5, py: 1.5 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 700, mb: 1.5 }}>Profile</Typography>
      {!isSignedIn ? (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1.5 }}>
            Sign in to access your profile and boards.
          </Typography>
          <Button variant="contained" onClick={onSignIn} sx={{ fontSize: 12, textTransform: 'none' }}>
            Sign in
          </Button>
        </Box>
      ) : (
        <Box>
          <Typography sx={{ fontSize: 12, color: 'text.secondary', mb: 2 }}>
            Profile editing is desktop-only. Use a desktop browser to update your bio, settings, or preferences.
          </Typography>
          <Box sx={{ p: 1.2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: '8px' }}>
            <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.5 }}>About source.io</Typography>
            <Typography sx={{ fontSize: 11, color: 'text.secondary', lineHeight: 1.5 }}>
              Fighting misinformation with transparent, traceable sources.
              Built in Gothenburg, Sweden, in collaboration with Chalmers University of Technology.
            </Typography>
            <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Button
                size="small"
                onClick={() => window.open('/docs/', '_blank', 'noopener,noreferrer')}
                sx={{ fontSize: 10.5, textTransform: 'none' }}>
                Documentation
              </Button>
              <Button
                size="small"
                onClick={() => window.open('/docs/about/', '_blank', 'noopener,noreferrer')}
                sx={{ fontSize: 10.5, textTransform: 'none' }}>
                About
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );

  // ─── Render ────────────────────────────────────────────────────────
  return (
    <Box sx={{
      width: '100vw', height: '100vh',
      bgcolor: 'background.default',
      display: 'flex', flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {headerBar}
      <Box sx={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
        {tab === 'sources' && sourcesScreen}
        {tab === 'refs' && refsScreen}
        {tab === 'boards' && boardsScreen}
        {tab === 'profile' && profileScreen}
      </Box>
      <Box sx={{
        flexShrink: 0,
        borderTop: '1px solid', borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        pb: 'env(safe-area-inset-bottom, 0)',
      }}>
        {[
          { id: 'sources' as const, label: 'Sources', icon: <FormatListBulletedIcon sx={{ fontSize: 20 }} /> },
          { id: 'refs' as const, label: 'Refs', icon: <FormatQuoteIcon sx={{ fontSize: 20 }} /> },
          { id: 'boards' as const, label: 'Boards', icon: <DashboardIcon sx={{ fontSize: 20 }} /> },
          { id: 'profile' as const, label: 'Profile', icon: <PersonIcon sx={{ fontSize: 20 }} /> },
        ].map(t => (
          <Box
            key={t.id}
            onClick={() => setTab(t.id)}
            sx={{
              flex: 1, py: 1, px: 0.5,
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.2,
              cursor: 'pointer',
              color: tab === t.id ? 'primary.main' : 'text.disabled',
              '&:active': { bgcolor: 'action.hover' },
            }}>
            {t.icon}
            <Typography sx={{ fontSize: 9.5, fontWeight: 600 }}>{t.label}</Typography>
          </Box>
        ))}
      </Box>
      <Dialog open={editBannerOpen} onClose={() => setEditBannerOpen(false)}
        PaperProps={{ sx: { borderRadius: '12px', mx: 2 } }}>
        <DialogTitle sx={{ fontSize: 14, pb: 0.5 }}>Open on desktop</DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography sx={{ fontSize: 12.5, color: 'text.secondary', lineHeight: 1.5 }}>
            Editing your boards — adding sources, setting references, uploading files, drawing reference areas, and adjusting trust scores — is only available on the desktop version of source.io.
          </Typography>
          <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mt: 1, lineHeight: 1.5 }}>
            Open this board on a laptop or desktop browser to make changes.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditBannerOpen(false)} sx={{ fontSize: 12, textTransform: 'none' }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={!!copiedSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: '70px !important' }}
        autoHideDuration={2000}
        onClose={() => setCopiedSnackbar(null)}
        message={copiedSnackbar || ''}
      />
    </Box>
  );
};

const SourceApp: React.FC = () => {
  const { isSignedIn, getToken, userId, isLoaded: authLoaded } = useAuth();
  const clerk = useClerk();
  const { user: clerkUser, isLoaded: userLoaded } = useUser();
  const [appInitialized, setAppInitialized] = useState(false);
  const clerkUsername = clerkUser?.firstName || clerkUser?.username || clerkUser?.emailAddresses?.[0]?.emailAddress || '';
  const clerkActualUsername = clerkUser?.username || '';
  const currentUserEmailVerified = clerkUser?.emailAddresses?.[0]?.verification?.status === 'verified';
  const tokenRef = useRef<string | null>(null);
  const getTokenRef = useRef(getToken);
  useEffect(() => { getTokenRef.current = getToken; }, [getToken]);
  useEffect(() => {
    if (!isSignedIn) { tokenRef.current = null; return; }
    let cancelled = false;
    const refresh = async () => { try { const t = await getToken(); if (!cancelled) tokenRef.current = t; } catch { if (!cancelled) tokenRef.current = null; } };
    refresh();
    const interval = setInterval(refresh, 45000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [isSignedIn, getToken]);
  const apiHeaders = useCallback(() => ({ 'Content-Type': 'application/json', ...(tokenRef.current ? { 'Authorization': `Bearer ${tokenRef.current}` } : {}) }), []);
  const getApiHeaders = useCallback(async () => {
    try { const t = await getToken(); if (t) tokenRef.current = t; } catch {}
    return { 'Content-Type': 'application/json', ...(tokenRef.current ? { 'Authorization': `Bearer ${tokenRef.current}` } : {}) };
  }, [getToken]);

  useEffect(() => {
    if (!isSignedIn) { setIsAdmin(false); return; }
    const checkAdmin = async (attempt = 0) => {
      try {
        try { const t = await getToken(); if (t) tokenRef.current = t; } catch {}
        if (!tokenRef.current) { if (attempt < 3) { setTimeout(() => checkAdmin(attempt + 1), 1000); return; } setIsAdmin(false); return; }
        const r = await fetch(`${API_BASE}/admin/check`, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${tokenRef.current}` } });
        if (r.ok) { const d = await r.json(); setIsAdmin(!!d.isAdmin); }
        else if (attempt < 2) { setTimeout(() => checkAdmin(attempt + 1), 1500); }
        else setIsAdmin(false);
      } catch { if (attempt < 2) setTimeout(() => checkAdmin(attempt + 1), 1500); else setIsAdmin(false); }
    };
    const t = setTimeout(checkAdmin, 800);
    return () => clearTimeout(t);
  }, [isSignedIn, getToken]);

  useEffect(() => {
    if (!isSignedIn || !currentUserEmailVerified) return;
    const syncVerification = async () => {
      try {
        const t = await getToken();
        if (!t) return;
        await fetch(`${API_BASE}/auth/verify-status`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${t}` },
          body: JSON.stringify({ emailVerified: true })
        });
      } catch {}
    };
    syncVerification();
  }, [isSignedIn, currentUserEmailVerified, getToken]);

  const urlParams = getURLParams();
  const _staticPage = urlParams.staticPage;
  // ─── Mobile viewport detection ──────────────────────────────────────
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    if (new URLSearchParams(window.location.search).get('desktop') === '1') return false;
    return window.matchMedia('(max-width: 768px)').matches;
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (new URLSearchParams(window.location.search).get('desktop') === '1') return;
    const mql = window.matchMedia('(max-width: 768px)');
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);
  const [appMode, setAppMode] = useState<AppMode>('none');
  const [boardId, setBoardId] = useState(() => urlParams.boardId || generateBoardId());
  type BoardHistoryEntry = { boardId: string; zoom: number; offset: { x: number; y: number }; selectedSourceId: string | null; appMode: string; title?: string; isPublic?: boolean };
  const [boardHistory, setBoardHistory] = useState<BoardHistoryEntry[]>([]);
  const boardHistoryLoadedRef = useRef(false);
  useEffect(() => {
    if (!isSignedIn || boardHistoryLoadedRef.current) return;
    boardHistoryLoadedRef.current = true;
    (async () => {
      try {
        const t = await getToken(); if (!t) return;
        const resp = await fetch(`${API_BASE}/recent-boards`, { headers: { 'Authorization': `Bearer ${t}` } });
        if (resp.ok) {
          const data = await resp.json();
          setBoardHistory((data.boards || []).map((b: any) => ({ boardId: b.board_id, zoom: 0.78, offset: { x: 0, y: 0 }, selectedSourceId: null, appMode: b.app_mode || '', title: b.title || '', isPublic: !!b.is_public })));
        }
      } catch {}
    })();
  }, [isSignedIn, getToken]);
  useEffect(() => {
    if (!isSignedIn || !boardHistoryLoadedRef.current || boardHistory.length === 0) return;
    const save = async () => {
      try {
        const t = await getToken(); if (!t) return;
        await fetch(`${API_BASE}/recent-boards`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${t}` }, body: JSON.stringify({ boards: boardHistory.slice(0, 3).map(h => ({ boardId: h.boardId, title: h.title || '', isPublic: !!h.isPublic, appMode: h.appMode || '' })) }) });
      } catch {}
    };
    save();
  }, [boardHistory, isSignedIn, getToken]);
  const prevBoardState = boardHistory.length > 0 ? boardHistory[0] : null;
  const boardIdRef = useRef(boardId);
  useEffect(() => { boardIdRef.current = boardId; }, [boardId]);
  const [chainId, setChainId] = useState<string | null>(() => urlParams.chainId || null);
  const chainIdRef = useRef(chainId);
  useEffect(() => { chainIdRef.current = chainId; }, [chainId]);
  const appModeRef = useRef(appMode);
  useEffect(() => { appModeRef.current = appMode; }, [appMode]);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [colorTheme, setColorTheme] = useState<ColorTheme>('default');
  const [squares, setSquares] = useState<SquareData[]>([]);
  const [refPoints, setRefPoints] = useState<RefPoint[]>([]);
  const [isPublic, setIsPublic] = useState(false);
  const [createdByAi, setCreatedByAi] = useState(false);
  const [aiAttribution, setAiAttribution] = useState('');
  const [allowTrustVoting, setAllowTrustVoting] = useState(true);
  const [madePublicAt, setMadePublicAt] = useState<string | null>(null);
  const [boardEditLog, setBoardEditLog] = useState<Array<{ sourceId: string; field: string; oldValue: string; newValue: string; editedAt: string; editedBy: string }>>([]);
  const [verifiedCreators, setVerifiedCreators] = useState<Record<string, boolean>>({});
  const [editLogDialogOpen, setEditLogDialogOpen] = useState(false);
  const [isOwner, setIsOwner] = useState(true);
  const squaresRef = useRef(squares);
  useEffect(() => { squaresRef.current = squares; }, [squares]);
  
  const fetchedCreatorsRef = useRef<Set<string>>(new Set());
  useEffect(() => {
    const creatorsSet = new Set(squares.map(sq => sq.createdBy).filter(c => c && c !== 'anonymous'));
    const creators = Array.from(creatorsSet);
    const unknownCreators = creators.filter(c => !fetchedCreatorsRef.current.has(c));
    if (unknownCreators.length === 0) return;
    
    unknownCreators.forEach(c => fetchedCreatorsRef.current.add(c));
    
    const fetchVerification = async () => {
      try {
        const resp = await fetch(`${API_BASE}/users/verified-batch`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ usernames: unknownCreators })
        });
        if (resp.ok) {
          const data = await resp.json();
          if (data.verified) {
            setVerifiedCreators(prev => ({ ...prev, ...data.verified }));
          }
        }
      } catch {}
    };
    fetchVerification();
  }, [squares]);
  
  const refPointsRef = useRef(refPoints);
  useEffect(() => { refPointsRef.current = refPoints; }, [refPoints]);
  const [privateBoardError, setPrivateBoardError] = useState(false);
  const [privateBoardId, setPrivateBoardId] = useState<string>('');
  const [privateBoardEverPublished, setPrivateBoardEverPublished] = useState(false);
  const [appSettings, setAppSettings] = useState<AppSettings>(DEFAULT_SETTINGS);
  const settingsRef = React.useRef(appSettings);
  React.useEffect(() => { settingsRef.current = appSettings; }, [appSettings]);
  const [treeLimits, setTreeLimits] = useState<{ maxRefPoints: number; maxSourcesPerBranch: number; maxChainSources: number }>({ maxRefPoints: 20, maxSourcesPerBranch: 10, maxChainSources: 10 });
  const treeLimitsRef = React.useRef(treeLimits);
  React.useEffect(() => { treeLimitsRef.current = treeLimits; }, [treeLimits]);
  const refreshTreeLimits = useCallback(async () => {
    try {
      const r = await fetch(`${API_BASE}/tree-limits`);
      if (!r.ok) return;
      const d = await r.json();
      if (d && typeof d.maxRefPoints === 'number' && typeof d.maxSourcesPerBranch === 'number') {
        setTreeLimits({
          maxRefPoints: d.maxRefPoints,
          maxSourcesPerBranch: d.maxSourcesPerBranch,
          maxChainSources: typeof d.maxChainSources === 'number' ? d.maxChainSources : 10,
        });
      }
    } catch {}
  }, []);
  React.useEffect(() => { refreshTreeLimits(); }, [refreshTreeLimits]);
  const nowDate = () => new Date().toISOString();
  const [mySourcesDialogOpen, setMySourcesDialogOpen] = useState(false);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);
  const [aboutDialogOpen, setAboutDialogOpen] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [isBoardSaved, setIsBoardSaved] = useState(false);
  const [dashboardView, setDashboardView] = useState<'home' | 'sources' | 'saved' | 'about' | 'admin' | 'settings' | 'account' | 'profile' | 'search' | 'create'>('home');
  const [dashRefreshKey, setDashRefreshKey] = useState(0);
  const dashViewRef = useRef(dashboardView);
  dashViewRef.current = dashboardView;

  const navigateDashboard = useCallback((view: typeof dashboardView) => {
    if (dashViewRef.current !== 'home' || view !== 'home') {
      window.history.pushState({ dashView: view }, '', window.location.href);
    }
    setDashboardView(view);
    setDashRefreshKey(k => k + 1);
  }, []);

  useEffect(() => {
    const onPop = (e: PopStateEvent) => {
      if (e.state?.dashView) { setDashboardView(e.state.dashView); setDashRefreshKey(k => k + 1); }
      else if (dashViewRef.current !== 'home' && appModeRef.current === 'none') { setDashboardView('home'); }
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  const [viewProfileUsername, setViewProfileUsername] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [modeDialogOpen, setModeDialogOpen] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [showAiPage, setShowAiPage] = useState(false);
  const [demoMode, setDemoMode] = useState(false);
  const demoModeRef = useRef(false);
  useEffect(() => { demoModeRef.current = demoMode; }, [demoMode]);
  useEffect(() => { if (isSignedIn && showSignIn) setShowSignIn(false); }, [isSignedIn, showSignIn]);
  const [refPointDialogOpen, setRefPointDialogOpen] = useState(false);
  const [refPointEditingId, setRefPointEditingId] = useState<string | null>(null);
  const [seedRefSettingsOpen, setSeedRefSettingsOpen] = useState(false);
  const [pendingPointerType, setPendingPointerType] = useState<string | null>(null);
  const [seedEditOpen, setSeedEditOpen] = useState(false);
  useEffect(() => { setSeedEditOpen(false); }, [boardId, appMode]);
  const [warningDialogOpen, setWarningDialogOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [leaveConfirmOpen, setLeaveConfirmOpen] = useState(false);
  const [linkIdDialogOpen, setLinkIdDialogOpen] = useState(false);
  const [linkIdRefPointId, setLinkIdRefPointId] = useState<string | null>(null);
  const [linkIdValue, setLinkIdValue] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [chipDialogSourceId, setChipDialogSourceId] = useState<string | null>(null);
  const [trustMathOpen, setTrustMathOpen] = useState(false);
  const [makePublicBlockOpen, setMakePublicBlockOpen] = useState(false);
  const [makePublicBlockReasons, setMakePublicBlockReasons] = useState<string[]>([]);
  const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [cleanView, setCleanView] = useState(false);
  const [zoom, setZoom] = useState(1.32);
  const [canvasOffset, setCanvasOffset] = useState<Position>({ x: 0, y: 0 });
  const [centerOnSourceReq, setCenterOnSourceReq] = useState<{ sourceId: string; nonce: number } | null>(null);
  const zoomRef = useRef(zoom);
  useEffect(() => { zoomRef.current = zoom; }, [zoom]);
  const canvasOffsetRef = useRef(canvasOffset);
  useEffect(() => { canvasOffsetRef.current = canvasOffset; }, [canvasOffset]);
  const [isPanning, setIsPanning] = useState(false);
  const [panStart, setPanStart] = useState<Position>({ x: 0, y: 0 });
  const [initialOffset, setInitialOffset] = useState<Position>({ x: 0, y: 0 });
  const [chainEnded, setChainEnded] = useState(false);
  const [chainEndReason, setChainEndReason] = useState<'' | 'ended' | 'unknown'>('');
  const [selectedSourceId, setSelectedSourceId] = useState<string | null>(urlParams.sourceId);
  const selectedSourceIdRef = useRef(selectedSourceId);
  useEffect(() => { selectedSourceIdRef.current = selectedSourceId; }, [selectedSourceId]);
  const [selectedRefPointId, setSelectedRefPointId] = useState<string | null>(null);
  const [contextMenu, setContextMenu] = useState<{ x: number; y: number } | null>(null);
  const [graphDialog, setGraphDialog] = useState<{ sourceId: string; label: string } | null>(null);
  const [embedDialog, setEmbedDialog] = useState<{ sourceId: string; label: string } | null>(null);
  const [canvasSize, setCanvasSize] = useState({ width: 1200, height: 800 });
  const [urlTab, setUrlTab] = useState<'ref' | 'file' | 'info' | null>(urlParams.tab as 'ref' | 'file' | 'info' | null);
  const [fileOpenSourceId, setFileOpenSourceId] = useState<string | null>(null);
  const [boardSettingsSourceId, setBoardSettingsSourceId] = useState<string | null>(null);
  const [canvasMenuAnchor, setCanvasMenuAnchor] = useState<HTMLElement | null>(null);
  const [canvasTab, setCanvasTab] = useState<'board' | 'code' | 'refs' | 'relations'>('board');
  const [relatedSources, setRelatedSources] = useState<any[]>([]);
  const [relationsLoading, setRelationsLoading] = useState(false);
  const [relationsSourceId, setRelationsSourceId] = useState<string | null>(null);
  const [relationsTotalCount, setRelationsTotalCount] = useState(0);
  const [relSearchQuery, setRelSearchQuery] = useState('');
  const [relSearchResults, setRelSearchResults] = useState<any[]>([]);
  const [relSearchLoading, setRelSearchLoading] = useState(false);
  const [codeViewTab, setCodeViewTab] = useState<'export' | 'import'>('export');
  const [refsCiteFormat, setRefsCiteFormat] = useState<'apa' | 'harvard' | 'mla' | 'chicago' | 'vancouver'>('apa');
  const importTextRef = useRef<HTMLTextAreaElement>(null);
  const [importConfirmOpen, setImportConfirmOpen] = useState(false);
  const pendingImportCode = useRef<string>('');
  const [canvasLocked, setCanvasLocked] = useState(false);
  const [simpleView, setSimpleView] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const snapToGrid = appSettings.snapToGrid;
  const [chainMenuAnchor, setChainMenuAnchor] = useState<null | HTMLElement>(null);
  const [treeMenuAnchor, setTreeMenuAnchor] = useState<{ el: HTMLElement; rpId: string } | null>(null);
  const [themeMenuAnchor, setThemeMenuAnchor] = useState<null | HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [boardCreatedAt, setBoardCreatedAt] = useState<string | null>(null);
  const [boardUpdatedAt, setBoardUpdatedAt] = useState<string | null>(null);
  const nextId = useRef(1);
  const nextRefPointId = useRef(1);

  const theme = useMemo(() => createAppTheme(isDarkMode ? 'dark' : 'light', colorTheme), [isDarkMode, colorTheme]);

  useEffect(() => { document.title = 'source.io — trace claims to their sources'; }, []);

  const saveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const boardCreatedRef = useRef<Set<string>>(new Set());
  const skipNextSaveRef = useRef(false);

  const ensureBoardExists = useCallback(async (bid: string, mode?: string) => {
    if (!tokenRef.current) return false;
    if (boardCreatedRef.current.has(bid)) return true;
    try {
      const resp = await fetch(`${API_BASE}/boards/${bid}`, { headers: apiHeaders() });
      if (resp.ok) { boardCreatedRef.current.add(bid); return true; }
      const createResp = await fetch(`${API_BASE}/boards`, { method: 'POST', headers: apiHeaders(), body: JSON.stringify({ boardId: bid, name: '', appMode: mode || 'none' }) });
      if (createResp.ok || createResp.status === 409) { boardCreatedRef.current.add(bid); return true; }
      return false;
    } catch { return false; }
  }, [apiHeaders]);

  const isPublicRef = useRef(isPublic);
  useEffect(() => { isPublicRef.current = isPublic; }, [isPublic]);
  const madePublicAtRef = useRef(madePublicAt);
  useEffect(() => { madePublicAtRef.current = madePublicAt; }, [madePublicAt]);
  const boardEditLogRef = useRef(boardEditLog);
  useEffect(() => { boardEditLogRef.current = boardEditLog; }, [boardEditLog]);
  const chainEndedRef = useRef(chainEnded);
  useEffect(() => { chainEndedRef.current = chainEnded; }, [chainEnded]);
  const chainEndReasonRef = useRef(chainEndReason);
  useEffect(() => { chainEndReasonRef.current = chainEndReason; }, [chainEndReason]);
  const colorThemeRef = useRef(colorTheme);
  useEffect(() => { colorThemeRef.current = colorTheme; }, [colorTheme]);

  const lastSavedHashRef = useRef('');

  const saveToApi = useCallback(async (forceBid?: string, forceMode?: string) => {
    if (demoModeRef.current) return;
    try { const t = await getTokenRef.current(); if (t) tokenRef.current = t; } catch {}
    const token = tokenRef.current;
    if (!token) return;
    const bid = forceBid || boardIdRef.current;
    const mode = forceMode || appModeRef.current;
    if (!bid || mode === 'none') return;
    if (!boardCreatedRef.current.has(bid) && squaresRef.current.length === 0) return;
    const hasInput = squaresRef.current.some(s =>
      s.sourceType !== null ||
      Object.values(s.fields).some(v => (v as string).trim() !== '') ||
      s.comments?.trim() ||
      s.uploadedFile
    );
    if (!hasInput) return;
    const hdrs: Record<string, string> = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
    setSaveStatus('saving');
    
    if (!boardCreatedRef.current.has(bid)) {
      try {
        const checkResp = await fetch(`${API_BASE}/boards/${bid}`, { headers: hdrs });
        if (checkResp.ok) {
          boardCreatedRef.current.add(bid);
        } else {
          const createResp = await fetch(`${API_BASE}/boards`, { method: 'POST', headers: hdrs, body: JSON.stringify({ boardId: bid, name: '', appMode: mode }) });
          if (createResp.ok || createResp.status === 409) { boardCreatedRef.current.add(bid); }
          else { console.error('[save] create board failed:', createResp.status); setSaveStatus('error'); return; }
        }
      } catch (e) { console.error('[save] board check error:', e); setSaveStatus('error'); return; }
    }
    
    try {
      const sq = squaresRef.current;
      const rp = refPointsRef.current;
      const body = {
        boardMeta: { name: '', appMode: mode, isPublic: isPublicRef.current, madePublicAt: madePublicAtRef.current, editLog: boardEditLogRef.current, chainEnded: chainEndedRef.current, chainEndReason: chainEndReasonRef.current, colorTheme: colorThemeRef.current, chainId: chainIdRef.current },
        sources: sq.map(s => ({ sourceId: s.sourceId, sourceType: s.sourceType, name: s.name, fields: s.fields, order: s.order, isMainSource: s.isMainSource, refPointId: s.refPointId, reference: s.reference, trustRates: s.trustRates, trustAssessed: s.trustAssessed, comments: s.comments, uploadedFile: s.uploadedFile, apiPrefillFields: s.apiPrefillFields, createdBy: s.createdBy, createdAt: s.createdAt, updatedAt: s.updatedAt })),
        refPoints: rp.map(r => ({
          id: r.id, label: r.label, y: r.y,
          fromValue: r.fromValue || '',
          toValue: r.toValue || '',
          branchEnded: !!r.branchEnded,
          branchEndReason: r.branchEndReason || '',
          fromSectionStartsWith: r.fromSectionStartsWith || '',
          toSectionEndsWith: r.toSectionEndsWith || '',
        })),
      };
      const bodyJson = JSON.stringify(body);
      const hash = bodyJson.length + ':' + bodyJson.substring(0, 200) + bodyJson.substring(bodyJson.length - 200);
      if (hash === lastSavedHashRef.current && !forceBid) { return; }
      const resp = await fetch(`${API_BASE}/boards/${bid}/save`, { method: 'PUT', headers: hdrs, body: bodyJson });
      if (resp.ok) {
        lastSavedHashRef.current = hash;
        setSaveStatus('saved');
        setTimeout(() => setSaveStatus('idle'), 2000);
      } else {
        console.error('[save] failed:', resp.status, await resp.text());
        setSaveStatus('error');
      }
    } catch (e) { console.error('[save] error:', e); setSaveStatus('error'); }
  }, []);

  useEffect(() => {
    if (!isSignedIn || !isOwner || skipNextSaveRef.current) { skipNextSaveRef.current = false; return; }
    if (appMode === 'none') return;
    if (!appSettings.autoSave) return;
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => { saveToApi(); }, 800);
    return () => { if (saveTimerRef.current) clearTimeout(saveTimerRef.current); };
  }, [squares, refPoints, appMode, isPublic, chainEnded, chainEndReason, colorTheme, isSignedIn, isOwner, saveToApi, appSettings.autoSave, boardEditLog]);

  const loadBoardFromApi = useCallback(async (bid: string, targetSourceId?: string | null, opts?: { centerOnHeadline?: boolean; forceNormalView?: boolean }) => {
    const normalBid = normId(bid);
    const normalTarget = targetSourceId ? normId(targetSourceId) : null;
    refreshTreeLimits();
    if (boardIdRef.current && appModeRef.current !== 'none' && boardIdRef.current !== normalBid) {
      const firstTitle = squaresRef.current.length > 0 ? (squaresRef.current.sort((a, b) => b.order - a.order)[0]?.fields?.field2 || squaresRef.current[0]?.fields?.field1 || '') : '';
      setBoardHistory(prev => {
        const entry: BoardHistoryEntry = { boardId: boardIdRef.current, zoom: zoomRef.current, offset: canvasOffsetRef.current, selectedSourceId: selectedSourceIdRef.current, appMode: appModeRef.current, title: firstTitle, isPublic: isPublicRef.current };
        const filtered = prev.filter(e => e.boardId !== entry.boardId);
        return [entry, ...filtered].slice(0, 3);
      });
    }
    try {
      try { const t = await getToken(); if (t) tokenRef.current = t; } catch {}
      let resp = await fetch(`${API_BASE}/boards/${normalBid}`, { headers: apiHeaders() });
      if (resp.status === 403 && tokenRef.current) {
        try { const t = await getToken(); if (t) tokenRef.current = t; } catch {}
        resp = await fetch(`${API_BASE}/boards/${normalBid}`, { headers: apiHeaders() });
      }
      if (resp.status === 403) {
        try { const body = await resp.json(); setPrivateBoardId(body.boardId || normalBid); setPrivateBoardEverPublished(!!body.everPublished); }
        catch { setPrivateBoardId(normalBid); setPrivateBoardEverPublished(false); }
        setPrivateBoardError(true); setModeDialogOpen(false); return false;
      }
      if (!resp.ok) return false;
      setPrivateBoardError(false);
      const data = await resp.json();
      skipNextSaveRef.current = true;
      setAppMode(data.board.appMode as AppMode);
      setIsPublic(data.board.isPublic);
      setCreatedByAi(!!data.board.createdByAi);
      setAiAttribution(data.board.aiAttribution || '');
      setMadePublicAt(data.board.madePublicAt || (data.board.isPublic ? data.board.createdAt : null));
      setBoardEditLog(data.board.editLog || []);
      setIsOwner(data.board.isOwner !== false);
      document.title = data.board.name ? `${data.board.name} — source.io` : 'source.io — trace claims to their sources';
      if (data.board.isOwner === false || !isSignedIn) {
        setCleanView(false);
        setSimpleView(true);
      } else {
        setCleanView(false);
        setSimpleView(false);
      }
      setBoardCreatedAt(data.board.createdAt || null);
      setBoardUpdatedAt(data.board.updatedAt || null);
      setChainEnded(data.board.chainEnded);
      setChainEndReason(data.board.chainEndReason || '');
      setAllowTrustVoting(data.board.allowTrustVoting === undefined ? true : !!data.board.allowTrustVoting);
      setColorTheme(((['default','clerk','claude'].includes(data.board.colorTheme) ? data.board.colorTheme : 'default')) as ColorTheme);
      const loadedSquares: SquareData[] = data.sources.map((s: any, i: number) => ({
        id: i + 1, sourceId: s.sourceId, sourceType: s.sourceType, name: s.name || '',
        fields: { ...emptyFields, ...s.fields },
        order: s.order || i + 1, position: s.position || { x: 80, y: 150 }, size: s.size || { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
        isMainSource: s.isMainSource, refPointId: s.refPointId, reference: { from: '', to: '', notes: '', ...s.reference },
        trustRates: { ...emptyTrustRates, ...s.trustRates }, trustAssessed: s.trustAssessed || false,
        comments: s.comments || '', uploadedFile: s.uploadedFile || null,
        createdAt: s.createdAt || '', updatedAt: s.updatedAt || '', createdBy: s.createdBy || 'anonymous',
        apiPrefillFields: s.apiPrefillFields || undefined,
        isAuthor: !!s.isAuthor,
        trustVoteSourceAgree: s.trustVoteSourceAgree || 0,
        trustVoteSourceDisagree: s.trustVoteSourceDisagree || 0,
        trustVoteReferenceAgree: s.trustVoteReferenceAgree || 0,
        trustVoteReferenceDisagree: s.trustVoteReferenceDisagree || 0,
        currentUserTrustVoteSource: s.currentUserTrustVoteSource || null,
        currentUserTrustVoteReference: s.currentUserTrustVoteReference || null,
      }));
      const loadedRPsForLayout: RefPoint[] = (data.refPoints || []).map((rp: any) => ({
        id: rp.id, label: rp.label || '', y: rp.y || 350,
        value: rp.label || '', fromValue: rp.fromValue || '',
        toValue: rp.toValue || '', branchEnded: !!rp.branchEnded,
        branchEndReason: rp.branchEndReason || '',
        fromSectionStartsWith: rp.fromSectionStartsWith || undefined,
        toSectionEndsWith: rp.toSectionEndsWith || undefined,
        sourceIds: [],
      }));
      const mode = data.board.appMode;
      const STRIDE_X_LAYOUT = SQUARE_WIDTH + 180;
      const positionedSquares = loadedSquares.map((sq) => {
        if (sq.isMainSource && mode === 'tree') {
          return { ...sq, position: { x: 80, y: 80 } };
        }
        if (mode === 'tree') {
          const rp = loadedRPsForLayout.find(r => r.id === sq.refPointId);
          if (!rp) {
            return { ...sq, position: { x: 80, y: 800 + (sq.order || 1) * 50 } };
          }
          const peers = loadedSquares
            .filter(s => s.refPointId === rp.id)
            .sort((a, b) => a.order - b.order);
          const idx = peers.findIndex(s => s.sourceId === sq.sourceId);
          return {
            ...sq,
            position: {
              x: 80 + SQUARE_WIDTH + 100 + idx * STRIDE_X_LAYOUT,
              y: rp.y - SQUARE_HEIGHT / 2,
            },
          };
        }
        const maxOrder = Math.max(...loadedSquares.map(s => s.order || 1));
        const leftToRightIdx = maxOrder - (sq.order || 1);
        return {
          ...sq,
          position: {
            x: 100 + leftToRightIdx * STRIDE_X_LAYOUT,
            y: 100,
          },
        };
      });
      setSquares(positionedSquares);
      nextId.current = positionedSquares.length > 0 ? Math.max(...positionedSquares.map(s => s.id)) + 1 : 1;
      const loadedRPs: RefPoint[] = (data.refPoints || []).map((rp: any) => ({
        id: rp.id,
        label: rp.label || '',
        y: rp.y || 350,
        value: rp.label || '',
        fromValue: rp.fromValue || '',
        toValue: rp.toValue || '',
        branchEnded: !!rp.branchEnded,
        branchEndReason: rp.branchEndReason || '',
        fromSectionStartsWith: rp.fromSectionStartsWith || undefined,
        toSectionEndsWith: rp.toSectionEndsWith || undefined,
        sourceIds: loadedSquares.filter((s: SquareData) => s.refPointId === rp.id).map((s: SquareData) => s.sourceId),
      }));
      setRefPoints(loadedRPs);
      nextRefPointId.current = loadedRPs.length > 0 ? Math.max(...loadedRPs.map(rp => parseInt(rp.id.replace(/^(ref-|rp-)/, '') || '0'))) + 2 : 1;
      boardCreatedRef.current.add(normalBid);
      setBoardId(normalBid);
      if (data.board.appMode === 'single') {
        const loadedCid = data.board.chainId || (data.sources && data.sources.length > 1 ? generateChainId() : null);
        setChainId(loadedCid);
        if (loadedCid) _cacheChain(loadedCid, normalBid);
      } else {
        setChainId(null);
      }
      if (data.board.appMode && data.board.appMode !== 'none') setModeDialogOpen(false);
      setTimeout(() => {
        if (containerRef.current) {
          const rect = containerRef.current.getBoundingClientRect();
          const defZ = settingsRef.current.defaultZoom / 100;
          
          if (normalTarget) {
            const target = loadedSquares.find((s: SquareData) => s.sourceId.toUpperCase() === normalTarget.toUpperCase());
            if (target) {
              const z = 1.0;
              const cx = (target.position.x + target.size.width / 2) * z;
              const cy = (target.position.y + target.size.height / 2) * z;
              setCanvasOffset({ x: (rect.width / 2) - cx, y: (rect.height / 2) - cy });
              setZoom(z);
              setSelectedSourceId(normalTarget.toUpperCase());
              return;
            }
          }
          
          const isVisitor = data.board.isOwner === false;
          const useSimple = opts?.forceNormalView ? false : isVisitor;
          if (opts?.forceNormalView) setSimpleView(false);
          const isTreeMode = data.board.appMode === 'tree';
          const TREE_START_Y_LOCAL = 80;

          if (isTreeMode) {
            const seedSq = loadedSquares.find((s: SquareData) => s.isMainSource);
            const trunkX = seedSq
              ? seedSq.position.x + (seedSq.size?.width || SQUARE_WIDTH) / 2
              : (containerRef.current?.getBoundingClientRect().width || 1280) / 2;
            const z = useSimple ? 1.26 : 0.78;
            const cx = trunkX * z;
            const targetBoxTop = Math.max(80, rect.height * 0.12);
            setCanvasOffset({ x: (rect.width / 2) - cx, y: targetBoxTop - TREE_START_Y_LOCAL * z });
            setZoom(z);
            return;
          }

          if (isVisitor) {
            const seedSq = loadedSquares.find((s: SquareData) => s.isMainSource) || loadedSquares[0];
            if (seedSq) {
              const bw = useSimple ? 220 : SQUARE_WIDTH;
              const z = useSimple ? 1.26 : 0.78;
              const cx = (seedSq.position.x + bw / 2) * z;
              const targetBoxTop = 70 + 140 * z;
              setCanvasOffset({ x: (rect.width / 2) - cx, y: targetBoxTop - seedSq.position.y * z });
              setZoom(z);
              return;
            }
          }

          const headlineSrc = (() => {
            const nonMain = [...loadedSquares].filter((s: SquareData) => !s.isMainSource).sort((a: SquareData, b: SquareData) => b.order - a.order);
            return nonMain[0] || loadedSquares.find((s: SquareData) => s.isMainSource) || loadedSquares[0];
          })();
          if (opts?.centerOnHeadline && headlineSrc) {
            const bw = useSimple ? 220 : SQUARE_WIDTH;
            const z = useSimple ? 1.26 : 0.78;
            const cx = (headlineSrc.position.x + bw / 2) * z;
            const targetBoxTop = 70 + 140 * z;
            setCanvasOffset({ x: (rect.width / 2) - cx, y: targetBoxTop - headlineSrc.position.y * z });
            setZoom(z);
          } else if (loadedSquares.length > 0 && data.board.appMode === 'single') {
            setTimeout(() => fitChainToScreenRef.current?.({ useSimple }), 150);
          } else if (loadedSquares.length > 0) {
            const nonMain = loadedSquares.filter((s: SquareData) => !s.isMainSource);
            const ordered = [...(nonMain.length > 0 ? nonMain : loadedSquares)].sort((a: SquareData, b: SquareData) => b.order - a.order);
            const foundation = ordered[0];
            const primary    = ordered[ordered.length - 1];
            const bw = useSimple ? 220 : SQUARE_WIDTH;
            const z = 1.18;
            const foundationCenterX = foundation.position.x + bw / 2;
            const primaryCenterX    = primary.position.x + bw / 2;
            const chainMidX = (foundationCenterX + primaryCenterX) / 2 * z;
            const targetBoxTop = 70 + 140 * z;
            setCanvasOffset({ x: (rect.width / 2) - chainMidX, y: targetBoxTop - foundation.position.y * z });
            setZoom(z);
          } else {
            setZoom(defZ);
          }
        }
      }, 200);
      const loadedTitle = (() => { const first = loadedSquares.length > 0 ? [...loadedSquares].sort((a, b) => b.order - a.order)[0] : null; return first?.fields?.field2 || first?.fields?.field1 || ''; })();
      setBoardHistory(prev => {
        const entry: BoardHistoryEntry = { boardId: normalBid, zoom: 0.78, offset: { x: 0, y: 0 }, selectedSourceId: null, appMode: data.board.appMode, title: loadedTitle, isPublic: data.board.isPublic };
        const filtered = prev.filter(e => e.boardId !== normalBid);
        return [entry, ...filtered].slice(0, 3);
      });
      if (tokenRef.current && data.board.isOwner === false) {
        fetch(`${API_BASE}/saved-boards/${normalBid}/check`, { headers: apiHeaders() })
          .then(r => r.json()).then(d => setIsBoardSaved(!!d.saved)).catch(() => setIsBoardSaved(false));
      } else { setIsBoardSaved(false); }
      return true;
    } catch { return false; }
  }, [apiHeaders, getToken, refreshTreeLimits]);

  const loadSourceByIdFromApi = useCallback(async (sid: string) => {
    try {
      try { const t = await getToken(); if (t) tokenRef.current = t; } catch {}
      const resp = await fetch(`${API_BASE}/sources/find/${sid}`, { headers: apiHeaders() });
      if (resp.status === 403) {
        try { const body = await resp.json(); setPrivateBoardId(body.boardId || ''); setPrivateBoardEverPublished(!!body.everPublished); }
        catch { setPrivateBoardId(''); setPrivateBoardEverPublished(false); }
        setPrivateBoardError(true); setModeDialogOpen(false); return false;
      }
      if (!resp.ok) return false;
      const data = await resp.json();
      if (data.boardId) {
        const loaded = await loadBoardFromApi(data.boardId, sid);
        if (loaded) {
          return true;
        }
      }
      return false;
    } catch { return false; }
  }, [apiHeaders, loadBoardFromApi, getToken]);

  const hasInitRef = useRef(false);
  const clerkLoadedRef = useRef(false);
  useEffect(() => {
    if (isSignedIn === undefined) return;
    
    const params = getURLParams();
    let bid = params.boardId;
    const cid = params.chainId;
    const sid = params.sourceId;
    
    const tryLoad = async () => {
      if (isSignedIn) {
        try { const t = await getToken(); tokenRef.current = t; } catch {}
      }
      const viewMode = params.viewMode;
      const targetSrc = (viewMode === 'source' && sid) ? sid : null;

      // ── Resolve boardId from chainId ────────────────────────────────────────
      if (cid && !bid) {
        const cached = _lookupChain(cid);
        if (cached) bid = cached;
        if (!bid) {
          try {
            const r = await fetch(`${API_BASE}/boards/by-chain/${normId(cid)}`, { headers: apiHeaders() });
            if (r.ok) {
              const d = await r.json();
              if (d.boardId) { bid = d.boardId; _cacheChain(cid, d.boardId); }
            }
          } catch {}
        }
      }

      // ── Load by boardId ────────────────────────────────────────────────────
      if (bid) {
        const loaded = await loadBoardFromApi(bid, targetSrc);
        if (loaded) {
          if (cid) setChainId(cid);
          return;
        }
      }
      // ── Load by sourceId (lookup endpoint) ─────────────────────────────────
      if (sid) {
        try {
          const resp = await fetch(`${API_BASE}/sources/find/${normId(sid)}`, { headers: apiHeaders() });
          if (resp.status === 403) { setPrivateBoardError(true); setModeDialogOpen(false); return; }
          if (resp.ok) {
            const data = await resp.json();
            if (data.boardId) {
              const loaded = await loadBoardFromApi(data.boardId, sid);
              if (loaded) { return; }
            }
          }
        } catch {}
      }
      if (!bid && !sid && isSignedIn && tokenRef.current) {
        try {
          const meResp = await fetch(`${API_BASE}/auth/me`, { headers: apiHeaders() });
          if (meResp.ok) {
            const meData = await meResp.json();
            if (meData.user?.settings) {
              try { const s = typeof meData.user.settings === 'string' ? JSON.parse(meData.user.settings) : meData.user.settings; setAppSettings({ ...DEFAULT_SETTINGS, ...s }); } catch {}
            }
          }
        } catch {}
        setAppInitialized(true);
        return;
      }
      if (bid || sid) setSnackbar({ open: true, message: 'Source not found' });
      if (!isSignedIn) setModeDialogOpen(true);
      setAppInitialized(true);
    };

    if (!hasInitRef.current || (isSignedIn && !clerkLoadedRef.current)) {
      hasInitRef.current = true;
      if (isSignedIn) { clerkLoadedRef.current = true; setDemoMode(false); }
      tryLoad().finally(() => setAppInitialized(true));
    }
    if (!isSignedIn && clerkLoadedRef.current) {
      clerkLoadedRef.current = false;
      tokenRef.current = null;
      setModeDialogOpen(true);
      setAppInitialized(true);
    }
  }, [isSignedIn]); // eslint-disable-line
  const GAP = 180;
  const SOURCES_PER_ROW = 3;
  const ROW_GAP = 80;
  const TREE_START_Y = 80;

  const compactPositionByOrder = useMemo(() => {
    if (!simpleView || appMode !== 'single') return null;
    const nonMain = squares.filter(s => !s.isMainSource);
    if (nonMain.length === 0) return null;
    const SIMPLE_W = 220, SIMPLE_H = 105;
    const startX = 80, startY = 150;
    const sortedDesc = [...nonMain].sort((a, b) => b.order - a.order);
    const total = sortedDesc.length;
    const STRIDE_X = SIMPLE_W + GAP;
    const STRIDE_Y = SIMPLE_H + ROW_GAP;
    const rawPositions: { x: number; y: number }[] = [];
    for (let i = 0; i < total; i++) {
      const row = Math.floor(i / SOURCES_PER_ROW);
      const col = i % SOURCES_PER_ROW;
      const leftToRight = row % 2 === 0;
      const x = leftToRight
        ? startX + col * STRIDE_X
        : startX + (SOURCES_PER_ROW - 1 - col) * STRIDE_X;
      const y = startY + row * STRIDE_Y;
      rawPositions.push({ x, y });
    }
    const foundation = sortedDesc[0];
    const shiftX = (foundation.position.x ?? rawPositions[0].x) - rawPositions[0].x;
    const shiftY = (foundation.position.y ?? rawPositions[0].y) - rawPositions[0].y;
    const map = new Map<string, { x: number; y: number }>();
    sortedDesc.forEach((sq, i) => {
      map.set(sq.sourceId, {
        x: rawPositions[i].x + shiftX,
        y: rawPositions[i].y + shiftY,
      });
    });
    return map;
  }, [simpleView, appMode, squares]);

  // ── Center camera on a just-added source ──────────────────────────────────
  useEffect(() => {
    if (!centerOnSourceReq) return;
    const sq = squares.find(s => s.sourceId === centerOnSourceReq.sourceId);
    if (!sq) { setCenterOnSourceReq(null); return; }
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const compact = compactPositionByOrder?.get(sq.sourceId);
    const pos = compact || sq.position;
    const isCompactCard = (!!compact || simpleView) && !sq.isMainSource;
    const w = isCompactCard ? 220 : sq.size.width;
    const h = isCompactCard ? 105 : sq.size.height;
    setCanvasOffset({
      x: rect.width / 2 - (pos.x + w / 2) * zoom,
      y: rect.height / 2 - (pos.y + h / 2) * zoom,
    });
    setCenterOnSourceReq(null);
  }, [centerOnSourceReq, squares, compactPositionByOrder, simpleView, zoom]);

  const editLogBySource = useMemo(() => {
    const m = new Map<string, Array<{ sourceId: string; field: string; oldValue: string; newValue: string; editedAt: string; editedBy: string }>>();
    for (const e of boardEditLog) {
      const arr = m.get(e.sourceId);
      if (arr) arr.push(e); else m.set(e.sourceId, [e]);
    }
    return m;
  }, [boardEditLog]);

  useEffect(() => {
    const updateSize = () => { if (containerRef.current) setCanvasSize({ width: containerRef.current.clientWidth, height: containerRef.current.clientHeight }); };
    updateSize();
    window.addEventListener('resize', updateSize);
    const handleFsChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleFsChange);
    return () => { window.removeEventListener('resize', updateSize); document.removeEventListener('fullscreenchange', handleFsChange); };
  }, []);

  useEffect(() => { 
    if (urlParams.boardId) {
      setModeDialogOpen(false);
      if (urlParams.chainId) setChainId(urlParams.chainId);
      if (urlParams.sourceId) {
        setSelectedSourceId(urlParams.sourceId);
        if (urlParams.tab) setUrlTab(urlParams.tab as 'ref' | 'file' | 'info');
      }
    }
  }, []);

  const mainSource = squares.find(s => s.isMainSource);
  const hasMainSource = !!mainSource;
  const treeLineX = useMemo(() => {
    if (mainSource) return mainSource.position.x + mainSource.size.width / 2;
    return canvasSize.width / 2;
  }, [mainSource?.position.x, mainSource?.size.width, canvasSize.width]);

  useEffect(() => {
    if (appMode === 'tree' && mainSource) {
      setBoardId(mainSource.sourceId);
      setChainId(null);
      updateURL(mainSource.sourceId, null, null);
    }
  }, [appMode, mainSource?.sourceId]);

  const handleSelectSource = useCallback((id: string) => { setSelectedSourceId(id); setSelectedRefPointId(null); updateURL(boardId, chainIdRef.current, id); }, [boardId]);
  const handleCanvasClick = useCallback(() => { setSelectedSourceId(null); setSelectedRefPointId(null); updateURL(boardIdRef.current, null, null); }, []);
  const handleSelectMainSource = useCallback(() => { setSelectedSourceId(null); setSelectedRefPointId(null); updateURL(boardId, chainIdRef.current, null); }, [boardId]);

  useEffect(() => {
    if (!selectedSourceId || selectedSourceId === relationsSourceId) return;
    setRelationsLoading(true);
    setRelationsSourceId(selectedSourceId);
    fetch(`${API_BASE}/sources/relations/${selectedSourceId}`)
      .then(r => r.ok ? r.json() : { relations: [], totalCount: 0 })
      .then(d => { setRelatedSources(d.relations || []); setRelationsTotalCount(d.totalCount || 0); setRelationsLoading(false); })
      .catch(() => { setRelatedSources([]); setRelationsTotalCount(0); setRelationsLoading(false); });
  }, [selectedSourceId]);

  const relSearchTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (relSearchTimeout.current) clearTimeout(relSearchTimeout.current);
    if (!relSearchQuery.trim() || relSearchQuery.length < 2) { setRelSearchResults([]); return; }
    relSearchTimeout.current = setTimeout(async () => {
      setRelSearchLoading(true);
      try {
        const res = await fetch(`${API_BASE}/sources/search?q=${encodeURIComponent(relSearchQuery)}`);
        const data = await res.json();
        setRelSearchResults(data.results || []);
      } catch { setRelSearchResults([]); }
      setRelSearchLoading(false);
    }, 400);
  }, [relSearchQuery]);

  const handleModeSelect = (mode: AppMode) => {
    setAppMode(mode);
    setSquares([]);
    setRefPoints([]);
    nextId.current = 1;
    nextRefPointId.current = 1;
    setChainEnded(false);
    setSelectedSourceId(null);
    setIsOwner(true);
    setSimpleView(false);
    setCleanView(false);
    
    if (mode === 'single') {
      const newBoardId = generateBoardId();
      const newChainId = generateChainId();
      _cacheChain(newChainId, newBoardId);
      setBoardId(newBoardId);
      setChainId(null);
      updateURL(newBoardId, null);
      const sourceX = 100;
      const sourceY = 100;
      const newSource: SquareData = {
        id: nextId.current++,
        sourceId: generateSourceId(),
        size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
        position: { x: sourceX, y: sourceY },
        sourceType: null,
        name: 'Source 1',
        fields: emptyFields,
        order: 1,
        createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
        uploadedFile: null,
        reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false
      };
      setSquares([newSource]);
      setTimeout(() => {
        if (containerRef.current) {
          const rect = containerRef.current.getBoundingClientRect();
          const z = settingsRef.current.defaultZoom / 100;
          const boxCenterX = (sourceX + SQUARE_WIDTH / 2) * z;
          const targetBoxTop = 70 + GAP * z;
          setCanvasOffset({
            x: (rect.width / 2) - boxCenterX,
            y: targetBoxTop - sourceY * z,
          });
          setZoom(z);
        }
      }, 150);
    }
  };

  const handleAddMainSource = useCallback(() => {
    const mainSourceId = generateSeedId();
    const sourceX = treeLineX - SQUARE_WIDTH / 2;
    const sourceY = TREE_START_Y;
    const newSquare: SquareData = {
      id: nextId.current++,
      sourceId: mainSourceId,
      size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
      position: { x: sourceX, y: sourceY },
      sourceType: null,
      name: 'Seed Node',
      fields: emptyFields,
      order: 0,
      createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
      uploadedFile: null,
      reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false,
      isMainSource: true,
    };
    setSquares([newSquare]);
    setBoardId(mainSourceId);
    setChainId(null);
    updateURL(mainSourceId, null, null);
    setTimeout(() => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const z = settingsRef.current.defaultZoom / 100;
        const boxCenterX = (sourceX + SQUARE_WIDTH / 2) * z;
        const boxCenterY = (sourceY + SQUARE_HEIGHT / 2) * z;
        setCanvasOffset({
          x: (rect.width / 2) - boxCenterX,
          y: (rect.height / 2) - boxCenterY,
        });
        setZoom(z);
      }
    }, 150);
  }, [treeLineX]);

  const handleOpenRefPointDialog = useCallback(() => {
    if (!hasMainSource) return;
    setRefPointEditingId(null);
    setRefPointDialogOpen(true);
  }, [hasMainSource]);

  const handleOpenEditRefPoint = useCallback((id: string) => {
    setRefPointEditingId(id);
    setRefPointDialogOpen(true);
  }, []);

  const sortRefPoints = useCallback((rps: RefPoint[], pointerType: string | undefined, squaresForLayout?: SquareData[], isSimpleView?: boolean): { sorted: RefPoint[]; deltas: Map<string, number> } => {
    if (rps.length === 0) return { sorted: rps, deltas: new Map() };
    const parseKey = (v: string | undefined): { num: number | null; str: string } => {
      const s = (v || '').trim();
      if (!s) return { num: Number.POSITIVE_INFINITY, str: '' };
      if (pointerType === 'time' || pointerType === 'datetime') {
        const m = s.match(/^(\d+):(\d+)(?::(\d+))?$/);
        if (m) return { num: parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + (m[3] ? parseInt(m[3], 10) / 60 : 0), str: s.toLowerCase() };
      }
      const n = parseFloat(s.replace(/[^0-9.\-]/g, ''));
      if (!isNaN(n)) return { num: n, str: s.toLowerCase() };
      return { num: Number.POSITIVE_INFINITY, str: s.toLowerCase() };
    };
    const indexed = rps.map((rp, idx) => ({ rp, key: parseKey(rp.fromValue), origIdx: idx }));
    indexed.sort((a, b) => {
      const na = a.key.num, nb = b.key.num;
      if (na !== null && nb !== null && na !== nb) return na - nb;
      if (a.key.str !== b.key.str) return a.key.str.localeCompare(b.key.str);
      return a.origIdx - b.origIdx;
    });
    const mainSourceBottom = mainSource ? (appMode === 'tree' ? (TREE_START_Y - 10 + Math.round(105 * 1.3) + 10) : mainSource.position.y + mainSource.size.height) : TREE_START_Y + SQUARE_HEIGHT;
    const BASE_REF_SPACING = SQUARE_HEIGHT + 80;
    const FILE_EXTRA_NORMAL = 80 + 219;
    const FILE_EXTRA_SIMPLE = 30 + 24;
    const fileExtra = isSimpleView ? FILE_EXTRA_SIMPLE : FILE_EXTRA_NORMAL;
    const rowHasFile = (rpId: string) => {
      if (!squaresForLayout) return false;
      return squaresForLayout.some(sq => sq.refPointId === rpId && !!(sq.uploadedFile?.previewUrl || sq.uploadedFile?.refCropUrl || sq.uploadedFile?.url));
    };
    const baseY = mainSourceBottom + SQUARE_HEIGHT / 2 + 60;
    const sorted: RefPoint[] = [];
    const deltas = new Map<string, number>();
    let cursorY = baseY;
    indexed.forEach(({ rp }, i) => {
      const newY = i === 0 ? cursorY : cursorY;
      const dy = newY - rp.y;
      if (dy !== 0) deltas.set(rp.id, dy);
      sorted.push({ ...rp, y: newY });
      const extra = rowHasFile(rp.id) ? fileExtra : 0;
      cursorY = newY + BASE_REF_SPACING + extra;
    });
    return { sorted, deltas };
  }, [mainSource, appMode]);

  const applySortedRefPoints = useCallback((rps: RefPoint[]) => {
    const { sorted, deltas } = sortRefPoints(rps, mainSource?.reference?.pointerType, squares, simpleView);
    setRefPoints(sorted);
    if (deltas.size > 0) {
      setSquares(prev => prev.map(sq => {
        if (!sq.refPointId) return sq;
        const dy = deltas.get(sq.refPointId);
        if (!dy) return sq;
        return { ...sq, position: { x: sq.position.x, y: sq.position.y + dy } };
      }));
    }
  }, [sortRefPoints, mainSource, squares, simpleView]);

  const handleAddRefPoint = useCallback((fromValue: string, toValue: string, sectionAnchors: {
    fromSectionStartsWith: string;
    toSectionEndsWith: string;
  }) => {
    const maxRP = treeLimitsRef.current.maxRefPoints;
    if (refPoints.length >= maxRP) {
      setWarningMessage(`Maximum ${maxRP} reference points per source-tree reached. An admin can raise this limit in the Source Tree Limits settings.`);
      setWarningDialogOpen(true);
      return;
    }
    const lastRefPoint = refPoints[refPoints.length - 1];
    const mainSourceBottom = mainSource ? (appMode === 'tree' ? (TREE_START_Y - 10 + Math.round(105 * 1.3) + 10) : mainSource.position.y + mainSource.size.height) : TREE_START_Y + SQUARE_HEIGHT;
    const REF_SPACING = SQUARE_HEIGHT + 80;
    const y = lastRefPoint ? lastRefPoint.y + REF_SPACING : mainSourceBottom + SQUARE_HEIGHT / 2 + 60;
    const labelText = formatRefPointLabel(mainSource?.reference?.pointerType, fromValue, toValue) || fromValue || `Ref ${refPoints.length + 1}`;
    const newRefPoint: RefPoint = {
      id: `ref-${nextRefPointId.current++}`,
      y,
      label: labelText,
      value: labelText,
      fromValue,
      toValue,
      fromSectionStartsWith: sectionAnchors.fromSectionStartsWith || undefined,
      toSectionEndsWith: sectionAnchors.toSectionEndsWith || undefined,
      sourceIds: [],
    };
    applySortedRefPoints([...refPoints, newRefPoint]);
    setSelectedRefPointId(newRefPoint.id);
    setSnackbar({ open: true, message: 'Reference point added' });
    setTimeout(() => saveToApi(), 200);
  }, [refPoints, mainSource, saveToApi, applySortedRefPoints, treeLimits]);

  const handleEditRefPoint = useCallback((id: string, fromValue: string, toValue: string, sectionAnchors: {
    fromSectionStartsWith: string;
    toSectionEndsWith: string;
  }) => {
    const updated = refPoints.map(rp => {
      if (rp.id !== id) return rp;
      const labelText = formatRefPointLabel(mainSource?.reference?.pointerType, fromValue, toValue) || fromValue || rp.value;
      return {
        ...rp, fromValue, toValue, label: labelText, value: labelText,
        fromSectionStartsWith: sectionAnchors.fromSectionStartsWith || undefined,
        toSectionEndsWith: sectionAnchors.toSectionEndsWith || undefined,
      };
    });
    applySortedRefPoints(updated);
    setTimeout(() => saveToApi(), 200);
  }, [refPoints, mainSource, saveToApi, applySortedRefPoints]);

  const treeFilesSignature = useMemo(() => {
    if (appMode !== 'tree') return '';
    return squares
      .filter(s => !s.isMainSource && s.refPointId)
      .map(s => `${s.refPointId}:${(s.uploadedFile?.previewUrl || s.uploadedFile?.refCropUrl || s.uploadedFile?.url) ? '1' : '0'}`)
      .sort()
      .join('|');
  }, [appMode, squares]);
  const lastSignatureRef = useRef('');
  const applySortedRef = useRef(applySortedRefPoints);
  useEffect(() => { applySortedRef.current = applySortedRefPoints; }, [applySortedRefPoints]);
  useEffect(() => {
    if (appModeRef.current !== 'tree' || refPointsRef.current.length === 0) {
      lastSignatureRef.current = treeFilesSignature;
      return;
    }
    if (lastSignatureRef.current === treeFilesSignature) return;
    lastSignatureRef.current = treeFilesSignature;
    applySortedRef.current(refPointsRef.current);
  }, [treeFilesSignature]);

  const scrollToRefPoint = useCallback((rpId: string) => {
    const rp = refPoints.find(r => r.id === rpId);
    if (!rp || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const z = zoom;
    const cx = treeLineX * z;
    const cy = rp.y * z;
    const HEADLINE_RESERVE = 70;
    const visibleHeight = rect.height - HEADLINE_RESERVE;
    setCanvasOffset({ x: rect.width / 2 - cx, y: HEADLINE_RESERVE + visibleHeight / 2 - cy });
    setSelectedRefPointId(rpId);
  }, [refPoints, zoom, treeLineX]);

  const scrollToSource = useCallback((sourceId: string) => {
    const sq = squares.find(s => s.sourceId === sourceId);
    if (!sq || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const z = zoom;
    const compact = compactPositionByOrder?.get(sq.sourceId);
    const pos = compact || sq.position;
    const isCompactCard = (!!compact || simpleView) && !sq.isMainSource;
    const bw = isCompactCard ? 220 : sq.size.width;
    const bh = isCompactCard ? 105 : sq.size.height;
    const cx = (pos.x + bw / 2) * z;
    const cy = (pos.y + bh / 2) * z;
    const HEADLINE_RESERVE = 140;
    const visibleHeight = rect.height - HEADLINE_RESERVE;
    setCanvasOffset({ x: rect.width / 2 - cx, y: HEADLINE_RESERVE + visibleHeight / 2 - cy });
    setSelectedSourceId(sourceId);
  }, [squares, zoom, simpleView, compactPositionByOrder]);

  const handleDeleteRefPoint = useCallback((id: string) => {
    setRefPoints(prev => {
      const filtered = prev.filter(rp => rp.id !== id);
      const { sorted } = sortRefPoints(filtered, mainSource?.reference?.pointerType);
      return sorted;
    });
    setSquares(prev => prev.filter(s => s.refPointId !== id));
    if (selectedRefPointId === id) setSelectedRefPointId(null);
    setTimeout(() => saveToApi(), 200);
  }, [saveToApi, selectedRefPointId, sortRefPoints, mainSource]);

  const handleToggleBranchEnd = useCallback((refPointId: string, reason?: 'ended' | 'unknown') => {
    setRefPoints(prev => prev.map(rp => rp.id === refPointId
      ? { ...rp, branchEnded: !!reason, branchEndReason: reason || '' }
      : rp));
    setTimeout(() => saveToApi(), 200);
  }, [saveToApi]);

  const handleAddSourceToRefPoint = useCallback((refPointId: string) => {
    const rp = refPoints.find(r => r.id === refPointId);
    if (!rp) return;
    
    const existingSources = squares.filter(s => s.refPointId === refPointId);
    
    const maxSrc = treeLimitsRef.current.maxSourcesPerBranch;
    if (existingSources.length >= maxSrc) {
      setWarningMessage(`Maximum ${maxSrc} sources per branch reached. An admin can raise this limit in the Source Tree Limits settings.`);
      setWarningDialogOpen(true);
      return;
    }
    
    const refBoxRight = treeLineX + 60 + REF_BOX_WIDTH + 40;
    const xOffset = refBoxRight + existingSources.length * (SQUARE_WIDTH + GAP);
    
    const newSquare: SquareData = {
      id: nextId.current++,
      sourceId: generateSourceId(),
      size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
      position: { x: xOffset, y: rp.y - SQUARE_HEIGHT / 2 },
      sourceType: null,
      name: `Source ${squares.filter(s => !s.isMainSource).length + 1}`,
      fields: emptyFields,
      order: squares.filter(s => !s.isMainSource).length + 1,
      createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
      uploadedFile: null,
      reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false,
      refPointId,
    };
    setSquares([...squares, newSquare]);
    setSelectedSourceId(newSquare.sourceId);
    setCenterOnSourceReq({ sourceId: newSquare.sourceId, nonce: Date.now() });
    updateURL(boardId, null, newSquare.sourceId);
  }, [refPoints, squares, treeLineX, boardId, treeLimits]);

  const handleAddSquare = useCallback(() => {
    if (chainEnded || appMode !== 'single') return;
    if (isPublic) {
      setWarningMessage('Make the board private to add or edit sources.');
      setWarningDialogOpen(true);
      return;
    }
    const maxChain = treeLimitsRef.current.maxChainSources;
    if (squares.length >= maxChain) {
      setWarningMessage(`Maximum ${maxChain} sources in a chain reached. An admin can raise this limit in the Source Chain Limits settings.`);
      setWarningDialogOpen(true);
      return;
    }
    const lastSource = squares[squares.length - 1];
    if (lastSource && !lastSource.sourceType) {
      setWarningMessage('Please select a source type for the current source before adding a new one.');
      setWarningDialogOpen(true);
      return;
    }
    const primarySource = squares.find(s => s.order === 1) || squares[squares.length - 1];
    const primaryEventHasCoords = primarySource?.sourceType === 'event' && primarySource.fields.field3 && primarySource.fields.field3.split(',').length === 2 && !isNaN(parseFloat(primarySource.fields.field3.split(',')[0]));
    if (primarySource && squares.length >= 1 && !(primarySource.reference.from || primarySource.reference.to || primarySource.reference.notes || primarySource.reference.notApplicable || primaryEventHasCoords)) {
      setWarningMessage('Please add a reference point to the current primary source before adding a new one — or check "Reference not applicable" if the entire source is the reference. The reference point describes where in this source the next source is referenced.');
      setWarningDialogOpen(true);
      return;
    }

    // ── Snake layout: new source added to the RIGHT, becomes Primary (order 1) ──
    const totalAfter = squares.length + 1;
    const snakePositions = (total: number): { x: number; y: number }[] => {
      const startX = 80;
      const startY = 150;
      const stairStep = 0;
      const positions: { x: number; y: number }[] = [];
      for (let i = 0; i < total; i++) {
        const row = Math.floor(i / SOURCES_PER_ROW);
        const col = i % SOURCES_PER_ROW;
        const leftToRight = row % 2 === 0;
        const x = leftToRight
          ? startX + col * (SQUARE_WIDTH + GAP)
          : startX + (SOURCES_PER_ROW - 1 - col) * (SQUARE_WIDTH + GAP);
        const y = startY + row * (SQUARE_HEIGHT + ROW_GAP) + i * stairStep;
        positions.push({ x, y });
      }
      return positions;
    };

    const positions = snakePositions(totalAfter);
    const newSourceId = generateSourceId();
    if (squares.length === 1 && !chainIdRef.current) {
      const newChainId = generateChainId();
      _cacheChain(newChainId, boardIdRef.current);
      setChainId(newChainId);
      updateURL(boardIdRef.current, newChainId);
    }
    const sortedExisting = [...squares].sort((a, b) => b.order - a.order);
    const updatedExisting = sortedExisting.map((sq, i) => ({
      ...sq,
      order: totalAfter - i,
      position: positions[i],
    }));
    const newSquare = {
      id: nextId.current++,
      sourceId: newSourceId,
      size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
      position: positions[totalAfter - 1],
      sourceType: null,
      name: `Source ${totalAfter}`,
      fields: emptyFields,
      order: 1,
      createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
      uploadedFile: null,
      reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false,
    };
    setSquares([...updatedExisting, newSquare]);
    setSelectedSourceId(newSourceId);
    setCenterOnSourceReq({ sourceId: newSourceId, nonce: Date.now() });
    updateURL(boardId, chainIdRef.current, newSourceId);
  }, [chainEnded, appMode, squares, isPublic, boardId, treeLimits]);

  const handleWheel = useCallback((e: React.WheelEvent) => {
    const target = e.target as HTMLElement;
    if (target.closest('.MuiDialog-root') || target.closest('.MuiMenu-root') || target.closest('.MuiPopover-root')) return;
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.08 : 0.08;
    setZoom(prevZoom => {
      const newZoom = Math.max(0.25, Math.min(2, prevZoom + delta));
      const rect = containerRef.current?.getBoundingClientRect();
      if (rect) {
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const scale = newZoom / prevZoom;
        setCanvasOffset(prev => ({
          x: mouseX - scale * (mouseX - prev.x),
          y: mouseY - scale * (mouseY - prev.y),
        }));
      }
      return newZoom;
    });
  }, []);
  
  const handleCanvasMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button === 2) return;
    const target = e.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT' || target.closest('input') || target.closest('textarea') || target.closest('select') || target.closest('[role="combobox"]') || target.closest('[role="listbox"]') || target.closest('[role="option"]') || target.closest('.MuiAutocomplete-root') || target.closest('.MuiDialog-root') || target.closest('.MuiMenu-root') || target.closest('button') || target.closest('[role="button"]')) return;
    if (canvasTab === 'board' && (e.target === e.currentTarget || (e.target as HTMLElement).closest('[data-canvas]'))) handleCanvasClick();
    if (canvasLocked) return;
    e.preventDefault(); setIsPanning(true); setPanStart({ x: e.clientX, y: e.clientY }); setInitialOffset({ ...canvasOffset });
  }, [canvasOffset, handleCanvasClick, canvasLocked, canvasTab]);

  const handleContextMenu = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    if (e.target === e.currentTarget || (e.target as HTMLElement).closest('[data-canvas]')) setContextMenu({ x: e.clientX, y: e.clientY });
  }, []);

  const handleCanvasMouseMove = useCallback((e: MouseEvent) => { if (isPanning) setCanvasOffset({ x: initialOffset.x + e.clientX - panStart.x, y: initialOffset.y + e.clientY - panStart.y }); }, [isPanning, panStart, initialOffset]);
  useEffect(() => { const up = () => setIsPanning(false); window.addEventListener('mousemove', handleCanvasMouseMove); window.addEventListener('mouseup', up); return () => { window.removeEventListener('mousemove', handleCanvasMouseMove); window.removeEventListener('mouseup', up); }; }, [handleCanvasMouseMove]);

  const handleUpdateSquare = useCallback((id: number, size: Size, position: Position) => {
    const snapped = snapToGrid ? { x: Math.round(position.x / 50) * 50, y: Math.round(position.y / 50) * 50 } : position;
    setSquares(prev => {
      const others = prev.filter(sq => sq.id !== id);
      let finalPos = { ...snapped };
      const simW = simpleView ? 220 : size.width;
      const simH = simpleView ? 105 : size.height;
      const gap = simpleView ? 8 : 10;
      for (const other of others) {
        const oW = simpleView ? 220 : other.size.width;
        const oH = simpleView ? 105 : other.size.height;
        const overlapX = (finalPos.x < other.position.x + oW + gap) && (finalPos.x + simW + gap > other.position.x);
        const overlapY = (finalPos.y < other.position.y + oH + gap) && (finalPos.y + simH + gap > other.position.y);
        if (overlapX && overlapY) {
          const pushRight = other.position.x + oW + gap - finalPos.x;
          const pushLeft = finalPos.x + simW + gap - other.position.x;
          const pushDown = other.position.y + oH + gap - finalPos.y;
          const pushUp = finalPos.y + simH + gap - other.position.y;
          const min = Math.min(pushRight, pushLeft, pushDown, pushUp);
          if (min === pushRight) finalPos.x = other.position.x + oW + gap;
          else if (min === pushLeft) finalPos.x = other.position.x - simW - gap;
          else if (min === pushDown) finalPos.y = other.position.y + oH + gap;
          else finalPos.y = other.position.y - simH - gap;
          if (snapToGrid) {
            finalPos.x = Math.round(finalPos.x / 50) * 50;
            finalPos.y = Math.round(finalPos.y / 50) * 50;
          }
        }
      }
      return prev.map(sq => sq.id === id ? { ...sq, size, position: finalPos } : sq);
    });
  }, [snapToGrid, simpleView]);
  const logEdit = useCallback((sourceId: string, field: string, oldValue: string, newValue: string) => {
    if (!madePublicAt) return;
    if (oldValue === newValue) return;
    setBoardEditLog(log => [...log, { sourceId, field, oldValue, newValue, editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
  }, [madePublicAt, clerkUsername]);

  const handleSourceTypeChange = useCallback((id: number, sourceType: string | null, fields: SourceFields, file: UploadedFile | null, apiPrefillFields?: Record<string, string>) => {
    setSquares(prev => {
      const oldSquare = prev.find(sq => sq.id === id);
      if (oldSquare && madePublicAt) {
        const sourceTypeDef = ALL_SOURCE_TYPES.find(t => t.type === (sourceType || oldSquare.sourceType));
        const fieldNames = sourceTypeDef?.fields || [];
        const newFields = sanitizeFields(fields);
        Object.keys(newFields).forEach(key => {
          const fieldKey = key as keyof SourceFields;
          const oldVal = oldSquare.fields[fieldKey] || '';
          const newVal = newFields[fieldKey] || '';
          if (oldVal !== newVal) {
            const fieldIdx = parseInt(key.replace('field', '')) - 1;
            const fieldLabel = fieldNames[fieldIdx]?.label || key;
            setBoardEditLog(log => [...log, { sourceId: oldSquare.sourceId, field: fieldLabel, oldValue: oldVal, newValue: newVal, editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
          }
        });
        if (sourceType !== oldSquare.sourceType) {
          setBoardEditLog(log => [...log, { sourceId: oldSquare.sourceId, field: 'Source Type', oldValue: oldSquare.sourceType || '(none)', newValue: sourceType || '(none)', editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
        }
        const hadFile = !!oldSquare.uploadedFile;
        const hasFile = !!file;
        if (hadFile !== hasFile) {
          setBoardEditLog(log => [...log, { sourceId: oldSquare.sourceId, field: 'File', oldValue: hadFile ? (oldSquare.uploadedFile?.name || 'file') : '(none)', newValue: hasFile ? (file?.name || 'file') : '(removed)', editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
        }
      }
      return prev.map(sq => sq.id === id ? { ...sq, sourceType, fields: sanitizeFields(fields), uploadedFile: file, updatedAt: nowDate(), ...(apiPrefillFields ? { apiPrefillFields } : {}) } : sq);
    });
  }, [madePublicAt, clerkUsername]);

  const handleReferenceChange = useCallback((id: number, ref: ReferencePointer) => {
    setSquares(prev => {
      const old = prev.find(sq => sq.id === id);
      if (old && madePublicAt) {
        const oldRef = `${old.reference.from || ''}${old.reference.to ? ' → ' + old.reference.to : ''}${old.reference.notes ? ' (' + old.reference.notes + ')' : ''}${old.reference.notApplicable ? ' [N/A]' : ''}`;
        const newRef = `${ref.from || ''}${ref.to ? ' → ' + ref.to : ''}${ref.notes ? ' (' + ref.notes + ')' : ''}${ref.notApplicable ? ' [N/A]' : ''}`;
        if (oldRef !== newRef) setBoardEditLog(log => [...log, { sourceId: old.sourceId, field: 'Reference', oldValue: oldRef || '(none)', newValue: newRef || '(none)', editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
      }
      return prev.map(sq => sq.id === id ? { ...sq, reference: { ...ref, from: sanitize(ref.from), to: sanitize(ref.to), notes: sanitize(ref.notes) }, updatedAt: nowDate() } : sq);
    });
  }, [madePublicAt, clerkUsername]);

  const handleTrustRateChange = useCallback((id: number, rates: TrustRates, assessed?: boolean) => {
    setSquares(prev => {
      const old = prev.find(sq => sq.id === id);
      if (old && madePublicAt) {
        const oldAvg = Object.values(old.trustRates).filter(v => v > 0);
        const newAvg = Object.values(rates).filter(v => v > 0);
        const oldScore = oldAvg.length > 0 ? (oldAvg.reduce((a, b) => a + b, 0) / oldAvg.length).toFixed(1) : '(unrated)';
        const newScore = newAvg.length > 0 ? (newAvg.reduce((a, b) => a + b, 0) / newAvg.length).toFixed(1) : '(unrated)';
        if (oldScore !== newScore) setBoardEditLog(log => [...log, { sourceId: old.sourceId, field: 'Trust Rating', oldValue: oldScore, newValue: newScore, editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
      }
      return prev.map(sq => sq.id === id ? { ...sq, trustRates: rates, trustAssessed: assessed !== undefined ? assessed : sq.trustAssessed, updatedAt: nowDate() } : sq);
    });
  }, [madePublicAt, clerkUsername]);

  const handleCommentsChange = useCallback((id: number, comments: string) => {
    setSquares(prev => {
      const old = prev.find(sq => sq.id === id);
      if (old && madePublicAt && (old.comments || '') !== comments) {
        setBoardEditLog(log => [...log, { sourceId: old.sourceId, field: 'Notes', oldValue: (old.comments || '').substring(0, 50) || '(empty)', newValue: comments.substring(0, 50) || '(empty)', editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
      }
      return prev.map(sq => sq.id === id ? { ...sq, comments: sanitize(comments), updatedAt: nowDate() } : sq);
    });
  }, [madePublicAt, clerkUsername]);

  const handleSetIsAuthor = useCallback(async (sourceId: string, isAuthor: boolean) => {
    setSquares(prev => prev.map(sq => sq.sourceId === sourceId ? { ...sq, isAuthor } : sq));
    try {
      await fetch(`${API_BASE}/boards/${boardIdRef.current}/sources/${sourceId}/author`, {
        method: 'PUT', headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ isAuthor }),
      });
    } catch {}
  }, [apiHeaders]);

  const handleSetAllowTrustVoting = useCallback(async (allow: boolean) => {
    setAllowTrustVoting(allow);
    try {
      await fetch(`${API_BASE}/boards/${boardIdRef.current}`, {
        method: 'PUT', headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ allowTrustVoting: allow }),
      });
    } catch {}
  }, [apiHeaders]);

  const handleTrustVote = useCallback(async (sourceId: string, category: 'source' | 'reference', vote: 'agree' | 'disagree' | null) => {
    if (!isSignedIn) { setSnackbar({ open: true, message: 'Sign in to vote' }); return; }
    setSquares(prev => prev.map(sq => sq.sourceId === sourceId ? {
      ...sq,
      ...(category === 'source' ? { currentUserTrustVoteSource: vote } : { currentUserTrustVoteReference: vote }),
    } : sq));
    try {
      const res = await fetch(`${API_BASE}/sources/${sourceId}/trust-vote`, {
        method: 'PUT', headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ category, vote: vote || 'none' }),
      });
      if (res.ok) {
        const data = await res.json();
        setSquares(prev => prev.map(sq => sq.sourceId === sourceId ? {
          ...sq,
          currentUserTrustVoteSource: data.currentUserTrustVoteSource,
          currentUserTrustVoteReference: data.currentUserTrustVoteReference,
          trustVoteSourceAgree: data.trustVoteSourceAgree,
          trustVoteSourceDisagree: data.trustVoteSourceDisagree,
          trustVoteReferenceAgree: data.trustVoteReferenceAgree,
          trustVoteReferenceDisagree: data.trustVoteReferenceDisagree,
        } : sq));
      } else if (res.status === 403) {
        setSnackbar({ open: true, message: 'Voting is disabled for this board' });
      }
    } catch {}
  }, [isSignedIn, apiHeaders]);

  const handleDeleteSquare = useCallback((id: number) => {
    if (madePublicAt) {
      const sq = squaresRef.current.find(s => s.id === id);
      if (sq) {
        const title = sq.fields.field2 || sq.fields.field1 || sq.sourceType || 'source';
        setBoardEditLog(log => [...log, { sourceId: sq.sourceId, field: 'Deleted', oldValue: title, newValue: '(removed)', editedAt: new Date().toISOString(), editedBy: clerkUsername || 'anonymous' }]);
      }
    }
    setSquares(prev => prev.filter(sq => sq.id !== id));
    setSnackbar({ open: true, message: 'Deleted' });
  }, [madePublicAt, clerkUsername]);
  const handleCopyId = useCallback((id: string) => setSnackbar({ open: true, message: `Copied: ${dispId(id)}` }), []);
  const fitChainToScreen = useCallback((opts?: { useSimple?: boolean }) => {
    if (squares.length === 0 || !containerRef.current) return;
    const useSimple = opts?.useSimple !== undefined ? opts.useSimple : simpleView;
    const rect = containerRef.current.getBoundingClientRect();
    const bw = useSimple ? 220 : SQUARE_WIDTH;
    const bh = useSimple ? 105 : SQUARE_HEIGHT;
    const renderedSquares = squares.map(sq => {
      const cp = compactPositionByOrder?.get(sq.sourceId);
      return cp ? { ...sq, position: cp } : sq;
    });
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    const chainSources: SquareData[] = [];
    for (const sq of renderedSquares) {
      if (appMode === 'single' && sq.isMainSource) continue;
      chainSources.push(sq);
      minX = Math.min(minX, sq.position.x);
      maxX = Math.max(maxX, sq.position.x + bw);
      minY = Math.min(minY, sq.position.y);
      maxY = Math.max(maxY, sq.position.y + bh);
    }
    if (!isFinite(minX)) {
      const s = renderedSquares[0];
      minX = s.position.x; maxX = s.position.x + bw;
      minY = s.position.y; maxY = s.position.y + bh;
    } else {
      // ─── Extrusion accounting ────────────────────────────────────────
      const isChain = chainSources.length > 1;
      if (isChain) {
        minX -= 170;
      }
      const chainEndBadgeReach = chainEnded && (!isOwner || isPublic) ? 240 : 80;
      maxX += chainEndBadgeReach;
      const anyHasFile = chainSources.some(sq =>
        !!(sq.uploadedFile?.previewUrl || sq.uploadedFile?.refCropUrl || sq.uploadedFile?.url)
      );
      if (anyHasFile) {
        const fileBubbleReach = useSimple ? 30 + 24 : 80 + 219;
        maxY += fileBubbleReach;
      }
      if (isOwner && !isPublic) {
        minY -= 60;
      }
    }
    const chainW = maxX - minX;
    const chainH = maxY - minY;
    const HEADLINE_RESERVE = 150;
    const SIDE_MARGIN      = 40;
    const BOTTOM_MARGIN    = 60;
    const usableW = Math.max(200, rect.width  - 2 * SIDE_MARGIN);
    const usableH = Math.max(200, rect.height - HEADLINE_RESERVE - BOTTOM_MARGIN);
    const fitZ = Math.min(usableW / chainW, usableH / chainH);
    const z = simpleView
      ? Math.max(0.35, Math.min(1.30, fitZ))
      : Math.max(0.35, Math.min(2.0, fitZ));
    const targetCenterX = (minX + maxX) / 2;
    const chainTopY    = minY;
    setZoom(z);
    setCanvasOffset({
      x: rect.width / 2 - targetCenterX * z,
      y: HEADLINE_RESERVE - chainTopY * z,
    });
  }, [squares, simpleView, appMode, compactPositionByOrder, chainEnded, isOwner, isPublic]);
  const fitChainToScreenRef = useRef(fitChainToScreen);
  useEffect(() => { fitChainToScreenRef.current = fitChainToScreen; }, [fitChainToScreen]);

  const handleResetView = useCallback(() => {
    if (squares.length > 0 && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const bw = simpleView ? 220 : SQUARE_WIDTH;
      const z = simpleView ? 1.26 : 0.78;
      if (appMode === 'single') {
        fitChainToScreen();
        return;
      } else if (appMode === 'tree') {
        const TREE_START_Y_LOCAL = 80;
        const cx = treeLineX * z;
        const targetBoxTop = Math.max(80, rect.height * 0.12);
        setZoom(z);
        setCanvasOffset({ x: rect.width / 2 - cx, y: targetBoxTop - TREE_START_Y_LOCAL * z });
      } else {
        const simW = simpleView ? 220 : 0;
        const simH = simpleView ? 105 : 0;
        const xs = squares.map(s => s.position.x);
        const ys = squares.map(s => s.position.y);
        const x2s = squares.map(s => s.position.x + (simpleView ? simW : s.size.width));
        const y2s = squares.map(s => s.position.y + (simpleView ? simH : s.size.height));
        const minX = Math.min(...xs), minY = Math.min(...ys);
        const maxX = Math.max(...x2s), maxY = Math.max(...y2s);
        const contentW = maxX - minX + 120;
        const contentH = maxY - minY + 120;
        const zx = rect.width / contentW;
        const zy = rect.height / contentH;
        const zFit = Math.max(0.25, Math.min(2, Math.min(zx, zy) * 0.9));
        const cx = (minX + maxX) / 2, cy = (minY + maxY) / 2;
        setZoom(zFit);
        setCanvasOffset({ x: rect.width / 2 - cx * zFit, y: rect.height / 2 - cy * zFit });
      }
    } else {
      setZoom(settingsRef.current.defaultZoom / 100);
      setCanvasOffset({ x: 0, y: 0 });
    }
  }, [squares, simpleView, appMode, treeLineX, fitChainToScreen]);
  const handleToggleFullscreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => setIsFullscreen(true)).catch(() => {});
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false)).catch(() => {});
    }
  }, []);
  
  const handleAlignSources = useCallback(() => {
    if (squares.length < 2) return;
    const nonMainSources = squares.filter(s => !s.isMainSource);
    if (nonMainSources.length < 2) return;
    const minY = Math.min(...nonMainSources.map(s => s.position.y));
    setSquares(prev => prev.map(sq => sq.isMainSource ? sq : { ...sq, position: { ...sq.position, y: minY } }));
    setSnackbar({ open: true, message: 'Sources aligned' });
  }, [squares]);
  const handleToggleChainEnd = useCallback((reason?: 'ended' | 'unknown') => { 
    if (chainEnded) { 
      logEdit('board', 'Chain Status', chainEndReason === 'unknown' ? 'Origin Unknown' : 'Original Source', 'Active');
      setChainEnded(false); setChainEndReason(''); setSnackbar({ open: true, message: 'Chain resumed — you can add more sources' }); 
    } else { 
      logEdit('board', 'Chain Status', 'Active', reason === 'unknown' ? 'Origin Unknown' : 'Original Source');
      setChainEnded(true); setChainEndReason(reason || 'ended'); setSnackbar({ open: true, message: reason === 'unknown' ? 'Marked as origin unknown — the true source could not be identified' : 'Marked as original source — no further sources to trace' }); 
    }
  }, [chainEnded, chainEndReason, logEdit]);
  const handleNewBoard = useCallback(() => {
    if (squares.length > 0 && appMode !== 'none' && tokenRef.current) {
      setLeaveConfirmOpen(true);
    } else {
      boardCreatedRef.current = new Set();
      setBoardId(generateBoardId()); setChainId(null); setSquares([]); setRefPoints([]); setAppMode('none'); setChainEnded(false); setChainEndReason(''); setSelectedSourceId(null); setIsPublic(false); setMadePublicAt(null); setBoardEditLog([]); setIsOwner(true); updateURL('');
      setModeDialogOpen(true);
    }
  }, [squares.length, appMode, isSignedIn]);
  const handleConfirmNewBoard = useCallback(async (save: boolean) => {
    if (save && tokenRef.current) { await saveToApi(); }
    setLeaveConfirmOpen(false);
    boardCreatedRef.current = new Set();
    setBoardId(generateBoardId()); setChainId(null); setSquares([]); setRefPoints([]); setAppMode('none'); setChainEnded(false); setChainEndReason(''); setSelectedSourceId(null); setIsPublic(false); setMadePublicAt(null); setBoardEditLog([]); setIsOwner(true); updateURL('');
    setModeDialogOpen(true);
  }, [saveToApi]);

  const handleExportCode = useCallback((): string => {
    if (squares.length === 0) return '<!-- No sources to export -->';
    
    let code = '';
    if (appMode === 'tree' && mainSource) {
      const mainType = ALL_SOURCE_TYPES.find(t => t.type === mainSource.sourceType);
      code = `<source-tree name="Source Tree">\n`;
      code += `  <root-source type="${mainSource.sourceType || 'unknown'}">\n`;
      mainType?.fields.forEach((f, i) => {
        const val = mainSource.fields[`field${i + 1}` as keyof SourceFields];
        if (val && f.codeTag) code += `    <field name="${f.codeTag}">${val}</field>\n`;
      });
      code += `  </root-source>\n`;
      
      refPoints.forEach(rp => {
        code += `  <node label="${rp.value}">\n`;
        squares.filter(s => s.refPointId === rp.id).forEach(sq => {
          const type = ALL_SOURCE_TYPES.find(t => t.type === sq.sourceType);
          code += `    <source type="${sq.sourceType || 'unknown'}">\n`;
          type?.fields.forEach((f, i) => {
            const val = sq.fields[`field${i + 1}` as keyof SourceFields];
            if (val && f.codeTag) code += `      <field name="${f.codeTag}">${val}</field>\n`;
          });
          if (sq.reference.from || sq.reference.to) {
            code += `      <ref from="${sq.reference.from}" to="${sq.reference.to}"/>\n`;
          }
          if (sq.uploadedFile) {
            const uf = sq.uploadedFile;
            code += `      <file name="${uf.name || ''}" type="${uf.type || ''}" size="${uf.size || 0}"`;
            if (uf.url) code += ` url="${uf.url}"`;
            if (uf.previewUrl) code += ` preview="${uf.previewUrl}"`;
            if (uf.refCropUrl) code += ` refCrop="${uf.refCropUrl}"`;
            if (uf.pageCount) code += ` pages="${uf.pageCount}"`;
            if (uf.origin) code += ` origin="${uf.origin}"`;
            code += `/>\n`;
          }
          code += `    </source>\n`;
        });
        code += `  </node>\n`;
      });
      code += `</source-tree>`;
    } else {
      code = `<source-chain>\n`;
      squares.forEach(sq => {
        const type = ALL_SOURCE_TYPES.find(t => t.type === sq.sourceType);
        code += `  <source type="${sq.sourceType || 'unknown'}" order="${sq.order}">\n`;
        type?.fields.forEach((f, i) => {
          const val = sq.fields[`field${i + 1}` as keyof SourceFields];
          if (val && f.codeTag) code += `    <field name="${f.codeTag}">${val}</field>\n`;
        });
        if (sq.reference.from || sq.reference.to) {
          code += `    <ref from="${sq.reference.from}" to="${sq.reference.to}"/>\n`;
        }
        if (sq.uploadedFile) {
          const uf = sq.uploadedFile;
          code += `    <file name="${uf.name || ''}" type="${uf.type || ''}" size="${uf.size || 0}"`;
          if (uf.url) code += ` url="${uf.url}"`;
          if (uf.previewUrl) code += ` preview="${uf.previewUrl}"`;
          if (uf.refCropUrl) code += ` refCrop="${uf.refCropUrl}"`;
          if (uf.pageCount) code += ` pages="${uf.pageCount}"`;
          if (uf.origin) code += ` origin="${uf.origin}"`;
          code += `/>\n`;
        }
        code += `  </source>\n`;
      });
      code += `</source-chain>`;
    }
    return code;
  }, [squares, refPoints, appMode, mainSource]);

  const handleCodeImport = useCallback((code: string) => {
    try {
      const isTree = code.includes('<source-tree');
      const isChain = code.includes('<source-chain');
      
      if (isTree) {
        setAppMode('tree');
        
        const rootMatch = code.match(/<root-source\s+type="([^"]+)">([\s\S]*?)<\/root-source>/);
        if (rootMatch) {
          const rootType = rootMatch[1];
          const rootContent = rootMatch[2];
          const rootFields = parseFieldsFromContent(rootContent, rootType);
          
          const mainSquare: SquareData = {
            id: nextId.current++,
            sourceId: generateSourceId(),
            size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
            position: { x: treeLineX - SQUARE_WIDTH / 2, y: TREE_START_Y },
            sourceType: rootType,
            name: 'Seed Node',
            fields: rootFields,
            order: 0,
            createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
            uploadedFile: null,
            reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false,
            isMainSource: true,
          };
          
          const newSquares: SquareData[] = [mainSquare];
          const newRefPoints: RefPoint[] = [];
          
          const nodeRegex = /<node\s+label="([^"]+)">([\s\S]*?)<\/node>/g;
          let nodeMatch;
          let nodeIndex = 0;
          
          while ((nodeMatch = nodeRegex.exec(code)) !== null) {
            const nodeLabel = nodeMatch[1];
            const nodeContent = nodeMatch[2];
            const refPointY = TREE_START_Y + SQUARE_HEIGHT + 100 + nodeIndex * (SQUARE_HEIGHT + 80);
            
            const refPoint: RefPoint = {
              id: `rp-${Date.now()}-${nodeIndex}`,
              y: refPointY,
              label: `Ref ${nodeIndex + 1}`,
              value: nodeLabel,
              sourceIds: [],
            };
            newRefPoints.push(refPoint);
            
            const sourceRegex = /<source\s+type="([^"]+)">([\s\S]*?)<\/source>/g;
            let sourceMatch;
            let sourceIndex = 0;
            
            while ((sourceMatch = sourceRegex.exec(nodeContent)) !== null) {
              const sourceType = sourceMatch[1];
              const sourceContent = sourceMatch[2];
              const fields = parseFieldsFromContent(sourceContent, sourceType);
              const ref = parseRefFromContent(sourceContent);
              
              const refBoxRight = treeLineX + 60 + REF_BOX_WIDTH + 40;
              const xOffset = refBoxRight + sourceIndex * (SQUARE_WIDTH + GAP);
              
              const square: SquareData = {
                id: nextId.current++,
                sourceId: generateSourceId(),
                size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
                position: { x: xOffset, y: refPointY - SQUARE_HEIGHT / 2 },
                sourceType,
                name: `Source ${newSquares.length}`,
                fields,
                order: newSquares.length,
                createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
                uploadedFile: null,
                reference: ref,
                refPointId: refPoint.id,
                trustRates: emptyTrustRates, trustAssessed: false,
              };
              newSquares.push(square);
              refPoint.sourceIds.push(square.sourceId);
              sourceIndex++;
            }
            nodeIndex++;
          }
          
          setSquares(newSquares);
          setRefPoints(newRefPoints);
          setBoardId(mainSquare.sourceId); setChainId(null);
        }
      } else if (isChain) {
        setAppMode('single');
        
        const newSquares: SquareData[] = [];
        const sourceRegex = /<source\s+type="([^"]+)"[^>]*>([\s\S]*?)<\/source>/g;
        let match;
        let index = 0;
        
        while ((match = sourceRegex.exec(code)) !== null) {
          const sourceType = match[1];
          const content = match[2];
          const fields = parseFieldsFromContent(content, sourceType);
          const ref = parseRefFromContent(content);
          
          
          const pos = { x: 80 + index * (SQUARE_WIDTH + GAP), y: 150 };
          
          const square: SquareData = {
            id: nextId.current++,
            sourceId: generateSourceId(),
            size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
            position: pos,
            sourceType,
            name: `Source ${index + 1}`,
            fields,
            order: index + 1,
            createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
            uploadedFile: null,
            reference: ref, trustRates: emptyTrustRates, trustAssessed: false,
          };
          newSquares.push(square);
          index++;
        }
        
        if (newSquares.length > 0) {
          setSquares(newSquares);
          setRefPoints([]);
        }
      } else {
        setAppMode('single');
        
        const newSquares: SquareData[] = [];
        const sourceRegex = /<source\s+type="([^"]+)"[^>]*>([\s\S]*?)<\/source>/g;
        let match;
        let index = 0;
        
        while ((match = sourceRegex.exec(code)) !== null) {
          const sourceType = match[1];
          const content = match[2];
          const fields = parseFieldsFromContent(content, sourceType);
          const ref = parseRefFromContent(content);
          
          
          const pos = { x: 80 + index * (SQUARE_WIDTH + GAP), y: 150 };
          
          const square: SquareData = {
            id: nextId.current++,
            sourceId: generateSourceId(),
            size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
            position: pos,
            sourceType,
            name: `Source ${index + 1}`,
            fields,
            order: index + 1,
            createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
            uploadedFile: null,
            reference: ref, trustRates: emptyTrustRates, trustAssessed: false,
          };
          newSquares.push(square);
          index++;
        }
        
        if (newSquares.length > 0) {
          setSquares(newSquares);
          setRefPoints([]);
        }
      }
      
      setSnackbar({ open: true, message: 'Code imported successfully!' });
    } catch (e) {
      console.error('Import error:', e);
      setSnackbar({ open: true, message: 'Error importing code' });
    }
  }, [treeLineX]);

  const bgGradient = isDarkMode ? '#1c1c26' : '#e4e7ec';

  const TREE_SEED_BOTTOM_Y = TREE_START_Y - 10 + Math.round(105 * 1.3) + 10;
  const mainSourceY = mainSource ? (appMode === 'tree' ? TREE_SEED_BOTTOM_Y : mainSource.position.y + mainSource.size.height) : TREE_START_Y + SQUARE_HEIGHT;
  const lastRefPointY = refPoints.length > 0 ? refPoints[refPoints.length - 1].y : mainSourceY;
  const treeLineEndY = lastRefPointY + SQUARE_HEIGHT / 2 + 120;

  if (_staticPage === 'about')  return <ThemeProvider theme={theme}><CssBaseline /><AboutSitePage /></ThemeProvider>;
  if (_staticPage === 'tos')    return <ThemeProvider theme={theme}><CssBaseline /><TOSPage /></ThemeProvider>;
  if (_staticPage === 'gdpr')   return <ThemeProvider theme={theme}><CssBaseline /><GDPRPage /></ThemeProvider>;
  if (_staticPage === 'optout') return <ThemeProvider theme={theme}><CssBaseline /><OptOutPage /></ThemeProvider>;

  if (showSignIn && !isSignedIn) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ height: '100vh', width: '100vw', bgcolor: 'background.default', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', overflow: 'auto' }}>
          <Box sx={{ mb: 3, textAlign: 'center' }}>
            <Typography sx={{ fontSize: '2.2rem', fontWeight: 700, mb: 0.5 }}>source<span style={{ color: '#5b8fc7' }}>.</span></Typography>
            <Typography fontSize={13} color="text.secondary">Sign in to create and manage your sources</Typography>
          </Box>
          <SignIn routing="virtual" />
          <Button
            onClick={() => { setShowSignIn(false); window.location.href = '/'; }}
            startIcon={<ArrowBackIcon sx={{ fontSize: 14 }} />}
            sx={{ mt: 3, textTransform: 'none', color: 'text.secondary', fontSize: 13 }}>
            Back to source.io
          </Button>
        </Box>
      </ThemeProvider>
    );
  }

  if (!authLoaded || !appInitialized) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
          <Typography sx={{ fontSize: 48, fontWeight: 800, color: 'text.primary', mb: 3, letterSpacing: '-0.02em' }}>Source.</Typography>
          <CircularProgress size={28} thickness={4} />
        </Box>
      </ThemeProvider>
    );
  }

  if (isMobile && appMode !== 'none') {
    return (
      <TranslationProvider
        initialLang={(SUPPORTED_LANGUAGES.includes(appSettings.language as LangCode) ? appSettings.language : 'en') as LangCode}
        onLanguageChange={(next) => setAppSettings(prev => ({ ...prev, language: next }))}>
      <ThemeProvider theme={theme}><CssBaseline />
        <MobileView
          squares={squares}
          refPoints={refPoints}
          appMode={appMode}
          boardId={boardId}
          boardTitle={boardHistory.find(h => h.boardId === boardId)?.title}
          boardUpdatedAt={boardUpdatedAt}
          isPublic={isPublic}
          isOwner={isOwner}
          isDark={isDarkMode}
          appSettings={appSettings}
          recentBoards={boardHistory.map(h => ({
            board_id: h.boardId,
            title: h.title,
            updated_at: undefined,
          }))}
          onSwitchBoard={async (bid) => { await loadBoardFromApi(bid); }}
          onSignIn={() => setShowSignIn(true)}
          isSignedIn={!!isSignedIn}
          apiBase={API_BASE}
          getToken={async () => { try { return await getToken(); } catch { return null; } }}
        />
        {showSignIn && (
          <Dialog open={showSignIn} onClose={() => setShowSignIn(false)} fullScreen>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
              <SignIn routing="virtual" />
              <Button onClick={() => setShowSignIn(false)} sx={{ mt: 2, fontSize: 12, textTransform: 'none' }}>Cancel</Button>
            </DialogContent>
          </Dialog>
        )}
      </ThemeProvider>
      </TranslationProvider>
    );
  }

  return (
    <TranslationProvider
      initialLang={(SUPPORTED_LANGUAGES.includes(appSettings.language as LangCode) ? appSettings.language : 'en') as LangCode}
      onLanguageChange={(next) => setAppSettings(prev => ({ ...prev, language: next }))}>
    <ThemeProvider theme={theme}><CssBaseline />
      <style>{`body { overflow: hidden !important; padding-right: 0 !important; }`}</style>
      <Box sx={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden', userSelect: 'none' }}>
        {demoMode && (
          <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 13000, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2.5, py: 0.8, bgcolor: '#f59e0b', color: '#1a1a1a', borderRadius: '0 0 12px 12px', boxShadow: 3, pointerEvents: 'auto', maxWidth: '94vw' }}>
              <PlayArrowIcon sx={{ fontSize: 18 }} />
              <Typography sx={{ fontSize: 12.5, fontWeight: 700, lineHeight: 1.3 }}>
                <T k="demo.banner" fb="Demo mode — this is a preview. Nothing you do here is saved." />
              </Typography>
              <Button
                size="small"
                onClick={() => {
                  setDemoMode(false);
                  boardCreatedRef.current = new Set();
                  setSquares([]); setRefPoints([]); setAppMode('none');
                  setChainEnded(false); setChainEndReason('');
                  setSelectedSourceId(null); setIsPublic(false);
                  setMadePublicAt(null); setBoardEditLog([]);
                  setBoardId(generateBoardId()); setChainId(null);
                  updateURL('');
                  setModeDialogOpen(true);
                }}
                sx={{ bgcolor: '#1a1a1a', color: '#f59e0b', fontSize: 11, fontWeight: 700, textTransform: 'none', px: 1.5, py: 0.2, minWidth: 0, '&:hover': { bgcolor: '#000' } }}>
                <T k="demo.exit" fb="Exit" />
              </Button>
            </Box>
          </Box>
        )}
        {!cleanView && (isOwner || appMode === 'none') && (
          <Sidebar onOpenMySourcesDialog={async () => { try { const t = await getToken(); if (t) tokenRef.current = t; } catch {} setAppMode('none'); navigateDashboard('home'); updateURL(''); }} onOpenMySources={async () => { try { const t = await getToken(); if (t) tokenRef.current = t; } catch {} setAppMode('none'); navigateDashboard('sources'); updateURL(''); }} onOpenSaved={() => { setAppMode('none'); navigateDashboard('saved'); updateURL(''); }} isSignedIn={!!isSignedIn} isCollapsed={sidebarCollapsed} setIsCollapsed={setSidebarCollapsed} onNewBoard={() => { setAppMode('none'); navigateDashboard('create'); updateURL(''); }} isPublic={isPublic} appMode={appMode} onOpenSettings={() => { setAppMode('none'); navigateDashboard('settings'); updateURL(''); }} isAdmin={isAdmin} onOpenAdmin={() => { setAppMode('none'); navigateDashboard('admin'); updateURL(''); }} onSignIn={() => { setShowSignIn(true); }} onSignUp={() => { clerk.openSignUp({}); }} onAccount={() => { setAppMode('none'); navigateDashboard('account'); updateURL(''); }} onLogout={async () => { try { await clerk.signOut(); } catch {} window.location.href = window.location.origin; }} onProfile={() => { setAppMode('none'); navigateDashboard('profile'); updateURL(''); }} hasPrevBoard={boardHistory.length > 0} onPrevBoard={async () => { if (boardHistory.length === 0) return; const prev = boardHistory[0]; const firstTitle = squares.length > 0 ? ([...squares].sort((a, b) => b.order - a.order)[0]?.fields?.field2 || '') : ''; if (appMode !== 'none') { setBoardHistory(h => { const entry = { boardId, zoom, offset: canvasOffset, selectedSourceId, appMode, title: firstTitle, isPublic }; const filtered = h.filter(e => e.boardId !== boardId); return [entry, ...filtered].slice(0, 3); }); } const ok = await loadBoardFromApi(prev.boardId, prev.selectedSourceId); if (ok) { setTimeout(() => { setZoom(prev.zoom); setCanvasOffset(prev.offset); if (prev.selectedSourceId) setSelectedSourceId(prev.selectedSourceId); }, 300); } }} activeView={appMode !== 'none' ? 'board' : dashboardView} boardId={appMode !== 'none' ? dispId(boardId) : undefined} boardHistory={boardHistory.map(h => ({ boardId: h.boardId, title: h.title, isPublic: h.isPublic }))} onLoadHistory={async (bid) => { const entry = boardHistory.find(h => h.boardId === bid); const ok = await loadBoardFromApi(bid, entry?.selectedSourceId, { centerOnHeadline: true }); if (ok && entry?.selectedSourceId) { setTimeout(() => setSelectedSourceId(entry.selectedSourceId), 300); } }} onRemoveHistory={(bid) => setBoardHistory(h => h.filter(e => e.boardId !== bid))} />
        )}
        
        <MySourcesDialog open={mySourcesDialogOpen} onClose={() => setMySourcesDialogOpen(false)} sources={squares} chainEnded={chainEnded} chainEndReason={chainEndReason} appMode={appMode} boardId={boardId} setSnackbar={setSnackbar} onDelete={handleDeleteSquare} isPublic={isPublic} 
          onGoTo={(sourceId) => {
            const sq = squares.find(s => s.sourceId === sourceId);
            if (sq && containerRef.current) {
              setSelectedSourceId(sourceId);
              updateURL(boardId, chainIdRef.current, sourceId);
              const rect = containerRef.current.getBoundingClientRect();
              const boxCenterX = (sq.position.x + sq.size.width / 2) * zoom;
              const boxCenterY = (sq.position.y + sq.size.height / 2) * zoom;
              setCanvasOffset({ x: (rect.width / 2) - boxCenterX, y: (rect.height / 2) - boxCenterY });
            }
          }}
          onEdit={(sourceId) => {
            setSelectedSourceId(sourceId);
            updateURL(boardId, chainIdRef.current, sourceId);
          }}
          readOnly={!isOwner || isPublic}
          apiHeaders={apiHeaders}
          isSignedIn={!!isSignedIn}
          onLoadBoard={async (bid: string) => { const loaded = await loadBoardFromApi(bid); if (loaded) { setModeDialogOpen(false); } }}
          onDeleteBoard={async (bid: string) => { try { await fetch(`${API_BASE}/boards/${bid}`, { method: 'DELETE', headers: apiHeaders() }); if (bid === boardId) { setSquares([]); setRefPoints([]); setAppMode('none'); } } catch {} }}
        />
        <HelpDialog open={helpDialogOpen} onClose={() => setHelpDialogOpen(false)} isDark={isDarkMode} />
        <AboutDialog open={aboutDialogOpen} onClose={() => setAboutDialogOpen(false)} isDark={isDarkMode} />
        {viewProfileUsername && <PublicProfilePage username={viewProfileUsername} onClose={() => setViewProfileUsername(null)} isDark={isDarkMode} apiHeaders={apiHeaders} />}
        <SourceGraphDialog
          open={!!graphDialog}
          onClose={() => setGraphDialog(null)}
          sourceId={graphDialog?.sourceId || ''}
          sourceLabel={graphDialog?.label || ''}
          isDark={isDarkMode}
          onOpenBoard={(bid) => { window.location.href = `${window.location.origin}/?board=${encodeURIComponent(bid)}`; }}
        />
        <EmbedDialog
          open={!!embedDialog}
          onClose={() => setEmbedDialog(null)}
          sourceId={embedDialog?.sourceId || ''}
          sourceLabel={embedDialog?.label || ''}
          isDark={isDarkMode}
          getToken={getToken}
        />
        <ShareDialog open={shareDialogOpen} onClose={() => setShareDialogOpen(false)} boardId={boardId} chainId={chainId} isPublic={isPublic} setSnackbar={setSnackbar} />
        {modeDialogOpen && (
          <Box sx={{ position: 'fixed', inset: 0, zIndex: 9999, bgcolor: 'background.default', overflow: 'auto' }}>
            <ModeSelectionPage onSelect={(mode) => { setModeDialogOpen(false); handleModeSelect(mode); }} isDark={isDarkMode} isLoggedIn={!!isSignedIn} onSignIn={() => { setModeDialogOpen(false); setShowSignIn(true); }} onClose={() => setModeDialogOpen(false)} onOpenAi={() => { setModeDialogOpen(false); setShowAiPage(true); }} onDemo={() => { setDemoMode(true); setModeDialogOpen(false); handleModeSelect('single'); }} />
          </Box>
        )}
        {showAiPage && (
          <Box sx={{ position: 'fixed', inset: 0, zIndex: 9999, bgcolor: 'background.default', overflow: 'auto' }}>
            <AiBoardPage
              isDark={isDarkMode}
              onBack={() => setShowAiPage(false)}
              onOpenBoard={(bid) => { window.location.href = `${window.location.origin}/?board=${encodeURIComponent(bid)}`; }}
            />
          </Box>
        )}
        <RefPointDialog
          open={refPointDialogOpen}
          onClose={() => { setRefPointDialogOpen(false); setRefPointEditingId(null); }}
          onSave={(fromValue, toValue, sectionAnchors) => {
            if (refPointEditingId) handleEditRefPoint(refPointEditingId, fromValue, toValue, sectionAnchors);
            else handleAddRefPoint(fromValue, toValue, sectionAnchors);
          }}
          mainSourceType={mainSource?.sourceType || null}
          pointerType={mainSource?.reference?.pointerType}
          initialFrom={refPointEditingId ? (refPoints.find(r => r.id === refPointEditingId)?.fromValue || '') : ''}
          initialTo={refPointEditingId ? (refPoints.find(r => r.id === refPointEditingId)?.toValue || '') : ''}
          initialFromSectionStartsWith={refPointEditingId ? (refPoints.find(r => r.id === refPointEditingId)?.fromSectionStartsWith || '') : ''}
          initialToSectionEndsWith={refPointEditingId ? (refPoints.find(r => r.id === refPointEditingId)?.toSectionEndsWith || '') : ''}
          isDark={isDarkMode}
        />
        <Dialog disableScrollLock open={seedRefSettingsOpen} onClose={() => setSeedRefSettingsOpen(false)}
          maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
          <DialogTitle sx={{ pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <SettingsIcon sx={{ fontSize: 18, color: '#475569' }} />
              <Typography fontWeight={700} fontSize={15}>Reference Type</Typography>
            </Box>
            <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.3 }}>
              Choose what the bubbles on the trunk represent. All bubbles in this tree use the same type — only their range differs.
            </Typography>
          </DialogTitle>
          <DialogContent>
            {(() => {
              const currentType = mainSource?.reference?.pointerType
                || (DEFAULT_POINTER_TYPES[mainSource?.sourceType || ''] || DEFAULT_POINTER_TYPES.default)[0]
                || 'page';
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.7 }}>
                  {REF_POINTER_TYPES.map(p => (
                    <Box key={p.key} onClick={() => {
                        if (!mainSource) return;
                        if (currentType === p.key) return;
                        if (refPoints.length === 0) {
                          handleReferenceChange(mainSource.id, { ...mainSource.reference, pointerType: p.key });
                        } else {
                          setPendingPointerType(p.key);
                        }
                      }}
                      sx={{ display: 'flex', alignItems: 'center', gap: 1.2, p: 1, borderRadius: '8px',
                        bgcolor: currentType === p.key ? 'rgba(71,85,105,0.12)' : 'transparent',
                        border: '1px solid', borderColor: currentType === p.key ? '#475569' : 'divider',
                        cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
                      <Typography fontSize={18}>{p.icon}</Typography>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography fontSize={13} fontWeight={600}>{p.label}</Typography>
                        <Typography fontSize={10} color="text.secondary">{p.fromLabel} → {p.toLabel}</Typography>
                      </Box>
                      {currentType === p.key && <CheckCircleIcon sx={{ fontSize: 16, color: '#475569' }} />}
                    </Box>
                  ))}
                </Box>
              );
            })()}
            {refPoints.length > 0 && (
              <Typography fontSize={10} color="warning.main" sx={{ mt: 1.5, display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                <WarningIcon sx={{ fontSize: 12, mt: 0.1, flexShrink: 0 }} />
                Changing the type will reset {refPoints.length} existing reference {refPoints.length === 1 ? 'point' : 'points'} on the trunk — page numbers and time stamps aren't interchangeable. You'll be asked to confirm before any change is applied.
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
            <Button onClick={() => setSeedRefSettingsOpen(false)} sx={{ textTransform: 'none' }}>Done</Button>
          </DialogActions>
        </Dialog>
        <Dialog disableScrollLock open={pendingPointerType != null} onClose={() => setPendingPointerType(null)}
          maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '10px' } }}>
          <DialogTitle sx={{ pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WarningIcon sx={{ fontSize: 20, color: '#f59e0b' }} />
              <Typography fontWeight={700} fontSize={15}>Reset reference points?</Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            {(() => {
              const newType = pendingPointerType ? REF_POINTER_TYPES.find(p => p.key === pendingPointerType) : null;
              const currentTypeKey = mainSource?.reference?.pointerType
                || (DEFAULT_POINTER_TYPES[mainSource?.sourceType || ''] || DEFAULT_POINTER_TYPES.default)[0]
                || 'page';
              const currentType = REF_POINTER_TYPES.find(p => p.key === currentTypeKey);
              return (
                <>
                  <Typography fontSize={12.5} sx={{ mb: 1.5 }}>
                    Switching from <Box component="span" sx={{ fontWeight: 700 }}>{currentType?.label}</Box> to <Box component="span" sx={{ fontWeight: 700 }}>{newType?.label}</Box> will clear all <Box component="span" sx={{ fontWeight: 700 }}>{refPoints.length}</Box> existing reference {refPoints.length === 1 ? 'point' : 'points'} on the trunk.
                  </Typography>
                  <Typography fontSize={11.5} color="text.secondary" sx={{ mb: 1.5 }}>
                    Source boxes connected to those references will also be removed. You'll need to add fresh reference points using the new type's format ({newType?.fromLabel?.toLowerCase()} → {newType?.toLabel?.toLowerCase()}).
                  </Typography>
                  <Typography fontSize={11} sx={{ p: 1, bgcolor: 'rgba(245,158,11,0.08)', borderRadius: '6px', border: '1px solid rgba(245,158,11,0.25)', color: 'text.secondary' }}>
                    <Box component="span" sx={{ fontWeight: 700, color: '#f59e0b' }}>This cannot be undone.</Box> Cancel if you'd rather keep your current points.
                  </Typography>
                </>
              );
            })()}
          </DialogContent>
          <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
            <Button onClick={() => setPendingPointerType(null)} sx={{ textTransform: 'none' }}>Cancel</Button>
            <Button variant="contained" color="warning" onClick={() => {
              if (mainSource && pendingPointerType) {
                setRefPoints([]);
                setSquares(prev => prev.filter(s => !s.refPointId));
                setSelectedRefPointId(null);
                handleReferenceChange(mainSource.id, { ...mainSource.reference, pointerType: pendingPointerType });
                setSnackbar({ open: true, message: 'Reference points cleared. Add new ones using the new type.' });
                setTimeout(() => saveToApi(), 300);
              }
              setPendingPointerType(null);
            }} sx={{ textTransform: 'none', fontWeight: 700 }}>Reset & change type</Button>
          </DialogActions>
        </Dialog>
        <WarningDialog open={warningDialogOpen} onClose={() => setWarningDialogOpen(false)} message={warningMessage} />
        <Dialog disableScrollLock open={importConfirmOpen} onClose={() => setImportConfirmOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
          <DialogTitle sx={{ pb: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><WarningIcon color="warning" /><Typography fontWeight={700} fontSize={16}>Import Sources</Typography></Box>
          </DialogTitle>
          <DialogContent>
            <Typography fontSize={12} color="text.secondary" lineHeight={1.6}>
              You already have {squares.length} source{squares.length !== 1 ? 's' : ''} on this board. How would you like to import?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 2.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button fullWidth variant="outlined" onClick={() => { setImportConfirmOpen(false); handleCodeImport(pendingImportCode.current); setCanvasTab('board'); }}
              sx={{ textTransform: 'none', fontWeight: 600 }}>
              Add to existing sources
            </Button>
            <Button fullWidth variant="contained" color="error" onClick={() => { setImportConfirmOpen(false); setSquares([]); setRefPoints([]); setBoardId(generateBoardId()); setChainId(null); setTimeout(() => { handleCodeImport(pendingImportCode.current); setCanvasTab('board'); }, 100); }}
              sx={{ textTransform: 'none', fontWeight: 600 }}>
              Start new board with imported data
            </Button>
            <Button fullWidth onClick={() => setImportConfirmOpen(false)} color="inherit" sx={{ textTransform: 'none' }}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <Dialog disableScrollLock open={leaveConfirmOpen} onClose={() => setLeaveConfirmOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
          <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <WarningIcon sx={{ color: '#f59e0b' }} />
            <Typography fontWeight={700}>Leave this board?</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography fontSize={13} color="text.secondary">You are leaving the current board. Would you like to save your changes before starting a new one?</Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
            <Button onClick={() => setLeaveConfirmOpen(false)} sx={{ color: 'text.secondary' }}>Cancel</Button>
            <Button variant="outlined" color="error" onClick={() => handleConfirmNewBoard(false)}>Don't Save</Button>
            <Button variant="contained" onClick={() => handleConfirmNewBoard(true)}>Save & Leave</Button>
          </DialogActions>
        </Dialog>
        <Dialog disableScrollLock open={makePublicBlockOpen} onClose={() => setMakePublicBlockOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
          <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <LockPersonIcon sx={{ color: '#f59e0b', fontSize: 22 }} />
            <Typography fontWeight={700}>Cannot Publish Yet</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography fontSize={13} color="text.secondary" sx={{ mb: 1.5 }}>To make this board public, the following must be completed:</Typography>
            {makePublicBlockReasons.map((r, i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.8 }}>
                <WarningIcon sx={{ fontSize: 14, color: '#f59e0b', mt: 0.15, flexShrink: 0 }} />
                <Typography fontSize={12}>{r}</Typography>
              </Box>
            ))}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" onClick={() => setMakePublicBlockOpen(false)} sx={{ fontWeight: 600 }}>Got it</Button>
          </DialogActions>
        </Dialog>
        <Dialog disableScrollLock open={linkIdDialogOpen} onClose={() => setLinkIdDialogOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LinkIcon color="primary" />
              <Typography fontWeight={600}>Link Source by ID</Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary" fontSize={12} sx={{ mb: 2 }}>
              Enter a Source ID or Source Chain ID to link an existing source to this reference point.
            </Typography>
            <TextField 
              fullWidth size="small" label="Source ID or Chain ID" 
              value={linkIdValue} onChange={(e) => setLinkIdValue(e.target.value.toLowerCase())}
              placeholder="e.g. a3b2c1" 
              InputProps={{ sx: { fontFamily: 'monospace' } }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => setLinkIdDialogOpen(false)}>Cancel</Button>
            <Button variant="contained" disabled={!linkIdValue.trim()} onClick={() => {
              if (linkIdRefPointId && linkIdValue.trim()) {
                const rp = refPoints.find(r => r.id === linkIdRefPointId);
                if (!rp) return;
                const existingSources = squares.filter(s => s.refPointId === linkIdRefPointId);
                const refBoxRight = treeLineX + 60 + REF_BOX_WIDTH + 40;
                const xOffset = refBoxRight + existingSources.length * (SQUARE_WIDTH + GAP);
                const newSquare: SquareData = {
                  id: nextId.current++,
                  sourceId: linkIdValue.trim().toLowerCase(),
                  size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
                  position: { x: xOffset, y: rp.y - SQUARE_HEIGHT / 2 },
                  sourceType: null,
                  name: `Linked: ${dispId(linkIdValue.trim())}`,
                  fields: emptyFields,
                  order: squares.filter(s => !s.isMainSource).length + 1,
                  createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
                  uploadedFile: null,
                  reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false,
                  refPointId: linkIdRefPointId,
                };
                setSquares([...squares, newSquare]);
                setSelectedSourceId(newSquare.sourceId);
                setCenterOnSourceReq({ sourceId: newSquare.sourceId, nonce: Date.now() });
                setSnackbar({ open: true, message: `Linked ${dispId(linkIdValue.trim())}` });
                setLinkIdDialogOpen(false);
              }
            }}>Link</Button>
          </DialogActions>
        </Dialog>
        <CanvasContextMenu anchorPosition={contextMenu} onClose={() => setContextMenu(null)} onAddSource={handleAddSquare} onResetView={handleResetView} onEndChain={handleToggleChainEnd} chainEnded={chainEnded} isPublic={isPublic} appMode={appMode} onStartSingle={() => handleModeSelect('single')} onStartTree={() => handleModeSelect('tree')} readOnly={!isOwner || isPublic} />


        <Box sx={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        {privateBoardError ? (
          <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: bgGradient }}>
            <Box sx={{ width: 72, height: 72, borderRadius: '50%', bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5 }}>
              <LockPersonIcon sx={{ fontSize: 36, color: 'text.disabled' }} />
            </Box>
            <Typography variant="h5" fontWeight={700} sx={{ mb: 1, textAlign: 'center' }}>
              {privateBoardEverPublished
                ? 'This board has been unpublished'
                : 'This board is not published'}
            </Typography>
            {privateBoardId && (
              <Typography color="text.secondary" fontSize={13} sx={{ mb: 1.5, fontFamily: 'monospace' }}>
                Board {dispId(privateBoardId)}
              </Typography>
            )}
            <Typography color="text.secondary" fontSize={14} sx={{ mb: 3, maxWidth: 460, textAlign: 'center', lineHeight: 1.7 }}>
              {privateBoardEverPublished
                ? 'The owner made this board private again. If you saved its URL, it may not be available until the owner re-publishes it.'
                : 'The owner has not made this board public yet. If you are the owner, sign in to access it or set the board visibility to public.'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              {isSignedIn ? (
                <Button variant="contained" onClick={() => { setPrivateBoardError(false); setDashboardView('home'); window.history.replaceState({}, '', '/'); }} startIcon={<RestartAltIcon />} sx={{ textTransform: 'none' }}>Go to Dashboard</Button>
              ) : (
                <>
                  <Button variant="contained" onClick={() => { setPrivateBoardError(false); setShowSignIn(true); }} startIcon={<LoginIcon />} sx={{ textTransform: 'none' }}>Sign In</Button>
                  <Button variant="outlined" onClick={() => { setPrivateBoardError(false); setModeDialogOpen(true); window.history.replaceState({}, '', '/'); }} sx={{ textTransform: 'none' }}>Start New Board</Button>
                </>
              )}
            </Box>
          </Box>
        ) : dashboardView === 'account' && isSignedIn ? (
        <Box sx={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'auto', bgcolor: 'background.default' }}>
          <Box sx={{ px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            <IconButton onClick={() => window.history.back()} size="small"><ArrowBackIcon /></IconButton>
            <Typography fontWeight={700} fontSize={18}>Account</Typography>
            <Box sx={{ flex: 1 }} />
            <Button size="small" onClick={() => navigateDashboard('profile')} sx={{ fontSize: 11, textTransform: 'none' }}>Edit Public Profile</Button>
          </Box>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', pt: 4, pb: 4 }}>
            <UserProfile routing="virtual" />
          </Box>
        </Box>
        ) : appMode === 'none' && isSignedIn ? (
        dashboardView === 'sources' ? (
        <MySourcesPage
          key={dashRefreshKey}
          isDark={isDarkMode}
          onLoadBoard={async (bid: string) => { await loadBoardFromApi(bid, null, { forceNormalView: true }); }}
          apiHeaders={apiHeaders}
          onDeleteBoard={async (bid: string) => { try { await fetch(`${API_BASE}/boards/${bid}`, { method: 'DELETE', headers: apiHeaders() }); } catch {} }}
          onBack={() => window.history.back()}
          appSettings={appSettings}
        />
        ) : dashboardView === 'profile' && isSignedIn ? (
        <EditProfilePage isDark={isDarkMode} onBack={() => window.history.back()} apiHeaders={apiHeaders} clerkUser={clerkUser} />
        ) : dashboardView === 'about' ? (
        <AboutPage isDark={isDarkMode} onBack={() => window.history.back()} />
        ) : dashboardView === 'admin' && isAdmin ? (
        <AdminPage isDark={isDarkMode} onBack={() => window.history.back()} apiHeaders={apiHeaders} />
        ) : dashboardView === 'settings' ? (
        <SettingsPage isDark={isDarkMode} onToggleDark={() => setIsDarkMode(v => !v)} onBack={() => window.history.back()} settings={appSettings} onSave={(s) => {
          setAppSettings(s);
          if (s.defaultZoom !== appSettings.defaultZoom) setZoom(s.defaultZoom / 100);
          if (tokenRef.current) { fetch(`${API_BASE}/auth/settings`, { method: 'PUT', headers: apiHeaders(), body: JSON.stringify({ settings: s }) }).catch(() => {}); }
        }} user={{ username: clerkUsername, isLoggedIn: !!isSignedIn }} onUsernameChange={(name) => { if (tokenRef.current) { fetch(`${API_BASE}/auth/settings`, { method: 'PUT', headers: apiHeaders(), body: JSON.stringify({ displayName: name }) }).catch(() => {}); } }} setSnackbar={setSnackbar} />
        ) : dashboardView === 'search' ? (
        <SearchPage isDark={isDarkMode} onBack={() => window.history.back()} onLoadBoard={async (bid: string) => { await loadBoardFromApi(bid); }} />
        ) : dashboardView === 'create' ? (
        <CreateSourcePage 
          isDark={isDarkMode} 
          onClose={() => window.history.back()}
          onSelect={(mode) => {
            if (squares.length > 0 && appMode !== 'none' && tokenRef.current) {
              setLeaveConfirmOpen(true);
            } else {
              boardCreatedRef.current = new Set();
              setBoardId(generateBoardId()); setChainId(null); setSquares([]); setRefPoints([]); setAppMode('none'); setChainEnded(false); setChainEndReason(''); setSelectedSourceId(null); setIsPublic(false); setMadePublicAt(null); setBoardEditLog([]); setIsOwner(true); updateURL('');
              handleModeSelect(mode);
            }
          }}
        />
        ) : dashboardView === 'saved' && isSignedIn ? (
        <Box sx={{ flex: 1, overflow: 'auto', p: 3, maxWidth: 900, mx: 'auto', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <BookmarkIcon sx={{ color: '#f59e0b' }} />
            <Typography fontWeight={700} fontSize={18}>Saved Boards</Typography>
          </Box>
          <Typography fontSize={12} color="text.secondary" sx={{ mb: 3 }}>Public boards from other users that you've bookmarked.</Typography>
          <SavedBoardsList apiHeaders={apiHeaders} isDark={isDarkMode} onLoadBoard={async (bid: string) => { await loadBoardFromApi(bid); }} appSettings={appSettings} />
        </Box>
        ) : (
        <DashboardPage
          key={dashRefreshKey}
          onSelect={handleModeSelect} isDark={isDarkMode}
          onLoadBoard={async (bid: string) => { await loadBoardFromApi(bid); }}
          apiHeaders={apiHeaders}
          onDeleteBoard={async (bid: string) => { try { await fetch(`${API_BASE}/boards/${bid}`, { method: 'DELETE', headers: apiHeaders() }); } catch {} }}
          username={clerkUsername || ''}
          onOpenMySources={() => navigateDashboard('sources')}
          userSettings={appSettings}
        />
        )
        ) : (
        <>
        <Box ref={containerRef} onMouseDown={handleCanvasMouseDown} onWheel={handleWheel} onContextMenu={handleContextMenu} data-canvas sx={{ width: '100%', height: '100vh', background: canvasTab === 'relations' ? (isDarkMode ? '#12121a' : '#eef1f6') : bgGradient, position: 'relative', overflow: 'hidden', cursor: isPanning ? 'grabbing' : 'grab' }}>
          
          {canvasTab === 'code' && (
            <Box sx={{ position: 'absolute', top: 50, left: 10, right: 40, bottom: 50, zIndex: 25, bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 4, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
                <CodeIcon color="primary" />
                <Typography fontWeight={600}>Source Code</Typography>
                <Box sx={{ flex: 1 }} />
                <Tabs value={isSignedIn ? codeViewTab : 'export'} onChange={(_, v) => { if (!isSignedIn) return; setCodeViewTab(v); if (v === 'import' && importTextRef.current) importTextRef.current.value = ''; }} sx={{ minHeight: 32, '& .MuiTab-root': { minHeight: 32, py: 0 } }}>
                  <Tab label="Export" value="export" sx={{ fontSize: 11 }} />
                  {isSignedIn && <Tab label="Import" value="import" sx={{ fontSize: 11 }} />}
                </Tabs>
              </Box>
              <Box sx={{ flex: 1, p: 2, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {(!isSignedIn || codeViewTab === 'export') ? (
                  <>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: 12 }}>Your current board exported as XML source code. Copy and share or save for later.</Typography>
                    <TextField
                      key="export-field"
                      fullWidth
                      multiline
                      value={handleExportCode()}
                      InputProps={{ readOnly: true, sx: { height: '100%', alignItems: 'stretch', p: 0 } }}
                      sx={{
                        flex: 1, minHeight: 0,
                        '& .MuiInputBase-root': { height: '100%', display: 'flex', alignItems: 'stretch' },
                        '& .MuiInputBase-input': {
                          height: '100% !important', boxSizing: 'border-box',
                          overflow: 'auto !important',
                          fontFamily: 'monospace', fontSize: 11, p: 1.5,
                        },
                      }}
                    />
                    <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={() => { navigator.clipboard.writeText(handleExportCode()); setSnackbar({ open: true, message: 'Copied!' }); }} sx={{ mt: 1, alignSelf: 'flex-start' }}>Copy to Clipboard</Button>
                  </>
                ) : (
                  <>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: 12 }}>Paste code generated by AI tools (ChatGPT, Claude) to create sources.</Typography>
                    <TextField
                      key="import-field"
                      fullWidth
                      multiline
                      placeholder="Paste your source code here..."
                      inputRef={importTextRef}
                      defaultValue=""
                      InputProps={{ sx: { height: '100%', alignItems: 'stretch', p: 0 } }}
                      sx={{
                        flex: 1, minHeight: 0,
                        '& .MuiInputBase-root': { height: '100%', display: 'flex', alignItems: 'stretch' },
                        '& .MuiInputBase-input': {
                          height: '100% !important', boxSizing: 'border-box',
                          overflow: 'auto !important',
                          fontFamily: 'monospace', fontSize: 11, p: 1.5,
                        },
                      }}
                    />
                    <Button variant="contained" sx={{ mt: 1, alignSelf: 'flex-start' }} onClick={() => { if (importTextRef.current?.value) { pendingImportCode.current = importTextRef.current.value; if (squares.length > 0) { setImportConfirmOpen(true); } else { handleCodeImport(pendingImportCode.current); setCanvasTab('board'); } } }}>Import</Button>
                  </>
                )}
              </Box>
            </Box>
          )}


          {canvasTab === 'refs' && (
            <Box sx={{ position: 'absolute', top: 50, left: 10, right: 40, bottom: 50, zIndex: 25, bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 4, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <FormatQuoteIcon color="primary" />
                <Typography fontWeight={600}>Reference List</Typography>
                <ToggleButtonGroup value={refsCiteFormat} exclusive onChange={(_, v) => { if (v) setRefsCiteFormat(v); }} size="small" sx={{ ml: 1 }}>
                  <ToggleButton value="apa" sx={{ px: 0.8, py: 0.1, fontSize: 9 }}>APA</ToggleButton>
                  <ToggleButton value="harvard" sx={{ px: 0.8, py: 0.1, fontSize: 9 }}>Harvard</ToggleButton>
                  <ToggleButton value="mla" sx={{ px: 0.8, py: 0.1, fontSize: 9 }}>MLA</ToggleButton>
                  <ToggleButton value="chicago" sx={{ px: 0.8, py: 0.1, fontSize: 9 }}>Chicago</ToggleButton>
                  <ToggleButton value="vancouver" sx={{ px: 0.8, py: 0.1, fontSize: 9 }}>Vanc.</ToggleButton>
                </ToggleButtonGroup>
                <Chip label={`${squares.filter(s => !s.isMainSource && s.sourceType).length} sources`} size="small" sx={{ ml: 'auto', fontSize: 10 }} />
                <Tooltip title="Copy all references"><IconButton size="small" onClick={() => {
                  const allCites = squares.filter(s => !s.isMainSource && s.sourceType).map((sq, i) => {
                    const text = formatSourceCitationText(sq, refsCiteFormat);
                    return `[${i + 1}] ${text}`;
                  }).filter(Boolean).join('\n');
                  try {
                    navigator.clipboard.writeText(allCites).then(() => {
                      setSnackbar({ open: true, message: 'All references copied!' });
                    }).catch(() => {
                      const ta = document.createElement('textarea');
                      ta.value = allCites; ta.style.position = 'fixed'; ta.style.opacity = '0';
                      document.body.appendChild(ta); ta.select(); document.execCommand('copy');
                      document.body.removeChild(ta);
                      setSnackbar({ open: true, message: 'All references copied!' });
                    });
                  } catch {
                    const ta = document.createElement('textarea');
                    ta.value = allCites; ta.style.position = 'fixed'; ta.style.opacity = '0';
                    document.body.appendChild(ta); ta.select(); document.execCommand('copy');
                    document.body.removeChild(ta);
                    setSnackbar({ open: true, message: 'All references copied!' });
                  }
                }}><ContentCopyIcon sx={{ fontSize: 16 }} /></IconButton></Tooltip>
                <Tooltip title="Export references as PDF"><IconButton size="small" onClick={() => {
                  const sources = squares.filter(s => !s.isMainSource && s.sourceType);
                  if (sources.length === 0) { setSnackbar({ open: true, message: 'No references to export' }); return; }
                  const cites = sources.map((sq, i) => {
                    const html = formatSourceCitationHTML(sq, refsCiteFormat);
                    const refFrom = escapeHtml(sq.reference.from || '');
                    const refTo = escapeHtml(sq.reference.to || '');
                    const refNotes = escapeHtml(sq.reference.notes || '');
                    const ref = (sq.reference.from || sq.reference.to) ? `<div style="margin-top:2px;font-size:10px;color:#666;">Ref: ${refFrom}${sq.reference.from && sq.reference.to ? ' → ' : ''}${refTo}${sq.reference.notes ? ` — ${refNotes}` : ''}</div>` : '';
                    return `<div style="margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #e5e7eb;"><div style="font-size:10px;color:#999;margin-bottom:4px;">[${i + 1}]</div><div style="font-size:13px;line-height:1.6;">${html}</div>${ref}</div>`;
                  }).join('');
                  const safeBoardId = escapeHtml(dispId(boardId));
                  const printHtml = `<!DOCTYPE html><html><head><title>References — ${safeBoardId}</title><style>@page{size:A4;margin:25mm 20mm}body{font-family:Georgia,serif;max-width:170mm;margin:0 auto;color:#1a1a2e}h1{font-size:18px;margin-bottom:4px}h2{font-size:12px;color:#666;font-weight:normal;margin-bottom:24px}em{font-style:italic}</style></head><body><h1>Reference List</h1><h2>${refsCiteFormat.toUpperCase()} format · ${sources.length} source${sources.length !== 1 ? 's' : ''} · Board ${safeBoardId}</h2>${cites}<div style="margin-top:24px;font-size:9px;color:#aaa;text-align:center;">Generated by source.io · ${escapeHtml(formatTimestamp(new Date().toISOString(), appSettings))}</div></body></html>`;
                  const w = window.open('', '_blank');
                  if (w) { try { w.opener = null; } catch {} w.document.write(printHtml); w.document.close(); setTimeout(() => w.print(), 400); }
                }}><PictureAsPdfIcon sx={{ fontSize: 16 }} /></IconButton></Tooltip>
              </Box>
              <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                {squares.filter(s => !s.isMainSource && s.sourceType).length === 0 ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 1 }}>
                    <FormatQuoteIcon sx={{ fontSize: 40, color: 'text.disabled', opacity: 0.3 }} />
                    <Typography color="text.secondary" fontSize={13}>No sources with data yet</Typography>
                  </Box>
                ) : (
                  squares.filter(s => !s.isMainSource && s.sourceType).map((sq, i) => {
                    const st = ALL_SOURCE_TYPES.find(t => t.type === sq.sourceType);
                    if (!st) return null;
                    const orderLabel = getOrderLabel(sq.order, i === squares.filter(s => !s.isMainSource).length - 1, chainEnded, false, chainEndReason);
                    const color = getSourceColor(sq.sourceType);
                    return (
                      <Box key={sq.id} sx={{ mb: 2, p: 1.5, border: '1px solid', borderColor: selectedSourceId === sq.sourceId ? color : 'divider', borderRadius: '8px', cursor: 'pointer', bgcolor: selectedSourceId === sq.sourceId ? `${color}08` : 'transparent', '&:hover': { borderColor: color, boxShadow: `0 0 0 1px ${color}40` } }} onClick={() => { setSelectedSourceId(sq.sourceId); }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.8 }}>
                          <Chip label={orderLabel} size="small" sx={{ fontSize: 9, height: 18, bgcolor: color, color: isDarkMode ? '#E3E3DF' : '#1a1a2e', fontWeight: 700 }} />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, '& .MuiSvgIcon-root': { fontSize: '13px !important' } }}>
                            {st.icon}
                            <Typography fontSize={10} fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase' }}>{st.label}</Typography>
                          </Box>
                          <Typography sx={{ ml: 'auto', fontSize: '0.6rem', fontFamily: 'monospace', color: 'text.disabled' }}>{dispId(sq.sourceId)}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.78rem', lineHeight: 1.55, color: 'text.primary', '& em': { fontStyle: 'italic' } }}>
                          {formatSourceCitationJSX(sq, refsCiteFormat)}
                        </Typography>                        {(sq.reference.from || sq.reference.to) && (
                          <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <BookmarkIcon sx={{ fontSize: 12, color }} />
                            <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>{getRefDescription(sq.sourceType, sq.reference)}</Typography>
                            {sq.reference.refType && <Chip label={sq.reference.refType} size="small" sx={{ fontSize: '0.55rem', height: 15, bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)' }} />}
                          </Box>
                        )}
                      </Box>
                    );
                  })
                )}
              </Box>
            </Box>
          )}

          {appMode === 'tree' && !hasMainSource && isOwner && canvasTab === 'board' && (
            <Box sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 30 }}>
              <Button variant="contained" onClick={handleAddMainSource} startIcon={<StarIcon />} sx={{ bgcolor: '#10b981', '&:hover': { bgcolor: '#059669' }, borderRadius: '8px', px: 3, py: 1 }}>Add Seed Node</Button>
            </Box>
          )}

          {appMode === 'single' && squares.length === 0 && isOwner && canvasTab === 'board' && !isPublic && (
            <Box sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 30, textAlign: 'center' }}>
              <Typography color="text.secondary" fontSize={14} sx={{ mb: 2 }}>Your board is empty</Typography>
              <Button variant="contained" onClick={() => {
                const pos = { x: 80, y: 150 };
                setSquares([{
                  id: nextId.current++,
                  sourceId: generateSourceId(),
                  size: { width: SQUARE_WIDTH, height: SQUARE_HEIGHT },
                  position: pos,
                  sourceType: null,
                  name: 'Source 1',
                  fields: emptyFields,
                  order: 1,
                  createdAt: nowDate(), updatedAt: nowDate(), createdBy: clerkActualUsername || clerkUsername || 'anonymous',
                  uploadedFile: null,
                  reference: emptyReference, trustRates: emptyTrustRates, trustAssessed: false
                }]);
              }} startIcon={<AddIcon />} sx={{ borderRadius: '8px', px: 3, py: 1 }}>Add your first source</Button>
            </Box>
          )}

          {appSettings.showGrid && canvasTab === 'board' && (
            <Box data-canvas sx={{
              position: 'absolute', inset: 0,
              backgroundImage: isDarkMode
                ? 'linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)'
                : 'linear-gradient(rgba(0,0,0,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)',
              backgroundSize: '50px 50px',
              pointerEvents: 'none',
              zIndex: 0,
            }} />
          )}

          <Box data-canvas sx={{ position: 'absolute', top: 0, left: 0, width: '500%', height: '500%', transform: `translate(${canvasOffset.x}px, ${canvasOffset.y}px) scale(${zoom})`, transformOrigin: 'top left', display: canvasTab !== 'board' ? 'none' : 'block' }}>
            
            {appMode === 'tree' && (
              <>
                {hasMainSource && mainSource?.sourceType && refPoints.length > 0 && (() => {
                  const SEED_TREE_W_LOCAL = Math.round(220 * 1.3);
                  const PANEL_W = 168;
                  const PANEL_GAP = 18;
                  const panelLeft = treeLineX + SEED_TREE_W_LOCAL / 2 + PANEL_GAP;
                  const panelTop = TREE_START_Y - 10;
                  const pointerType = mainSource?.reference?.pointerType;
                  return (
                    <Box sx={{ position: 'absolute', left: panelLeft, top: panelTop, width: PANEL_W,
                      bgcolor: isDarkMode ? 'rgba(26,26,36,0.95)' : 'rgba(255,255,255,0.95)',
                      backdropFilter: 'blur(4px)',
                      border: '1px solid', borderColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
                      borderRadius: '10px', boxShadow: 2, overflow: 'hidden', zIndex: 12 }}>
                      <Box sx={{ px: 1.2, py: 0.7, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 0.6 }}>
                        <FormatListBulletedIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                        <Typography fontSize={10} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.04em' }}>References</Typography>
                        <Box sx={{ flex: 1 }} />
                        <Chip size="small" label={refPoints.length} sx={{ height: 16, fontSize: 9, bgcolor: 'action.selected', '& .MuiChip-label': { px: 0.7 } }} />
                      </Box>
                      <Box sx={{ maxHeight: 320, overflowY: 'auto',
                        '&::-webkit-scrollbar': { width: 6 },
                        '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(0,0,0,0.15)', borderRadius: 3 } }}>
                        {refPoints.map((rp) => {
                          const label = formatRefPointLabel(pointerType, rp.fromValue, rp.toValue, rp.value) || '—';
                          const isSel = selectedRefPointId === rp.id;
                          const isEnded = !!rp.branchEnded;
                          const endColor = rp.branchEndReason === 'unknown' ? '#f59e0b' : '#ef4444';
                          return (
                            <Box key={rp.id} onClick={() => scrollToRefPoint(rp.id)}
                              onMouseDown={(e) => e.stopPropagation()}
                              sx={{ px: 1.2, py: 0.65, display: 'flex', alignItems: 'center', gap: 0.7, cursor: 'pointer',
                                borderLeft: '3px solid', borderColor: isSel ? '#475569' : 'transparent',
                                bgcolor: isSel ? (isDarkMode ? 'rgba(71,85,105,0.18)' : 'rgba(71,85,105,0.08)') : 'transparent',
                                '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)' } }}>
                              <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: isEnded ? endColor : '#64748b', flexShrink: 0 }} />
                              <Typography fontSize={11} fontWeight={isSel ? 700 : 500} sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: isSel ? 'text.primary' : 'text.secondary' }}>{label}</Typography>
                              {isEnded && <StopIcon sx={{ fontSize: 10, color: endColor, flexShrink: 0 }} />}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  );
                })()}
                {hasMainSource && mainSource && (() => {
                  const seedColor = getSourceColor(mainSource.sourceType);
                  const seedBottom = TREE_SEED_BOTTOM_Y;
                  return (
                    <>
                      <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', overflow: 'visible' }}>
                        <circle cx={treeLineX} cy={seedBottom} r="6" fill={seedColor} />
                      </svg>
                      <Box sx={{ position: 'absolute', left: treeLineX - 2, top: seedBottom, width: 4, height: Math.max(0, treeLineEndY - seedBottom), bgcolor: seedColor, borderRadius: 2, opacity: 0.4 }} />
                    </>
                  );
                })()}
                
                {hasMainSource && mainSource?.sourceType && !chainEnded && isOwner && (
                  <Box sx={{ position: 'absolute', left: treeLineX - 16, top: lastRefPointY + (refPoints.length > 0 ? SQUARE_HEIGHT / 2 + 40 : 60), zIndex: 20 }}>
                    <Tooltip title="Add Reference Point">
                      <IconButton onClick={handleOpenRefPointDialog} sx={{ bgcolor: '#475569', color: '#E3E3DF', width: 32, height: 32, '&:hover': { bgcolor: '#334155' } }}><AddIcon /></IconButton>
                    </Tooltip>
                  </Box>
                )}
                
                {refPoints.map((rp) => {
                  const sourcesForRef = squares.filter(s => s.refPointId === rp.id);
                  const isSelected = selectedRefPointId === rp.id;
                  const refBoxX = treeLineX + 60;
                  
                  return (
                    <React.Fragment key={rp.id}>
                      <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', overflow: 'visible' }}>
                        <line x1={treeLineX} y1={rp.y} x2={refBoxX} y2={rp.y} stroke="#64748b" strokeWidth="2.4" />
                        <circle cx={treeLineX} cy={rp.y} r="6" fill="#64748b" />
                      </svg>
                      
                      <RefPointBox refPoint={rp} x={refBoxX} onAddSource={() => handleAddSourceToRefPoint(rp.id)} onEdit={isOwner ? () => handleOpenEditRefPoint(rp.id) : undefined} isSelected={isSelected} onSelect={() => setSelectedRefPointId(rp.id)} sourceCount={sourcesForRef.length} isDark={isDarkMode} isPublic={isPublic} mainSourceType={mainSource?.sourceType || null} pointerType={mainSource?.reference?.pointerType} />
                      
                      {(() => {
                        const showOwnerControls = isOwner && !isPublic;
                        if (!showOwnerControls && !rp.branchEnded) return null;
                        const simW = 220;
                        let anchorX: number;
                        let lineColor: string;
                        if (sourcesForRef.length > 0) {
                          const lastSq = [...sourcesForRef].sort((a, b) => b.position.x - a.position.x)[0];
                          const lastW = simpleView ? simW : lastSq.size.width;
                          anchorX = lastSq.position.x + lastW + 25;
                          lineColor = getSourceColor(lastSq.sourceType);
                        } else {
                          anchorX = refBoxX + REF_BOX_WIDTH + 25;
                          lineColor = '#64748b';
                        }
                        const anchorY = rp.y;

                        if (!showOwnerControls && rp.branchEnded) {
                          const isUnknown = rp.branchEndReason === 'unknown';
                          const badgeColor = isUnknown ? '#f59e0b' : '#ef4444';
                          return (
                            <Box sx={{ position: 'absolute', top: anchorY, left: anchorX, transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 1.5, zIndex: 15 }}>
                              <Box sx={{ width: 25, height: 2, bgcolor: badgeColor, opacity: 0.6 }} />
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, bgcolor: 'background.paper', border: '2px solid', borderColor: badgeColor, borderRadius: '10px', px: 1.5, py: 0.8, boxShadow: 2 }}>
                                {isUnknown
                                  ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" /><path d="M12 17v.01M12 14c0-2 2-2.5 2-4.5a2 2 0 1 0-4 0" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                  : <StopIcon sx={{ fontSize: 18, color: '#ef4444' }} />
                                }
                                <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: badgeColor, textTransform: 'uppercase' }}>
                                  {isUnknown ? 'Origin Unknown' : 'Original Source'}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        }

                        return (
                          <Box sx={{ position: 'absolute', top: anchorY, left: anchorX, transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 1, zIndex: 15 }}>
                            <Box sx={{ width: 25, height: 2, bgcolor: rp.branchEnded ? (rp.branchEndReason === 'unknown' ? '#f59e0b' : '#ef4444') : lineColor, opacity: 0.4 }} />
                            <IconButton
                              onClick={(e) => { e.stopPropagation(); e.preventDefault(); setTreeMenuAnchor({ el: e.currentTarget as HTMLElement, rpId: rp.id }); }}
                              sx={{ bgcolor: rp.branchEnded ? (rp.branchEndReason === 'unknown' ? '#f59e0b' : '#ef4444') : 'primary.main', color: '#E3E3DF', width: 28, height: 28, '&:hover': { bgcolor: rp.branchEnded ? (rp.branchEndReason === 'unknown' ? '#d97706' : '#dc2626') : 'primary.dark' }, boxShadow: 2 }}
                            >
                              {rp.branchEnded ? <StopIcon sx={{ fontSize: 16 }} /> : <AddIcon sx={{ fontSize: 16 }} />}
                            </IconButton>
                          </Box>
                        );
                      })()}
                      
                    </React.Fragment>
                  );
                })}
              </>
            )}
            
            {(() => {
              const nonMain = squares.filter(s => !s.isMainSource);
              const sortedByOrder = [...nonMain].sort((a, b) => a.order - b.order);
              const visualRank = new Map(sortedByOrder.map((s, idx) => [s.sourceId, idx + 1]));
              const isLastByX = (sq: SquareData) => !sq.isMainSource && sq.order === Math.min(...nonMain.map(s => s.order));
              const sortedAscOrder = [...nonMain].sort((a, b) => b.order - a.order);
              const nextSourceLabelMap = new Map<string, string>();
              sortedAscOrder.forEach((sq, i) => {
                if (i < sortedAscOrder.length - 1) {
                  const nextSq = sortedAscOrder[i + 1];
                  const nextType = ALL_SOURCE_TYPES.find(t => t.type === nextSq.sourceType);
                  const nextTitle = (() => { const st = ALL_SOURCE_TYPES.find(t => t.type === nextSq.sourceType); if (!st) return ''; const ti = st.titleField; return (nextSq.fields as any)[`field${ti + 1}`] || ''; })();
                  const label = nextTitle ? `${nextType?.label || 'source'}: ${nextTitle}` : (nextType?.label || 'source');
                  nextSourceLabelMap.set(sq.sourceId, label);
                }
              });
              const SEED_TREE_SCALE = 1.3;
              const SEED_TREE_W = Math.round(220 * SEED_TREE_SCALE);
              return squares.map((sq) => {
                const isTreeSeed = appMode === 'tree' && sq.isMainSource;
                const seedHasType = isTreeSeed && !!sq.sourceType;
                const seedSimple = seedHasType && !seedEditOpen;
                const seedExpanded = seedHasType && seedEditOpen;
                const compactPos = compactPositionByOrder?.get(sq.sourceId);
                const sqRender: SquareData = isTreeSeed
                  ? {
                      ...sq,
                      position: {
                        x: seedSimple ? (treeLineX - SEED_TREE_W / 2) : (treeLineX - SQUARE_WIDTH / 2),
                        y: TREE_START_Y - 10,
                      },
                    }
                  : compactPos
                  ? { ...sq, position: compactPos }
                  : sq;
                return (
              <SingleSquare key={sq.id} square={sqRender} onUpdate={handleUpdateSquare} onSourceTypeChange={handleSourceTypeChange} onReferenceChange={handleReferenceChange} onDelete={handleDeleteSquare} onCopyId={handleCopyId} zoom={zoom} isDark={isDarkMode} isSelected={selectedSourceId === sq.sourceId} onSelect={handleSelectSource} boardId={boardId} chainId={chainId} isLast={isLastByX(sq)} overrideOrder={visualRank.get(sq.sourceId)} chainEnded={chainEnded} chainEndReason={chainEndReason} isPublic={isPublic} appMode={appMode} onSelectMainSource={sq.isMainSource && !seedHasType ? handleSelectMainSource : undefined} initialTab={selectedSourceId === sq.sourceId ? urlTab || undefined : undefined} canvasLocked={canvasLocked || isTreeSeed} onTrustRateChange={handleTrustRateChange} onCommentsChange={handleCommentsChange} username={clerkUsername} simpleView={seedSimple ? true : simpleView} simpleCardScale={seedSimple ? SEED_TREE_SCALE : undefined} onOpenRefSettings={seedSimple && isOwner ? () => setSeedRefSettingsOpen(true) : undefined} onOpenEdit={seedSimple && isOwner ? () => setSeedEditOpen(true) : undefined} isExpandedSeed={seedExpanded} onCloseExpandedSeed={() => setSeedEditOpen(false)} appSettings={appSettings} readOnly={!isOwner || isPublic} authToken={tokenRef.current} getToken={getToken} onViewProfile={(u) => setViewProfileUsername(u)} nextSourceLabel={nextSourceLabelMap.get(sq.sourceId)} creatorVerified={!!(sq.createdBy && sq.createdBy !== 'anonymous' && (verifiedCreators[sq.createdBy] || (currentUserEmailVerified && (sq.createdBy === clerkActualUsername || sq.createdBy === clerkUsername))))} fieldEdits={editLogBySource.get(sq.sourceId) ?? EMPTY_EDIT_LOG} autoOpenFile={fileOpenSourceId === sq.sourceId} onFileOpened={() => setFileOpenSourceId(null)} onOpenTrustDialog={(sid) => setChipDialogSourceId(sid)} onTrustVote={handleTrustVote} allowTrustVoting={allowTrustVoting} onViewGraph={(sid, label) => setGraphDialog({ sourceId: sid, label })} onEmbed={(sid, label) => setEmbedDialog({ sourceId: sid, label })} />
                );
              });})()}
            
            {appMode === 'single' && <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 10, pointerEvents: 'none', overflow: 'visible' }}><SingleConnections squares={compactPositionByOrder ? squares.map(sq => { const cp = compactPositionByOrder.get(sq.sourceId); return cp ? { ...sq, position: cp } : sq; }) : squares} isDark={isDarkMode} boardId={boardId} chainId={chainId} setSnackbar={setSnackbar} simpleView={simpleView} selectedSourceId={selectedSourceId} onOpenFile={(sid) => { setSelectedSourceId(sid); setFileOpenSourceId(sid); }} /></Box>}

            
            {appMode === 'tree' && (
              <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', overflow: 'visible', zIndex: 10 }}>
                <defs>
                  {squares.map(s => getSourceColor(s.sourceType)).filter((c, i, a) => a.indexOf(c) === i).map(color => (
                    <marker key={color} id={`tree-arrow-${color.replace('#','')}`} markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
                      <path d="M0,0 L0,6 L8,3 z" fill={color} opacity={0.8} />
                    </marker>
                  ))}
                </defs>
                {refPoints.map((rp) => {
                  const sourcesForRef = squares.filter(s => s.refPointId === rp.id);
                  const refBoxX = treeLineX + 60;
                  return sourcesForRef.map((sq, si) => {
                    const color = getSourceColor(sq.sourceType);
                    const colorId = color.replace('#', '');
                    const simW = simpleView ? 220 : 0;
                    const simH = simpleView ? 105 : 0;
                    const prevSq = si > 0 ? sourcesForRef[si - 1] : null;
                    const exitX = si === 0 ? refBoxX + REF_BOX_WIDTH : prevSq!.position.x + (simpleView ? simW : prevSq!.size.width);
                    const exitY = si === 0 ? rp.y : prevSq!.position.y + (simpleView ? simH : prevSq!.size.height) / 2;
                    const entryX = sq.position.x;
                    const entryY = sq.position.y + (simpleView ? simH : sq.size.height) / 2;
                    const midX = (exitX + entryX) / 2;
                    return (
                      <g key={`tree-conn-${sq.id}`}>
                        <path d={`M${exitX},${exitY} C${midX},${exitY} ${midX},${entryY} ${entryX},${entryY}`} stroke={color} strokeWidth="2.4" fill="none" opacity={0.6} markerEnd={`url(#tree-arrow-${colorId})`} />
                        <circle cx={exitX} cy={exitY} r="4" fill={color} opacity={0.6} />
                      </g>
                    );
                  });
                })}
              </svg>
            )}
            {appMode === 'tree' && (() => {
              const rpId = treeMenuAnchor?.rpId || '';
              const branch = refPoints.find(r => r.id === rpId);
              const branchEnded = !!branch?.branchEnded;
              const branchReason = branch?.branchEndReason || '';
              return (
              <Menu anchorEl={treeMenuAnchor?.el} open={Boolean(treeMenuAnchor)} onClose={() => setTreeMenuAnchor(null)} disableScrollLock PaperProps={{ sx: { minWidth: 220, borderRadius: '10px', p: 0.3 } }}>
                {!branchEnded && (
                  <MenuItem onClick={() => { if (treeMenuAnchor) { handleAddSourceToRefPoint(treeMenuAnchor.rpId); } setTreeMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                    <AddIcon sx={{ fontSize: 15, color: 'primary.main', mr: 1 }} />
                    <Box>
                      <Typography fontSize={12} fontWeight={600}>Add next source</Typography>
                      <Typography fontSize={9} color="text.disabled">Continue tracing this branch</Typography>
                    </Box>
                  </MenuItem>
                )}
                {!branchEnded && <Divider sx={{ my: 0.3 }} />}
                <MenuItem onClick={() => { if (treeMenuAnchor) handleToggleBranchEnd(treeMenuAnchor.rpId, branchEnded ? undefined : 'ended'); setTreeMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                  {branchEnded ? <PlayArrowIcon sx={{ fontSize: 15, color: '#10b981', mr: 1 }} /> : <StopIcon sx={{ fontSize: 15, color: '#ef4444', mr: 1 }} />}
                  <Box>
                    <Typography fontSize={12} fontWeight={600} color={branchEnded ? '#10b981' : '#ef4444'}>{branchEnded ? 'Resume branch' : 'Original source'}</Typography>
                    <Typography fontSize={9} color="text.disabled">{branchEnded ? 'Re-open to add more' : 'This is where the information originates'}</Typography>
                  </Box>
                </MenuItem>
                {!branchEnded && (
                  <>
                  <Divider sx={{ my: 0.3 }} />
                  <MenuItem onClick={() => { if (treeMenuAnchor) handleToggleBranchEnd(treeMenuAnchor.rpId, 'unknown'); setTreeMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" /><path d="M12 17v.01M12 14c0-2 2-2.5 2-4.5a2 2 0 1 0-4 0" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    <Box>
                      <Typography fontSize={12} fontWeight={600} color="#f59e0b">Origin unknown</Typography>
                      <Typography fontSize={9} color="text.disabled">Could not determine the original source</Typography>
                    </Box>
                  </MenuItem>
                  </>
                )}
                <Divider sx={{ my: 0.3 }} />
                <MenuItem onClick={() => { if (treeMenuAnchor) { setLinkIdRefPointId(treeMenuAnchor.rpId); setLinkIdValue(''); setLinkIdDialogOpen(true); } setTreeMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                  <LinkIcon sx={{ fontSize: 15, color: 'text.secondary', mr: 1 }} />
                  <Box>
                    <Typography fontSize={12} fontWeight={600}>Link by Source ID</Typography>
                    <Typography fontSize={9} color="text.disabled">Connect an existing source to this branch</Typography>
                  </Box>
                </MenuItem>
              </Menu>
              );
            })()}
            
            {appMode === 'single' && squares.length > 0 && (() => {
              const nonMainBtnSqs = squares.filter(s => !s.isMainSource);
              const primarySq = nonMainBtnSqs.length > 0
                ? nonMainBtnSqs.reduce((a, b) => a.order < b.order ? a : b)
                : squares[squares.length - 1];
              const compactPos = compactPositionByOrder?.get(primarySq.sourceId);
              const lastSq = compactPos
                ? { ...primarySq, position: compactPos }
                : primarySq;
              const simW = 220;
              const simH = 105;
              const lastSqW = simpleView ? simW : lastSq.size.width;
              const lastSqH = simpleView ? simH : lastSq.size.height;
              const lastHasFile = !!(lastSq.uploadedFile?.previewUrl || lastSq.uploadedFile?.refCropUrl || lastSq.uploadedFile?.url);
              const btnY = lastSq.position.y + lastSqH / 2;
              const btnX = lastSq.position.x + lastSqW;

              if ((!isOwner || isPublic) && chainEnded) {
                const lineColor = chainEndReason === 'unknown' ? '#f59e0b' : '#ef4444';
                const arrowFill = lastHasFile ? '#FFD465' : lineColor;
                return (
                  <Box sx={{ position: 'absolute', top: btnY, left: btnX, transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 1.5, zIndex: 15 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.85 }}>
                      <svg width="25" height="10" viewBox="0 0 25 10" xmlns="http://www.w3.org/2000/svg">
                        <line x1="25" y1="5" x2="7" y2="5" stroke={arrowFill} strokeWidth="2" />
                        <polygon points="0,5 8,1 8,9" fill={arrowFill} />
                      </svg>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, bgcolor: 'background.paper', border: '2px solid', borderColor: chainEndReason === 'unknown' ? '#f59e0b' : '#ef4444', borderRadius: '10px', px: 1.5, py: 0.8, boxShadow: 2 }}>
                      {chainEndReason === 'unknown' ? (
                        <Box sx={{ width: 24, height: 24, borderRadius: '50%', bgcolor: '#f59e0b15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" /><path d="M12 17v.01M12 14c0-2 2-2.5 2-4.5a2 2 0 1 0-4 0" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </Box>
                      ) : (
                        <Box sx={{ width: 24, height: 24, borderRadius: '50%', bgcolor: '#ef444415', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <StopIcon sx={{ fontSize: 14, color: '#ef4444' }} />
                        </Box>
                      )}
                      <Box>
                        <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: chainEndReason === 'unknown' ? '#f59e0b' : '#ef4444', textTransform: 'uppercase', lineHeight: 1 }}>
                          {chainEndReason === 'unknown' ? 'Origin Unknown' : 'Original Source'}
                        </Typography>
                        <Typography sx={{ fontSize: '0.52rem', color: 'text.disabled', lineHeight: 1.3, mt: 0.2, maxWidth: 140 }}>
                          {chainEndReason === 'unknown' ? 'The creator could not verify where this information originally comes from' : 'The creator believes this is where the information originates'}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              }

              if (!isOwner || isPublic) return null;

              return (
                <Box sx={{ position: 'absolute', top: btnY, left: btnX, transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 1, zIndex: 15 }}>
                  <Box sx={{ width: 25, height: 2, bgcolor: lastHasFile ? '#FFD465' : getSourceColor(lastSq.sourceType), opacity: 0.4 }} />
                  <IconButton onClick={(e) => setChainMenuAnchor(e.currentTarget)} sx={{ bgcolor: chainEnded ? '#ef4444' : 'primary.main', color: '#E3E3DF', width: 28, height: 28, '&:hover': { bgcolor: chainEnded ? '#dc2626' : 'primary.dark' }, boxShadow: 2 }}>
                    {chainEnded ? <StopIcon sx={{ fontSize: 16 }} /> : <AddIcon sx={{ fontSize: 16 }} />}
                  </IconButton>
                  <Menu anchorEl={chainMenuAnchor} open={Boolean(chainMenuAnchor)} onClose={() => setChainMenuAnchor(null)} disableScrollLock PaperProps={{ sx: { minWidth: 220, borderRadius: '10px', p: 0.3 } }}>
                    {!chainEnded && (
                      <MenuItem onClick={() => { handleAddSquare(); setChainMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                        <AddIcon sx={{ fontSize: 15, color: 'primary.main', mr: 1 }} />
                        <Box>
                          <Typography fontSize={12} fontWeight={600}>Add next source</Typography>
                          <Typography fontSize={9} color="text.disabled">Continue tracing the chain</Typography>
                        </Box>
                      </MenuItem>
                    )}
                    {!chainEnded && <Divider sx={{ my: 0.3 }} />}
                    <MenuItem onClick={() => { handleToggleChainEnd(chainEnded ? undefined : 'ended'); setChainMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                      {chainEnded ? <PlayArrowIcon sx={{ fontSize: 15, color: '#10b981', mr: 1 }} /> : <StopIcon sx={{ fontSize: 15, color: '#ef4444', mr: 1 }} />}
                      <Box>
                        <Typography fontSize={12} fontWeight={600} color={chainEnded ? '#10b981' : '#ef4444'}>{chainEnded ? 'Resume chain' : 'Original source'}</Typography>
                        <Typography fontSize={9} color="text.disabled">{chainEnded ? 'Re-open to add more' : 'This is where the information originates'}</Typography>
                      </Box>
                    </MenuItem>
                    {!chainEnded && (
                      <>
                      <Divider sx={{ my: 0.3 }} />
                      <MenuItem onClick={() => { handleToggleChainEnd('unknown'); setChainMenuAnchor(null); }} sx={{ py: 0.8, borderRadius: '6px' }}>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style={{ marginRight: 8, flexShrink: 0 }}><circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2" /><path d="M12 17v.01M12 14c0-2 2-2.5 2-4.5a2 2 0 1 0-4 0" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        <Box>
                          <Typography fontSize={12} fontWeight={600} color="#f59e0b">Origin unknown</Typography>
                          <Typography fontSize={9} color="text.disabled">Could not determine the original source</Typography>
                        </Box>
                      </MenuItem>
                      </>
                    )}
                  </Menu>
                </Box>
              );
            })()}
          </Box>

          {canvasTab === 'relations' && (() => {
            const clerkId = clerkUser?.id || '';
            const selectedSquare = squares.find(s => s.sourceId === selectedSourceId);
            const centerSrcDef = selectedSquare ? ALL_SOURCE_TYPES.find(t => t.type === selectedSquare.sourceType) : null;
            const centerColor = centerSrcDef?.color || '#3b82f6';
            const centerTitle = (() => { if (!centerSrcDef || !selectedSquare) return ''; return selectedSquare.fields[`field${centerSrcDef.titleField + 1}` as keyof SourceFields] || ''; })();
            const centerSubtitle = (() => { if (!centerSrcDef || !selectedSquare) return ''; return selectedSquare.fields[`field${centerSrcDef.subtitleField + 1}` as keyof SourceFields] || ''; })();
            const trustColor = (v: number) => v >= 7 ? '#10b981' : v >= 4 ? '#f59e0b' : v > 0 ? '#ef4444' : '#94a3b8';
            const trustLabel = (v: number) => v >= 8 ? 'High Trust' : v >= 6 ? 'Good' : v >= 4 ? 'Moderate' : v > 0 ? 'Low Trust' : 'Unrated';
            const timeAgo = (d: string) => { if (!d) return ''; const ms = Date.now() - new Date(d).getTime(); const m = ms/60000; if (m<60) return `${Math.round(m)}m`; const h = m/60; if (h<24) return `${Math.round(h)}h`; const dd = h/24; return dd<30 ? `${Math.round(dd)}d` : `${Math.round(dd/30)}mo`; };
            const allNodes = relSearchQuery.trim().length >= 2 ? relSearchResults : relatedSources;
            const NODE_W = 230, NODE_H = 110, CENTER_W = 210, CENTER_H = 120;
            const n = allNodes.length;
            const R = Math.max(300, 170 + n * 32);
            const mapW = (R + NODE_W) * 2 + 120, mapH = (R + NODE_H) * 2 + 120;
            const mcx = mapW / 2, mcy = mapH / 2;

            const RelationsCanvas: React.FC<{}> = () => {
              const [nodeOffsets, setNodeOffsets] = React.useState<Record<number, {dx:number;dy:number}>>({});
              const [dragIdx, setDragIdx] = React.useState<number|null>(null);
              const [dStart, setDStart] = React.useState({x:0,y:0});
              const [popover, setPopover] = React.useState<{idx:number}|null>(null);
              const didDrag = React.useRef(false);

              const getNodePos = (i: number) => {
                const angle = (2 * Math.PI * i) / n - Math.PI / 2;
                const off = nodeOffsets[i] || {dx:0,dy:0};
                return { x: mcx + R * Math.cos(angle) + off.dx, y: mcy + R * Math.sin(angle) + off.dy };
              };

              React.useEffect(() => {
                if (dragIdx === null) return;
                const initOff = nodeOffsets[dragIdx] || {dx:0,dy:0};
                const sx = dStart.x, sy = dStart.y;
                didDrag.current = false;
                const onMove = (ev: MouseEvent) => {
                  didDrag.current = true;
                  setNodeOffsets(prev => ({...prev, [dragIdx]: {dx: initOff.dx + (ev.clientX - sx) / zoom, dy: initOff.dy + (ev.clientY - sy) / zoom}}));
                };
                const onUp = () => setDragIdx(null);
                window.addEventListener('mousemove', onMove);
                window.addEventListener('mouseup', onUp);
                return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
              }, [dragIdx]);

              return (
                <>
                <svg style={{ position: 'absolute', top: 0, left: 0, width: mapW, height: mapH, pointerEvents: 'none', overflow: 'visible' }}>
                  <defs><filter id="rg"><feGaussianBlur stdDeviation="5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>
                  <circle cx={mcx} cy={mcy} r={R} fill="none" stroke={isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'} strokeWidth="1.5" strokeDasharray="8,12" />
                  {allNodes.map((_: any, i: number) => {
                    const rel = allNodes[i];
                    const np = getNodePos(i);
                    const dx = np.x - mcx, dy = np.y - mcy, dist = Math.sqrt(dx*dx+dy*dy) || 1, ux = dx/dist, uy = dy/dist;
                    const x1 = mcx + ux*(CENTER_W/2+8), y1 = mcy + uy*(CENTER_H/2+8);
                    const x2 = np.x - ux*(NODE_W/2+8), y2 = np.y - uy*(NODE_H/2+8);
                    const tAvg = rel.trustAvg||0;
                    const lc = trustColor(tAvg);
                    const mx = (x1+x2)/2, my = (y1+y2)/2;
                    return (<g key={i}>
                      <path d={`M ${x1} ${y1} Q ${mx} ${my}, ${x2} ${y2}`} stroke={lc} strokeWidth={tAvg > 0 ? 5 : 3} fill="none" strokeOpacity={0.15} filter="url(#rg)" />
                      <path d={`M ${x1} ${y1} Q ${mx} ${my}, ${x2} ${y2}`} stroke={lc} strokeWidth={tAvg > 0 ? 3.5 : 2} fill="none" strokeOpacity={0.5} strokeDasharray={tAvg > 0 ? '0' : '8,5'} />
                      <circle cx={x1} cy={y1} r={5} fill={centerColor} opacity={0.5} />
                      <circle cx={x2} cy={y2} r={5} fill={lc} opacity={0.5} />
                      <foreignObject x={mx - 72} y={my - 30} width={144} height={60} style={{overflow:'visible'}}>
                        <div style={{ background: isDarkMode ? 'rgba(18,18,26,0.93)' : 'rgba(255,255,255,0.95)', borderRadius: 10, border: `2px solid ${lc}35`, padding: '5px 10px', textAlign: 'center', boxShadow: '0 3px 16px rgba(0,0,0,0.18)', backdropFilter: 'blur(8px)' }}>
                          {tAvg > 0 ? <>
                            <div style={{ fontSize: 20, fontWeight: 900, fontFamily: 'monospace', color: lc, lineHeight: 1 }}>★ {tAvg.toFixed(1)}</div>
                            <div style={{ fontSize: 8.5, fontWeight: 700, color: lc, textTransform: 'uppercase', letterSpacing: 1.2, marginTop: 2 }}>{trustLabel(tAvg)}</div>
                          </> : <div style={{ fontSize: 10, color: isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.25)', fontWeight: 500 }}>Unrated</div>}
                          <div style={{ fontSize: 7.5, color: isDarkMode ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.2)', marginTop: 2 }}>
                            {rel.sourceCount || 1} src{rel.hasFile ? ' · 📎' : ''}{rel.hasReference ? ' · ref' : ''}{rel.ownerUsername && rel.ownerUsername !== 'anonymous' ? ` · ${rel.ownerUsername}` : ''}
                          </div>
                        </div>
                      </foreignObject>
                    </g>);
                  })}
                </svg>

                <Box sx={{ position: 'absolute', left: mcx - CENTER_W/2, top: mcy - CENTER_H/2, width: CENTER_W, height: CENTER_H,
                  background: `linear-gradient(135deg, ${centerColor}, ${centerColor}cc)`, borderRadius: '14px',
                  boxShadow: `0 0 0 5px ${centerColor}25, 0 8px 32px rgba(0,0,0,0.3)`,
                  display: 'flex', flexDirection: 'column', p: 1.5, zIndex: 5, overflow: 'hidden' }}>
                  <Box sx={{ position: 'absolute', top: -20, right: -20, width: 60, height: 60, borderRadius: '50%', background: 'rgba(255,255,255,0.12)', filter: 'blur(20px)' }} />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, position: 'relative', zIndex: 1 }}>
                    {centerSrcDef && <Box sx={{ '& .MuiSvgIcon-root': { fontSize: '15px !important' }, color: '#E3E3DF', display: 'flex' }}>{centerSrcDef.icon}</Box>}
                    <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: 'rgba(255,255,255,0.9)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{centerSrcDef?.label || 'Source'}</Typography>
                    <Box sx={{ flex: 1 }} />
                    <Box sx={{ bgcolor: 'rgba(255,255,255,0.2)', borderRadius: '4px', px: 0.5, py: 0.1 }}><Typography sx={{ fontSize: 8, color: '#E3E3DF', fontFamily: 'monospace', fontWeight: 700 }}>{dispId(selectedSourceId || '')}</Typography></Box>
                  </Box>
                  <Typography sx={{ fontSize: '0.95rem', fontWeight: 800, color: '#E3E3DF', lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', position: 'relative', zIndex: 1 }}>{centerTitle || 'Untitled'}</Typography>
                  {centerSubtitle && <Typography sx={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.7)', mt: 0.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{centerSubtitle}</Typography>}
                  <Box sx={{ flex: 1 }} />
                  <Typography sx={{ fontSize: '0.55rem', color: 'rgba(255,255,255,0.55)', textAlign: 'center' }}>{n} connection{n !== 1 ? 's' : ''}{relationsTotalCount > n ? ` · ${relationsTotalCount} total on site` : ''}</Typography>
                </Box>

                {allNodes.map((rel: any, i: number) => {
                  const np = getNodePos(i);
                  const srcDef = ALL_SOURCE_TYPES.find(t => t.type === rel.sourceType);
                  const nodeColor = srcDef?.color || '#64748b';
                  const tAvg = rel.trustAvg || 0;
                  const tColor = trustColor(tAvg);
                  const relTitle = rel.fields?.[`field${(srcDef?.titleField||0)+1}`] || rel.boardName || '';
                  const relSub = rel.fields?.[`field${(srcDef?.subtitleField||0)+1}`] || '';
                  const isOwnSource = clerkId && rel.ownerClerkId === clerkId;
                  const isDraggingThis = dragIdx === i;
                  return (
                    <Box key={i}
                      onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); setDragIdx(i); setDStart({ x: e.clientX, y: e.clientY }); }}
                      onClick={(e) => { e.stopPropagation(); if (!didDrag.current) setPopover(popover?.idx === i ? null : { idx: i }); }}
                      sx={{ position: 'absolute', left: np.x - NODE_W/2, top: np.y - NODE_H/2, width: NODE_W, height: NODE_H,
                        bgcolor: isDarkMode ? 'rgba(26,26,36,0.98)' : 'rgba(255,255,255,0.98)',
                        border: '2px solid', borderColor: isOwnSource ? '#8b5cf6' : (isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'),
                        borderRadius: '12px', boxShadow: isOwnSource ? `0 0 0 2px rgba(139,92,246,0.2), 0 4px 16px rgba(0,0,0,0.15)` : `0 3px 12px rgba(0,0,0,${isDarkMode ? 0.3 : 0.1})`,
                        display: 'flex', flexDirection: 'column', overflow: 'hidden', cursor: isDraggingThis ? 'grabbing' : 'grab', zIndex: isDraggingThis ? 20 : 3,
                        transition: isDraggingThis ? 'none' : 'box-shadow 0.18s, border-color 0.18s',
                        '&:hover': { boxShadow: `0 0 0 3px ${nodeColor}25, 0 8px 24px rgba(0,0,0,0.2)`, borderColor: nodeColor } }}>
                      <Box sx={{ bgcolor: `${nodeColor}18`, px: 1, py: 0.45, display: 'flex', alignItems: 'center', gap: 0.4, borderBottom: '1px solid', borderColor: 'divider' }}>
                        {srcDef && <Box sx={{ '& .MuiSvgIcon-root': { fontSize: '11px !important' }, color: nodeColor, display: 'flex', flexShrink: 0 }}>{srcDef.icon}</Box>}
                        <Typography sx={{ fontSize: '0.55rem', fontWeight: 600, color: nodeColor, textTransform: 'uppercase', letterSpacing: '0.04em', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{rel.boardName || 'Board'}</Typography>
                        {isOwnSource && <Box sx={{ bgcolor: '#8b5cf6', borderRadius: '3px', px: 0.5, py: 0.1, flexShrink: 0 }}><Typography sx={{ fontSize: 7, color: '#E3E3DF', fontWeight: 800 }}>YOU</Typography></Box>}
                        {rel.hasFile && <AttachFileIcon sx={{ fontSize: 10, color: '#6366f1', flexShrink: 0 }} />}
                      </Box>
                      <Box sx={{ px: 1, py: 0.5, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.15 }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', color: isDarkMode ? '#E3E3DF' : 'text.primary' }}>{relTitle || '—'}</Typography>
                        {relSub && <Typography sx={{ fontSize: '0.56rem', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{relSub}</Typography>}
                      </Box>
                      <Box sx={{ px: 1, py: 0.35, borderTop: '1px solid', borderColor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography sx={{ fontSize: '0.48rem', color: 'text.disabled', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {rel.ownerUsername && rel.ownerUsername !== 'anonymous' ? rel.ownerUsername : ''}{rel.refType ? ` · ${rel.refType}` : ''}{rel.refFrom && rel.refTo ? ` · pp.${rel.refFrom}–${rel.refTo}` : ''}
                        </Typography>
                        <Typography sx={{ fontSize: '0.44rem', color: 'text.disabled', flexShrink: 0 }}>{timeAgo(rel.updatedAt)}</Typography>
                      </Box>
                      {tAvg > 0 && <Box sx={{ position: 'absolute', top: -14, right: -10, bgcolor: tColor, borderRadius: '8px', px: 1, py: 0.35, boxShadow: `0 2px 10px ${tColor}60`, zIndex: 4 }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 900, color: '#E3E3DF', fontFamily: 'monospace', lineHeight: 1 }}>★ {tAvg.toFixed(1)}</Typography>
                      </Box>}
                    </Box>
                  );
                })}

                {popover && allNodes[popover.idx] && (() => {
                  const rel = allNodes[popover.idx];
                  const srcDef = ALL_SOURCE_TYPES.find(t => t.type === rel.sourceType);
                  const relTitle = rel.fields?.[`field${(srcDef?.titleField||0)+1}`] || rel.boardName || '—';
                  const np = getNodePos(popover.idx);
                  return (
                    <Box onClick={(e) => e.stopPropagation()} sx={{ position: 'absolute', left: np.x + NODE_W/2 + 14, top: np.y - 55, width: 210, bgcolor: 'background.paper', borderRadius: '10px', boxShadow: 8, border: '1px solid', borderColor: 'divider', zIndex: 50, overflow: 'hidden' }}>
                      <Box sx={{ px: 1.5, py: 1, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                          <Typography sx={{ fontSize: 11, fontWeight: 600, lineHeight: 1.3 }}>{relTitle}</Typography>
                          <Typography sx={{ fontSize: 9, color: 'text.secondary', mt: 0.2 }}>{rel.boardName} · {rel.sourceCount || 1} sources</Typography>
                        </Box>
                        <IconButton size="small" onClick={() => setPopover(null)} sx={{ ml: 0.5 }}><CloseIcon sx={{ fontSize: 12 }} /></IconButton>
                      </Box>
                      <Box sx={{ py: 0.5 }}>
                        <Box onClick={() => { navigator.clipboard.writeText(dispId(rel.sourceId)); setSnackbar({ open: true, message: `Source ID copied: ${dispId(rel.sourceId)}` }); setPopover(null); }} sx={{ px: 1.5, py: 0.7, display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
                          <ContentCopyIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                          <Box><Typography sx={{ fontSize: 11 }}>Copy Source ID</Typography><Typography sx={{ fontSize: 9, color: 'text.disabled', fontFamily: 'monospace' }}>{dispId(rel.sourceId)}</Typography></Box>
                        </Box>
                        <Box onClick={() => { navigator.clipboard.writeText(dispId(rel.boardId)); setSnackbar({ open: true, message: `Board ID copied: ${dispId(rel.boardId)}` }); setPopover(null); }} sx={{ px: 1.5, py: 0.7, display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
                          <ContentCopyIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                          <Box><Typography sx={{ fontSize: 11 }}>Copy Board ID</Typography><Typography sx={{ fontSize: 9, color: 'text.disabled', fontFamily: 'monospace' }}>{dispId(rel.boardId)}</Typography></Box>
                        </Box>
                        <Divider sx={{ my: 0.3 }} />
                        <Box onClick={() => { window.open(`/${encodeURIComponent(dispId(rel.boardId))}/`, '_blank', 'noopener,noreferrer'); setPopover(null); }} sx={{ px: 1.5, py: 0.7, display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
                          <OpenInNewIcon sx={{ fontSize: 13, color: 'primary.main' }} />
                          <Typography sx={{ fontSize: 11, color: 'primary.main' }}>Open Board in New Tab</Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })()}
                </>
              );
            };

            return (
              <>
              <Box sx={{ position: 'absolute', top: 12, left: 12, right: 44, zIndex: 30, pointerEvents: 'none', display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                <Box onClick={() => setCanvasTab('board')} sx={{ bgcolor: 'background.paper', borderRadius: '8px', px: 1.2, py: 0.8, boxShadow: 2, pointerEvents: 'auto', display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}>
                  <ArrowBackIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                  <Typography sx={{ fontSize: 10, fontWeight: 600, color: 'text.secondary' }}>Board</Typography>
                </Box>
                <Box sx={{ bgcolor: 'background.paper', borderRadius: '8px', px: 1.5, py: 0.8, boxShadow: 2, pointerEvents: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                  <HubIcon sx={{ fontSize: 16, color: centerColor }} />
                  <Box>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, lineHeight: 1.2 }}>{centerTitle || 'Select a source'}</Typography>
                    <Typography sx={{ fontSize: 9, color: 'text.secondary' }}>
                      {relationsTotalCount > 0 ? `${relationsTotalCount} total on site · ${relatedSources.length} connected` : selectedSourceId ? 'No public connections' : 'Click a source on Board tab'}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 2, pointerEvents: 'auto', display: 'flex', alignItems: 'center', overflow: 'hidden', minWidth: 200, maxWidth: 320 }}>
                  <Box sx={{ px: 1, display: 'flex', alignItems: 'center' }}><SearchIcon sx={{ fontSize: 15, color: 'text.disabled' }} /></Box>
                  <input value={relSearchQuery} onChange={e => setRelSearchQuery(e.target.value)} placeholder="Search public sources..." style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 11, padding: '7px 8px 7px 0', width: '100%', color: 'inherit' }} />
                  {relSearchLoading && <CircularProgress size={12} sx={{ mr: 1 }} />}
                  {relSearchQuery && <IconButton size="small" onClick={() => setRelSearchQuery('')} sx={{ mr: 0.5 }}><CloseIcon sx={{ fontSize: 12 }} /></IconButton>}
                </Box>
                {relSearchQuery.trim().length >= 2 && <Box sx={{ bgcolor: 'background.paper', borderRadius: '6px', px: 1, py: 0.5, boxShadow: 1, pointerEvents: 'auto' }}><Typography sx={{ fontSize: 9, color: 'text.secondary' }}>{relSearchResults.length} results</Typography></Box>}
              </Box>
              <Box sx={{ position: 'absolute', top: 0, left: 0, width: '500%', height: '500%', transform: `translate(${canvasOffset.x}px, ${canvasOffset.y}px) scale(${zoom})`, transformOrigin: 'top left' }}>
                {selectedSquare && n > 0 && <RelationsCanvas />}
                {!selectedSquare && (
                  <Box sx={{ position: 'absolute', left: 300, top: 200, textAlign: 'center', maxWidth: 340 }}>
                    <HubIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
                    <Typography fontSize={15} fontWeight={600} color="text.secondary">Select a source first</Typography>
                    <Typography fontSize={12} color="text.disabled" sx={{ mt: 0.5, lineHeight: 1.6 }}>Switch to the Board tab, click any source, then come back here.</Typography>
                  </Box>
                )}
                {selectedSquare && n === 0 && !relationsLoading && !relSearchLoading && (
                  <Box sx={{ position: 'absolute', left: 300, top: 200, textAlign: 'center', maxWidth: 340 }}>
                    <HubIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 2 }} />
                    <Typography fontSize={15} fontWeight={600} color="text.secondary">{relSearchQuery ? 'No search results' : 'No public connections yet'}</Typography>
                    <Typography fontSize={12} color="text.disabled" sx={{ mt: 0.5, lineHeight: 1.6 }}>{relSearchQuery ? 'Try different search terms.' : 'Use the search bar to find any public source.'}</Typography>
                  </Box>
                )}
                {(relationsLoading || relSearchLoading) && n === 0 && (
                  <Box sx={{ position: 'absolute', left: 400, top: 280, textAlign: 'center' }}><CircularProgress size={28} /><Typography fontSize={11} color="text.secondary" sx={{ mt: 1 }}>Searching...</Typography></Box>
                )}
              </Box>
              </>
            );
          })()}
        </Box>
        <Box sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 40 }}>
          {sidebarCollapsed && canvasTab !== 'relations' && <Box sx={{ position: 'absolute', top: 10, left: 10, pointerEvents: 'auto' }}><Typography sx={{ fontSize: '1.35rem', fontWeight: 700 }}>source<span style={{ color: '#3b82f6' }}>.</span></Typography></Box>}
          
          {appMode !== 'none' && canvasTab !== 'relations' && (() => {
            const sourceIdVal = selectedSourceId ? dispId(selectedSourceId) : null;
            const mainSrc = squares.find(s => s.isMainSource) || squares[0];
            const owner = mainSrc?.createdBy || '';
            const ownerVerified = !!(owner && owner !== 'anonymous' && (verifiedCreators[owner] || (currentUserEmailVerified && (owner === clerkActualUsername || owner === clerkUsername))));
            const showOwner = owner && owner !== 'anonymous' && !/^user_/.test(owner);
            const settingsTargetId = selectedSourceId
              || mainSrc?.sourceId
              || squares.find(s => !s.isMainSource)?.sourceId
              || squares[0]?.sourceId
              || '';
            return (
              <Box sx={{
                position: 'absolute', bottom: 14, left: 14, pointerEvents: 'auto', zIndex: 5,
                bgcolor: 'background.paper', borderRadius: '8px', px: 1.5, py: 0.8,
                boxShadow: 1, border: '1px solid', borderColor: 'divider',
                display: 'flex', flexDirection: 'column', gap: 0.4,
                minWidth: 180,
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                  {showOwner ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, minWidth: 0, flex: 1 }}>
                      <Typography
                        onClick={(e: any) => { e.stopPropagation(); setViewProfileUsername(owner); }}
                        sx={{ fontSize: '0.78rem', fontWeight: 600, color: 'text.primary', cursor: 'pointer', userSelect: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', '&:hover': { color: 'primary.main' } }}>
                        {owner}
                      </Typography>
                      {ownerVerified && <CheckCircleIcon sx={{ fontSize: 12, color: '#16a34a', flexShrink: 0 }} />}
                    </Box>
                  ) : (
                    <Typography sx={{ fontSize: '0.7rem', color: 'text.disabled', fontStyle: 'italic', flex: 1 }}>
                      anonymous
                    </Typography>
                  )}
                </Box>
                <Typography sx={{ fontSize: '0.65rem', fontFamily: 'monospace', color: 'text.secondary', userSelect: 'none', whiteSpace: 'nowrap', letterSpacing: 0.3, lineHeight: 1.4 }}>
                  <span style={{ cursor: 'pointer' }} onClick={() => { navigator.clipboard.writeText(dispId(boardId)); setSnackbar({ open: true, message: 'Board ID copied' }); }}>Board {dispId(boardId)}</span>
                  {sourceIdVal && <><span style={{ margin: '0 5px', opacity: 0.4 }}>·</span><span style={{ cursor: 'pointer' }} onClick={() => { navigator.clipboard.writeText(sourceIdVal); setSnackbar({ open: true, message: 'Source ID copied' }); }}>Source {sourceIdVal}</span></>}
                </Typography>
                {boardUpdatedAt && (
                  <Typography sx={{ fontSize: '0.58rem', color: 'text.disabled', userSelect: 'none', whiteSpace: 'nowrap', lineHeight: 1.4 }}>
                    Updated {formatTimestamp(boardUpdatedAt, appSettings)} · {timeSince(boardUpdatedAt)}
                  </Typography>
                )}
              </Box>
            );
          })()}

          {appMode === 'tree' && canvasTab !== 'relations' && hasMainSource && mainSource?.sourceType && (() => {
            const srcDef = ALL_SOURCE_TYPES.find(t => t.type === mainSource.sourceType);
            const typeLabel = srcDef?.label || 'Source';
            const titleField = srcDef?.titleField ? `field${srcDef.titleField}` as keyof SourceFields : 'field2' as keyof SourceFields;
            const title = mainSource.fields[titleField] || mainSource.fields.field2 || mainSource.fields.field1 || '';
            if (!title) return null;
            const sourceColor = getSourceColor(mainSource.sourceType);
            return (
              <Box sx={{ position: 'absolute', top: 14, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none', zIndex: 5 }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography sx={{ fontSize: '0.6rem', fontWeight: 700, color: sourceColor, textTransform: 'uppercase', letterSpacing: 1.5, userSelect: 'none', textShadow: '0 1px 4px rgba(0,0,0,0.3)', mb: 0.3 }}>
                    {typeLabel}
                  </Typography>
                  <Typography sx={{ fontSize: '1.7rem', fontWeight: 700, letterSpacing: '-0.4px', color: '#E3E3DF', textShadow: '0 2px 8px rgba(0,0,0,0.35)', userSelect: 'none', maxWidth: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2 }}>
                    {title}
                  </Typography>
                  {(mainSource.sourceType === 'website' || mainSource.sourceType === 'article') && (() => {
                    const urlField = srcDef?.fields.find(f => f.type === 'url');
                    const urlIdx = urlField ? srcDef!.fields.indexOf(urlField) : -1;
                    const urlVal = urlIdx >= 0 ? (mainSource.fields as any)[`field${urlIdx + 1}`] : '';
                    if (!urlVal) return null;
                    const displayUrl = urlVal.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
                    return <Typography sx={{ fontSize: '0.6rem', fontFamily: 'monospace', color: 'rgba(227,227,223,0.35)', textShadow: '0 1px 4px rgba(0,0,0,0.3)', userSelect: 'none', maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.2 }}>{displayUrl}</Typography>;
                  })()}
                </Box>
              </Box>
            );
          })()}

          {appMode !== 'none' && appMode !== 'tree' && canvasTab !== 'relations' && squares.length > 0 && (() => {
            const first = [...squares].sort((a, b) => b.order - a.order)[0] || squares[0];
            const srcDef = ALL_SOURCE_TYPES.find(t => t.type === first.sourceType);
            const typeLabel = srcDef?.label || 'Source';
            const title = first.fields.field2 || first.fields.field1 || '';
            if (!title) return null;
            const sourceColor = getSourceColor(first.sourceType);
            return (
              <Box sx={{ position: 'absolute', top: 14, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none', zIndex: 5 }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography sx={{ fontSize: '0.6rem', fontWeight: 700, color: sourceColor, textTransform: 'uppercase', letterSpacing: 1.5, userSelect: 'none', textShadow: '0 1px 4px rgba(0,0,0,0.3)', mb: 0.3 }}>
                    Source chain for reference in {typeLabel.toLowerCase()}
                  </Typography>
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, maxWidth: 540 }}>
                    <Typography sx={{ fontSize: '1.7rem', fontWeight: 700, letterSpacing: '-0.4px', color: '#E3E3DF', textShadow: '0 2px 8px rgba(0,0,0,0.35)', userSelect: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2 }}>
                      {title}
                    </Typography>
                  </Box>
                  {first.isAuthor && (
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, mt: 0.5, px: 0.9, py: 0.25, borderRadius: '4px', bgcolor: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.4)', textShadow: 'none' }}>
                      <PersonIcon sx={{ fontSize: 12, color: '#fbbf24' }} />
                      <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#fbbf24', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        Self-rated by author
                      </Typography>
                    </Box>
                  )}
                  {createdByAi && (
                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, mt: 0.5, ml: first.isAuthor ? 0.5 : 0, px: 0.9, py: 0.25, borderRadius: '4px', bgcolor: 'rgba(56,189,248,0.15)', border: '1px solid rgba(56,189,248,0.4)', textShadow: 'none', pointerEvents: 'auto' }}>
                      <SmartToyIcon sx={{ fontSize: 12, color: '#38bdf8' }} />
                      <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#38bdf8', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        Created by AI{aiAttribution ? ` · ${aiAttribution}` : ''}
                      </Typography>
                      {isSignedIn && !isOwner && (
                        <Typography
                          component="span"
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              const token = await getToken();
                              const resp = await fetch(`${API_BASE}/boards/${boardId}/claim`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
                              if (resp.ok) {
                                setSnackbar({ open: true, message: 'Board claimed — it\'s now yours.' });
                                setTimeout(() => loadBoardFromApi(boardId), 600);
                              } else {
                                const data = await resp.json().catch(() => ({}));
                                setSnackbar({ open: true, message: `Claim failed: ${data.error || resp.status}` });
                              }
                            } catch (err) {
                              setSnackbar({ open: true, message: 'Claim failed (network error).' });
                            }
                          }}
                          sx={{ fontSize: '0.6rem', fontWeight: 700, color: '#38bdf8', cursor: 'pointer', ml: 0.4, textDecoration: 'underline', textUnderlineOffset: '2px', '&:hover': { color: '#7dd3fc' } }}
                        >
                          claim
                        </Typography>
                      )}
                    </Box>
                  )}
                  {(first.sourceType === 'website' || first.sourceType === 'article') && (() => {
                    const urlField = srcDef?.fields.find(f => f.type === 'url');
                    const urlIdx = urlField ? srcDef!.fields.indexOf(urlField) : -1;
                    const urlVal = urlIdx >= 0 ? (first.fields as any)[`field${urlIdx + 1}`] : '';
                    if (!urlVal) return null;
                    const displayUrl = urlVal.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
                    return <Typography sx={{ fontSize: '0.6rem', fontFamily: 'monospace', color: 'rgba(227,227,223,0.35)', textShadow: '0 1px 4px rgba(0,0,0,0.3)', userSelect: 'none', maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', mt: 0.2 }}>{displayUrl}</Typography>;
                  })()}
                </Box>
              </Box>
            );
          })()}


          {appMode !== 'none' && (cleanView || !isOwner) && (
            <Box sx={{ position: 'absolute', top: 10, left: 10, display: 'flex', alignItems: 'center', gap: 1, pointerEvents: 'auto', zIndex: 5 }}>
              <Box component="a" href="https://source.io" sx={{ textDecoration: 'none', display: 'flex', alignItems: 'baseline', bgcolor: 'background.paper', borderRadius: '8px', px: 1.5, py: 0.6, boxShadow: 2, border: '1px solid', borderColor: 'divider', '&:hover': { boxShadow: 3 } }}>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: 'text.primary' }}>source</Typography>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: '#5b8fc7' }}>.</Typography>
              </Box>
              {!isSignedIn && (
                <Button size="small" variant="outlined" onClick={() => setShowSignIn(true)} sx={{ fontSize: 9, height: 26, textTransform: 'none', borderRadius: '8px' }}>Sign in</Button>
              )}
            </Box>
          )}
          
          {!isOwner && canvasTab !== 'relations' && (
            <Box sx={{ position: 'absolute', top: 10, right: 10, display: 'flex', alignItems: 'center', gap: 0.75, pointerEvents: 'auto' }}>
              <Chip size="small" icon={<PublicIcon sx={{ fontSize: '12px !important' }} />} label={`Public · ${dispId(boardId)}`} sx={{ fontSize: 9, height: 26, fontFamily: 'monospace' }} />
            </Box>
          )}

          {isOwner && appMode !== 'none' && !cleanView && canvasTab !== 'relations' && (
            <Box sx={{ position: 'absolute', top: 10, right: 10, pointerEvents: 'auto', zIndex: 6, width: 248,
              bgcolor: 'background.paper', borderRadius: '10px', boxShadow: 3,
              border: '1px solid', borderColor: isPublic ? 'rgba(16,185,129,0.4)' : 'divider', p: 1.2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                {isPublic
                  ? <PublicIcon sx={{ fontSize: 18, color: '#10b981' }} />
                  : <LockIcon sx={{ fontSize: 18, color: 'text.secondary' }} />}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: isPublic ? '#10b981' : 'text.primary', lineHeight: 1.2 }}>
                    {isPublic ? 'Public' : 'Private'}
                  </Typography>
                  <Typography sx={{ fontSize: 10, color: 'text.secondary', lineHeight: 1.2 }}>
                    {isPublic ? 'Anyone with the link can view' : 'Only you can see this board'}
                  </Typography>
                </Box>
                <Switch
                  size="small"
                  checked={isPublic}
                  onChange={(e) => {
                    const next = e.target.checked;
                    if (next) {
                      const reasons: string[] = [];
                      const nonMainSources = squares.filter(s => !s.isMainSource);
                      if (nonMainSources.length === 0) reasons.push('Add at least one source before publishing.');
                      const sourcesWithoutType = nonMainSources.filter(s => !s.sourceType);
                      if (sourcesWithoutType.length > 0) reasons.push(`${sourcesWithoutType.length} source${sourcesWithoutType.length > 1 ? 's' : ''} missing a source type — all sources must have a type selected.`);
                      const sourcesWithoutRef = nonMainSources.filter(s => !s.reference?.from?.trim() && !s.reference?.to?.trim() && !s.reference?.notes?.trim() && !s.comments?.trim());
                      if (sourcesWithoutRef.length > 0) reasons.push(`${sourcesWithoutRef.length} source${sourcesWithoutRef.length > 1 ? 's' : ''} must have a Reference filled in before publishing. Open each source and complete the Reference tab.`);
                      if (reasons.length > 0) { setMakePublicBlockReasons(reasons); setMakePublicBlockOpen(true); return; }
                    }
                    logEdit('board', 'Visibility', isPublic ? 'Public' : 'Private', next ? 'Public' : 'Private');
                    setIsPublic(next);
                    if (next && !madePublicAt) setMadePublicAt(new Date().toISOString());
                    setSnackbar({ open: true, message: next ? `Now public & read-only · ${dispId(boardId)}` : `Now private · You can edit again` });
                  }}
                />
              </Box>
              <Typography sx={{ fontSize: 9.5, color: 'text.disabled', lineHeight: 1.4, mt: 0.7, pt: 0.7, borderTop: '1px solid', borderColor: 'divider' }}>
                {isPublic
                  ? 'Turn off to make this board private again. It will disappear from public view and you\'ll be able to edit it.'
                  : 'Turn on to publish: anyone with the link can view it, and the board becomes read-only (editing locked).'}
              </Typography>
            </Box>
          )}
          
          <Box sx={{ position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)', display: canvasTab === 'relations' ? 'none' : 'flex', flexDirection: 'column', gap: 0.3, bgcolor: 'background.paper', borderRadius: '6px', p: 0.5, boxShadow: 2, pointerEvents: 'auto' }}>
            {appMode !== 'none' && !isOwner && squares.length > 0 && (
              <>
                <Tooltip title={simpleView ? 'Switch to Normal view (full source details)' : 'Switch to Simple view (compact cards)'} placement="left">
                  <IconButton size="small" onClick={() => {
                    const next = !simpleView;
                    setSimpleView(next);
                    setTimeout(() => {
                      if (appMode === 'tree') {
                        if (!containerRef.current) return;
                        const rect = containerRef.current.getBoundingClientRect();
                        const z = next ? 1.26 : 0.78;
                        const cx = treeLineX * z;
                        const targetBoxTop = Math.max(80, rect.height * 0.12);
                        setZoom(z);
                        setCanvasOffset({ x: rect.width / 2 - cx, y: targetBoxTop - 80 * z });
                      } else {
                        fitChainToScreen({ useSimple: next });
                      }
                    }, 50);
                  }} sx={{ width: 24, height: 24 }}>
                    {simpleView ? <UnfoldMoreIcon sx={{ fontSize: 14 }} /> : <UnfoldLessIcon sx={{ fontSize: 14 }} />}
                  </IconButton>
                </Tooltip>
                <Divider sx={{ my: 0.2 }} />
              </>
            )}
            {appMode !== 'none' && isOwner && (
              <>
                {squares.length > 0 && (
                  <Tooltip title={simpleView ? 'Switch to Normal view (full source details)' : 'Switch to Simple view (compact cards)'} placement="left">
                    <IconButton size="small" onClick={() => {
                      const next = !simpleView;
                      setSimpleView(next);
                      setTimeout(() => {
                        if (appMode === 'tree') {
                          if (!containerRef.current) return;
                          const rect = containerRef.current.getBoundingClientRect();
                          const z = next ? 1.26 : 0.78;
                          const cx = treeLineX * z;
                          const targetBoxTop = Math.max(80, rect.height * 0.12);
                          setZoom(z);
                          setCanvasOffset({ x: rect.width / 2 - cx, y: targetBoxTop - 80 * z });
                        } else {
                          fitChainToScreen({ useSimple: next });
                        }
                      }, 50);
                    }} sx={{ width: 24, height: 24 }}>
                      {simpleView ? <UnfoldMoreIcon sx={{ fontSize: 14 }} /> : <UnfoldLessIcon sx={{ fontSize: 14 }} />}
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title={cleanView ? "Show controls" : "Clean view — hide controls"} placement="left">
                  <IconButton size="small" onClick={() => setCleanView(v => !v)} sx={{ width: 24, height: 24 }}>
                    {cleanView ? <VisibilityIcon sx={{ fontSize: 14 }} /> : <VisibilityOffIcon sx={{ fontSize: 14 }} />}
                  </IconButton>
                </Tooltip>
                <Divider sx={{ my: 0.2 }} />
              </>
            )}
            <IconButton size="small" onClick={() => {
              const rect = containerRef.current?.getBoundingClientRect();
              if (!rect) { setZoom(z => Math.min(2, z + 0.1)); return; }
              const cx = rect.width / 2;
              const cy = rect.height / 2;
              setZoom(prevZoom => {
                const newZoom = Math.min(2, prevZoom + 0.1);
                if (newZoom === prevZoom) return prevZoom;
                const scale = newZoom / prevZoom;
                setCanvasOffset(prev => ({
                  x: cx - scale * (cx - prev.x),
                  y: cy - scale * (cy - prev.y),
                }));
                return newZoom;
              });
            }} sx={{ width: 24, height: 24 }}><ZoomInIcon sx={{ fontSize: 14 }} /></IconButton>
            <Typography sx={{ textAlign: 'center', fontSize: '0.5rem', color: 'text.secondary' }}>{Math.round(zoom * 100)}%</Typography>
            <IconButton size="small" onClick={() => {
              const rect = containerRef.current?.getBoundingClientRect();
              if (!rect) { setZoom(z => Math.max(0.25, z - 0.1)); return; }
              const cx = rect.width / 2;
              const cy = rect.height / 2;
              setZoom(prevZoom => {
                const newZoom = Math.max(0.25, prevZoom - 0.1);
                if (newZoom === prevZoom) return prevZoom;
                const scale = newZoom / prevZoom;
                setCanvasOffset(prev => ({
                  x: cx - scale * (cx - prev.x),
                  y: cy - scale * (cy - prev.y),
                }));
                return newZoom;
              });
            }} sx={{ width: 24, height: 24 }}><ZoomOutIcon sx={{ fontSize: 14 }} /></IconButton>
          </Box>


          {!cleanView && (
            <Box sx={{ position: 'absolute', bottom: 12, right: 12, pointerEvents: 'auto', zIndex: 5 }}>
              <Tooltip title="Canvas menu" placement="left">
                <IconButton
                  size="small"
                  onClick={(e) => setCanvasMenuAnchor(e.currentTarget)}
                  sx={{ width: 36, height: 36, bgcolor: 'background.paper', boxShadow: 2, border: '1px solid', borderColor: 'divider', '&:hover': { bgcolor: 'action.hover' }, position: 'relative' }}>
                  <MenuIcon sx={{ fontSize: 20 }} />
                  {isPublic && boardEditLog.length > 0 && (
                    <Box sx={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', bgcolor: '#ef4444', border: '1.5px solid #fff' }} />
                  )}
                  {isOwner && saveStatus !== 'idle' && (
                    <Box sx={{ position: 'absolute', bottom: 4, right: 4, width: 8, height: 8, borderRadius: '50%',
                      bgcolor: saveStatus === 'error' ? '#ef4444' : saveStatus === 'saving' ? '#f59e0b' : '#10b981',
                      border: '1.5px solid #fff' }} />
                  )}
                </IconButton>
              </Tooltip>
              <Menu
                disableScrollLock
                anchorEl={canvasMenuAnchor}
                open={Boolean(canvasMenuAnchor)}
                onClose={() => setCanvasMenuAnchor(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                slotProps={{ paper: { sx: {
                  borderRadius: '10px', minWidth: 240, mt: -0.5, boxShadow: 6,
                  border: '1px solid', borderColor: 'divider',
                  maxHeight: 'calc(100vh - 32px)',
                  overflowY: 'auto',
                } } }}>

                <Typography sx={{ px: 2, pt: 1.2, pb: 0.5, fontSize: 10, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.6 }}>View</Typography>
                <MenuItem onClick={() => { setCanvasTab('board'); updateURL(boardId, chainId); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13, ...(canvasTab === 'board' ? { color: 'primary.main', fontWeight: 600 } : {}) }}>
                  <DashboardIcon fontSize="small" /> Board
                </MenuItem>
                <MenuItem onClick={() => { setCanvasTab('code'); setCodeViewTab('export'); updateURL(boardId, chainId, null, 'code'); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13, ...(canvasTab === 'code' ? { color: 'primary.main', fontWeight: 600 } : {}) }}>
                  <CodeIcon fontSize="small" /> Code
                </MenuItem>
                <MenuItem onClick={() => { setCanvasTab('refs'); updateURL(boardId, chainId, null, 'refs'); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13, ...(canvasTab === 'refs' ? { color: 'primary.main', fontWeight: 600 } : {}) }}>
                  <PaletteIcon fontSize="small" /> <T k="canvas.oldStyles" fb="Old styles" />
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={() => {
                    const next = !simpleView;
                    const simW = 220;
                    const simH = 105;
                    const simGap = 30;
                    if (appMode === 'single' && squares.length > 0) {
                      const sorted = [...squares].sort((a, b) => b.order - a.order);
                      const baseX = sorted[0].position.x;
                      const baseY = next
                        ? sorted[0].position.y + (SQUARE_HEIGHT - simH) / 2
                        : sorted[0].position.y - (SQUARE_HEIGHT - simH) / 2;
                      const positionMap = new Map<number, { x: number; y: number }>();
                      sorted.forEach((sq, i) => {
                        positionMap.set(sq.id, {
                          x: baseX + i * ((next ? simW : SQUARE_WIDTH) + (next ? simGap : GAP)),
                          y: baseY,
                        });
                      });
                      setSquares(prev => prev.map(sq => ({
                        ...sq,
                        position: positionMap.get(sq.id) || sq.position,
                      })));
                      setTimeout(() => {
                        if (containerRef.current) {
                          const rect = containerRef.current.getBoundingClientRect();
                          const bw = next ? simW : SQUARE_WIDTH;
                          const z = next ? 1.26 : 0.78;
                          const newPositions = sorted.map((sq) => ({ ...sq, position: positionMap.get(sq.id) || sq.position }));
                          const nonMain = newPositions.filter(s => !s.isMainSource);
                          const targetBoxTop = 70 + 140 * z;
                          if (nonMain.length >= 2) {
                            const first = nonMain[0];
                            const second = nonMain[1];
                            const midX = ((first.position.x + bw / 2) + (second.position.x + bw / 2)) / 2 * z;
                            setZoom(z);
                            setCanvasOffset({ x: (rect.width / 2) - midX, y: targetBoxTop - first.position.y * z });
                          } else if (nonMain.length === 1) {
                            const cx = (nonMain[0].position.x + bw / 2) * z;
                            setZoom(z);
                            setCanvasOffset({ x: (rect.width / 2) - cx, y: targetBoxTop - nonMain[0].position.y * z });
                          }
                        }
                      }, 50);
                    }
                    setSimpleView(next);
                    setCanvasMenuAnchor(null);
                  }}
                  sx={{ gap: 1, fontSize: 13 }}>
                  {simpleView ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
                  <Box component="span" sx={{ flex: 1 }}>{simpleView ? 'Simple view' : 'Normal view'}</Box>
                  <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>switch</Typography>
                </MenuItem>
                <MenuItem onClick={() => { handleResetView(); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13 }}>
                  <CenterFocusStrongIcon fontSize="small" /> Reset view
                </MenuItem>
                <MenuItem onClick={() => { handleToggleFullscreen(); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13 }}>
                  {isFullscreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
                  <Box component="span" sx={{ flex: 1 }}>{isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}</Box>
                </MenuItem>

                {appMode === 'single' && squares.length > 1 && (
                  <>
                    <Divider sx={{ my: 0.5 }} />
                    <Typography sx={{ px: 2, pt: 0.5, pb: 0.5, fontSize: 10, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.6 }}>Layout</Typography>
                    <MenuItem onClick={() => {
                      const sorted = [...squares].filter(s => !s.isMainSource).sort((a, b) => b.order - a.order);
                      if (sorted.length < 1) return;
                      const baseY = sorted[0].position.y;
                      setSquares(prev => prev.map(sq => sq.isMainSource ? sq : { ...sq, position: { ...sq.position, y: baseY } }));
                      setSnackbar({ open: true, message: 'Aligned straight' });
                      setCanvasMenuAnchor(null);
                    }} sx={{ gap: 1, fontSize: 13 }}>
                      <AlignVerticalTopIcon fontSize="small" /> Align straight
                    </MenuItem>
                    <MenuItem onClick={() => {
                      const sorted = [...squares].filter(s => !s.isMainSource).sort((a, b) => b.order - a.order);
                      if (sorted.length < 1) return;
                      const baseY = sorted[0].position.y;
                      const step = SQUARE_HEIGHT * 0.25;
                      const posMap = new Map<string, number>();
                      sorted.forEach((sq, i) => posMap.set(sq.sourceId, baseY + i * step));
                      setSquares(prev => prev.map(sq => sq.isMainSource ? sq : { ...sq, position: { ...sq.position, y: posMap.get(sq.sourceId) ?? sq.position.y } }));
                      setSnackbar({ open: true, message: 'Stairs descending' });
                      setCanvasMenuAnchor(null);
                    }} sx={{ gap: 1, fontSize: 13 }}>
                      <ArrowDropDownIcon fontSize="small" /> Stairs descending
                    </MenuItem>
                    <MenuItem onClick={() => {
                      const sorted = [...squares].filter(s => !s.isMainSource).sort((a, b) => b.order - a.order);
                      if (sorted.length < 1) return;
                      const baseY = sorted[sorted.length - 1].position.y;
                      const step = SQUARE_HEIGHT * 0.25;
                      const posMap = new Map<string, number>();
                      sorted.forEach((sq, i) => posMap.set(sq.sourceId, baseY - (sorted.length - 1 - i) * step));
                      setSquares(prev => prev.map(sq => sq.isMainSource ? sq : { ...sq, position: { ...sq.position, y: posMap.get(sq.sourceId) ?? sq.position.y } }));
                      setSnackbar({ open: true, message: 'Stairs ascending' });
                      setCanvasMenuAnchor(null);
                    }} sx={{ gap: 1, fontSize: 13 }}>
                      <ArrowDropUpIcon fontSize="small" /> Stairs ascending
                    </MenuItem>
                  </>
                )}

                <Divider sx={{ my: 0.5 }} />
                <Typography sx={{ px: 2, pt: 0.5, pb: 0.5, fontSize: 10, fontWeight: 700, color: 'text.disabled', textTransform: 'uppercase', letterSpacing: 0.6 }}>Board</Typography>
                {(() => {
                  const mainSrc = squares.find(s => s.isMainSource) || squares[0];
                  const settingsTarget = selectedSourceId
                    || mainSrc?.sourceId
                    || squares.find(s => !s.isMainSource)?.sourceId
                    || squares[0]?.sourceId
                    || '';
                  if (!settingsTarget) return null;
                  return (
                    <MenuItem
                      onClick={() => { setBoardSettingsSourceId(settingsTarget); setCanvasMenuAnchor(null); }}
                      sx={{ gap: 1, fontSize: 13 }}>
                      <SettingsIcon fontSize="small" />
                      <Box component="span" sx={{ flex: 1 }}>Board settings</Box>
                    </MenuItem>
                  );
                })()}
                {isOwner && (
                  <>
                    <MenuItem
                      onClick={async () => {
                        if (tokenRef.current) { await saveToApi(); } else { setSnackbar({ open: true, message: 'Login to save boards' }); }
                        setCanvasMenuAnchor(null);
                      }}
                      sx={{ gap: 1, fontSize: 13 }}>
                      <SaveIcon fontSize="small" sx={{ color: saveStatus === 'error' ? '#ef4444' : saveStatus === 'saving' ? '#f59e0b' : saveStatus === 'saved' ? '#10b981' : 'inherit' }} />
                      <Box component="span" sx={{ flex: 1 }}>
                        {saveStatus === 'saving' ? 'Saving…' : saveStatus === 'saved' ? 'Saved' : saveStatus === 'error' ? 'Save failed — retry' : 'Save now'}
                      </Box>
                    </MenuItem>
                    <MenuItem
                      onClick={() => { setAppSettings(prev => ({ ...prev, autoSave: !prev.autoSave })); }}
                      sx={{ gap: 1, fontSize: 13 }}>
                      {appSettings.autoSave ? <RadioButtonCheckedIcon fontSize="small" sx={{ color: 'primary.main' }} /> : <RadioButtonUncheckedIcon fontSize="small" />}
                      <Box component="span" sx={{ flex: 1 }}>Auto-save</Box>
                      <Typography sx={{ fontSize: 11, color: 'text.disabled' }}>{appSettings.autoSave ? 'on' : 'off'}</Typography>
                    </MenuItem>
                  </>
                )}
                <MenuItem
                  disabled={!isPublic}
                  onClick={() => { if (isPublic) { setEditLogDialogOpen(true); updateURL(boardId, chainId, null, 'history'); } setCanvasMenuAnchor(null); }}
                  sx={{ gap: 1, fontSize: 13 }}>
                  <HistoryIcon fontSize="small" />
                  <Box component="span" sx={{ flex: 1 }}>Edit history</Box>
                  {isPublic && boardEditLog.length > 0 && (
                    <Box sx={{ minWidth: 18, height: 18, borderRadius: '9px', bgcolor: '#ef4444', color: '#fff', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', px: 0.5 }}>
                      {boardEditLog.length}
                    </Box>
                  )}
                  {!isPublic && <Typography sx={{ fontSize: 10, color: 'text.disabled' }}>public only</Typography>}
                </MenuItem>
                <MenuItem onClick={() => { setShareDialogOpen(true); setCanvasMenuAnchor(null); }} sx={{ gap: 1, fontSize: 13 }}>
                  <ShareIcon fontSize="small" /> Share board
                </MenuItem>
                {isSignedIn && !isOwner && (
                  <MenuItem
                    onClick={async () => {
                      try {
                        const token = tokenRef.current;
                        if (!token) return;
                        const hdrs: Record<string, string> = { 'Authorization': `Bearer ${token}` };
                        if (isBoardSaved) {
                          await fetch(`${API_BASE}/saved-boards/${boardId}`, { method: 'DELETE', headers: hdrs });
                          setIsBoardSaved(false);
                          setSnackbar({ open: true, message: 'Board removed from saved' });
                        } else {
                          await fetch(`${API_BASE}/saved-boards/${boardId}`, { method: 'POST', headers: hdrs });
                          setIsBoardSaved(true);
                          setSnackbar({ open: true, message: 'Board saved to your collection' });
                        }
                      } catch {}
                      setCanvasMenuAnchor(null);
                    }}
                    sx={{ gap: 1, fontSize: 13 }}>
                    <BookmarkIcon fontSize="small" sx={{ color: isBoardSaved ? '#f59e0b' : 'inherit' }} />
                    <Box component="span" sx={{ flex: 1 }}>{isBoardSaved ? 'Saved to your collection' : 'Save to your collection'}</Box>
                  </MenuItem>
                )}

              </Menu>
            </Box>
          )}
        </Box>
        </>
        )}
        {editLogDialogOpen && (
          <Box sx={{ position: 'absolute', inset: 0, zIndex: 500, bgcolor: 'background.default', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Box sx={{ px: 3, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
              <IconButton onClick={() => { setEditLogDialogOpen(false); updateURL(boardId, chainId); }} size="small"><ArrowBackIcon sx={{ fontSize: 20 }} /></IconButton>
              <HistoryIcon sx={{ color: 'primary.main', fontSize: 20 }} />
              <Box>
                <Typography fontWeight={700} fontSize={16}>Edit History</Typography>
                <Typography fontSize={11} color="text.secondary">
                  {boardEditLog.length} change{boardEditLog.length !== 1 ? 's' : ''} since board was published{madePublicAt ? ` · ${formatTimestamp(madePublicAt, appSettings)}` : ''}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }} />
              <Chip label={`Board ${dispId(boardId)}`} size="small" sx={{ fontSize: 10, fontFamily: 'monospace' }} />
            </Box>
            <Box sx={{ flex: 1, overflow: 'auto', px: 2, py: 1 }}>
              {boardEditLog.length === 0 ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 1 }}>
                  <HistoryIcon sx={{ fontSize: 48, color: 'text.disabled', opacity: 0.3 }} />
                  <Typography color="text.secondary" fontSize={13}>No edits recorded yet</Typography>
                  <Typography color="text.disabled" fontSize={11}>Changes will appear here once this board has been published and edited.</Typography>
                </Box>
              ) : (
                <EditLogTable entries={boardEditLog} isDark={isDarkMode} appSettings={appSettings} />
              )}
            </Box>
          </Box>
        )}
        </Box>
      </Box>
      <PerSourceTrustDialog open={!!chipDialogSourceId} onClose={() => setChipDialogSourceId(null)}
        squares={squares} sourceId={chipDialogSourceId} isDark={isDarkMode} />
      {(() => {
        const sq = boardSettingsSourceId ? squares.find(s => s.sourceId === boardSettingsSourceId) : null;
        if (!sq) return null;
        const sourceTypeData = ALL_SOURCE_TYPES.find(t => t.type === sq.sourceType);
        const typeNoun = sourceTypeData?.label?.toLowerCase() || 'source';
        const titleField = sourceTypeData?.titleField ? `field${sourceTypeData.titleField}` as keyof SourceFields : 'field2' as keyof SourceFields;
        const sourceTitle = sq.fields[titleField] || sq.fields.field2 || sq.fields.field1 || 'this source';
        const srcAgree = sq.trustVoteSourceAgree || 0;
        const srcDis   = sq.trustVoteSourceDisagree || 0;
        const refAgree = sq.trustVoteReferenceAgree || 0;
        const refDis   = sq.trustVoteReferenceDisagree || 0;
        const myVoteSrc = sq.currentUserTrustVoteSource || null;
        const myVoteRef = sq.currentUserTrustVoteReference || null;
        const firstAddedSource = [...squares]
          .filter(s => !s.isMainSource)
          .sort((a, b) => b.order - a.order)[0]
          || squares.find(s => s.isMainSource)
          || squares[0];
        const isFirstSource = !!firstAddedSource && firstAddedSource.sourceId === sq.sourceId;
        return (
          <Dialog disableScrollLock open onClose={() => setBoardSettingsSourceId(null)}
            maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
            <DialogTitle sx={{ pb: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SettingsIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                <Typography fontWeight={700} fontSize={14}>Board settings</Typography>
              </Box>
              <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.4 }}>
                Board <Box component="span" sx={{ fontFamily: 'monospace' }}>{dispId(boardId)}</Box>
              </Typography>
            </DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
              {isOwner && (
                <>
                  <Typography fontSize={9.5} fontWeight={700} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 0.6, mb: 0.7 }}>
                    Board-wide
                  </Typography>
                  <Box sx={{ p: 1.4, mb: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
                    <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>Visitor voting</Typography>
                    <FormControlLabel
                      sx={{ ml: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
                      control={<Checkbox size="small" checked={allowTrustVoting}
                        onChange={(e) => handleSetAllowTrustVoting(e.target.checked)} sx={{ p: 0.5 }} />}
                      label="Allow visitors to vote on my trust scoring"
                    />
                    <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.5, ml: 4, lineHeight: 1.5 }}>
                      Applies to the entire board. When enabled, signed-in visitors can agree or disagree with your scoring of each source's source-trust and reference-trust groups, separately. Tallies are visible to everyone.
                    </Typography>
                  </Box>
                  <Typography fontSize={9.5} fontWeight={700} color="text.disabled" sx={{ textTransform: 'uppercase', letterSpacing: 0.6, mb: 0.7, mt: 0.5 }}>
                    This source <Box component="span" sx={{ fontFamily: 'monospace', textTransform: 'none', letterSpacing: 0, color: 'text.disabled' }}>{dispId(sq.sourceId)}</Box>
                  </Typography>
                  {isFirstSource ? (
                    <Box sx={{ p: 1.4, mb: 1.5, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
                      <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }}>Author claim</Typography>
                      <FormControlLabel
                        sx={{ ml: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
                        control={<Checkbox size="small" checked={!!sq.isAuthor}
                          onChange={(e) => handleSetIsAuthor(sq.sourceId, e.target.checked)} sx={{ p: 0.5 }} />}
                        label={<>I am the author of the {typeNoun} <Box component="span" sx={{ fontStyle: 'italic' }}>"{sourceTitle}"</Box></>}
                      />
                      <Typography fontSize={11} color="text.secondary" sx={{ mt: 0.5, ml: 4, lineHeight: 1.5 }}>
                        When checked, the chain's headline gets a "Self-rated by author" badge so visitors know the trust scoring comes from the work's own author.
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ p: 1.4, mb: 1.5, borderRadius: '8px', border: '1px dashed', borderColor: 'divider', bgcolor: 'transparent' }}>
                      <Typography fontSize={11} color="text.secondary" sx={{ lineHeight: 1.5 }}>
                        Author claim applies to the first source in the chain. Open Board settings from the first source to set it.
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ p: 1.4, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
                    <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.7 }}>Visitor feedback on this source</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography fontSize={11} fontWeight={600} sx={{ width: 80, color: '#10b981' }}>Source</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <ThumbUpIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                          <Typography fontSize={12}><Box component="span" sx={{ fontWeight: 700 }}>{srcAgree}</Box></Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <ThumbDownIcon sx={{ fontSize: 12, color: '#ef4444' }} />
                          <Typography fontSize={12}><Box component="span" sx={{ fontWeight: 700 }}>{srcDis}</Box></Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography fontSize={11} fontWeight={600} sx={{ width: 80, color: '#3b82f6' }}>Reference</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <ThumbUpIcon sx={{ fontSize: 12, color: '#16a34a' }} />
                          <Typography fontSize={12}><Box component="span" sx={{ fontWeight: 700 }}>{refAgree}</Box></Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <ThumbDownIcon sx={{ fontSize: 12, color: '#ef4444' }} />
                          <Typography fontSize={12}><Box component="span" sx={{ fontWeight: 700 }}>{refDis}</Box></Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
              {!isOwner && (
                <Box sx={{ p: 1.4, borderRadius: '8px', border: '1px solid', borderColor: 'divider', bgcolor: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)' }}>
                  <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.7 }}>
                    Your votes on the {sq.isAuthor ? 'author' : 'curator'}'s trust scoring
                  </Typography>
                  {!allowTrustVoting && (
                    <Typography fontSize={12} color="text.disabled" sx={{ fontStyle: 'italic' }}>
                      The owner has disabled voting on this board.
                    </Typography>
                  )}
                  {allowTrustVoting && (
                    <>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Typography fontSize={12} sx={{ width: 80, fontWeight: 600, color: '#10b981' }}>Source</Typography>
                        <Typography fontSize={12} color={myVoteSrc === 'agree' ? '#16a34a' : myVoteSrc === 'disagree' ? '#ef4444' : 'text.disabled'} sx={{ fontWeight: 600 }}>
                          {myVoteSrc === 'agree' ? '✓ Agree' : myVoteSrc === 'disagree' ? '✗ Disagree' : 'No vote'}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.7 }}>
                        <Typography fontSize={12} sx={{ width: 80, fontWeight: 600, color: '#3b82f6' }}>Reference</Typography>
                        <Typography fontSize={12} color={myVoteRef === 'agree' ? '#16a34a' : myVoteRef === 'disagree' ? '#ef4444' : 'text.disabled'} sx={{ fontWeight: 600 }}>
                          {myVoteRef === 'agree' ? '✓ Agree' : myVoteRef === 'disagree' ? '✗ Disagree' : 'No vote'}
                        </Typography>
                      </Box>
                      <Typography fontSize={11} color="text.secondary" sx={{ lineHeight: 1.5 }}>
                        Vote buttons live in the Trust dialog (open the source's <Box component="span" sx={{ fontWeight: 600 }}>Trust</Box> tab) where you can review the scoring as you vote.
                        {!isSignedIn && <> Sign in to vote.</>}
                      </Typography>
                    </>
                  )}
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ px: 2.5, pb: 2 }}>
              <Button onClick={() => setBoardSettingsSourceId(null)} variant="contained" sx={{ fontWeight: 600 }}>Done</Button>
            </DialogActions>
          </Dialog>
        );
      })()}
      <Snackbar open={snackbar.open} autoHideDuration={3000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={(snackbar.message || '').toLowerCase().match(/fail|error|invalid|must|enter\b/) ? 'error' : 'success'}
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
          sx={{ fontSize: 13, fontWeight: 600 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
    </TranslationProvider>
  );
};

export default SourceApp;